webpackJsonp([1],{

/***/ "+GrW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+a+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserProfile_ProfileForm_vue__ = __webpack_require__("tjNg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserProfile_UserCard_vue__ = __webpack_require__("/IDP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProfileForm: __WEBPACK_IMPORTED_MODULE_3__UserProfile_ProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_4__UserProfile_UserCard_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      user: null,
      company: null,
      currentPassword: "",
      newPassword: "",
      newPassword2: "",
      isLoading: false,
      isChangingPassword: false,
      isImageChanged: false
    };
  },
  mounted: function mounted() {
    var user = this.$store.state.auth.user;
    var company = this.$store.state.auth.company;

    if (user) {
      this.user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, user, {
        nameToShow: user.username,
        aboutToShow: user.aboutMe,
        status: user.status || 'Active'
      });
      this.company = company;
    }
  },

  methods: {
    updateParent: function updateParent(e, isImageChanged) {
      var originalStatus = this.$store.state.auth.user.status || this.user.status || 'Active';
      this.user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, e, {
        status: originalStatus // Preserve status
      });
      console.log('updateParent called, user:', this.user, 'isImageChanged:', isImageChanged);
      if (isImageChanged) {
        this.isImageChanged = true;
      }
    },
    updateUser: function updateUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newData, downloadURL, response, updatedUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                newData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.user);

                delete newData.nameToShow;
                delete newData.aboutToShow;
                delete newData.status; // Prevent status update in Firebase
                console.log('updateUser newData:', newData);

                _this.isLoading = true;

                if (!_this.isImageChanged) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].uploadImage("profileImages", _this.user.profile_picture);

              case 10:
                downloadURL = _context.sent;


                newData.profile_picture = downloadURL;

              case 12:
                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].updateDatabase("users/" + _this.user.uid, newData);

              case 14:
                response = _context.sent;
                updatedUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.$store.state.auth.user, newData, {
                  status: _this.$store.state.auth.user.status || _this.user.status || 'Active' // Preserve status
                });


                console.log('Updating Vuex store with:', updatedUser);
                _this.$store.commit("setUser", updatedUser);

                _this.user.nameToShow = _this.user.username;
                _this.user.aboutToShow = _this.user.aboutMe;
                _this.isLoading = false;
                swal("Done", "Profile updated!", "success");
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](0);

                swal("Error!", _context.t0.message, "error");
                _this.isLoading = false;

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 24]]);
      }))();
    },
    changePassword: function changePassword(e) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var user, currentPassword, newPassword, newPassword2, response, promises, updatedUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();

                user = _this2.$store.state.auth.user;
                currentPassword = _this2.currentPassword;
                newPassword = _this2.newPassword;
                newPassword2 = _this2.newPassword2;
                _context2.prev = 5;

                if (!(newPassword !== newPassword2)) {
                  _context2.next = 8;
                  break;
                }

                throw { message: "password's didn't matched" };

              case 8:

                _this2.isChangingPassword = true;

                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].reAuthenticateUserFirebase({
                  email: user.email,
                  password: currentPassword
                });

              case 11:
                response = _context2.sent;
                promises = [__WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].updatePasswordFirebase(newPassword), __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].updateDatabase("/users/" + user.uid, { firstLoggedIn: true })];
                updatedUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, user, { firstLoggedIn: true, status: user.status || 'Active' });

                _this2.$store.commit("setUser", updatedUser);
                console.log('changePassword, updated user:', updatedUser);
                _this2.clearPasswordFields();

                swal("Wooa!", "Your password is now upto date", "success");

                _this2.isChangingPassword = false;
                _context2.next = 27;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](5);

                _this2.clearPasswordFields();

                if (_context2.t0.code === "auth/wrong-password") {
                  _context2.t0.message = "Current password is not correct";
                }

                _this2.isChangingPassword = false;

                swal("Oops!", _context2.t0.message, "error");

              case 27:

                _this2.closeModal();

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 21]]);
      }))();
    },
    clearPasswordFields: function clearPasswordFields() {
      this.currentPassword = "";
      this.newPassword = "";
      this.newPassword2 = "";
    },
    closeModal: function closeModal() {
      var modal = document.querySelector("#myModal");

      modal.click();
    }
  }
});

/***/ }),

/***/ "+b3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"header-actions"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search by admin, user or activity title..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})])]},proxy:true}])},[_vm._v(" "),_c('CustomTable',{ref:"customTable",attrs:{"loading":_vm.loadingStates.table,"columns":_vm.tableColumns,"data":_vm.filteredActivities,"resetPage":_vm.resetTableFlag},on:{"update:resetPage":function($event){_vm.resetTableFlag=$event},"update:reset-page":function($event){_vm.resetTableFlag=$event}},scopedSlots:_vm._u([{key:"activityByUserName",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                "+_vm._s(item.adminId ? item.activityByUserName : ( item.actionUsername || 'N/A'))+"\n              ")]}},{key:"activityOnUserName",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                "+_vm._s(item.activityOnUserName || 'N/A')+"\n              ")]}},{key:"type",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                "+_vm._s(item.type || 'N/A')+"\n              ")]}},{key:"timestamp",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                "+_vm._s(_vm.formatDate(item.timestamp))+"\n              ")]}},{key:"action",fn:function(ref){
var item = ref.item;
return [_c('button',{staticClass:"btn-sm btn-info action-button",on:{"click":function($event){return _vm.openActivity(item)}}},[_vm._v("\n                  Open\n                ")])]}}])})],1),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isViewModalOpen,"xlarge":true,"scrollable":true,"maxHeight":"65vh","title":("Activity Details of " + ((_vm.selectedActivity && _vm.selectedActivity.type) || '')),"submitButtonText":"Close","hideSubmit":true},on:{"update:modelValue":function($event){_vm.isViewModalOpen = $event},"submit":_vm.closeViewModal}},[(_vm.loadingStates.view)?_c('div',{staticStyle:{"height":"65vh"}},[_vm._v("Loading...")]):(_vm.selectedActivity)?_c('div',{staticClass:"activity-detail-wrapper"},[_c('table',{staticClass:"activity-table"},[_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Admin Id")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.adminId || _vm.selectedActivity.actionUserId || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Admin Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.adminId ? _vm.selectedActivity.activityByUserName : ( _vm.selectedActivity.actionUsername || 'N/A')))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("User Id")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.activityOnUser || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("User Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.activityOnUserName || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Activity")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.activityTitle || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.formattedDescription)}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Latitude")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.latitude || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Longitude")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.longitude || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Browser Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.browserName || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("OS Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedActivity.osName || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Activity Date")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.selectedActivity.timestamp) || 'N/A'))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Changes")]),_vm._v(" "),_c('td',[(_vm.selectedActivity.changes)?_c('div',{staticStyle:{"white-space":"pre-line"},domProps:{"innerHTML":_vm._s(_vm.formattedChanges)}}):_c('span',[_vm._v("N/A")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Location")]),_vm._v(" "),_c('td',[(_vm.selectedActivity.latitude && _vm.selectedActivity.longitude)?_c('div',{},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":("https://maps.google.com/maps?q=" + (_vm.selectedActivity.latitude) + "," + (_vm.selectedActivity.longitude) + "&z=15&output=embed"),"width":"100%","height":"220"}})]):_c('span',[_vm._v("N/A")])])])])]):_vm._e()])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/IDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("hHDF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218d6fd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("MSOW");
function injectStyle (ssrContext) {
  __webpack_require__("m3dc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218d6fd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/daF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyDocuments_vue__ = __webpack_require__("LlT3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5036806_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyDocuments_vue__ = __webpack_require__("iXGv");
function injectStyle (ssrContext) {
  __webpack_require__("ZMzL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5036806"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyDocuments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5036806_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyDocuments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/pYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvailableVariables_vue__ = __webpack_require__("sqB2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AvailableVariables: __WEBPACK_IMPORTED_MODULE_1__AvailableVariables_vue__["a" /* default */] },

  props: {
    template: Object,
    isOpen: Boolean
  },

  data: function data() {
    return {
      isEditMode: false,
      localSubject: "",
      localBody: "",
      activeField: null
    };
  },


  watch: {
    isOpen: function isOpen(val) {
      if (val) {
        this.resetValues();
      }
    }
  },

  methods: {
    resetValues: function resetValues() {
      this.isEditMode = false;
      this.localSubject = this.template.subject;
      this.localBody = this.template.body;
    },
    enableEdit: function enableEdit() {
      this.isEditMode = true;
    },
    cancelEdit: function cancelEdit() {
      this.resetValues();
    },
    saveTemplate: function saveTemplate() {
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.template, {
        subject: this.localSubject,
        body: this.localBody
      });

      this.$emit("save", payload);
      this.isEditMode = false;
    },
    insertVariable: function insertVariable(variable) {
      var ref = this.activeField === "subject" ? this.$refs.subjectInput : this.$refs.bodyInput;

      if (!ref) return;

      var start = ref.selectionStart;
      var end = ref.selectionEnd;
      var value = this.activeField === "subject" ? this.localSubject : this.localBody;

      var updated = value.slice(0, start) + variable + value.slice(end);

      if (this.activeField === "subject") {
        this.localSubject = updated;
      } else {
        this.localBody = updated;
      }

      this.$nextTick(function () {
        ref.focus();
        ref.selectionStart = ref.selectionEnd = start + variable.length;
      });
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$refs.subjectInput.addEventListener("focus", function () {
      _this.activeField = "subject";
    });
    this.$refs.bodyInput.addEventListener("focus", function () {
      _this.activeField = "body";
    });
  }
});

/***/ }),

/***/ "/ruN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("npIG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6356f50c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("TJj7");
function injectStyle (ssrContext) {
  __webpack_require__("vGmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6356f50c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6356f50c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "04Xd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_api__ = __webpack_require__("IFYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ForgotPassword_vue__ = __webpack_require__("gWRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UIComponents_BugReportModal_vue__ = __webpack_require__("P/Qr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_config_helpers__ = __webpack_require__("DJ6O");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ForgotPassword: __WEBPACK_IMPORTED_MODULE_13__ForgotPassword_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_14__UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_16__UIComponents_CustomDropdown_vue__["a" /* default */],
    BugReportModal: __WEBPACK_IMPORTED_MODULE_15__UIComponents_BugReportModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeNotifications: false,
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      isLoading: false,
      loginLoading: false,
      emailValidating: false,
      selectedCompany: null,
      companies: [],
      emailValidated: false,
      showPassword: false,
      showForgotPassword: false,
      isCompanyModalOpen: false,
      selectedCompanyId: "",
      isBugModalOpen: false
    };
  },

  computed: {
    loginButtonDisabled: function loginButtonDisabled() {
      return this.loginLoading || !this.emailValidated || !this.password;
    },
    nextButtonDisabled: function nextButtonDisabled() {
      return this.emailValidating || !this.email;
    }
  },
  methods: {
    handleBackToLogin: function handleBackToLogin() {
      this.showForgotPassword = false;
      this.passwordError = "";
      this.emailError = "";
      this.showPasswordField = false;
      this.emailValidated = false, this.email = "";
      this.selectedCompany = null;
    },
    handleEmailChange: function handleEmailChange() {
      // Clear previous errors and state, no validation here
      this.emailError = "";
      this.emailValidated = false;
      this.showPasswordField = false;
      this.password = "";
      this.passwordError = "";
      this.selectedCompany = null;
      this.companies = [];
    },
    handleNextClick: function handleNextClick() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var emailRegex, atIndex, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.email) {
                  _context.next = 3;
                  break;
                }

                _this.emailError = "Email is required";
                return _context.abrupt("return");

              case 3:
                emailRegex = __WEBPACK_IMPORTED_MODULE_17__assets_config_helpers__["x" /* default */].emailRegex;

                if (emailRegex.test(_this.email)) {
                  _context.next = 7;
                  break;
                }

                _this.emailError = "Please enter a valid email address";
                return _context.abrupt("return");

              case 7:
                atIndex = _this.email.indexOf('@');

                if (!(atIndex === -1 || !_this.email.slice(atIndex + 1).includes('.'))) {
                  _context.next = 11;
                  break;
                }

                _this.emailError = "Please enter a valid email address";
                return _context.abrupt("return");

              case 11:

                // Step 2: Email is valid, proceed to company lookup
                _this.emailValidating = true;
                _context.prev = 12;
                _context.next = 15;
                return _this.findCompany();

              case 15:
                response = _context.sent;

                if (_this.email) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return");

              case 18:

                if (response && Array.isArray(response) && response.length > 0) {
                  localStorage.setItem('firebaseConfig', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(response[0].firebase || {}));
                  _this.companies = response;
                  _this.selectCompany(response[0]);
                  _this.emailValidated = true;
                  _this.emailError = "";
                  _this.showPasswordField = true;

                  if (response.length > 1) {
                    _this.selectedCompanyId = response[0].id || response[0].companyName;
                    _this.openCompanyModal();
                  }
                } else {
                  _this.emailError = "You are not associated with any company";
                }
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](12);

                _this.emailError = "You are not associated with any company";

              case 24:
                _context.prev = 24;

                _this.emailValidating = false;
                return _context.finish(24);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 21, 24, 27]]);
      }))();
    },
    handlePasswordChange: function handlePasswordChange() {
      this.passwordError = "";
    },
    handleLogin: function handleLogin(e) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();

                _context2.prev = 1;

                if (_this2.email) {
                  _context2.next = 4;
                  break;
                }

                throw { message: "Email is required!" };

              case 4:
                if (_this2.emailValidated) {
                  _context2.next = 7;
                  break;
                }

                _this2.emailError = "Please validate your email first";
                return _context2.abrupt("return");

              case 7:
                if (_this2.password) {
                  _context2.next = 9;
                  break;
                }

                throw { message: "Password is required!" };

              case 9:
                if (!(_this2.password.length < 6)) {
                  _context2.next = 11;
                  break;
                }

                throw { message: "Password must be at least 6 characters long" };

              case 11:
                _context2.next = 13;
                return _this2.login();

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](1);

                _this2.passwordError = _context2.t0.message;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 15]]);
      }))();
    },
    login: function login() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var credentials, users, response, _ref, _ref2, allUsersResponse, constants, allLeaves, user;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                credentials = { email: _this3.email, password: _this3.password };
                users = [];
                _context3.prev = 2;

                _this3.loginLoading = true;

                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].login(credentials);

              case 6:
                response = _context3.sent;

                response.data.isActive = response.data.isActive || false;

                if (response.data.isActive) {
                  _context3.next = 12;
                  break;
                }

                swal("Account Inactive", "Your account is not active. Please contact your administrator.", "error");
                _this3.loginLoading = false;
                return _context3.abrupt("return");

              case 12:
                console.log("response", response.data.isActive);
                _context3.next = 15;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].readDatabase("/users"), __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].readDatabase("/constants"), __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].readDatabase("/leaves")]);

              case 15:
                _ref = _context3.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                allUsersResponse = _ref2[0];
                constants = _ref2[1];
                allLeaves = _ref2[2];


                for (user in allUsersResponse.data) {
                  users.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, allUsersResponse.data[user], { uid: user }));
                }

                _this3.loginLoading = false;

                _this3.$store.commit("setUser", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  uid: response.key
                }, response.data));

                _this3.$store.commit("setAllUsers", users);
                _this3.$store.commit("setConstants", constants.data);
                _this3.$store.commit("setCompany", _this3.selectedCompany);
                _this3.$store.commit("setAllLeaves", allLeaves.data);
                _context3.next = 29;
                return _this3.$store.dispatch('fetchAllTrelloData');

              case 29:

                _this3.fetchAllUsersRealTime();
                _this3.fetchLeavesRealTime();
                _this3.fetchUserLeavesRealTime();
                _this3.fetchConstantsRealTime();
                _this3.fetchNewUsersRealTime();
                _this3.removeUserRealTime();
                console.log("before route");

                _this3.$router.replace("/overview");
                console.log("after route");

                _context3.next = 44;
                break;

              case 40:
                _context3.prev = 40;
                _context3.t0 = _context3["catch"](2);

                _this3.passwordError = _context3.t0.message;
                _this3.loginLoading = false;

              case 44:
                _context3.prev = 44;

                localStorage.removeItem('firebaseConfig');
                return _context3.finish(44);

              case 47:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 40, 44, 47]]);
      }))();
    },
    selectCompany: function selectCompany(company) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.selectedCompany = company;

                _context4.prev = 1;

                if (!__WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].checkAlreadyConfiguredApp()) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].unconfigureFirebase();

              case 5:
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].configureFirebase(company.firebase);

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);

                __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()("Error!", _context4.t0.message, "error");

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 9]]);
      }))();
    },
    confirmCompanySelection: function confirmCompanySelection() {
      var _this5 = this;

      var selectedCompany = this.companies.find(function (company) {
        return (company.id || company.companyName) === _this5.selectedCompanyId;
      });

      if (selectedCompany) {
        this.selectCompany(selectedCompany);
      }

      this.closeCompanyModal();
    },
    findCompany: function findCompany(emailToFind) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var emailToCheck, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                emailToCheck = emailToFind || _this6.email.toLowerCase();
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_api__["a" /* default */].findCompanyByEmail(emailToCheck);

              case 4:
                response = _context5.sent;
                return _context5.abrupt("return", response);

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                console.error('findCompanyByEmail error:', _context5.t0);
                throw _context5.t0;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 8]]);
      }))();
    },
    changeEmail: function changeEmail() {
      this.selectedCompany = null;
      this.email = "";
      this.password = "";
      this.companies = [];
      this.showPasswordField = false;
      this.emailValidated = false;
    },
    changeCompany: function changeCompany() {
      if (this.selectedCompany) {
        this.selectedCompanyId = this.selectedCompany.id || this.selectedCompany.companyName;
      }
      this.openCompanyModal();
    },
    openCompanyModal: function openCompanyModal() {
      this.isCompanyModalOpen = true;
    },
    closeCompanyModal: function closeCompanyModal() {
      this.isCompanyModalOpen = false;
    },
    fetchNewUsersRealTime: function fetchNewUsersRealTime() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database().ref("users").on("child_added", function (data) {
        if (data.val()) {
          var allUsers = _this7.$store.state.auth.allUsers;
          var foundUser = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.find(allUsers, { uid: data.key });
          if (!foundUser) {
            _this7.$store.commit("setAllUsers", [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(allUsers), [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data.val(), { uid: data.key })]));
          }
        }
      });
    },
    removeUserRealTime: function removeUserRealTime() {
      var _this8 = this;

      var allUsers = this.$store.state.auth.allUsers;

      __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database().ref("users").on("child_removed", function (data) {
        if (data.val()) {
          var foundIndex = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.findIndex(allUsers, { uid: data.key });
          if (foundIndex > -1) {
            allUsers.splice(foundIndex, 1);
            _this8.$store.commit("setAllUsers", allUsers);
          }
        }
      });
    },
    fetchAllUsersRealTime: function fetchAllUsersRealTime() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database().ref("users").on("child_changed", function (data) {
        if (data.val()) {
          var allUsers = _this9.$store.state.auth.allUsers;
          var targetIndex = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.findIndex(allUsers, { uid: data.key });
          allUsers[targetIndex] = data.val();
          _this9.$store.commit("setAllUsers", allUsers);
        }
      });
    },
    fetchConstantsRealTime: function fetchConstantsRealTime() {
      var _this10 = this;

      var constants = this.$store.state.auth.constants || {};

      __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database().ref("constants").on("child_changed", function (data) {
        if (data.val()) {
          constants[data.key] = data.val();
          _this10.$store.commit(s, constants);
        }
      });
    },
    fetchLeavesRealTime: function fetchLeavesRealTime() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database().ref("leaves").orderByChild("createdAt").on("value", function (snapshot) {
        var leaves = [];
        snapshot.forEach(function (childSnapshot) {
          var leave = childSnapshot.val();
          leave.id = childSnapshot.key;
          leaves.push(leave);
        });

        var sortedLeaves = leaves.reverse();
        _this11.$store.commit("setAllLeaves", sortedLeaves);
      }, function (error) {
        console.error("Error fetching real-time leaves: ", error);
      });
    },
    fetchUserLeavesRealTime: function fetchUserLeavesRealTime() {
      var _this12 = this;

      var user = this.$store.state.auth.user;

      if (!user) {
        console.error("User not found!");
        return;
      }

      __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database().ref("leaves").orderByChild("userId").equalTo(user.uid).on("value", function (snapshot) {
        var leaves = [];
        snapshot.forEach(function (childSnapshot) {
          var leave = childSnapshot.val();
          leave.id = childSnapshot.key;
          leaves.push(leave);
        });
        var sortedLeaves = leaves.sort(function (a, b) {
          return b.createdAt - a.createdAt;
        });
        _this12.$store.commit("setUserLeaves", sortedLeaves);
      }, function (error) {
        console.error("Error fetching real-time leaves: ", error);
      });
    }
  }
});

/***/ }),

/***/ "0AJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GradeDropdown_vue__ = __webpack_require__("8uFK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0808cce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GradeDropdown_vue__ = __webpack_require__("L9U3");
function injectStyle (ssrContext) {
  __webpack_require__("qwKD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0808cce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GradeDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0808cce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GradeDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UIComponents_BugReportModal_vue__ = __webpack_require__("P/Qr");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { BugReportModal: __WEBPACK_IMPORTED_MODULE_0__UIComponents_BugReportModal_vue__["a" /* default */] },
  data: function data() {
    return {
      isBugModalOpen: false
    };
  }
});

/***/ }),

/***/ "0Fq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = sanitizeString;
/* harmony export (immutable) */ __webpack_exports__["b"] = sanitizeFilename;
/* harmony export (immutable) */ __webpack_exports__["a"] = validateFile;
function sanitizeString(value) {
	if (!value) return "";
	return String(value).trim().replace(/[<>"]/g, "");
}

function sanitizeFilename(name) {
	if (!name) return "";
	return name.trim().replace(/[^a-zA-Z0-9-_\.]/g, "");
}

function validateFile(file) {
	if (!file || !(file instanceof File)) {
		throw new Error("Invalid file object");
	}
}

/***/ }),

/***/ "0GRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_index_vue__ = __webpack_require__("H902");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EmployeeInformation_index_vue__ = __webpack_require__("2v+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AttendanceDetails_index_vue__ = __webpack_require__("Vs7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SalaryCalculation_index_vue__ = __webpack_require__("ZHb1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SalaryCalculation_LeavesCalculation_vue__ = __webpack_require__("cNeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_loaders_DoubleLoader_vue__ = __webpack_require__("AxYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_notificationService__ = __webpack_require__("l527");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Header: __WEBPACK_IMPORTED_MODULE_7__Header_index_vue__["a" /* default */],
        EmployeeInformation: __WEBPACK_IMPORTED_MODULE_8__EmployeeInformation_index_vue__["a" /* default */],
        AttendanceDetails: __WEBPACK_IMPORTED_MODULE_9__AttendanceDetails_index_vue__["a" /* default */],
        SalaryCalculation: __WEBPACK_IMPORTED_MODULE_10__SalaryCalculation_index_vue__["a" /* default */],
        LeavesCalculation: __WEBPACK_IMPORTED_MODULE_11__SalaryCalculation_LeavesCalculation_vue__["a" /* default */],
        ReuseableModal: __WEBPACK_IMPORTED_MODULE_15__UIComponents_ReuseableModal_vue__["a" /* default */],
        DoubleLoader: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_loaders_DoubleLoader_vue__["a" /* default */]
    },
    props: ["employee"],
    data: function data() {
        var user = this.$store.state.auth.user;
        return {
            currentUser: user,
            isAdmin: user && user.role === "admin",
            isDeleteModalOpen: false,
            isConfirmModalOpen: false,
            isDraftProcessing: false,
            isDraftDeleting: false,
            modalTitle: '',
            modalMessage: '',
            employeeData: {},
            attendanceData: {},
            salaryData: {},
            leavesData: {},
            initialValues: {},
            isPaymentProcessed: false,
            isActionProcessing: false,
            isDrafted: false,
            isDraftUpdated: false,
            payrollIdKey: null,
            selectedMonth: null,
            selectedYear: null,
            isInitialLoading: false,
            dbConstants: null
        };
    },

    computed: {
        selectedEmployee: function selectedEmployee() {
            var emp = this.$store.state.payroll.selectedEmployeePayroll || {};
            this.employeeData = emp;
            return emp;
        },
        isProcessed: function isProcessed() {
            var processedMonth = this.selectedEmployee.month;
            var juneDecPayroll = processedMonth === "June" || processedMonth === "December";
            if (juneDecPayroll) {
                return true;
            }
            var currentDate = new Date();
            var selectedMonth = currentDate.toLocaleString('default', { month: 'long' });
            if (selectedMonth === "June" || selectedMonth === "December") {
                return true;
            }
            return false;
        },
        showPayrollContainer: function showPayrollContainer() {
            var currentData = this.selectedEmployee || this.employeeData || this.employee || {};
            var isEmployee = currentData.status && currentData.status.toLowerCase().trim() === "processed";
            var isAdmin = this.isAdmin;
            var show = !isEmployee && isAdmin || isEmployee && !isAdmin || isEmployee && isAdmin;
            return show;
        }
    },
    methods: {
        updateEmployee: function updateEmployee(newEmployee) {
            var isPerDaySalary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var empData = this.employeeData || {};
            empData.basicSalary = Number(newEmployee.basicSalary);
            empData.extraAllowance = Number(newEmployee.extraAllowance);
            empData.perDaySalary = Number(newEmployee.perDaySalary);

            if (isPerDaySalary) return;
            if (empData.basicSalary !== newEmployee.basicSalary || empData.extraAllowance !== newEmployee.extraAllowance) {
                var basicSalary = parseFloat(empData.basicSalary || 0);
                var extraAllowance = parseFloat(empData.extraAllowance || 0);
                var workingDays = empData.requiredWorkingDays;
                var requiredWorkingDays = parseInt(workingDays, 10) || 0;

                if (requiredWorkingDays > 0 && (basicSalary !== newEmployee.basicSalary || extraAllowance !== newEmployee.extraAllowance)) {

                    var calculatedPerDaySalary = ((basicSalary + extraAllowance) / requiredWorkingDays).toFixed(2);
                    empData.perDaySalary = calculatedPerDaySalary;
                }
            }
        },


        // Update the attendance data
        updateAttendance: function updateAttendance(newAttendance) {
            var _this = this;

            var empData = this.employeeData || {};

            empData.daysWorked = newAttendance.daysWorked;
            empData.leavesTaken = newAttendance.leavesTaken;
            empData.absents = newAttendance.absents;
            empData.lateArrivals = newAttendance.lateArrivals;
            empData.leaveBalance = newAttendance.leaveBalance;
            empData.leavesDeductionDays = Number(newAttendance.leavesDeductionDays);
            empData.lateDeductionDays = Number(newAttendance.lateDeductionDays);
            empData.manualLeaveDeductionDays = Number(newAttendance.manualLeaveDeductionDays);
            empData.leaveDeductionCount = Number(newAttendance.leavesDeductionDays);
            empData.leaveDeductionNote = newAttendance.leaveDeductionNote;
            empData.DBLeavesTaken = Number(newAttendance.DBLeavesTaken);
            empData.absentDays = newAttendance.absentDays;
            empData.totalExtraHoursDays = newAttendance.totalExtraHoursDays;
            this.$nextTick(function () {
                if (_this.$refs.salaryCalculationRef) {
                    _this.$refs.salaryCalculationRef.handleExternalUpdate();
                }
            });
        },


        // Update the salary data
        updateSalary: function updateSalary(newSalary) {
            var empData = this.employeeData || {};

            empData.perDaySalary = newSalary.perDaySalary;
            empData.lateDeduction = newSalary.lateDeduction;
            empData.extraAmountAdjustment = newSalary.extraAmountAdjustment;
            empData.extraAmountAdjustmentNote = newSalary.extraAmountAdjustmentNote;
            empData.taxDeduction = newSalary.taxDeduction;
            empData.bonus = newSalary.bonus;
            empData.transactionFees = newSalary.transactionFees;
            empData.finalAmount = newSalary.finalAmount;
            empData.leavesEncashmentDays = newSalary.leavesEncashmentDays;
            empData.leavesEncashmentAmount = newSalary.leavesEncashmentAmount;
            empData.annualLeavesEncashmentDays = newSalary.annualLeavesEncashmentDays;
        },


        // Update the leaves data
        updateLeaves: function updateLeaves(newLeaves) {
            var empData = this.employeeData || {};

            empData.midYearLeaves = newLeaves.midYearLeaves;
            empData.annualLeaves = newLeaves.annualLeaves;
            empData.remainingLeaves = newLeaves.remainingLeaves;
            empData.carryForwardDays = newLeaves.carryForwardDays;
            empData.updatedLeaveQuota = newLeaves.updatedLeaveQuota;
            empData.leavesEncashmentDays = newLeaves.leavesEncashmentDays;
            empData.leavesQuota = newLeaves.leavesQuota;
            empData.annualLeavesEncashmentDays = newLeaves.leavesEncashmentDays;
        },
        submitAutoLeave: function submitAutoLeave(employeeData) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
                var user, employeeId, employeeName, leaveDeductionCount, leavesTaken, leaveBalance, month, year, leaveDeductionNote, leavesDeductionDays, lateArrivals, DBLeavesTaken, deductedLeaves, newLeavesTaken, payload, res;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                user = _this2.$store.state.auth.user;
                                employeeId = employeeData.employeeId, employeeName = employeeData.employeeName, leaveDeductionCount = employeeData.leaveDeductionCount, leavesTaken = employeeData.leavesTaken, leaveBalance = employeeData.leaveBalance, month = employeeData.month, year = employeeData.year, leaveDeductionNote = employeeData.leaveDeductionNote, leavesDeductionDays = employeeData.leavesDeductionDays, lateArrivals = employeeData.lateArrivals;
                                DBLeavesTaken = Number(employeeData.DBLeavesTaken) || 0;
                                deductedLeaves = Number(leavesDeductionDays) || Number(leaveDeductionCount) || 0;
                                newLeavesTaken = DBLeavesTaken + deductedLeaves;

                                if (!(deductedLeaves <= 0)) {
                                    _context.next = 7;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 7:
                                payload = {
                                    assignees: user.username,
                                    assigneeId: user.uid,
                                    type: "Auto-Deducted",
                                    noofdays: deductedLeaves,
                                    reason: leaveDeductionNote || "Auto-adjusted leaves for " + lateArrivals + " late arrivals \u2013 " + month + " - " + year,
                                    status: "Auto-Deducted",
                                    userId: employeeId,
                                    employee: employeeName,
                                    dates: "-",
                                    leaveBalance: leaveBalance,
                                    createdAt: Date.now(),
                                    createdBy: "Payroll"
                                };
                                _context.prev = 8;
                                _context.next = 11;
                                return __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__["a" /* default */].submitLeave("leaves", payload);

                            case 11:
                                res = _context.sent;

                                console.log("✅ Auto leave submitted:", res);

                                if (!(deductedLeaves > 0)) {
                                    _context.next = 17;
                                    break;
                                }

                                _context.next = 16;
                                return __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__["a" /* default */].updateEmployee({ leavesTaken: newLeavesTaken }, employeeId);

                            case 16:
                                console.log("✅ Employee leavesTaken updated:", newLeavesTaken);

                            case 17:
                                _context.next = 22;
                                break;

                            case 19:
                                _context.prev = 19;
                                _context.t0 = _context["catch"](8);

                                console.error("❌ Failed to submit auto leave:", _context.t0);

                            case 22:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[8, 19]]);
            }))();
        },
        handleProcessPayment: function handleProcessPayment() {
            var _this3 = this;

            var isDraft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var isDeleteDraft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var employeeData, isMoreLeavesDeducted, isLeaveDeductionEqualToTaken, employeeId, employeeName, basicSalary, extraAllowance, workingDays, daysWorked, leavesTaken, absents, lateArrivals, leaveBalance, perDaySalary, lateDeduction, extraAmountAdjustment, bonus, transactionFees, finalAmount, leavesEncashment, updatedSalaryDeduction, grossSalary, calculatedSalary, obtainedLeaves, _obtainedLeaves$split, _obtainedLeaves$split2, leavesTakenParsed, leaveBalanceParsed, currentDate, selectedMonth, selectedYear, payrollRef, userRef, snapshot, existingRecordKey, existingData, payrollId, payrollData, leavesDeduction, DBLeavesTaken, leavesTakenUpdated, deductedLeaves, diff, employeeUserSnapshot, employeeUser, employeeEmail, status, _updatedFields, _changes, title, description, newPayrollRef, updatedFields, changes, _title, _description, isUpdatedBasicSalary, isUpdatedExtraAllowance, userSnapshot, userData, updateUserData, _updatedFields2, _changes2, _title2, _description2, _title3, _description3, newLeavesAllowed, leaveUpdateData;

                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!isDeleteDraft) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 3;
                                return _this3.deleteDraftPayroll();

                            case 3:
                                return _context2.abrupt("return", _context2.sent);

                            case 4:
                                if (!isDraft) _this3.isActionProcessing = true;
                                employeeData = _this3.employeeData || {};
                                isMoreLeavesDeducted = Number(employeeData.leavesTaken) < Number(employeeData.leaveDeductionCount);
                                isLeaveDeductionEqualToTaken = Number(employeeData.leavesTaken) === Number(employeeData.leaveDeductionCount);

                                if (!((isMoreLeavesDeducted || isLeaveDeductionEqualToTaken) && !isDraft)) {
                                    _context2.next = 11;
                                    break;
                                }

                                _context2.next = 11;
                                return _this3.submitAutoLeave(employeeData);

                            case 11:
                                employeeId = employeeData.employeeId || "N/A";
                                employeeName = employeeData.employeeName || "Unknown";
                                basicSalary = employeeData.basicSalary || 0;
                                extraAllowance = employeeData.extraAllowance || 0;
                                //const workingDays = employeeData.workingDays || 22;       // there is no workingDays in employeeData but requiredWorkingDays so I chenged it   

                                workingDays = employeeData.requiredWorkingDays || 22;
                                daysWorked = employeeData.daysWorked || 0;
                                leavesTaken = employeeData.leavesTaken || 0;
                                absents = employeeData.absents || 0;
                                lateArrivals = employeeData.lateArrivals || 0;
                                leaveBalance = employeeData.leaveBalance || 0;
                                perDaySalary = employeeData.perDaySalary || (Number(basicSalary) + Number(extraAllowance)) / workingDays;
                                lateDeduction = employeeData.lateDeduction || 0;
                                extraAmountAdjustment = employeeData.extraAmountAdjustment || 0;
                                bonus = employeeData.bonus || 0;
                                transactionFees = employeeData.transactionFees || 0;
                                finalAmount = employeeData.finalAmount || 0;
                                leavesEncashment = employeeData.leavesEncashment || 0;
                                updatedSalaryDeduction = lateDeduction + " - " + lateArrivals;
                                grossSalary = Number(basicSalary) + Number(extraAllowance);
                                calculatedSalary = perDaySalary * daysWorked;
                                obtainedLeaves = leavesTaken + " / " + leaveBalance;
                                _obtainedLeaves$split = obtainedLeaves.split(" / ").map(Number), _obtainedLeaves$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_obtainedLeaves$split, 2), leavesTakenParsed = _obtainedLeaves$split2[0], leaveBalanceParsed = _obtainedLeaves$split2[1];
                                currentDate = new Date();
                                selectedMonth = employeeData.month;
                                selectedYear = employeeData.year;
                                payrollRef = __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("payroll/" + selectedYear + "/" + selectedMonth);
                                userRef = __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("users/" + employeeId);

                                // Check if a record exists for the given employee, month, and year

                                _context2.next = 40;
                                return payrollRef.orderByChild("employeeId").equalTo(employeeId).once("value");

                            case 40:
                                snapshot = _context2.sent;
                                existingRecordKey = null;
                                existingData = null;


                                snapshot.forEach(function (childSnapshot) {
                                    var data = childSnapshot.val();
                                    if (data.month === selectedMonth && data.year === selectedYear) {
                                        existingRecordKey = childSnapshot.key;
                                        existingData = data;
                                    }
                                });

                                payrollId = existingData && existingData.payrollId ? existingData.payrollId : selectedYear + "_" + selectedMonth + "_" + __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref().push().key;
                                payrollData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
                                    payrollId: payrollId,
                                    employeeId: employeeId,
                                    employeeName: employeeName,
                                    employeeDesignation: employeeData.employeeDesignation,
                                    basicSalary: Number(basicSalary),
                                    perDaySalary: Number(perDaySalary) || Number(grossSalary / workingDays),
                                    requiredWorkingDays: Number(workingDays),
                                    daysWorked: Number(daysWorked),
                                    absents: Number(absents),
                                    actualAbsents: Number(employeeData.actualAbsents || 0),
                                    lateArrivals: Number(lateArrivals),
                                    lateDeduction: updatedSalaryDeduction,
                                    obtainedLeaves: obtainedLeaves,
                                    leavesTaken: Number(leavesTakenParsed),
                                    extraAllowance: Number(extraAllowance),
                                    extraAmountAdjustment: Number(extraAmountAdjustment),
                                    bonus: Number(bonus),
                                    transactionFees: Number(transactionFees),
                                    finalAmount: Number(finalAmount),
                                    status: isDraft ? "Draft" : "Processed",
                                    shift: (employeeData.shift || "Morning").toLowerCase(),
                                    month: selectedMonth,
                                    year: selectedYear,
                                    leavesEncashment: Number(leavesEncashment),
                                    remainingLeaves: Number("" + (leaveBalanceParsed - leavesTakenParsed)),
                                    // leavesQuota: {
                                    //     remainingLeaves: Number(employeeData.leavesQuota.remainingLeaves || 0),
                                    //     carryForwardDays: Number(employeeData.leavesQuota.carryForwardDays || 0),
                                    //     updatedLeaveQuota: Number(employeeData.leavesQuota.updatedLeaveQuota || 0),
                                    //     leavesEncashmentDays: Number(employeeData.leavesQuota.leavesEncashmentDays || 0)
                                    // },
                                    leavesEncashmentDays: Number(employeeData.leavesEncashmentDays || 0),
                                    leavesEncashmentAmount: Number(employeeData.leavesEncashmentAmount || 0),
                                    monthlyLeaves: employeeData.monthlyLeaves || [],
                                    totalNormalHours: Number(employeeData.totalNormalHours || 0),
                                    totalExtraHours: Number(employeeData.totalExtraHours || 0),
                                    lowHoursDays: employeeData.lowHoursDays || {},
                                    totalLowHours: Number(employeeData.totalLowHours || 0),
                                    reqWorkingHours: Number(employeeData.reqWorkingHours || 0),
                                    extraAmountAdjustmentNote: employeeData.extraAmountAdjustmentNote || "",
                                    taxDeduction: Number(employeeData.taxDeduction || 0),
                                    leaveDeductionNote: employeeData.leaveDeductionNote || "",
                                    leavesDeductionDays: Number(employeeData.leavesDeductionDays || 0),
                                    lateDeductionDays: Number(employeeData.lateDeductionDays || 0),
                                    perDayProductiveHours: Number(employeeData.perDayProductiveHours || employeeData.productiveHours || 0),
                                    remainingHalfDays: employeeData.remainingHalfDays || {},
                                    totalHalfDayHours: Number(employeeData.totalHalfDayHours || 0),
                                    halfDays: employeeData.halfDays || {},
                                    normalDaysWorked: Number(employeeData.normalDaysWorked || 0),
                                    newLeaveBalance: Number(employeeData.newLeaveBalance || 0),
                                    requiredTotalWorkingHours: Number(employeeData.requiredTotalWorkingHours || 0),
                                    requiredTotalWorkingDays: employeeData.requiredTotalWorkingDays || {},
                                    normalHoursDays: employeeData.normalHoursDays || {},
                                    leavesAllowed: Number(employeeData.leavesAllowed || 0),
                                    leavesAvailable: Number(employeeData.leavesAvailable || 0),
                                    DBLeavesTaken: Number(employeeData.DBLeavesTaken || 0),
                                    absentDays: employeeData.absentDays || null,
                                    totalExtraHoursDays: employeeData.totalExtraHoursDays || null,
                                    empTotalHours: employeeData.empTotalHours || 0
                                }, "normalHoursDays", employeeData.normalHoursDays || null);


                                if (employeeData.leavesQuota) {
                                    payrollData.leavesQuota = employeeData.leavesQuota;
                                }
                                if (employeeData.midYearLeaves) {
                                    payrollData.midYearLeaves = employeeData.midYearLeaves;
                                }
                                if (employeeData.annualLeaves) {
                                    payrollData.annualLeaves = employeeData.annualLeaves;
                                }
                                // Record when the payroll was first processed (shown as the payslip's payment date).
                                // Re-saving an already processed payroll keeps the original date.
                                if (!isDraft) {
                                    payrollData.processedAt = existingData && existingData.status === "Processed" && existingData.processedAt || Date.now();
                                }

                                // Carry every remaining field of the existing record through the save.
                                // The object literal above only lists the fields payroll recalculates, so
                                // without this a save would silently drop display-only fields that the
                                // attendance/salary tooltips read (holiday details, workingDays,
                                // employeeStatus, totalDaysWorked, ...) and leave them blank until reload.
                                // Firebase rejects an `undefined` value anywhere in the payload, so any
                                // key that is explicitly undefined is stripped before merging.
                                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(employeeData).forEach(function (key) {
                                    if (payrollData[key] === undefined && employeeData[key] !== undefined) {
                                        payrollData[key] = employeeData[key];
                                    }
                                });

                                if (payrollData.month === "June" || payrollData.month === "December") {
                                    leavesDeduction = Number(employeeData.leavesDeductionDays) || 0;
                                    DBLeavesTaken = Number(employeeData.DBLeavesTaken) || 0;
                                    leavesTakenUpdated = Number(employeeData.leavesTaken) || 0;
                                    deductedLeaves = Math.abs(leavesDeduction - leavesTakenUpdated);
                                    diff = payrollData.month === "June" ? Math.abs(DBLeavesTaken - deductedLeaves) : 0;


                                    payrollData.leavesQuota = {
                                        remainingLeaves: Number(employeeData.leavesQuota.remainingLeaves) || 0,
                                        carryForwardDays: Number(employeeData.leavesQuota.carryForwardDays) || 0,
                                        updatedLeaveQuota: Number(employeeData.leavesQuota.updatedLeaveQuota) || 0,
                                        leavesEncashmentDays: Number(employeeData.leavesQuota.leavesEncashmentDays) || 0
                                    };
                                }
                                _context2.next = 54;
                                return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("users/" + employeeId).once("value");

                            case 54:
                                employeeUserSnapshot = _context2.sent;
                                employeeUser = employeeUserSnapshot.val() || {};
                                employeeEmail = employeeUser.email || "N/A";
                                _context2.prev = 57;

                                if (!existingRecordKey) {
                                    _context2.next = 101;
                                    break;
                                }

                                status = existingData.status && existingData.status;

                                if (!(status !== "Pending")) {
                                    _context2.next = 75;
                                    break;
                                }

                                // Update existing record if status is not "Pending"
                                console.log("update payroll record", payrollData);
                                _context2.next = 64;
                                return payrollRef.child(existingRecordKey).update(payrollData);

                            case 64:
                                console.log("✅ Payroll record updated:", existingRecordKey);
                                swal((isDraft ? "Draft" : "Payroll") + " has been " + (status === "Draft" && !isDraft ? "Processed" : "Updated"), "Updated", "success");

                                if (!(status === "Draft" && isDraft)) {
                                    _context2.next = 73;
                                    break;
                                }

                                _updatedFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["a" /* getUpdatedFields */])(existingData || {}, payrollData);
                                _changes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_updatedFields).map(function (_ref) {
                                    var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                                        key = _ref2[0],
                                        value = _ref2[1];

                                    return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.new);
                                }).join('\n');
                                title = _this3.currentUser.username + " updated the payroll draft for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                description = _this3.currentUser.email + " updated the payroll draft for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _context2.next = 73;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["d" /* createActivityPayload */])({
                                    user: _this3.currentUser,
                                    title: title,
                                    description: description,
                                    changes: _changes,
                                    type: "payroll"
                                }));

                            case 73:
                                _context2.next = 90;
                                break;

                            case 75:
                                if (!(status === "Draft" && isDraft)) {
                                    _context2.next = 83;
                                    break;
                                }

                                console.log("update payroll record", payrollData);
                                _context2.next = 79;
                                return payrollRef.child(existingRecordKey).update(payrollData);

                            case 79:
                                console.log("✅ Payroll record updated:", existingRecordKey);
                                swal((isDraft ? "Draft" : "Payroll") + " has been " + (status === "Draft" && !isDraft ? "Processed" : "Updated"), "Updated", "success");
                                _context2.next = 90;
                                break;

                            case 83:
                                console.log("🆕 Existing record is 'Pending', creating a new one.");
                                newPayrollRef = payrollRef.push();
                                _context2.next = 87;
                                return newPayrollRef.set(payrollData);

                            case 87:

                                console.log("update payroll record", payrollData);
                                swal((isDraft ? "Draft" : "Payroll") + " has been " + (status === "Draft" && !isDraft ? "Processed" : "Created"), "Created", "success");

                                console.log("✅ New payroll record created.");

                            case 90:
                                updatedFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["a" /* getUpdatedFields */])(existingData || {}, payrollData);
                                changes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(updatedFields).map(function (_ref3) {
                                    var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                                        key = _ref4[0],
                                        value = _ref4[1];

                                    return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.new);
                                }).join('\n');

                                if (!(!isDraft && !isDeleteDraft)) {
                                    _context2.next = 99;
                                    break;
                                }

                                _title = _this3.currentUser.username + " processed payroll for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _description = _this3.currentUser.email + " processed payroll for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _context2.next = 97;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["d" /* createActivityPayload */])({
                                    user: _this3.currentUser,
                                    title: _title,
                                    description: _description,
                                    changes: changes,
                                    username: employeeName,
                                    type: "payroll",
                                    uid: employeeId
                                }));

                            case 97:
                                _context2.next = 99;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__services_notificationService__["b" /* handleActivityNotification */])({
                                    type: "payroll",
                                    activityDescription: _description,
                                    activityOnUser: _this3.employeeData.employeeId,
                                    activityOnUserName: employeeName,
                                    activityByUserName: _this3.currentUser.username
                                }, _this3.$store.state.auth, _this3.currentUser.uid);

                            case 99:
                                _context2.next = 139;
                                break;

                            case 101:
                                // No record exists, create a new one
                                console.log("create payroll record", payrollData);

                                _context2.next = 104;
                                return payrollRef.child(payrollId).set(payrollData);

                            case 104:
                                isUpdatedBasicSalary = _this3.initialValues.basicSalary != basicSalary;
                                isUpdatedExtraAllowance = _this3.initialValues.extraAllowance != extraAllowance;

                                // Check if employee exists in User collection and update salary details if missing

                                _context2.next = 108;
                                return userRef.once("value");

                            case 108:
                                userSnapshot = _context2.sent;

                                if (!userSnapshot.exists()) {
                                    _context2.next = 120;
                                    break;
                                }

                                userData = userSnapshot.val();
                                updateUserData = {};


                                if (!userData.basicSalary || isUpdatedBasicSalary) {
                                    updateUserData.basicSalary = basicSalary;
                                }
                                if (!userData.extraAllowance || isUpdatedExtraAllowance) {
                                    updateUserData.extraAllowance = extraAllowance;
                                }

                                if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(updateUserData).length > 0)) {
                                    _context2.next = 118;
                                    break;
                                }

                                _context2.next = 117;
                                return userRef.update(updateUserData);

                            case 117:
                                console.log("\u2705 User " + employeeId + " updated with missing salary details.");

                            case 118:
                                _context2.next = 121;
                                break;

                            case 120:
                                console.log("\u26A0\uFE0F Employee " + employeeId + " not found in users collection.");

                            case 121:

                                console.log("✅ New payroll record created.");
                                _this3.employeeData.status = isDraft ? "Draft" : "Processed";
                                if (payrollData.processedAt) _this3.employeeData.processedAt = payrollData.processedAt;

                                _updatedFields2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["a" /* getUpdatedFields */])(existingData || {}, payrollData);
                                _changes2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_updatedFields2).map(function (_ref5) {
                                    var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                                        key = _ref6[0],
                                        value = _ref6[1];

                                    return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.new);
                                }).join('\n');

                                if (!(isDraft && !isDeleteDraft)) {
                                    _context2.next = 131;
                                    break;
                                }

                                _title2 = _this3.currentUser.username + " saved the payroll draft for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _description2 = _this3.currentUser.email + " saved the payroll draft for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _context2.next = 131;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["d" /* createActivityPayload */])({
                                    user: _this3.currentUser,
                                    title: _title2,
                                    description: _description2,
                                    changes: _changes2,
                                    type: "payroll"
                                }));

                            case 131:
                                if (!(!isDraft && !isDeleteDraft)) {
                                    _context2.next = 138;
                                    break;
                                }

                                _title3 = _this3.currentUser.username + " processed payroll for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _description3 = _this3.currentUser.email + " processed payroll for " + employeeName + " for " + selectedMonth + " " + selectedYear + ".";
                                _context2.next = 136;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["d" /* createActivityPayload */])({
                                    user: _this3.currentUser,
                                    title: _title3,
                                    description: _description3,
                                    changes: _changes2,
                                    username: employeeName,
                                    type: "payroll",
                                    uid: employeeId
                                }));

                            case 136:
                                _context2.next = 138;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__services_notificationService__["b" /* handleActivityNotification */])({
                                    type: "payroll",
                                    activityDescription: _description3,
                                    activityOnUser: _this3.employeeData.employeeId,
                                    activityOnUserName: employeeName,
                                    activityByUserName: _this3.currentUser.username
                                }, _this3.$store.state.auth, _this3.currentUser.uid);

                            case 138:
                                swal((isDraft ? "Draft" : "Payroll") + " has been Created", "Created", "success");

                            case 139:
                                newLeavesAllowed = payrollData.leavesQuota && payrollData.leavesQuota.updatedLeaveQuota;

                                if (!(!isDraft && (payrollData.month === "June" || payrollData.month === "December") && newLeavesAllowed)) {
                                    _context2.next = 149;
                                    break;
                                }

                                leaveUpdateData = {};


                                if (payrollData.month === "June") {
                                    leaveUpdateData.leavesAllowed = Number(newLeavesAllowed);
                                    leaveUpdateData.leavesTaken = 0;
                                }

                                if (payrollData.month === "December") {
                                    leaveUpdateData.leavesAvailable = Number(newLeavesAllowed);
                                    leaveUpdateData.leavesAllowed = Number(newLeavesAllowed) / 2;
                                    leaveUpdateData.leavesTaken = 0;
                                }

                                if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(leaveUpdateData).length > 0)) {
                                    _context2.next = 147;
                                    break;
                                }

                                _context2.next = 147;
                                return userRef.update(leaveUpdateData);

                            case 147:
                                _context2.next = 149;
                                break;

                            case 149:

                                _this3.$store.commit('setSelectedEmployeePayroll', payrollData);
                                if (!isDraft) {
                                    _this3.isPaymentProcessed = true;
                                    setTimeout(function () {
                                        _this3.isActionProcessing = false;
                                    }, 900);
                                } else {
                                    _this3.isDrafted = true;
                                }

                                _context2.next = 157;
                                break;

                            case 153:
                                _context2.prev = 153;
                                _context2.t0 = _context2["catch"](57);

                                console.log("e =>", _context2.t0);
                                swal("Oops!", _context2.t0.message, "error");

                            case 157:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[57, 153]]);
            }))();
        },
        deleteDraftPayroll: function deleteDraftPayroll() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref7, employeeId, month, year, payrollId, status, handleSuccess, payrollBaseRef, isPayrollIdAvailable, snapshot, draftKeyToDelete, payrollRef, _snapshot;

                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _ref7 = _this4.employeeData || {}, employeeId = _ref7.employeeId, month = _ref7.month, year = _ref7.year, payrollId = _ref7.payrollId, status = _ref7.status;

                                console.log("employeeId, month, year, payrollId", employeeId, month, year, payrollId);

                                if (!(!employeeId || !month || !year)) {
                                    _context3.next = 6;
                                    break;
                                }

                                swal("Missing Info", "Required employee data is missing.", "warning");
                                return _context3.abrupt("return");

                            case 6:
                                if (!(status !== "Draft")) {
                                    _context3.next = 9;
                                    break;
                                }

                                swal("Not Allowed", "Only draft payrolls can be deleted.", "info");
                                return _context3.abrupt("return");

                            case 9:
                                handleSuccess = function handleSuccess() {
                                    _this4.isDrafted = false;
                                    _this4.isDraftProcessing = false;
                                    _this4.isDraftDeleting = false;
                                    swal("Deleted", "Draft payroll has been deleted successfully.", "success").then(function () {
                                        _this4.$router.push({ path: '/payroll' });
                                    });
                                };

                                payrollBaseRef = __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("payroll/" + year + "/" + month);
                                isPayrollIdAvailable = payrollId.includes(month);

                                console.log("isPayrollIdAvailable", isPayrollIdAvailable);

                                if (isPayrollIdAvailable) {
                                    _context3.next = 30;
                                    break;
                                }

                                console.log("payrollId", payrollId);
                                _context3.next = 17;
                                return payrollBaseRef.once("value");

                            case 17:
                                snapshot = _context3.sent;
                                draftKeyToDelete = null;


                                snapshot.forEach(function (childSnapshot) {
                                    var data = childSnapshot.val();
                                    if (data.employeeId === employeeId && data.status === "Draft" && data.month.toLowerCase() === month.toLowerCase() && data.year == year) {
                                        draftKeyToDelete = childSnapshot.key;
                                    }
                                });

                                if (!draftKeyToDelete) {
                                    _context3.next = 26;
                                    break;
                                }

                                _context3.next = 23;
                                return payrollBaseRef.child(draftKeyToDelete).remove();

                            case 23:
                                handleSuccess();
                                _context3.next = 27;
                                break;

                            case 26:
                                swal("Not Found", "No draft payroll found for this employee.", "info");

                            case 27:
                                return _context3.abrupt("return");

                            case 30:
                                payrollRef = payrollBaseRef.child(payrollId);
                                _context3.next = 33;
                                return payrollRef.once("value");

                            case 33:
                                _snapshot = _context3.sent;

                                if (!_snapshot.exists()) {
                                    _context3.next = 40;
                                    break;
                                }

                                _context3.next = 37;
                                return payrollRef.remove();

                            case 37:
                                handleSuccess();
                                _context3.next = 41;
                                break;

                            case 40:
                                swal("Not Found", "No draft record found at the specified path.", "info");

                            case 41:
                                _context3.next = 47;
                                break;

                            case 43:
                                _context3.prev = 43;
                                _context3.t0 = _context3["catch"](0);

                                console.error("❌ Error deleting draft payroll:", _context3.t0);
                                swal("Error", _context3.t0.message || "Failed to delete draft payroll.", "error");

                            case 47:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4, [[0, 43]]);
            }))();
        },
        handleProcessPayroll: function handleProcessPayroll() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.isDraftProcessing = false;
                                _this5.modalTitle = "Confirm Payroll Processing";
                                _this5.modalMessage = "Are you sure you want to process payroll for this employee?";
                                _this5.isConfirmModalOpen = true;

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        handleSaveAsDraft: function handleSaveAsDraft() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this6.isDraftProcessing = true;
                                _this6.modalTitle = "Confirm Save as Draft";
                                _this6.modalMessage = "Are you sure you want to save payroll as a draft?";
                                _this6.isConfirmModalOpen = true;

                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },
        handleUpdateDraft: function handleUpdateDraft() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this7.isDraftProcessing = true;
                                _this7.modalTitle = "Confirm Update Draft";
                                _this7.modalMessage = "Are you sure you want to update payroll draft?";
                                _this7.isConfirmModalOpen = true;

                            case 4:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },
        handleDeleteDraft: function handleDeleteDraft() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _this8.isDraftDeleting = true;
                                _this8.modalTitle = "Confirm Delete Draft";
                                _this8.modalMessage = "Are you sure you want to delete payroll draft?";
                                _this8.isConfirmModalOpen = true;

                            case 4:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this8);
            }))();
        },
        confirmPayrollAction: function confirmPayrollAction() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _this9.isConfirmModalOpen = false;
                                _context8.next = 3;
                                return _this9.handleProcessPayment(_this9.isDraftProcessing, _this9.isDraftDeleting);

                            case 3:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this9);
            }))();
        },
        exportPayrollDetails: function exportPayrollDetails() {
            // if (!this.Admin) return;
            var employeeData = this.employeeData || {};

            var payrollData = {
                "Employee ID": employeeData.employeeId || "N/A",
                "Employee Name": employeeData.employeeName || "Unknown",
                "Employee Designation": employeeData.employeeDesignation || "Not Specified",
                "Basic Salary": employeeData.basicSalary || 0,
                "Extra Allowance": employeeData.extraAllowance || 0,
                "Total Working Days": employeeData.requiredWorkingDays || 22,
                "Days Worked": employeeData.daysWorked || 0,
                "Leaves Taken": employeeData.leavesTaken || 0,
                "Absents": employeeData.absents || 0,
                "Late Arrivals": employeeData.lateArrivals || 0,
                "Leave Balance": employeeData.leaveBalance || 0,
                "Per Day Salary": employeeData.perDaySalary || 0,
                "Late Deduction": employeeData.lateDeduction || 0,
                "Late Deduction Days": employeeData.lateDeductionDays || 0,
                "Extra Amount Adjustment": employeeData.extraAmountAdjustment || 0,
                "Extra Amount Adjustment Note": employeeData.extraAmountAdjustmentNote || "N/A",
                "Bonus": employeeData.bonus || 0,
                "Transaction Fees": employeeData.transactionFees || 0,
                "Final Amount": employeeData.finalAmount || 0,
                "Leaves Encashment": employeeData.leavesEncashment || 0,
                // "Mid-Year Leaves": employeeData.midYearLeaves && employeeData.midYearLeaves.leavesAvailable || 0,
                // "Annual Leaves Allowed": employeeData.annualLeaves && employeeData.annualLeaves.leavesAllowed || 0,
                // "Annual Leaves Available": employeeData.annualLeaves && employeeData.annualLeaves.leavesAvailable || 0,
                "Month": new Date().toLocaleString("default", { month: "long" }),
                "Year": new Date().getFullYear(),
                "Status": employeeData.status || "Pending"
            };

            // Convert data to an array for Excel
            var payrollArray = [payrollData];

            // Generate Excel file
            var worksheet = XLSX.utils.json_to_sheet(payrollArray);
            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll Details");

            // Download the file
            XLSX.writeFile(workbook, employeeData.employeeName + "_payroll_" + payrollData.Month + "_" + payrollData.Year + ".xlsx");
        },
        fetchConstantsRealTime: function fetchConstantsRealTime() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var constants;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return _this10.$store.dispatch('fetchConstants');

                            case 2:
                                constants = _context9.sent;

                                _this10.$store.commit("setConstants", constants);
                                _this10.dbConstants = constants;
                                return _context9.abrupt("return", constants || {});

                            case 6:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this10);
            }))();
        },
        createNewPayroll: function createNewPayroll() {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
                var company, companyUserIds, allEmployees, notExistingPayrollEmp, selectedYear, selectedMonth, emp, constants, newPayroll;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.prev = 0;
                                company = _this11.$store.state.auth.company;
                                companyUserIds = company.users.map(function (user) {
                                    return user.uid;
                                });
                                allEmployees = _this11.$store.state.auth.allUsers.filter(function (user) {
                                    return companyUserIds.indexOf(user.uid) !== -1;
                                });
                                notExistingPayrollEmp = allEmployees.find(function (v, i) {
                                    return v.uid === (_this11.selectedEmployee && _this11.selectedEmployee.uid || _this11.employee && _this11.employee.employeeId || _this11.payrollIdKey);
                                });
                                selectedYear = _this11.selectedYear || _this11.employee.year;
                                selectedMonth = _this11.selectedMonth || _this11.employee.month;
                                emp = notExistingPayrollEmp || _this11.employee;

                                if (!(!_this11.isAdmin && notExistingPayrollEmp)) {
                                    _context10.next = 11;
                                    break;
                                }

                                swal("Oops!", "No processed payroll found for " + selectedMonth + " " + selectedYear + ".", "error");
                                return _context10.abrupt("return");

                            case 11:
                                constants = _this11.dbConstants || _this11.fetchConstantsRealTime();
                                _context10.next = 14;
                                return _this11.$store.dispatch('createPayrollForEmployee', {
                                    emp: emp,
                                    selectedYear: Number(selectedYear),
                                    selectedMonth: selectedMonth,
                                    constantsCollection: constants && constants.constant ? constants.constant : constants
                                });

                            case 14:
                                newPayroll = _context10.sent;

                                if (newPayroll) {
                                    _this11.$store.commit('setSelectedEmployeePayroll', newPayroll);
                                } else {
                                    console.warn("No new payroll created.");
                                    swal("Oops!", "No processed payroll found for " + _this11.selectedMonth + ", " + _this11.selectedYear + ".", "error");
                                }

                                _context10.next = 22;
                                break;

                            case 18:
                                _context10.prev = 18;
                                _context10.t0 = _context10["catch"](0);

                                console.error("Error creating new payroll:", _context10.t0);
                                throw _context10.t0;

                            case 22:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this11, [[0, 18]]);
            }))();
        },
        fetchPayrollByIdKey: function fetchPayrollByIdKey() {
            var _this12 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
                var payrollRef, snapshot, payrollData;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!(!_this12.payrollIdKey || !_this12.selectedYear || !_this12.selectedMonth)) {
                                    _context11.next = 2;
                                    break;
                                }

                                return _context11.abrupt("return");

                            case 2:
                                // Local flag only: the shared store `loading` also drives the payroll
                                // list page, and toggling it here would blank this page mid-session.
                                _this12.isInitialLoading = true;

                                _context11.prev = 3;
                                payrollRef = __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("payroll/" + _this12.selectedYear + "/" + _this12.selectedMonth + "/" + _this12.payrollIdKey);
                                _context11.next = 7;
                                return payrollRef.once('value');

                            case 7:
                                snapshot = _context11.sent;

                                if (!snapshot.exists()) {
                                    _context11.next = 13;
                                    break;
                                }

                                payrollData = snapshot.val();

                                _this12.$store.commit('setSelectedEmployeePayroll', payrollData);
                                _context11.next = 15;
                                break;

                            case 13:
                                _context11.next = 15;
                                return _this12.createNewPayroll();

                            case 15:
                                _context11.next = 20;
                                break;

                            case 17:
                                _context11.prev = 17;
                                _context11.t0 = _context11["catch"](3);

                                console.error("Error fetching payroll by ID key:", _context11.t0);

                            case 20:
                                _context11.prev = 20;

                                _this12.isInitialLoading = false;
                                return _context11.finish(20);

                            case 23:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this12, [[3, 17, 20, 23]]);
            }))();
        },
        getPayrollIdKeyFromUrl: function getPayrollIdKeyFromUrl() {
            var match = window.location.hash.match(/\/payroll\/details\/([^/]+)/);
            return match ? match[1] : null;
        }
    },
    watch: {
        '$store.state.payroll.selectedEmployeePayroll': function $storeStatePayrollSelectedEmployeePayroll(newVal) {
            if (newVal) {
                this.initialValues = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newVal));
            }
        }
    },
    created: function created() {
        var _this13 = this;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
            var company, initialEmployeeData;
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            company = _this13.$store.state.auth.company;

                            if (__WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.apps.length) {
                                _context12.next = 12;
                                break;
                            }

                            _context12.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__["a" /* default */].configureFirebase(company.firebase);

                        case 4:

                            _this13.payrollIdKey = _this13.getPayrollIdKeyFromUrl();
                            _this13.selectedMonth = localStorage.getItem("payrollMonth") || _this13.selectedMonth;
                            _this13.selectedYear = localStorage.getItem("payrollYear") || _this13.selectedYear;

                            if (!(_this13.payrollIdKey && _this13.selectedYear && _this13.selectedMonth)) {
                                _context12.next = 12;
                                break;
                            }

                            console.log("dayaaaaa");
                            _context12.next = 11;
                            return _this13.fetchConstantsRealTime();

                        case 11:
                            _this13.fetchPayrollByIdKey();

                        case 12:
                            initialEmployeeData = _this13.$store.state.payroll.selectedEmployeePayroll || {};

                            _this13.initialValues = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(initialEmployeeData)); // Deep copy to prevent mutation

                        case 14:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, _this13);
        }))();
    }
});

/***/ }),

/***/ "0HNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerformanceByGrade_vue__ = __webpack_require__("uBxT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PerformanceCriteria_vue__ = __webpack_require__("JRG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FileTable: __WEBPACK_IMPORTED_MODULE_1__PerformanceCriteria_vue__["a" /* default */],
    PerformanceByGrade: __WEBPACK_IMPORTED_MODULE_0__PerformanceByGrade_vue__["a" /* default */]
  },
  computed: {
    isAdmin: function isAdmin() {
      var user = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].state.auth.user;
      return user && user.role === "admin";
    }
  },
  methods: {
    refreshFiles: function refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "0IWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetIconButton_vue__ = __webpack_require__("UA9o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecce4344_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetIconButton_vue__ = __webpack_require__("Gawq");
function injectStyle (ssrContext) {
  __webpack_require__("xYPG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecce4344"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetIconButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecce4344_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetIconButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0NQk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0gK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeStatusDropdown_vue__ = __webpack_require__("dOhZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f23355fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeStatusDropdown_vue__ = __webpack_require__("yfmn");
function injectStyle (ssrContext) {
  __webpack_require__("ILhT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f23355fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeStatusDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f23355fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeStatusDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = canPerformRequestAction;
function canPerformRequestAction(editRequest, currentUser, action) {
  if (!editRequest || !currentUser) {
    return { allowed: false, message: "Invalid data" };
  }

  var requestUserId = editRequest.userId || editRequest.uid || null;
  var requestRole = editRequest.role || null;
  var currentUserId = currentUser.uid || null;
  var currentUserRole = currentUser.role || null;
  var currentUserIsSuperAdmin = currentUser.isSuperAdmin === true;

  if (requestUserId && requestUserId === currentUserId) {
    return { allowed: false, message: "You cannot " + action + " your own data" };
  }

  if (requestRole && requestRole === currentUserRole) {
    console.log("current user isAdmin", currentUser, " IS ADMIN", currentUserIsSuperAdmin);
    if (!currentUserIsSuperAdmin) {
      return {
        allowed: false,
        message: "You cannot " + action + " a request from a user with the same role as yours"
      };
    }
  }

  return { allowed: true, message: "" };
}

/***/ }),

/***/ "1AgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminLeaveManagement_vue__ = __webpack_require__("qD9e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b75256c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminLeaveManagement_vue__ = __webpack_require__("J7u6");
function injectStyle (ssrContext) {
  __webpack_require__("cknC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b75256c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminLeaveManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b75256c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminLeaveManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1KY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('AdminComplains'):_c('EmployeeComplains')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1b4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policies_vue__ = __webpack_require__("72yC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b95b29_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policies_vue__ = __webpack_require__("GVUr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b95b29_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "1rke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaySlip_vue__ = __webpack_require__("Frsz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65126613_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaySlip_vue__ = __webpack_require__("ZsxB");
function injectStyle (ssrContext) {
  __webpack_require__("QsZF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65126613"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaySlip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65126613_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaySlip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Oca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-controls"},[_c('div',{staticClass:"pagination-show"},[_c('label',{attrs:{"for":"itemsPerPage"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemsPerPage),expression:"itemsPerPage"}],attrs:{"id":"itemsPerPage"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemsPerPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.$emit('change-items-per-page', _vm.itemsPerPage)}]}},_vm._l((_vm.pageOptions),function(option){return _c('option',{key:option,domProps:{"value":option}},[_vm._v("\n        "+_vm._s(option)+"\n      ")])}),0)]),_vm._v(" "),_c('ul',{staticClass:"pagination"},[_c('li',{class:{ disabled: _vm.currentPage === 1 },on:{"click":function($event){return _vm.changePage(_vm.currentPage - 1)}}},[_c('span',[_vm._v("Previous")])]),_vm._v(" "),_vm._l((_vm.visiblePages),function(page){return _c('li',{key:page.key,class:{ active: _vm.currentPage === page.value, ellipsis: page.ellipsis },on:{"click":function($event){!page.ellipsis && _vm.changePage(page.value)}}},[_c('span',[_vm._v(_vm._s(page.display))])])}),_vm._v(" "),_c('li',{class:{ disabled: _vm.currentPage === _vm.totalPages },on:{"click":function($event){return _vm.changePage(_vm.currentPage + 1)}}},[_c('span',[_vm._v("Next")])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2U7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-details-header-wrapper"},[_c('div',{staticClass:"payroll-header-container",staticStyle:{"margin":"20px auto"}},[_c('div',{staticClass:"dropdowns-container"},[_c('div',{staticClass:"admin-access-section"},[(!_vm.isEmployeeSearchHidden)?_c('HeaderEmployeeDropdown',{attrs:{"items":_vm.employeeList,"labelKey":"username","searchable":"","placeholder":this.employee.employeeName || 'Select Employee'},on:{"select":_vm.selectEmployee}}):_vm._e()],1),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticStyle:{"width":"300px"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-group"},[_c('div',{staticClass:"searchable-1"},[_c('SearchableDropdown',{attrs:{"items":_vm.months.map(function (month) { return ({ name: month }); }),"labelKey":"name","placeholder":this.employee.month || _vm.selectedMonth || 'Select Month'},on:{"select":_vm.selectMonth}})],1),_vm._v(" "),_c('div',{staticClass:"searchable-2"},[_c('SearchableDropdown',{attrs:{"items":_vm.years.map(function (year) { return ({ name: year }); }),"labelKey":"name","placeholder":Number(this.employee.year || _vm.selectedYear ) || 'Select Year'},on:{"select":_vm.selectYear}})],1)]),_vm._v(" "),_c('div',{staticClass:"payroll-header-actions"},[_c('button',{staticClass:"btn btn-outline",attrs:{"disabled":_vm.isSearching},on:{"click":_vm.filterPayrollData}},[_c('i',{staticClass:"fa fa-search payroll-header-search-icon"})]),_vm._v(" "),(!_vm.isAdmin)?_c('button',{staticClass:"btn btn-outline",on:{"click":function($event){return _vm.$router.push({ path: '/payroll', query: { tab: 'expenses' } })}}},[_vm._v("\n      My Expenses\n    ")]):_vm._e(),_vm._v(" "),(this.isAdmin)?_c('button',{staticClass:"btn btn-outline export-icon-button",on:{"click":_vm.exportToExcel}},[_c('span',{staticClass:"export-icon"},[_vm._v("↓")]),_vm._v("\n      Export\n    ")]):_vm._e()])])]),_vm._v(" "),(_vm.isSearching)?_c('div',{staticClass:"payroll-search-overlay"},[_c('div',{staticClass:"payroll-loader-box"},[_c('DoubleLoader',{staticClass:"payroll-loader"})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09da9e93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("6Wx2");
function injectStyle (ssrContext) {
  __webpack_require__("p/gn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09da9e93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2v+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SWYO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff9af4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("odUX");
function injectStyle (ssrContext) {
  __webpack_require__("7jko")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ff9af4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff9af4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2y6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2yTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HistoryActivityTable",
  props: {
    activities: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      required: true,
      default: function _default() {
        return [{ label: "Activity On", key: "activityOnUserName", width: "200px" }, { label: "Activity By", key: "activityByUserName", width: "200px" }, { label: "Action", key: "action" }, { label: "Updated In", key: "updatedTimeIn" }, { label: "Updated Out", key: "updatedTimeOut" }, { label: "Reason", key: "reason" }, { label: "Timestamp", key: "timestamp", width: "200px", truncate: true, length: 20 }, { label: "OS", key: "osName" }, { label: "Browser", key: "browserName" }, { label: "Map", key: "map", width: "70px" }];
      }
    }
  },
  data: function data() {
    return {
      visibleDetails: {}
    };
  },

  methods: {
    formatTimestamp: function formatTimestamp(ts) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(ts, "DD/MM/YYYY, h:mm:ss a", true).isValid() ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(ts, "DD/MM/YYYY, h:mm:ss a").format("MMMM D, YYYY h:mm:ss A") : "Invalid Date";
    },
    truncateText: function truncateText(text, length) {
      return text && text.length > length ? text.substring(0, length) + "..." : text;
    },
    getBrowserName: function getBrowserName(ua) {
      if (!ua) return "N/A";
      ua = ua.toLowerCase();
      if (ua.includes("chrome") && !ua.includes("edg")) return "Chrome";
      if (ua.includes("firefox")) return "Firefox";
      if (ua.includes("safari") && !ua.includes("chrome")) return "Safari";
      if (ua.includes("edg")) return "Edge";
      if (ua.includes("opr") || ua.includes("opera")) return "Opera";
      return "Other";
    },
    handleMap: function handleMap(mapUrl) {
      this.$emit("open-map", mapUrl);
    },
    getDetailKey: function getDetailKey(activityId, colKey) {
      return activityId + "-" + colKey;
    },
    showDetails: function showDetails(activityId, colKey) {
      var key = this.getDetailKey(activityId, colKey);
      this.$set(this.visibleDetails, key, true);
    },
    hideDetails: function hideDetails(activityId, colKey) {
      var key = this.getDetailKey(activityId, colKey);
      this.$set(this.visibleDetails, key, false);
    }
  }
});

/***/ }),

/***/ "386r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomTable',{attrs:{"loading":_vm.loading,"columns":_vm.adjustmentColumns,"data":_vm.sortedData,"itemsPerPageOptions":[5, 10, 20, 50]},scopedSlots:_vm._u([{key:"employee",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.employeeName || 'N/A')+"\n  ")]}},{key:"adjustmentType",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.adjustmentType)+"\n  ")]}},{key:"amount",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.formatAmount(item))+"\n  ")]}},{key:"reason",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-ellipsis",staticStyle:{"margin-bottom":"-5.5px"},attrs:{"title":item.reason}},[_vm._v("\n      "+_vm._s(item.reason)+"\n    ")])]}},{key:"receipt",fn:function(ref){
var item = ref.item;
return [(item.receiptUrl)?_c('a',{staticClass:"receipt-link",attrs:{"href":item.receiptUrl,"target":"_blank","rel":"noopener"}},[_vm._v("View")]):_c('span',{staticClass:"muted"},[_vm._v("-")])]}},{key:"addedBy",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.addedBy || 'N/A')+"\n  ")]}},{key:"createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.formatDate(item.createdAt))+"\n  ")]}},{key:"action",fn:function(ref){
var item = ref.item;
return [(_vm.canModify(item))?_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"edit-btn btn-status",attrs:{"title":"Edit"},on:{"click":function($event){return _vm.$emit('edit', item)}}},[_c('PencilIcon',{attrs:{"color":"gray","width":16,"height":16}})],1),_vm._v(" "),_c('div',{staticClass:"delete-btn btn-status",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.$emit('openDeleteModal', item)}}},[_c('TrashIcon',{attrs:{"color":"red","width":16,"height":16}})],1)]):_c('span',{staticClass:"muted",attrs:{"title":"Payroll for this month is already processed"}},[_vm._v("Locked")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3IDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReuseableModal',{attrs:{"modelValue":_vm.modelValue,"title":_vm.modalTitle,"submitButtonText":_vm.submitText,"loading":_vm.isLoading,"isLarge":true,"performance":true},on:{"update:modelValue":function($event){return _vm.$emit('update:modelValue', $event)},"submit":_vm.handleSubmit},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"modal-body-container"},[_c('div',{staticClass:"form-scroll-container",staticStyle:{"padding":"12px 14px"}},[_c('div',{staticClass:"mb-1"},[_c('CustomDropdown',{attrs:{"options":_vm.criteriaNames,"value":_vm.form.criteriaName,"label":"Type","required":true,"placeholder":"Select Type"},on:{"change":_vm.handleCriteriaChange}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("\n            Title "),_c('span',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.form.type === 'Ticket' ? '*' : ''))]),_vm._v(_vm._s(_vm.form.type === 'Ticket' ? '' : '(Auto-generated)')+"\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTitle),expression:"displayTitle"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.form.type !== 'Ticket',"placeholder":_vm.form.type === 'Ticket' ? 'Enter ticket title' : 'Title will be auto-generated'},domProps:{"value":(_vm.displayTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayTitle=$event.target.value}}})]),_vm._v(" "),(['Ticket', 'Lead Per Project'].includes(_vm.form.type))?_c('div',{staticClass:"mb-1"},[_c('CustomDropdown',{attrs:{"options":_vm.projectOptions,"value":_vm.form.project,"label":"Project","placeholder":"Select Project","required":_vm.form.type === 'Lead Per Project' || _vm.form.type === 'Ticket',"search":""},on:{"change":_vm.handleProjectChange}})],1):_vm._e(),_vm._v(" "),(_vm.form.type === 'Ticket')?_c('div',[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("\n              Ticket URL "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.url),expression:"form.url"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"https://trello.com/c/..."},domProps:{"value":(_vm.form.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row g-3 mb-3"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("\n                Duration (hrs) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.duration),expression:"form.duration",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(_vm.form.duration)},on:{"keydown":_vm.preventDecimalInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "duration", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Reopens")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.reopens),expression:"form.reopens",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.form.reopens)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "reopens", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Deadline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.deadlineMissed),expression:"form.deadlineMissed",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.form.deadlineMissed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "deadlineMissed", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])])]):(_vm.form.type === 'PR Review/Help')?_c('div',{staticClass:"mb-3 mt-3"},[_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-0 me-2 text-start"},[_vm._v("\n              PRs / Helps\n            ")]),_vm._v(" "),(!_vm.hasLimit)?_c('small',{staticClass:"text-muted"},[_vm._v("(divisible by "+_vm._s(_vm.prDivisor)+" → "+_vm._s(_vm.prScore)+" scores per "+_vm._s(_vm.prDivisor)+")")]):_c('small',{staticClass:"text-muted"},[_vm._v("(at least "+_vm._s(_vm.limitValue)+" → "+_vm._s(_vm.prScore)+" scores)")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":_vm.addPr}},[_c('i',{staticClass:"fa fa-plus me-1"}),_vm._v("Add PR/Help\n             ")])]),_vm._v(" "),_vm._l((_vm.form.prs),function(pr,index){return _c('div',{key:index,staticClass:"input-group mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(pr.link),expression:"pr.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter PR link or help description"},domProps:{"value":(pr.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pr, "link", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.removePr(index)}}},[_c('i',{staticClass:"fa fa-trash"})])])})],2):(_vm.form.type === 'Weekly Session')?_c('div',{staticClass:"row g-3 mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Rating ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.value),expression:"form.value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.form.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "value", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Date "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.date),expression:"form.date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.form.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "date", $event.target.value)}}})])]):(['Weekly Session Attendance', 'Random Post'].includes(_vm.form.type))?_c('div',{staticClass:"mb-3",staticStyle:{"position":"relative"}},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("\n            "+_vm._s(_vm.form.type === 'Weekly Session Attendance' ? 'Sessions Attended' : 'No. of Posts')+"\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"right":"0px","top":"0px","position":"absolute"}},[(!_vm.hasLimit)?_c('small',{staticClass:"text-muted "},[(_vm.form.type === 'Weekly Session Attendance')?_c('span',[_vm._v("\n                ("+_vm._s(_vm.attScore.toFixed(1))+" scores each)\n              ")]):_c('span',[_vm._v("\n                (must be even → "+_vm._s(_vm.randomScore.toFixed(1))+" score per "+_vm._s(_vm.randomDivisor)+")\n              ")])]):_c('small',{staticClass:"text-muted",staticStyle:{}},[(_vm.form.type === 'Weekly Session Attendance')?_c('span',[_vm._v("\n                (at least "+_vm._s(_vm.limitValue)+" → "+_vm._s(_vm.attScore.toFixed(1))+" scores)\n              ")]):_c('span',[_vm._v("\n                (at least "+_vm._s(_vm.limitValue)+" → "+_vm._s(_vm.randomScore.toFixed(1))+" scores)\n              ")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.count),expression:"form.count",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":_vm.minCount,"step":_vm.countStep},domProps:{"value":(_vm.form.count)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "count", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]):(_vm.form.type === 'Weekly Session Lead')?_c('div',{staticClass:"alert alert-info small mb-3 py-2"},[_c('i',{staticClass:"fa fa-star me-2"}),_vm._v(" "),_c('strong',[_vm._v("Weekly Session Lead:")]),_vm._v(" Automatically awards "+_vm._s(_vm.leadScore)+" score.\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Reason")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.reason),expression:"form.reason"}],attrs:{"rows":"3","maxlength":"400","placeholder":"Provide context or justification..."},domProps:{"value":(_vm.form.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "reason", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"text-end text-muted small mt-1"},[_vm._v(_vm._s(_vm.form.reason.length)+"/400")])]),_vm._v(" "),_c('div',{staticClass:"score-card p-3 text-center rounded bg-light mb-0"},[_c('h5',{staticClass:"mb-1 text-primary"},[_c('i',{staticClass:"fa fa-trophy me-2"}),_vm._v("\n            Calculated Score\n          ")]),_vm._v(" "),_c('h3',{staticClass:"mb-0 fw-bold text-primary"},[_vm._v(_vm._s(_vm.calcScore.toFixed(1)))])])])])]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3NxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"payroll-container"},[_c('PayrollTable')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Sp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3dPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReuseableModal',{attrs:{"modelValue":_vm.modelValue,"title":(_vm.meeting.nextIncrementMeetingDetails && _vm.meetingType === 'increment') || (_vm.meeting.nextQuarterlyMeetingDetails && _vm.meetingType === 'quarterly') ? 'Edit Meeting' : 'Schedule Meeting',"isLarge":true,"submitButtonText":"Save Meeting","closeButtonText":"Cancel","scrollable":true,"loading":_vm.loading.saveMeeting},on:{"update:modelValue":function($event){return _vm.$emit('update:modelValue', $event)},"submit":_vm.saveMeeting,"close":_vm.resetForm},scopedSlots:_vm._u([{key:"footer",fn:function(){return [((_vm.meeting.nextIncrementMeetingDetails && _vm.meetingType === 'increment') || (_vm.meeting.nextQuarterlyMeetingDetails && _vm.meetingType === 'quarterly'))?_c('button',{staticClass:"danger-button",attrs:{"disabled":_vm.loading.deleteMeeting},on:{"click":_vm.deleteMeeting}},[(_vm.loading.deleteMeeting)?_c('span',[_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle","cursor":"progress"},attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v("\n        Delete Meeting\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","gap":"10px","margin-left":"auto"}},[_c('button',{staticClass:"secondary-button",on:{"click":function($event){return _vm.$emit('update:modelValue', false)}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('button',{staticClass:"primary-button",staticStyle:{"width":"130px"},attrs:{"disabled":_vm.loading.saveMeeting},on:{"click":_vm.saveMeeting}},[(_vm.loading.saveMeeting)?_c('span',{staticStyle:{"width":"80px"}},[_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle","cursor":"progress"},attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v("\n          Save Meeting\n        ")])])])]},proxy:true}])},[(_vm.selectedEmployee)?_c('div',{staticClass:"selected-employee"},[_vm._v("\n    Employee: "+_vm._s(_vm.selectedEmployee.username)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"meeting-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v("Date "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.date),expression:"form.date"}],attrs:{"type":"date"},domProps:{"value":(_vm.form.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "date", $event.target.value)}}}),_vm._v(" "),(_vm.errors.date)?_c('small',{staticClass:"error",staticStyle:{"margin-top":"-4px"}},[_vm._v(_vm._s(_vm.errors.date))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Time "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.time),expression:"form.time"}],attrs:{"type":"time"},domProps:{"value":(_vm.form.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "time", $event.target.value)}}}),_vm._v(" "),(_vm.errors.time)?_c('small',{staticClass:"error",staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(_vm.errors.time))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"field field-container"},[_c('div',[_c('label',[_vm._v("Title "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],attrs:{"type":"text"},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}})]),_vm._v(" "),(_vm.errors.title)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.title))]):_c('small',{staticClass:"hint"},[_vm._v("Auto-generated, but you can edit it")])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Attendees "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"attendees-container"},_vm._l((_vm.users),function(user){return _c('label',{key:user.id,staticClass:"attendee-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.attendees),expression:"form.attendees"}],staticClass:"attendees-checkbox",attrs:{"type":"checkbox"},domProps:{"value":user.email,"checked":Array.isArray(_vm.form.attendees)?_vm._i(_vm.form.attendees,user.email)>-1:(_vm.form.attendees)},on:{"change":function($event){var $$a=_vm.form.attendees,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.email,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "attendees", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "attendees", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "attendees", $$c)}}}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px","width":"max-content"}},[[_c('img',{staticStyle:{"width":"32px","height":"32px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":user.profile_picture || 'static/img/default-dp.png',"alt":"avatar"}})],_vm._v(" "),_c('span',[_vm._v(_vm._s(user.username))])],2)])}),0),_vm._v(" "),(_vm.errors.attendees)?_c('small',{staticClass:"error",staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(_vm.errors.attendees))]):_c('small',{staticClass:"hint"},[_vm._v("\n        "+_vm._s(_vm.form.attendees.length)+" attendee(s) selected\n      ")])]),_vm._v(" "),_c('div',{staticClass:"field field-container"},[_c('div',[_c('label',[_vm._v("Description "),_c('span',{staticClass:"optional"},[_vm._v("(Optional)")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],attrs:{"placeholder":"Optional"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})]),_vm._v(" "),_c('small',{staticClass:"hint"},[_vm._v("Auto-generated, but you can edit or clear it")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3o/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admindashboard_vue__ = __webpack_require__("BZqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de98e51c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admindashboard_vue__ = __webpack_require__("tMXJ");
function injectStyle (ssrContext) {
  __webpack_require__("8I5V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de98e51c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admindashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de98e51c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admindashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3qd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicHoliday_vue__ = __webpack_require__("XXp+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cdf27a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicHoliday_vue__ = __webpack_require__("djO0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicHoliday_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cdf27a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicHoliday_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4KxV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileTable',{ref:"fileTable",attrs:{"isAdmin":_vm.isAdmin}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4NFJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"complains"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"header-section"},[_c('div',{staticClass:"dropdown-section"},[_c('EmployeeDropdown',{attrs:{"employees":_vm.$store.state.auth.allUsers,"company":_vm.$store.state.auth.company,"defaultFilter":"active"},on:{"update":function($event){_vm.filteredUsers = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"add-complains",on:{"click":_vm.openAddComplainModal}},[_vm._v("Add")])])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center py-3",staticStyle:{"margin-top":"60px"}},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.complains},scopedSlots:_vm._u([{key:"assignee",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.assigneeName || '-'}},[_vm._v(_vm._s(item.assigneeName || '-'))])]}},{key:"email",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.email}},[_vm._v(_vm._s(item.email || '-'))])]}},{key:"title",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.title}},[_vm._v(_vm._s(item.title || '-'))])]}},{key:"desc",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.originalDesc}},[_vm._v(" "+_vm._s(item.originalDesc || '-')+" ")])]}},{key:"isHighPriority",fn:function(ref){
var item = ref.item;
return [_c('span',{style:({ color: item.isHighPriority ? '#FF4E50' : 'blue',  })},[_vm._v("\n                  "+_vm._s(item.isHighPriority ? "High" : "Normal" || '-')+"\n                ")])]}},{key:"isPersonal",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.isPersonal ? "Personal" : "General" || '-'))])]}},{key:"dateLastActivity",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.moment(item.dateLastActivity).fromNow() || '-'))])]}},{key:"feedback",fn:function(ref){
var item = ref.item;
return [(item.status === 'Resolved')?_c('div',{staticClass:"feedback-cell",attrs:{"title":!item.feedback ? 'No feedback yet' : null}},[(item.feedback)?[_c('span',{staticClass:"stars-contianer"},[_c('span',{staticClass:"stars",staticStyle:{"font-size":"1.7em"}},_vm._l((5),function(n){return _c('span',{key:n,class:{ 'star-filled': n <= item.feedback.rating }},[_vm._v("★")])}),0)]),_vm._v(" "),(item.feedback.comment)?_c('span',{staticClass:"detail-tooltip-wrapper",staticStyle:{"font-size":"14px","margin-left":"6px","margin-top":"12px"},on:{"mouseover":function($event){return _vm.showDetails(item.id)},"mouseleave":function($event){return _vm.hideDetails(item.id)}}},[_c('i',{staticClass:"fa fa-info-circle text-info pointer info-icon ml-1"}),_vm._v(" "),(_vm.visibleDetails[item.id])?_c('div',{staticClass:"detail-tooltip-box"},[_c('div',{staticClass:"details-title text-center"},[_vm._v("\n                        Feedback Comment\n                      ")]),_vm._v(" "),_c('div',{staticClass:"detail-text text-start"},[_vm._v("\n                        "+_vm._s(item.feedback.comment)+"\n                      ")])]):_vm._e()]):_vm._e()]:(item.email === _vm.user.email)?_c('span',{staticClass:"add-feedback",on:{"click":function($event){$event.stopPropagation();return _vm.openFeedbackModal(item)}}},[_vm._v("\n                  Add Feedback\n                ")]):_c('span',[_vm._v("N/A")])],2):_c('span',[_vm._v("N/A")])]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('button',{staticClass:"btn",class:_vm.getStatusClass(item.status),staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.toggleStatus(item)}}},[_vm._v("\n                "+_vm._s(item.status)+"\n                ")])]}}])}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.dialog,"title":"Create Complaint","submit-button-text":"Add"},on:{"update:modelValue":function($event){_vm.dialog = $event},"submit":_vm.addComplain}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('label',{attrs:{"for":"assignee"}},[_vm._v("Assignee")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"assignee","value":_vm.selectedAssigneeName,"options":_vm.assigneeOptions,"placeholder":"Select an assignee"},on:{"change":_vm.handleAssigneeChange}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text","id":"title","placeholder":"Title here...","maxlength":"50","required":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"priority"}},[_vm._v("Priority")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"priority","value":_vm.priority,"options":_vm.priorityOptions,"placeholder":"Select a priority"},on:{"change":_vm.handlePriorityChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"issueType"}},[_vm._v("Issue Type")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"issueType","value":_vm.issueType,"options":_vm.issueTypeOptions,"placeholder":"Select an issue type"},on:{"change":_vm.handleIssueTypeChange}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control textarea",attrs:{"id":"description","placeholder":"Description here...","rows":"2","required":""},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.feedbackDialog,"title":"Add Feedback","submit-button-text":"Submit","loading":_vm.isSubmitting},on:{"update:modelValue":function($event){_vm.feedbackDialog = $event},"submit":_vm.submitFeedback}},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("\n                  Rating "),_c('span',{staticStyle:{"color":"red","font-size":"15px","margin-left":"-5px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"rating-stars"},_vm._l((5),function(n){return _c('span',{key:n,staticClass:"star",class:{ active: n <= _vm.feedbackRating },on:{"click":function($event){_vm.feedbackRating = n}}},[_vm._v("★")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Comment")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.feedbackComment),expression:"feedbackComment"}],staticClass:"form-control",attrs:{"rows":"3","maxlength":"400","placeholder":"Your feedback..."},domProps:{"value":(_vm.feedbackComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.feedbackComment=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"text-end text-muted small mt-1"},[_vm._v("\n                  "+_vm._s(_vm.feedbackComment.length)+"/400\n                ")])])])],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "565z":
/***/ (function(module, exports) {

module.exports = {"countries":["Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Korea, North","Korea, South","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Macedonia","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"]}

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5PIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monthly-stats-container"},[(_vm.isCurrentMonth)?_c('div',{staticClass:"filter-container mb-3"},[_c('div',{staticClass:"custom-btn-toggle"},[_c('button',{class:{ 'active': _vm.filter === 'tillToday' },on:{"click":function($event){_vm.filter = 'tillToday'}}},[_c('v-icon',[_vm._v("mdi-calendar")]),_vm._v("Till Today\n            ")],1),_vm._v(" "),_c('button',{class:{ 'active': _vm.filter === 'fullMonth' },on:{"click":function($event){_vm.filter = 'fullMonth'}}},[_c('v-icon',[_vm._v("mdi-calendar")]),_vm._v("Full Month\n            ")],1)])]):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"gap-4",attrs:{"row":"","wrap":""}},_vm._l((_vm.stats),function(stat,index){return _c('v-flex',{key:index,staticClass:"status-box-container gap-4"},[_c('v-card',{staticClass:"stat-card"},[_c('v-card-text',[_c('div',{staticClass:"text-center"},[_c('v-icon',{attrs:{"color":stat.iconColor,"size":"25"}},[_vm._v(_vm._s(stat.icon))]),_vm._v(" "),_c('div',{class:['stat-value mt-1', stat.valueClass]},[_vm._v(_vm._s(stat.value))]),_vm._v(" "),(stat.breakdown)?_c('div',{staticStyle:{"font-size":"11px","color":"#555"}},[_vm._v(_vm._s(stat.breakdown))]):_c('div',{staticStyle:{"font-size":"11px","color":"#555"}},[_vm._v("--")]),_vm._v(" "),_c('div',{staticClass:"stat-title mt-1"},[_vm._v(_vm._s(stat.title))])],1)])],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5n5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "64t6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modelValue)?_c('div',{class:_vm.modalOverlayClass,on:{"click":function($event){_vm.closeOnOverlayClick && _vm.$emit('update:modelValue', false)}}},[_c('div',{staticClass:"reusable-modal-parent"},[_c('div',{class:_vm.firstLoggedIn ? 'reusable-modal'  : 'reusable-modal2',style:({ maxWidth: _vm.xlarge? '700px' : _vm.isLarge ? '550px' : '450px' }),on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"reusable-modal-header"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(!_vm.hideCancelButton)?_c('button',{staticClass:"close-button",on:{"click":function($event){return _vm.$emit('update:modelValue', false)}}},[_vm._v(" × ")]):_c('div')],2),_vm._v(" "),_c('div',{class:_vm.performance ? 'reusable-modal-content-performance' : 'reusable-modal-content',style:(_vm.scrollable ? { maxHeight: _vm.maxHeight, overflowY: 'auto' } : {})},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"reusable-modal-footer"},[_vm._t("footer",[(!_vm.hideCancelButton)?_c('button',{staticClass:"secondary-button",on:{"click":function($event){return _vm.$emit('update:modelValue', false)}}},[_vm._v(_vm._s(_vm.cancelButtonText))]):_vm._e(),_vm._v(" "),_vm._t("middle-footer"),_vm._v(" "),_c('button',{staticClass:"primary-button",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('submit')}}},[(_vm.loading)?_c('span',[_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle"},attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v("\n              "+_vm._s(_vm.submitButtonText)+"\n            ")])])])],2)])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "65+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("fyNS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2d76d9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4KxV");
function injectStyle (ssrContext) {
  __webpack_require__("jEyp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a2d76d9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2d76d9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "65a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0HNz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28cbaddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Lnhs");
function injectStyle (ssrContext) {
  __webpack_require__("oV+4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28cbaddc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28cbaddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Wx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isResignedUser)?_c('div',{staticClass:"resigned-banner",staticStyle:{"background-color":"#ff4d4d","color":"white","padding":"5px","text-align":"center"}},[_vm._v("\n    You are currently serving your notice period. Please ensure strict\n    adherence to company policies.\n    "),_c('router-link',{staticStyle:{"color":"white","text-decoration":"underline"},attrs:{"to":"/policies"}},[_vm._v("\n      Click here to review the policies.\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.$root.isImpersonating && _vm.$root.impersonatedUser)?_c('div',{staticClass:"resigned-banner",staticStyle:{"background-color":"#f59e0b","color":"#ffffff","padding":"5px","display":"flex","justify-content":"space-between","align-items":"center","padding-right":"19px","padding-left":"15px"}},[_c('span',[_vm._v("You are logged in as "+_vm._s(_vm.$root.impersonatedUser.email)+".")]),_vm._v(" "),(_vm.$root.isImpersonating)?_c('p',{staticClass:"large-screen-text",staticStyle:{"text-transform":"uppercase","cursor":"pointer","font-size":"smaller","display":"none","margin-bottom":"0px"},on:{"click":_vm.logoutAsEmployee}},[_vm._v("Log out as Employee")]):_vm._e(),_vm._v(" "),(_vm.$root.isImpersonating)?_c('i',{staticClass:"fa fa-sign-out-alt mobile-icons",staticStyle:{"font-size":"18px","display":"none","cursor":"pointer"},attrs:{"color":"gray"},on:{"click":_vm.logoutAsEmployee}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-toggleable-md bg-white"},[_c('div',{ref:"menuWrapper",staticClass:"container"},[_c('span',{staticClass:"mobile-icons",staticStyle:{"position":"absolute","right":"-5px","top":"1.5px","z-index":"1000","display":"none","align-items":"center","gap":"10px"}},[(_vm.currentUserId)?_c('NotificationBell',{attrs:{"userId":_vm.currentUserId}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"notif-bell",class:{ 'notif-bell--active': _vm.isPanelOpen && !_vm.isMobile, 'notif-bell--no-hover': _vm.isMobile },attrs:{"aria-label":"Notifications"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-sign-out-alt",staticStyle:{"font-size":"18px"},attrs:{"color":"gray"}})])],1),_vm._v(" "),_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"navbar-toggler",class:{ toggled: _vm.$sidebar.showSidebar },attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"navbar-toggler-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar bar3"})])]),_vm._v(" "),(_vm.$route)?_c('div',{staticClass:"navbar-brand"},[_vm._v(_vm._s(_vm.routeName))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse justify-content-end",attrs:{"id":"navigation"}},[_c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item",staticStyle:{"display":"flex","justify-content":"end"}},[(_vm.currentUserId)?_c('NotificationBell',{attrs:{"userId":_vm.currentUserId}}):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item",staticStyle:{"display":"flex","justify-content":"end"}},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:function() { return false; }"},on:{"click":_vm.logout}},[_c('p',{},[_vm._v("Log out")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Y0e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6h6A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportedBugs_vue__ = __webpack_require__("QTts");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68579fa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportedBugs_vue__ = __webpack_require__("l5qH");
function injectStyle (ssrContext) {
  __webpack_require__("WIzc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68579fa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportedBugs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68579fa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportedBugs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6nww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UIComponents_Buttons_ResetIconButton_vue__ = __webpack_require__("0IWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__ = __webpack_require__("gY6d");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LeavesCalculation",
    components: {
        ResetIconButton: __WEBPACK_IMPORTED_MODULE_5__UIComponents_Buttons_ResetIconButton_vue__["a" /* default */]
    },
    props: {
        isAdmin: {
            type: Boolean,
            default: false
        },
        employee: {
            type: Object,
            required: true
        },
        initialValues: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            remainingLeaves: 0,
            carryForwardDays: 0,
            updatedLeaveQuota: 0,
            perDaySalary: 0,
            leavesEncashmentDays: 0,
            annualLeavesEncashmentDays: 0,
            leavesEncashmentAmount: 0,
            month: this.employee.month,

            leavesEncashmentManuallyUpdated: false,
            remainingLeavesManuallyUpdated: false,
            carryForwardManuallyUpdated: false,
            updatedLeaveQuotaManuallyUpdated: false,
            isCarryForwardInfoVisible: false,
            isEncashmentInfoVisible: false,
            constants: this.$store.state.auth.constants || {}
        };
    },

    computed: {
        showLeavesCalculation: function showLeavesCalculation() {
            var month = this.employee.month;
            var status = this.employee.employeeStatus;
            var isCorrectMonth = month === 'December' || month === 'June';
            var isActiveEmployee = status !== 'Resigned' && status !== 'Probation';
            return isCorrectMonth && isActiveEmployee;
        },
        selectedEmployee: function selectedEmployee() {
            return this.$store.state.payroll.selectedEmployeePayroll || {};
        },
        isDisabled: function isDisabled() {
            return this.$store.state.auth.user.role !== "admin";
        },
        carryForwardRulesList: function carryForwardRulesList() {
            var grouped = {};

            // Group keys by their value (e.g., { "1": [2, 3], "2": [4, 5] })
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["k" /* leavesCarryForwardDecRule */])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                    var key = _ref2[0];
                    var value = _ref2[1];

                    if (!grouped[value]) grouped[value] = [];
                    grouped[value].push(key);
                }

                // Create human-readable lines
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(grouped).map(function (_ref3) {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                    carry = _ref4[0],
                    days = _ref4[1];

                var range = days.join(' or ');
                return range + " leaves remaining \u2192 " + carry + " day" + (carry > 1 ? 's' : '') + " carried forward";
            });
        },
        encashmentRulesList: function encashmentRulesList() {
            var grouped = {};

            // Group keys by their encashment value
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["l" /* leaveEncashmentDecRule */])), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ref5 = _step2.value;

                    var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

                    var key = _ref6[0];
                    var value = _ref6[1];

                    if (!grouped[value]) grouped[value] = [];
                    grouped[value].push(key);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(grouped).map(function (_ref7) {
                var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
                    encash = _ref8[0],
                    days = _ref8[1];

                var range = days.join(' or ');
                return range + " leaves remaining \u2192 " + encash + " day" + (encash > 1 ? 's' : '') + " encashed";
            });
        }
    },
    methods: {
        onLeavesEncashmentInput: function onLeavesEncashmentInput() {
            this.leavesEncashmentManuallyUpdated = true;
        },
        updateLeavesData: function updateLeavesData() {
            if (!this.selectedEmployee) return;
            var leavesQuota = this.selectedEmployee.leavesQuota || {};

            if (!this.remainingLeavesManuallyUpdated) {
                this.remainingLeaves = Number(this.selectedEmployee.leavesAllowed) - Number(this.selectedEmployee.DBLeavesTaken) - Number(this.selectedEmployee.leavesDeductionDays) || 0;
            }

            this.perDaySalary = this.selectedEmployee.perDaySalary || 0;

            if (!this.carryForwardManuallyUpdated) {
                this.carryForwardDays = leavesQuota.carryForwardDays || "";
            }

            if (!this.updatedLeaveQuotaManuallyUpdated) {
                this.updatedLeaveQuota = leavesQuota.updatedLeaveQuota || "";
            }

            if (this.month === "June") {
                if (!this.updatedLeaveQuotaManuallyUpdated) {
                    this.updatedLeaveQuota = Number(this.calculateJuneLeaveQuota() || leavesQuota.updatedLeaveQuota) || "";
                }
                if (!this.carryForwardManuallyUpdated) {
                    this.carryForwardDays = this.calculateJuneCarryForward() || leavesQuota.carryForwardDays || "";
                }
            } else if (this.month === "December") {
                var calculatedEncashment = this.calculateEncashment() || leavesQuota.leavesEncashmentDays || "";

                if (!this.carryForwardManuallyUpdated) {
                    this.carryForwardDays = this.calculateDecCarryForward() || leavesQuota.carryForwardDays || "";
                }

                if (!this.leavesEncashmentManuallyUpdated) {
                    var _calculatedEncashment = this.calculateEncashment();
                    this.leavesEncashmentDays = _calculatedEncashment;
                    this.annualLeavesEncashmentDays = _calculatedEncashment;
                }

                if (!this.updatedLeaveQuotaManuallyUpdated) {
                    this.updatedLeaveQuota = Number(this.calculateUpdatedLeaveQuota() || leavesQuota.updatedLeaveQuota) || "";
                }
            }
        },
        forceResetField: function forceResetField(field) {
            if (field === "leavesEncashmentDays") {
                this.leavesEncashmentDays = this.calculateEncashment();
                this.leavesEncashmentManuallyUpdated = false;
            } else if (field === "carryForwardDays") {
                this.carryForwardDays = this.month === "December" ? this.calculateDecCarryForward() : this.calculateJuneCarryForward();
                this.carryForwardManuallyUpdated = false;
            } else if (field === "updatedLeaveQuota") {
                this.updatedLeaveQuota = this.calculateUpdatedLeaveQuota();
                this.updatedLeaveQuotaManuallyUpdated = false;
            } else if (field === "remainingLeaves") {
                this.remainingLeaves = this.initialValues.remainingLeaves || 0;
                this.remainingLeavesManuallyUpdated = false;
            }
        },
        resetCarryForward: function resetCarryForward() {
            if (this.carryForwardDays === "" || this.carryForwardDays === null) {
                this.carryForwardDays = this.calculateDecCarryForward();
                this.carryForwardManuallyUpdated = false;
            }
        },
        resetLeaveQuota: function resetLeaveQuota() {
            if (this.updatedLeaveQuota === "" || this.updatedLeaveQuota === null) {
                this.updatedLeaveQuota = this.calculateUpdatedLeaveQuota();
                this.updatedLeaveQuotaManuallyUpdated = false;
            }
        },
        calculateJuneLeaveQuota: function calculateJuneLeaveQuota() {
            var emp = this.selectedEmployee;
            var leavesAllowed = Number(emp.leavesAllowed || 0);
            var leavesTaken = Number(emp.DBLeavesTaken || 0);
            var leavesAvailable = Number(emp.leavesAvailable || 0);
            var remainingLeaves = leavesAllowed - leavesTaken;
            var newAllowedLeaves = leavesAvailable - leavesAllowed + remainingLeaves;
            var updatedLeaves = newAllowedLeaves;
            return updatedLeaves;
        },
        calculateEncashment: function calculateEncashment() {
            if (this.month !== "December") return 0;

            var remaining = Math.min(Math.floor(this.remainingLeaves), 5);
            var encashmentValue = __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["l" /* leaveEncashmentDecRule */][remaining] || "";

            if (!this.leavesEncashmentManuallyUpdated) {
                this.leavesEncashmentDays = encashmentValue;
                this.annualLeavesEncashmentDays = encashmentValue;
            }

            return encashmentValue;
        },
        calculateDecCarryForward: function calculateDecCarryForward() {
            if (this.month !== "December") return 0;

            var remaining = Math.min(Math.floor(this.remainingLeaves), 5);
            return __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["k" /* leavesCarryForwardDecRule */][remaining] || "";
        },
        calculateJuneCarryForward: function calculateJuneCarryForward() {
            if (this.month !== "June") return 0;
            var emp = this.selectedEmployee;
            var remaininingAllowedLeaves = Number(emp.leavesAllowed || 0) - Number(emp.DBLeavesTaken || 0);
            return remaininingAllowedLeaves;
        },
        calculateUpdatedLeaveQuota: function calculateUpdatedLeaveQuota() {
            if (this.month === "December") {
                if (this.remainingLeavesManuallyUpdated) {
                    if (Number(this.remainingLeaves) <= 5) {
                        var baseQuota = this.remainingLeaves;
                        var carryForwardLeaves = this.calculateDecCarryForward();
                        return Number(baseQuota) + Number(carryForwardLeaves);
                    } else {
                        // Keep the last known quota, don't change
                        return this.updatedLeaveQuota;
                    }
                } else {
                    return Number(this.constants.leavesAvailable) + this.carryForwardDays;
                }
            }

            if (this.month === "June") {
                if (this.remainingLeavesManuallyUpdated) {
                    var _baseQuota = this.remainingLeaves;
                    var _carryForwardLeaves = this.calculateJuneCarryForward();
                    return Number(_baseQuota) + Number(_carryForwardLeaves);
                }
                console.log("refactor", this.selectedEmployee.leavesAvailable, this.remainingLeaves);
                return Number(this.remainingLeaves) + Number(this.selectedEmployee.leavesAvailable) / 2;
            }

            return this.updatedLeaveQuota;
        },
        syncToEmployee: function syncToEmployee() {
            var leavesData = this.getUpdatedLeavesData();

            var updatedLeavesQuota = {
                remainingLeaves: Number(this.remainingLeaves) || 0,
                carryForwardDays: Number(this.carryForwardDays) || 0,
                updatedLeaveQuota: Number(this.updatedLeaveQuota) || 0,
                leavesEncashmentDays: Number(this.leavesEncashmentDays) || 0
            };

            var updated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.employee, {
                annualLeavesEncashmentDays: Number(this.leavesEncashmentDays),
                leavesQuota: updatedLeavesQuota // Keeping the leavesQuota data inside the object
            });

            for (var key in leavesData) {
                if (leavesData.hasOwnProperty(key)) {
                    updated[key] = leavesData[key];
                }
            }

            this.$emit("update-leaves", updated); // emit updated employee data
        },
        getUpdatedLeavesData: function getUpdatedLeavesData() {
            var leavesQuota = this.selectedEmployee.leavesQuota;
            var payrollMonth = this.month;

            var data = {
                leavesEncashmentDays: this.leavesEncashmentDays,
                updatedLeaveQuota: this.updatedLeaveQuota,
                remainingLeaves: this.remainingLeaves,
                carryForwardDays: this.carryForwardDays,
                annualLeavesEncashmentDays: this.leavesEncashmentDays
            };

            if (payrollMonth === "June") {
                data.midYearLeaves = {
                    leavesAvailable: this.updatedLeaveQuota
                };
            } else if (payrollMonth === "December") {
                data.annualLeaves = {
                    leavesAvailable: this.updatedLeaveQuota / 2,
                    leavesAllowed: this.updatedLeaveQuota
                };
            }

            return data;
        }
    },
    watch: {
        selectedEmployee: {
            handler: function handler() {
                this.updateLeavesData();
            },

            deep: true,
            immediate: true
        },
        employee: {
            immediate: true,
            deep: true,
            handler: function handler(newVal) {
                this.updateLeavesData();
            }
        },

        remainingLeaves: function remainingLeaves(val) {
            this.remainingLeaves = val;

            if (!this.leavesEncashmentManuallyUpdated && this.month === "December") {
                this.leavesEncashmentDays = this.calculateEncashment();
                this.annualLeavesEncashmentDays = this.leavesEncashmentDays;
            }

            if (!this.carryForwardManuallyUpdated) {
                this.carryForwardDays = this.month === "December" ? this.calculateDecCarryForward() : this.calculateJuneCarryForward();
            }

            if (!this.updatedLeaveQuotaManuallyUpdated) {
                this.updatedLeaveQuota = this.calculateUpdatedLeaveQuota();
            }

            this.syncToEmployee();
        },
        carryForwardDays: function carryForwardDays(val) {
            this.syncToEmployee();
        },
        updatedLeaveQuota: function updatedLeaveQuota(val) {
            this.syncToEmployee();
        },
        leavesEncashmentDays: function leavesEncashmentDays(val) {
            this.syncToEmployee();
        }
    },
    mounted: function mounted() {
        this.syncToEmployee();
    }
});

/***/ }),

/***/ "6s0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationBell_vue__ = __webpack_require__("trEX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a07c31a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationBell_vue__ = __webpack_require__("cjc0");
function injectStyle (ssrContext) {
  __webpack_require__("8M3m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a07c31a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationBell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a07c31a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationBell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "72yC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_assets_config_constants_js__ = __webpack_require__("gY6d");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Policies",
  computed: {
    policyUrl: function policyUrl() {
      var constants = this.$store.state.auth.constants || {};
      var url = (constants.policyUrl || __WEBPACK_IMPORTED_MODULE_0_src_assets_config_constants_js__["i" /* DEFAULT_POLICY_URL */]).trim();
      // Google Docs edit/view links can't be embedded; switch them to the preview view
      return url.replace(/(docs\.google\.com\/document\/d\/[^/]+)\/(edit|view)[^#]*(#.*)?$/, "$1/preview");
    }
  }
});

/***/ }),

/***/ "7jko":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7pLE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Dap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"title"},[_vm._v("All Employees")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"},[(this.$store.state.auth.user.role === 'admin')?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.openModal}},[_vm._v("Add Employee")]):_vm._e(),_vm._v(" "),_c('button',{staticStyle:{"display":"none"},attrs:{"id":"modal-btn","data-toggle":"modal","data-target":"#myModal"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive table-full-width"},[_c('n-table',{staticClass:"table table-hover table-striped",attrs:{"columns":_vm.table1.columns,"data":this.$store.state.auth.allUsers}})],1)],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"myModal"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":_vm.addEmployee}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Enter employee name"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","placeholder":"Enter new password"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":""},domProps:{"checked":_vm.isAdmin},on:{"change":_vm.handleRadioChange}}),_vm._v(" "),_c('span',[_vm._v("Admin")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary btn-block"},[(_vm.isAddingEmployee)?_c('img',{staticClass:"next-arrow",attrs:{"src":"static/img/loader.gif"}}):_c('span',[_vm._v("Add")])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Add Employee")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8I5V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8M3m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Q0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_cloudinary__ = __webpack_require__("SJFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_assets_config_constants_js__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_adminLogs__ = __webpack_require__("nvCY");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var FIELDS = ["companyAddress", "companyPhone", "companyEmail", "companyLogoUrl", "policyUrl"];
var MAX_LOGO_BYTES = 1024 * 1024;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CompanyDetails",
  data: function data() {
    return {
      form: this.loadForm(),
      pendingLogo: "", // data URL preview of a newly picked logo
      pendingLogoFile: null, // uploaded on save
      saving: false
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user || {};
    },
    isAdmin: function isAdmin() {
      return this.currentUser.role === "admin";
    },
    logoPreview: function logoPreview() {
      return this.pendingLogo || this.form.companyLogoUrl;
    },
    isDirty: function isDirty() {
      var _this = this;

      var saved = this.loadForm();
      return !!this.pendingLogo || FIELDS.some(function (key) {
        return saved[key] !== _this.form[key];
      });
    }
  },
  methods: {
    loadForm: function loadForm() {
      var constants = this.$store.state.auth.constants || {};
      var form = {};
      FIELDS.forEach(function (key) {
        form[key] = constants[key] || "";
      });
      form.policyUrl = form.policyUrl || __WEBPACK_IMPORTED_MODULE_8_src_assets_config_constants_js__["i" /* DEFAULT_POLICY_URL */];
      return form;
    },
    isValidUrl: function isValidUrl(url) {
      return (/^https?:\/\/\S+$/i.test(url || "")
      );
    },
    openFilePicker: function openFilePicker() {
      if (this.isAdmin) this.$refs.logoInput.click();
    },
    onLogoSelected: function onLogoSelected(event) {
      var _this2 = this;

      var file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;
      if (!file.type.startsWith("image/")) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()("Invalid file", "Please choose an image file.", "error");
        return;
      }
      if (file.size > MAX_LOGO_BYTES) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()("File too large", "Logo must be 1 MB or smaller.", "error");
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        _this2.pendingLogo = reader.result;
        _this2.pendingLogoFile = file;
      };
      reader.readAsDataURL(file);
    },
    removeLogo: function removeLogo() {
      this.pendingLogo = "";
      this.pendingLogoFile = null;
      this.form.companyLogoUrl = "";
    },
    reset: function reset() {
      this.form = this.loadForm();
      this.pendingLogo = "";
      this.pendingLogoFile = null;
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _form, companyEmail, policyUrl, constants, oldValues, updated, changes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _form = _this3.form, companyEmail = _form.companyEmail, policyUrl = _form.policyUrl;

                if (!(companyEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(companyEmail))) {
                  _context.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()("Invalid email", "Please enter a valid company email.", "error");
                return _context.abrupt("return");

              case 4:
                if (!(policyUrl && !_this3.isValidUrl(policyUrl))) {
                  _context.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()("Invalid URL", "Company Policy URL must start with http:// or https://", "error");
                return _context.abrupt("return");

              case 7:
                constants = _this3.$store.state.auth.constants || {};
                oldValues = {};

                FIELDS.forEach(function (key) {
                  oldValues[key] = constants[key] || "";
                });

                _this3.saving = true;
                _this3.$store.commit("loadingStarts");
                _context.prev = 12;
                updated = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.form);

                if (!_this3.pendingLogoFile) {
                  _context.next = 18;
                  break;
                }

                _context.next = 17;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_cloudinary__["a" /* uploadToCloudinary */])(_this3.pendingLogoFile, "company_logo", "profile_images");

              case 17:
                updated.companyLogoUrl = _context.sent;

              case 18:
                _context.next = 20;
                return __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].updateDatabase("constants", updated);

              case 20:
                _this3.$store.commit("setConstants", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, constants, updated));
                _this3.form = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, updated);
                _this3.pendingLogo = "";
                _this3.pendingLogoFile = null;
                __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()("Success!", "Company profile saved!", "success");

                changes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_adminLogs__["a" /* getUpdatedFields */])(oldValues, updated)).map(function (_ref) {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_adminLogs__["b" /* formatValue */])(value.new);
                }).join("\n");
                _context.next = 28;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this3.currentUser,
                  title: _this3.currentUser.username + " updated company profile",
                  description: _this3.currentUser.email + " updated company profile.",
                  changes: changes,
                  type: "settings"
                }));

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](12);

                console.error("Failed to save company profile:", _context.t0);
                __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()("Error!", "Failed to save company profile.", "error");

              case 34:
                _context.prev = 34;

                _this3.saving = false;
                _this3.$store.commit("loadingEnds");
                return _context.finish(34);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[12, 30, 34, 38]]);
      }))();
    }
  }
});

/***/ }),

/***/ "8f3O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8qAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminLeaveManagement_vue__ = __webpack_require__("1AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmployeeLeaveManagement_vue__ = __webpack_require__("VC1x");
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AdminLeaveManagement: __WEBPACK_IMPORTED_MODULE_0__AdminLeaveManagement_vue__["a" /* default */],
    EmployeeLeaveManagement: __WEBPACK_IMPORTED_MODULE_1__EmployeeLeaveManagement_vue__["a" /* default */]
  },
  data: function data() {
    var user = this.$store.state.auth.user;
    return {
      isAdmin: user && user.role === "admin"
    };
  }
});

/***/ }),

/***/ "8uFK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GradeDropdown',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    designation: {
      type: String,
      required: false,
      default: ''
    },
    designationGrades: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'grade-dropdown'
    },
    placeholder: {
      type: String,
      default: 'Select Grade'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 195
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'This field is required'
    },
    debug: {
      type: Boolean,
      default: true // Enable debug by default
    }
  },
  emits: ['change'],
  data: function data() {
    return {
      isOpen: false,
      selectedValue: this.value,
      selectedLabel: '',
      availableGrades: [],
      searchQuery: ''
    };
  },

  computed: {
    filteredGrades: function filteredGrades() {
      if (!this.searchQuery) return this.availableGrades;
      var query = this.searchQuery.toLowerCase().trim();
      return this.availableGrades.filter(function (option) {
        return option.label.toLowerCase().includes(query);
      });
    }
  },
  created: function created() {
    // Log in created hook
    console.log('[GradeDropdown] Created with props:', {
      designation: this.designation,
      value: this.value,
      designationGrades: this.designationGrades
    });
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('[GradeDropdown] Value changed:', newVal);
        this.selectedValue = newVal;
        this.updateSelectedLabel();
      }
    },
    designation: {
      immediate: true,
      handler: function handler(newDesignation) {
        console.log('[GradeDropdown] Designation changed:', newDesignation);
        this.updateAvailableGrades(newDesignation);
        this.updateSelectedLabel();
      }
    },
    designationGrades: {
      immediate: true,
      deep: true,
      handler: function handler(newGrades) {
        console.log('[GradeDropdown] DesignationGrades changed:', newGrades);
        this.updateAvailableGrades(this.designation);
        this.updateSelectedLabel();
      }
    }
  },

  methods: {
    updateAvailableGrades: function updateAvailableGrades(designation) {
      console.log('[GradeDropdown] updateAvailableGrades called with:', designation);

      // If designation is undefined or empty, show no grades
      if (!designation) {
        console.log('[GradeDropdown] No designation provided, setting empty grades');
        this.availableGrades = [];
        return;
      }

      // Check the structure of designationGrades
      console.log('[GradeDropdown] DesignationGrades structure:', {
        hasDesignationGradesProperty: this.designationGrades && this.designationGrades.designationGrades ? 'yes' : 'no',
        keys: this.designationGrades ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.designationGrades) : 'none'
      });

      // Check if designationGrades has a nested designationGrades property
      if (this.designationGrades && this.designationGrades.designationGrades) {
        console.log('[GradeDropdown] Using nested designationGrades property');
        this.availableGrades = this.designationGrades.designationGrades[designation] || [];
      } else if (this.designationGrades) {
        // Direct access to the object
        console.log('[GradeDropdown] Using direct designationGrades object');
        this.availableGrades = this.designationGrades[designation] || [];
      } else {
        console.log('[GradeDropdown] No designationGrades object found');
        this.availableGrades = [];
      }

      console.log('[GradeDropdown] Available Grades set to:', this.availableGrades);
    },
    updateSelectedLabel: function updateSelectedLabel() {
      var _this = this;

      console.log('[GradeDropdown] updateSelectedLabel called with selectedValue:', this.selectedValue);

      if (!this.selectedValue) {
        console.log('[GradeDropdown] No selectedValue, clearing selectedLabel');
        this.selectedLabel = '';
        return;
      }

      var grade = this.availableGrades.find(function (g) {
        return g.value.toString() === _this.selectedValue.toString();
      });
      console.log('[GradeDropdown] Found grade for selectedValue:', grade);

      this.selectedLabel = grade ? grade.label : '';
      console.log('[GradeDropdown] Set selectedLabel to:', this.selectedLabel);
    },
    toggleDropdown: function toggleDropdown() {
      var _this2 = this;

      if (!this.disabled) {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
          this.searchQuery = '';
          this.$nextTick(function () {
            if (_this2.$refs.searchInput) _this2.$refs.searchInput.focus();
          });
        }
      }
    },
    selectOption: function selectOption(option) {
      console.log('[GradeDropdown] Option selected:', option);
      this.selectedValue = option.value.toString();
      this.selectedLabel = option.label;
      this.$emit('change', option.value.toString());
      this.isOpen = false;
      this.searchQuery = '';
    },
    handleClickOutside: function handleClickOutside(event) {
      var dropdownEl = this.$refs.dropdown;
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted: function mounted() {
    console.log('[GradeDropdown] Mounted');
    document.addEventListener('click', this.handleClickOutside);
    this.updateAvailableGrades(this.designation);
    this.updateSelectedLabel();
  },
  beforeDestroy: function beforeDestroy() {
    console.log('[GradeDropdown] Before destroy');
    document.removeEventListener('click', this.handleClickOutside);
  }
});

/***/ }),

/***/ "9279":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__ = __webpack_require__("c+jd");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45f4f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__ = __webpack_require__("ZuEi");
function injectStyle (ssrContext) {
  __webpack_require__("qma3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45f4f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Gbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"title"},[_vm._v("All Employees")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"display":"flex","justify-content":"end"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search by name or email"},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})])])]),_vm._v(" "),_c('div',[_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.filteredUsers},scopedSlots:_vm._u([{key:"avatar",fn:function(ref){
var item = ref.item;
return [_c('img',{staticStyle:{"width":"35px","height":"35px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":item.profile_picture || 'static/img/default-dp.png',"alt":"avatar"}})]}},{key:"username",fn:function(ref){
var item = ref.item;
return [_c('span',{attrs:{"title":item.username}},[_vm._v(_vm._s(item.username || '-'))])]}},{key:"email",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.email}},[_vm._v(_vm._s(item.email || '-'))])]}},{key:"designation",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.designation}},[_vm._v(_vm._s(item.designation || '-'))])]}},{key:"grade",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.grade}},[_vm._v(_vm._s(item.grade || '-'))])]}}])})],1)],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A6/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:" main-container d-flex flex-column"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-login"},[_c('div',{staticClass:"form-container"},[(!_vm.showForgotPassword)?_c('div',[_c('span',{staticClass:"full-width d-inline-block text-center",staticStyle:{"font-size":"20px","font-weight":"600","margin-bottom":"20px"}},[_vm._v("Login with your account")]),_vm._v(" "),(_vm.selectedCompany && !_vm.emailError)?_c('div',{staticClass:"label-box-container",on:{"click":_vm.changeCompany}},[_c('span',{staticClass:"company-name"},[_vm._v(_vm._s(_vm.selectedCompany.companyName))])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"novalidate":"true"},on:{"submit":function($event){$event.preventDefault();return _vm.handleNextClick($event)}}},[_c('div',{staticClass:"form-group margin-base-y",staticStyle:{"position":"relative"}},[_c('label',{staticClass:"control-label",attrs:{"for":"email"}},[_vm._v("Enter your email:")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control input-field",attrs:{"type":"email","id":"email","placeholder":"Enter your email","disabled":_vm.showPasswordField},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.handleEmailChange],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleNextClick($event)}}}),_vm._v(" "),(_vm.emailValidating && _vm.email.length > 0)?_c('div',{staticClass:"input-icon"},[_vm._m(1)]):(_vm.emailValidated)?_c('div',{staticClass:"input-icon"},[_c('i',{staticClass:"fa fa-check-circle mail-checked"})]):_vm._e()]),_vm._v(" "),(_vm.emailError)?_c('div',{staticClass:"text-danger",staticStyle:{"position":"absolute"}},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()]),_vm._v(" "),(!_vm.showPasswordField)?_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"next-button",attrs:{"type":"submit","disabled":_vm.nextButtonDisabled}},[_c('span',[_vm._v("Next")])])]):_vm._e()]),_vm._v(" "),(_vm.showPasswordField)?_c('form',{attrs:{"novalidate":"true"},on:{"submit":function($event){$event.preventDefault();return _vm.handleLogin($event)}}},[_c('div',{staticClass:"form-group margin-base-y",staticStyle:{"position":"relative"}},[_c('label',{staticClass:"control-label",attrs:{"for":"password"}},[_vm._v("Enter your password:")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-field",attrs:{"id":"password","placeholder":"Enter your password","disabled":!_vm.emailValidated,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password)?_vm._i(_vm.password,null)>-1:(_vm.password)},on:{"input":_vm.handlePasswordChange,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleLogin($event)},"change":function($event){var $$a=_vm.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.password=$$c}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-field",attrs:{"id":"password","placeholder":"Enter your password","disabled":!_vm.emailValidated,"type":"radio"},domProps:{"checked":_vm._q(_vm.password,null)},on:{"input":_vm.handlePasswordChange,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleLogin($event)},"change":function($event){_vm.password=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-field",attrs:{"id":"password","placeholder":"Enter your password","disabled":!_vm.emailValidated,"type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.handlePasswordChange],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleLogin($event)}}}),_vm._v(" "),(_vm.emailValidated)?_c('div',{staticClass:"input-icon password-toggle",on:{"click":function($event){_vm.showPassword = !_vm.showPassword}}},[_c('i',{class:_vm.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'})]):_vm._e()]),_vm._v(" "),(_vm.passwordError)?_c('div',{staticClass:"text-danger",staticStyle:{"position":"absolute"}},[_vm._v(_vm._s(_vm.passwordError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"forget-password"},[_c('span',{on:{"click":function($event){$event.preventDefault();_vm.showForgotPassword = true}}},[_vm._v("\n                  Forgot Password?\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"login-button",attrs:{"type":"submit","disabled":_vm.loginButtonDisabled}},[(_vm.loginLoading)?_c('img',{staticClass:"next-arrow",attrs:{"src":"static/img/loader.gif"}}):_c('span',[_vm._v("Login")])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showForgotPassword)?_c('ForgotPassword',{on:{"back-to-login":_vm.handleBackToLogin}}):_vm._e()],1)]),_vm._v(" "),_c('footer',{staticStyle:{"background-color":"#01271F","text-align":"right","padding":"18px 0","position":"fixed","bottom":"0","width":"100%"}},[_c('span',{staticStyle:{"color":"white","cursor":"pointer","font-size":"12px","padding-right":"80px","font-weight":"600"},on:{"click":function($event){_vm.isBugModalOpen = true}}},[_vm._v("\n        Report A Bug\n      ")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isCompanyModalOpen,"title":"Select your company","submitButtonText":"Confirm"},on:{"update:modelValue":function($event){_vm.isCompanyModalOpen = $event},"submit":_vm.confirmCompanySelection}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"company-select"}},[_vm._v("Select Company")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCompanyId),expression:"selectedCompanyId"}],staticClass:"form-control",staticStyle:{"height":"40px"},attrs:{"id":"company-select"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCompanyId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.companies),function(company){return _c('option',{key:company.id || company.companyName,domProps:{"value":company.id || company.companyName}},[_vm._v("\n            "+_vm._s(company.companyName)+"\n          ")])}),0)])]),_vm._v(" "),_c('BugReportModal',{attrs:{"fullOverlay":true,"isOpen":_vm.isBugModalOpen},on:{"update:isOpen":function($event){_vm.isBugModalOpen = $event}}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-toggleable-md bg-theme nopadding-y"},[_c('div',{staticClass:" nopadding-y"},[_c('a',{staticClass:"navbar-brand nopadding-y",attrs:{"href":"#"}},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":__webpack_require__("pyqL")}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border spinner-border-sm text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AAEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      required: true
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    searchable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select an option'
    },
    initialValue: {
      type: [String, Number, Object],
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dropdownOpen: false,
      searchQuery: '',
      selectedItem: null
    };
  },

  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      if (!this.searchQuery) return this.items;
      return this.items.filter(function (item) {
        return item[_this.labelKey].toLowerCase().includes(_this.searchQuery.toLowerCase());
      });
    },
    displayText: function displayText() {
      var _this2 = this;

      if (this.selectedItem) return this.selectedItem[this.labelKey];
      if (this.initialValue) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.initialValue) === 'object') {
          return this.initialValue[this.labelKey];
        }
        var foundItem = this.items.find(function (item) {
          return item[_this2.labelKey] === _this2.initialValue;
        });
        return foundItem ? foundItem[this.labelKey] : this.placeholder;
      }
      return this.placeholder;
    }
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown: function closeDropdown() {
      this.dropdownOpen = false;
    },
    selectItem: function selectItem(item) {
      this.selectedItem = item;
      this.$emit('select', item);
      this.closeDropdown();
    },
    clearSelection: function clearSelection() {
      this.selectedItem = null;
      this.searchQuery = '';
      this.$emit('select', null); // Notify parent that selection is cleared
      this.closeDropdown();
    }
  },
  watch: {
    initialValue: {
      immediate: true,
      handler: function handler(newVal) {
        var _this3 = this;

        if (newVal) {
          if ((typeof newVal === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(newVal)) === 'object') {
            this.selectedItem = newVal;
          } else {
            this.selectedItem = this.items.find(function (item) {
              return item[_this3.labelKey] === newVal;
            }) || null;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "AM9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("qvnn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c4a61d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("WtC7");
function injectStyle (ssrContext) {
  __webpack_require__("f50w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57c4a61d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c4a61d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ac3z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],staticClass:"dropdown",class:{open:_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_vm._t("title",[_c('i',{class:_vm.icon}),_vm._v(" "),_vm._m(0)])],2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"notification"},[_c('b',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ajc/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Al8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openFileInNewTab;
function openFileInNewTab(url) {
    if (url) window.open(url, "_blank");
}

/***/ }),

/***/ "Atj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-item"},[_c('div',{staticClass:"email-header",on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('div',{staticClass:"info"},[_c('h5',[_vm._v(_vm._s(_vm.template.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.template.description))])]),_vm._v(" "),(!_vm.isEditMode && _vm.isOpen)?_c('i',{staticClass:"fa fa-edit",staticStyle:{"margin-right":"8px"},on:{"click":function($event){$event.stopPropagation();return _vm.enableEdit($event)}}}):_vm._e(),_vm._v(" "),_c('span',{class:{ rotate: _vm.isOpen }},[_c('i',{staticClass:"fa fa-chevron-down",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"collapse"}},[(_vm.isOpen)?_c('div',{staticClass:"content"},[(_vm.isEditMode)?_c('AvailableVariables',{attrs:{"variables":_vm.template.variables},on:{"insert":_vm.insertVariable}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Subject")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localSubject),expression:"localSubject"}],ref:"subjectInput",attrs:{"type":"text","disabled":!_vm.isEditMode},domProps:{"value":(_vm.localSubject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localSubject=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Email Body")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localBody),expression:"localBody"}],ref:"bodyInput",attrs:{"rows":"14","disabled":!_vm.isEditMode},domProps:{"value":(_vm.localBody)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localBody=$event.target.value}}})]),_vm._v(" "),(_vm.isEditMode)?_c('div',{staticStyle:{"margin-block":"12px","padding":"12px","background-color":"#fefce8","border-radius":"8px","font-size":"12px","border":"1px solid #f9f4c7"}},[_c('p',{staticStyle:{"font-size":"11px","color":"#a57b4b","margin-bottom":"0px"}},[_c('strong',{staticStyle:{"font-weight":"bolder","color":"#9b7244"}},[_vm._v("Note:")]),_vm._v(" Click the variable buttons above to insert them at your cursor position. All variables will be automatically replaced with actual data when email is sent.\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.isEditMode)?[_c('button',{staticClass:"secondary-button",on:{"click":_vm.cancelEdit}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"primary-button",on:{"click":_vm.saveTemplate}},[_vm._v("Save Template")])]:_vm._e()],2)],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AxYa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubleLoader_vue__ = __webpack_require__("QV0N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f28cff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubleLoader_vue__ = __webpack_require__("rITC");
function injectStyle (ssrContext) {
  __webpack_require__("yhB7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23f28cff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubleLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f28cff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubleLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B2Q4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("+a+j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d49b013_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("gDoP");
function injectStyle (ssrContext) {
  __webpack_require__("CZJN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d49b013_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B7VG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('h5',{staticClass:"title"},[_vm._v("100 Awesome Nucleo Icons")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Handcrafted by our friends from "),_c('a',{attrs:{"href":"https://nucleoapp.com/?ref=creativetim"}},[_vm._v("NucleoApp")])])]),_vm._v(" "),_c('div',{staticClass:"card-block all-icons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_cloud-download-93"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_cloud-download-93")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_cloud-upload-94"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_cloud-upload-94")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_minimal-down"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_minimal-down")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_minimal-left"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_minimal-left")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_minimal-right"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_minimal-right")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_minimal-up"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_minimal-up")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_refresh-69"}),_vm._v(" "),_c('p',[_vm._v("arrows-1_refresh-69")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons arrows-1_share-66 "}),_vm._v(" "),_c('p',[_vm._v("arrows-1_share-66")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_badge"}),_vm._v(" "),_c('p',[_vm._v("business_badge")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_bank"}),_vm._v(" "),_c('p',[_vm._v("business_bank")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_briefcase-24"}),_vm._v(" "),_c('p',[_vm._v("business_briefcase-24")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_bulb-63"}),_vm._v(" "),_c('p',[_vm._v("business_bulb-63")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("business_chart-bar-32")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_chart-pie-36"}),_vm._v(" "),_c('p',[_vm._v("business_chart-pie-36")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_globe"}),_vm._v(" "),_c('p',[_vm._v("business_globe")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons business_money-coins"}),_vm._v(" "),_c('p',[_vm._v("business_money-coins")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons clothes_tie-bow"}),_vm._v(" "),_c('p',[_vm._v("clothes_tie-bow")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design_app"}),_vm._v(" "),_c('p',[_vm._v("design_app")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design_bullet-list-67"}),_vm._v(" "),_c('p',[_vm._v("design_bullet-list-67")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design_image"}),_vm._v(" "),_c('p',[_vm._v("design_image")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design_palette"}),_vm._v(" "),_c('p',[_vm._v("design_palette")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design_scissors"}),_vm._v(" "),_c('p',[_vm._v("design_scissors")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design_vector"}),_vm._v(" "),_c('p',[_vm._v("design_vector")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design-2_html5"}),_vm._v(" "),_c('p',[_vm._v("design-2_html5")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons design-2_ruler-pencil"}),_vm._v(" "),_c('p',[_vm._v("design-2_ruler-pencil")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons emoticons_satisfied"}),_vm._v(" "),_c('p',[_vm._v("emoticons_satisfied")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons files_box"}),_vm._v(" "),_c('p',[_vm._v("files_box")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons files_paper"}),_vm._v(" "),_c('p',[_vm._v("files_paper")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons files_single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("files_single-copy-04")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons health_ambulance"}),_vm._v(" "),_c('p',[_vm._v("health_ambulance")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons loader_gear"}),_vm._v(" "),_c('p',[_vm._v("loader_gear")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons loader_refresh"}),_vm._v(" "),_c('p',[_vm._v("loader_refresh")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons location_bookmark"}),_vm._v(" "),_c('p',[_vm._v("location_bookmark")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons location_compass-05"}),_vm._v(" "),_c('p',[_vm._v("location_compass-05")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons location_map-big"}),_vm._v(" "),_c('p',[_vm._v("location_map-big")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons location_pin"}),_vm._v(" "),_c('p',[_vm._v("location_pin")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons location_world"}),_vm._v(" "),_c('p',[_vm._v("location_world")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-1_album"}),_vm._v(" "),_c('p',[_vm._v("media-1_album")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-1_button-pause"}),_vm._v(" "),_c('p',[_vm._v("media-1_button-pause")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-1_button-play"}),_vm._v(" "),_c('p',[_vm._v("media-1_button-play")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-1_button-power"}),_vm._v(" "),_c('p',[_vm._v("media-1_button-power")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-1_camera-compact"}),_vm._v(" "),_c('p',[_vm._v("media-1_camera-compact")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-2_note-03"}),_vm._v(" "),_c('p',[_vm._v("media-2_note-03")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons media-2_sound-wave"}),_vm._v(" "),_c('p',[_vm._v("media-2_sound-wave")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_diamond"}),_vm._v(" "),_c('p',[_vm._v("objects_diamond")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_globe"}),_vm._v(" "),_c('p',[_vm._v("objects_globe")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_key-25"}),_vm._v(" "),_c('p',[_vm._v("objects_key-25")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_planet"}),_vm._v(" "),_c('p',[_vm._v("objects_planet")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_spaceship"}),_vm._v(" "),_c('p',[_vm._v("objects_spaceship")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_support-17"}),_vm._v(" "),_c('p',[_vm._v("objects_support-17")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons objects_umbrella-13"}),_vm._v(" "),_c('p',[_vm._v("objects_umbrella-13")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons education_agenda-bookmark"}),_vm._v(" "),_c('p',[_vm._v("education_agenda-bookmark")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons education_atom"}),_vm._v(" "),_c('p',[_vm._v("education_atom")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons education_glasses"}),_vm._v(" "),_c('p',[_vm._v("education_glasses")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons education_hat"}),_vm._v(" "),_c('p',[_vm._v("education_hat")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons education_paper"}),_vm._v(" "),_c('p',[_vm._v("education_paper")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_bag-16"}),_vm._v(" "),_c('p',[_vm._v("shopping_bag-16")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_basket"}),_vm._v(" "),_c('p',[_vm._v("shopping_basket")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_box"}),_vm._v(" "),_c('p',[_vm._v("shopping_box")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_cart-simple"}),_vm._v(" "),_c('p',[_vm._v("shopping_cart-simple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_credit-card"}),_vm._v(" "),_c('p',[_vm._v("shopping_credit-card")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_delivery-fast"}),_vm._v(" "),_c('p',[_vm._v("shopping_delivery-fast")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_shop"}),_vm._v(" "),_c('p',[_vm._v("shopping_shop")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons shopping_tag-content"}),_vm._v(" "),_c('p',[_vm._v("shopping_tag-content")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons sport_trophy"}),_vm._v(" "),_c('p',[_vm._v("sport_trophy")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons sport_user-run"}),_vm._v(" "),_c('p',[_vm._v("sport_user-run")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_controller-modern"}),_vm._v(" "),_c('p',[_vm._v("tech_controller-modern")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_headphones"}),_vm._v(" "),_c('p',[_vm._v("tech_headphones")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_laptop"}),_vm._v(" "),_c('p',[_vm._v("tech_laptop")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_mobile"}),_vm._v(" "),_c('p',[_vm._v("tech_mobile")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_tablet"}),_vm._v(" "),_c('p',[_vm._v("tech_tablet")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_tv"}),_vm._v(" "),_c('p',[_vm._v("tech_tv")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons tech_watch-time"}),_vm._v(" "),_c('p',[_vm._v("tech_watch-time")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons text_align-center"}),_vm._v(" "),_c('p',[_vm._v("text_align-center")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons text_align-left"}),_vm._v(" "),_c('p',[_vm._v("text_align-left")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons text_bold"}),_vm._v(" "),_c('p',[_vm._v("text_bold")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons text_caps-small"}),_vm._v(" "),_c('p',[_vm._v("text_caps-small")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons gestures_tap-01"}),_vm._v(" "),_c('p',[_vm._v("gestures_tap-01")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons transportation_air-baloon"}),_vm._v(" "),_c('p',[_vm._v("transportation_air-baloon")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons transportation_bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("transportation_bus-front-12")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons travel_info"}),_vm._v(" "),_c('p',[_vm._v("travel_info")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons travel_istanbul"}),_vm._v(" "),_c('p',[_vm._v("travel_istanbul")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_bell-53"}),_vm._v(" "),_c('p',[_vm._v("ui-1_bell-53")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_check"}),_vm._v(" "),_c('p',[_vm._v("ui-1_check")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_calendar-60"}),_vm._v(" "),_c('p',[_vm._v("ui-1_calendar-60")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_lock-circle-open"}),_vm._v(" "),_c('p',[_vm._v("ui-1_lock-circle-open")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_send"}),_vm._v(" "),_c('p',[_vm._v("ui-1_send")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_settings-gear-63"}),_vm._v(" "),_c('p',[_vm._v("ui-1_settings-gear-63")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_simple-add"}),_vm._v(" "),_c('p',[_vm._v("ui-1_simple-add")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_simple-delete"}),_vm._v(" "),_c('p',[_vm._v("ui-1_simple-delete")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_simple-remove"}),_vm._v(" "),_c('p',[_vm._v("ui-1_simple-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_zoom-bold"}),_vm._v(" "),_c('p',[_vm._v("ui-1_zoom-bold")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-2_chat-round"}),_vm._v(" "),_c('p',[_vm._v("ui-2_chat-round")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-2_favourite-28"}),_vm._v(" "),_c('p',[_vm._v("ui-2_favourite-28")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-2_like"}),_vm._v(" "),_c('p',[_vm._v("ui-2_like")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-2_settings-90"}),_vm._v(" "),_c('p',[_vm._v("ui-2_settings-90")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-2_time-alarm"}),_vm._v(" "),_c('p',[_vm._v("ui-2_time-alarm")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons ui-1_email-85"}),_vm._v(" "),_c('p',[_vm._v("ui-1_email-85")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons users_circle-08"}),_vm._v(" "),_c('p',[_vm._v("users_circle-08")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"now-ui-icons users_single-02"}),_vm._v(" "),_c('p',[_vm._v("users_single-02")])])])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BCof":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BIC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports"},[_c('transition',{attrs:{"name":"component-fade"}},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":true,"secondary":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticStyle:{"margin":"30px","min-height":"84vh"}},[_c('v-card-actions',[_c('v-card-actions',{staticClass:"dropdowns-container"},[(_vm.hasAdminAccess)?_c('div',{staticClass:"admin-access-section"},[_c('employee-status-dropdown',{attrs:{"employees":_vm.employees,"disabled":_vm.isSelectLoading || !_vm.logs.length,"loading":_vm.isSelectLoading},on:{"input":_vm.selectEmployee},model:{value:(_vm.selectedEmployee),callback:function ($$v) {_vm.selectedEmployee=$$v},expression:"selectedEmployee"}})],1):_vm._e(),_vm._v(" "),(this.isAdmin)?_c('div',{staticStyle:{"width":"271px"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-group"},[_c('div',{staticClass:"searchable-1"},[_c('SearchableDropdown',{attrs:{"items":_vm.months,"disabled":_vm.isSelectLoading || !_vm.logs.length,"loading":_vm.isSelectLoading,"label-key":"name","placeholder":_vm.currentMonth || 'Select Month'},on:{"select":_vm.selectMonthYear},model:{value:(_vm.currentMonth),callback:function ($$v) {_vm.currentMonth=$$v},expression:"currentMonth"}})],1),_vm._v(" "),_c('div',[_c('SearchableDropdown',{attrs:{"items":_vm.years,"disabled":_vm.isSelectLoading || !_vm.logs.length,"loading":_vm.isSelectLoading,"label-key":"name","placeholder":_vm.currentYear ? Number(_vm.currentYear) : 'Select Year'},on:{"select":_vm.selectMonthYear},model:{value:(_vm.currentYear),callback:function ($$v) {_vm.currentYear=$$v},expression:"currentYear"}})],1)]),_vm._v(" "),_c('button',{staticClass:"pdf-button",attrs:{"disabled":_vm.isSelectLoading || !_vm.logs.length},on:{"click":_vm.exportPDF}},[_vm._v("Export as PDF")])])],1),_vm._v(" "),_c('v-card-actions',{staticClass:"select-container",staticStyle:{"margin-top":"-25px","margin":"0px 15px"}},[_vm._l((_vm.description),function(item){return _c('div',{key:item.for + item.color,staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"chips chips-container",staticStyle:{"background-color":"#435851"},style:({color: item.color})},[_c('v-icon',{staticClass:"text--darken-2",staticStyle:{"font-size":"22px"}},[_vm._v(_vm._s(item.icon))]),_vm._v(" "),_c('span',{staticStyle:{"color":"white","display":"inline-block","text-align":"left","margin-left":"8px"}},[_vm._v(_vm._s(item.for))])],1)],1)}),_vm._v(" "),_c('div',{staticClass:"edit-request-count",staticStyle:{"padding":"10px","font-weight":"bold"}},[_c('div',{staticClass:"edit-request-inner"},[_vm._v("\n                    Pending Edit Requests for "+_vm._s(_vm.currentMonth)+" "+_vm._s(_vm.currentYear)+" : "),_c('span',{staticStyle:{"color":"#5EC1A5"}},[_vm._v(_vm._s(_vm.pendingEditRequestCount))])])])],2),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isSelectLoading || !_vm.logs.length)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"loader-container"},[_c('DoubleLoader',{staticClass:"loader"})],1)]):_c('div',[_c('MonthlyStats',{attrs:{"logs":_vm.logs,"working-days":_vm.workingDays,"working-hours":_vm.workingHours,"month":_vm.currentMonth,"year":String(_vm.currentYear),"average-hours":_vm.averageHours,"average-minutes":_vm.averageMinutes,"holidays":_vm.holidays}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',_vm._b({attrs:{"fluid":""}},"v-container",_vm._d({},[(("grid-list-" + _vm.size)),true])),[_c('v-layout',{staticStyle:{"padding":"10px","display":"flex","flex-wrap":"wrap"},attrs:{"row":"","wrap":""}},_vm._l((_vm.days),function(day,index){return _c('v-flex',{key:index,staticClass:"log-flex",staticStyle:{"flex":"1 0 240px","max-width":"300px"}},[_c('v-expansion-panel',{staticStyle:{"transition":"none"},attrs:{"popout":"","focusable":"","elevation":"1"}},[(_vm.logs[index] && _vm.logs[index].editRequest)?_c('v-badge',{staticStyle:{"position":"absolute","top":"5px","right":"-10px"},attrs:{"color":"#5EC1A5","overlap":""},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('v-icon',{staticStyle:{"cursor":"pointer","color":"white","font-size":"20px"},on:{"click":function($event){return _vm.openEditRequestModal(_vm.logs[index])}}},[_vm._v("mdi-bell-alert")])]},proxy:true}])},[_vm._v(" "),_c('span')]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","z-index":"0","gap":"6px","top":"70px","justify-content":"end","right":"55px","width":"50px","display":"flex"}},[(_vm.logs && _vm.logs[index] && _vm.manualHoursActivities.some(function (activity) { return activity.Key === _vm.logs[index].key; }))?_c('div',{staticStyle:{"cursor":"pointer","color":"white","font-size":"10px","min-width":"18px","height":"18px","border-radius":"50%","display":"flex","background-color":"#5EC1A5","text-align":"center","align-items":"center","justify-content":"center"},on:{"click":function($event){_vm.openHistoryModal(_vm.manualHoursActivities.filter(function (activity) { return activity.Key === _vm.logs[index].key; }))}}},[_c('span',{staticStyle:{"font-size":"12px","line-height":"1"}},[_vm._v("M")])]):_vm._e(),_vm._v(" "),(_vm.isHoliday(index + 1) && _vm.hasAdminAccess)?_c('div',{staticStyle:{"cursor":"pointer","color":"orange","font-size":"10px","min-width":"18px","height":"18px","border-radius":"50%","display":"flex","background-color":"white","text-align":"center","align-items":"center","justify-content":"center"},attrs:{"title":_vm.isHoliday(index + 1)}},[_c('span',{staticStyle:{"font-size":"12px","line-height":"1"}},[_vm._v("H")])]):_vm._e(),_vm._v(" "),(_vm.shouldHighlight(_vm.logs[index]).highlight)?_c('v-icon',{staticStyle:{"font-size":"22px","margin-top":"-1.9px","display":"flex","align-items":"center","justify-content":"center","opacity":"0.9"},attrs:{"icon":"","index":index,"color":_vm.shouldHighlight(_vm.logs[index]).isExpertizo ? 'rgba(211,47,47,0.9)' : 'blue'},on:{"click":function($event){return _vm.openMapPopup(index)}}},[_vm._v("\n                            mdi-map-marker \n                          ")]):_vm._e(),_vm._v(" "),(_vm.checkLateScreenshot(_vm.logs[index]))?_c('v-icon',{staticStyle:{"font-size":"22px","margin-top":"-2px","display":"flex","align-items":"center","justify-content":"center"},attrs:{"color":"orange","overlap":"","title":"No screenshot taken within 20 minutes."}},[_vm._v("\n                            mdi-clock-alert\n                          ")]):_vm._e()],1),_vm._v(" "),_c('v-expansion-panel-content',{class:{ 'grey' : day.indexOf('*') + 1 },style:(_vm.isHoliday(index + 1) ? 'background-color: 	#ffd7b5' : ''),attrs:{"hide-actions":""},model:{value:(_vm.expandedPanels[index]),callback:function ($$v) {_vm.$set(_vm.expandedPanels, index, $$v)},expression:"expandedPanels[index]"}},[_c('div',{staticStyle:{"padding":"10px 0","display":"flex","justify-content":"space-between","align-items":"center"},attrs:{"slot":"header"},slot:"header"},[_c('div',{},[_c('p',{staticStyle:{"margin":"0px","margin-top":"15px"}},[_vm._v(_vm._s(day.slice(0, day.indexOf('*'))))]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0px","margin-top":"10px"}},[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","display":"flex","margin-top":"8px","align-items":"center","flex-direction":"column-reverse","gap":"12px"}},[(_vm.logs[index])?_c('v-icon',{staticClass:"text--darken-2 late",class:{ 'red--text': _vm.logs[index].late.hours || _vm.logs[index].late.minutes, 
                          'lightgreen--text': !_vm.logs[index].late.hours && !_vm.logs[index].late.minutes },staticStyle:{"font-size":"22px"}},[_vm._v("\n                                mdi-clock-outline\n                              ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.auth.user && _vm.hasAdminAccess && !_vm.logs[index])?_c('span',{staticClass:"edit-icon",staticStyle:{"margin-top":"-4px"}},[(_vm.$store.state.auth.user && _vm.hasAdminAccess && !_vm.logs[index])?_c('v-icon',{staticStyle:{"color":"green","font-size":"16px"},on:{"click":function($event){$event.stopPropagation();return _vm.editLog(index+1)}}},[_vm._v("mdi-pencil")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isHoliday(index + 1) && !_vm.hasAdminAccess)?_c('div',{staticStyle:{"cursor":"pointer","color":"orange","font-size":"10px","min-width":"18px","height":"18px","border-radius":"50%","display":"flex","background-color":"white","text-align":"center","align-items":"center","justify-content":"center","margin-right":".5px"},attrs:{"title":_vm.isHoliday(index + 1)}},[_c('span',{staticStyle:{"font-size":"12px","line-height":"1"}},[_vm._v("H")])]):_vm._e(),_vm._v(" "),_c('v-icon',{staticClass:"custom-angle-icon",staticStyle:{"font-size":"25px"},attrs:{"title":'Expanded: ' + _vm.expandedPanels[index]}},[_vm._v("\n                                "+_vm._s(_vm.expandedPanels[index] ? 'mdi-chevron-up' : 'mdi-chevron-down')+"\n                              ")])],1)]),_vm._v(" "),(_vm.logs[index])?_c('v-card',{staticClass:"blue-grey darken-2 white--text card-info",staticStyle:{"margin-top":"20px","height":"auto","position":"relative"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('v-icon',{staticClass:"red--text text--darken-2",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-clock-outline")]),_vm._v(" "),(_vm.logs[index].late.hours != 0 || _vm.logs[index].late.minutes != 0)?_c('span',[(_vm.logs[index].late.hours != 0)?_c('span',[_vm._v(_vm._s(_vm.logs[index].late.hours)+" hours and")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.logs[index].late.minutes)+" minutes")])]):_c('span',[_vm._v("Not Late!")])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('v-icon',{staticClass:"blue--text text--darken-2",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-login")]),_vm._v(" "),_c('span',[(
                                _vm.logs[index] && 
                                _vm.logs[index].editRequest && 
                                _vm.logs[index].editRequest.timeIn !== _vm.logs[index].timeIn
                              )?_c('span',{staticStyle:{"display":"flex","align-items":"center","flex-wrap":"wrap"}},[_c('span',{style:({ textDecoration: 'line-through' })},[_vm._v(_vm._s(_vm.logs[index].timeIn))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(" "+_vm._s(_vm.logs[index].editRequest.timeIn))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"5px","font-size":"9px","color":"#ffa500"}}),_vm._v(" "),(_vm.logs[index].originalTimeIn !== _vm.logs[index].editRequest.timeIn)?_c('span',{staticClass:"custom-tooltip-wrapper",staticStyle:{"position":"relative","display":"inline-block","margin":"5px 0px","z-index":"10000"}},[_c('v-icon',{staticStyle:{"margin-left":"4px","cursor":"pointer","z-index":"10000"},attrs:{"small":"","color":"#5EC1A5"},on:{"mouseover":_vm.logMouseover,"mouseleave":_vm.logMouseleave}},[_vm._v("mdi-information")]),_vm._v(" "),_c('span',{staticClass:"custom-tooltip"},[_vm._v("\n                                     Reason: "+_vm._s(_vm.logs[index].editRequest.reason || 'No reason provided')+"\n                                  ")])],1):_vm._e()]):_c('span',[_vm._v("\n                              "+_vm._s(_vm.logs[index].timeIn)+"\n                            ")])])],1),_vm._v(" "),(_vm.logs[index].break && _vm.logs[index].break.breakStart)?_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('v-icon',{staticClass:"orange--text text--darken-1",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-food")]),_vm._v(" "),_c('span',[_c('span',[_vm._v("\n                                  "+_vm._s(_vm.formatTime(_vm.logs[index].break.breakStart))+"\n                                ")])])],1):_vm._e(),_vm._v(" "),(_vm.logs[index].break && _vm.logs[index].break.breakEnd)?_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('v-icon',{staticClass:"green--text text--darken-2",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-food-off")]),_vm._v(" "),_c('span',[_c('span',[_vm._v("\n                                  "+_vm._s(_vm.formatTime(_vm.logs[index].break.breakEnd))+"\n                                ")])])],1):_vm._e(),_vm._v(" "),(_vm.logs[index].break && _vm.logs[index].break.breakExceededMs)?_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('v-icon',{staticClass:"red--text text--darken-2",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-clock-alert")]),_vm._v(" "),_c('span',[_c('span',[_vm._v("\n                                  "+_vm._s(_vm.formatDuration(_vm.logs[index].break.breakExceededMs))+"\n                                ")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"time-status-container",staticStyle:{"margin-bottom":"10px"}},[(_vm.checkTimeoutResult(index, _vm.userOnline(_vm.logs[index])))?_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('v-icon',{staticClass:"yellow--text text--darken-2",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-logout")]),_vm._v(" "),_c('span',[(_vm.logs[index].editRequest && _vm.logs[index].editRequest.timeOut !== _vm.logs[index].timeOut)?_c('span',{staticStyle:{"display":"flex","align-items":"center","flex-wrap":"wrap"}},[_c('span',{style:({ textDecoration: 'line-through' })},[_vm._v(_vm._s(_vm.checkTimeoutResult(index)))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(" "+_vm._s(_vm.logs[index].editRequest.timeOut))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"5px","font-size":"9px","color":"#ffa500"}}),_vm._v(" "),(_vm.logs[index].editRequest && _vm.logs[index].editRequest.originalTimeIn === _vm.logs[index].editRequest.timeIn && _vm.logs[index].editRequest.originalTimeOut !== _vm.logs[index].editRequest.timeOut)?_c('span',{staticClass:"custom-tooltip-wrapper",staticStyle:{"position":"relative","display":"inline-block","margin":"5px","z-index":"10000"},on:{"click":function($event){return _vm.logTooltipCondition(index)}}},[_c('v-icon',{staticStyle:{"margin-left":"3px","cursor":"pointer","z-index":"10000"},attrs:{"small":"","color":"#5EC1A5"},on:{"mouseover":_vm.logMouseover,"mouseleave":_vm.logMouseleave}},[_vm._v("mdi-information")]),_vm._v(" "),_c('span',{staticClass:"custom-tooltip"},[_vm._v("\n                                  Reason: "+_vm._s(_vm.logs[index].editRequest.reason || 'No reason provided')+"\n                                ")])],1):_vm._e()]):_c('span',[_vm._v("\n                              "+_vm._s(_vm.logs[index].timeOut)+"\n                            ")])])],1):_vm._e(),_vm._v(" "),(_vm.userOnline(_vm.logs[index]))?_c('div',{staticClass:"user-status",staticStyle:{"display":"flex","align-items":"center"}},[_c('v-icon',{staticClass:"lightgreen--text",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-account-check")]),_vm._v("\n                                "+_vm._s(_vm.logs[index].userStatus)+"\n                              ")],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"50px"}},[_c('v-icon',{staticClass:"lightgreen--text text--darken-2",staticStyle:{"font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-check-circle-outline")]),_vm._v(" "),_c('span',[(_vm.logs[index].completed.hours != 0)?_c('span',[_vm._v(_vm._s(_vm.logs[index].completed.hours)+" hours\n                              and")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.logs[index].completed.minutes)+" minutes")])])],1),_vm._v(" "),_c('div',{staticClass:"card-bottom"},[_c('v-btn',{attrs:{"icon":"","primary":"","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editLog(_vm.logs[index])}}},[_c('v-icon',{staticStyle:{"margin":"3px","font-size":"20px"}},[_vm._v("mdi-pencil")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","primary":"","dark":"","index":index},on:{"click":function($event){return _vm.details(index)}}},[_c('v-icon',{staticStyle:{"margin":"3px","font-size":"20px"}},[_vm._v("mdi-information")])],1)],1)]):_vm._e()],1),_vm._v(" "),(_vm.logs[index]  && Number.isFinite(_vm.logs[index].completedPercent) && _vm.logs[index].completedPercent >= 88)?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"value":_vm.logs[index].completedPercent,"height":"5","success":"","color":"green"},on:{"update:value":function($event){return _vm.console.debug('Success bar index:', index, 'completedPercent:', _vm.logs[index].completedPercent)}}}):_vm._e(),_vm._v(" "),(!_vm.logs[index] || !Number.isFinite(_vm.logs[index].completedPercent))?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"height":"5","secondary":"","color":"grey"},on:{"update:value":function($event){return _vm.console.debug('Secondary bar index:', index, 'completedPercent:', 
                      _vm.logs[index] ? _vm.logs[index].completedPercent : 'null')}}}):_vm._e(),_vm._v(" "),(_vm.logs[index] && Number.isFinite(_vm.logs[index].completedPercent) && _vm.logs[index].completedPercent < 88)?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"value":_vm.logs[index].completedPercent,"height":"5","error":"","color":"red"},on:{"update:value":function($event){return _vm.console.debug('Error bar index:', index, 'completedPercent:', _vm.logs[index].completedPercent)}}}):_vm._e()],1)],1)}),1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800px","transition":"dialog-bottom-transition","overlay":false,"id":"preview-dialog"},model:{value:(_vm.previewDetails),callback:function ($$v) {_vm.previewDetails=$$v},expression:"previewDetails"}},[(_vm.currentObj)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline",staticStyle:{"margin-left":"10px"}},[(_vm.currentImgObj)?_c('span',[_vm._v("Screenshot at "+_vm._s(_vm.moment(_vm.currentImgObj.timestamp).format('h:mm:ss a'))+"\n                          on")]):_vm._e(),_vm._v("\n                      "+_vm._s(_vm.currentMonth)+" "+_vm._s(_vm.currentObj.day)+", "+_vm._s(_vm.currentYear)+"\n                    ")]),_vm._v(" "),(!_vm.currentImgObj)?_c('div',{staticStyle:{"width":"85%","text-align":"right"},style:({ color: _vm.currentObj.completedPercent >= 88 ? '#02e009' : _vm.currentObj.completedPercent >= 50 ? 'yellow' : 'red' })},[_c('div',[_vm._v("Time Completed")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"id":"dialog3","size":100,"width":15,"rotate":-90,"value":_vm.currentObj.completedPercent}},[_vm._v(_vm._s(parseInt(_vm.currentObj.completedPercent))+"%\n                        ")])],1):_vm._e()]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('div',{staticStyle:{"margin-top":"10px","display":"flex","justify-content":"space-between","align-items":"center","flex-wrap":"wrap"}},[_vm._l((_vm.currentObj.screenshots),function(item,index){return (!_vm.currentImgObj)?_c('span',{key:index,staticClass:"text-xs-center",staticStyle:{"margin":"10px","display":"inline-block","cursor":"pointer"},on:{"click":function($event){return _vm.previewImage(index)}}},[_c('img',{staticStyle:{"width":"215px","height":"120px"},attrs:{"src":item.url,"alt":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.moment(item.timestamp).format('h:mm:ss a')))])]):_vm._e()}),_vm._v(" "),(_vm.currentImgObj)?_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.currentImgObj.url}}):_vm._e()],2)])],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"action-buttons",staticStyle:{"background-color":"transparent"}},[(_vm.currentImgObj)?_c('div',[_c('v-btn',{staticClass:"next-previous-btn",attrs:{"text":"","disabled":_vm.currentScreenshotIndex <= 0},on:{"click":_vm.prevScreenshot}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Previous\n                      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"next-previous-btn",attrs:{"text":"","disabled":_vm.currentScreenshotIndex >= _vm.currentObj.screenshots.length - 1},on:{"click":_vm.nextScreenshot}},[_vm._v("\n                        Next "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-arrow-right")])],1)],1):_vm._e(),_vm._v(" "),_c('div',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentImgObj),expression:"currentImgObj"}],staticClass:"next-previous-btn",attrs:{"text":""},on:{"click":function($event){_vm.currentImgObj = null}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{staticClass:"next-previous-btn",attrs:{"text":""},on:{"click":function($event){_vm.previewDetails = false}}},[_vm._v("Close")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","z-index":"99"}},[_c('ReuseableModal',{attrs:{"modelValue":_vm.mapPopup,"title":"User Location","submitButtonText":"Close","xlarge":true,"hideCancelButton":true},on:{"update:modelValue":function($event){_vm.mapPopup = $event},"submit":function($event){_vm.mapPopup = false}},scopedSlots:_vm._u([{key:"default",fn:function(){return [(_vm.currentCoordinates)?_c('div',[(_vm.currentCoordinates.timeIn || _vm.currentCoordinates.timeOut)?_c('div',[(_vm.currentCoordinates.timeIn)?_c('div',{staticStyle:{"width":"100%","height":"200px"},attrs:{"id":"mapIn"}}):_vm._e(),_vm._v(" "),(_vm.currentCoordinates.timeOut)?_c('div',{staticStyle:{"width":"100%","height":"200px","margin-top":"10px"},attrs:{"id":"mapOut"}}):_vm._e()]):(_vm.currentCoordinates.latitude && _vm.currentCoordinates.longitude)?_c('div',{staticStyle:{"width":"100%","height":"200px"},attrs:{"id":"mapActivity"}}):_c('div',[_c('p',[_vm._v("No location data available.")])])]):_vm._e()]},proxy:true}])})],1),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isEditRequestModalOpen,"showSubmitButton":false,"title":"Review Time Edit Request","submitButtonText":"Close","hideCancelButton":true},on:{"update:modelValue":function($event){_vm.isEditRequestModalOpen = $event},"submit":_vm.closemodal},scopedSlots:_vm._u([{key:"default",fn:function(){return [(_vm.selectedEditRequest)?_c('div',[_c('p',{staticStyle:{"margin":"10px"}},[(
                          _vm.selectedEditRequest.editRequest &&
                          _vm.selectedEditRequest.originalTimeIn !== _vm.selectedEditRequest.editRequest.timeIn
                        )?_c('span',{staticStyle:{"display":"flex","align-items":"center","flex-wrap":"wrap","max-width":"400px"}},[_c('strong',[_vm._v("Time In:")]),_vm._v(" "),_c('span',{staticStyle:{"text-decoration":"line-through","margin-right":"8px","margin-left":"5px"}},[_vm._v(_vm._s(_vm.selectedEditRequest.originalTimeIn))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(_vm._s(_vm.selectedEditRequest.editRequest.timeIn))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"5px","font-size":"10px","color":"#5EC1A5"}},[_vm._v("(Pending)")]),_vm._v(" "),(_vm.selectedEditRequest.originalTimeIn !== _vm.selectedEditRequest.editRequest.timeIn)?_c('v-tooltip',{attrs:{"top":"","content-class":"tooltip-fix"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                        var on = ref.on;
                        var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"margin-left":"3px","cursor":"pointer"},attrs:{"small":"","color":"#5EC1A5"}},'v-icon',attrs,false),on),[_vm._v("mdi-information")])]}}])},[_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","max-width":"300px","text-align":"center","background":"#000000","padding":"5px 8px","color":"#ffffff","border-radius":"4px","word-wrap":"break-word"}},[_vm._v("\n                              Reason: "+_vm._s(_vm.selectedEditRequest.editRequest.reason)+"\n                            ")])]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('p',{staticStyle:{"margin":"10px"}},[(
                          _vm.selectedEditRequest.editRequest &&
                          _vm.selectedEditRequest.originalTimeOut !== _vm.selectedEditRequest.editRequest.timeOut
                        )?_c('span',{staticStyle:{"display":"flex","align-items":"center","flex-wrap":"wrap","max-width":"400px"}},[_c('strong',[_vm._v("Time Out:")]),_vm._v(" "),_c('span',{staticStyle:{"text-decoration":"line-through","margin-left":"5px"}},[_vm._v(_vm._s(_vm.selectedEditRequest.originalTimeOut)+"\n                        ")]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(_vm._s(_vm.selectedEditRequest.editRequest.timeOut))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"5px","font-size":"10px","color":"#5EC1A5"}},[_vm._v("(Pending)")]),_vm._v(" "),(_vm.selectedEditRequest.originalTimeIn === _vm.selectedEditRequest.editRequest.timeIn && _vm.selectedEditRequest.originalTimeOut !== _vm.selectedEditRequest.editRequest.timeOut)?_c('v-tooltip',{attrs:{"top":"","content-class":"tooltip-fix"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                        var on = ref.on;
                        var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"margin-left":"3px","cursor":"pointer"},attrs:{"small":"","color":"#5EC1A5"}},'v-icon',attrs,false),on),[_vm._v("mdi-information")])]}}])},[_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","max-width":"300px","text-align":"center","background":"#000000","color":"#ffffff","padding":"5px 8px","border-radius":"4px","word-wrap":"break-word"}},[_vm._v("\n                              Reason: "+_vm._s(_vm.selectedEditRequest.editRequest.reason)+"\n                            ")])]):_vm._e()],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.canPerformRequestAction(_vm.selectedEditRequest.editRequest, _vm.$store.state.auth.user, 'approve').allowed)?_c('v-btn',{staticStyle:{"color":"white","outline":"none","border-radius":"6px"},attrs:{"color":"#5EC1A5"},on:{"click":_vm.approveEditRequest}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-check")]),_vm._v(" Approve\n                    ")],1):_vm._e(),_vm._v(" "),(_vm.canPerformRequestAction(_vm.selectedEditRequest.editRequest, _vm.$store.state.auth.user, 'reject').allowed)?_c('v-btn',{staticStyle:{"color":"white","outline":"none","border-radius":"6px"},attrs:{"color":"red"},on:{"click":_vm.rejectEditRequest}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-close")]),_vm._v(" Reject\n                    ")],1):_vm._e()],1)]},proxy:true}])}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isHistoryModalOpen,"title":"Activity History","submitButtonText":"Close","xlarge":true,"hideCancelButton":true},on:{"update:modelValue":function($event){_vm.isHistoryModalOpen = $event},"submit":_vm.closeHistoryModal},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('HistoryActivityTable',{attrs:{"activities":_vm.manualHoursActivity,"columns":_vm.columns},on:{"open-map":_vm.openMapPopup}})]},proxy:true}])}),_vm._v(" "),(!_vm.loading && !_vm.logs.length)?_c('v-card',{staticClass:"text-xs-center"},[_c('v-card-text',[_c('h3',[_vm._v("No logs available for this month.")])])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isEditModalOpen,"title":"Update the time","submitButtonText":"Submit","loading":_vm.loading.editRequest},on:{"update:modelValue":function($event){_vm.isEditModalOpen = $event},"submit":_vm.submitAction},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitAction($event)}}},[_c('div',{staticClass:"form-group time-dropdown-container"},[_c('label',{attrs:{"for":"lateTime"}},[_vm._v("Time In")]),_vm._v(" "),_c('div',{staticClass:"time-columns"},[_c('LateTimeDropdown',{attrs:{"data":_vm.hours,"selected":_vm.selectedDay.timeInHour},on:{"change":_vm.updateTimeInHour}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.minutes,"selected":_vm.selectedDay.timeInMinute},on:{"change":_vm.updateTimeInMinute}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.meridians,"selected":_vm.selectedDay.timeInMeridian},on:{"change":_vm.updateTimeInMeridian}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group time-dropdown-container"},[_c('label',{attrs:{"for":"lateTime"}},[_vm._v("Time Out")]),_vm._v(" "),_c('div',{staticClass:"time-columns"},[_c('LateTimeDropdown',{attrs:{"data":_vm.hours,"selected":_vm.selectedDay.timeOutHour},on:{"change":_vm.updateTimeOutHour}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.minutes,"selected":_vm.selectedDay.timeOutMinute},on:{"change":_vm.updateTimeOutMinute}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.meridians,"selected":_vm.selectedDay.timeOutMeridian},on:{"change":_vm.updateTimeOutMeridian}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('label',{attrs:{"for":"reason"}},[_vm._v("Reason for Edit Request "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticStyle:{"width":"100%"},attrs:{"id":"reason","required":"","placeholder":"Enter reason for edit request","rows":"3","maxlength":"400"},domProps:{"value":(_vm.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason=$event.target.value}}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","font-size":"12px","color":"gray","margin-top":"4px"}},[_vm._v("\n                  "+_vm._s(_vm.reason.length)+" / 400\n                ")])])])]},proxy:true}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BITr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview"},[(_vm.isAdmin)?_c('div',{staticClass:"mode-switch",attrs:{"role":"group","aria-label":"Dashboard mode"}},[_c('button',{staticClass:"mode-btn",class:{ 'mode-btn--active': _vm.activeMode === 'admin' },attrs:{"type":"button","aria-pressed":_vm.activeMode === 'admin' ? 'true' : 'false'},on:{"click":function($event){return _vm.setMode('admin')}}},[_c('i',{staticClass:"now-ui-icons business_chart-bar-32",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("Admin")])]),_vm._v(" "),_c('button',{staticClass:"mode-btn",class:{ 'mode-btn--active': _vm.activeMode === 'employee' },attrs:{"type":"button","aria-pressed":_vm.activeMode === 'employee' ? 'true' : 'false'},on:{"click":function($event){return _vm.setMode('employee')}}},[_c('i',{staticClass:"now-ui-icons users_single-02",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("Employee")])])]):_vm._e(),_vm._v(" "),(_vm.activeMode === 'admin')?_c('Admindashboard'):_c('EmployeeDashboard')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BZqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UserProfile_ProfileData__ = __webpack_require__("JiyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_notificationService__ = __webpack_require__("l527");











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdminDashboard",
  data: function data() {
    var _ref;

    return _ref = {
      loading: {
        stats: true,
        header: true
      },
      countedWithEmployees: false,
      busyLeaveIds: [],
      pendingDecision: null,

      presentToday: 0,
      newThisMonth: 0,

      payroll: {
        monthLabel: __WEBPACK_IMPORTED_MODULE_11_moment___default()().format("MMMM YYYY"),
        processed: 0,
        draft: 0,
        awaiting: 0,
        estimatedCount: 0,
        // Active employees eligible for payroll (super admins excluded).
        payrollEmployeeCount: 0,
        totalSalaries: 0,
        totalTaxes: 0,
        // Real payroll figures only (Processed + Draft).
        realSalaries: 0,
        // Gross-salary estimate for employees with no payroll row yet.
        estimatedSalaries: 0,
        // True while any active employee is still represented by an estimate
        // rather than a real payroll record. Drives the "estimated" label.
        hasEstimate: true,
        // null means "not comparable" — the percentage is hidden until payroll
        // is processed for this month, per the PM's rule.
        changeVsLastMonth: null
      },

      attendance: [],
      events: [],
      performance: [],
      complains: []
    }, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, "loading", {
      stats: true,
      header: true,
      attendance: true,
      events: true,
      performance: true,
      complains: true,
      payroll: true,
      activity: true,
      bugs: true
    }), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, "activity", []), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, "bugs", []), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, "avatarPalette", [{ background: "#e6f7f4", color: "#1a6040" }, { background: "#eaf0f9", color: "#1a4a80" }, { background: "#fff3cd", color: "#80400a" }, { background: "#f0e8fb", color: "#4a1a80" }]), _ref;
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user || {};
    },
    leavesLoading: function leavesLoading() {
      return !Array.isArray(this.$store.state.auth.AllLeaves);
    },
    complainsSubtitle: function complainsSubtitle() {
      if (!this.complains.length) return "RECENT COMPLAINS";
      var count = this.complains.length;
      return "RECENT COMPLAINS \xB7 TOP " + count;
    },

    // Raw Trello cards from the complains store module. The module is not
    // namespaced, so its state sits directly under state.complains.
    rawComplains: function rawComplains() {
      var mod = this.$store.state.complains;
      return mod && mod.cardsData;
    },

    // The Complains tab filters cards down to ACTIVE employees via
    // EmployeeDropdown (defaultFilter="active"), so the dashboard must apply
    // the same scope or the two screens show different rows.
    activeEmployeeEmails: function activeEmployeeEmails() {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(this.activeEmployees.map(function (u) {
        return u.email;
      }).filter(Boolean));
    },

    // Last completed month only — the current month is still in progress.
    lastMonthRange: function lastMonthRange() {
      var last = __WEBPACK_IMPORTED_MODULE_11_moment___default()().subtract(1, "month");
      return {
        month: last.format("MMMM"),
        year: String(last.year())
      };
    },
    companyUserIds: function companyUserIds() {
      var company = this.$store.state.auth.company;
      if (!company || !Array.isArray(company.users)) return null;
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(company.users.map(function (u) {
        return u.uid;
      }));
    },

    // Active employees of this company, mirroring the "Active Employees"
    // filter used by the User Reports screen (EmployeeStatusDropdown).
    activeEmployees: function activeEmployees() {
      var allUsers = this.$store.state.auth.allUsers;
      if (!Array.isArray(allUsers) || !allUsers.length) return [];

      var companyUserIds = this.companyUserIds;
      var scoped = companyUserIds ? allUsers.filter(function (u) {
        return companyUserIds.has(u.uid);
      }) : allUsers;

      return scoped.filter(function (u) {
        return u.isActive;
      });
    },
    totalActiveEmployees: function totalActiveEmployees() {
      return this.activeEmployees.length;
    },

    // Company-wide working days from Settings (constants.days). Empty means the
    // company hasn't configured any, in which case the full week is shown.
    workingDayNames: function workingDayNames() {
      var constants = this.$store.state.auth.constants;
      var days = constants && Array.isArray(constants.days) ? constants.days : [];
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(days.map(function (d) {
        return String(d).toLowerCase();
      }));
    },
    weekRangeLabel: function weekRangeLabel() {
      if (!this.attendance.length) return "";
      var first = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.attendance[0].key);
      var last = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.attendance[this.attendance.length - 1].key);
      if (!first.isValid() || !last.isValid()) return "";
      return first.format("D MMM") + " \u2013 " + last.format("D MMM YYYY");
    },
    attendanceMax: function attendanceMax() {
      return this.attendance.reduce(function (max, day) {
        return Math.max(max, day.present, day.absent);
      }, 0);
    },
    weekAttendancePct: function weekAttendancePct() {
      var total = this.totalActiveEmployees * this.attendance.length;
      if (!total) return 0;
      var present = this.attendance.reduce(function (sum, d) {
        return sum + d.present;
      }, 0);
      return Math.round(present / total * 100);
    },
    activitySubtitle: function activitySubtitle() {
      return this.activity.length ? "LATEST " + this.activity.length : "LATEST ACTIVITY";
    },
    payrollSubLabel: function payrollSubLabel() {
      var change = this.payroll.changeVsLastMonth;
      // Hidden until there is a fair comparison to show.
      if (change === null || change === undefined) return "Payroll not processed yet";
      return "" + (change >= 0 ? "+" : "") + change + "% vs last month";
    },
    bugsSubtitle: function bugsSubtitle() {
      return this.bugs.length ? "LATEST " + this.bugs.length : "LATEST REPORTS";
    },
    joiningDateText: function joiningDateText() {
      var joiningDate = this.currentUser.joiningDate;
      if (!joiningDate) return "";
      var date = __WEBPACK_IMPORTED_MODULE_11_moment___default()(joiningDate);
      return date.isValid() ? "Joined " + date.format("D MMM YYYY") : "";
    },
    greeting: function greeting() {
      var hour = new Date().getHours();
      if (hour < 12) return "Good morning";
      if (hour < 18) return "Good afternoon";
      return "Good evening";
    },
    todayText: function todayText() {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()().format("ddd, D MMMM YYYY");
    },

    // Every pending leave belonging to this company, regardless of age.
    // The stat card is a backlog signal, so old requests still count.
    allPendingLeaves: function allPendingLeaves() {
      var leaves = this.$store.state.auth.AllLeaves;
      if (!Array.isArray(leaves)) return [];

      var companyUserIds = this.companyUserIds;
      return leaves.filter(function (leave) {
        if (!leave || leave.status !== "Pending") return false;
        if (!companyUserIds) return true;
        return companyUserIds.has(leave.userId);
      });
    },

    // The panel is an action surface, so it only surfaces recent requests.
    // Anything older is still counted above and handled in Leave Management.
    leaveRequests: function leaveRequests() {
      var _this = this;

      var cutoff = __WEBPACK_IMPORTED_MODULE_11_moment___default()().subtract(30, "days");

      return this.allPendingLeaves.filter(function (leave) {
        var created = Number(leave.createdAt);
        if (!created) return false;
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(created).isSameOrAfter(cutoff);
      }).sort(function (a, b) {
        return b.createdAt - a.createdAt;
      }).map(function (leave) {
        return {
          id: leave.id,
          userId: leave.userId,
          name: leave.employee || _this.findEmployeeName(leave.userId),
          dates: leave.dates || _this.formatLeaveDates(leave),
          type: leave.type,
          busy: _this.busyLeaveIds.includes(leave.id)
        };
      });
    },
    pendingLeaves: function pendingLeaves() {
      return this.allPendingLeaves.length;
    },
    stalePendingLeaves: function stalePendingLeaves() {
      return Math.max(0, this.pendingLeaves - this.leaveRequests.length);
    },
    absentToday: function absentToday() {
      return Math.max(0, this.totalActiveEmployees - this.presentToday);
    },
    stats: function stats() {
      var change = this.payroll.changeVsLastMonth;
      // Green when payroll grew, red when it shrank. Hidden entirely when
      // there is no comparable previous month.
      var payrollSubColor = null;
      if (change !== null && change !== undefined) {
        payrollSubColor = change < 0 ? "#e05c5c" : change > 0 ? "#28a06a" : "#8a9a98";
      }

      return [{
        label: "TOTAL EMPLOYEES",
        value: this.totalActiveEmployees,
        sub: "+" + this.newThisMonth + " this month",
        color: "#1a1a1a"
      }, {
        label: "PRESENT TODAY",
        value: this.presentToday,
        sub: this.absentToday + " absent / on leave",
        color: "#1a1a1a"
      }, {
        label: "PENDING LEAVES",
        value: this.pendingLeaves,
        sub: this.stalePendingLeaves ? this.stalePendingLeaves + " older than 30 days" : "awaiting approval",
        color: "#e0a800"
      }, {
        label: "PAYROLL (" + __WEBPACK_IMPORTED_MODULE_11_moment___default()().format("MMM").toUpperCase() + ")" + (this.payroll.hasEstimate ? " · ESTIMATED" : ""),
        value: this.formatCompact(this.payroll.realSalaries),
        sub: this.payrollSubLabel,
        subColor: payrollSubColor,
        color: "#1a1a1a"
      }];
    }
  },
  watch: {
    // App.vue fills allUsers asynchronously, so the first count can run against
    // an empty employee list. Re-run once the store actually has employees.
    activeEmployees: function activeEmployees(employees) {
      if (employees.length && !this.countedWithEmployees) {
        this.countedWithEmployees = true;
        this.fetchPresentToday();
        this.fetchWeekAttendance();
        this.fetchPayrollSummary();
        this.fetchUpcomingEvents();
        this.fetchPerformance();
        // Re-map complains too: the active-employee filter can only apply
        // once the roster has loaded.
        this.fetchRecentComplains();
      }
    },

    // Trello cards arrive after mount, so re-map the card whenever they land.
    rawComplains: function rawComplains(cards) {
      if (!Array.isArray(cards) || !cards.length) return;
      this.complains = this.mapComplains(cards);
      this.loading.complains = false;
    }
  },
  mounted: function mounted() {
    // Swap this for your real fetches. Each section can clear its own
    // loading flag, like EmployeeDashboard's loadSection does.
    this.fetchPresentToday();
    this.fetchNewThisMonth();
    this.fetchWeekAttendance();
    this.fetchRecentActivity();
    this.fetchRecentBugs();
    this.fetchPayrollSummary();
    this.fetchUpcomingEvents();
    this.fetchPerformance();
    this.fetchRecentComplains();
    this.loading.stats = false;
  },

  methods: {
    // Counts users created in the current month from the Activity Logs feed.
    // adminActivities.*.timestamp is written as toLocaleString('en-PK'),
    // i.e. "D/M/YYYY, h:mm:ss pm" — see createActivityPayload in utils/adminLogs.js.
    fetchNewThisMonth: function fetchNewThisMonth() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
        var snapshot, now, created;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("adminActivities").once("value");

              case 3:
                snapshot = _context.sent;
                now = __WEBPACK_IMPORTED_MODULE_11_moment___default()();
                created = [];


                snapshot.forEach(function (child) {
                  var activity = child.val() || {};
                  if (activity.type !== "create_user") return;

                  var date = _this2.parseActivityTimestamp(activity.timestamp);
                  if (!date || !date.isValid()) return;
                  if (date.isSame(now, "month") && date.isSame(now, "year")) {
                    created.push(activity);
                  }
                });

                _this2.newThisMonth = created.length;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.error("Error fetching new employees this month:", _context.t0);
                _this2.newThisMonth = 0;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10]]);
      }))();
    },


    // Accepts both the en-PK locale string and a parsable date/number, so the
    // count survives if the timestamp format ever changes on write.
    parseActivityTimestamp: function parseActivityTimestamp(timestamp) {
      if (!timestamp) return null;

      if (typeof timestamp === "number") return __WEBPACK_IMPORTED_MODULE_11_moment___default()(timestamp);

      var match = /^(\d{1,2})\/(\d{1,2})\/(\d{4}),\s*(\d{1,2}):(\d{2}):(\d{2})\s*([ap]m)$/i.exec(timestamp);
      if (match) {
        var _match = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(match, 8),
            day = _match[1],
            month = _match[2],
            year = _match[3],
            hours = _match[4],
            minutes = _match[5],
            seconds = _match[6],
            meridiem = _match[7];

        var hour = Number(hours);
        if (/pm/i.test(meridiem) && hour !== 12) hour += 12;
        if (/am/i.test(meridiem) && hour === 12) hour = 0;
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date(Number(year), Number(month) - 1, Number(day), hour, Number(minutes), Number(seconds)));
      }

      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(timestamp);
    },


    // Counts distinct active employees who have a timeIn recorded today.
    // Mirrors the "Active Employees" filter of the User Reports screen.
    fetchPresentToday: function fetchPresentToday() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var now, startOfDay, endOfDay, snapshot, activeIds, activeIdSet, presentIds;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                now = new Date();
                startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
                endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("timePeriod").orderByChild("timeIn").startAt(startOfDay).endAt(endOfDay).once("value");

              case 6:
                snapshot = _context2.sent;
                activeIds = _this3.activeEmployees.map(function (u) {
                  return u.uid;
                }).filter(Boolean);
                activeIdSet = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(activeIds);
                presentIds = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a();

                snapshot.forEach(function (child) {
                  var log = child.val() || {};
                  if (activeIdSet.has(log.userId)) presentIds.add(log.userId);
                });

                _this3.presentToday = presentIds.size;
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);

                console.error("Error fetching present employees for today:", _context2.t0);
                _this3.presentToday = 0;

              case 18:
                _context2.prev = 18;

                _this3.loading.header = false;
                return _context2.finish(18);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 14, 18, 21]]);
      }))();
    },


    // Reads one month's payroll and folds it into the active-employee roster.
    //
    // Per the PM's rules:
    //   (c) processed OR draft rows contribute their real finalAmount
    //   (b) active employees with no row yet contribute an ESTIMATE of their
    //       monthly salary from basicSalary + extraAllowance
    //   (a) only ACTIVE employees are counted — deactivated staff are excluded
    //       even when they still hold a processed row for that month
    //
    // Rows are de-duplicated by employeeId because processing a Pending row can
    // push a second record instead of updating in place.
    fetchMonthPayroll: function fetchMonthPayroll(date) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var year, month, snapshot, byEmployee, payrollEmployees, totals, byId;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                year = date.getFullYear();
                month = __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("MMMM");
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("payroll/" + year + "/" + month).once("value");

              case 4:
                snapshot = _context3.sent;


                // status precedence: Processed wins over Draft.
                byEmployee = {};

                snapshot.forEach(function (child) {
                  var record = child.val() || {};
                  if (!record.employeeId) return;
                  if (record.status !== "Processed" && record.status !== "Draft") return;

                  var existing = byEmployee[record.employeeId];
                  if (existing && existing.status === "Processed") return;

                  byEmployee[record.employeeId] = {
                    status: record.status,
                    amount: Number(record.finalAmount) || 0,
                    tax: Number(record.taxDeduction) || 0
                  };
                });

                // Super admins are excluded from payroll entirely — the Payroll Management
                // screen filters them out at PayrollTable.vue:203, so the dashboard must
                // not invent an estimated salary for them.
                payrollEmployees = _this4.activeEmployees.filter(function (u) {
                  return !u.isSuperAdmin;
                });
                totals = {
                  salaries: 0,
                  taxes: 0,
                  processed: 0,
                  draft: 0,
                  estimated: 0,
                  estimatedAmount: 0,
                  processedAmount: 0,
                  activeCount: payrollEmployees.length
                };
                byId = {};


                payrollEmployees.forEach(function (emp) {
                  var row = byEmployee[emp.uid];

                  if (row) {
                    totals.salaries += row.amount;
                    totals.taxes += row.tax;
                    // Processed and Draft rows are real payroll figures.
                    totals.processedAmount += row.amount;
                    if (row.status === "Processed") totals.processed += 1;else totals.draft += 1;
                    byId[emp.uid] = { amount: row.amount, estimated: false };
                    return;
                  }

                  // No payroll row yet — estimate a full month from the fixed salary.
                  // basicSalary/extraAllowance are monthly figures, matching how payroll
                  // derives grossSalary in payrollHelper.js.
                  var estimate = (Number(emp.basicSalary) || Number(emp.salary) || 0) + (Number(emp.extraAllowance) || 0);

                  totals.salaries += estimate;
                  totals.estimated += 1;
                  totals.estimatedAmount += estimate;
                  byId[emp.uid] = { amount: estimate, estimated: true };
                });

                return _context3.abrupt("return", { year: year, month: month, byId: byId, totals: totals });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },


    // Month-over-month comparison.
    //
    // PM's rule: an employee whose payroll is not processed (or is only Draft)
    // contributes their basic + extra allowance for BOTH months, so the
    // comparison always has figures on both sides and never reports
    // "not available" just because a month is unfinished.
    //
    // The headline "Total salaries" on the card still shows only real payroll
    // figures (rule c); estimated amounts are exposed separately so they can be
    // shown on their own line.
    fetchPayrollSummary: function fetchPayrollSummary() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var now, prev, _ref2, _ref3, current, previous, fullyProcessed, currentSum, previousSum, change;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                now = __WEBPACK_IMPORTED_MODULE_11_moment___default()();
                prev = now.clone().subtract(1, "month");
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([_this5.fetchMonthPayroll(now.toDate()), _this5.fetchMonthPayroll(prev.toDate())]);

              case 5:
                _ref2 = _context4.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                current = _ref3[0];
                previous = _ref3[1];


                _this5.payroll.monthLabel = current.month + " " + current.year;
                _this5.payroll.payrollEmployeeCount = current.totals.activeCount;
                _this5.payroll.processed = current.totals.processed;
                _this5.payroll.draft = current.totals.draft;
                _this5.payroll.estimatedCount = current.totals.estimated;
                _this5.payroll.totalSalaries = current.totals.salaries;
                _this5.payroll.totalTaxes = current.totals.taxes;

                // (d) The estimated label disappears once every payroll-eligible
                // employee has a real Processed payroll for this month.
                fullyProcessed = current.totals.processed > 0 && current.totals.processed >= current.totals.activeCount;

                _this5.payroll.hasEstimate = !fullyProcessed;

                _this5.payroll.awaiting = Math.max(0, current.totals.activeCount - current.totals.processed);

                // Headline total shows real payroll only, with estimates itemised on
                // their own row (the user asked for a separate pending-salaries field).
                _this5.payroll.realSalaries = current.totals.processedAmount;
                _this5.payroll.estimatedSalaries = current.totals.estimatedAmount;

                currentSum = current.totals.salaries;
                previousSum = previous.totals.salaries;

                // Only a genuinely missing baseline (no previous payroll at all) can
                // block the comparison.

                if (previousSum) {
                  _context4.next = 26;
                  break;
                }

                _this5.payroll.changeVsLastMonth = null;
                return _context4.abrupt("return");

              case 26:
                change = (currentSum - previousSum) / previousSum * 100;

                _this5.payroll.changeVsLastMonth = Math.abs(change) < 0.05 ? 0 : Number(change.toFixed(1));
                _context4.next = 34;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t0 = _context4["catch"](0);

                console.error("Error fetching payroll summary:", _context4.t0);
                _this5.payroll.changeVsLastMonth = null;

              case 34:
                _context4.prev = 34;

                _this5.loading.payroll = false;
                return _context4.finish(34);

              case 37:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 30, 34, 37]]);
      }))();
    },


    // Newest bug reports from the last 24 hours. bugReported timestamps are also
    // written as toLocaleString('en-PK') strings, so the shared parser applies.
    fetchRecentBugs: function fetchRecentBugs() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var list, recent;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].getAllBugReports();

              case 3:
                list = _context5.sent;
                recent = [];

                (Array.isArray(list) ? list : []).forEach(function (bug) {
                  if (!bug) return;
                  var date = _this6.parseActivityTimestamp(bug.timestamp);
                  if (!date || !date.isValid()) return;
                  recent.push({ bug: bug, date: date });
                });

                recent.sort(function (a, b) {
                  return b.date.valueOf() - a.date.valueOf();
                });

                _this6.bugs = recent.slice(0, 4).map(function (_ref4) {
                  var bug = _ref4.bug,
                      date = _ref4.date;
                  return {
                    id: bug.id,
                    text: bug.description || "No description provided",
                    reporter: bug.email || "Unknown reporter",
                    time: _this6.relativeTime(date),
                    resolved: bug.status === "Resolved",
                    priority: bug.priority || "",
                    priorityClass: _this6.priorityClass(bug.priority)
                  };
                });
                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                console.error("Error fetching recent bugs:", _context5.t0);
                _this6.bugs = [];

              case 14:
                _context5.prev = 14;

                _this6.loading.bugs = false;
                return _context5.finish(14);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 10, 14, 17]]);
      }))();
    },


    // BugReportModal offers Urgent / High / Normal / Low.
    priorityClass: function priorityClass(priority) {
      var value = String(priority || "").toLowerCase();
      if (value === "urgent") return "urgent";
      if (value === "high") return "high";
      if (value === "low") return "low";
      if (value === "normal" || value === "medium") return "normal";
      return "unknown";
    },


    // Four most recent team complaints. Complains live on Trello and land in
    // the complains Vuex module asynchronously — fetchAllTrelloData does not
    // await its card fetch, so cardsData is usually still null at mount. A
    // one-shot read here showed a stale/empty list, so the card is driven by a
    // watcher on the store instead and re-renders whenever cards arrive.
    mapComplains: function mapComplains(cards) {
      var _this7 = this;

      if (!Array.isArray(cards) || !cards.length) return [];

      // While allUsers is still loading the email set is empty; showing
      // nothing would be worse than briefly showing every row.
      var activeEmails = this.activeEmployeeEmails;

      return cards.filter(function (card) {
        return !activeEmails.size || activeEmails.has(_this7.complainEmail(card));
      }).slice().sort(function (a, b) {
        return new Date(b.dateLastActivity) - new Date(a.dateLastActivity);
      }).slice(0, 6).map(function (card) {
        var email = _this7.complainEmail(card);
        var name = typeof card.name === "string" ? card.name : "";
        var title = name.includes(" - ") ? name.split(" - ")[0] : name;

        // Feedback is appended to desc when submitted, so strip it back to
        // the original complaint text (mirrors AdminComplains.vue:325-328).
        var desc = card.desc || "";
        var text = desc.includes("Feedback Submitted") ? desc.split("Feedback Submitted")[0].trim() : desc.trim();

        return {
          id: card.id,
          text: title || text || "No description",
          reporter: email,
          time: _this7.relativeTime(__WEBPACK_IMPORTED_MODULE_11_moment___default()(card.dateLastActivity)),
          priority: card.isHighPriority ? "High" : "Normal",
          priorityClass: card.isHighPriority ? "high" : "normal",
          status: card.status === "Resolved" ? "Resolved" : "Pending",
          statusClass: card.status === "Resolved" ? "resolved" : "pending",
          type: card.isPersonal ? "Personal" : "General"
        };
      });
    },


    // The reporter's email is the suffix of the Trello card name,
    // "title - reporter@company.com".
    complainEmail: function complainEmail(card) {
      var name = typeof card.name === "string" ? card.name : "";
      if (!name.includes(" - ")) return "";
      return name.split(" - ")[1] || "";
    },
    fetchRecentComplains: function fetchRecentComplains() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                try {
                  _this8.complains = _this8.mapComplains(_this8.rawComplains);
                } catch (err) {
                  console.error("Error fetching complains:", err);
                  _this8.complains = [];
                } finally {
                  _this8.loading.complains = false;
                }

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },


    // Performance for every active employee in the last completed month.
    // Mirrors EmployeeDashboard's scoring: raw score minus reopen and
    // deadline-missed penalties, expressed as a percentage of the target
    // defined for that employee's designation + grade.
    fetchPerformance: function fetchPerformance() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _lastMonthRange, month, year, _ref5, _ref6, cards, criteria, targets, ticketCrit, penalties, reopens, deadlineMissed, byEmployee, targetMap;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _lastMonthRange = _this9.lastMonthRange, month = _lastMonthRange.month, year = _lastMonthRange.year;

                // Read every card and bucket in memory, exactly like
                // EmployeeDashboard.getScoresByMonth. Filtering by month/year inside
                // fetchEditedCards compares with strict ===, so records storing year as
                // a number were silently dropped and produced wildly wrong scores.

                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].fetchEditedCards({}), __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].getAllPerformanceCriteria(), __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].getAllPerformanceScoresByGrade()]);

              case 4:
                _ref5 = _context7.sent;
                _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 3);
                cards = _ref6[0];
                criteria = _ref6[1];
                targets = _ref6[2];
                ticketCrit = (criteria || []).find(function (c) {
                  return c.type === "Ticket";
                });
                penalties = ticketCrit && ticketCrit.rules && ticketCrit.rules.penalties || {};
                reopens = penalties.reopens || {};
                deadlineMissed = penalties.deadlineMissed || {};

                // One read covers every employee, so group the cards by uid here.

                byEmployee = {};

                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(cards || {}).forEach(function (card) {
                  if (!card || card.ticketStatus === "pending") return;
                  if (!card.user) return;
                  // Compare loosely on year so "2026" and 2026 both match.
                  if (String(card.year) !== year) return;
                  if (card.month !== month) return;

                  var bucket = byEmployee[card.user] = byEmployee[card.user] || { rawScore: 0, reopened: 0, deadlineMissedCount: 0, itemCount: 0 };

                  var fields = _this9.resolvePerformanceFields(card);
                  bucket.itemCount += 1;
                  bucket.rawScore += fields.score;
                  bucket.reopened += fields.status !== "pending" && fields.status !== "rejected" ? fields.reopenCount : fields.originalreopenCount;
                  bucket.deadlineMissedCount += fields.deadlineMissedCount;
                });

                // Target score lookup keyed on designation + grade.
                targetMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a((targets || []).map(function (t) {
                  return [t.designation + "||" + String(t.grade), t];
                }));


                _this9.performance = _this9.activeEmployees.map(function (emp) {
                  var bucket = byEmployee[emp.uid];
                  var target = targetMap.get(emp.designation + "||" + String(emp.grade));
                  var targetScore = target && Number(target.score) ? Number(target.score) : null;
                  var gradeLabel = _this9.gradeLabelFor(emp);

                  if (!bucket || !bucket.itemCount || !targetScore) {
                    return {
                      uid: emp.uid,
                      name: emp.username || "Unknown",
                      gradeLabel: gradeLabel,
                      pct: 0,
                      display: "--",
                      color: "#c3ccc9",
                      label: "No data",
                      badgeClass: "badge-none"
                    };
                  }

                  var reopenDeduction = reopens.limit && reopens.score ? bucket.reopened >= reopens.limit ? reopens.score : 0 : reopens.every && reopens.score ? Math.floor(bucket.reopened / reopens.every) * reopens.score : 0;

                  var deadlineDeduction = deadlineMissed.limit && deadlineMissed.score ? bucket.deadlineMissedCount >= deadlineMissed.limit ? deadlineMissed.score : 0 : deadlineMissed.every && deadlineMissed.score ? Math.floor(bucket.deadlineMissedCount / deadlineMissed.every) * deadlineMissed.score : 0;

                  var netScore = bucket.rawScore + reopenDeduction + deadlineDeduction;
                  var pct = Math.max(0, Math.round(netScore / targetScore * 100));
                  var rating = _this9.performanceRating(pct);

                  return {
                    uid: emp.uid,
                    name: emp.username || "Unknown",
                    gradeLabel: gradeLabel,
                    pct: Math.min(pct, 100),
                    display: pct + "%",
                    color: rating.color,
                    label: rating.label,
                    badgeClass: rating.badgeClass
                  };
                }).sort(function (a, b) {
                  // Highest performer first; "No data" rows sink to the bottom.
                  if (a.display === "--" && b.display === "--") return 0;
                  if (a.display === "--") return 1;
                  if (b.display === "--") return -1;
                  return b.pct - a.pct;
                });
                _context7.next = 23;
                break;

              case 19:
                _context7.prev = 19;
                _context7.t0 = _context7["catch"](0);

                console.error("Error fetching performance:", _context7.t0);
                _this9.performance = [];

              case 23:
                _context7.prev = 23;

                _this9.loading.performance = false;
                return _context7.finish(23);

              case 26:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 19, 23, 26]]);
      }))();
    },


    // saveEditedCard writes only updatedData/originalData, never flat
    // score fields, so fall back through both shapes like the employee card.
    resolvePerformanceFields: function resolvePerformanceFields(card) {
      var original = card.originalData || {};
      var updated = card.updatedData || {};

      var pick = function pick(value) {
        for (var _len = arguments.length, fallbacks = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          fallbacks[_key - 1] = arguments[_key];
        }

        if (value !== null && value !== undefined) return value;
        return fallbacks.find(function (v) {
          return v !== null && v !== undefined;
        });
      };

      return {
        score: Number(pick(card.score, updated.score, original.score) || 0),
        reopenCount: Number(pick(card.reopenCount, updated.reopened, original.reopenCount) || 0),
        originalreopenCount: Number(pick(card.originalreopenCount, original.reopenCount) || 0),
        deadlineMissedCount: Number(pick(card.deadlineMissedCount, updated.deadlineMissedCount) || 0),
        status: card.status || updated.status || "approved"
      };
    },
    performanceRating: function performanceRating(pct) {
      if (pct >= 100) return { label: "Excellent", color: "#28a06a", badgeClass: "badge-excellent" };
      if (pct >= 80) return { label: "Good", color: "#2ec4a9", badgeClass: "badge-good" };
      if (pct >= 60) return { label: "Avg", color: "#5b85c3", badgeClass: "badge-avg" };
      if (pct >= 40) return { label: "Fair", color: "#e0a800", badgeClass: "badge-fair" };
      return { label: "Poor", color: "#e05c5c", badgeClass: "badge-poor" };
    },
    gradeLabelFor: function gradeLabelFor(emp) {
      if (!emp.grade) return "";
      var list = __WEBPACK_IMPORTED_MODULE_15__UserProfile_ProfileData__["b" /* designationGrades */][emp.designation] || [];
      var match = list.find(function (g) {
        return String(g.value) === String(emp.grade);
      });
      return match ? match.label : "Grade " + emp.grade;
    },


    // Builds the Upcoming panel from meetings and holidays across every
    // employee. Leave is deliberately excluded — it has its own card.
    fetchUpcomingEvents: function fetchUpcomingEvents() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _ref7, _ref8, meetingEvents, holidayEvents;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([_this10.buildMeetingEvents(), _this10.buildHolidayEvents()]);

              case 3:
                _ref7 = _context8.sent;
                _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);
                meetingEvents = _ref8[0];
                holidayEvents = _ref8[1];


                _this10.events = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(meetingEvents), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(holidayEvents)).sort(function (a, b) {
                  return a.sortDate - b.sortDate;
                }).slice(0, 8);
                _context8.next = 14;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](0);

                console.error("Error fetching upcoming events:", _context8.t0);
                _this10.events = [];

              case 14:
                _context8.prev = 14;

                _this10.loading.events = false;
                return _context8.finish(14);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[0, 10, 14, 17]]);
      }))();
    },


    // Scheduled increment / quarterly meetings. Unlike the employee version
    // this reads every active employee's record from allUsers, which already
    // carries nextIncrementMeetingDetails and nextQuarterlyMeetingDetails.
    buildMeetingEvents: function buildMeetingEvents() {
      var _this11 = this;

      var today = __WEBPACK_IMPORTED_MODULE_11_moment___default()().startOf("day");

      return this.activeEmployees.flatMap(function (emp) {
        return [emp.nextIncrementMeetingDetails, emp.nextQuarterlyMeetingDetails].filter(function (meeting) {
          return meeting && meeting.date;
        }).map(function (meeting) {
          var date = _this11.parseEventDate(meeting.date);
          if (!date) return null;

          var isIncrement = meeting.type === "increment";
          var time = "";
          if (meeting.time) {
            var parsed = __WEBPACK_IMPORTED_MODULE_11_moment___default()(meeting.time, "HH:mm");
            if (parsed.isValid()) time = parsed.format("h:mm A");
          }

          return {
            sortDate: date.valueOf(),
            day: date.format("DD"),
            month: date.format("MMM").toUpperCase(),
            title: meeting.title || (isIncrement ? emp.username + " \xB7 increment review" : emp.username + " \xB7 quarterly review"),
            desc: time ? "With manager \xB7 " + time : "With manager",
            tag: "Meeting",
            tagClass: "tag-meeting"
          };
        }).filter(Boolean);
      }).filter(function (item) {
        return item.sortDate >= today.valueOf();
      });
    },


    // Meeting dates are written from a date picker, but older records may hold
    // a locale string that moment cannot parse. Fall back to the same
    // D/M/YYYY parsing used for activity logs so an event is never silently
    // dropped.
    parseEventDate: function parseEventDate(value) {
      if (!value) return null;

      var locale = this.parseActivityTimestamp(value);
      if (locale && locale.isValid()) return locale.startOf("day");

      var parsed = __WEBPACK_IMPORTED_MODULE_11_moment___default()(value);
      return parsed.isValid() ? parsed.startOf("day") : null;
    },


    // Company holidays. Admins already see every shift's holidays, so no
    // per-user shift filtering here.
    buildHolidayEvents: function buildHolidayEvents() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var holidays, today, horizon;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 2:
                holidays = _context9.sent;
                today = __WEBPACK_IMPORTED_MODULE_11_moment___default()().startOf("day");

                // Recurring holidays roll forward a whole year at a time; without a
                // horizon they would flood the panel with future occurrences.

                horizon = __WEBPACK_IMPORTED_MODULE_11_moment___default()(today).endOf("month").add(1, "month").endOf("month");
                return _context9.abrupt("return", (Array.isArray(holidays) ? holidays : []).map(function (h) {
                  var base = __WEBPACK_IMPORTED_MODULE_11_moment___default()(h.dates);
                  if (!base.isValid()) return null;

                  var start = base;
                  if (h.isRecurring) {
                    while (start.isSameOrBefore(today, "day")) {
                      start = start.clone().add(1, "year");
                    }
                  }

                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, h, { start: start });
                }).filter(function (item) {
                  return item && item.start.isAfter(today, "day") && item.start.isSameOrBefore(horizon, "day");
                }).map(function (item) {
                  var shift = (item.shift || "").toLowerCase();
                  var scopeLabel = shift === "general" ? "Company-wide" : shift === "night" ? "Night shift" : "Morning shift";
                  var days = item.numberOfDays === 1 ? "1 day" : item.numberOfDays + " days";

                  return {
                    sortDate: item.start.valueOf(),
                    day: item.start.format("DD"),
                    month: item.start.format("MMM").toUpperCase(),
                    title: item.name,
                    desc: scopeLabel + " \xB7 " + days,
                    tag: "Holiday",
                    tagClass: "tag-holiday"
                  };
                }));

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },


    // Newest activity from the last 24 hours. Shares the timestamp parsing
    // above because adminActivities stores toLocaleString('en-PK') strings.
    fetchRecentActivity: function fetchRecentActivity() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var snapshot, recent;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("adminActivities").once("value");

              case 3:
                snapshot = _context10.sent;
                recent = [];

                snapshot.forEach(function (child) {
                  var record = child.val() || {};
                  var date = _this13.parseActivityTimestamp(record.timestamp);
                  if (!date || !date.isValid()) return;
                  recent.push({ id: child.key, record: record, date: date });
                });

                recent.sort(function (a, b) {
                  return b.date.valueOf() - a.date.valueOf();
                });

                _this13.activity = recent.slice(0, 4).map(function (_ref9) {
                  var id = _ref9.id,
                      record = _ref9.record,
                      date = _ref9.date;
                  return {
                    id: id,
                    text: record.activityName || record.activityTitle || "Activity",
                    time: _this13.relativeTime(date),
                    color: _this13.activityColor(record.action)
                  };
                });
                _context10.next = 14;
                break;

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](0);

                console.error("Error fetching recent activity:", _context10.t0);
                _this13.activity = [];

              case 14:
                _context10.prev = 14;

                _this13.loading.activity = false;
                return _context10.finish(14);

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[0, 10, 14, 17]]);
      }))();
    },
    relativeTime: function relativeTime(date) {
      var minutes = __WEBPACK_IMPORTED_MODULE_11_moment___default()().diff(date, "minutes");
      if (minutes < 1) return "Just now";
      if (minutes < 60) return minutes + " min ago";
      var hours = Math.floor(minutes / 60);
      if (hours < 24) return hours + " hr" + (hours > 1 ? "s" : "") + " ago";
      return date.format("D MMM, h:mm A");
    },
    activityColor: function activityColor(action) {
      var value = String(action || "").toLowerCase();
      if (value.includes("reject") || value.includes("delete") || value.includes("remove")) {
        return "#e05c5c";
      }
      if (value.includes("approve") || value.includes("add") || value.includes("creat")) {
        return "#28a06a";
      }
      if (value.includes("request") || value.includes("update") || value.includes("edit")) {
        return "#e0a800";
      }
      return "#2ec4a9";
    },


    // Per-day present/absent counts for the current week, restricted to the
    // company's configured working days so weekends don't read as absences.
    // An employee is counted present once per day regardless of how many
    // sessions they clocked. Absent = active headcount - present.
    fetchWeekAttendance: function fetchWeekAttendance() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var today, start, end, weekDays, workingSet, dayIndexes, shown, snapshot, activeIdSet, perDay, total;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                today = __WEBPACK_IMPORTED_MODULE_11_moment___default()();
                start = today.clone().startOf("isoWeek");
                end = start.clone().endOf("isoWeek");
                weekDays = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 7 }, function (_, i) {
                  return start.clone().add(i, "days");
                });
                workingSet = _this14.workingDayNames;
                dayIndexes = weekDays.map(function (day, index) {
                  return { index: index, name: day.format("dddd").toLowerCase() };
                }).filter(function (_ref10) {
                  var name = _ref10.name;
                  return !workingSet.size || workingSet.has(name);
                });
                shown = dayIndexes.length ? dayIndexes : weekDays.map(function (day, index) {
                  return { index: index, name: day.format("dddd").toLowerCase() };
                });
                _context11.next = 10;
                return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("timePeriod").orderByChild("timeIn").startAt(start.valueOf()).endAt(end.valueOf()).once("value");

              case 10:
                snapshot = _context11.sent;
                activeIdSet = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(_this14.activeEmployees.map(function (u) {
                  return u.uid;
                }).filter(Boolean));
                perDay = {};

                shown.forEach(function (_ref11) {
                  var index = _ref11.index;

                  perDay[index] = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a();
                });

                snapshot.forEach(function (child) {
                  var log = child.val() || {};
                  if (!activeIdSet.has(log.userId)) return;

                  var dayIndex = __WEBPACK_IMPORTED_MODULE_11_moment___default()(log.timeIn).diff(start, "days");
                  if (perDay[dayIndex]) {
                    perDay[dayIndex].add(log.userId);
                  }
                });

                total = _this14.totalActiveEmployees;

                _this14.attendance = shown.map(function (_ref12) {
                  var index = _ref12.index;

                  var day = weekDays[index];
                  var present = perDay[index].size;
                  return {
                    key: day.format("YYYY-MM-DD"),
                    day: day.format("ddd"),
                    date: day.format("D MMM"),
                    present: present,
                    absent: Math.max(0, total - present),
                    isToday: day.isSame(today, "day"),
                    isFuture: day.isAfter(today, "day")
                  };
                });
                _context11.next = 23;
                break;

              case 19:
                _context11.prev = 19;
                _context11.t0 = _context11["catch"](0);

                console.error("Error fetching weekly attendance:", _context11.t0);
                _this14.attendance = [];

              case 23:
                _context11.prev = 23;

                _this14.loading.attendance = false;
                return _context11.finish(23);

              case 26:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14, [[0, 19, 23, 26]]);
      }))();
    },


    // Scales against the week's peak day so the bars stay readable even when
    // the headcount is large or attendance is low.
    attendanceBarHeight: function attendanceBarHeight(value) {
      if (!this.attendanceMax || !value) return 0;
      var max = 76;
      return Math.max(3, Math.round(value / this.attendanceMax * max));
    },
    initials: function initials(name) {
      return (name || "").split(" ").filter(Boolean).slice(0, 2).map(function (part) {
        return part[0].toUpperCase();
      }).join("");
    },
    avatarStyle: function avatarStyle(index) {
      return this.avatarPalette[index % this.avatarPalette.length];
    },
    formatCurrency: function formatCurrency(amount) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PKR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Number(amount) || 0);
    },
    formatCompact: function formatCompact(amount) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PKR",
        notation: "compact",
        maximumFractionDigits: 1
      }).format(Number(amount) || 0);
    },
    openDecision: function openDecision(leave, status) {
      if (!leave || leave.busy) return;
      this.pendingDecision = {
        id: leave.id,
        status: status,
        comment: ""
      };
    },
    cancelDecision: function cancelDecision() {
      this.pendingDecision = null;
    },
    confirmDecision: function confirmDecision() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var decision, leave, comment;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                decision = _this15.pendingDecision;

                if (decision) {
                  _context12.next = 3;
                  break;
                }

                return _context12.abrupt("return");

              case 3:
                leave = _this15.leaveRequests.find(function (l) {
                  return l.id === decision.id;
                });

                if (leave) {
                  _context12.next = 7;
                  break;
                }

                _this15.pendingDecision = null;
                return _context12.abrupt("return");

              case 7:
                comment = (decision.comment || "").trim();
                _context12.next = 10;
                return _this15.updateLeave(leave, decision.status, comment);

              case 10:
                _this15.pendingDecision = null;

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },


    // Mirrors AdminLeaveManagement.submitAction so approving here keeps the
    // employee's leavesTaken balance in sync, and logs to Activity Logs.
    updateLeave: function updateLeave(leave, status, comment) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var source, employee, leavesTaken, days;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(!leave || !leave.id || leave.busy)) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return");

              case 2:
                _this16.busyLeaveIds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this16.busyLeaveIds), [leave.id]);

                source = _this16.allPendingLeaves.find(function (l) {
                  return l.id === leave.id;
                });

                if (source) {
                  _context13.next = 7;
                  break;
                }

                _this16.busyLeaveIds = _this16.busyLeaveIds.filter(function (id) {
                  return id !== leave.id;
                });
                return _context13.abrupt("return");

              case 7:
                _context13.prev = 7;

                if (!(source.userId === _this16.currentUser.uid)) {
                  _context13.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()("Error", "You cannot approve or reject your own leave.", "error");
                return _context13.abrupt("return");

              case 11:
                _context13.next = 13;
                return __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].getSingleUser(source.userId);

              case 13:
                employee = _context13.sent;
                leavesTaken = null;


                if (employee) {
                  leavesTaken = Number(employee.leavesTaken) || 0;
                  days = Number(source.noofdays) || 0;

                  if (source.status !== "Approved" && status === "Approved") {
                    leavesTaken = (leavesTaken + days).toFixed(1);
                  } else if (source.status === "Approved" && status === "Rejected") {
                    leavesTaken = (leavesTaken - days).toFixed(1);
                  }
                }

                _context13.next = 18;
                return __WEBPACK_IMPORTED_MODULE_14__assets_config_firebase__["a" /* default */].updateLeaveStatusAndComment(leave.id, status, source.userId, comment, leavesTaken);

              case 18:
                _context13.next = 20;
                return _this16.logLeaveDecision(source, status, employee, comment);

              case 20:
                __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()("Success", comment ? "Leave " + status.toLowerCase() + ". Comment saved." : "Leave " + status.toLowerCase() + ".", "success");
                _context13.next = 27;
                break;

              case 23:
                _context13.prev = 23;
                _context13.t0 = _context13["catch"](7);

                console.error("Error marking leave " + status.toLowerCase() + ":", _context13.t0);
                __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()("Error", "Could not " + status.toLowerCase() + " the leave request.", "error");

              case 27:
                _context13.prev = 27;

                _this16.busyLeaveIds = _this16.busyLeaveIds.filter(function (id) {
                  return id !== leave.id;
                });
                return _context13.finish(27);

              case 30:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this16, [[7, 23, 27, 30]]);
      }))();
    },
    logLeaveDecision: function logLeaveDecision(leave, status, employee, comment) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var name, email, start, end, dayText, range, title, description;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                name = leave.employee || employee && employee.username || "employee";
                email = employee && employee.email || "";
                start = leave.startDate || "";
                end = leave.endDate || start;
                dayText = leave.noofdays === 0.5 ? "half day" : leave.noofdays > 1 ? "days" : "day";
                range = leave.noofdays > 1 ? "from " + start + " to " + end : "for " + start;
                title = _this17.currentUser.username + " " + status.toLowerCase() + " " + name + "'s " + leave.type + " request " + range + " (" + leave.noofdays + " " + dayText + ")";
                description = _this17.currentUser.email + " " + status.toLowerCase() + " " + email + "'s " + leave.type + " request from " + start + " to " + end + " (" + leave.noofdays + " " + dayText + ").";
                _context14.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this17.currentUser,
                  title: title,
                  description: description,
                  reason: comment || null,
                  username: name,
                  type: "leaves",
                  uid: leave.userId
                }));

              case 11:
                _context14.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "leaves",
                  activityDescription: description,
                  activityName: title,
                  activityOnUser: leave.userId,
                  activityOnUserName: name,
                  activityByUserName: _this17.currentUser.username
                }, _this17.$store.state.auth, _this17.currentUser.uid);

              case 13:
                _context14.next = 18;
                break;

              case 15:
                _context14.prev = 15;
                _context14.t0 = _context14["catch"](0);

                console.error("Failed to log leave activity:", _context14.t0);

              case 18:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this17, [[0, 15]]);
      }))();
    },
    findEmployeeName: function findEmployeeName(uid) {
      var user = (this.$store.state.auth.allUsers || []).find(function (u) {
        return u.uid === uid;
      });
      return user && user.username || "Unknown User";
    },
    formatLeaveDates: function formatLeaveDates(leave) {
      var start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(leave.startDate);
      var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(leave.endDate || leave.startDate);
      if (!start.isValid()) return "-";
      if (!end.isValid() || end.isSame(start, "day")) return start.format("D MMM");
      return start.format("D MMM") + " \u2013 " + end.format("D MMM");
    }
  }
});

/***/ }),

/***/ "BbOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Dropdowns_SearchableDropdown_vue__ = __webpack_require__("KM+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_EmployeeDropdown_vue__ = __webpack_require__("gd4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeaveManagement_CardsSection_vue__ = __webpack_require__("mZEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tableColumns__ = __webpack_require__("kQVJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_loaders_DoubleLoader_vue__ = __webpack_require__("AxYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Adjustments__ = __webpack_require__("icvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TaxReportExport_vue__ = __webpack_require__("S0cN");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    SearchableDropdown: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Dropdowns_SearchableDropdown_vue__["a" /* default */],
    CardsSection: __WEBPACK_IMPORTED_MODULE_7__LeaveManagement_CardsSection_vue__["a" /* default */],
    EmployeeDropdown: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_EmployeeDropdown_vue__["a" /* default */],
    DoubleLoader: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_loaders_DoubleLoader_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_15_src_assets_icons_PencilIcon_js__["a" /* default */],
    Adjustments: __WEBPACK_IMPORTED_MODULE_16__Adjustments__["a" /* default */],
    TaxReportExport: __WEBPACK_IMPORTED_MODULE_17__TaxReportExport_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeTab: this.tabFromQuery(this.$route.query.tab) || 'payroll',
      isAdmin: this.$store.state.auth.user.role === "admin",
      columns: __WEBPACK_IMPORTED_MODULE_8__tableColumns__["a" /* MainTableColumns */],
      selectedEmployee: null,
      cards: [],
      employeeList: this.getCompanyEmployees(),
      filteredUsers: [], // Store filtered employees from EmployeeDropdown
      months: __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["a" /* monthNames */],
      years: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__assets_config_helpers__["t" /* generateYearsArray */])(),
      loading: false,
      isSelectLoading: false,
      constants: this.$store.state.auth.constants || {},
      taxSlabs: {},
      holidaysList: [],
      tableFilterLoading: false
    };
  },

  computed: {
    selectedMonth: function selectedMonth() {
      var currentDate = new Date();
      var currentMonth = currentDate.toLocaleString('default', { month: 'long' });
      return this.$store.state.payroll.selectedMonth || currentMonth;
    },
    selectedYear: function selectedYear() {
      return this.$store.state.payroll.selectedYear || new Date().getFullYear();
    },
    payrollData: function payrollData() {
      return this.$store.state.payroll.payrollData || [];
    },
    filteredPayrollData: function filteredPayrollData() {
      var _this = this;

      var selectedEmployee = this.selectedEmployee,
          selectedMonth = this.selectedMonth,
          selectedYear = this.selectedYear,
          filteredUsers = this.filteredUsers;


      this.tableFilterLoading = true;
      try {
        var filteredPayroll = this.payrollData.filter(function (payroll) {
          if (payroll.isSuperAdmin) return false;
          if (payroll.joiningDate) {
            var joiningDate = new Date(payroll.joiningDate);
            var joiningYear = joiningDate.getFullYear();
            var joiningMonth = joiningDate.getMonth(); // 0–11
            // Convert selected month (name) to month index
            var selectedDate = new Date(selectedMonth + " 1, " + selectedYear);
            var selectedYearNum = selectedDate.getFullYear();
            var selectedMonthNum = selectedDate.getMonth();
            // Check if selected month/year >= joining month/year
            if (selectedYearNum < joiningYear || selectedYearNum === joiningYear && selectedMonthNum < joiningMonth) {
              return false;
            }
          }
          var employeeMatch = !selectedEmployee || payroll.employeeId === selectedEmployee.uid;
          var monthMatch = !selectedMonth || payroll.month === selectedMonth;
          var yearMatch = !selectedYear || Number(payroll.year) === Number(selectedYear);
          // Filter by UIDs in filteredUsers (from EmployeeDropdown)
          var userMatch = filteredUsers.length === 0 || filteredUsers.some(function (user) {
            return user.uid === payroll.employeeId;
          });
          return employeeMatch && monthMatch && yearMatch && userMatch;
        }).map(function (payroll) {
          if (payroll.status === "Pending") {
            var updatedLeavesData = _this.updateLeavesData(payroll, payroll.month);
            var updatedTaxDeduction = _this.taxDeduction(payroll);
            var newAbsents = Math.max(0, payroll.requiredWorkingDays - payroll.daysWorked - payroll.obtainedLeaves.split(" / ")[0]);
            var finalAmount = _this.finalAmountUpdate(payroll, updatedTaxDeduction, updatedLeavesData);
            var lateDeduction = _this.calculateLateDeduction(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, payroll, { leavesQuota: updatedLeavesData.leavesQuota })).lateDeduction.toString();
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, payroll, updatedLeavesData, {
              absents: newAbsents,
              taxDeduction: updatedTaxDeduction,
              finalAmount: finalAmount,
              lateDeduction: lateDeduction
            });
          } else {
            var _updatedLeavesData = _this.updateLeavesData(payroll, payroll.month);
            var _lateDeduction = _this.calculateLateDeduction(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, payroll, { leavesQuota: _updatedLeavesData.leavesQuota })).lateDeduction.toString();
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, payroll, {
              lateDeduction: _lateDeduction
            });
          }
        });
        return filteredPayroll;
      } catch (error) {
        console.error("Error filtering payroll data:", error);
        return [];
      } finally {
        this.tableFilterLoading = false;
      }
    },
    isSearchDisabled: function isSearchDisabled() {
      return !this.selectedEmployee || !this.selectedMonth || !this.selectedYear;
    },
    isEmployeeSearchHidden: function isEmployeeSearchHidden() {
      return !this.isAdmin;
    },
    monthItems: function monthItems() {
      var months = this.months || __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["a" /* monthNames */];
      return months.map(function (month) {
        return { name: month };
      });
    },
    yearItems: function yearItems() {
      var years = this.years || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__assets_config_helpers__["t" /* generateYearsArray */])();
      return years.map(function (year) {
        return { name: year };
      });
    },
    isLoading: function isLoading() {
      return this.$store.state.payroll.loading;
    },
    noPayrollFound: function noPayrollFound() {
      var hasPayrollId = this.employee && this.employee.payrollId && true;
      var isNotAdmin = !this.isAdmin;

      return !hasPayrollId && isNotAdmin;
    }
  },
  watch: {
    // e.g. clicking an expense notification while already on this page
    '$route.query.tab': function $routeQueryTab(tab) {
      var target = this.tabFromQuery(tab);
      if (target) this.switchTab(target);
    },
    selectedMonth: function selectedMonth() {
      this.fetchPayrollData();
    },
    selectedYear: function selectedYear() {
      this.fetchPayrollData();
    },
    selectedEmployee: function selectedEmployee(newValue) {
      if (newValue) {
        this.fetchPayrollData();
      }
    },
    filteredUsers: function filteredUsers(newValue) {
      var _this2 = this;

      // Reset selectedEmployee and refresh table when filteredUsers changes
      if (newValue.length > 0 && this.selectedEmployee && !newValue.some(function (user) {
        return user.uid === _this2.selectedEmployee.uid;
      })) {
        this.selectedEmployee = null;
        this.fetchPayrollData(); // Refresh table to reflect new filteredUsers
      } else if (!this.selectedEmployee) {
        this.fetchPayrollData(); // Refresh table when no employee is selected
      }
    },

    payrollData: {
      handler: function handler() {
        this.updateCards();
      },

      deep: true
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var company;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              company = _this3.$store.state.auth.company;
              _context.prev = 1;

              if (__WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.apps.length) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_11__assets_config_firebase__["a" /* default */].configureFirebase(company.firebase);

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              console.error("Firebase initialization error:", _context.t0.message);

            case 10:
              _context.next = 12;
              return _this3.fetchPayrollData();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3, [[1, 7]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanupFirebaseListeners();
  },

  methods: {
    calculateLateDeduction: function calculateLateDeduction(payrollData) {
      var lateArrivals = payrollData.lateArrivals || 0;
      var remainingLeaves = Math.floor(payrollData.leavesQuota.remainingLeaves) || 0;

      var lateDeduction = Math.floor(lateArrivals / 5);

      var adjustableFromLeaves = Math.min(2, remainingLeaves, lateDeduction);

      lateDeduction -= adjustableFromLeaves;

      if (payrollData.status !== "Pending") {
        lateDeduction = payrollData.lateDeductionDays ? Number(payrollData.lateDeductionDays) : 0;
      }

      return {
        lateDeduction: lateDeduction,
        adjustedFromLeaves: adjustableFromLeaves
      };
    },
    finalAmountUpdate: function finalAmountUpdate(selectedEmployee, updatedTaxDeduction, updatedLeavesData) {
      var leavesEncashmentDays = Number(Math.round(updatedLeavesData.leavesQuota.leavesEncashmentDays) || 0);

      var finalAmount = selectedEmployee.bonus - (Number(updatedTaxDeduction) || 0);

      var leavesEncashment = (selectedEmployee.perDaySalary * (Number(selectedEmployee.obtainedLeaves.split(" / ")[0]) + leavesEncashmentDays)).toFixed(2);

      var daysWorkedAmount = (selectedEmployee.perDaySalary * selectedEmployee.daysWorked).toFixed(2);

      finalAmount = finalAmount + Number(daysWorkedAmount) + Number(leavesEncashment);

      return Math.round(finalAmount);
    },
    formatPublicHolidays: function formatPublicHolidays(selectedEmployee) {
      var holidays = this.holidaysList || [];
      var shift = (selectedEmployee.shift || "Morning").toLowerCase();
      var year = Number(selectedEmployee.year);
      var monthName = (selectedEmployee.month || "").toLowerCase();
      var workingDays = [];
      if (selectedEmployee && Array.isArray(selectedEmployee.workingDays) && selectedEmployee.workingDays.length) {
        workingDays = selectedEmployee.workingDays.map(function (d) {
          return d.toLowerCase();
        });
      } else {
        workingDays = ["monday", "tuesday", "wednesday", "thursday", "friday"];
      }
      var formattedList = [];
      holidays.forEach(function (h) {
        var baseDate = new Date(h.dates);
        var isRecurring = !!h.isRecurring;
        var count = h.numberOfDays || 1;
        var hShift = (h.shift || "general").toLowerCase();
        if (!(shift === "general" || hShift === "general" || hShift === shift)) {
          return;
        }
        var startDate = new Date(isRecurring ? year : baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
        for (var i = 0; i < count; i++) {
          var d = new Date(startDate);
          d.setDate(startDate.getDate() + i);
          var dayName = d.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
          if (!workingDays.includes(dayName)) continue;
          var dMonthName = d.toLocaleString("default", { month: "long" }).toLowerCase();
          if (monthName && dMonthName !== monthName) continue;
          var dd = ("0" + d.getDate()).slice(-2);
          var mm = ("0" + (d.getMonth() + 1)).slice(-2);
          var yyyy = d.getFullYear();
          formattedList.push({
            text: dd + "-" + mm + "-" + yyyy + ": " + h.name,
            dateObj: d
          });
        }
      });
      formattedList.sort(function (a, b) {
        return a.dateObj - b.dateObj;
      });
      return formattedList.map(function (i) {
        return i.text;
      });
    },
    fetchHolidayData: function fetchHolidayData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    taxDeduction: function taxDeduction(employee) {
      var availableYears = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.taxSlabs).map(Number).sort(function (a, b) {
        return b - a;
      });
      var selectedYear = availableYears.includes(Number(employee.year)) ? Number(employee.year) : availableYears[0] || 2025;
      var slabs = this.taxSlabs[selectedYear] || {};
      var annualSalary = ((employee.basicSalary || 0) + (employee.extraAllowance || 0)) * 12;
      var medicalExemption = annualSalary * 0.065;
      var taxableSalary = annualSalary - medicalExemption;
      var annualTax = 0;
      var thresholds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(slabs).map(Number).sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < thresholds.length; i++) {
        var threshold = thresholds[i];
        var slab = slabs[threshold];
        var nextThreshold = thresholds[i + 1] || Infinity;
        if (taxableSalary >= threshold && taxableSalary < nextThreshold) {
          annualTax = slab.fixed + (taxableSalary - threshold) * (slab.percentage / 100);
          break;
        }
      }
      var monthlyTax = annualTax / 12;
      this.taxDeductionInput = monthlyTax.toFixed(1);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__assets_config_helpers__["j" /* stripeLeadingZero */])(monthlyTax.toFixed(1));
    },
    calculateJuneLeaveQuota: function calculateJuneLeaveQuota(selectedEmployee) {
      var emp = selectedEmployee;
      var leavesAllowed = Number(emp.leavesAllowed || 0);
      var leavesTaken = Number(emp.DBLeavesTaken || 0);
      var leavesAvailable = Number(emp.leavesAvailable || 0);
      var remainingLeaves = leavesAllowed - leavesTaken;
      var newAllowedLeaves = leavesAvailable - leavesAllowed + remainingLeaves;
      var updatedLeaves = newAllowedLeaves;
      return updatedLeaves;
    },
    calculateJuneCarryForward: function calculateJuneCarryForward(selectedEmployee, selectedMonth) {
      if (selectedMonth !== "June") return 0;
      var emp = selectedEmployee;
      var remaininingAllowedLeaves = Number(emp.leavesAllowed || 0) - Number(emp.DBLeavesTaken || 0);
      return remaininingAllowedLeaves;
    },
    calculateEncashment: function calculateEncashment(remainingLeaves, selectedMonth) {
      if (selectedMonth !== "December") return 0;
      var remaining = Math.min(Math.floor(remainingLeaves), 5);
      var encashmentValue = __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["l" /* leaveEncashmentDecRule */][remaining] || 0;
      var leavesEncashmentDays = encashmentValue;
      var annualLeavesEncashmentDays = encashmentValue;
      return { encashmentValue: encashmentValue, leavesEncashmentDays: leavesEncashmentDays, annualLeavesEncashmentDays: annualLeavesEncashmentDays };
    },
    calculateDecCarryForward: function calculateDecCarryForward(remainingLeaves, selectedMonth) {
      if (selectedMonth !== "December") return 0;
      var remaining = Math.min(Math.floor(remainingLeaves), 5);
      return __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["k" /* leavesCarryForwardDecRule */][remaining] || 0;
    },
    calculateUpdatedLeaveQuota: function calculateUpdatedLeaveQuota(selectedEmployee, updatedLeaveQuota, carryForwardDays, remainingLeaves, selectedMonth) {
      if (selectedMonth === "December") {
        return Number(this.constants.leavesAvailable || 0) + carryForwardDays;
      }
      if (selectedMonth === "June") {
        return Number(remainingLeaves) + Number(selectedEmployee.leavesAvailable) / 2;
      }
      return updatedLeaveQuota;
    },
    updateLeavesData: function updateLeavesData(selectedEmployee, selectedMonth) {
      if (!selectedEmployee) return {};
      var leavesQuota = selectedEmployee.leavesQuota || {};
      var remainingLeaves = Number(selectedEmployee.leavesAllowed) - Number(selectedEmployee.DBLeavesTaken) - Number(selectedEmployee.leavesDeductionDays) || 0;
      remainingLeaves = Math.max(0, remainingLeaves);
      var perDaySalary = selectedEmployee.perDaySalary || 0;
      var carryForwardDays = leavesQuota.carryForwardDays || 0;
      var updatedLeaveQuota = leavesQuota.updatedLeaveQuota || 0;
      var leavesEncashmentDays = leavesQuota.leavesEncashmentDays || 0;
      var annualLeavesEncashmentDays = leavesQuota.annualLeavesEncashmentDays || 0;
      if (selectedMonth === "June") {
        updatedLeaveQuota = Number(this.calculateJuneLeaveQuota(selectedEmployee) || leavesQuota.updatedLeaveQuota) || 0;
        carryForwardDays = this.calculateJuneCarryForward(selectedEmployee, selectedMonth) || leavesQuota.carryForwardDays || 0;
      } else if (selectedMonth === "December") {
        var calculatedEncashment = this.calculateEncashment(remainingLeaves, selectedMonth).encashmentValue || leavesQuota.leavesEncashmentDays || 0;
        carryForwardDays = this.calculateDecCarryForward(remainingLeaves, selectedMonth) || leavesQuota.carryForwardDays || 0;
        calculatedEncashment = this.calculateEncashment(remainingLeaves, selectedMonth).encashmentValue;
        leavesEncashmentDays = calculatedEncashment;
        annualLeavesEncashmentDays = calculatedEncashment;
        updatedLeaveQuota = Number(this.calculateUpdatedLeaveQuota(selectedEmployee, updatedLeaveQuota, carryForwardDays, remainingLeaves, selectedMonth) || leavesQuota.updatedLeaveQuota) || 0;
      }
      return {
        perDaySalary: perDaySalary,
        annualLeavesEncashmentDays: annualLeavesEncashmentDays,
        leavesQuota: { carryForwardDays: carryForwardDays, leavesEncashmentDays: leavesEncashmentDays, remainingLeaves: remainingLeaves, updatedLeaveQuota: updatedLeaveQuota }
      };
    },
    getCompanyEmployees: function getCompanyEmployees() {
      var companyUserIds = this.$store.state.auth.company.users.map(function (user) {
        return user.uid;
      });
      return this.$store.state.auth.allUsers.filter(function (user) {
        return companyUserIds.includes(user.uid);
      });
    },
    updateCards: function updateCards() {
      var totalTax = 0;
      var totalSalary = 0;
      var processed = 0;
      var totalEmp = 0;

      this.filteredPayrollData.map(function (item) {
        totalSalary += +item.finalAmount || 0;
        totalTax += +item.taxDeduction || 0;
        processed += item.status === "Processed";
        totalEmp += 1;
      });

      this.cards = [{ value: totalEmp, label: "Total Employees", color: "#00aaff" }, { value: processed, label: "Processed", color: "green" }, { value: Math.round(totalSalary), label: "Total Salaries", color: "orange" }, { value: Math.round(totalTax), label: "Total Taxes", color: "#00c7c7" }];
    },
    fetchPayrollData: function fetchPayrollData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var router;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.loading = true;
                _context3.prev = 1;

                // Non-admins are redirected to their processed payroll; don't pull them off the expenses tab
                router = {
                  push: function push(location) {
                    if (_this5.activeTab === 'payroll') _this5.$router.push(location);
                  }
                };
                _context3.next = 5;
                return _this5.$store.dispatch('fetchPayrollRealTime', { router: router });

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);

                console.error("Error fetching payroll data:", _context3.t0);

              case 10:
                _context3.prev = 10;

                _this5.loading = false;
                _this5.updateCards();
                return _context3.finish(10);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 7, 10, 14]]);
      }))();
    },
    cleanupFirebaseListeners: function cleanupFirebaseListeners() {
      var selectedYear = this.selectedYear || new Date().getFullYear();
      var selectedMonth = this.selectedMonth || __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["a" /* monthNames */][new Date().getMonth()];
      var payrollRef = __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.database().ref("payroll/" + selectedYear + "/" + selectedMonth);
      payrollRef.off();
    },
    tabFromQuery: function tabFromQuery(tab) {
      return tab === 'expenses' || tab === 'adjustments' ? 'adjustments' : tab === 'payroll' ? 'payroll' : null;
    },
    switchTab: function switchTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      // Re-run the non-admin redirect check that was skipped while on the expenses tab
      if (tab === 'payroll' && !this.isAdmin) this.fetchPayrollData();
    },
    selectEmployee: function selectEmployee(employee) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.selectedEmployee = employee;
                _context4.next = 3;
                return _this6.fetchPayrollData();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    selectMonth: function selectMonth(month) {
      this.$store.commit("setSelectedMonth", month ? month.name : "");
    },
    selectYear: function selectYear(year) {
      this.$store.commit("setSelectedYear", year ? year.name : "");
    },
    viewDetails: function viewDetails(item) {
      this.$store.commit("setSelectedEmployeePayroll", item);
      this.$router.push({
        name: "Payroll Details",
        params: {
          employeeId: item.employeeId,
          employee: item
        }
      });
    },


    // UI Helper Methods
    getStatusClass: function getStatusClass(status) {
      return {
        'payroll-table-status-processed': status === 'Processed',
        'payroll-table-status-draft': status === 'Draft',
        'payroll-table-status-pending': status !== 'Processed' && status !== 'Draft'
      };
    },
    getLeavesTaken: function getLeavesTaken(item) {
      var parts = (item.obtainedLeaves || '0 / 0').split(' / ');
      return parts[0] || 0;
    },
    getLateDeductionTooltip: function getLateDeductionTooltip(item) {
      var parts = (item.lateDeduction || '0 - 0').split(' - ');
      return "Late Deduction Days: " + (parts[1] || 0);
    },
    formatLateDeduction: function formatLateDeduction(item) {
      var parts = (item.lateDeduction || '0 - 0').split(' - ');
      return (parseFloat(parts[0]) || 0).toFixed(2);
    },
    getLeavesTooltip: function getLeavesTooltip(item) {
      var parts = (item.obtainedLeaves || '0 / 0').split(' / ');
      return "Remaining Leaves: " + Number(parts[1] || 0);
    },
    exportToExcel: function exportToExcel() {
      var _this7 = this;

      if (!this.isAdmin || !this.filteredPayrollData.length) return;

      var payrollArray = this.filteredPayrollData.map(function (item) {
        return {
          "Employee ID": item.employeeId || "N/A",
          "Employee Name": item.employeeName || "Unknown",
          "Basic Salary": item.basicSalary || 0,
          "Extra Allowance": item.extraAllowance || 0,
          "Total Working Days": item.workingDays || 22,
          "Days Worked": item.daysWorked || 0,
          "Leaves Taken": item.leavesTaken || 0,
          "Absents": item.absents || 0,
          "Late Arrivals": item.lateArrivals || 0,
          "Leave Balance": item.leaveBalance || 0,
          "Per Day Salary": item.perDaySalary || 0,
          "Late Deduction": item.lateDeduction || 0,
          "Extra Amount Adjustment": item.extraAmountAdjustment || 0,
          "Extra Amount Adjustment Note": item.extraAmountAdjustmentNote || "N/A",
          "Leave Deduction Note": item.extraAmountAdjustmentNote || "N/A",
          "Leave Deduction Days": item.leavesDeductionDays || "N/A",
          "Bonus": item.bonus || 0,
          "Transaction Fees": item.transactionFees || 0,
          "Leaves Encashment": item.leavesEncashment || 0,
          "Month": item.month || _this7.selectedMonth,
          "Year": item.year || _this7.selectedYear,
          "Status": item.status || "Pending",
          "Final Amount": item.finalAmount || 0
        };
      });

      var worksheet = XLSX.utils.json_to_sheet(payrollArray);
      var workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll Data");

      var fileName = "Payroll_" + this.selectedMonth + "_" + this.selectedYear + ".xlsx";
      XLSX.writeFile(workbook, fileName);
    },
    fetchTaxSlabs: function fetchTaxSlabs() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__assets_config_firebase__["a" /* default */].fetchTaxSlabs();

              case 2:
                _this8.taxSlabs = _context5.sent;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this9.fetchTaxSlabs();
              _context6.next = 3;
              return _this9.fetchHolidayData();

            case 3:
              _this9.holidaysList = _context6.sent;

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this9);
    }))();
  }
});

/***/ }),

/***/ "BgjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlackIntegration_vue__ = __webpack_require__("sHQS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df8ab90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlackIntegration_vue__ = __webpack_require__("EHkY");
function injectStyle (ssrContext) {
  __webpack_require__("2y6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1df8ab90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlackIntegration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df8ab90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlackIntegration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BjXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SLACK_CONFIG_PATH */
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidSlackWebhook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSlackConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saveSlackConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeSlackConfig; });
/* harmony export (immutable) */ __webpack_exports__["d"] = postToSlack;
/* unused harmony export formatActivityForSlack */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notifySlackOfActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_database__ = __webpack_require__("hZls");








// Per-tenant Slack settings live in the tenant's own database
var SLACK_CONFIG_PATH = 'integrations/slack';
var SLACK_WEBHOOK_PATTERN = /^https:\/\/hooks\.slack\.com\/services\/\S+$/;

function isValidSlackWebhook(url) {
  return SLACK_WEBHOOK_PATTERN.test(url || '');
}

var getSlackConfig = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
    var snapshot;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.database().ref(SLACK_CONFIG_PATH).once('value');

          case 2:
            snapshot = _context.sent;
            return _context.abrupt('return', snapshot.val() || {});

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSlackConfig() {
    return _ref.apply(this, arguments);
  };
}();

var saveSlackConfig = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(config) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.database().ref(SLACK_CONFIG_PATH).set(config);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function saveSlackConfig(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var removeSlackConfig = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.database().ref(SLACK_CONFIG_PATH).remove();

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function removeSlackConfig() {
    return _ref3.apply(this, arguments);
  };
}();

// Slack webhooks don't send CORS headers, so post as a "simple" form request.
// The response is opaque: a resolved promise means the request was sent, not that Slack accepted it.
function postToSlack(webhookUrl, message) {
  var body = new URLSearchParams({ payload: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(message) });
  return fetch(webhookUrl, { method: 'POST', mode: 'no-cors', body: body });
}

function truncate(text) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2900;

  return text.length > max ? text.slice(0, max) + '\u2026' : text;
}

function formatActivityForSlack(data) {
  var fields = [['By', data.actionUsername || data.activityByUserName], ['Affected user', data.activityOnUserName], ['Type', data.type], ['Time', data.timestamp]].filter(function (_ref4) {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
        value = _ref5[1];

    return value;
  }).map(function (_ref6) {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
        label = _ref7[0],
        value = _ref7[1];

    return { type: 'mrkdwn', text: '*' + label + '*\n' + value };
  });

  var blocks = [{ type: 'header', text: { type: 'plain_text', text: truncate(data.activityName || 'Activity', 150) } }];
  if (data.activityDescription) {
    blocks.push({ type: 'section', text: { type: 'mrkdwn', text: truncate(data.activityDescription) } });
  }
  if (fields.length) {
    blocks.push({ type: 'section', fields: fields });
  }
  if (data.changes) {
    blocks.push({ type: 'section', text: { type: 'mrkdwn', text: truncate('*Changes*\n```' + data.changes + '```') } });
  }
  if (data.change) {
    var lines = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(data.change).map(function (_ref8) {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
          key = _ref9[0],
          value = _ref9[1];

      return '\u2022 *' + key + '*: ' + value;
    }).join('\n');
    blocks.push({ type: 'section', text: { type: 'mrkdwn', text: truncate('*Change*\n' + lines) } });
  }
  if (data.reason) {
    blocks.push({ type: 'section', text: { type: 'mrkdwn', text: truncate('*Reason*\n' + data.reason) } });
  }
  if (data.attendees) {
    blocks.push({ type: 'section', text: { type: 'mrkdwn', text: truncate('*Attendees*\n' + data.attendees) } });
  }
  var context = [data.osName, data.map ? '<' + data.map + '|View location>' : null].filter(Boolean);
  if (context.length) {
    blocks.push({ type: 'context', elements: [{ type: 'mrkdwn', text: context.join('  •  ') }] });
  }

  return { text: data.activityName || 'New activity', blocks: blocks };
}

// Never throws: a Slack problem must not block the action being logged
var notifySlackOfActivity = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(activityData) {
    var config;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return getSlackConfig();

          case 3:
            config = _context4.sent;

            if (!(!config.enabled || !isValidSlackWebhook(config.webhookUrl))) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt('return');

          case 6:
            _context4.next = 8;
            return postToSlack(config.webhookUrl, formatActivityForSlack(activityData));

          case 8:
            _context4.next = 13;
            break;

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4['catch'](0);

            console.warn('Slack notification failed:', _context4.t0);

          case 13:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[0, 10]]);
  }));

  return function notifySlackOfActivity(_x3) {
    return _ref10.apply(this, arguments);
  };
}();

/***/ }),

/***/ "Bt9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_AdminActivities_AdminActivities_vue__ = __webpack_require__("jp4O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__("wtEF");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AdminActivities: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_AdminActivities_AdminActivities_vue__["a" /* default */]
  },
  computed: {
    isAdmin: function isAdmin() {
      var user = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.auth.user;
      return user && user.role === "admin";
    }
  },
  mounted: function mounted() {
    if (!this.isAdmin) {
      this.$router.push("/overview");
    }
  },

  methods: {
    refreshFiles: function refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "CF5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_genralSpecificSettings__ = __webpack_require__("TvP8");












var _this11 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EmployeeDashboard',
  data: function data() {
    return {
      currentUser: this.$store.state.auth.user,
      checkIn: { checkedIn: false, time: null },
      stats: [{
        label: 'ANNUAL LEAVES LEFT',
        value: '14',
        sub: 'of 21 total',
        color: '#1a1a1a',
        progress: 67,
        barColor: '#2ec4a9'
      }, {
        label: 'PENDING LEAVE',
        value: '1',
        sub: 'awaiting approval',
        color: '#e0a800',
        progress: 20,
        barColor: '#e0a800'
      }, {
        label: 'PERFORMANCE',
        value: '--',
        sub: 'no data',
        color: '#1a1a1a',
        progress: 0,
        barColor: '#2ec4a9'
      }, {
        label: 'HOURS THIS WEEK',
        value: '18h',
        sub: 'of 40h target',
        color: '#1a1a1a',
        progress: 45,
        barColor: '#2ec4a9'
      }],
      performance: [],
      events: [],
      payslips: [],
      loading: {
        stats: true,
        performance: true,
        events: true,
        payslips: true
      },
      holidayList: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee() {
      var weekHours;
      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTodayCheckIn(_this.$store.state.auth.user.uid);

            case 2:
              _this.checkIn = _context.sent;


              _this.stats[0].value = _this.$store.state.auth.user.leavesAvailable - Number(_this.$store.state.auth.user.leavesTaken);
              _this.stats[0].sub = "of " + _this.$store.state.auth.user.leavesAvailable + " total";
              _this.stats[0].progress = (_this.$store.state.auth.user.leavesAvailable - Number(_this.$store.state.auth.user.leavesTaken)) / _this.$store.state.auth.user.leavesAvailable * 100;

              _this.stats[1].value = _this.$store.state.auth.userLeaves.filter(function (leave) {
                return leave.status.toLowerCase() === 'pending';
              }).length || 0;
              _this.stats[1].progress = _this.stats[1].value / _this.$store.state.auth.user.leavesAvailable * 100;

              _this.loading.stats = false;

              // Each section resolves its own flag so a slow query in one card does not
              // hold back the others.
              _this.loadSection('events', _this.fetchUpcomingEvents());
              _this.loadSection('performance', _this.fetchPerformanceData());
              _this.loadSection('payslips', _this.fetchRecentPayslips());

              _context.next = 14;
              return _this.getUserCurrentWeekHours(_this.$store.state.auth.user.uid);

            case 14:
              weekHours = _context.sent;

              _this.stats[3].value = weekHours.spentHours + "h";
              _this.stats[3].sub = "of " + weekHours.totalRequiredHours + "h target";
              _this.stats[3].progress = weekHours.spentDecimal / weekHours.totalRequiredHours * 100;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    // Tracks one card's loading state, always clearing it even on failure so a
    // failed query leaves an empty card rather than a permanent skeleton.
    loadSection: function loadSection(key, promise) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return promise;

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                console.error("Error loading " + key + ":", _context2.t0);

              case 8:
                _context2.prev = 8;

                _this2.loading[key] = false;
                return _context2.finish(8);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5, 8, 11]]);
      }))();
    },


    // Payroll lives at payroll/{year}/{month}/{pushKey}. The employee query is
    // scoped with orderByChild('employeeId').equalTo(uid), matching the payroll
    // store, so this can only ever return the signed-in user's own records.
    fetchRecentPayslips: function fetchRecentPayslips() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var user, now, results, _loop, back, _ret;

        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                user = _this3.$store.state.auth.user;

                if (!(!user || !user.uid)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                now = new Date();
                results = [];

                // Walk back month by month until 6 processed payslips are collected.

                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _loop(back) {
                  var date, year, month, snapshot, records;
                  return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          date = new Date(now.getFullYear(), now.getMonth() - back, 1);
                          year = date.getFullYear();
                          month = __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('MMMM');
                          _context3.prev = 3;
                          _context3.next = 6;
                          return __WEBPACK_IMPORTED_MODULE_11_firebase_app___default.a.database().ref("payroll/" + year + "/" + month).orderByChild('employeeId').equalTo(user.uid).once('value');

                        case 6:
                          snapshot = _context3.sent;
                          records = snapshot.val();

                          if (records) {
                            _context3.next = 10;
                            break;
                          }

                          return _context3.abrupt("return", "continue");

                        case 10:

                          __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(records).forEach(function (key) {
                            var record = records[key];
                            if (!record || record.status !== 'Processed') return;

                            results.push({
                              key: record.payrollId || key,
                              month: (record.month || month) + " " + (record.year || year),
                              amount: new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'PKR',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                              }).format(Number(record.finalAmount) || 0),
                              // Declared up front so the per-row spinner is reactive in Vue 2.
                              downloading: false,
                              record: record
                            });
                          });
                          _context3.next = 16;
                          break;

                        case 13:
                          _context3.prev = 13;
                          _context3.t0 = _context3["catch"](3);

                          console.error("Error fetching payroll for " + month + " " + year + ":", _context3.t0);

                        case 16:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _loop, _this3, [[3, 13]]);
                });
                back = 0;

              case 7:
                if (!(back < 24 && results.length < 6)) {
                  _context4.next = 15;
                  break;
                }

                return _context4.delegateYield(_loop(back), "t0", 9);

              case 9:
                _ret = _context4.t0;

                if (!(_ret === "continue")) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("continue", 12);

              case 12:
                back++;
                _context4.next = 7;
                break;

              case 15:

                results.sort(function (a, b) {
                  var aDate = new Date(a.record.year, __WEBPACK_IMPORTED_MODULE_13_moment___default()(a.record.month, 'MMMM').month());
                  var bDate = new Date(b.record.year, __WEBPACK_IMPORTED_MODULE_13_moment___default()(b.record.month, 'MMMM').month());
                  return bDate - aDate;
                });

                _this3.payslips = results.slice(0, 6);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },


    // Mirrors SalaryCalculation's handleDownloadClick: hand the record to the
    // payslip route through localStorage and open it in a new tab. The PDF is
    // generated there because html2canvas cannot capture a hidden element.
    // The storage key is suffixed with the payroll id so downloading a second
    // month cannot overwrite a payslip a previous tab has not read yet.
    downloadPayslip: function downloadPayslip(slip) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var payslipKey, storageKey, payslipUrl;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!slip || slip.downloading)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                payslipKey = slip.record.employeeId + "_" + slip.key;
                storageKey = "payslipData_" + payslipKey;

                slip.downloading = true;

                try {
                  localStorage.setItem(storageKey, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()({
                    employee: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, slip.record, {
                      leavesQuota: slip.record.leavesQuota || { leavesEncashmentDays: 0 }
                    }),
                    salaryData: {
                      totalDaysSalary: Number(slip.record.perDaySalary) * Number(slip.record.daysWorked)
                    }
                  }));

                  payslipUrl = window.location.origin + "/#/payroll/payslip/" + payslipKey;

                  window.open(payslipUrl, '_blank');
                } catch (e) {
                  console.error('Error downloading payslip:', e);
                  __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Could not generate the payslip PDF.', 'error');
                  localStorage.removeItem(storageKey);
                } finally {
                  // The payslip tab clears its own key; release ours on navigate away.
                  _this4.$once('hook:beforeDestroy', function () {
                    localStorage.removeItem(storageKey);
                  });
                  setTimeout(function () {
                    slip.downloading = false;
                  }, 1500);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },


    // Builds the Upcoming panel from all three sources (leaves, meetings,
    // holidays) and keeps the whole list sorted by date.
    fetchUpcomingEvents: function fetchUpcomingEvents() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref, _ref2, leaveEvents, meetingEvents, holidayEvents;

        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([_this5.buildLeaveEvents(), _this5.buildMeetingEvents(), _this5.buildHolidayEvents()]);

              case 2:
                _ref = _context6.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                leaveEvents = _ref2[0];
                meetingEvents = _ref2[1];
                holidayEvents = _ref2[2];


                _this5.events = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(leaveEvents), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(meetingEvents), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(holidayEvents)).sort(function (a, b) {
                  return a.sortDate - b.sortDate;
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    buildLeaveEvents: function buildLeaveEvents() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      return (this.$store.state.auth.userLeaves || []).filter(function (leave) {
        return ['Approved', 'Pending'].includes(leave.status);
      }).map(function (leave) {
        var start = new Date(leave.startDate);
        if (isNaN(start)) return null;
        start.setHours(0, 0, 0, 0);

        return { start: start, leave: leave };
      }).filter(function (item) {
        return item && item.start > today;
      }).map(function (_ref3) {
        var start = _ref3.start,
            leave = _ref3.leave;

        var isPending = leave.status === 'Pending';

        return {
          date: start,
          sortDate: start.getTime(),
          day: String(start.getDate()).padStart(2, '0'),
          month: start.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
          title: isPending ? 'Leave request pending' : 'Leave approved',
          desc: leave.type + " \u2014 " + (leave.noofdays === 1 ? '1 day' : leave.noofdays + " days"),
          tag: isPending ? 'Awaiting' : 'Approved',
          tagClass: isPending ? 'tag-awaiting' : 'tag-approved'
        };
      });
    },


    // Meetings are scheduled per-employee by the admin from User Management
    // and stored on the user record. App.vue refreshes that record on mount, but
    // this component can render before that resolves, so read it fresh.
    buildMeetingEvents: function buildMeetingEvents() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var user, snapshot, fresh, today, sources;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                user = _this6.$store.state.auth.user;
                _context7.prev = 1;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_11_firebase_app___default.a.database().ref("users/" + user.uid).once('value');

              case 4:
                snapshot = _context7.sent;
                fresh = snapshot.val();

                if (fresh) {
                  user = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, user, fresh);
                }
                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](1);

                console.error('Error reading meeting details:', _context7.t0);

              case 12:
                today = new Date();

                today.setHours(0, 0, 0, 0);

                sources = [user.nextIncrementMeetingDetails, user.nextQuarterlyMeetingDetails];
                return _context7.abrupt("return", sources.filter(function (meeting) {
                  return meeting && meeting.date;
                }).map(function (meeting) {
                  var date = new Date(meeting.date);
                  if (isNaN(date)) return null;
                  date.setHours(0, 0, 0, 0);

                  return { date: date, meeting: meeting };
                }).filter(function (item) {
                  return item && item.date >= today;
                }).map(function (_ref4) {
                  var date = _ref4.date,
                      meeting = _ref4.meeting;

                  var time = '';
                  if (meeting.time) {
                    var _meeting$time$split = meeting.time.split(':'),
                        _meeting$time$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_meeting$time$split, 2),
                        hourStr = _meeting$time$split2[0],
                        _meeting$time$split2$ = _meeting$time$split2[1],
                        minute = _meeting$time$split2$ === undefined ? '00' : _meeting$time$split2$;

                    var hour = parseInt(hourStr, 10);
                    if (!isNaN(hour)) {
                      time = (hour % 12 || 12) + ":" + minute + " " + (hour >= 12 ? 'PM' : 'AM');
                    }
                  }

                  var isIncrement = meeting.type === 'increment';

                  return {
                    date: date,
                    sortDate: date.getTime(),
                    day: String(date.getDate()).padStart(2, '0'),
                    month: date.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
                    title: meeting.title || (isIncrement ? 'Increment review meeting' : 'Quarterly review meeting'),
                    desc: time ? "With manager \xB7 " + time : 'With manager',
                    tag: 'Meeting',
                    tagClass: 'tag-meeting'
                  };
                }));

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, _this6, [[1, 9]]);
      }))();
    },
    buildHolidayEvents: function buildHolidayEvents() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var holidays, user, today, horizon;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 2:
                holidays = _context8.sent;
                user = _this7.$store.state.auth.user;

                // Admins see every holiday; everyone else only their shift plus general.

                _this7.holidayList = user.role === 'admin' ? holidays : holidays.filter(function (h) {
                  return _this7.isHolidayForUser(h, user);
                });

                today = new Date();

                today.setHours(0, 0, 0, 0);

                // Only surface holidays in the current or next month. Without this a
                // recurring holiday rolls forward a whole year and floods the panel.
                horizon = new Date(today.getFullYear(), today.getMonth() + 2, 0);

                horizon.setHours(23, 59, 59, 999);

                return _context8.abrupt("return", holidays.filter(function (h) {
                  return _this7.isHolidayForUser(h, user);
                }).map(function (h) {
                  var base = new Date(h.dates);
                  if (isNaN(base)) return null;

                  var start = new Date(base.getFullYear(), base.getMonth(), base.getDate());

                  // A recurring holiday whose date already passed this year rolls
                  // forward to its next occurrence, otherwise it would never reappear.
                  if (h.isRecurring) {
                    while (start <= today) {
                      start = new Date(start.getFullYear() + 1, start.getMonth(), start.getDate());
                    }
                  }

                  start.setHours(0, 0, 0, 0);

                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, h, { start: start });
                }).filter(function (item) {
                  return item && item.start > today && item.start <= horizon;
                }).map(function (item) {
                  var shift = (item.shift || '').toLowerCase();
                  var scopeLabel = shift === 'general' ? 'Company-wide' : shift === 'night' ? 'Night shift' : 'Morning shift';

                  var days = item.numberOfDays === 1 ? '1 day' : item.numberOfDays + " days";
                  var start = item.start;

                  return {
                    date: start,
                    sortDate: start.getTime(),
                    day: String(start.getDate()).padStart(2, '0'),
                    month: start.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
                    title: item.name,
                    desc: scopeLabel + " \xB7 " + days,
                    tag: 'Holiday',
                    tagClass: 'tag-holiday'
                  };
                }));

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    isHolidayForUser: function isHolidayForUser(holiday, user) {
      var holidayShift = (holiday.shift || 'morning').toLowerCase();
      if (holidayShift === 'general') return true;

      var userShift = (user.shift || 'morning').toLowerCase();
      return userShift === holidayShift;
    },


    // The last `count` completed months relative to today, newest first.
    getRecentMonths: function getRecentMonths(count) {
      var now = new Date();

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: count }, function (_, i) {
        var date = new Date(now.getFullYear(), now.getMonth() - 1 - i, 1);
        return {
          month: __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format("MMMM"),
          year: String(date.getFullYear()),
          short: __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format("MMM").toUpperCase()
        };
      });
    },


    // Resolves the score fields the same way Performance.vue's
    // normalizePerformanceCard does. saveEditedCard only writes updatedData,
    // never a top-level score/reopenCount, so the flat fields alone are not
    // enough for items that were added and then edited.
    resolveCardFields: function resolveCardFields(card) {
      var original = card.originalData || {};
      var updated = card.updatedData || {};

      var pick = function pick(value) {
        for (var _len = arguments.length, fallbacks = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          fallbacks[_key - 1] = arguments[_key];
        }

        if (value !== null && value !== undefined) return value;
        return fallbacks.find(function (v) {
          return v !== null && v !== undefined;
        });
      };

      return {
        score: Number(pick(card.score, updated.score, original.score) || 0),
        reopenCount: Number(pick(card.reopenCount, updated.reopened, original.reopenCount) || 0),
        originalreopenCount: Number(pick(card.originalreopenCount, original.reopenCount) || 0),
        deadlineMissedCount: Number(pick(card.deadlineMissedCount, updated.deadlineMissedCount) || 0),
        status: card.status || updated.status || "approved"
      };
    },


    // Net score per month, mirroring Performance.vue's tableTotals + summaryCards.
    // The `performance` node is read once and grouped in memory, since
    // fetchEditedCards always pulls the whole node regardless of the filters.
    getScoresByMonth: function getScoresByMonth(userId, ranges) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var cards, rows, byMonth, criteria, ticketCrit, penalties, reopens, deadlineMissed, counts;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__assets_config_firebase__["a" /* default */].fetchEditedCards({ userId: userId });

              case 2:
                cards = _context9.sent;
                rows = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(cards || {});
                byMonth = {};

                ranges.forEach(function (_ref5) {
                  var month = _ref5.month,
                      year = _ref5.year;

                  byMonth[year + "-" + month] = { rawScore: 0, netScore: 0, itemCount: 0 };
                });

                if (rows.length) {
                  _context9.next = 8;
                  break;
                }

                return _context9.abrupt("return", byMonth);

              case 8:
                _context9.next = 10;
                return __WEBPACK_IMPORTED_MODULE_12__assets_config_firebase__["a" /* default */].getAllPerformanceCriteria();

              case 10:
                criteria = _context9.sent;
                ticketCrit = (criteria || []).find(function (c) {
                  return c.type === "Ticket";
                });
                penalties = ticketCrit && ticketCrit.rules && ticketCrit.rules.penalties || {};
                reopens = penalties.reopens || {};
                deadlineMissed = penalties.deadlineMissed || {};
                counts = {};


                rows.forEach(function (card) {
                  if (card.ticketStatus === "pending") return;

                  var key = card.year + "-" + card.month;
                  var bucket = byMonth[key];
                  if (!bucket) return;

                  var fields = _this8.resolveCardFields(card);

                  bucket.itemCount += 1;
                  bucket.rawScore += fields.score;

                  counts[key] = counts[key] || { reopened: 0, deadlineMissed: 0 };
                  counts[key].reopened += fields.status !== "pending" && fields.status !== "rejected" ? fields.reopenCount : fields.originalreopenCount;
                  counts[key].deadlineMissed += fields.deadlineMissedCount;
                });

                // Penalty scores are negative, so they are added to the raw score.
                __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(byMonth).forEach(function (key) {
                  var bucket = byMonth[key];
                  var totals = counts[key] || { reopened: 0, deadlineMissed: 0 };

                  var reopenDeduction = reopens.limit && reopens.score ? totals.reopened >= reopens.limit ? reopens.score : 0 : reopens.every && reopens.score ? Math.floor(totals.reopened / reopens.every) * reopens.score : 0;

                  var deadlineDeduction = deadlineMissed.limit && deadlineMissed.score ? totals.deadlineMissed >= deadlineMissed.limit ? deadlineMissed.score : 0 : deadlineMissed.every && deadlineMissed.score ? Math.floor(totals.deadlineMissed / deadlineMissed.every) * deadlineMissed.score : 0;

                  bucket.netScore = bucket.rawScore + reopenDeduction + deadlineDeduction;
                });

                return _context9.abrupt("return", byMonth);

              case 19:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },


    // Target score comes from the employee's designation + grade.
    getTargetScore: function getTargetScore(designation, grade) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var targets, match;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!designation || !grade)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return", null);

              case 2:
                _context10.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12__assets_config_firebase__["a" /* default */].getAllPerformanceScoresByGrade();

              case 4:
                targets = _context10.sent;
                match = (targets || []).find(function (t) {
                  return t.designation === designation && String(t.grade) === String(grade);
                });

                if (!(!match || !Number(match.score))) {
                  _context10.next = 8;
                  break;
                }

                return _context10.abrupt("return", null);

              case 8:
                return _context10.abrupt("return", Number(match.score));

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    getPerformanceRating: function getPerformanceRating(pct) {
      if (pct >= 100) return { label: "Excellent", color: "#28a06a", badgeClass: "badge-excellent" };
      if (pct >= 80) return { label: "Good", color: "#2ec4a9", badgeClass: "badge-good" };
      if (pct >= 60) return { label: "Avg", color: "#5b85c3", badgeClass: "badge-avg" };
      if (pct >= 40) return { label: "Fair", color: "#e0a800", badgeClass: "badge-fair" };
      return { label: "Poor", color: "#e05c5c", badgeClass: "badge-poor" };
    },
    fetchPerformanceData: function fetchPerformanceData() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var user, ranges, stat, _ref6, _ref7, scores, targetScore, latest;

        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                user = _this10.$store.state.auth.user;

                if (!(!user || !user.uid)) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return");

              case 3:
                ranges = _this10.getRecentMonths(4);
                stat = _this10.stats[2];
                _context11.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([_this10.getScoresByMonth(user.uid, ranges), _this10.getTargetScore(user.designation, user.grade)]);

              case 7:
                _ref6 = _context11.sent;
                _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);
                scores = _ref7[0];
                targetScore = _ref7[1];


                _this10.performance = ranges.map(function (_ref8) {
                  var month = _ref8.month,
                      year = _ref8.year,
                      short = _ref8.short;

                  var result = scores[year + "-" + month] || { netScore: 0, itemCount: 0 };

                  if (!targetScore || !result.itemCount) {
                    return {
                      month: short,
                      pct: 0,
                      display: "--",
                      color: "#c3ccc9",
                      label: "No data",
                      badgeClass: "badge-none"
                    };
                  }

                  var pct = Math.max(0, Math.round(result.netScore / targetScore * 100));
                  var rating = _this10.getPerformanceRating(pct);

                  return {
                    month: short,
                    netScore: result.netScore,
                    pct: Math.min(pct, 100),
                    display: pct + "%",
                    color: rating.color,
                    label: rating.label,
                    badgeClass: rating.badgeClass
                  };
                });

                // The stat card shows the most recent completed month.
                latest = _this10.performance[0];

                if (!(!targetScore || latest.display === "--")) {
                  _context11.next = 21;
                  break;
                }

                stat.label = "PERFORMANCE";
                stat.value = "--";
                stat.sub = targetScore ? "no records last month" : "no target score set";
                stat.color = "#1a1a1a";
                stat.progress = 0;
                stat.barColor = "#2ec4a9";
                return _context11.abrupt("return");

              case 21:

                stat.label = "PERFORMANCE (" + latest.month + ")";
                stat.value = latest.display;
                stat.sub = latest.netScore.toFixed(1) + " of " + targetScore + " target";
                stat.color = latest.color;
                stat.progress = latest.pct;
                stat.barColor = latest.color;

              case 27:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    getWorkingDaysText: function getWorkingDaysText() {
      var days = this.$store.state.auth.user.workingDays || this.$store.state.auth.constants.days || [];

      var weekOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

      var shortDays = {
        Monday: "Mon",
        Tuesday: "Tue",
        Wednesday: "Wed",
        Thursday: "Thu",
        Friday: "Fri",
        Saturday: "Sat",
        Sunday: "Sun"
      };

      var sortedDays = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(days)).sort(function (a, b) {
        return weekOrder.indexOf(a) - weekOrder.indexOf(b);
      });

      if (!sortedDays.length) return "";

      var indexes = sortedDays.map(function (day) {
        return weekOrder.indexOf(day);
      });

      var isContinuous = indexes.every(function (index, i) {
        return i === 0 || index === indexes[i - 1] + 1;
      });

      if (isContinuous && sortedDays.length > 1) {
        return shortDays[sortedDays[0]] + " \u2013 " + shortDays[sortedDays[sortedDays.length - 1]];
      }

      var shortNames = sortedDays.map(function (day) {
        return shortDays[day];
      });

      if (shortNames.length === 1) {
        return shortNames[0];
      }

      if (shortNames.length === 2) {
        return shortNames[0] + " and " + shortNames[1];
      }

      return shortNames.slice(0, -1).join(", ") + " and " + shortNames[shortNames.length - 1];
    },

    getTodayCheckIn: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee11(userId) {
        var now, startOfDay, endOfDay, snapshot, value, entry;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                now = new Date();
                startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
                endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();
                _context12.next = 5;
                return __WEBPACK_IMPORTED_MODULE_11_firebase_app___default.a.database().ref("timePeriod").orderByChild("timeIn").startAt(startOfDay).endAt(endOfDay).once("value");

              case 5:
                snapshot = _context12.sent;
                value = snapshot.val();

                if (value) {
                  _context12.next = 9;
                  break;
                }

                return _context12.abrupt("return", { checkedIn: false, time: null });

              case 9:
                entry = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(value).find(function (log) {
                  return log.userId === userId;
                });

                if (entry) {
                  _context12.next = 12;
                  break;
                }

                return _context12.abrupt("return", { checkedIn: false, time: null });

              case 12:
                return _context12.abrupt("return", {
                  checkedIn: true,
                  time: __WEBPACK_IMPORTED_MODULE_13_moment___default()(entry.timeIn).format("hh:mm A")
                });

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee11, _this11);
      }));

      return function getTodayCheckIn(_x) {
        return _ref9.apply(this, arguments);
      };
    }(),
    getUserCurrentWeekHours: function getUserCurrentWeekHours(userId) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var now, dayOfWeek, monday, sunday, startTime, endTime, settingsResponse, workingDays, workingHoursPerDay, requiredWorkingDays, d, dayName, totalRequiredHours, database, snapshot, value, totalSpentMs, totalSpentSeconds, spentHours, spentMinutes, spentDecimal, netBalance;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                now = new Date();
                dayOfWeek = now.getDay();
                monday = new Date(now);

                monday.setDate(now.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
                monday.setHours(0, 0, 0, 0);

                sunday = new Date(monday);

                sunday.setDate(monday.getDate() + 6);
                sunday.setHours(23, 59, 59, 999);

                startTime = monday.getTime();
                endTime = sunday.getTime();
                _context13.next = 12;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_genralSpecificSettings__["a" /* settings */])(userId, _this12.$store.state.auth.constants);

              case 12:
                settingsResponse = _context13.sent;
                workingDays = settingsResponse && settingsResponse.days || ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
                workingHoursPerDay = Number(settingsResponse && settingsResponse.totalHours) || 9;

                // ✅ Count ALL 5 working days of the week, not just up to today

                requiredWorkingDays = 0;

                for (d = new Date(monday); d <= sunday; d.setDate(d.getDate() + 1)) {
                  dayName = d.toLocaleDateString("en-US", { weekday: "long" });

                  if (workingDays.includes(dayName)) {
                    requiredWorkingDays++;
                  }
                }
                totalRequiredHours = requiredWorkingDays * workingHoursPerDay;
                database = __WEBPACK_IMPORTED_MODULE_11_firebase_app___default.a.database();
                _context13.next = 21;
                return database.ref("timePeriod").orderByChild("timeIn").startAt(startTime).endAt(endTime).once("value");

              case 21:
                snapshot = _context13.sent;
                value = snapshot.val();

                // ✅ Debug: see what Firebase actually returned

                console.log("Firebase week logs:", value);

                totalSpentMs = 0;


                if (value) {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(value).forEach(function (log) {
                    if (log.userId !== userId) return;

                    if (log.sessions && Array.isArray(log.sessions)) {
                      log.sessions.forEach(function (session, index) {
                        if (!session.timeIn || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(session.timeIn)) return;

                        var sessionTimeOut = session.timeOut || (index === log.sessions.length - 1 ? log.latestScreenshotTime : null);

                        if (sessionTimeOut && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(sessionTimeOut) && sessionTimeOut > session.timeIn) {
                          totalSpentMs += sessionTimeOut - session.timeIn;
                        }
                      });
                    }
                  });
                }

                totalSpentSeconds = Math.floor(totalSpentMs / 1000);
                spentHours = Math.floor(totalSpentSeconds / 3600);
                spentMinutes = Math.floor(totalSpentSeconds % 3600 / 60);
                spentDecimal = spentHours + spentMinutes / 60;
                netBalance = spentDecimal - totalRequiredHours;
                return _context13.abrupt("return", {
                  weekRange: { from: monday.toDateString(), to: sunday.toDateString() },
                  requiredWorkingDays: requiredWorkingDays, // should now be 5
                  totalRequiredHours: totalRequiredHours, // should now be 45
                  spentHours: spentHours,
                  spentMinutes: spentMinutes,
                  spentDecimal: parseFloat(spentDecimal.toFixed(2)),
                  netBalance: parseFloat(netBalance.toFixed(2)),
                  isDeficit: netBalance < 0
                });

              case 32:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    }
  }
});

/***/ }),

/***/ "CZJN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CfxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-password-container"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleForgotPassword($event)}}},[_c('span',{staticClass:"full-width d-inline-block text-center",staticStyle:{"font-size":"20px","font-weight":"600","margin-bottom":"20px"}},[_vm._v("\n      Forgot your password?\n    ")]),_vm._v(" "),_c('p',{staticClass:"text-center text-muted",staticStyle:{"margin-bottom":"30px"}},[_vm._v("\n      Enter your registered email address. We'll send you a link to reset your password.\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group margin-base-y",staticStyle:{"position":"relative"}},[_c('label',{staticClass:"control-label",attrs:{"for":"forgot-email"}},[_vm._v("Email address:")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control input-field",attrs:{"type":"email","id":"forgot-email","placeholder":"Enter your email"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.handleEmailChange]}}),_vm._v(" "),(_vm.emailValidating && _vm.email.length > 0)?_c('div',{staticClass:"input-icon"},[_vm._m(0)]):(_vm.emailValidated)?_c('div',{staticClass:"input-icon"},[_c('i',{staticClass:"fa fa-check-circle mail-checked"})]):_vm._e()]),_vm._v(" "),(_vm.emailError)?_c('div',{staticClass:"text-danger",staticStyle:{"position":"absolute"}},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"30px"}},[_c('button',{staticClass:"login-button",attrs:{"type":"submit","disabled":!_vm.emailValidated || _vm.isLoading}},[(_vm.isLoading)?_c('img',{staticClass:"next-arrow",attrs:{"src":"static/img/loader.gif"}}):_c('span',[_vm._v("\n          Send Reset Link\n        ")])])]),_vm._v(" "),(_vm.successMessage)?_c('div',{staticClass:"text-success text-center"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center back-login"},[_c('span',{staticClass:"text-link",on:{"click":function($event){return _vm.$emit('back-to-login')}}},[_vm._v("\n        Back to Login\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border spinner-border-sm text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar_vue__ = __webpack_require__("R5Ta");



var SidebarStore = {
  showSidebar: false,
  sidebarLinksOriginal: [{
    name: 'Dashboard',
    icon: 'now-ui-icons design_app',
    path: '/overview'
  }, {
    name: 'User Profile',
    icon: 'now-ui-icons users_single-02',
    path: '/user'
  }, {
    name: 'User Management',
    icon: 'now-ui-icons text_align-center',
    path: '/usermanagement'
  }, {
    name: 'User Reports',
    icon: 'now-ui-icons files_single-copy-04',
    path: '/reports'
  },
  // {
  //   name: 'Typography',
  //   icon: 'now-ui-icons files_paper',
  //   path: '/typography'
  // },
  // {
  //   name: 'Icons',
  //   icon: 'now-ui-icons objects_diamond',
  //   path: '/icons'
  // },
  // {
  //   name: 'Maps',
  //   icon: 'now-ui-icons location_pin',
  //   path: '/maps'
  // },
  {
    name: 'Performance',
    icon: 'now-ui-icons business_chart-bar-32', // Updated icon
    path: '/performance'
  }, {
    name: 'Leave Management',
    icon: 'now-ui-icons ui-1_calendar-60',
    path: '/leave'
  }, {
    name: 'Payroll Management',
    icon: 'now-ui-icons business_money-coins',
    path: '/payroll'
  }, {
    name: 'Settings',
    icon: 'now-ui-icons loader_gear',
    path: '/settings'
  }, {
    name: 'Complains',
    icon: 'now-ui-icons ui-1_bell-53',
    path: '/complains'
  }, {
    name: 'Policies',
    icon: 'now-ui-icons files_paper',
    path: '/policies'
  }, {
    name: 'Reported Bugs',
    icon: 'fas fa-bug',
    path: '/reported-bugs'
  }, {
    name: 'Activity Logs',
    icon: 'fas fa-user-shield',
    path: '/activity-logs'
  }, {
    name: 'Chatbot Management',
    icon: 'fas fa-robot',
    path: '/chatbot'
  }],
  sidebarLinks: [],
  displaySidebar: function displaySidebar(value) {
    // we simulate the window Resize so the charts will get updated in realtime.
    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    if (value) {
      document.body.classList.add('nav-open');
    } else {
      document.body.classList.remove('nav-open');
    }
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue, _ref) {
    var store = _ref.store;

    Vue.mixin({
      computed: {
        filteredSidebarLinks: function filteredSidebarLinks() {
          var user = store.state.auth.user;
          var isAdmin = user && user.role === "admin";

          var links = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(SidebarStore.sidebarLinksOriginal));
          var adminOnlyPages = ["Chatbot Management", "Activity Logs", "Reported Bugs"];

          if (!isAdmin) {
            return links.filter(function (link) {
              return !adminOnlyPages.includes(link.name);
            });
          }
          return links;
        }
      },
      watch: {
        'filteredSidebarLinks': {
          immediate: true,
          handler: function handler(newLinks) {
            SidebarStore.sidebarLinks = newLinks;
          }
        }
      },
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_1__SideBar_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var auth = {
  state: {
    user: null,
    allUsers: null,
    company: null,
    constants: null,
    AllLeaves: null,
    userLeaves: null,
    allEmployees: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setAllUsers: function setAllUsers(state, payload) {
      state.allUsers = payload;
    },
    setCompany: function setCompany(state, payload) {
      state.company = payload;
    },
    setConstants: function setConstants(state, payload) {
      state.constants = payload;
    },
    setAllLeaves: function setAllLeaves(state, payload) {
      state.AllLeaves = payload;
    },
    setUserLeaves: function setUserLeaves(state, payload) {
      state.userLeaves = payload;
    },
    setEmployeeList: function setEmployeeList(state, payload) {
      state.allEmployees = payload;
    },
    clearAuth: function clearAuth(state) {
      state.user = null;
      state.company = null;
      state.allUsers = null;
      state.constants = null;
      state.AllLeaves = null;
      state.userLeaves = null;
      state.allEmployees = null;
    }
  },
  getters: {
    allUsers: function allUsers(state) {
      return function () {
        return state.allUsers;
      };
    },
    AllLeaves: function AllLeaves(state) {
      return function () {
        return state.AllLeaves;
      };
    },
    userLeaves: function userLeaves(state) {
      return function () {
        return state.userLeaves;
      };
    },
    allEmployees: function allEmployees(state) {
      return function () {
        return state.allEmployees;
      };
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),

/***/ "DJ6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = calculateTotalWorkingDays;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return daysWorkedSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return approvedLeaveDatesSet; });
/* unused harmony export requiredWorkingDaysWithHours */
/* harmony export (immutable) */ __webpack_exports__["a"] = resetWorkData;
/* unused harmony export monthNames */
/* harmony export (immutable) */ __webpack_exports__["e"] = convertToFullDate;
/* harmony export (immutable) */ __webpack_exports__["t"] = generateYearsArray;
/* harmony export (immutable) */ __webpack_exports__["j"] = stripeLeadingZero;
/* harmony export (immutable) */ __webpack_exports__["h"] = normalizeTime;
/* harmony export (immutable) */ __webpack_exports__["f"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = isInHourRange;
/* harmony export (immutable) */ __webpack_exports__["s"] = formatDecimalHours;
/* harmony export (immutable) */ __webpack_exports__["v"] = calculateWorkingDays;
/* harmony export (immutable) */ __webpack_exports__["u"] = isHoliday;
/* harmony export (immutable) */ __webpack_exports__["w"] = calculateWorkingDaysExcludingHolidays;
/* unused harmony export parseLeaveDates */
/* harmony export (immutable) */ __webpack_exports__["r"] = formatDaysToDateArray;
/* harmony export (immutable) */ __webpack_exports__["q"] = getTotalDaysInMonth;
/* unused harmony export isValidEmail */
/* unused harmony export isValidNIC */
/* unused harmony export isValidPhoneNumber */
/* unused harmony export isValidIBAN */
/* harmony export (immutable) */ __webpack_exports__["y"] = validateForm;
/* unused harmony export validateDocuments */
/* harmony export (immutable) */ __webpack_exports__["i"] = convertAmountToWords;
/* unused harmony export padDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return formatHoursDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getRemainingHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getAboveHalfDayExtra; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return formatAndFilterZeroMins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return calculateTotalHoursAndMinutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return sumHoursAndMinutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("gY6d");










var fileToDataURL = function fileToDataURL(file) {
  return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);
    }

    reader.addEventListener("load", function () {
      resolve(reader.result);
    }, false);
  });
};

// const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var emailRegex = /^(?=.{1,256})(?=.{1,64}@.{1,255})(?=.{1,64}@.{1,255}\.[a-zA-Z]{2,})(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function calculateTotalWorkingDays(year, month, workingDays) {
  if (!year || !month || !workingDays || !Array.isArray(workingDays)) {
    console.error("Invalid inputs provided to calculateWorkingDays.");
    return 0;
  }

  if (typeof month === "string") {
    month = __WEBPACK_IMPORTED_MODULE_8__constants__["c" /* monthMap */][month];
  }

  if (!month) {
    console.error("Invalid month provided.");
    return 0;
  }

  var daysInMonth = new Date(year, month, 0).getDate();
  var totalWorkingDays = 0;

  for (var day = 1; day <= daysInMonth; day++) {
    var currentDate = new Date(year, month - 1, day);
    var currentDay = currentDate.toLocaleDateString('en-US', { weekday: 'long' });

    if (workingDays.includes(currentDay)) {
      totalWorkingDays++;
    }
  }

  return totalWorkingDays;
}

var daysWorkedSet = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a(); // To store unique work days
var approvedLeaveDatesSet = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();
var requiredWorkingDaysWithHours = {};

function resetWorkData() {
  daysWorkedSet.clear();
  // approvedLeaveDatesSet.clear();
  for (var key in requiredWorkingDaysWithHours) {
    delete requiredWorkingDaysWithHours[key];
  }
}

var monthNames = {
  "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04", "May": "05", "Jun": "06",
  "Jul": "07", "Aug": "08", "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
};

function convertToFullDate(shortDate, year, monthNumber) {
  var _shortDate$split = shortDate.split(" "),
      _shortDate$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_shortDate$split, 2),
      monthStr = _shortDate$split2[0],
      day = _shortDate$split2[1];

  var month = monthNames[monthStr];

  if (!month) {
    console.warn("Invalid leave date format:", shortDate);
    return null;
  }

  return year + "-" + month + "-" + day.padStart(2, '0');
}

function generateYearsArray() {
  var currentYear = new Date().getFullYear();
  var years = [];

  for (var i = -5; i < 5; i++) {
    years.push(currentYear + i);
  }

  return years;
}

function stripeLeadingZero(value) {
  if (!value) return value;

  var stringVal = value.toString();
  var parts = stringVal.split('.');
  var whole = parts[0].replace(/^0+(?!$)/, '') || '0';
  var decimal = parts[1] || '';

  var result = decimal ? whole + '.' + decimal : whole;

  if (parseFloat(result) === 0) {
    return '';
  }

  return result;
}

function convertTo24HourFormat(timeStr) {
  if (!timeStr) return null;

  var _timeStr$split = timeStr.split(' '),
      _timeStr$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_timeStr$split, 2),
      time = _timeStr$split2[0],
      modifier = _timeStr$split2[1];

  if (!time || !modifier) return timeStr; // Already in 24-hour format

  var _time$split = time.split(':'),
      _time$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];

  hours = parseInt(hours, 10);

  if (modifier.toLowerCase() === 'pm' && hours !== 12) {
    hours += 12;
  } else if (modifier.toLowerCase() === 'am' && hours === 12) {
    hours = 0;
  }

  return String(hours).padStart(2, '0') + ":" + minutes;
}

function normalizeTime(timeStr) {
  if (!timeStr) return null;

  // Try to parse directly (24-hour format)
  var date = new Date("1970-01-01T" + timeStr);
  if (!isNaN(date.getTime())) {
    return date.toTimeString().slice(0, 5); // "HH:mm"
  }

  // If failed, try converting from 12-hour to 24-hour format
  var converted = convertTo24HourFormat(timeStr);
  date = new Date("1970-01-01T" + converted);

  if (!isNaN(date.getTime())) {
    return date.toTimeString().slice(0, 5); // "HH:mm"
  }

  console.warn("Invalid time format:", timeStr);
  return null;
}

function formatDate(date) {
  var d = new Date(date);
  var day = String(d.getDate()).padStart(2, '0');
  var month = String(d.getMonth() + 1).padStart(2, '0');
  var year = d.getFullYear();
  return day + "-" + month + "-" + year;
}

function isInHourRange(decimalHour) {
  var hoursPart = Math.floor(decimalHour);
  var minutesDecimal = decimalHour - hoursPart;
  var minutesPart = Math.round(minutesDecimal * 60);

  return minutesPart >= 0 && minutesPart < 60;
}

function formatDecimalHours(decimalHours) {
  var hours = Math.floor(decimalHours);
  var minutes = Math.round((decimalHours - hours) * 60);
  return hours + " hrs " + minutes + " mins";
}

// src/utils/dateUtils.js

function calculateWorkingDays(startDateStr, endDateStr, workingDays) {
  if (startDateStr === endDateStr) {
    return 1;
  }
  var startDate = new Date(startDateStr);
  var endDate = new Date(endDateStr);
  if (startDate > endDate) {
    return 0;
  }
  var count = 0;

  var workingDaysNums = workingDays.map(function (day) {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day);
  });

  for (var d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    if (workingDaysNums.includes(d.getDay())) {
      count++;
    }
  }

  return count;
}
function isHoliday(date, holidays) {
  var userShift = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!date || !holidays || !holidays.length) return false;
  var d = new Date(date);
  var year = d.getFullYear();
  var month = d.getMonth();
  var day = d.getDate();
  var isNightShiftUser = userShift && userShift.toLowerCase() === "night";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(holidays), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var hol = _step.value;

      if (!hol.dates) continue;

      var holStart = new Date(hol.dates);
      var holYear = holStart.getFullYear();
      var holShift = (hol.shift || "General").toLowerCase();
      if (isNightShiftUser) {
        if (holShift !== "night" && holShift !== "general") continue;
      } else {
        if (holShift !== "morning" && holShift !== "general") continue;
      }

      if (hol.isRecurring) {
        if (holStart.getMonth() === month && holStart.getDate() === day) {
          return true;
        }
      } else if (holYear === year && holStart.getMonth() === month && holStart.getDate() === day) {
        return true;
      }
      if (hol.numberOfDays && hol.numberOfDays > 1) {
        for (var i = 0; i < hol.numberOfDays; i++) {
          var holDate = new Date(holStart);
          holDate.setDate(holDate.getDate() + i);

          if (holDate.getFullYear() === year && holDate.getMonth() === month && holDate.getDate() === day) {
            return true;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}
function calculateWorkingDaysExcludingHolidays(start, end, workingDaysConfig, holidays) {
  var userShift = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var count = 0;
  var startDate = new Date(start);
  var endDate = new Date(end);

  if (startDate > endDate) return 0;

  for (var d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    if (isWorkingDay(d, workingDaysConfig) && !isHoliday(d, holidays, userShift)) {
      count++;
    }
  }
  return count;
}
function isWorkingDay(date, workingDays) {
  var workingDaysNums = workingDays.map(function (day) {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day);
  });
  return workingDaysNums.includes(date.getDay());
}
function parseLeaveDates(dateStr, year) {
  var parts = dateStr.split(" - ");

  if (parts.length === 2) {
    var startDate = new Date(parts[0] + " " + year);
    var endDate = new Date(parts[1] + " " + year);
    return { startDate: startDate, endDate: endDate };
  } else {
    var _startDate = new Date(dateStr + " " + year);
    return { startDate: _startDate, endDate: _startDate };
  }
}

/**
 * Formats an object of half-day hours into an array of readable date strings.
 * 
 * @param {Object} halfDays - Object with day numbers as keys, and hours as values.
 * @param {Number} year - The full year (e.g., 2025).
 * @param {Number} month - The month number (1 = January, 12 = December).
 * @returns {String[]} Array of formatted date strings like "07-May-2025".
 */
function formatDaysToDateArray() {
  var halfDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var year = arguments[1];
  var month = arguments[2];

  if (!halfDays || (typeof halfDays === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(halfDays)) !== 'object') return [];

  var monthNum = __WEBPACK_IMPORTED_MODULE_8__constants__["c" /* monthMap */][month]; // Make sure this gives number like 4 for 'April'
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(halfDays).map(function (day) {
    var dayNum = parseInt(day, 10);
    var dateObj = new Date(year, monthNum - 1, dayNum); // JS months are 0-indexed
    return dateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit", // <-- changed from 'long' to '2-digit'
      year: "numeric"
    }).replace(/\//g, "-"); // Convert dd/mm/yyyy to dd-mm-yyyy
  });
}

function getTotalDaysInMonth(monthName, year) {
  var date = new Date(monthName + " 1, " + year);
  var monthIndex = date.getMonth(); // Get month index from name
  var totalDays = new Date(year, monthIndex + 1, 0).getDate(); // Last day of the month
  return totalDays;
}

// form validation

function isValidEmail(email) {
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidNIC(nic) {
  var nicRegex = /^\d{5}-\d{7}-\d{1}$/;
  return nicRegex.test(nic);
}

function isValidPhoneNumber(phone) {
  var phoneRegex = /^\+?[0-9]{10,15}$/;
  return phoneRegex.test(phone);
}

function isValidIBAN(iban) {
  var ibanRegex = /^PK\d{2}[A-Z0-9]{20}$/;
  return ibanRegex.test(iban.replace(/\s/g, ''));
}

function validateForm(user, isNonAdmin) {
  var errors = {};
  var isValid = true;
  console.log('Validating form with user data:', user); // Debug log

  if (!user.fullName) {
    errors.fullName = 'Full Name as per NIC is required';
    isValid = false;
  }
  if (!user.personalEmail) {
    errors.personalEmail = 'Personal Email is required';
    isValid = false;
  } else if (!isValidEmail(user.personalEmail)) {
    errors.personalEmail = 'Please enter a valid email address';
    isValid = false;
  }
  if (!user.nicNumber) {
    errors.nicNumber = 'NIC Number is required';
    isValid = false;
  } else if (!isValidNIC(user.nicNumber)) {
    errors.nicNumber = 'Please enter a valid NIC number (e.g., 12345-1234567-1)';
    isValid = false;
  }
  if (!user.dateOfBirth) {
    errors.dateOfBirth = 'Date of birth is required';
    isValid = false;
  }
  if (!isNonAdmin) {
    if (!user.designation) {
      errors.designation = 'Designation is required';
      isValid = false;
    }
    if (!user.joiningDate) {
      errors.joiningDate = 'Joining Date is required';
      isValid = false;
    }
    if (!user.grade) {
      errors.grade = 'Grade is required';
      isValid = false;
    }
    if (!user.email) {
      errors.companyEmail = 'Company Email is required';
      isValid = false;
    } else if (!isValidEmail(user.email)) {
      errors.companyEmail = 'Please enter a valid company email address';
      isValid = false;
    }
  }
  if (!user.bankName) {
    errors.bankName = 'Bank Name is required';
    isValid = false;
  }
  if (!user.iban) {
    errors.iban = 'IBAN/Account number is required';
    isValid = false;
  } else if (!isValidIBAN(user.iban)) {
    errors.iban = 'Enter a valid IBAN (e.g., PK36SCBL0000001123456702)';
    isValid = false;
  }
  if (!user.nationality) {
    errors.nationality = 'Nationality is required';
    isValid = false;
  }
  if (!user.maritalStatus) {
    errors.maritalStatus = 'Marital Status is required';
    isValid = false;
  }
  if (!user.currentAddress) {
    errors.currentAddress = 'Current Address is required';
    isValid = false;
  }
  if (!user.permanentAddress) {
    errors.permanentAddress = 'Permanent Address is required';
    isValid = false;
  }
  if (!user.phoneNumber) {
    errors.contactNumber = 'Contact Number is required';
    isValid = false;
  } else if (!isValidPhoneNumber(user.phoneNumber)) {
    errors.contactNumber = 'Please enter a valid contact number (10-15 digits)';
    isValid = false;
  }
  if (!user.emergencyContactName) {
    errors.emergencyContactName = 'Emergency Contact Name & Relationship is required';
    isValid = false;
  }
  if (!user.emergencyContactNumber) {
    errors.emergencyContactNumber = 'Emergency Contact Number is required';
    isValid = false;
  } else if (!isValidPhoneNumber(user.emergencyContactNumber)) {
    errors.emergencyContactNumber = 'Please enter a valid emergency contact number (10-15 digits)';
    isValid = false;
  }
  if (!user.nicImageUrl) {
    errors.nicImageUrl = 'NIC Picture is required';
    isValid = false;
  }

  console.log('Validation result:', { isValid: isValid, errors: errors }); // Debug log
  return { isValid: isValid, errors: errors };
}
function validateDocuments(user, errors) {
  var isValid = true;
  if (!user.certificateUrl) {
    errors.certificateUrl = 'Academic certificate/Experience letter is required';
    isValid = false;
  }
  if (!user.salarySlipUrl) {
    errors.salarySlipUrl = 'Salary Slip is required';
    isValid = false;
  }
  return { isValid: isValid, errors: errors };
}
function convertAmountToWords(num) {
  var units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  var teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  var tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  num = Math.floor(num || 0);
  if (num === 0) return "Zero";

  function convertLessThanOneThousand(n) {
    if (n === 0) return "";
    if (n < 10) return units[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) {
      return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "");
    }
    return units[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " and " + convertLessThanOneThousand(n % 100) : "");
  }

  function convert(n) {
    if (n === 0) return "Zero";
    var result = "";

    // Handle lakhs
    if (n >= 100000) {
      var lakhs = Math.floor(n / 100000);
      result += convertLessThanOneThousand(lakhs) + " Lakh";
      n %= 100000;
      if (n > 0) result += " ";
    }

    // Handle thousands
    if (n >= 1000) {
      var thousands = Math.floor(n / 1000);
      result += convertLessThanOneThousand(thousands) + " Thousand";
      n %= 1000;
      if (n > 0) result += " ";
    }

    // Handle remainder
    if (n > 0) {
      result += convertLessThanOneThousand(n);
    }

    return result;
  }

  return convert(num);
}

var padDay = function padDay(day) {
  return String(day).padStart(2, '0');
};

var formatHoursDetails = function formatHoursDetails(data, formatToHoursMinutes, month, year) {
  if (!data) return [];
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data || {}).map(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        day = _ref2[0],
        hours = _ref2[1];

    var time = formatToHoursMinutes(hours);
    return padDay(day) + "-" + month + "-" + year + ": " + time;
  });
};

var getRemainingHours = function getRemainingHours(data, empTotalHours) {
  var skipZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data || {}).reduce(function (acc, _ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        day = _ref4[0],
        value = _ref4[1];

    var diff = empTotalHours - Number(value);
    if (skipZero && diff === 0) return acc;
    acc[day] = diff;
    return acc;
  }, {});
};

var getAboveHalfDayExtra = function getAboveHalfDayExtra(data) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var result = {};

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data || {})), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref5 = _step2.value;

      var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

      var key = _ref6[0];
      var value = _ref6[1];

      if (value > threshold) {
        var extra = value - threshold;
        result[key] = extra;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
};

var formatAndFilterZeroMins = function formatAndFilterZeroMins(data, formatToHoursMinutes, month, year) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data || {}).map(function (_ref7) {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
        day = _ref8[0],
        value = _ref8[1];

    var formatted = formatToHoursMinutes(value);
    return { day: day, formatted: formatted };
  }).filter(function (_ref9) {
    var formatted = _ref9.formatted;
    return formatted !== '0 min';
  }).map(function (_ref10) {
    var day = _ref10.day,
        formatted = _ref10.formatted;
    return padDay(day) + "-" + month + "-" + year + ": " + formatted;
  });
};

var calculateTotalHoursAndMinutes = function calculateTotalHoursAndMinutes(data) {
  console.log("data", data);
  var totalMinutes = 0;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(data || {}).forEach(function (val) {
    var decimal = Number(val); // e.g. 4.510185
    if (!isNaN(decimal)) {
      totalMinutes += decimal * 60;
    }
  });

  var isNegative = totalMinutes < 0;
  var absMinutes = Math.round(Math.abs(totalMinutes));
  var hrs = Math.floor(absMinutes / 60);
  var mins = absMinutes % 60;

  return {
    hrs: hrs,
    mins: mins,
    isNegative: isNegative,
    text: hrs + " hr" + (hrs !== 1 ? 's' : '') + " " + mins + " min" + (mins !== 1 ? 's' : ''),
    color: isNegative ? 'red' : 'green'
  };
};

var sumHoursAndMinutes = function sumHoursAndMinutes(a, b) {
  var totalHrs = a.hrs + b.hrs;
  var totalMins = a.mins + b.mins;

  // Convert minutes to hours if over 60
  if (totalMins >= 60) {
    totalHrs += Math.floor(totalMins / 60);
    totalMins = totalMins % 60;
  }

  return {
    hrs: totalHrs,
    mins: totalMins,
    text: totalHrs + " hrs " + totalMins + " mins"
  };
};

/* harmony default export */ __webpack_exports__["x"] = ({
  fileToDataURL: fileToDataURL,
  emailRegex: emailRegex
});

/***/ }),

/***/ "DJCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tax-report-export"},[_c('button',{staticClass:"btn btn-outline export-icon-button",on:{"click":_vm.openModal}},[_c('span',{staticClass:"export-icon"},[_vm._v("↓")]),_vm._v("\n    Salary & Tax Report\n  ")]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.showModal,"title":"Export Salary & Tax Report","submitButtonText":"Export","loading":_vm.exporting},on:{"update:modelValue":function($event){_vm.showModal = $event},"submit":_vm.exportReport}},[_c('div',{staticClass:"tax-report-form"},[_c('label',{staticClass:"tax-report-label"},[_vm._v("Period")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.preset),expression:"preset"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.preset=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.applyPreset]}},_vm._l((_vm.presetOptions),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n          "+_vm._s(option.label)+"\n        ")])}),0),_vm._v(" "),_c('div',{staticClass:"tax-report-range"},[_c('div',{staticClass:"tax-report-range-col"},[_c('label',{staticClass:"tax-report-label"},[_vm._v("From")]),_vm._v(" "),_c('div',{staticClass:"tax-report-row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromMonth),expression:"fromMonth"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fromMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.preset = 'custom'}]}},_vm._l((_vm.months),function(month,index){return _c('option',{key:month,domProps:{"value":index}},[_vm._v(_vm._s(month))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fromYear),expression:"fromYear",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.fromYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.preset = 'custom'}]}},_vm._l((_vm.years),function(year){return _c('option',{key:year,domProps:{"value":year}},[_vm._v(_vm._s(year))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"tax-report-range-col"},[_c('label',{staticClass:"tax-report-label"},[_vm._v("To")]),_vm._v(" "),_c('div',{staticClass:"tax-report-row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.toMonth),expression:"toMonth"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.toMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.preset = 'custom'}]}},_vm._l((_vm.months),function(month,index){return _c('option',{key:month,domProps:{"value":index}},[_vm._v(_vm._s(month))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.toYear),expression:"toYear",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.toYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.preset = 'custom'}]}},_vm._l((_vm.years),function(year){return _c('option',{key:year,domProps:{"value":year}},[_vm._v(_vm._s(year))])}),0)])])]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"tax-report-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"tax-report-hint"},[_vm._v("\n        Downloads one workbook with two sheets: "),_c('strong',[_vm._v("Salary")]),_vm._v(" and "),_c('strong',[_vm._v("Tax Deducted")]),_vm._v(",\n        one row per employee (Name, NIC) and one column per month.\n        Only processed payrolls are included.\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DV2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminComplains_vue__ = __webpack_require__("j73S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5e7128_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminComplains_vue__ = __webpack_require__("4NFJ");
function injectStyle (ssrContext) {
  __webpack_require__("a1in")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminComplains_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5e7128_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminComplains_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dsl7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"complains"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"title"},[_vm._v("Complains")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"},[_c('button',{staticClass:"add-complains",on:{"click":_vm.openAddComplainModal}},[_vm._v("Add")])])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center py-3"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e(),_vm._v(" "),_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.items},scopedSlots:_vm._u([{key:"assignee",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.assigneeName}},[_vm._v(_vm._s(item.assigneeName || '-'))])]}},{key:"name",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.name ? item.name.split('-')[0].trim() : '-'}},[_vm._v(_vm._s(item.name ? item.name.split('-')[0].trim() : '-'))])]}},{key:"desc",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.originalDesc}},[_vm._v("\n                  "+_vm._s(item.originalDesc.length > 30 ? item.originalDesc.slice(0, 30) + "..." : item.originalDesc || '-')+"\n                ")])]}},{key:"isHighPriority",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",style:({ color: item.isHighPriority ? '#FF4E50' : 'blue' })},[_vm._v("\n                  "+_vm._s(item.isHighPriority ? "High" : "Normal" || '-')+"\n                ")])]}},{key:"isPersonal",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.isPersonal ? "Personal" : "General" || '-'))])]}},{key:"dateLastActivity",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.formatRelativeTime(item.dateLastActivity) || '-'))])]}},{key:"feedback",fn:function(ref){
var item = ref.item;
return [(item.status === 'Resolved')?_c('div',{staticClass:"feedback-cell",attrs:{"title":!item.feedback ? 'No feedback yet' : null}},[(item.feedback)?[_c('span',{staticClass:"stars-contianer"},[_c('span',{staticClass:"stars",staticStyle:{"font-size":"1.7em"}},_vm._l((5),function(n){return _c('span',{key:n,class:{ 'star-filled': n <= item.feedback.rating }},[_vm._v("★")])}),0),_vm._v(" "),(item.feedback.comment)?_c('span',{staticClass:"detail-tooltip-wrapper",staticStyle:{"font-size":"14px","margin-left":"6px","margin-top":"12px"},on:{"mouseover":function($event){return _vm.showDetails(item.id)},"mouseleave":function($event){return _vm.hideDetails(item.id)}}},[_c('i',{staticClass:"fa fa-info-circle text-info pointer info-icon ml-1"}),_vm._v(" "),(_vm.visibleDetails[item.id])?_c('div',{staticClass:"detail-tooltip-box"},[_c('div',{staticClass:"details-title text-center"},[_vm._v("\n                        Feedback Comment\n                      ")]),_vm._v(" "),_c('div',{staticClass:"detail-text text-start"},[_vm._v("\n                        "+_vm._s(item.feedback.comment)+"\n                      ")])]):_vm._e()]):_vm._e()])]:(item.email === _vm.user.email)?_c('span',{staticClass:"add-feedback",on:{"click":function($event){$event.stopPropagation();return _vm.openFeedbackModal(item)}}},[_vm._v("\n                  Add Feedback\n                ")]):_c('span',[_vm._v("N/A")])],2):_c('span',[_vm._v("N/A")])]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('button',{staticClass:"btn",class:_vm.getStatusClass(item.status),staticStyle:{"cursor":"pointer"}},[_vm._v("\n                  "+_vm._s(item.status)+"\n                ")])]}}])})],2),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.dialog,"title":_vm.isEdit ? 'Edit Complaint' : 'Create Complaint',"submit-button-text":_vm.isEdit ? 'Update' : 'Add'},on:{"update:modelValue":function($event){_vm.dialog = $event},"submit":_vm.addComplain}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('label',{attrs:{"for":"assignee"}},[_vm._v("Assignee")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"assignee","value":_vm.selectedAssigneeName,"options":_vm.assigneeOptions,"placeholder":"Select an assignee"},on:{"change":_vm.handleAssigneeChange}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form-control",attrs:{"type":"text","id":"title","placeholder":"Title here...","maxlength":"50","required":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"priority"}},[_vm._v("Priority")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"priority","value":_vm.priority,"options":_vm.priorityOptions,"placeholder":"Select a priority"},on:{"change":_vm.handlePriorityChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"issueType"}},[_vm._v("Issue Type")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"issueType","value":_vm.issueType,"options":_vm.issueTypeOptions,"placeholder":"Select an issue type"},on:{"change":_vm.handleIssueTypeChange}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control textarea",attrs:{"id":"description","placeholder":"Description here...","rows":"2","required":""},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.feedbackDialog,"title":"Add Feedback","submit-button-text":"Submit","loading":_vm.isSubmitting},on:{"update:modelValue":function($event){_vm.feedbackDialog = $event},"submit":_vm.submitFeedback}},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("\n                Rating "),_c('span',{staticStyle:{"color":"red","font-size":"15px","margin-left":"-5px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"rating-stars"},_vm._l((5),function(n){return _c('span',{key:n,staticClass:"star",class:{ active: n <= _vm.feedbackRating },on:{"click":function($event){_vm.feedbackRating = n}}},[_vm._v("★")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"form-label fw-bold mb-1 text-start"},[_vm._v("Comment")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.feedbackComment),expression:"feedbackComment"}],staticClass:"form-control",attrs:{"rows":"3","maxlength":"400","placeholder":"Your feedback..."},domProps:{"value":(_vm.feedbackComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.feedbackComment=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"text-end text-muted small mt-1"},[_vm._v("\n                "+_vm._s(_vm.feedbackComment.length)+"/400\n              ")])])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E95N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTable_vue__ = __webpack_require__("lYPq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655b8ba9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTable_vue__ = __webpack_require__("UAIe");
function injectStyle (ssrContext) {
  __webpack_require__("Ajc/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-655b8ba9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655b8ba9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EHkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slack-integration"},[_c('div',{staticClass:"si-header"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),(!_vm.loading)?_c('span',{staticClass:"si-status",class:_vm.statusClass},[_vm._v(_vm._s(_vm.statusLabel))]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"si-loading"},[_vm._v("Loading…")]):_c('div',{staticClass:"si-body"},[_c('label',{staticClass:"si-label",attrs:{"for":"slackWebhook"}},[_vm._v("Incoming Webhook URL")]),_vm._v(" "),_c('div',{staticClass:"si-input-wrap"},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" "),(_vm.showUrl)?_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.webhookUrl),expression:"form.webhookUrl",modifiers:{"trim":true}}],staticClass:"si-input",attrs:{"id":"slackWebhook","type":"text","placeholder":"https://hooks.slack.com/services/...","autocomplete":"off"},domProps:{"value":(_vm.form.webhookUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "webhookUrl", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}):_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.webhookUrl),expression:"form.webhookUrl",modifiers:{"trim":true}}],staticClass:"si-input",attrs:{"id":"slackWebhook","type":"password","placeholder":"https://hooks.slack.com/services/...","autocomplete":"off"},domProps:{"value":(_vm.form.webhookUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "webhookUrl", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"si-eye",attrs:{"type":"button","title":_vm.showUrl ? 'Hide' : 'Show'},on:{"click":function($event){_vm.showUrl = !_vm.showUrl}}},[_c('i',{class:_vm.showUrl ? 'fa fa-eye-slash' : 'fa fa-eye'})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('label',{staticClass:"si-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.enabled),expression:"form.enabled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.enabled)?_vm._i(_vm.form.enabled,null)>-1:(_vm.form.enabled)},on:{"change":function($event){var $$a=_vm.form.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "enabled", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"si-slider"}),_vm._v(" "),_c('span',{staticClass:"si-toggle-text"},[_vm._v("Send activities to Slack")])])]),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"si-footer"},[(_vm.saved.webhookUrl)?_c('button',{staticClass:"si-btn si-btn--danger",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.disconnect}},[_vm._v("\n      Disconnect\n    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"si-spacer"}),_vm._v(" "),_c('button',{staticClass:"si-btn si-btn--ghost",attrs:{"type":"button","disabled":_vm.busy || !_vm.webhookValid},on:{"click":_vm.sendTest}},[_vm._v("\n      "+_vm._s(_vm.testing ? "Sending…" : "Send Test Message")+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"si-btn si-btn--primary",attrs:{"type":"button","disabled":_vm.busy || !_vm.isDirty},on:{"click":_vm.save}},[_vm._v("\n      "+_vm._s(_vm.saving ? "Saving…" : "Save")+"\n    ")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"si-icon"},[_c('i',{staticClass:"mdi mdi-slack"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"si-heading"},[_c('h5',{staticClass:"title si-title"},[_vm._v("Slack Integration")]),_vm._v(" "),_c('p',{staticClass:"si-subtitle"},[_vm._v("Post admin activities (settings changes, approvals, user updates) to a Slack channel.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"si-help"},[_vm._v("\n      In Slack, create an app with "),_c('b',[_vm._v("Incoming Webhooks")]),_vm._v(" turned on, add a webhook to the channel you want, and paste its URL here.\n      "),_c('a',{attrs:{"href":"https://api.slack.com/messaging/webhooks","target":"_blank","rel":"noopener"}},[_vm._v("How to get a webhook URL")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EUqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"card-block"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EgLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLeavesCalculation)?_c('div',{staticClass:"payroll-leaves-calculation-container"},[_c('div',{staticClass:"payroll-leaves-calculation-panel"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"payroll-leaves-calculation-panel-body"},[_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('label',[_vm._v("Remaining Leaves\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.remainingLeaves),expression:"remainingLeaves",modifiers:{"number":true}}],staticClass:"payroll-disabled-field",attrs:{"type":"number","disabled":true,"placeholder":"0","step":"0.5","min":"0"},domProps:{"value":(_vm.remainingLeaves)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.remainingLeaves=_vm._n($event.target.value)},function($event){_vm.remainingLeavesManuallyUpdated = true}],"wheel":function($event){return $event.target.blur()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Carry Forward Leaves")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.forceResetField('carryForwardDays'); }}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":function($event){_vm.isCarryForwardInfoVisible = true},"mouseleave":function($event){_vm.isCarryForwardInfoVisible = false}}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isCarryForwardInfoVisible)?_c('div',{staticClass:"required-hours-tooltip-box",staticStyle:{"width":"230px"}},[_c('b',[_vm._v("Carry Forward Rules ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ul',[_vm._l((_vm.carryForwardRulesList),function(rule,idx){return _c('li',{key:'cf-rule-' + idx},[_vm._v("\n                                        "+_vm._s(rule)+"\n                                    ")])}),_vm._v(" "),_c('li',[_vm._v("Less than 2 leaves → 0 days carried forward")])],2)]):_vm._e()])])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.carryForwardDays),expression:"carryForwardDays",modifiers:{"number":true}}],attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0","step":"0.5"},domProps:{"value":(_vm.carryForwardDays)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.carryForwardDays=_vm._n($event.target.value)},function($event){_vm.carryForwardManuallyUpdated = true}],"wheel":function($event){return $event.target.blur()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Leaves Encashment")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.forceResetField('leavesEncashmentDays'); }}}),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":function($event){_vm.isEncashmentInfoVisible = true},"mouseleave":function($event){_vm.isEncashmentInfoVisible = false}}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isEncashmentInfoVisible)?_c('div',{staticClass:"required-hours-tooltip-box",staticStyle:{"height":"170px","width":"230px"}},[_c('b',[_vm._v("Encashment Rules")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('ul',[_vm._l((_vm.encashmentRulesList),function(rule,idx){return _c('li',{key:'enc-rule-' + idx},[_vm._v("\n                                    "+_vm._s(rule)+"\n                                ")])}),_vm._v(" "),_c('li',[_vm._v("Less than 1 leave → 0 days encashed")])],2)]):_vm._e()])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.leavesEncashmentDays),expression:"leavesEncashmentDays",modifiers:{"number":true}}],class:this.month === 'June' ? 'payroll-disabled-field' : '',attrs:{"type":"number","disabled":_vm.isDisabled || this.month === 'June',"placeholder":"0"},domProps:{"value":(_vm.leavesEncashmentDays)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.leavesEncashmentDays=_vm._n($event.target.value)},_vm.onLeavesEncashmentInput],"wheel":function($event){return $event.target.blur()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("New Leave Quota")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.forceResetField('updatedLeaveQuota'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.updatedLeaveQuota),expression:"updatedLeaveQuota",modifiers:{"number":true}}],attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0","step":"0.5"},domProps:{"value":(_vm.updatedLeaveQuota)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.updatedLeaveQuota=_vm._n($event.target.value)},function($event){_vm.updatedLeaveQuotaManuallyUpdated = true}],"wheel":function($event){return $event.target.blur()},"blur":function($event){return _vm.$forceUpdate()}}})])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-emp-info-panel-header"},[_c('span',{staticClass:"icon"},[_vm._v("📝")]),_vm._v(" "),_c('h2',[_vm._v("Leaves Calculation")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v("(December only):")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v("(December only):")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F8R5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-details-container"},[(_vm.isInitialLoading)?_c('div',{staticClass:"payroll-loader-container"},[_c('div',{staticClass:"payroll-loader-box"},[_c('DoubleLoader',{staticClass:"payroll-loader"})],1)]):_c('div',[_c('Header',{attrs:{"employee":this.employeeData,"show-payroll-container":_vm.showPayrollContainer},on:{"export-excel":_vm.exportPayrollDetails}}),_vm._v(" "),_c('div',{staticClass:"payroll-flex-container-main",staticStyle:{"padding-left":"20px","padding-right":"20px","padding-bottom":"60px"}},[(_vm.showPayrollContainer)?_c('div',{staticClass:"payroll-flex-container"},[_c('div',{staticClass:"payroll-card"},[_c('EmployeeInformation',{ref:"employeeInfo",attrs:{"employee":this.employeeData,"initialValues":this.initialValues},on:{"update-employee":_vm.updateEmployee}}),_vm._v(" "),(_vm.isProcessed)?_c('LeavesCalculation',{ref:"LeavesCalculation",attrs:{"employee":this.employeeData,"initialValues":this.initialValues},on:{"update-leaves":_vm.updateLeaves}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"payroll-card"},[_c('AttendanceDetails',{ref:"attendanceDetails",attrs:{"employee":this.employeeData,"initialValues":this.initialValues},on:{"update-attendance":_vm.updateAttendance}})],1),_vm._v(" "),_c('div',{staticClass:"payroll-card"},[_c('SalaryCalculation',{key:'salary-calc-' + _vm.employeeData.employeeId + '-' + _vm.employeeData.lateDeductionDays,ref:"salaryCalculationRef",attrs:{"employee":this.employeeData,"initialValues":this.initialValues,"paymentProcessedLoaded":this.isPaymentProcessed,"draftLoaded":this.isDrafted,"isActionProcessing":this.isActionProcessing,"isDraftUpdated":this.isDraftUpdated},on:{"save-draft":_vm.handleSaveAsDraft,"update-draft":_vm.handleUpdateDraft,"process-payment":_vm.handleProcessPayroll,"update-salary":_vm.updateSalary,"delete-draft":_vm.handleDeleteDraft}})],1)]):_vm._e(),_vm._v(" "),(!_vm.showPayrollContainer)?_c('div',{staticClass:"no-payroll-card"},[_c('p',{staticClass:"no-payroll-title"},[_vm._v("No Payroll Data")]),_vm._v(" "),_c('p',{staticClass:"no-payroll-subtext"},[_vm._v("We couldn't find any payroll records for the selected period.")])]):_vm._e()]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isConfirmModalOpen,"title":_vm.modalTitle,"submitButtonText":"Yes, Confirm"},on:{"update:modelValue":function($event){_vm.isConfirmModalOpen = $event},"submit":_vm.confirmPayrollAction}},[_c('div',[_vm._v(_vm._s(_vm.modalMessage))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F8TZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Frsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__("l9mu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__ = __webpack_require__("gY6d");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "payslip",
    props: {
        // Optional overrides; by default details come from Settings > Company Details
        company: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        hideActions: {
            type: Boolean,
            default: false
        }

    },
    data: function data() {
        return {
            downloadedOnce: false,
            currentDateTime: new Date().toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }),
            employee: {},
            salaryData: {}
        };
    },

    computed: {
        // `leavesQuota` only exists on June/December records, so default it.
        totalEncashmentDays: function totalEncashmentDays() {
            return (Number(this.employee.leavesEncashmentDays) || 0) + (Number((this.employee.leavesQuota || {}).leavesEncashmentDays) || 0);
        },
        companyInfo: function companyInfo() {
            var constants = this.$store.state.auth.constants || {};
            var company = this.$store.state.auth.company || {};
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                name: company.companyName || "",
                address: constants.companyAddress || "",
                phone: constants.companyPhone || "",
                email: constants.companyEmail || "",
                logo: constants.companyLogoUrl || "",
                software: "Pertime"
            }, this.company);
        },
        companyContact: function companyContact() {
            return [this.companyInfo.phone, this.companyInfo.email].filter(Boolean).join(" • ");
        },
        formattedPerHoursalary: function formattedPerHoursalary() {
            return Number(this.employee.perDaySalary / this.employee.empTotalHours).toFixed(2);
        },
        paymentDate: function paymentDate() {
            var date = this.employee.processedAt ? new Date(this.employee.processedAt) : null;
            if (!date) {
                // Payrolls processed before processedAt was recorded: last day of the payroll month
                var monthIndex = __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["a" /* monthNames */].indexOf(this.employee.month);
                var year = Number(this.employee.year);
                if (monthIndex === -1 || !year) return "-";
                date = new Date(year, monthIndex + 1, 0);
            }
            return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        },
        grossEarnings: function grossEarnings() {
            var totalDaysSalary = Number(this.employee.daysWorked * this.employee.perDaySalary) || 0;
            var bonus = Number(this.employee.bonus) || 0;
            var leavesEncashment = Number(this.employee.leavesEncashmentAmount) || 0;
            var transactionFees = Number(this.employee.transactionFees) || 0;
            var positiveAdjustment = Number(this.employee.extraAmountAdjustment) > 0 ? Number(this.employee.extraAmountAdjustment) : 0;
            var grossEarnings = totalDaysSalary + bonus + leavesEncashment + transactionFees + positiveAdjustment;
            return grossEarnings;
        },
        totalDeductions: function totalDeductions() {
            var lateDeduction = Number(this.employee.lateDeduction) || 0;
            var taxDeduction = Number(this.employee.taxDeduction) || 0;
            var negativeAdjustment = Number(this.employee.extraAmountAdjustment) < 0 ? Math.abs(Number(this.employee.extraAmountAdjustment)) : 0;

            return lateDeduction + taxDeduction + negativeAdjustment;
        }
    },
    methods: {
        formatCurrency: function formatCurrency(amount) {
            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "PKR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount || 0);
        },
        formatPeriod: function formatPeriod(month, year) {
            return month + " " + year;
        },
        generateTransactionId: function generateTransactionId() {
            var chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
            var result = "";
            for (var i = 0; i < 8; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        amountToWords: function amountToWords(num) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__assets_config_helpers__["i" /* convertAmountToWords */])(num);
        },
        formatEmployeeId: function formatEmployeeId(employeeId) {
            if (!employeeId) return "";
            var suffix = employeeId.length >= 5 ? employeeId.slice(-5) : employeeId;
            return "emp_" + suffix;
        },
        formatPayrollId: function formatPayrollId(payrollId) {
            if (!payrollId) return "";
            var suffix = payrollId.length >= 5 ? payrollId.slice(-5) : payrollId;
            return "p_" + suffix;
        },
        downloadPayslip: function downloadPayslip() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var payslipElement, _ref, employeeName, month, year, canvas, imgData, pdf, pdfWidth, pdfHeight;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                payslipElement = _this.$refs.payslip;

                                if (payslipElement) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 3:
                                _ref = _this.employee || {}, employeeName = _ref.employeeName, month = _ref.month, year = _ref.year;
                                _context.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(payslipElement, {
                                    scale: 2, // Increase if quality is low
                                    useCORS: true
                                });

                            case 6:
                                canvas = _context.sent;
                                imgData = canvas.toDataURL('image/png');

                                // A0 size in mm: 841 x 1189

                                pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
                                    orientation: 'portrait',
                                    unit: 'mm',
                                    format: 'a0'
                                });
                                pdfWidth = pdf.internal.pageSize.getWidth();
                                pdfHeight = pdf.internal.pageSize.getHeight();


                                console.log("pdfWidht", pdfWidth);

                                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

                                pdf.save(employeeName + "_" + month + "_" + year + "_Payslip.pdf");

                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        maybeDownloadPayslip: function maybeDownloadPayslip() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var payslipId, storageKey, payslipData;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                payslipId = _this2.$route.params.employeeId;

                                if (!payslipId) {
                                    _context2.next = 14;
                                    break;
                                }

                                storageKey = "payslipData_" + payslipId;
                                payslipData = JSON.parse(localStorage.getItem(storageKey));

                                if (!payslipData) {
                                    _context2.next = 14;
                                    break;
                                }

                                _this2.employee = payslipData.employee;
                                _this2.salaryData = payslipData.salaryData;
                                _this2.employee.status = "Processed";
                                _this2.employee.employeeId = _this2.formatEmployeeId(_this2.employee.employeeId);

                                _this2.downloadedOnce = true; // prevent multiple downloads

                                _context2.next = 12;
                                return _this2.$nextTick();

                            case 12:
                                // wait for DOM to update

                                setTimeout(function () {
                                    _this2.downloadPayslip();
                                }, 100);
                                setTimeout(function () {
                                    if (_this2.employee) {
                                        localStorage.removeItem(storageKey);
                                    }
                                }, 60000);

                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.maybeDownloadPayslip();
    }
});

/***/ }),

/***/ "G3aJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"dropdown-container"},[(_vm.label)?_c('label',{staticStyle:{"text-align":"left"},attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label)+"\n    "),(_vm.required)?_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"custom-dropdown",class:{ 'is-open': _vm.isOpen, 'is-invalid': _vm.showError }},[_c('div',{staticClass:"dropdown-toggle",style:({ width: _vm.width, height: _vm.height }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.toggleDropdown}},[(_vm.custom && _vm.isCustomInput)?_c('span',{staticClass:"selected-text"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customValue),expression:"customValue"}],staticClass:"custom-input",attrs:{"type":"number","placeholder":"Enter custom value"},domProps:{"value":(_vm.customValue)},on:{"blur":_vm.updateCustomValue,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateCustomValue($event)},"input":function($event){if($event.target.composing){ return; }_vm.customValue=$event.target.value}}})]):_c('span',{staticClass:"selected-text"},[_vm._v("\n        "+_vm._s(_vm.selectedValue || _vm.placeholder)+"\n      ")]),_vm._v(" "),_c('i',{staticClass:"dropdown-arrow",class:{ 'is-open': _vm.isOpen }})]),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"dropdown-menu"},[(_vm.search)?_c('div',{staticClass:"search-dropdown"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"searchInput",staticClass:"search-field",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-items"},[_vm._l((_vm.filteredOptions),function(option){return _c('div',{key:option,staticClass:"dropdown-item",class:{ 'selected': option === _vm.selectedValue },on:{"click":function($event){$event.stopPropagation();return _vm.selectOption(option)}}},[_vm._v("\n          "+_vm._s(option)+"\n        ")])}),_vm._v(" "),(_vm.filteredOptions.length === 0)?_c('div',{staticClass:"dropdown-item no-results"},[_vm._v("\n          No results found\n        ")]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),(_vm.showError && _vm.errorMessage)?_c('div',{staticClass:"error-message"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GGDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('AdminActivities',{ref:"fileTable"}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GIso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReuseableModal',
  props: {
    fullOverlay: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    submitButtonText: {
      type: String,
      default: 'Add'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideCancelButton: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '70vh'
    },
    performance: {
      type: Boolean,
      default: false
    }

  },
  emits: ['update:modelValue', 'submit'],
  data: function data() {
    return {
      isWindowLarge: window.innerWidth > 900
    };
  },

  computed: {
    firstLoggedIn: function firstLoggedIn() {
      var auth = this.$store.state.auth;
      if (!auth || !auth.user) {
        return false;
      }
      return !!auth.user.firstLoggedIn;
    },
    modalOverlayClass: function modalOverlayClass() {
      if (this.fullOverlay) return 'modal-overlay1';

      var path = this.$route && this.$route.path;
      var auth = this.$store.state.auth;
      var user = auth && auth.user;
      if (path === '/overview' && user && !user.firstLoggedIn) {
        return 'modal-overlay1';
      }

      return this.isWindowLarge ? 'modal-overlay2' : 'modal-overlay1';
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.isWindowLarge = window.innerWidth > 900;
    }
  }
});

/***/ }),

/***/ "GVUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid",staticStyle:{"height":"100vh","margin":"0","padding":"0"}},[_c('div',{staticClass:"row",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"col-md-12",staticStyle:{"height":"100%","padding":"0"}},[(_vm.policyUrl)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.policyUrl}}):_c('div',{staticStyle:{"padding":"20px","text-align":"center"}},[_vm._v("\n          Company policy has not been configured yet. An admin can set it from Settings > General Settings.\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gawq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"reset-button",class:{ rotating: _vm.isRotating },attrs:{"title":"Reset to original"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-undo"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gg+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"header-card"},[_c('div',{staticClass:"header-left"},[[_c('img',{staticStyle:{"width":"64px","height":"64px","border-radius":"50%","padding":"2px","border":"2px solid gray"},attrs:{"src":_vm.currentUser.profile_picture || 'static/img/default-dp.png',"alt":"avatar"},on:{"click":function($event){return _vm.$router.replace(("/user/" + (_vm.currentUser.uid)))}}})],_vm._v(" "),_c('div',{staticClass:"employee-info"},[_c('h1',{staticClass:"emp-name"},[_vm._v(_vm._s(_vm.currentUser.username))]),_vm._v(" "),_c('p',{staticClass:"emp-role"},[_vm._v(_vm._s(_vm.currentUser.designation))]),_vm._v(" "),_c('div',{staticClass:"badges"},[_c('span',{staticClass:"badge"},[_vm._v("Joined "+_vm._s(_vm.currentUser.joiningDate))]),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.getWorkingDaysText()))])])])],2),_vm._v(" "),_c('div',{staticClass:"header-right"},[_c('span',{staticClass:"status-btn"},[_vm._v("Checked In")]),_vm._v(" "),_c('div',{staticClass:"checkin-time"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.checkIn.checkedIn ? _vm.checkIn.time : '--:-- --'))]),_vm._v(" "),_c('span',{staticClass:"time-label"},[_vm._v(_vm._s(_vm.checkIn.checkedIn ? "Today's check-in time" : "Not checked in yet"))])])])]),_vm._v(" "),_c('div',{staticClass:"stats-row"},_vm._l((_vm.stats),function(stat){return _c('div',{key:stat.label,staticClass:"stat-card"},[(_vm.loading.stats)?[_c('div',{staticClass:"sk sk-label"}),_vm._v(" "),_c('div',{staticClass:"sk sk-value"}),_vm._v(" "),_c('div',{staticClass:"sk sk-sub"}),_vm._v(" "),_c('div',{staticClass:"sk sk-bar"})]:[_c('p',{staticClass:"stat-label"},[_vm._v(_vm._s(stat.label))]),_vm._v(" "),_c('p',{staticClass:"stat-value",style:({ color: stat.color })},[_vm._v(_vm._s(stat.value))]),_vm._v(" "),_c('p',{staticClass:"stat-sub"},[_vm._v(_vm._s(stat.sub))]),_vm._v(" "),_c('div',{staticClass:"stat-bar-track"},[_c('div',{staticClass:"stat-bar-fill",style:({ width: stat.progress + '%', backgroundColor: stat.barColor })})])]],2)}),0),_vm._v(" "),_c('div',{staticClass:"panels-row"},[_c('div',{staticClass:"panel panel-performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"perf-list"},[(_vm.loading.performance)?_vm._l((4),function(n){return _c('div',{key:'sk-perf-' + n,staticClass:"perf-row"},[_c('div',{staticClass:"sk sk-month"}),_vm._v(" "),_c('div',{staticClass:"sk sk-bar-lg"}),_vm._v(" "),_c('div',{staticClass:"sk sk-pct"}),_vm._v(" "),_c('div',{staticClass:"sk sk-badge"})])}):_vm._l((_vm.performance),function(p){return _c('div',{key:p.month,staticClass:"perf-row"},[_c('span',{staticClass:"perf-month"},[_vm._v(_vm._s(p.month))]),_vm._v(" "),_c('div',{staticClass:"perf-bar-track"},[_c('div',{staticClass:"perf-bar-fill",style:({ width: p.pct + '%', backgroundColor: p.color })})]),_vm._v(" "),_c('span',{staticClass:"perf-pct"},[_vm._v(_vm._s(p.display))]),_vm._v(" "),_c('span',{staticClass:"perf-badge",class:p.badgeClass},[_vm._v(_vm._s(p.label))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"panel panel-events"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"event-list"},[(_vm.loading.events)?_vm._l((3),function(n){return _c('div',{key:'sk-evt-' + n,staticClass:"event-row"},[_vm._m(2,true),_vm._v(" "),_vm._m(3,true)])}):[_vm._l((_vm.events),function(ev,i){return _c('div',{key:i,staticClass:"event-row"},[_c('div',{staticClass:"event-date"},[_c('span',{staticClass:"event-day"},[_vm._v(_vm._s(ev.day))]),_vm._v(" "),_c('span',{staticClass:"event-month"},[_vm._v(_vm._s(ev.month))])]),_vm._v(" "),_c('div',{staticClass:"event-details"},[_c('p',{staticClass:"event-title"},[_vm._v(_vm._s(ev.title))]),_vm._v(" "),_c('p',{staticClass:"event-desc"},[_vm._v(_vm._s(ev.desc))]),_vm._v(" "),_c('span',{staticClass:"event-tag",class:ev.tagClass},[_vm._v(_vm._s(ev.tag))])])])}),_vm._v(" "),(!_vm.events.length)?_c('p',{staticClass:"event-empty"},[_vm._v("No upcoming events")]):_vm._e()]],2)])]),_vm._v(" "),_c('div',{staticClass:"panels-row panels-row-single"},[_c('div',{staticClass:"panel panel-payslips"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"payslip-list",class:{ 'payslip-list-single': !_vm.loading.payslips && _vm.payslips.length <= 3 }},[(_vm.loading.payslips)?_vm._l((6),function(n){return _c('div',{key:'sk-pay-' + n,staticClass:"payslip-row"},[_c('div',{staticClass:"sk sk-month"}),_vm._v(" "),_c('div',{staticClass:"sk sk-amount"}),_vm._v(" "),_c('div',{staticClass:"sk sk-btn"})])}):[_vm._l((_vm.payslips),function(slip){return _c('div',{key:slip.key,staticClass:"payslip-row"},[_c('span',{staticClass:"payslip-month"},[_vm._v(_vm._s(slip.month))]),_vm._v(" "),_c('span',{staticClass:"payslip-amount"},[_vm._v(_vm._s(slip.amount))]),_vm._v(" "),_c('button',{staticClass:"download-btn",attrs:{"disabled":slip.downloading},on:{"click":function($event){return _vm.downloadPayslip(slip)}}},[_vm._v("\n              "+_vm._s(slip.downloading ? '...' : 'Download')+"\n            ")])])}),_vm._v(" "),(!_vm.payslips.length)?_c('p',{staticClass:"payslip-empty"},[_vm._v("No processed payslips yet")]):_vm._e()]],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Performance")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("RECENT MONTHS")])]),_vm._v(" "),_c('a',{staticClass:"panel-link",attrs:{"href":"#/performance"}},[_vm._v("View All →")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Upcoming")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("EVENTS & MEETINGS")])]),_vm._v(" "),_c('a',{staticClass:"panel-link",attrs:{"href":"https://calendar.google.com/calendar/u/0/r","target":"_blank"}},[_vm._v("Calendar →")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-date"},[_c('div',{staticClass:"sk sk-day"}),_vm._v(" "),_c('div',{staticClass:"sk sk-mon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-details"},[_c('div',{staticClass:"sk sk-title"}),_vm._v(" "),_c('div',{staticClass:"sk sk-desc"}),_vm._v(" "),_c('div',{staticClass:"sk sk-tag"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Recent Payslips")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("DOWNLOAD HISTORY")])]),_vm._v(" "),_c('a',{staticClass:"panel-link",attrs:{"href":"#/payroll"}},[_vm._v("View All →")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gq4s":
/***/ (function(module, exports) {

module.exports = {"designations":["Executive Leadership","Human Resource","Software Engineer","Intern","Admin","Office Boy","Sales Executive","Business Analyst","Team Lead","Project Manager","Quality Assurance Engineer","Designer (UI/UX)","Marketing Specialist","Customer Support","Technical Lead"]}

/***/ }),

/***/ "GszA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H902":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("r73q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d8ae27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("2U7C");
function injectStyle (ssrContext) {
  __webpack_require__("6h6A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66d8ae27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d8ae27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hgzq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sanitize__ = __webpack_require__("0Fq9");



function buildFormData(_ref) {
  var file = _ref.file,
      filename = _ref.filename,
      uniqueFileId = _ref.uniqueFileId,
      user = _ref.user,
      OPENAI_EMBEDDINGS_KEY = _ref.OPENAI_EMBEDDINGS_KEY,
      MONGODB_Atlas_KEY = _ref.MONGODB_Atlas_KEY,
      dbName = _ref.dbName,
      collectionName = _ref.collectionName;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["a" /* validateFile */])(file);

  if (!user || !user.username) {
    throw new Error("Invalid user object");
  }

  var safeFilename = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["b" /* sanitizeFilename */])(filename);
  var safeUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["c" /* sanitizeString */])(user.username);
  var safeDbName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["c" /* sanitizeString */])(dbName);
  var safeCollectionName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["c" /* sanitizeString */])(collectionName);
  var safeFileId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["c" /* sanitizeString */])(uniqueFileId);
  var safeOpenAiKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["c" /* sanitizeString */])(OPENAI_EMBEDDINGS_KEY);
  var safeMongoKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanitize__["c" /* sanitizeString */])(MONGODB_Atlas_KEY);

  var fd = new FormData();
  fd.append('files', file);
  fd.append('replaceExisting', 'false');
  fd.append('createNewDocStore', 'false');

  if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
    fd.append('loader', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
      name: 'docxFile',
      config: {
        docxFile: "FILE-STORAGE::[\"" + safeFilename + "\"]",
        textSplitter: '',
        metadata: '',
        omitMetadataKeys: ''
      }
    }));
  } else if (file.type === "application/pdf") {
    fd.append('loader', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
      name: 'pdfFile',
      config: {
        pdfFile: "FILE-STORAGE::[\"" + safeFilename + "\"]",
        textSplitter: '',
        metadata: '',
        omitMetadataKeys: ''
      }
    }));
  } else {
    console.warn('Unsupported file type', file.type);
  }

  fd.append('splitter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    name: 'recursiveCharacterTextSplitter',
    config: { chunkSize: 1000, chunkOverlap: 200, "separators": "" }
  }));

  fd.append('embedding', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    name: 'openAIEmbeddings',
    config: { modelName: 'text-embedding-ada-002', credential: safeOpenAiKey }
  }));

  fd.append('vectorStore', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    name: 'mongoDBAtlas',
    config: {
      databaseName: safeDbName,
      collectionName: safeCollectionName,
      indexName: 'vector_index',
      textKey: 'text',
      embeddingKey: 'embedding',
      searchType: 'similarity',
      credential: safeMongoKey
    }
  }));

  fd.append('metadata', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    fileId: safeFileId,
    fileName: filename,
    username: safeUser
  }));

  return fd;
}

/***/ }),

/***/ "HqTQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Htl5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hv92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdownRoot",staticClass:"working-days-dropdown"},[_c('div',{staticClass:"btn-days"},[_c('button',{staticClass:"dropdown-button",style:({ fontSize: _vm.value.option.value === 'custom' ? '8px' : 'inherit' }),on:{"click":_vm.togglePopover}},[_vm._v("\n      "+_vm._s(_vm.getWorkingDaysDisplay(_vm.value))+"\n    ")])]),_vm._v(" "),(_vm.isOpen)?_c('div',{ref:"popover",class:_vm.dropdownPosition === 'top' ? 'popover-content-table-top' : 'popover-content-table-bottom',on:{"click":function($event){$event.stopPropagation();}}},[_c('ul',{staticClass:"dropdwon-list"},_vm._l((_vm.workingDaysOptions),function(option){return _c('li',{key:option.value,staticClass:"option-item",on:{"click":function($event){return _vm.selectOption(option, $event)}}},[_vm._v("\n        "+_vm._s(option.label)+"\n        "),(_vm.tempSelection.option.value === option.value)?_c('span',[_vm._v("✔️")]):_vm._e()])}),0),_vm._v(" "),(_vm.tempSelection.option.value === 'custom')?_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"checkbox-columns"},_vm._l((_vm.daysOfWeek),function(day){return _c('div',{key:day.value,staticClass:"cutom-input-container"},[_c('input',{staticClass:"custom-input",attrs:{"type":"checkbox","id":("day-" + (day.value))},domProps:{"checked":_vm.tempSelection.customDays.includes(day.value)},on:{"change":function($event){return _vm.onCustomDayToggle(day.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("day-" + (day.value))}},[_vm._v(_vm._s(day.label))])])}),0),_vm._v(" "),_c('div',{staticClass:"button-paraent",staticStyle:{"text-align":"right","margin-top":"3px"}},[_c('button',{staticClass:"btn-close",on:{"click":_vm.closeCustomPopover}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn-apply",attrs:{"disabled":_vm.tempSelection.option.value === 'custom' && !_vm.tempSelection.customDays.length && !_vm.isFirstCustomToggle},on:{"click":_vm.applySelection}},[_vm._v("Apply")])])]):_c('div',{staticClass:"button-paraent",staticStyle:{"text-align":"right","margin-top":"10px"}},[_c('button',{staticClass:"btn-close",on:{"click":_vm.closeCustomPopover}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn-apply",on:{"click":_vm.applySelection}},[_vm._v("Apply")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IFYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("gY6d");




var _this = this;



var findCompanyByEmail = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email) {
    var apiOptions, response, status, data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ email: email })
            };
            _context.prev = 1;
            _context.next = 4;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* serverURL */] + "/company/user/find", apiOptions);

          case 4:
            response = _context.sent;
            status = response.status;
            _context.next = 8;
            return response.json();

          case 8:
            data = _context.sent;

            if (!(status !== 200)) {
              _context.next = 11;
              break;
            }

            throw data;

          case 11:
            return _context.abrupt("return", data);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            throw _context.t0;

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 14]]);
  }));

  return function findCompanyByEmail(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createUser = function createUser(data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* serverURL */] + "/company/user", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)
  });
};

var api = {
  findCompanyByEmail: findCompanyByEmail,
  createUser: createUser
};

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ "ILhT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IXZi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ig3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bugReport__ = __webpack_require__("NDXF");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var DESCRIPTION_MIN_LENGTH = 10;
var DESCRIPTION_MAX_LENGTH = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ReuseableModal: __WEBPACK_IMPORTED_MODULE_2__ReuseableModal_vue__["a" /* default */], CustomDropdown: __WEBPACK_IMPORTED_MODULE_3__CustomDropdown_vue__["a" /* default */] },
  props: {
    isOpen: { type: Boolean, default: false },
    fullOverlay: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        email: "",
        description: "",
        priority: "Normal",
        screenshot: null
      },
      priorities: ["Urgent", "High", "Normal", "Low"],
      isImageFile: false,
      isPdfFile: false,
      error: {
        email: "",
        description: "",
        screenshot: ""
      }
    };
  },

  watch: {
    user: {
      immediate: true,
      handler: function handler(user) {
        if (user && user.email) {
          this.form.email = user.email;
        }
      }
    },
    "form.email": function formEmail(val) {
      if (val) this.error.email = "";
    },
    "form.description": function formDescription(val) {
      if (val) this.error.description = "";
    },
    'form.screenshot': function formScreenshot() {
      this.error.screenshot = '';
    },
    "isOpen": function isOpen(newVal) {
      if (!newVal) {
        this.resetForm();
        this.error = { email: '', description: '', screenshot: '' };
      }
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.auth.user || null;
    },
    isUserLoggedIn: function isUserLoggedIn() {
      return !!(this.user && this.user.email);
    }
  },
  methods: {
    isValidEmail: function isValidEmail(email) {
      var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    validateScreenshot: function validateScreenshot(file) {
      if (!file) return true;

      var MAX_SIZE_MB = 5;
      var allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

      if (typeof file === 'string') {
        if (!file.startsWith('data:image/')) {
          return 'Only JPG, JPEG, PNG images are allowed.';
        }

        var sizeInBytes = file.length * 3 / 4;
        if (sizeInBytes > MAX_SIZE_MB * 1024 * 1024) {
          return 'Image size must be less than 5MB.';
        }

        return true;
      }

      if (!allowedTypes.includes(file.type)) {
        return 'Only JPG, JPEG, PNG images are allowed.';
      }

      if (file.size > MAX_SIZE_MB * 1024 * 1024) {
        return 'Image size must be less than 5MB.';
      }

      return true;
    },
    handlePriorityChange: function handlePriorityChange(selectedPriority) {
      this.form.priority = selectedPriority;
    },
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFile: function handleFile(event) {
      var _this = this;

      var file = event.target.files[0];
      if (!file) return;
      if (file.type.startsWith("image/")) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.form.screenshot = e.target.result;
          _this.isImageFile = true;
          _this.isPdfFile = false;
        };
        reader.readAsDataURL(file);
      } else if (file.type === "application/pdf") {
        this.form.screenshot = file;
        this.isImageFile = false;
        this.isPdfFile = true;
      } else {
        this.form.screenshot = file;
        this.isImageFile = false;
        this.isPdfFile = false;
      }
    },
    removeFile: function removeFile() {
      this.form.screenshot = null;
      this.isImageFile = false;
      this.isPdfFile = false;
      this.$refs.fileInput.value = null;
    },
    openFileInNewTab: function openFileInNewTab(file) {
      if (!file) return;
      var url = typeof file === "string" ? file : URL.createObjectURL(file);
      window.open(url, "_blank");
    },
    submitBugReport: function submitBugReport() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var descLength, screenshotValidation, payload, firebaseConfig;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.error = { email: '', description: '', screenshot: '' };

                if (_this2.form.email) {
                  _context.next = 4;
                  break;
                }

                _this2.error.email = "Email is required.";
                return _context.abrupt("return");

              case 4:
                if (_this2.isValidEmail(_this2.form.email)) {
                  _context.next = 7;
                  break;
                }

                _this2.error.email = "Please enter a valid email address.";
                return _context.abrupt("return");

              case 7:
                if (_this2.form.description) {
                  _context.next = 10;
                  break;
                }

                _this2.error.description = "Description is required.";
                return _context.abrupt("return");

              case 10:
                descLength = _this2.form.description.trim().length;

                if (!(descLength < DESCRIPTION_MIN_LENGTH)) {
                  _context.next = 14;
                  break;
                }

                _this2.error.description = "Description must be at least " + DESCRIPTION_MIN_LENGTH + " characters.";
                return _context.abrupt("return");

              case 14:
                if (!(descLength > DESCRIPTION_MAX_LENGTH)) {
                  _context.next = 17;
                  break;
                }

                _this2.error.description = "Description cannot exceed " + DESCRIPTION_MAX_LENGTH + " characters.";
                return _context.abrupt("return");

              case 17:
                screenshotValidation = _this2.validateScreenshot(_this2.form.screenshot);

                if (!(screenshotValidation !== true)) {
                  _context.next = 21;
                  break;
                }

                _this2.error.screenshot = screenshotValidation;
                return _context.abrupt("return");

              case 21:

                _this2.loading = true;

                _context.prev = 22;
                payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_bugReport__["a" /* createBugReportPayload */])(_this2.form);
                firebaseConfig = localStorage.getItem('firebaseConfig') || null;
                _context.next = 27;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_bugReport__["b" /* logBugReport */])(payload, firebaseConfig);

              case 27:
                swal('Success', 'Bug report submitted successfully', 'success');
                _this2.resetForm();
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](22);

                console.error(_context.t0);
                swal('Failed', 'Bug report submission failed', 'error');

              case 35:
                _context.prev = 35;

                _this2.loading = false;
                return _context.finish(35);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[22, 31, 35, 38]]);
      }))();
    },
    resetForm: function resetForm() {
      this.form.description = "";
      this.form.priority = "Normal";
      this.form.screenshot = null;

      if (this.isUserLoggedIn) {
        this.form.email = this.user.email;
      } else {
        this.form.email = "";
      }

      this.isImageFile = false;
      this.isPdfFile = false;

      this.$emit("update:isOpen", false);
    }
  }
});

/***/ }),

/***/ "J7u6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"dropdown-container"},[_c('EmployeeDropdown',{attrs:{"employees":_vm.$store.state.auth.allUsers,"company":_vm.$store.state.auth.company,"defaultFilter":"active"},on:{"update":function($event){_vm.filteredUsers = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"applyleave",on:{"click":_vm.openModal}},[_vm._v("\n                  Apply for leave\n                ")])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('CardsSection',{attrs:{"cards":_vm.cards}})],1),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"loading-text"},[_vm._v("Loading data...")]):_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.leaves,"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"assignees",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.assignees}},[_vm._v(_vm._s(item.assignees || '-'))])]}},{key:"employee",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.employee}},[_vm._v(_vm._s(item.employee || '-'))])]}},{key:"type",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.type}},[_vm._v(_vm._s(item.type || '-'))])]}},{key:"noofdays",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.noofdays}},[_vm._v(_vm._s(item.noofdays || '-'))])]}},{key:"dates",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.dates}},[_vm._v(_vm._s(item.dates || '-'))])]}},{key:"createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(_vm.formatRelativeTime(item.createdAt))+"\n            ")]}},{key:"reason",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.reason}},[_vm._v(_vm._s(item.reason || '-'))])]}},{key:"leavesBalance",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.leavesBalance}},[_vm._v(_vm._s(item.leavesBalance || '-'))])]}},{key:"comment",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.comment}},[_vm._v(_vm._s(item.comment || '-'))])]}},{key:"status",fn:function(ref){
var item = ref.item;
return [(item.status === 'Pending' && _vm.user.uid === item.userId)?_c('div',[_c('button',{staticClass:"withdraw-btn",on:{"click":function($event){$event.stopPropagation();return _vm.withdrawLeave(item)}}},[_vm._v("\n                  Withdraw\n                ")])]):_c('span',{class:_vm.getStatusClass(item.status)},[_vm._v("\n                "+_vm._s(item.status)+"\n              ")])]}},{key:"action",fn:function(ref){
var item = ref.item;
return [_c('button',{staticClass:"btn btn-sm btn-info action-button btn-leave-response",class:{ 'disabled-btn': item.status === 'Auto-Deducted' || _vm.isMonthPassedAndPayrollProcessed(item) || item.status === 'Withdrawn' },attrs:{"disabled":item.status === 'Auto-Deducted' || _vm.isMonthPassedAndPayrollProcessed(item) || item.status === 'Withdrawn'},on:{"click":function($event){return _vm.openActionModal(item)}}},[_vm._v("\n                "+_vm._s(item.status === 'Approved' || item.status === 'Rejected' ? 'Update' : 'Response')+"\n              ")])]}}])})],2)],1)]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isActionModalOpen,"loading":_vm.loading.responseLeaves,"title":"Leave Action","submitButtonText":"Submit"},on:{"update:modelValue":function($event){_vm.isActionModalOpen = $event},"submit":_vm.submitAction}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitAction($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Comment")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeave.comment),expression:"selectedLeave.comment"}],staticClass:"form-control",attrs:{"rows":"2"},domProps:{"value":(_vm.selectedLeave.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedLeave, "comment", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-left":"2px"}},[_c('label',[_vm._v("Status"),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"radio-group"},[_c('div',{staticClass:"radio-single"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeave.status),expression:"selectedLeave.status"}],attrs:{"type":"radio","id":"approved","value":"Approved","name":"leaveStatus","required":""},domProps:{"checked":_vm._q(_vm.selectedLeave.status,"Approved")},on:{"change":function($event){return _vm.$set(_vm.selectedLeave, "status", "Approved")}}}),_vm._v(" "),_c('label',{attrs:{"for":"approved"}},[_vm._v("Approved")])]),_vm._v(" "),_c('div',{staticClass:"radio-single"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeave.status),expression:"selectedLeave.status"}],attrs:{"type":"radio","id":"rejected","value":"Rejected","name":"leaveStatus","required":""},domProps:{"checked":_vm._q(_vm.selectedLeave.status,"Rejected")},on:{"change":function($event){return _vm.$set(_vm.selectedLeave, "status", "Rejected")}}}),_vm._v(" "),_c('label',{attrs:{"for":"rejected"}},[_vm._v("Rejected")])])])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isModalOpen,"title":"Add Leave","loading":_vm.loading.applyLeave,"submitButtonText":"Submit"},on:{"update:modelValue":function($event){_vm.isModalOpen = $event},"submit":_vm.addLeave}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.addLeave($event)}}},[_c('div',{},[_c('CustomDropdown',{attrs:{"required":true,"id":"assignee-dropdown","label":"Assignees","options":_vm.assigneeOptions,"value":_vm.selectedAssigneeName,"placeholder":"Select Assignee","showError":_vm.formSubmitted && 
            !_vm.newLeave.assigneeId,"errorMessage":"Please select an assignee"},on:{"change":_vm.handleAssigneeChange}})],1),_vm._v(" "),_c('div',{},[_c('CustomDropdown',{attrs:{"required":true,"id":"leave-type-dropdown","label":"Leave Type","options":_vm.leaveTypeOptions,"value":_vm.newLeave.type,"placeholder":"Select Leave Type","showError":_vm.formSubmitted && !_vm.newLeave.type,"errorMessage":"Please select a leave type"},on:{"change":_vm.handleLeaveTypeChange}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"18px"}},[_c('label',[_vm._v("Duration")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"8px","display":"flex","align-items":"center","gap":"30px"}},[_c('label',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],attrs:{"type":"radio","value":"full","checked":""},domProps:{"checked":_vm._q(_vm.duration,"full")},on:{"change":function($event){_vm.duration="full"}}}),_vm._v(" Full Day\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],attrs:{"type":"radio","value":"half"},domProps:{"checked":_vm._q(_vm.duration,"half")},on:{"change":function($event){_vm.duration="half"}}}),_vm._v(" Half Day\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"16px"}},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"startDate"}},[_vm._v("Start Date"),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLeave.startDate),expression:"newLeave.startDate"}],staticClass:"form-control",attrs:{"type":"date","id":"startDate","required":""},domProps:{"value":(_vm.newLeave.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newLeave, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"endDate"}},[_vm._v("End Date"),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLeave.endDate),expression:"newLeave.endDate"}],staticClass:"form-control",attrs:{"type":"date","id":"endDate","required":""},domProps:{"value":(_vm.newLeave.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newLeave, "endDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{},[_c('label',{attrs:{"for":"reason"}},[_vm._v("Reason"),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLeave.reason),expression:"newLeave.reason"}],staticClass:"form-control",attrs:{"id":"reason","placeholder":"Type you reason...","required":""},domProps:{"value":(_vm.newLeave.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newLeave, "reason", $event.target.value)}}})])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isWithdrawModalOpen,"title":"Withdraw Leave","loading":_vm.loading.withdrawLeave,"submitButtonText":"Yes, Withdraw"},on:{"update:modelValue":function($event){_vm.isWithdrawModalOpen = $event},"submit":_vm.confirmWithdraw}},[_c('p',{staticClass:"m-0 p-0"},[_vm._v("Are you sure you want to withdraw this leave? This action cannot be undone.")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JElF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_KEY; });
var API_KEY = 'AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw';

/***/ }),

/***/ "JRG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceCriteria_vue__ = __webpack_require__("rNV4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e1e31a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceCriteria_vue__ = __webpack_require__("s9Aa");
function injectStyle (ssrContext) {
  __webpack_require__("we63")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07e1e31a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceCriteria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e1e31a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceCriteria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JW9s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JiyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return designations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return designationGrades; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_UserProfileData_designations_json__ = __webpack_require__("Gq4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_UserProfileData_designations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_UserProfileData_designations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_UserProfileData_designationGrades_json__ = __webpack_require__("nVsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_UserProfileData_designationGrades_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_UserProfileData_designationGrades_json__);



var designations = __WEBPACK_IMPORTED_MODULE_0__data_UserProfileData_designations_json___default.a.designations;
var designationGrades = __WEBPACK_IMPORTED_MODULE_1__data_UserProfileData_designationGrades_json___default.a.designationGrades;

/***/ }),

/***/ "JniN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("qg9l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4142b8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("BIC7");
function injectStyle (ssrContext) {
  __webpack_require__("6Y0e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4142b8e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4142b8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KE/0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KF6g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KKzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0GRW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8af344ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("F8R5");
function injectStyle (ssrContext) {
  __webpack_require__("Htl5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8af344ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8af344ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KM+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchableDropdown_vue__ = __webpack_require__("AAEj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba5bd88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchableDropdown_vue__ = __webpack_require__("N/oY");
function injectStyle (ssrContext) {
  __webpack_require__("VH9K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchableDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba5bd88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchableDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Km+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeComplains_vue__ = __webpack_require__("mAgz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f4caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeComplains_vue__ = __webpack_require__("Dsl7");
function injectStyle (ssrContext) {
  __webpack_require__("s9bF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeComplains_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f4caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeComplains_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kyzy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"dropdown-container"},[_c('EmployeeDropdown',{attrs:{"employees":_vm.$store.state.auth.allUsers,"company":_vm.$store.state.auth.company,"defaultFilter":"active"},on:{"update":function($event){_vm.filteredUsers = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"add-employee",on:{"click":_vm.addEmp}},[_vm._v("Add Employee")])])])]),_vm._v(" "),(_vm.plan === 'free')?_c('div',{staticClass:"text-center py-5",staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","height":"400px"}},[_c('h3',[_vm._v("Upgrade Your Plan!")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v("If you want to access these features, you have to upgrade your plan!")])]):_c('div',[(_vm.loading)?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated",staticStyle:{"width":"100%"},attrs:{"role":"progressbar"}})]):_vm._e(),_vm._v(" "),_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.filteredUsers},scopedSlots:_vm._u([{key:"profile_picture",fn:function(ref){
var item = ref.item;
return [_c('img',{staticStyle:{"width":"32px","height":"32px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":item.profile_picture || 'static/img/default-dp.png',"alt":"avatar"},on:{"click":function($event){return _vm.$router.replace(("/user/" + (item.uid)))}}})]}},{key:"username",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.username}},[_vm._v(_vm._s(item.username || '-'))])]}},{key:"designation",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.designation}},[_vm._v(_vm._s(item.designation || '-'))])]}},{key:"grade",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.grade}},[_vm._v(_vm._s(item.grade || '-'))])]}},{key:"joiningDate",fn:function(ref){
var item = ref.item;
return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.joiningDate),expression:"item.joiningDate"}],staticClass:"meeting-date-input",attrs:{"type":"date"},domProps:{"value":(item.joiningDate)},on:{"change":function($event){return _vm.updateMeetingDate(item, 'joiningDate', item.joiningDate)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "joiningDate", $event.target.value)}}})]}},{key:"companyEmail",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.companyEmail}},[_vm._v(_vm._s(item.companyEmail || '-'))])]}},{key:"personalEmail",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.personalEmail}},[_vm._v(_vm._s(item.personalEmail || '-'))])]}},{key:"dateOfBirth",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.dateOfBirth}},[_vm._v(_vm._s(item.dateOfBirth || '-'))])]}},{key:"nationality",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.nationality}},[_vm._v(_vm._s(item.nationality || '-'))])]}},{key:"maritalStatus",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.maritalStatus}},[_vm._v(_vm._s(item.maritalStatus || '-'))])]}},{key:"currentAddress",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.currentAddress}},[_vm._v(_vm._s(item.currentAddress || '-'))])]}},{key:"permanentAddress",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.permanentAddress}},[_vm._v(_vm._s(item.permanentAddress || '-'))])]}},{key:"emergencyContactName",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.emergencyContactName}},[_vm._v(_vm._s(item.emergencyContactName || '-'))])]}},{key:"emergencyContactNumber",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.emergencyContactNumber}},[_vm._v(_vm._s(item.emergencyContactNumber ||
                    '-'))])]}},{key:"role",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"position":"absolute","width":"140px","margin-top":"2px","margin-left":"8px","height":"20px","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.isCurrentUserAdmin)?_c('CustomDropdown',{attrs:{"id":"role","options":_vm.roleOptions,"value":item.role,"placeholder":'Select Role',"disabled":!_vm.isCurrentUserAdmin,"height":'30px'},on:{"change":function($event){return _vm.changeRole($event, item)}}}):_c('span',[_vm._v(_vm._s(item.role || '-'))])],1)])]}},{key:"nicImageUrl",fn:function(ref){
                    var item = ref.item;
return [(item.nicImageUrl)?_c('span',{staticClass:"view-cnic"},[_c('a',{attrs:{"href":item.nicImageUrl,"target":"_blank"}},[_vm._v("View CNIC")])]):_c('span',[_vm._v("-")])]}},{key:"certificateUrl",fn:function(ref){
                    var item = ref.item;
return [(item.certificateUrl)?_c('span',{staticClass:"view-letter"},[_c('a',{attrs:{"href":item.certificateUrl,"target":"_blank"}},[_vm._v("View Letter")])]):_c('span',[_vm._v("-")])]}},{key:"salarySlipUrl",fn:function(ref){
                    var item = ref.item;
return [(item.salarySlipUrl)?_c('span',{staticClass:"view-slip"},[_c('a',{attrs:{"href":item.salarySlipUrl,"target":"_blank"}},[_vm._v("View Slip")])]):_c('span',[_vm._v("-")])]}},{key:"active",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"position":"absolute","margin-top":"2px","width":"140px","margin-left":"8px","height":"20px","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.isCurrentUserAdmin)?_c('CustomDropdown',{attrs:{"id":"active","options":_vm.activeOptions,"value":item.isActive ? 'Active' : 'InActive',"placeholder":'Select Status',"disabled":!_vm.isCurrentUserAdmin,"height":'30px'},on:{"change":function($event){return _vm.changeStatus($event === 'Active', item)}}}):_c('span',[_vm._v(_vm._s(item.isActive ? 'Active' : 'InActive'))])],1)])]}},{key:"status",fn:function(ref){
                    var item = ref.item;
return [(!item)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("No item data")]):_c('Status',{attrs:{"item":item,"isAdmin":_vm.isCurrentUserAdmin,"displayMode":"status"},on:{"status-change":_vm.openStatusChangeModal}})]}},{key:"promotionInfo",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticClass:"promotion-info"},[(item.promotionInfo && item.promotionInfo.length)?_c('div',{staticClass:"promotion-header",on:{"click":function($event){return _vm.togglePromotions(item)}}},[(!item.isPromotionExpanded)?_c('span',[_vm._v("View Notes ("+_vm._s(item.promotionInfo && item.promotionInfo.length || 0)+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(!item.promotionInfo || !item.promotionInfo.length)?_c('div',{staticClass:"add-note",on:{"click":function($event){return _vm.togglePromotions(item)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add First Note\n                    ")]):_vm._e()])]}},{key:"nextQuarterlyMeeting",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticClass:"meeting-cell"},[(item.nextQuarterlyMeetingDetails ? item.nextQuarterlyMeetingDetails.date : item.nextQuarterlyMeeting)?[_c('span',{staticClass:"icon-btn",attrs:{"title":"Edit meeting"},on:{"click":function($event){return _vm.openMeetingModal(item, 'quarterly')}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('span',{staticClass:"meeting-date"},[_vm._v("\n                        "+_vm._s(_vm.formatDate(item.nextQuarterlyMeetingDetails ? item.nextQuarterlyMeetingDetails.date : item.nextQuarterlyMeeting) || '-')+"\n                      ")])]:_c('span',{staticClass:"schedule-meeting",on:{"click":function($event){return _vm.openMeetingModal(item, 'quarterly')}}},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v("mdi-calendar")]),_vm._v("\n                      Schedule Meeting\n                    ")],1)],2)]}},{key:"nextIncrementReview",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticClass:"meeting-cell"},[(item.nextIncrementMeetingDetails ? item.nextIncrementMeetingDetails.date : item.nextIncrementReview)?[_c('span',{staticClass:"icon-btn",attrs:{"title":"Edit meeting"},on:{"click":function($event){return _vm.openMeetingModal(item, 'increment')}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('span',{staticClass:"meeting-date"},[_vm._v("\n                        "+_vm._s(_vm.formatDate(item.nextIncrementMeetingDetails ? item.nextIncrementMeetingDetails.date : item.nextIncrementReview) || '-')+"\n                      ")])]:_c('span',{staticClass:"schedule-meeting",on:{"click":function($event){return _vm.openMeetingModal(item, 'increment')}}},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v("mdi-calendar")]),_vm._v("\n                      Schedule Meeting\n                    ")],1)],2)]}},{key:"resignationDate",fn:function(ref){
                    var item = ref.item;
return [(!item)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("No item data")]):_c('Status',{attrs:{"item":item,"isAdmin":_vm.isCurrentUserAdmin,"displayMode":"resignationDate"}})]}},{key:"lastWorkingDate",fn:function(ref){
                    var item = ref.item;
return [(item.status === 'Resigned')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.lastWorkingDate),expression:"item.lastWorkingDate"}],staticClass:"meeting-date-input",attrs:{"type":"date"},domProps:{"value":(item.lastWorkingDate)},on:{"change":function($event){return _vm.updateMeetingDate(item, 'lastWorkingDate', item.lastWorkingDate)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "lastWorkingDate", $event.target.value)}}}):_c('span',[_vm._v("-")])]}},{key:"durationSpent",fn:function(ref){
                    var item = ref.item;
return [_c('span',{staticClass:"truncate-text"},[_vm._v(_vm._s(_vm.calculateDuration(item) || '-'))])]}},{key:"shift",fn:function(ref){
                    var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.shift}},[_vm._v(_vm._s(item.shift ? (item.shift.charAt(0).toUpperCase() + item.shift.slice(1)) : 'Morning'))])]}},{key:"action",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"edit-btn btn-status",attrs:{"title":"Edit"},on:{"click":function($event){return _vm.$router.push(("/user/" + (item.uid)))}}},[_c('PencilIcon',{attrs:{"color":"gray","width":16,"height":16}})],1),_vm._v(" "),_c('div',{staticClass:"login-btn btn-status",attrs:{"title":"Login as Employee"},on:{"click":function($event){return _vm.loginAsEmployee(item)}}},[_c('i',{staticClass:"fa fa-sign-in-alt",staticStyle:{"color":"gray"}})]),_vm._v(" "),_c('div',{staticClass:"delete-btn btn-status",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.delEmp(item)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"gray"}})])])]}}])})],1)],2)],1)])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeleteModalOpen,"title":"Confirm Deletion","submitButtonText":"Delete"},on:{"update:modelValue":function($event){_vm.isDeleteModalOpen = $event},"submit":_vm.confirmDelete}},[_c('div',[_vm._v("Are you sure you want to delete this user?")])]),_vm._v(" "),_c('MeetingModal',{attrs:{"modelValue":_vm.showModal,"meeting":_vm.selectedMeeting,"loading":_vm.loadings,"users":_vm.filteredUsers,"selectedEmployee":_vm.selectedUser,"meetingType":_vm.meetingType},on:{"save":_vm.saveMeeting,"delete":_vm.deleteMeeting,"update:modelValue":function($event){_vm.showModal = $event}}}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isEmployeeModalOpen,"title":"Add Employee","isLarge":true,"submitButtonText":"Save","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isEmployeeModalOpen = $event},"submit":function($event){return _vm.addEmployee()}}},[_c('form',{staticStyle:{"padding":"10px 0px"},on:{"submit":function($event){$event.preventDefault();return _vm.addEmployee()}}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Full Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.nameError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.nameError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","placeholder":"user@expertizo.pk"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.emailError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"designation"}},[_vm._v("Designation")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"designation","label":"","options":_vm.designations,"value":_vm.designation,"placeholder":"Select your designation","show-error":false},on:{"change":_vm.onDesignationChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"grade"}},[_vm._v("Grade")]),_vm._v(" "),_c('GradeDropdown',{attrs:{"id":"grade","designation":_vm.designation,"designationGrades":_vm.designationGrades,"placeholder":"Select Grade","show-error":false},on:{"change":_vm.onGradeChange},model:{value:(_vm.grade),callback:function ($$v) {_vm.grade=$$v},expression:"grade"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"margin-top":"-15px"}},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"shift"}},[_vm._v("Shift "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"shift","options":_vm.shiftOptions,"value":_vm.shift,"placeholder":"Select Shift","show-error":!!_vm.shiftError},on:{"change":_vm.onShiftChange}}),_vm._v(" "),(_vm.shiftError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.shiftError))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"checkbox-box",staticStyle:{"display":"flex","align-items":"center","margin-top":"-15px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isAdmin),expression:"isAdmin"}],staticClass:"checkbox",staticStyle:{"width":"15px","height":"15px","margin-top":"5px"},attrs:{"type":"checkbox","id":"isAdmin"},domProps:{"checked":Array.isArray(_vm.isAdmin)?_vm._i(_vm.isAdmin,null)>-1:(_vm.isAdmin)},on:{"change":function($event){var $$a=_vm.isAdmin,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isAdmin=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isAdmin=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isAdmin=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"width":"max-content","margin-top":"8px"},attrs:{"for":"isAdmin"}},[_vm._v("Is Admin")])])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isPromotionModalOpen,"title":_vm.promotionEditIndex !== null ? 'Edit Note' : 'Add Note',"submitButtonText":"Save"},on:{"update:modelValue":function($event){_vm.isPromotionModalOpen = $event},"submit":_vm.savePromotion}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Note")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.promotionText),expression:"promotionText"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":"e.g. Increased salary from Rs. 70,000 to Rs. 75,000 on 1st Sept 2025"},domProps:{"value":(_vm.promotionText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promotionText=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSalaryPromotion),expression:"isSalaryPromotion"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isSalaryPromotion)?_vm._i(_vm.isSalaryPromotion,null)>-1:(_vm.isSalaryPromotion)},on:{"change":function($event){var $$a=_vm.isSalaryPromotion,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSalaryPromotion=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSalaryPromotion=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSalaryPromotion=$$c}}}}),_vm._v("\n          This is a salary increment\n        ")])]),_vm._v(" "),(_vm.isSalaryPromotion)?_c('div',{staticClass:"salary-fields mt-3"},[_c('label',[_vm._v("New Basic Salary")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newBasicSalary),expression:"newBasicSalary",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"e.g. 75000"},domProps:{"value":(_vm.newBasicSalary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newBasicSalary=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"mt-2"},[_vm._v("New Extra Allowance")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newExtraAllowance),expression:"newExtraAllowance",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"e.g. 5000"},domProps:{"value":(_vm.newExtraAllowance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newExtraAllowance=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]):_vm._e()]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isStatusChangeModalOpen,"title":"Send Employment Status Change Notification","xlarge":true,"scrollable":true,"submitButtonText":"Send & Update Status","loading":_vm.isSubmitting},on:{"update:modelValue":function($event){_vm.isStatusChangeModalOpen = $event},"submit":_vm.submitStatusChange}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"15px"}},[_c('div',{staticClass:"info-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Employee:")]),_vm._v(" "+_vm._s(_vm.selectedEmployee.username || '')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Old Employment Status:")]),_vm._v(" "+_vm._s(_vm.oldStatus)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row mt-1"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("New Employment Status:")]),_vm._v(" "+_vm._s(_vm.newStatus)+"\n            ")]),_vm._v(" "),((_vm.newStatus === 'Resigned') || (_vm.newStatus === 'Terminated'))?_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Notice Period:")]),_vm._v(" "),(_vm.newStatus === 'Resigned')?_c('span',[_vm._v(_vm._s(_vm.noticePeriodDays())+" days")]):_vm._e(),_vm._v(" "),(_vm.newStatus === 'Terminated')?_c('span',[_vm._v("Immediate (No Notice period)")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("\n            To "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"user-pill"},[_c('img',{staticClass:"avatar",staticStyle:{"width":"36px","height":"36px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":_vm.selectedEmployee.profile_picture || 'static/img/default-dp.png',"alt":"avatar"}}),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(_vm.selectedEmployee.username || ""))]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.selectedEmployee.email))])])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("\n            Email will be send to this employee\n          ")])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"cc-label"},[_vm._v("\n            CC (Select recipients to copy)\n          ")]),_vm._v(" "),_c('div',{staticClass:"cc-container"},_vm._l((_vm.companyEmployees),function(user){return _c('div',{key:user.uid,staticClass:"cc-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ccRecipients),expression:"ccRecipients"}],staticClass:"cc-checkbox",staticStyle:{"margin-top":"10px"},attrs:{"type":"checkbox"},domProps:{"value":user.email,"checked":Array.isArray(_vm.ccRecipients)?_vm._i(_vm.ccRecipients,user.email)>-1:(_vm.ccRecipients)},on:{"change":function($event){var $$a=_vm.ccRecipients,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.email,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ccRecipients=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ccRecipients=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ccRecipients=$$c}}}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"10px"}},[_c('img',{staticClass:"cc-avatar",staticStyle:{"width":"32px","height":"32px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":user.profile_picture || 'static/img/default-dp.png',"alt":"avatar"}}),_vm._v(" "),_c('div',{staticClass:"cc-info"},[_c('div',{staticClass:"cc-name"},[_vm._v("\n                    "+_vm._s(user.username || "")+"\n                    "),(user.role === 'admin')?_c('span',{staticClass:"admin-badge"},[_vm._v("Admin")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cc-email"},[_vm._v("\n                    "+_vm._s(user.email)+"\n                  ")])])])])}),0),_vm._v(" "),(_vm.errors.ccRecipients)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.ccRecipients))]):_c('small',{staticClass:"text-muted"},[_vm._v("\n            "+_vm._s(_vm.ccRecipients.length)+" recipients selected for CC\n            (Admins pre-selected by default)\n          ")])]),_vm._v(" "),(_vm.newStatus === 'Terminated')?_c('div',[_c('label',[_vm._v("\n            Termination Date "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.terminationDate),expression:"terminationDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.terminationDate)},on:{"change":_vm.updateEmailBodyDates,"input":function($event){if($event.target.composing){ return; }_vm.terminationDate=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v("Note:")]),_vm._v(" Termination is effective immediately. Last working date is the same as the termination date.\n          ")])]):_vm._e(),_vm._v(" "),(_vm.newStatus === 'Resigned')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("\n              Resignation Approval Date "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resignationApprovalDate),expression:"resignationApprovalDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.resignationApprovalDate)},on:{"change":_vm.updateEmailBodyDates,"input":function($event){if($event.target.composing){ return; }_vm.resignationApprovalDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Last Working Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastWorkingDate),expression:"lastWorkingDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.lastWorkingDate)},on:{"change":_vm.updateEmailBodyDates,"input":function($event){if($event.target.composing){ return; }_vm.lastWorkingDate=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("\n              Auto-calculated: +"+_vm._s(_vm.noticePeriodDays())+" days from approval date\n              (can be manually adjusted)\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',[_c('label',[_vm._v("\n            Subject "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject),expression:"subject"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject=$event.target.value}}}),_vm._v(" "),(_vm.errors.subject)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.subject))]):_c('small',{staticClass:"text-muted"},[_vm._v("\n            Auto generated, but you can edit it\n          ")])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"mt-2"},[_vm._v("\n            Email Body "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailBody),expression:"emailBody"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.emailBody)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailBody=$event.target.value}}}),_vm._v(" "),(_vm.errors.emailBody)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.emailBody))]):_c('small',{staticClass:"text-muted"},[_vm._v("\n            Auto generated based on employment status change, fully editable\n          ")])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isNotesModalOpen,"title":'Notes for ' + (_vm.selectedEmployee.username || ''),"isLarge":true,"scrollable":true,"submitButtonText":"Save & Preview Email","loading":_vm.isSubmitting},on:{"update:modelValue":function($event){_vm.isNotesModalOpen = $event},"submit":_vm.submitNote}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"20px"}},[(_vm.selectedEmployee && _vm.selectedEmployee.promotionInfo && _vm.selectedEmployee.promotionInfo.length)?_c('div',[_c('p',{staticStyle:{"font-weight":"800"}},[_vm._v("Existing Notes")]),_vm._v(" "),_vm._l((_vm.selectedEmployee.promotionInfo),function(note,index){return _c('div',{key:note.id,ref:index === _vm.selectedEmployee.promotionInfo.length - 1 ? 'lastNote' : null,refInFor:true,staticClass:"note-card"},[_c('div',{staticClass:"note-header"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"10px"}},[_c('span',{staticClass:"badge",style:({ backgroundColor: note.isSalaryPromotion ? '#d1e7dd' : '#cfe2ff', color: note.isSalaryPromotion ? '#0f5132' : '#084298' })},[_vm._v("\n                  "+_vm._s(note.isSalaryPromotion ? 'Salary Increment' : 'Regular Note')+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"note-date"},[_vm._v(_vm._s(_vm.formatDate(note.effectiveDate) || _vm.formatDate(note.createdAt)))])]),_vm._v(" "),_c('i',{staticClass:"far fa-trash-alt",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openDeletePromotionModal(index, note)}}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(note.text || ( note.isSalaryPromotion ? '' : 'No note content available.' )))]),_vm._v(" "),(note.type && note.type === 'increment')?_c('div',{staticClass:"salary-box"},[_c('div',[_vm._v("Old Salary: PKR "+_vm._s(note.oldSalary.toLocaleString('en-PK')))]),_vm._v(" "),_c('div',[_vm._v("New Salary: PKR "+_vm._s((note.newBasicSalary + note.newExtraAllowance).toLocaleString('en-PK')))]),_vm._v(" "),_c('div',{staticClass:"text-success"},[_vm._v("\n                Increment: Rs. "+_vm._s(note.increment.toLocaleString('en-PK'))+" ("+_vm._s(note.percentage)+"%)\n              ")])]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.selectedEmployee && _vm.selectedEmployee.promotionInfo && _vm.selectedEmployee.promotionInfo.length)?_c('hr',{staticStyle:{"margin-top":"0","margin-bottom":"0"}}):_vm._e(),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"font-weight":"800"}},[_vm._v("Add New Note")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('label',{staticStyle:{"font-weight":"500"}},[_vm._v("Note Type")]),_vm._v(" "),_c('div',{staticClass:"d-flex gap-3 mt-1"},[_c('label',{staticStyle:{"width":"min-content"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.noteType),expression:"noteType"}],attrs:{"type":"radio","value":"regular"},domProps:{"checked":_vm._q(_vm.noteType,"regular")},on:{"change":function($event){_vm.noteType="regular"}}}),_vm._v("\n                Regular Note\n              ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.noteType),expression:"noteType"}],attrs:{"type":"radio","value":"increment"},domProps:{"checked":_vm._q(_vm.noteType,"increment")},on:{"change":function($event){_vm.noteType="increment"}}}),_vm._v("\n                Salary Increment\n              ")])])]),_vm._v(" "),(_vm.noteType === 'increment')?_c('div',{staticClass:"salary-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Current Salary")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentSalary),expression:"currentSalary"}],staticClass:"form-control",staticStyle:{"background":"#ffffff"},attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.currentSalary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentSalary=$event.target.value}}}),_vm._v(" "),(_vm.notesErrors.currentSalary)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.notesErrors.currentSalary))]):_c('small',{staticClass:"text-muted"},[_vm._v("\n                  "+_vm._s("Basic Salary: " + _vm.selectedEmployee.basicSalary + " and Extra Allowance: " + _vm.selectedEmployee.extraAllowance)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("New Basic Salary "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBasicSalary),expression:"newBasicSalary"}],staticClass:"form-control",staticStyle:{"background":"#ffffff"},attrs:{"type":"number"},domProps:{"value":(_vm.newBasicSalary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newBasicSalary=$event.target.value}}}),_vm._v(" "),(_vm.notesErrors.newBasicSalary)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.notesErrors.newBasicSalary))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("New Extra Allowance "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newExtraAllowance),expression:"newExtraAllowance"}],staticClass:"form-control",staticStyle:{"background":"#ffffff"},attrs:{"type":"number"},domProps:{"value":(_vm.newExtraAllowance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newExtraAllowance=$event.target.value}}}),_vm._v(" "),(_vm.notesErrors.newExtraAllowance)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.notesErrors.newExtraAllowance))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Effective Date "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.effectiveDate),expression:"effectiveDate"}],staticClass:"form-control",staticStyle:{"background":"#ffffff"},attrs:{"type":"date"},domProps:{"value":(_vm.effectiveDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.effectiveDate=$event.target.value}}}),_vm._v(" "),(_vm.notesErrors.effectiveDate)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.notesErrors.effectiveDate))]):_vm._e()])]),_vm._v(" "),(_vm.currentSalary && _vm.newBasicSalary && _vm.newExtraAllowance)?_c('div',{staticClass:"increment-box"},[_vm._v("\n              Increment: PKR\n              "+_vm._s((Number(_vm.newBasicSalary) + Number(_vm.newExtraAllowance) - Number(_vm.currentSalary)).toLocaleString('en-PK'))+"\n              ("+_vm._s(_vm.calculatePercentage())+"%)\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('label',{staticStyle:{"font-weight":"500"}},[_vm._v("Note Content")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.noteContent),expression:"noteContent"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":_vm.noteType === 'increment' ? 'Enter note about salary increment (e.g., reason, performance highlights)' : 'Enter note content'},domProps:{"value":(_vm.noteContent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.noteContent=$event.target.value}}}),_vm._v(" "),(_vm.notesErrors.noteContent)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.notesErrors.noteContent))]):_c('small',{staticClass:"text-muted"},[_vm._v("\n              "+_vm._s(_vm.noteType === 'increment' ? "This note will be included in the salary increment email" : "This note will be included in the notification email")+"\n            ")])])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isNotesEmailPreviewModalOpen,"title":"Review & Send Note Email","isLarge":true,"scrollable":true,"submitButtonText":"Send Email and Save Note","loading":_vm.isSubmitting},on:{"update:modelValue":function($event){_vm.isNotesEmailPreviewModalOpen = $event},"submit":_vm.submitNote}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"18px"}},[_c('div',{staticClass:"info-box",staticStyle:{"background":"#f0f6ff","border-radius":"10px","padding":"16px 20px","border":"1px solid #d0e4ff"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"6px"}},[_c('div',[_c('span',{staticStyle:{"color":"#2a6db5","font-weight":"600"}},[_vm._v("Employee: ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#2a6db5"}},[_vm._v(_vm._s(_vm.selectedEmployee.username || ''))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#2a6db5","font-weight":"600"}},[_vm._v("Note Type: ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#2a6db5"}},[_vm._v(_vm._s(_vm.noteType === 'increment' ? 'Salary Increment' : 'Regular Note'))])]),_vm._v(" "),(_vm.noteType === 'increment')?_c('hr',{staticStyle:{"border-color":"#c8dff8","margin":"6px 0"}}):_vm._e(),_vm._v(" "),(_vm.noteType === 'increment')?_c('div',[_c('div',[_c('span',{staticStyle:{"color":"#2a6db5","font-weight":"600"}},[_vm._v("Salary Details:")])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#2a6db5"}},[_vm._v("Current Salary: Rs. "+_vm._s(Number(_vm.currentSalary).toLocaleString('en-PK')))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#2a6db5"}},[_vm._v("New Salary: Rs. "+_vm._s((Number(_vm.newBasicSalary) +
                  Number(_vm.newExtraAllowance)).toLocaleString('en-PK')))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"green"}},[_vm._v("Increment: Rs. "+_vm._s((Number(_vm.newBasicSalary) + Number(_vm.newExtraAllowance) -
                  Number(_vm.currentSalary)).toLocaleString('en-PK'))+" ("+_vm._s(_vm.calculatePercentage())+"%)")])])]):_vm._e()])]),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"font-weight":"500","margin-bottom":"6px","display":"block"}},[_vm._v("\n            To "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"12px","background":"#f3fbf4","border":"1px solid #c3e6cb","border-radius":"8px","padding":"10px 14px"}},[_c('img',{staticStyle:{"width":"36px","height":"36px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":_vm.selectedEmployee.profile_picture || 'static/img/default-dp.png',"alt":"avatar"}}),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.selectedEmployee.username || ""))]),_vm._v(" "),_c('div',{staticStyle:{"color":"#888","font-size":"13px"}},[_vm._v(_vm._s(_vm.selectedEmployee.email))])])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Email will be sent to this employee")])]),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"font-weight":"500","margin-bottom":"6px","display":"block"}},[_vm._v("\n            CC "),_c('span',{staticStyle:{"color":"#888","font-weight":"400"}},[_vm._v("(Select recipients to copy)")])]),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid #ddd","border-radius":"8px","overflow":"hidden"}},_vm._l((_vm.companyEmployees),function(user){return _c('div',{key:user.uid,staticStyle:{"display":"flex","align-items":"center","gap":"12px","padding":"10px 14px","border-bottom":"1px solid #f0f0f0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ccRecipients),expression:"ccRecipients"}],staticClass:"cc-checkbox",staticStyle:{"margin-top":"10px"},attrs:{"type":"checkbox"},domProps:{"value":user.email,"checked":Array.isArray(_vm.ccRecipients)?_vm._i(_vm.ccRecipients,user.email)>-1:(_vm.ccRecipients)},on:{"change":function($event){var $$a=_vm.ccRecipients,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.email,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ccRecipients=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ccRecipients=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ccRecipients=$$c}}}}),_vm._v(" "),_c('img',{staticStyle:{"width":"36px","height":"36px","border-radius":"20px","padding":"2px","border":"2px solid gray"},attrs:{"src":user.profile_picture || 'static/img/default-dp.png',"alt":"avatar"}}),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"font-weight":"500","display":"flex","align-items":"center","gap":"6px"}},[_vm._v("\n                  "+_vm._s(user.username || "")+"\n                  "),(user.role === 'admin')?_c('span',{staticStyle:{"font-size":"11px","background":"#ede9fe","color":"#7c3aed","border-radius":"4px","padding":"1px 7px","font-weight":"500"}},[_vm._v("\n                    Admin\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"color":"#888","font-size":"13px"}},[_vm._v(_vm._s(user.email))])])])}),0),_vm._v(" "),(_vm.errors.ccRecipients)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.ccRecipients))]):_c('small',{staticStyle:{"color":"#2563eb","font-size":"12px"}},[_vm._v("\n            "+_vm._s(_vm.ccRecipients.length)+" recipient(s) selected for CC\n            "),_c('span',{staticStyle:{"color":"#888"}},[_vm._v("(Admins pre-selected by default)")])])]),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"font-weight":"500","margin-bottom":"6px","display":"block"}},[_vm._v("\n            Subject "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject),expression:"subject"}],staticClass:"form-control",staticStyle:{"border-radius":"8px"},attrs:{"type":"text"},domProps:{"value":(_vm.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject=$event.target.value}}}),_vm._v(" "),(_vm.errors.subject)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.subject))]):_c('small',{staticClass:"text-muted"},[_vm._v("Auto-generated, but you can edit it")])]),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"font-weight":"500","margin-bottom":"6px","display":"block"}},[_vm._v("\n            Email Body "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailBody),expression:"emailBody"}],staticClass:"form-control",staticStyle:{"font-family":"monospace","font-size":"13px","border-radius":"8px","resize":"vertical"},attrs:{"rows":"8"},domProps:{"value":(_vm.emailBody)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailBody=$event.target.value}}}),_vm._v(" "),(_vm.errors.emailBody)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.emailBody))]):_c('small',{staticClass:"text-muted"},[_vm._v("Auto-generated based on note type, fully editable")])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeletePromotionModalOpen,"title":"Confirm Deletion","submitButtonText":"Delete","loading":_vm.loadings.deletingNote},on:{"update:modelValue":function($event){_vm.isDeletePromotionModalOpen = $event},"submit":_vm.deleteNote}},[_c('div',[_vm._v("Are you sure you want to delete this note?")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KzeF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L9U3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"dropdown-container"},[(_vm.label)?_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"custom-dropdown",class:{ 'is-open': _vm.isOpen, 'is-invalid': _vm.showError }},[_c('button',{staticClass:"dropdown-toggle",attrs:{"type":"button","id":_vm.id,"disabled":_vm.disabled},on:{"click":_vm.toggleDropdown}},[_c('span',{staticClass:"selected-text"},[_vm._v("\n        "+_vm._s(_vm.selectedLabel || _vm.placeholder)+"\n      ")]),_vm._v(" "),_c('i',{staticClass:"dropdown-arrow",class:{ 'is-open': _vm.isOpen }})]),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"dropdown-menu",style:({ maxHeight: _vm.maxHeight + 'px' })},[_c('div',{staticClass:"search-dropdown"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"searchInput",staticClass:"search-field",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"dropdown-items"},[(_vm.filteredGrades.length > 0)?_vm._l((_vm.filteredGrades),function(option){return _c('div',{key:option.value,staticClass:"dropdown-item",class:{ 'selected': option.value.toString() === _vm.selectedValue },on:{"click":function($event){$event.stopPropagation();return _vm.selectOption(option)}}},[_vm._v("\n            "+_vm._s(option.label)+"\n          ")])}):_c('div',{staticClass:"dropdown-item no-results"},[_vm._v("\n          No results found\n        ")])],2)]):_vm._e()]),_vm._v(" "),(_vm.showError && _vm.errorMessage)?_c('div',{staticClass:"error-message"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L9Zj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LDEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadChatbot;
/* harmony export (immutable) */ __webpack_exports__["b"] = unloadChatbot;
function loadChatbot() {
  if (window.flowiseLoaded) return;
  window.flowiseLoaded = true;
  var chatflowid = "9333c39b-2db6-4b0f-b167-c774914f0429";

  var script = document.createElement("script");
  script.id = "flowise-script";
  script.type = "module";

  script.innerHTML = "\n      import Chatbot from \"https://cdn.jsdelivr.net/npm/flowise-embed/dist/web.js\";\n  \n      Chatbot.init({\n        chatflowid: \"" + chatflowid + "\",\n        apiHost: \"https://cloud.flowiseai.com\",\n        theme: {\n          button: {\n            backgroundColor: '#435851',\n            dragAndDrop: true,\n            iconColor: 'white',\n          },\n          chatWindow: {\n            userMessage: {\n              backgroundColor: '#435851',\n              textColor: '#ffffff',\n            },\n            textInput: {\n              sendButtonColor: '#435851',\n            },\n            footer: {\n              textColor: '#303235',\n              text: 'Powered by',\n              company: 'Expertizo',\n              companyLink: 'https://www.expertizo.pk',\n            },\n          },\n        }\n      });\n    ";

  document.body.appendChild(script);
}

function unloadChatbot() {
  window.flowiseLoaded = false;

  var script = document.getElementById("flowise-script");
  if (script) script.remove();

  document.querySelectorAll("flowise-chatbot, .flowise-chatbot-container, .flowise-chatbot-button").forEach(function (el) {
    return el.remove();
  });
}

/***/ }),

/***/ "LPQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginationComponent_vue__ = __webpack_require__("Qtum");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620dadc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginationComponent_vue__ = __webpack_require__("2Oca");
function injectStyle (ssrContext) {
  __webpack_require__("nd9x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-620dadc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginationComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620dadc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginationComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LTED":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LlT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helperFunc__ = __webpack_require__("Al8k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VerifyDocuments',
  props: {
    user: { type: Object, required: true },
    isUploadingExperienceLetter: { type: Boolean, default: false },
    isUploadingSalarySlip: { type: Boolean, default: false },
    experienceLetterFileName: { type: String, default: '' },
    experienceLetterFileSize: { type: String, default: '' },
    experienceLetterFileType: { type: String, default: '' },
    salarySlipFileName: { type: String, default: '' },
    salarySlipFileSize: { type: String, default: '' },
    salarySlipFileType: { type: String, default: '' },
    tempExperienceLetterUrl: { type: String, default: '' },
    tempSalarySlipUrl: { type: String, default: '' },
    documentLoading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      errors: {
        certificateUrl: '',
        salarySlipUrl: ''
      }
    };
  },

  computed: {
    isExperienceLetterImage: function isExperienceLetterImage() {
      return this.experienceLetterFileType && this.experienceLetterFileType.match('image.*');
    },
    isExperienceLetterPdf: function isExperienceLetterPdf() {
      return this.experienceLetterFileType && this.experienceLetterFileType === 'application/pdf';
    },
    isSalarySlipImage: function isSalarySlipImage() {
      return this.salarySlipFileType && this.salarySlipFileType.match('image.*');
    },
    isSalarySlipPdf: function isSalarySlipPdf() {
      return this.salarySlipFileType && this.salarySlipFileType === 'application/pdf';
    }
  },
  methods: {
    openFileInNewTab: __WEBPACK_IMPORTED_MODULE_1__utils_helperFunc__["a" /* openFileInNewTab */],
    inferFileType: function inferFileType(url) {
      if (!url) return '';
      var extension = url.split('.').pop().toLowerCase().split('?')[0];
      if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image/' + extension;
      if (extension === 'pdf') return 'application/pdf';
      return '';
    },
    validateDocuments: function validateDocuments() {
      var isValid = true;
      var errors = {};

      if (!this.tempExperienceLetterUrl && !this.user.certificateUrl) {
        errors.certificateUrl = 'Academic Certificate/Experience Letter is required';
        isValid = false;
      }
      if (!this.tempSalarySlipUrl && !this.user.salarySlipUrl) {
        errors.salarySlipUrl = 'Salary Slip is required';
        isValid = false;
      }

      this.errors = errors;
      return isValid;
    },
    submitDocuments: function submitDocuments() {
      if (this.validateDocuments()) {
        this.$emit('submit-documents');
      } else {
        this.$nextTick(function () {
          var firstError = document.querySelector('.invalid-feedback');
          if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    },
    triggerExperienceLetterFileInput: function triggerExperienceLetterFileInput() {
      this.$refs.experienceLetterInput.click();
    },
    triggerSalarySlipFileInput: function triggerSalarySlipFileInput() {
      this.$refs.salarySlipInput.click();
    },
    handleExperienceLetterFileDrop: function handleExperienceLetterFileDrop(event) {
      var file = event.dataTransfer.files[0];
      if (file) {
        this.errors.certificateUrl = '';
        this.$emit('file-selected', file, 'experience_letter');
      }
    },
    handleSalarySlipFileDrop: function handleSalarySlipFileDrop(event) {
      var file = event.dataTransfer.files[0];
      if (file) {
        this.errors.salarySlipUrl = '';
        this.$emit('file-selected', file, 'salary_slip');
      }
    },
    handleExperienceLetterUpload: function handleExperienceLetterUpload(event) {
      var file = event.target.files[0];
      if (file) {
        this.errors.certificateUrl = '';
        this.$emit('file-selected', file, 'experience_letter');
      }
      event.target.value = '';
    },
    handleSalarySlipUpload: function handleSalarySlipUpload(event) {
      var file = event.target.files[0];
      if (file) {
        this.errors.salarySlipUrl = '';
        this.$emit('file-selected', file, 'salary_slip');
      }
      event.target.value = '';
    },
    getDocumentThumbnail: function getDocumentThumbnail(url) {
      if (!url || !url.includes('cloudinary.com')) return url;
      var lowerUrl = url.toLowerCase();
      if (lowerUrl.endsWith('.pdf')) {
        var normalized = url.replace('/raw/upload/', '/image/upload/').replace('/raw/', '/image/');
        var parts = normalized.split('/upload/');
        if (parts.length !== 2) return url;
        var transform = 'w_150,h_200,c_thumb,pg_1,f_auto,q_auto';
        return parts[0] + '/upload/' + transform + '/' + parts[1];
      }

      return url;
    }
  }
});

/***/ }),

/***/ "Ln1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmployeeDashboard_vue__ = __webpack_require__("ZdPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admindashboard_vue__ = __webpack_require__("3o/R");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MODE_STORAGE_KEY = "dashboardMode";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Overview",
  components: {
    EmployeeDashboard: __WEBPACK_IMPORTED_MODULE_0__EmployeeDashboard_vue__["a" /* default */],
    Admindashboard: __WEBPACK_IMPORTED_MODULE_1__Admindashboard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      mode: this.readStoredMode()
    };
  },

  computed: {
    isAdmin: function isAdmin() {
      var user = this.$store.state.auth.user;
      return !!user && user.role === "admin";
    },
    activeMode: function activeMode() {
      return this.isAdmin ? this.mode : "employee";
    }
  },
  watch: {
    isAdmin: function isAdmin(_isAdmin) {
      if (!_isAdmin) this.setMode("employee", false);
    }
  },
  methods: {
    readStoredMode: function readStoredMode() {
      try {
        return localStorage.getItem(MODE_STORAGE_KEY) === "employee" ? "employee" : "admin";
      } catch (e) {
        return "admin";
      }
    },
    setMode: function setMode(mode) {
      var persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.mode = mode;
      if (!persist) return;
      try {
        localStorage.setItem(MODE_STORAGE_KEY, mode);
      } catch (e) {
        // Storage unavailable (private mode / quota) — the switch still works for this session.
      }
    }
  }
});

/***/ }),

/***/ "Lnhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FileTable',{ref:"fileTable",attrs:{"isAdmin":_vm.isAdmin}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('PerformanceByGrade',{attrs:{"isAdmin":_vm.isAdmin}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LtOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isExpertizoLocation;
function isExpertizoLocation(latitude, longitude) {
  var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.00015;

  var EXPERTIZO_LAT = 24.8833188;
  var EXPERTIZO_LNG = 67.0662084;

  if (typeof latitude !== "number" || typeof longitude !== "number" || isNaN(latitude) || isNaN(longitude)) {
    return false;
  }

  var latDiff = Math.abs(latitude - EXPERTIZO_LAT);
  var lngDiff = Math.abs(longitude - EXPERTIZO_LNG);

  return latDiff <= tolerance && lngDiff <= tolerance;
}

/***/ }),

/***/ "M2ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var openDropdownInstance = null;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LateTimeDropdown",
  props: {
    data: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: "--"
    },
    selected: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropdown: function toggleDropdown() {
      if (openDropdownInstance && openDropdownInstance !== this) {
        openDropdownInstance.closeDropdown();
      }

      this.isOpen = !this.isOpen;
      openDropdownInstance = this.isOpen ? this : null;
    },
    selectItem: function selectItem(item) {
      this.$emit("change", item);
      this.closeDropdown();
    },
    closeDropdown: function closeDropdown() {
      this.isOpen = false;
      if (openDropdownInstance === this) {
        openDropdownInstance = null;
      }
    },
    handleOutsideClick: function handleOutsideClick() {
      this.closeDropdown();
    }
  },
  directives: {
    clickOutside: {
      bind: function bind(el, binding, vnode) {
        el.__ClickOutsideHandler__ = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener("click", el.__ClickOutsideHandler__);
      },
      unbind: function unbind(el) {
        document.removeEventListener("click", el.__ClickOutsideHandler__);
        el.__ClickOutsideHandler__ = null;
      }
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb2bdfac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("XWAE");
function injectStyle (ssrContext) {
  __webpack_require__("LTED")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb2bdfac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leave-mangement"},[_c('div',{staticClass:"cards-container"},_vm._l((_vm.cards),function(card,index){return _c('div',{key:index,staticClass:"card",style:({ borderColor: card.color })},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"card-mian"},[_c('h2',{style:({ color: card.color })},[_vm._v(_vm._s(card.value))]),_vm._v(" "),(_vm.showScoreInfo && card.hasTooltip)?_c('i',{staticClass:"fa fa-info-circle pointer info-icon",on:{"mouseenter":function($event){return _vm.showInfo($event, card)},"mouseleave":_vm.hideInfo}}):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.label))]),_vm._v(" "),_c('p',[_vm._v(_vm._s())])])])}),0),_vm._v(" "),(_vm.showTooltip && _vm.currentCard)?_c('div',{staticClass:"performance-tooltip",staticStyle:{"overflow-y":"auto"},style:({ top: _vm.tooltipY + 'px', left: _vm.tooltipX + 'px' }),on:{"mouseenter":_vm.keepTooltip,"mouseleave":_vm.hideInfo}},[_c('div',{staticStyle:{"width":"100%","text-align":"center","font-weight":"bold","margin-bottom":"8px"}},[_vm._v(" Score Summary")]),_vm._v(" "),(_vm.currentCard.typeBreakdown && _vm.currentCard.typeBreakdown.length)?_c('div',{staticStyle:{"padding":"6px 0","border-top":"1px solid #eee","width":"100%"}},[_vm._l((_vm.currentCard.typeBreakdown),function(item){return _c('div',{key:item.type,staticStyle:{"display":"flex","justify-content":"space-between","font-size":"0.9em","color":"#444","margin":"5px 0"}},[_c('span',[_vm._v("→ "+_vm._s(item.type))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.sum.toFixed(1)))])])}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","width":"100%","font-size":"14px","padding":"4px 0","font-weight":"bold","padding-top":"6px"}},[_c('span',[_vm._v("Gross Score:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentCard.grossScore.toFixed(1)))])])],2):_vm._e(),_vm._v(" "),(_vm.currentCard.reopenDeduction !== null || _vm.currentCard.deadlineDeduction !== null)?_c('div',{staticStyle:{"border-top":"1px solid #eee","padding-top":"8px","width":"100%"}},[(_vm.currentCard.reopenDeduction !== null)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","color":"#ff4d4d","width":"100%"}},[_c('span',[_vm._v("Reopen Deductions:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentCard.reopenDeduction.toFixed(1)))])]):_vm._e(),_vm._v(" "),(_vm.currentCard.deadlineDeduction !== null)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","color":"#ff8c00","margin-bottom":"8px","width":"100%"}},[_c('span',[_vm._v("Deadlines Deductions:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentCard.deadlineDeduction.toFixed(1)))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","font-size":"14px","padding":"6px 0","font-weight":"bolder","border-top":"1px solid #eee","width":"100%","padding-top":"8px"}},[_c('span',[_vm._v("Net Score:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentCard.value))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MNXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"employee-dropdown"},[_c('div',{staticClass:"dropdown-container"},[_c('div',{staticClass:"dropdown-header",class:{ disabled: _vm.disabled },on:{"click":_vm.toggleDropdown}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px"}},[(_vm.selectedItem)?_c('div',{staticStyle:{"margin-top":"3px","display":"flex","align-items":"center","gap":"6px"}},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.selectedItem.profile_picture || 'static/img/default-dp.png'}}),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',{staticClass:" user-name"},[_vm._v(_vm._s(_vm.selectedItem[_vm.labelKey]))])])]):_c('div',[_c('i',{staticClass:"fa fa-user",staticStyle:{"font-size":"18px","margin-right":"5px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder))])])]),_vm._v(" "),_c('div',{staticStyle:{"color":"#7b7a7ac7","margin-right":"0px","font-size":"14px"}},[_c('i',{class:['fa  ', _vm.dropdownOpen ? 'fa-chevron-up'  : 'fa-chevron-down']})])]),_vm._v(" "),(_vm.dropdownOpen)?_c('div',{staticClass:"dropdown-body"},[_c('div',{staticClass:"filter-options"},[_c('div',{staticClass:"filter-item",class:{ active: _vm.filterType === 'all' },on:{"click":function($event){$event.stopPropagation();return _vm.setFilter('all')}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.items.length))])]),_vm._v(" "),_c('div',{staticClass:"filter-item",class:{ active: _vm.filterType === 'active' },on:{"click":function($event){$event.stopPropagation();return _vm.setFilter('active')}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.activeItems.length))])])]),_vm._v(" "),(_vm.searchable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"search-box",attrs:{"type":"text","placeholder":"Search employees..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"employee-list"},_vm._l((_vm.filteredItems),function(emp){return _c('li',{key:emp.uid,staticClass:"employee-item",on:{"click":function($event){return _vm.selectItem(emp)}}},[_c('div',{staticClass:"item"},[_c('img',{staticClass:"avatar",attrs:{"src":emp.profile_picture || 'static/img/default-dp.png'}}),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(emp[_vm.labelKey]))]),_vm._v(" "),(!emp.isActive)?_c('span',{staticClass:"small"},[_vm._v("(inactive)")]):_vm._e()])]),_vm._v(" "),(_vm.selectedItem && _vm.selectedItem.uid === emp.uid)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","margin-left":"auto"}}):_vm._e()])}),0),_vm._v(" "),(_vm.filteredItems.length === 0)?_c('div',{staticClass:"custom-searchable-dropdown-item empty"},[_vm._v("\n        No matching items found\n      ")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-users",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('span',{staticClass:"filter"},[_vm._v("All Employees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-user-check",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('span',{staticClass:"filter"},[_vm._v("Active Employees")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MSOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"card-user"},[_c('img',{attrs:{"slot":"image","src":"static/img/bg5.jpg","alt":"..."},slot:"image"}),_vm._v(" "),_c('div',{staticClass:"author"},[_c('label',{attrs:{"for":"avatar-input"}},[_c('div',{staticClass:"background-image avatar"},[_c('div',{staticClass:"avatar-backdrop"},[_c('img',{staticClass:"backdrop-icon",attrs:{"src":"static/img/photo-camera.png"}})])])]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"id":"avatar-input","type":"file"},on:{"change":_vm.readImage}}),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.user.nameToShow))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.user.company))])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_vm._v(_vm._s(_vm.user.aboutToShow))]),_vm._v(" "),_c('template',{slot:"footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('a',{staticClass:"btn btn-neutral btn-icon btn-round btn-lg",attrs:{"href":_vm.user.facebookProfile,"target":"_blank","title":_vm.getProfileText('facebook')}},[_c('i',{staticClass:"fa fa-facebook-square"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-neutral btn-icon btn-round btn-lg",attrs:{"href":_vm.user.twitterProfile,"target":"_blank","title":_vm.getProfileText('twitter')}},[_c('i',{staticClass:"fa fa-twitter"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-neutral btn-icon btn-round btn-lg",attrs:{"href":_vm.user.googlePlusProfile,"target":"_blank","title":_vm.getProfileText('google')}},[_c('i',{staticClass:"fa fa-google-plus-square"})])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2700d794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("lm93");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2700d794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZnX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    backgroundColor: {
      type: String,
      default: '#01271f',
      validator: function validator(value) {
        var acceptedValues = ['orange', 'black', 'darkblue', "#01271f"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      linkHeight: 60,
      activeLinkIndex: 0,

      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false
    };
  },

  methods: {
    findActiveLink: function findActiveLink() {
      var _this = this;

      this.sidebarLinks.find(function (element, index) {
        var found = element.path === _this.$route.path;
        if (found) {
          _this.activeLinkIndex = index;
        }
        return found;
      });
    }
  },
  mounted: function mounted() {
    this.findActiveLink();
  },

  watch: {
    $route: function $route() {
      this.findActiveLink();
    }
  }
});

/***/ }),

/***/ "N/oY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"custom-searchable-dropdown-container",class:{ 'is-disabled': _vm.disabled }},[_c('button',{staticClass:"custom-searchable-btn-dropdown",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown($event)}}},[_c('span',{staticClass:"custom-searchable-btn-text"},[_vm._v("\n      "+_vm._s(_vm.selectedItem ? _vm.selectedItem[_vm.labelKey] : _vm.displayText || _vm.placeholder)+"\n    ")]),_vm._v(" "),(_vm.dropdownOpen)?_c('i',{staticClass:"fa fa-chevron-up custom-searchable-btn-icon"}):_c('i',{staticClass:"fa fa-chevron-down custom-searchable-btn-icon"})]),_vm._v(" "),(_vm.dropdownOpen)?_c('div',{staticClass:"custom-searchable-dropdown-menu"},[(_vm.searchable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"custom-searchable-dropdown-search",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.filteredItems),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.selectItem(item)}}},[_vm._v("\n        "+_vm._s(item[_vm.labelKey])+"\n      ")])}),0),_vm._v(" "),(_vm.filteredItems.length === 0)?_c('div',{staticClass:"custom-searchable-dropdown-item empty"},[_vm._v("\n      No matching items found\n    ")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N7fN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NDXF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = logBugReport;
/* harmony export (immutable) */ __webpack_exports__["a"] = createBugReportPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cloudinary__ = __webpack_require__("SJFN");






var bugActivities = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(bugData, firebaseConfig) {
    var BOARD_ID, LIST_ID, trelloCard, createdCard, url;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            BOARD_ID = "XJ7MqZSB";
            LIST_ID = "69776065ab435aee6b20a130";
            trelloCard = {
              name: buildBugCardTitle(bugData),
              desc: formatBugTrelloDescription(bugData),
              idList: LIST_ID,
              pos: 'top'
            };
            _context2.next = 5;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__adminLogs__["e" /* sendToTrello */])(trelloCard);

          case 5:
            createdCard = _context2.sent;
            _context2.next = 8;
            return addExistingLabelToCard(createdCard.id, BOARD_ID, "Bug");

          case 8:
            _context2.next = 10;
            return addExistingLabelToCard(createdCard.id, BOARD_ID, bugData.priority);

          case 10:
            url = '';

            if (!(bugData.screenshot && bugData.screenshot.startsWith('data:image'))) {
              _context2.next = 17;
              break;
            }

            _context2.next = 14;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cloudinary__["a" /* uploadToCloudinary */])(bugData.screenshot, 'reported_bug');

          case 14:
            url = _context2.sent;
            _context2.next = 17;
            return addTrelloAttachment(createdCard.id, url, bugData.screenshot.name);

          case 17:
            __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].configuredAppForReportBug(firebaseConfig);
            _context2.next = 20;
            return __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].saveBugReport(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, bugData, { screenshot: url }));

          case 20:
            return _context2.abrupt('return', bugData);

          case 21:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function bugActivities(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var addExistingLabelToCard = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(cardId, boardId, labelName) {
    var labels, label;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getTrelloBoardLabels(boardId);

          case 2:
            labels = _context3.sent;
            label = labels.find(function (l) {
              return l.name.toLowerCase() === labelName.toLowerCase();
            });

            if (!label) {
              _context3.next = 9;
              break;
            }

            _context3.next = 7;
            return addTrelloLabelById(cardId, label.id);

          case 7:
            _context3.next = 10;
            break;

          case 9:
            console.warn('Label "' + labelName + '" not found on board');

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function addExistingLabelToCard(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var getTrelloBoardLabels = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(boardId) {
    var apiKey, apiToken, url, res, labels;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
            apiToken = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
            url = 'https://api.trello.com/1/boards/' + boardId + '/labels?key=' + apiKey + '&token=' + apiToken;
            _context4.next = 5;
            return fetch(url);

          case 5:
            res = _context4.sent;
            _context4.next = 8;
            return res.json();

          case 8:
            labels = _context4.sent;
            return _context4.abrupt('return', labels);

          case 10:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getTrelloBoardLabels(_x8) {
    return _ref4.apply(this, arguments);
  };
}();

var addTrelloLabelById = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(cardId, labelId) {
    var apiKey, apiToken, url;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
            apiToken = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
            url = 'https://api.trello.com/1/cards/' + cardId + '/idLabels?key=' + apiKey + '&token=' + apiToken;
            _context5.next = 5;
            return fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ value: labelId })
            });

          case 5:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function addTrelloLabelById(_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();





function logBugReport(bugData, firebaseConfig) {
  var _this = this;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
      var userAgent, platform, fullBugData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              userAgent = navigator.userAgent;
              platform = navigator.platform;
              fullBugData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, bugData, {
                browserName: userAgent,
                osName: platform,
                timestamp: new Date().toLocaleString('en-PK')
              });
              _context.next = 6;
              return bugActivities(fullBugData, firebaseConfig);

            case 6:
              resolve(fullBugData);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              reject(_context.t0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

function buildBugCardTitle(bugData) {
  var MAX_LENGTH = 50;

  var description = bugData.description ? bugData.description.trim().slice(0, MAX_LENGTH) : 'Bug Report';

  return description + ' - ' + bugData.email;
}

function formatBugTrelloDescription(data) {
  return '**Reporter Email**: ' + data.email + '\n\n' + '**Description**:\n' + data.description + '\n\n' + '**Priority**: ' + data.priority + '\n\n' + '**Browser**: ' + data.browserName + '\n' + '**OS**: ' + data.osName + '\n\n' + '**Time**: ' + data.timestamp;
}

function addTrelloAttachment(cardId, attachmentUrl) {
  var fileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Screenshot';

  var apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
  var apiToken = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";

  var url = 'https://api.trello.com/1/cards/' + cardId + '/attachments?key=' + apiKey + '&token=' + apiToken;

  return fetch(url, {
    method: 'POST',
    body: new URLSearchParams({
      url: attachmentUrl,
      name: fileName
    })
  });
}

function createBugReportPayload(_ref6) {
  var email = _ref6.email,
      description = _ref6.description,
      priority = _ref6.priority,
      _ref6$screenshot = _ref6.screenshot,
      screenshot = _ref6$screenshot === undefined ? null : _ref6$screenshot;

  return {
    email: email,
    description: description,
    priority: priority,
    screenshot: screenshot,
    status: 'open'
  };
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdi_font_css_materialdesignicons_css__ = __webpack_require__("csSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_chartist__ = __webpack_require__("715g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_now_ui_dashboard_scss__ = __webpack_require__("cfT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_now_ui_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sass_now_ui_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_modules_payroll__ = __webpack_require__("aNyT");
// plugin setup




 //with out this vuetify dosent apply in exsisting project
// import 'material-design-icons-iconfont/dist/material-design-icons.css'


// Plugins





// router setup



// library imports





// style conditionally for swal modal
function applySwalModalStyle(path) {

  var existing = document.getElementById('custom-swal-style');
  if (existing) existing.remove();

  if (path !== '/' && path !== "/resetPassword") {
    var style = document.createElement('style');
    style.id = 'custom-swal-style';
    style.innerHTML = '\n      @media screen and (min-width: 901px) {\n        .swal-modal {\n          margin-left: 260px !important;\n          animation: none !important;\n          transition: none !important;\n        }\n      }\n    ';
    document.head.appendChild(style);
  }
}

// Vuetify setup
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  iconfont: 'mdi' // ✅ use MDI icons instead of Material Icons font
});
//modules
 // Ensure correct path


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__globalComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__components_UIComponents_SidebarPlugin__["a" /* default */], { store: __WEBPACK_IMPORTED_MODULE_11__store_store__["a" /* default */] });

// configure router
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_10__routes_routes__["a" /* default */], // short for routes: routes
  linkActiveClass: 'active'
});

var publicPages = ['Login', 'ResetPassword'];

router.beforeEach(function (to, from, next) {
  var globalState = JSON.parse(localStorage.getItem("vuex"));
  var isLoggedIn = globalState && globalState.auth && globalState.auth.company && globalState.auth.company.firebase;

  // Allow public pages
  if (publicPages.includes(to.name)) {
    if (to.name === 'Login' && isLoggedIn) {
      return next('/overview');
    }
    return next();
  }

  // If not logged in, redirect to login
  if (!isLoggedIn) {
    return next('/');
  }

  next();
});

// 🔁 Apply modal style based on route
router.afterEach(function (to) {
  applySwalModalStyle(to.path);
});

// global library setup
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, '$Chartist', {
  get: function get() {
    return this.$root.Chartist;
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */]);
  },
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_11__store_store__["a" /* default */],
  data: {
    Chartist: __WEBPACK_IMPORTED_MODULE_12_chartist___default.a
  },
  modules: {
    payroll: __WEBPACK_IMPORTED_MODULE_16__store_modules_payroll__["a" /* default */]
  }
});

/***/ }),

/***/ "NM96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NW5j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NcLo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NepR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"trello-logout-mian col-md-12"},[_c('button',{staticClass:"trello-logout",on:{"click":_vm.openLogoutModal}},[_vm._v("\n          Trello Logout\n          "),_c('i',{staticClass:"fa fa-sign-out-alt performance-header-search-icon ml-1"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"performance-header-container"},[_c('div',{staticClass:"dropdowns-container"},[_c('div',{staticClass:"admin-access-section"},[(_vm.isAdmin)?_c('HeaderEmployeeDropdown',{attrs:{"disabled":_vm.loading,"items":_vm.employeeList,"labelKey":"username","searchable":"","placeholder":_vm.selectedEmployee ? _vm.selectedEmployee.username : 'Select Employee'},on:{"select":_vm.onEmployeeSelect}}):_vm._e()],1),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticStyle:{"width":"245px"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"searchable-1"},[_c('SearchableDropdown',{attrs:{"items":_vm.filteredBoardsForEmployee,"labelKey":"name","placeholder":_vm.selectedBoardName || 'All Projects',"disabled":_vm.loading},on:{"select":_vm.onBoardSelect}})],1),_vm._v(" "),_c('div',{staticClass:"searchable-2"},[_c('SearchableDropdown',{attrs:{"items":_vm.months.map(function (m) { return ({ name: m }); }),"labelKey":"name","placeholder":_vm.selectedMonth || 'Select Month',"disabled":_vm.loading},on:{"select":_vm.onMonthSelect}})],1),_vm._v(" "),_c('div',{staticClass:"searchable-3"},[_c('SearchableDropdown',{attrs:{"items":_vm.years.map(function (y) { return ({ name: y.toString() }); }),"labelKey":"name","placeholder":_vm.selectedYear || 'Select Year',"disabled":_vm.loading},on:{"select":_vm.onYearSelect}})],1),_vm._v(" "),_c('div',{staticClass:"performance-header-actions"},[_c('button',{staticClass:"btn btn-outline",attrs:{"disabled":_vm.loading || !_vm.selectedEmployee || !_vm.selectedMonth || !_vm.selectedYear},on:{"click":_vm.triggerSearch}},[_c('i',{staticClass:"fa fa-search performance-header-search-icon"})])])]),_vm._v(" "),(_vm.showLockBar && (_vm.isScheduled || _vm.effectiveLocked) && (!_vm.isLoading || !_vm.scheduledloading))?_c('div',{staticClass:"lock-bar"},[(_vm.isScheduled )?_c('span',[_vm._v("\n            Modifying below will be locked on "+_vm._s(_vm.formatDate(_vm.lockData.scheduledLockTime))+" at "+_vm._s(_vm.formatTime(_vm.lockData.scheduledLockTime))+". Time Remaining: "+_vm._s(_vm.timeRemaining)+".\n          ")]):_c('span',[_vm._v("Modifying below is locked now.")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"add-items-mian col-md-12"},[(!_vm.effectiveLocked && _vm.showLockBar)?_c('button',{staticClass:"lock-button",on:{"click":function($event){_vm.isAddModalOpen = true}}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"0.9em"}}),_vm._v(" Add Item\n         ")]):_vm._e(),_vm._v(" "),(_vm.isAdmin && _vm.showLockBar)?_c('button',{staticClass:"lock-button",on:{"click":_vm.onLockButtonClick}},[_c('i',{class:_vm.lockButtonText === 'Lock' ? 'fas fa-lock' :_vm.lockButtonText === 'Unlock' ? 'fas fa-unlock' : 'fas fa-calendar',staticStyle:{"font-size":"0.9em"}}),_vm._v(" "+_vm._s(_vm.lockButtonText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isAdmin && _vm.isScheduled && _vm.showLockBar)?_c('button',{staticClass:"end-schedule",on:{"click":_vm.openEndScheduleModal}},[_c('i',{staticClass:"fas fa-times",staticStyle:{"font-size":"1em"}}),_vm._v(" Cancel Schedule\n         ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"min-height":"450px","position":"relative","border-radius":"8px","text-align":"center"}},[((!_vm.loading && !_vm.error && !_vm.noMemberFound && _vm.summaryCards.length > 0) && _vm.showLockBar)?_c('div',{staticStyle:{"margin":"20px 0px"}},[_c('CardsSection',{attrs:{"cards":_vm.summaryCards,"showScoreInfo":true}})],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"payroll-table-loader-overlay"},[_c('div',{staticClass:"payroll-loader-container"},[_c('DoubleLoader',{staticClass:"payroll-loader"})],1)]):(_vm.selectedEmployee && _vm.filteredBoardsForEmployee.length === 0 && _vm.membersLoaded)?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"alert alert-info d-inline-block"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.selectedEmployee.username))]),_vm._v(" is not a member of any board.\n          ")])]):(!_vm.loading && _vm.isAdmin && !_vm.hasSearched || !_vm.showLockBar)?_c('div',{staticClass:"text-center py-5"},[_vm._m(0)]):(!_vm.loading && _vm.filteredPerformanceData.length === 0)?_c('div',{staticClass:"text-center py-5"},[_vm._m(1)]):(_vm.error)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n          "+_vm._s(_vm.error)+"\n        ")]):_c('div',[_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.filteredPerformanceData,"totals":_vm.tableTotals,"showModal":true,"footer":true},on:{"row-click":_vm.handleRowClick},scopedSlots:_vm._u([{key:"serialNumber",fn:function(ref){
var index = ref.index;
return [_vm._v(_vm._s(index + 1)+".")]}},{key:"taskName",fn:function(ref){
var item = ref.item;
return [(!item.link || item.link === '#')?_c('span',{attrs:{"title":item.taskName}},[_vm._v("\n                "+_vm._s(item.taskName.length > 25 ? item.taskName.slice(0, 25) + '...' : item.taskName)+"\n              ")]):_c('a',{staticClass:"task-link",attrs:{"href":item.link,"title":item.taskName,"target":"_blank"}},[_vm._v("\n                "+_vm._s(item.taskName.length > 25 ? item.taskName.slice(0, 25) + '...' : item.taskName)+"\n              ")]),_vm._v(" "),(Array.isArray(item.details) && item.details.length > 0)?_c('span',{staticClass:"detail-tooltip-wrapper",on:{"mouseover":function($event){return _vm.showDetails(item.id)},"mouseleave":function($event){return _vm.hideDetails(item.id)}}},[_c('i',{staticClass:"fa fa-info-circle text-info pointer info-icon ml-1"}),_vm._v(" "),(_vm.visibleDetails[item.id])?_c('div',{staticClass:"detail-tooltip-box"},[_c('div',{staticClass:"details-title"},[_vm._v("\n                    PR Review / Help\n                  ")]),_vm._v(" "),_c('ul',{staticClass:"details-list"},_vm._l((item.details),function(detail,index){return _c('li',{key:index,staticClass:"detail-item"},[(detail && typeof detail === 'object')?[(detail.link && detail.link.startsWith('http'))?_c('a',{attrs:{"href":detail.link,"target":"_blank"}},[_vm._v("\n                          "+_vm._s(detail.link)+"\n                        ")]):(detail.link)?_c('span',[_vm._v("\n                          "+_vm._s(detail.link)+"\n                        ")]):_vm._e(),_vm._v(" "),(detail.text)?_c('span',{staticClass:"detail-text"},[_vm._v("\n                          "+_vm._s(detail.text)+"\n                        ")]):_vm._e()]:_c('span',{staticClass:"detail-text"},[_vm._v("\n                        "+_vm._s(detail)+"\n                      ")])],2)}),0)]):_vm._e()]):_vm._e()]}},{key:"durationSpent",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.durationSpent))]}},{key:"movedToDone",fn:function(ref){
var item = ref.item;
return [_c('span',{attrs:{"title":item.movedToDone}},[_vm._v(_vm._s(item.movedToDone))])]}},{key:"reopened",fn:function(ref){
var item = ref.item;
return [(item.isCustom && item.type !== 'Ticket')?_c('div',{staticClass:"reopened-cell"},[_c('span',[_vm._v("\n                  "+_vm._s(item.reopened==0 ? 'N/A' : item.reopened)+"\n                ")])]):_c('div',{staticClass:"reopened-cell"},[(item.status === 'pending')?_c('div',{staticClass:"reopened-edit"},[_c('span',{staticClass:"text-muted line-through",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(item.originalreopenCount != null ? item.originalreopenCount : 0))]),_vm._v("\n                  →\n                  "),_c('span',{staticClass:" font-bold",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(item.reopened != null ? item.reopened : 0))]),_vm._v(" "),(_vm.isAdmin && !_vm.effectiveLocked)?_c('div',{staticClass:"edit-actions"},[_c('button',{staticClass:"action-save",attrs:{"title":"Approve"},on:{"click":function($event){$event.stopPropagation();return _vm.openConfirm('approve', item, 'reopened')}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"action-cancel",attrs:{"title":"Reject"},on:{"click":function($event){$event.stopPropagation();return _vm.openConfirm('reject', item, 'reopened')}}},[_c('i',{staticClass:"fa fa-times"})])]):_vm._e(),_vm._v(" "),(!_vm.isAdmin)?_c('span',{staticStyle:{"font-size":"10px","color":"#5EC1A5"}},[_vm._v("(Pending)")]):_vm._e(),_vm._v(" "),(_vm.getReasonForField(item.id, 'reopened'))?_c('i',{staticClass:"fa fa-info-circle text-info pointer info-icon",on:{"mouseenter":function($event){return _vm.showInfo($event, item.id, 'reopened')},"mouseleave":_vm.hideInfo}}):_vm._e()]):_c('div',[(!_vm.isEditing(item.id, 'reopened'))?_c('div',{staticClass:"reopened-view"},[(_vm.canEdit('reopened') && !_vm.effectiveLocked)?_c('button',{staticClass:"reopened-badge",attrs:{"title":'Edit reopened count',"disabled":item.ticketStatus === 'pending'},on:{"click":function($event){return _vm.startEdit(item.id, 'reopened', item.reopened)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "),_c('span',{staticClass:"reopened-count"},[_vm._v(_vm._s(item.reopened != null ? item.reopened : 0))])]):_c('div',{staticClass:"reopened-badge disabled"},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "),_c('span',{staticClass:"reopened-count"},[_vm._v(_vm._s(item.reopened != null ? item.reopened : 0))])]),_vm._v(" "),_c('span',{staticClass:"icon-slot",attrs:{"role":"img","aria-hidden":"true"}},[(_vm.getReasonForField(item.id, 'reopened'))?_c('i',{staticClass:"fa fa-info-circle pointer info-icon",attrs:{"title":"View reopen reason"},on:{"mouseenter":function($event){return _vm.showInfo($event, item.id, 'reopened')},"mouseleave":_vm.hideInfo}}):_c('i',{staticClass:"fa fa-info-circle info-icon-disabled",attrs:{"title":"No reopen reason"}})])]):_c('div',{staticClass:"reopened-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempValues[((item.id) + "-reopened")]),expression:"tempValues[`${item.id}-reopened`]"}],staticClass:"edit-input",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.tempValues[((item.id) + "-reopened")])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempValues, ((item.id) + "-reopened"), $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"edit-actions"},[_c('button',{staticClass:"action-save",attrs:{"title":"Save"},on:{"click":function($event){return _vm.confirmEdit(item, 'reopened', item.reopened, item.reopenReason)}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"action-cancel",attrs:{"title":"Cancel"},on:{"click":function($event){return _vm.cancelEdit(item.id, 'reopened')}}},[_c('i',{staticClass:"fa fa-times"})])])])])])]}},{key:"deadlineMissed",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.deadlineMissed))]}},{key:"score",fn:function(ref){
var item = ref.item;
return [(!_vm.isAdmin)?_c('div',{staticClass:"reopened-cell"},[_c('span',[_vm._v("\n                  "+_vm._s(item.score)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"icon-slot",attrs:{"role":"img","aria-hidden":"true"}},[(_vm.getReasonForField(item.id, 'score'))?_c('i',{staticClass:"fa fa-info-circle pointer info-icon",attrs:{"title":"View score reason"},on:{"mouseenter":function($event){return _vm.showInfo($event, item.id, 'score')},"mouseleave":_vm.hideInfo}}):_c('i',{staticClass:"fa fa-info-circle info-icon-disabled",attrs:{"title":"No score reason"}})]),_vm._v(" "),(item.ticketStatus === 'pending' && !_vm.isAdmin)?_c('span',{staticClass:"pending-status"},[_vm._v("("),_c('span',{staticClass:"pending-text"},[_vm._v("Pending")]),_vm._v(")")]):_vm._e()]):_c('div',{staticClass:"reopened-cell"},[(!_vm.isEditing(item.id, 'score'))?_c('div',{staticClass:"reopened-view"},[(_vm.canEdit('score') && !_vm.effectiveLocked)?_c('button',{staticClass:"reopened-badge",attrs:{"title":'Edit score',"disabled":item.ticketStatus === 'pending'},on:{"click":function($event){return _vm.startEdit(item.id, 'score', item.score)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "),_c('span',{staticClass:"reopened-count"},[_vm._v(_vm._s(item.score))])]):_c('div',{staticClass:"reopened-badge disabled"},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "),_c('span',{staticClass:"reopened-count"},[_vm._v(_vm._s(item.score))])]),_vm._v(" "),_c('span',{staticClass:"icon-slot",attrs:{"role":"img","aria-hidden":"true"}},[(_vm.getReasonForField(item.id, 'score'))?_c('i',{staticClass:"fa fa-info-circle pointer info-icon",attrs:{"title":"View score reason"},on:{"mouseenter":function($event){return _vm.showInfo($event, item.id, 'score')},"mouseleave":_vm.hideInfo}}):_c('i',{staticClass:"fa fa-info-circle info-icon-disabled",attrs:{"title":"No score reason"}})])]):_c('div',{staticClass:"reopened-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempValues[((item.id) + "-score")]),expression:"tempValues[`${item.id}-score`]"}],staticClass:"edit-input",attrs:{"type":"number","step":"0.5","min":"0"},domProps:{"value":(_vm.tempValues[((item.id) + "-score")])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempValues, ((item.id) + "-score"), $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"edit-actions"},[_c('button',{staticClass:"action-save",attrs:{"title":"Save"},on:{"click":function($event){return _vm.confirmEdit(item, 'score', item.score, item.scoreReason)}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"action-cancel",attrs:{"title":"Cancel"},on:{"click":function($event){return _vm.cancelEdit(item.id, 'score')}}},[_c('i',{staticClass:"fa fa-times"})])])]),_vm._v(" "),(item.ticketStatus === 'pending' && !_vm.isAdmin)?_c('span',{staticClass:"pending-status"},[_vm._v("("),_c('span',{staticClass:"pending-text"},[_vm._v("Pending")]),_vm._v(")")]):_vm._e()])]}},{key:"project",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(item.isCustom && item.type === 'Ticket' || item.type=="Lead Per Project"|| !item.isCustom
                  ? _vm.truncateText(item.project || item.boardName, 20) : 'N/A')+"\n            ")]}},{key:"action",fn:function(ref){
                  var item = ref.item;
return [(_vm.effectiveLocked)?_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('i',{staticClass:"fa fa-history pointer",class:{ 'text-primary': _vm.hasHistory(item.id), 'text-muted opacity-50': !_vm.hasHistory(item.id) },staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.hasHistory(item.id) ? 'History' : 'No history available'},on:{"click":function($event){$event.stopPropagation();_vm.hasHistory(item.id) && _vm.onHistoryClick(item)}}})]):_vm._e(),_vm._v(" "),(item.ticketStatus !== 'pending' && _vm.isAdmin && !_vm.effectiveLocked)?_c('span',{staticClass:"action"},[_c('i',{staticClass:"fa fa-trash delete-icon pointer",class:{ 'delete-icon': !_vm.editedCards[item.id], 'opacity-60': !_vm.editedCards[item.id] },style:({ 'pointer-events': _vm.editedCards[item.id] ? 'auto' : 'none' }),attrs:{"title":"Delete edit (Firebase only)"},on:{"click":function($event){$event.stopPropagation();_vm.editedCards[item.id] && _vm.onDeleteClick(item)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-history pointer",class:{ 'text-primary': _vm.hasHistory(item.id), 'text-muted opacity-50': !_vm.hasHistory(item.id) },staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.hasHistory(item.id) ? 'History' : 'No history available'},on:{"click":function($event){$event.stopPropagation();_vm.hasHistory(item.id) && _vm.onHistoryClick(item)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-edit pointer",class:{ 'text-primary': true },staticStyle:{"cursor":"pointer"},attrs:{"title":"Edit item"},on:{"click":function($event){$event.stopPropagation();return _vm.onEditClick(item)}}})]):_vm._e(),_vm._v(" "),( !_vm.isAdmin && !_vm.effectiveLocked)?_c('span',{staticClass:"action-user"},[_c('i',{staticClass:"fa fa-trash delete-icon pointer",class:{ 'delete-icon': !_vm.editedCards[item.id], 'opacity-60': !_vm.editedCards[item.id] },style:({ 'pointer-events': _vm.editedCards[item.id] ? 'auto' : 'none' }),attrs:{"title":"Delete edit (Firebase only)"},on:{"click":function($event){$event.stopPropagation();_vm.editedCards[item.id] && _vm.onDeleteClick(item)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-history pointer",class:{ 'text-primary': _vm.hasHistory(item.id), 'text-muted opacity-50': !_vm.hasHistory(item.id) },staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.hasHistory(item.id) ? 'History' : 'No history available'},on:{"click":function($event){$event.stopPropagation();_vm.hasHistory(item.id) && _vm.onHistoryClick(item)}}}),_vm._v(" "),(item.ticketStatus == 'pending' && !_vm.effectiveLocked)?_c('i',{staticClass:"fa fa-edit pointer",class:{ 'text-primary': true },staticStyle:{"cursor":"pointer"},attrs:{"title":"Edit item"},on:{"click":function($event){$event.stopPropagation();return _vm.onEditClick(item)}}}):_vm._e()]):_vm._e(),_vm._v(" "),(item.ticketStatus === 'pending' && _vm.isAdmin && !_vm.effectiveLocked)?_c('span',{staticClass:"action"},[_c('button',{staticClass:" actoin-column-save",attrs:{"title":"Approve Item"},on:{"click":function($event){$event.stopPropagation();return _vm.onApproveClick(item)}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"actoin-column-cancel",attrs:{"title":"Reject Item"},on:{"click":function($event){$event.stopPropagation();return _vm.onDeleteClick(item)}}},[_c('i',{staticClass:"fa fa-times"})]),_vm._v(" "),_c('i',{staticClass:"fa fa-edit pointer",class:{ 'text-primary': true },staticStyle:{"cursor":"pointer"},attrs:{"title":"Edit item"},on:{"click":function($event){$event.stopPropagation();return _vm.onEditClick(item)}}})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.showTooltip)?_c('div',{staticClass:"performance-tooltip",style:({ top: _vm.tooltipY + 'px', left: _vm.tooltipX + 'px' })},[_vm._v("\n          "+_vm._s(_vm.getReasonForField(_vm.showTooltip, _vm.currentHoverField))+"\n        ")]):_vm._e(),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isHistoryModalOpen,"title":"Activity History","submitButtonText":"Close","xlarge":true,"hideCancelButton":true},on:{"update:modelValue":function($event){_vm.isHistoryModalOpen = $event},"submit":_vm.closeHistoryModal},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('HistoryActivityTable',{attrs:{"activities":_vm.performanceActivity,"columns":_vm.columns},on:{"open-map":_vm.openMapPopup}})]},proxy:true}])}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.showReasonModal,"title":_vm.reasonModalTitle,"submitButtonText":"Confirm","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.showReasonModal = $event},"submit":_vm.handleReasonSubmit},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticStyle:{"padding":"7px 13px"}},[_c('div',{staticClass:"changed-value"},[_c('label',{staticClass:"reason-label"},[_vm._v("\n                "+_vm._s(_vm.pendingAction ? _vm.pendingAction + ' Change' : _vm.changeInfo.field + ' Change')+"\n              ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticClass:"mr-1"},[_vm._v("\n                "+_vm._s(_vm.changeInfo.original || '0')+"\n              ")]),_vm._v("\n                 →   \n              "),(_vm.changeInfo.new !== undefined)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.changeInfo.new))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"reason-container",staticStyle:{"margin-top":"15px"}},[_c('label',{staticClass:"reason-label"},[_vm._v("Reason "),(!_vm.isAdmin)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"placeholder":"Enter reason here","rows":"3","maxlength":"400"},domProps:{"value":(_vm.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reason=$event.target.value}}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","font-size":"12px","color":"gray","margin-top":"4px"}},[_vm._v("\n                "+_vm._s(_vm.reason.length)+" / 400\n              ")])])])]},proxy:true}])}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeleteModalOpen,"title":"Confirm Deletion","submitButtonText":"Delete","submitButtonClass":"btn-danger","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isDeleteModalOpen = $event},"submit":_vm.confirmDelete}},[_c('div',[_vm._v("Are you sure you want to delete this card? This action cannot be undone.")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isLogoutModalOpen,"title":"Confirm Logout","submitButtonText":"Logout","submitButtonClass":"btn-danger"},on:{"update:modelValue":function($event){_vm.isLogoutModalOpen = $event},"submit":_vm.confirmLogout}},[_c('div',[_vm._v("Are you sure you want to logout from Trello?")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.mapPopup,"title":"Activity Location","submitButtonText":"Close","xlarge":true,"hideCancelButton":true},on:{"update:modelValue":function($event){_vm.mapPopup = $event},"submit":function($event){_vm.mapPopup = false}},scopedSlots:_vm._u([{key:"default",fn:function(){return [(_vm.currentCoordinates.latitude)?_c('div',{staticStyle:{"width":"100%","height":"250px","border-radius":"8px","overflow":"hidden"},attrs:{"id":"mapActivity"}}):_c('div',{staticClass:"text-center py-5 text-muted"},[_c('p',[_vm._v("No location data available.")])])]},proxy:true}])}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isApproveModalOpen,"title":"Confirm Approval","submitButtonText":"Approve","submitButtonClass":"btn-success","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isApproveModalOpen = $event},"submit":_vm.confirmApprove}},[_c('div',[_vm._v("Are you sure you want to approve this ticket?")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isUnLockModalOpen,"title":"Confirm Unlock","submitButtonText":"Unlock","submitButtonClass":"btn-warning","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isUnLockModalOpen = $event},"submit":_vm.confirmUnLock}},[_c('div',[_vm._v("Are you sure you want to unlock?")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isEndScheduleModalOpen,"title":"Confirm End Schedule","submitButtonText":"End Schedule","submitButtonClass":"btn-danger","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isEndScheduleModalOpen = $event},"submit":_vm.confirmEndSchedule}},[_c('div',[_vm._v("Are you sure you want to end the schedule?.")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isLockModalOpen,"title":"Schedule Lock / Lock Now","submitButtonText":"Lock Now","cancelButtonText":"Cancel","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isLockModalOpen = $event},"submit":_vm.lockNow},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"lock-schedule",staticStyle:{"display":"flex","justify-content":"start","align-items":"start","flex-direction":"column","gap":"5px"}},[_c('label',[_vm._v("Schedule Lock Date & Time:")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","gap":"20px","width":"100%","border-radius":"4px","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lockDate),expression:"lockDate"}],staticStyle:{"width":"50%","margin":"0","padding":"5px"},attrs:{"type":"date","value":""},domProps:{"value":(_vm.lockDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lockDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lockTime),expression:"lockTime"}],staticStyle:{"width":"50%","margin":"0","padding":"5px","height":"43px","border":"1px solid #ccc","border-radius":"4px"},attrs:{"type":"time","value":""},domProps:{"value":(_vm.lockTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lockTime=$event.target.value}}})])])]},proxy:true},{key:"middle-footer",fn:function(){return [_c('button',{staticClass:"lock-button",staticStyle:{"min-width":"120px","margin-right":"-75px"},attrs:{"disabled":_vm.scheduledloading || _vm.isLoading},on:{"click":_vm.scheduleLock}},[(_vm.scheduledloading)?_c('span',[_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle"},attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v(" Schedule Lock ")])])]},proxy:true}])}),_vm._v(" "),(_vm.isAddModalOpen)?_c('AddPerformanceItemModal',{attrs:{"modelValue":_vm.isAddModalOpen,"employee":_vm.selectedEmployee,"month":_vm.selectedMonth,"year":_vm.selectedYear,"boards":_vm.filteredBoardsForEmployee,"isAdmin":_vm.isAdmin,"existingItem":_vm.selectedItem},on:{"update:modelValue":function($event){return _vm.handleModalClose($event)},"submitted":_vm.onItemAdded,"updated":_vm.onItemUpdated}}):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info d-inline-block"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n            Kindly set the filter and press the search button\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info d-inline-block"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('strong',[_vm._v("No cards found for the selected criteria.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NzMo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyDetails_vue__ = __webpack_require__("8Q0V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7179263c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyDetails_vue__ = __webpack_require__("war1");
function injectStyle (ssrContext) {
  __webpack_require__("JW9s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7179263c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7179263c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OKCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserDataLoaded)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.$store.state.auth.user.username))])]),_vm._v(" "),(!_vm.isResignedUser)?_c('div',{staticClass:"col-sm-6 text-right"},[_c('button',{staticClass:"applyleave",on:{"click":_vm.openModal}},[_vm._v("\n                  Apply for leave\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('CardsSection',{attrs:{"cards":_vm.cards}})],1),_vm._v(" "),_c('div',[_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.leaves || [],"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"assignees",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.assignees}},[_vm._v(_vm._s(item.assignees || '-'))])]}},{key:"type",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.type}},[_vm._v(_vm._s(item.type || '-'))])]}},{key:"noofdays",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.noofdays}},[_vm._v(_vm._s(item.noofdays || '-'))])]}},{key:"dates",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.dates}},[_vm._v(_vm._s(item.dates || '-'))])]}},{key:"createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(_vm.formatRelativeTime(item.createdAt))+"\n            ")]}},{key:"reason",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.reason}},[_vm._v(_vm._s(item.reason || '-'))])]}},{key:"comment",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.comment}},[_vm._v(_vm._s(item.comment || '-'))])]}},{key:"status",fn:function(ref){
var item = ref.item;
return [(item.status === 'Pending')?_c('div',[_c('button',{staticClass:"withdraw-btn",on:{"click":function($event){$event.stopPropagation();return _vm.withdrawLeave(item)}}},[_vm._v("\n                  Withdraw\n                ")])]):_c('span',{class:_vm.getStatusClass(item.status)},[_vm._v("\n                "+_vm._s(item.status)+"\n              ")])]}}])})],1)],2)],1)])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isModalOpen,"title":"Add Leave","loading":_vm.loading.applyLeave,"submitButtonText":"Submit"},on:{"update:modelValue":function($event){_vm.isModalOpen = $event},"submit":_vm.addLeave}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.addLeave($event)}}},[_c('div',[_c('CustomDropdown',{attrs:{"required":true,"id":"assignee-dropdown","label":"Assignees","options":_vm.assigneeOptions,"value":_vm.selectedAssigneeName,"placeholder":"Select Assignee","showError":_vm.formSubmitted && 
          !_vm.newLeave.assigneeId,"errorMessage":"Please select an assignee"},on:{"change":_vm.handleAssigneeChange}})],1),_vm._v(" "),_c('div',[_c('CustomDropdown',{attrs:{"required":true,"id":"leave-type-dropdown","label":"Leave Type","options":_vm.leaveTypeOptions,"value":_vm.newLeave.type,"placeholder":"Select Leave Type","showError":_vm.formSubmitted && !_vm.newLeave.type,"errorMessage":"Please select a leave type"},on:{"change":_vm.handleLeaveTypeChange}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"18px"}},[_c('label',[_vm._v("Duration")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"8px","display":"flex","align-items":"center","gap":"30px"}},[_c('label',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],attrs:{"type":"radio","value":"full","checked":""},domProps:{"checked":_vm._q(_vm.duration,"full")},on:{"change":function($event){_vm.duration="full"}}}),_vm._v(" Full Day\n          ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration),expression:"duration"}],attrs:{"type":"radio","value":"half"},domProps:{"checked":_vm._q(_vm.duration,"half")},on:{"change":function($event){_vm.duration="half"}}}),_vm._v(" Half Day\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"margin-bottom":"13px"}},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"startDate"}},[_vm._v("Start Date "),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLeave.startDate),expression:"newLeave.startDate"}],staticClass:"form-control",attrs:{"type":"date","id":"startDate","required":""},domProps:{"value":(_vm.newLeave.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newLeave, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"endDate"}},[_vm._v("End Date"),_c('span',{staticClass:"required-asterisk",staticStyle:{"margin-left":"3px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLeave.endDate),expression:"newLeave.endDate"}],staticClass:"form-control",attrs:{"type":"date","id":"endDate","required":""},domProps:{"value":(_vm.newLeave.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newLeave, "endDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"reason"}},[_vm._v("Reason"),_c('span',{staticClass:"required-asterisk",staticStyle:{"margin-left":"2px"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newLeave.reason),expression:"newLeave.reason"}],staticClass:"form-control",attrs:{"id":"reason","placeholder":"Type you reason...","required":""},domProps:{"value":(_vm.newLeave.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newLeave, "reason", $event.target.value)}}})])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isWithdrawModalOpen,"title":"Withdraw Leave","loading":_vm.loading.withdrawLeave,"submitButtonText":"Yes, Withdraw"},on:{"update:modelValue":function($event){_vm.isWithdrawModalOpen = $event},"submit":_vm.confirmWithdraw}},[_c('p',{staticClass:"m-0 p-0"},[_vm._v("Are you sure you want to withdraw this leave? This action cannot be undone.")])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd398d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("zKnm");
function injectStyle (ssrContext) {
  __webpack_require__("jvZ3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd398d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OnzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subtractHolidays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


function subtractHolidays(_ref) {
  var holidays = _ref.holidays,
      currentYear = _ref.currentYear,
      monthIndex = _ref.monthIndex,
      workingDays = _ref.workingDays,
      workingDaysInMonth = _ref.workingDaysInMonth,
      shift = _ref.shift,
      lastWorkingDate = _ref.lastWorkingDate;

  monthIndex = normalizeMonth(monthIndex);
  var deductedDates = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

  var lastWorkingDateObj = lastWorkingDate ? new Date(lastWorkingDate) : null;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(holidays), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var holiday = _step.value;

      var holidayDate = new Date(holiday.dates);

      var holidayYear = holiday.isRecurring ? currentYear : holidayDate.getFullYear();

      var holidayStart = new Date(holidayYear, holidayDate.getMonth(), holidayDate.getDate());

      for (var i = 0; i < holiday.numberOfDays; i++) {
        var actualHolidayDate = new Date(holidayStart);
        actualHolidayDate.setDate(actualHolidayDate.getDate() + i);

        if (actualHolidayDate.getFullYear() !== currentYear || actualHolidayDate.getMonth() !== monthIndex) {
          continue;
        }

        if (lastWorkingDateObj && actualHolidayDate > lastWorkingDateObj) {
          continue;
        }

        var holidayWeekday = actualHolidayDate.toLocaleDateString("en-US", {
          weekday: "long"
        });
        var holidayShift = holiday.shift.toLowerCase();
        var currentShift = shift.toLowerCase();

        if (workingDays.includes(holidayWeekday) && (holidayShift === currentShift || holidayShift === "general")) {
          var dateKey = actualHolidayDate.getFullYear() + "-" + String(actualHolidayDate.getMonth() + 1).padStart(2, '0') + "-" + String(actualHolidayDate.getDate()).padStart(2, '0');
          if (!deductedDates.has(dateKey)) {
            deductedDates.add(dateKey);
            workingDaysInMonth--;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return workingDaysInMonth;
}

function normalizeMonth(month) {
  if (typeof month === "number") return month;

  var months = ["january", "february", "march", "april", "may", "june", "july", "august", "September", "october", "november", "december"];

  var lower = String(month).toLowerCase();

  var index = months.indexOf(lower);

  if (index === -1) {
    console.warn("Invalid month provided:", month);
    return 0;
  }

  return index;
}

/***/ }),

/***/ "OsJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isGoogleCalendarConnected;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createMeeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMeeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteMeeting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_constants__ = __webpack_require__("gY6d");







function getAuthBody() {
  var currentUser = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["auth"]().currentUser;
  return {
    uid: currentUser && currentUser.uid,
    companyEmail: currentUser && currentUser.email
  };
}

function isGoogleCalendarConnected() {
  return !!localStorage.getItem('gc_access_token');
}

var createMeeting = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event) {
    var response, err;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_5__assets_config_constants__["f" /* serverURL */] + '/google-calendar/create-meeting', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getAuthBody(), { event: event }))
            });

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 8;
              break;
            }

            _context.next = 6;
            return response.json();

          case 6:
            err = _context.sent;
            throw new Error(err.error || 'Failed to create meeting');

          case 8:
            return _context.abrupt('return', response.json());

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function createMeeting(_x) {
    return _ref.apply(this, arguments);
  };
}();

var updateMeeting = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(eventId, event) {
    var response, err;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_5__assets_config_constants__["f" /* serverURL */] + '/google-calendar/update-meeting', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getAuthBody(), { eventId: eventId, event: event }))
            });

          case 2:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 8;
              break;
            }

            _context2.next = 6;
            return response.json();

          case 6:
            err = _context2.sent;
            throw new Error(err.error || 'Failed to update meeting');

          case 8:
            return _context2.abrupt('return', response.json());

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function updateMeeting(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var deleteMeeting = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(eventId) {
    var response, err;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_5__assets_config_constants__["f" /* serverURL */] + '/google-calendar/delete-meeting', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getAuthBody(), { eventId: eventId }))
            });

          case 2:
            response = _context3.sent;

            if (response.ok) {
              _context3.next = 8;
              break;
            }

            _context3.next = 6;
            return response.json();

          case 6:
            err = _context3.sent;
            throw new Error(err.error || 'Failed to delete meeting');

          case 8:
            return _context3.abrupt('return', response.json());

          case 9:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function deleteMeeting(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "P/Qr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BugReportModal_vue__ = __webpack_require__("Ig3y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349cf70e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BugReportModal_vue__ = __webpack_require__("WoeS");
function injectStyle (ssrContext) {
  __webpack_require__("KzeF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-349cf70e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BugReportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349cf70e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BugReportModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ppg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variables: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ "Pu0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UIComponents_GradeDropdown_vue__ = __webpack_require__("0AJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_UserProfileData_designations_json__ = __webpack_require__("Gq4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_UserProfileData_designations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_UserProfileData_designations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_designationGrades_json__ = __webpack_require__("nVsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_designationGrades_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_designationGrades_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__ = __webpack_require__("nvCY");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_4_src_assets_icons_PencilIcon_js__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_6__UIComponents_CustomDropdown_vue__["a" /* default */],
    GradeDropdown: __WEBPACK_IMPORTED_MODULE_7__UIComponents_GradeDropdown_vue__["a" /* default */]
  },
  props: {
    isAdmin: Boolean
  },
  data: function data() {
    return {
      tableColumns: [{ label: "Designation", key: "designation", sortable: true, width: 280 }, { label: "Grade", key: "grade", width: 340 }, { label: "Target Score", key: "score", width: 140, align: "right" }, { label: "Actions", key: "action", sticky: "right", width: 100 }],
      scoreList: [],
      selectedScore: null,
      isScoreModalOpen: false,
      isDeleteModalOpen: false,
      selectedDesignation: "",
      selectedGrade: "",
      score: null,
      designations: __WEBPACK_IMPORTED_MODULE_8__data_UserProfileData_designations_json___default.a.designations || [],
      designationGrades: __WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_designationGrades_json___default.a.designationGrades || {},
      loadingStates: { table: false, save: false, delete: false }
    };
  },


  computed: {
    filteredColumns: function filteredColumns() {
      return this.isAdmin ? this.tableColumns : this.tableColumns.filter(function (c) {
        return c.key !== "action";
      });
    }
  },

  mounted: function mounted() {
    this.fetchScores();
  },


  methods: {
    onDesignationChange: function onDesignationChange(value) {
      this.selectedDesignation = value;
      this.selectedGrade = "";
    },
    onGradeChange: function onGradeChange(value) {
      this.selectedGrade = value;
    },
    openScoreModal: function openScoreModal() {
      this.resetForm();
      this.isScoreModalOpen = true;
    },
    editScore: function editScore(item) {
      this.selectedScore = item;
      this.selectedDesignation = item.designation || "";
      this.selectedGrade = item.gradeValue || item.grade || "";
      this.score = item.score || 0;
      this.isScoreModalOpen = true;
    },
    resetForm: function resetForm() {
      this.selectedScore = null;
      this.selectedDesignation = "";
      this.selectedGrade = "";
      this.score = null;
    },
    hasChanges: function hasChanges() {
      if (!this.selectedScore) return true;

      return this.selectedDesignation !== (this.selectedScore.designation || "") || this.selectedGrade !== (this.selectedScore.gradeValue || this.selectedScore.grade || "") || Number(this.score) !== Number(this.selectedScore.score);
    },
    saveScore: function saveScore() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var gradeList, selectedGradeObj, payload, adminActivity, _adminActivity;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.selectedDesignation) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Validation Error", "Designation is required", "error");
                return _context.abrupt("return");

              case 3:
                if (_this.selectedGrade) {
                  _context.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Validation Error", "Grade is required", "error");
                return _context.abrupt("return");

              case 6:
                if (!(_this.score === null || _this.score === "" || isNaN(_this.score))) {
                  _context.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Validation Error", "Target score is required", "error");
                return _context.abrupt("return");

              case 9:
                if (!(_this.score < 0)) {
                  _context.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Validation Error", "Target score cannot be negative.", "error");
                return _context.abrupt("return");

              case 12:
                if (!(_this.score === 0)) {
                  _context.next = 15;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Validation Error", "Target score cannot be zero", "error");
                return _context.abrupt("return");

              case 15:
                if (_this.hasChanges()) {
                  _context.next = 18;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("No Changes", "No changes were made to the target score.", "info");
                return _context.abrupt("return");

              case 18:
                gradeList = _this.designationGrades[_this.selectedDesignation] || [];
                selectedGradeObj = gradeList.find(function (g) {
                  return String(g.value) === String(_this.selectedGrade);
                });
                payload = {
                  designation: _this.selectedDesignation,
                  grade: _this.selectedGrade,
                  gradeLabel: selectedGradeObj ? selectedGradeObj.label : _this.selectedGrade,
                  score: Number(_this.score),
                  updatedAt: new Date().toISOString()
                };
                _context.prev = 21;

                _this.loadingStates.save = true;

                if (!(_this.selectedScore && _this.selectedScore.uid)) {
                  _context.next = 32;
                  break;
                }

                adminActivity = {
                  adminId: _this.$store.state.auth.user.uid,
                  activityByUserName: _this.$store.state.auth.user.username || 'Admin',
                  action: "Updated",
                  activityTitle: "Updated Target Score",
                  activityDescription: "Performance target scores updated for " + (selectedGradeObj ? selectedGradeObj.label : _this.selectedGrade) + ": " + _this.selectedScore.score + " \u2192 " + payload.score,
                  activityName: "Performance target scores updated for " + (selectedGradeObj ? selectedGradeObj.label : _this.selectedGrade) + ": " + _this.selectedScore.score + " \u2192 " + payload.score,
                  type: "update_score_by_grade",
                  timestamp: new Date().toLocaleString('en-PK'),
                  uid: _this.selectedScore.uid
                };
                _context.next = 27;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 27:
                _context.next = 29;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].updatePerformanceScoreByGrade(_this.selectedScore.uid, payload);

              case 29:
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Success!", "Target score updated successfully", "success");
                _context.next = 38;
                break;

              case 32:
                _adminActivity = {
                  adminId: _this.$store.state.auth.user.uid,
                  activityByUserName: _this.$store.state.auth.user.username || 'Admin',
                  action: "Added",
                  activityTitle: "Added Target Score",
                  activityDescription: "Performance target scores added for " + (selectedGradeObj ? selectedGradeObj.label : _this.selectedGrade) + ": " + payload.score,
                  activityName: "Performance target scores added for " + (selectedGradeObj ? selectedGradeObj.label : _this.selectedGrade) + ": " + payload.score,
                  type: "add_score_by_grade",
                  timestamp: new Date().toLocaleString('en-PK')
                };
                _context.next = 35;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__["c" /* logAdminActivity */])(_adminActivity);

              case 35:
                _context.next = 37;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].addPerformanceScoreByGrade(payload);

              case 37:
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Success!", "Target score added successfully", "success");

              case 38:
                _context.next = 40;
                return _this.fetchScores();

              case 40:
                _this.isScoreModalOpen = false;
                _context.next = 47;
                break;

              case 43:
                _context.prev = 43;
                _context.t0 = _context["catch"](21);

                console.error(_context.t0);
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Error", _context.t0.message || "Failed to save target score", "error");

              case 47:
                _context.prev = 47;

                _this.loadingStates.save = false;
                return _context.finish(47);

              case 50:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[21, 43, 47, 50]]);
      }))();
    },
    openDeleteModal: function openDeleteModal(item) {
      this.selectedScore = item;
      this.isDeleteModalOpen = true;
    },
    deleteScore: function deleteScore() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var adminActivity;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loadingStates.delete = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].deletePerformanceScoreByGrade(_this2.selectedScore.uid);

              case 4:
                adminActivity = {
                  adminId: _this2.$store.state.auth.user.uid,
                  activityByUserName: _this2.$store.state.auth.user.username || 'Admin',
                  action: "Deleted",
                  activityTitle: "Deleted Target Score",
                  activityDescription: "Performance target scores deleted for " + _this2.selectedScore.gradeLabel + ": " + _this2.selectedScore.score,
                  activityName: "Performance target scores deleted for " + _this2.selectedScore.gradeLabel + ": " + _this2.selectedScore.score,
                  type: "delete_score_by_grade",
                  timestamp: new Date().toLocaleString('en-PK'),
                  uid: _this2.selectedScore.uid
                };
                _context2.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 7:
                _context2.next = 9;
                return _this2.fetchScores();

              case 9:
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Deleted", "Target score removed successfully", "success");
                _this2.isDeleteModalOpen = false;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Error", "Failed to delete target score", "error");

              case 16:
                _context2.prev = 16;

                _this2.loadingStates.delete = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 13, 16, 19]]);
      }))();
    },
    fetchScores: function fetchScores() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var list;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loadingStates.table = true;
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].getAllPerformanceScoresByGrade();

              case 4:
                list = _context3.sent;

                _this3.scoreList = list || [];
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

                console.error(_context3.t0);
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Error", "Could not load target scores", "error");

              case 12:
                _context3.prev = 12;

                _this3.loadingStates.table = false;
                return _context3.finish(12);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8, 12, 15]]);
      }))();
    }
  }
});

/***/ }),

/***/ "PzTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomDropdown_vue__ = __webpack_require__("nLtf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65af09fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomDropdown_vue__ = __webpack_require__("G3aJ");
function injectStyle (ssrContext) {
  __webpack_require__("bXbZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65af09fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65af09fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "QJQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_fileUtils__ = __webpack_require__("mq8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_formDataBuilder__ = __webpack_require__("Hgzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_flowiseService__ = __webpack_require__("zmwx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_backendService__ = __webpack_require__("aOf0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_fileUtils__ = __webpack_require__("mq8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_flowiseService__ = __webpack_require__("zmwx");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var FLOWISE_BASE = "https://cloud.flowiseai.com/api/v1";
var BACKEND_BASE = "https://pertime.expertizo.co";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    CustomTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_5_src_assets_icons_PencilIcon_js__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_ReuseableModal_vue__["a" /* default */]
  },

  data: function data() {
    return {
      searchTerm: "",
      tableColumns: [{ label: "File Name", key: "fileName", sortable: true, width: 40 }, { label: "Uploaded By", key: "username", sortable: true, width: 20 }, { label: "Uploaded At", key: "uploadedAt", sortable: true, width: 20 }, { label: "Action", key: "action", width: 20 }],
      isDeleteModalOpen: false,
      selectedFile: null,
      editTarget: null,
      isEdit: false,

      loading: false,
      newFileUploadLoading: false,
      deleteLoading: false,
      response: null,
      fileList: [],

      loadingStates: {
        table: false,
        upload: false,
        edit: false,
        delete: false
      },

      documentStoreId: "b839a237-e072-4967-9e1b-b6bfd70e38da",
      apiKey: "5FSQZNZ-IBtHUJGDvlRI9AJs7jq7VLIn2XGAkRUi56A",
      dbName: "pertime",
      collectionName: "flowise",
      OPENAI_EMBEDDINGS_KEY: "d0391cfa-9b3b-4eef-84d5-dcd029f5b79f",
      MONGODB_Atlas_KEY: "63e48fdf-90d4-402a-a740-93b8bdf2127d"
    };
  },


  computed: {
    user: function user() {
      return this.$store.state.auth.user || { username: 'anonymous' };
    }
  },

  mounted: function mounted() {
    this.fetchDocuments();
  },


  methods: {
    formatDate: function formatDate(dateStr) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_fileUtils__["a" /* formatToLocaleString */])(dateStr);
    },
    triggerFileInput: function triggerFileInput(item) {
      var isEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.editTarget = item;
      this.isEdit = isEdit;
      this.$refs.editFileInput.click();
    },
    startUpload: function startUpload() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var edit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.editTarget = item;
      this.isEdit = edit === true;
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    handleFileUpload: function handleFileUpload(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, sizeCheck, fileSizeMB, check, filename, uniqueFileId, formData, loaderId, fileId, uploadResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = event.target.files[0];

                if (file) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (!(!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_fileUtils__["b" /* isDocx */])(file) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_fileUtils__["c" /* isPdf */])(file))) {
                  _context.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Only DOCX or PDF allowed", "Please upload another file", "error");
                return _context.abrupt("return");

              case 6:
                _context.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_fileUtils__["d" /* validateFileSize */])(file, 2);

              case 8:
                sizeCheck = _context.sent;

                if (sizeCheck.ok) {
                  _context.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Invalid file size", sizeCheck.message, "error");
                return _context.abrupt("return");

              case 12:
                fileSizeMB = file.size / (1024 * 1024);
                _context.next = 15;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_flowiseService__["a" /* canUploadFile */])(fileSizeMB, FLOWISE_BASE, _this.apiKey);

              case 15:
                check = _context.sent;

                if (check.ok) {
                  _context.next = 19;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Limit reached", check.message, "error");
                return _context.abrupt("return");

              case 19:
                filename = file.name.replace(/\.[^/.]+$/, "");
                uniqueFileId = crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random().toString(36).slice(2, 8);
                formData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_formDataBuilder__["a" /* buildFormData */])({
                  file: file,
                  filename: filename,
                  uniqueFileId: uniqueFileId,
                  user: _this.user,
                  OPENAI_EMBEDDINGS_KEY: _this.OPENAI_EMBEDDINGS_KEY,
                  MONGODB_Atlas_KEY: _this.MONGODB_Atlas_KEY,
                  dbName: _this.dbName,
                  collectionName: _this.collectionName
                });
                _context.prev = 22;

                if (_this.isEdit && _this.editTarget) {
                  _this.loadingStates.edit = true;
                } else {
                  _this.loadingStates.upload = true;
                }

                loaderId = _this.editTarget && _this.editTarget.id ? _this.editTarget.id : null;
                fileId = _this.editTarget && _this.editTarget.loaderConfig && _this.editTarget.loaderConfig.metadata && _this.editTarget.loaderConfig.metadata.fileId ? _this.editTarget.loaderConfig.metadata.fileId : null;
                _context.next = 28;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_flowiseService__["b" /* uploadFile */])({
                  FLOWISE_BASE: FLOWISE_BASE,
                  documentStoreId: _this.documentStoreId,
                  apiKey: _this.apiKey,
                  formData: formData
                });

              case 28:
                uploadResult = _context.sent;

                if (!(uploadResult && uploadResult.ok && !loaderId && !fileId)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 32;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_backendService__["a" /* createSearchIndexIfNeeded */])({
                  BACKEND_BASE: BACKEND_BASE,
                  dbName: _this.dbName,
                  collectionName: _this.collectionName
                });

              case 32:
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("File has been uploaded", "Uploaded", "success");

              case 33:
                if (!(_this.isEdit && _this.editTarget)) {
                  _context.next = 37;
                  break;
                }

                _context.next = 36;
                return _this.deleteFile(_this.editTarget.id, _this.editTarget.loaderConfig.metadata.fileId, true);

              case 36:
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("File has been updated", "Updated", "success");

              case 37:
                _context.next = 43;
                break;

              case 39:
                _context.prev = 39;
                _context.t0 = _context["catch"](22);

                console.error('Upload error', _context.t0);
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Upload failed', _context.t0.message || 'Something went wrong', 'error');

              case 43:
                _context.prev = 43;

                _this.loadingStates.upload = false;
                _this.loadingStates.edit = false;
                _this.isEdit = false;
                _this.editTarget = null;
                _context.next = 50;
                return _this.fetchDocuments();

              case 50:
                return _context.finish(43);

              case 51:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[22, 39, 43, 51]]);
      }))();
    },
    fetchDocuments: function fetchDocuments() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingStates.table = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_flowiseService__["c" /* fetchDocumentsAPI */])({
                  FLOWISE_BASE: FLOWISE_BASE,
                  documentStoreId: _this2.documentStoreId,
                  apiKey: _this2.apiKey
                });

              case 4:
                data = _context2.sent;


                _this2.fileList = data.loaders || [];
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                console.error('Error fetching files:', _context2.t0);
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Fetch failed', 'Could not load files', 'error');

              case 12:
                _context2.prev = 12;

                _this2.loadingStates.table = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8, 12, 15]]);
      }))();
    },


    openDeleteModal: function openDeleteModal(item) {
      this.selectedFile = item;
      this.isDeleteModalOpen = true;
    },

    confirmDelete: function confirmDelete() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var loaderId, fileId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.selectedFile) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                loaderId = _this3.selectedFile.id;
                fileId = _this3.selectedFile.loaderConfig.metadata.fileId;
                _context3.next = 6;
                return _this3.deleteFile(loaderId, fileId, false);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    deleteFile: function deleteFile(loaderId) {
      var _this4 = this;

      var fileId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var flowiseJson, backendJson;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!loaderId || !fileId)) {
                  _context4.next = 3;
                  break;
                }

                console.warn('deleteFile called without loaderId or fileId', { loaderId: loaderId, fileId: fileId });
                return _context4.abrupt("return");

              case 3:

                _this4.loadingStates.delete = true;
                _context4.prev = 4;
                _context4.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_flowiseService__["d" /* deleteLoader */])({
                  FLOWISE_BASE: FLOWISE_BASE,
                  documentStoreId: _this4.documentStoreId,
                  loaderId: loaderId,
                  apiKey: _this4.apiKey
                });

              case 7:
                flowiseJson = _context4.sent;
                _context4.next = 10;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_backendService__["b" /* deleteByFileId */])({
                  BACKEND_BASE: BACKEND_BASE,
                  dbName: _this4.dbName,
                  collectionName: _this4.collectionName,
                  fileId: fileId
                });

              case 10:
                backendJson = _context4.sent;


                if (!replace) {
                  _this4.isDeleteModalOpen = false;
                  __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('File has been deleted', 'Deleted', 'success');
                }

                _context4.next = 14;
                return _this4.fetchDocuments();

              case 14:
                return _context4.abrupt("return", { flowise: flowiseJson, backend: backendJson });

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](4);

                console.error('Error deleting file:', _context4.t0);
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Delete failed', _context4.t0.message || 'Could not delete file', 'error');

              case 21:
                _context4.prev = 21;

                _this4.loadingStates.delete = false;
                return _context4.finish(21);

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 17, 21, 24]]);
      }))();
    }
  }
});

/***/ }),

/***/ "QTts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_fileUtils__ = __webpack_require__("mq8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__ = __webpack_require__("guQB");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Cards_Card_vue__["a" /* default */],
    CustomTable: __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_CustomTable_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_ReuseableModal_vue__["a" /* default */]
  },

  data: function data() {
    return {
      searchTerm: "",
      resetTableFlag: false,
      bugList: [],
      selectedBug: null,
      isModalOpen: false,

      tableColumns: [{ label: "Email", key: "email", sortable: true, sticky: "left" }, { label: "Description", key: "description", sticky: "left" }, { label: "Reported Date", key: "timestamp", sortable: true }, { label: "Status", key: "status", sortable: true }, { label: "Open Details", key: "open" }, { label: "Action", key: "action", sticky: "right" }],

      loadingStates: {
        table: false,
        updateStatus: {}
      }
    };
  },


  computed: {
    filteredBugs: function filteredBugs() {
      if (!this.searchTerm) return this.bugList;

      var term = this.searchTerm.toLowerCase();
      return this.bugList.filter(function (bug) {
        return bug.email.toLowerCase().includes(term) || bug.description.toLowerCase().includes(term);
      });
    }
  },

  mounted: function mounted() {
    this.fetchReportedBugs();
  },


  methods: {
    handleUpdateBugStatus: function handleUpdateBugStatus(bug) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$set(_this.loadingStates.updateStatus, bug.id, true);
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].updateBugStatus(bug.id);

              case 4:
                _this.fetchReportedBugs();
                swal("Success", "Bug status updated successfully.", "success");
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.error("Failed to update bug status", _context.t0);

              case 11:
                _context.prev = 11;

                _this.$set(_this.loadingStates.updateStatus, bug.id, false);
                return _context.finish(11);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 11, 14]]);
      }))();
    },
    formatDate: function formatDate(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_fileUtils__["e" /* formatAdminActivityDate */])(date);
    },
    fetchReportedBugs: function fetchReportedBugs() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingStates.table = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].getAllBugReports();

              case 4:
                _this2.bugList = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);

                console.error("Failed to fetch bugs", _context2.t0);

              case 10:
                _context2.prev = 10;

                _this2.loadingStates.table = false;
                return _context2.finish(10);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 7, 10, 13]]);
      }))();
    },
    openBug: function openBug(bug) {
      this.selectedBug = bug;
      this.isModalOpen = true;
    },
    getStatusClass: function getStatusClass(status) {
      return {
        "open": "status-badge pending",
        "Resolved": "status-badge approved"
      }[status] || "status-badge";
    }
  },

  watch: {
    searchTerm: function searchTerm() {
      this.resetTableFlag = true;
    }
  }
});

/***/ }),

/***/ "QV0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DoubleLoader'
});

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    columns: Array,
    data: Array,
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    isImage: function isImage(item, column) {
      return column.toLowerCase() === "avatar";
    },
    itemValue: function itemValue(item, column) {
      var lowerCaseColumn = column.toLowerCase();
      if (lowerCaseColumn === "phone number") {
        return item["phoneNumber"];
      } else if (lowerCaseColumn === "nic") {
        return item["nicNumber"];
      } else {
        return item[column.toLowerCase()];
      }
    }
  }
});

/***/ }),

/***/ "QsZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qtum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
    pageOptions: {
      type: Array,
      default: function _default() {
        return [5, 10, 15, 20];
      }
    },
    maxVisiblePages: { type: Number, default: 7 }
  },
  computed: {
    visiblePages: function visiblePages() {
      var pages = [];
      var total = this.totalPages;
      var current = this.currentPage;
      var max = this.maxVisiblePages;
      if (total <= max) {
        for (var i = 1; i <= total; i++) {
          pages.push({ value: i, display: i, key: i });
        }
      } else {
        var start = Math.max(1, current - Math.floor(max / 2));
        var end = start + max - 1;
        if (end > total) {
          end = total;
          start = end - max + 1;
        }

        if (start > 1) pages.push({ value: 1, display: 1, key: 1 });
        if (start > 2) pages.push({ value: null, display: '...', key: 'start-ellipsis', ellipsis: true });

        for (var _i = start; _i <= end; _i++) {
          pages.push({ value: _i, display: _i, key: _i });
        }if (end < total - 1) pages.push({ value: null, display: '...', key: 'end-ellipsis', ellipsis: true });
        if (end < total) pages.push({ value: total, display: total, key: total });
      }
      return pages;
    }
  },
  methods: {
    changePage: function changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit('change-page', page);
      }
    }
  }
});

/***/ }),

/***/ "R2fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("Ln1U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b7742c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("BITr");
function injectStyle (ssrContext) {
  __webpack_require__("7pLE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96b7742c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b7742c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746daa5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("Rlqh");
function injectStyle (ssrContext) {
  __webpack_require__("uNpY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746daa5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RYtT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RdAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplateItem_vue__ = __webpack_require__("/pYi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50890ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplateItem_vue__ = __webpack_require__("Atj7");
function injectStyle (ssrContext) {
  __webpack_require__("pxek")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50890ec0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplateItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50890ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplateItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rlqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",attrs:{"data-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"simple-text",attrs:{"to":"/"}},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":"static/img/new-Logo-color.png"}})])],1),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"sidebar-wrapper"},[_c('ul',{staticClass:"nav"},_vm._l((_vm.sidebarLinks),function(link,index){return _c('router-link',{key:("" + link + index),ref:link.name,refInFor:true,attrs:{"to":link.path,"tag":"li"}},[_c('a',[_c('i',{class:link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(link.name)+"\n          ")])])])}),1)]),_vm._v(" "),_c('div',{staticClass:"sidebar-background",staticStyle:{"background-image":"url(/static/img/blurred-image-1.jpg)"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RmNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('ReportedBugs',{ref:"fileTable"}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S0cN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxReportExport_vue__ = __webpack_require__("UDry");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cdd687e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxReportExport_vue__ = __webpack_require__("DJCN");
function injectStyle (ssrContext) {
  __webpack_require__("g5jX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cdd687e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxReportExport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cdd687e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxReportExport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S5nd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHNF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('AdminUserManagement'):_c('EmployeeUserManagement')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SJFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uploadToCloudinary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var _this = this;

var cloudinaryConfig = {
  cloudName: "dtcgqqyjo",
  apiKey: "866623847274671",
  apiSecret: "Ku7ndIHeH4-0qglNbhAoX37Mq7M",
  uploadPreset: "employee_profile"
};

var isRawFile = function isRawFile(file) {
  var name = file.name && file.name.toLowerCase() || '';
  var type = file.type || '';
  return type === 'application/msword' || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // .docx
  name.endsWith('.doc') || name.endsWith('.docx');
};

// `uploadPreset` defaults to `type`; pass an existing preset to reuse it for a new folder
var uploadToCloudinary = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file, type) {
    var uploadPreset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : type;
    var folder, resourceType, formData, response, data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            folder = 'pertime/user/' + type;
            resourceType = isRawFile(file) ? 'raw' : 'image';
            _context.prev = 2;
            formData = new FormData();

            formData.append('file', file);
            formData.append('upload_preset', uploadPreset);
            formData.append('folder', folder);

            _context.next = 9;
            return fetch('https://api.cloudinary.com/v1_1/' + cloudinaryConfig.cloudName + '/' + resourceType + '/upload', {
              method: 'POST',
              body: formData
            });

          case 9:
            response = _context.sent;

            if (response.ok) {
              _context.next = 12;
              break;
            }

            throw new Error('Upload failed with status ' + response.status);

          case 12:
            _context.next = 14;
            return response.json();

          case 14:
            data = _context.sent;
            return _context.abrupt('return', data.secure_url);

          case 18:
            _context.prev = 18;
            _context.t0 = _context['catch'](2);

            console.error('Error uploading to Cloudinary (' + folder + '):', _context.t0);
            throw new Error('Failed to upload file to Cloudinary');

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[2, 18]]);
  }));

  return function uploadToCloudinary(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


/***/ }),

/***/ "SKLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplateManager_vue__ = __webpack_require__("UufD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2238295e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplateManager_vue__ = __webpack_require__("cFw1");
function injectStyle (ssrContext) {
  __webpack_require__("vh+9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2238295e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailTemplateManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2238295e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailTemplateManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SLNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adjustments-container"},[_c('div',{staticClass:"adjust-button-container"},[_c('button',{staticClass:"add-adjustment",on:{"click":_vm.openAddModal}},[_vm._v(_vm._s(_vm.isAdmin ? "Add Adjustment" : "Add Expense"))])]),_vm._v(" "),_c('AdjustmentTable',{attrs:{"loading":_vm.loading,"data":_vm.filteredAdjustments,"employee-list":_vm.employeeList,"working-days":_vm.workingDays,"working-hours":_vm.workingHours,"working-days-in-month":_vm.workingDaysInMonth,"can-modify":_vm.canModify},on:{"edit":_vm.openEditModal,"openDeleteModal":_vm.openDeleteModal}}),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isModalOpen,"title":_vm.modalTitle,"isLarge":true,"submitButtonText":"Save","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isModalOpen = $event},"submit":_vm.saveAdjustment}},[_c('form',{staticStyle:{"padding":"10px 0px"},on:{"submit":function($event){$event.preventDefault();return _vm.saveAdjustment()}}},[_c('div',{staticClass:"form-group row"},[(_vm.isAdmin)?_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('CustomDropdown',{attrs:{"id":"employee","label":"Employee","options":_vm.employeeOptions,"required":true,"value":_vm.selectedEmployeeId,"placeholder":"Select Employee","show-error":_vm.employeeError !== '',"error-message":_vm.employeeError},on:{"change":_vm.selectEmployeeId}})],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('CustomDropdown',{attrs:{"id":"adjustmentType","label":"Adjustment Type","options":_vm.adjustmentTypeOptions,"required":true,"value":_vm.selectedAdjustmentType,"placeholder":"Select Type","show-error":_vm.typeError !== '',"error-message":_vm.typeError},on:{"change":_vm.selectAdjustmentType}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[(_vm.isExpense)?_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('label',{attrs:{"for":"expenseAmount"}},[_vm._v("Amount (Rs.) "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.expenseAmount),expression:"expenseAmount",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"id":"expenseAmount","type":"number","placeholder":"Enter amount","min":"1","step":"any"},domProps:{"value":(_vm.expenseAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.expenseAmount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.amountError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.amountError))]):_vm._e()]):_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('CustomDropdown',{attrs:{"id":"amount","label":"Amount","options":_vm.amountOptions,"required":true,"value":_vm.amount,"placeholder":"Select Amount","show-error":_vm.amountError !== '',"error-message":_vm.amountError,"custom":true},on:{"change":_vm.handleAmountChange}}),_vm._v(" "),(_vm.amount === 'Custom Value')?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customAmount),expression:"customAmount",modifiers:{"number":true}}],staticClass:"form-control",staticStyle:{"margin-top":"5px","width":"100%"},attrs:{"type":"number","placeholder":"Enter custom amount","min":"0"},domProps:{"value":(_vm.customAmount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customAmount=_vm._n($event.target.value)},_vm.validateForm],"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('CustomDropdown',{attrs:{"id":"month","label":"Month","options":_vm.monthItems,"required":true,"value":_vm.selectedModalMonth,"placeholder":"Select Month","show-error":_vm.monthError !== '',"error-message":_vm.monthError},on:{"change":_vm.selectModalMonth}}),_vm._v(" "),(_vm.monthError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.monthError))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"7px"}},[_c('CustomDropdown',{attrs:{"id":"year","label":"Year","options":_vm.yearItems,"required":true,"value":_vm.selectedModalYear,"placeholder":"Select Year","show-error":_vm.yearError !== '',"error-message":_vm.yearError},on:{"change":_vm.selectModalYear}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"reason"}},[_vm._v(_vm._s(_vm.isExpense ? "Description" : "Reason")+" "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reason),expression:"reason"}],staticClass:"form-control",attrs:{"id":"reason","placeholder":_vm.isExpense ? 'What was this expense for?' : 'Enter reason'},domProps:{"value":(_vm.reason)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.reason=$event.target.value},_vm.checkReasonLength]}}),_vm._v(" "),(_vm.reasonError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.reasonError))]):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"display":"flex","justify-content":"end","font-size":"12px","color":"#666"}},[_vm._v("\n            Characters: "+_vm._s(_vm.reasonLength)+"/300\n          ")])])]),_vm._v(" "),(_vm.isExpense)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"receipt"}},[_vm._v("Receipt "),_c('span',{staticClass:"optional-label"},[_vm._v("(optional)")])]),_vm._v(" "),_c('input',{ref:"receiptInput",staticClass:"form-control",attrs:{"id":"receipt","type":"file","accept":"image/*,.pdf"},on:{"change":_vm.onReceiptSelected}}),_vm._v(" "),(_vm.receiptFile || _vm.receiptUrl)?_c('div',{staticClass:"receipt-current"},[(!_vm.receiptFile)?_c('a',{attrs:{"href":_vm.receiptUrl,"target":"_blank","rel":"noopener"}},[_vm._v("View current receipt")]):_c('span',[_vm._v(_vm._s(_vm.receiptFile.name))]),_vm._v(" "),_c('button',{staticClass:"receipt-remove",attrs:{"type":"button"},on:{"click":_vm.removeReceipt}},[_vm._v("Remove")])]):_vm._e(),_vm._v(" "),(_vm.receiptError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.receiptError))]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeleteModalOpen,"title":"Confirm Delete","isLarge":false,"submitButtonText":"Delete","cancelButtonText":"Cancel","loading":_vm.isLoading},on:{"update:modelValue":function($event){_vm.isDeleteModalOpen = $event},"submit":_vm.confirmDelete}},[(_vm.deleteItem && _vm.deleteItem.employeeName)?_c('p',[_vm._v("\n      Are you sure you want to delete the adjustment for "),_c('strong',[_vm._v(_vm._s(_vm.deleteItem.employeeName))]),_vm._v("?\n    ")]):_c('p',[_vm._v("Are you sure you want to delete this adjustment?")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SWYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UIComponents_Buttons_ResetIconButton_vue__ = __webpack_require__("0IWI");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EmployeeInfo",
  components: {
    ResetIconButton: __WEBPACK_IMPORTED_MODULE_1__UIComponents_Buttons_ResetIconButton_vue__["a" /* default */]
  },
  props: ["employee", "initialValues"],
  data: function data() {
    return {
      localEmployee: {
        employeeName: "",
        basicSalary: 0,
        extraAllowance: 0,
        perDaySalary: 0,
        requiredWorkingDays: 0
      },
      perDaySalaryManuallySet: false,
      originalEmployee: {}
    };
  },

  computed: {
    isDisabled: function isDisabled() {
      return this.$store.state.auth.user.role !== "admin";
    }
  },
  watch: {
    employee: {
      immediate: true,
      deep: true,
      handler: function handler(newVal) {
        this.localEmployee = {
          employeeName: newVal.employeeName || "",
          basicSalary: newVal.basicSalary || "",
          extraAllowance: newVal.extraAllowance || "",
          perDaySalary: newVal.perDaySalary || 0,
          requiredWorkingDays: newVal.requiredWorkingDays || 0
        };
        this.perDaySalaryManuallySet = false;
        this.autoCalculatePerDaySalary();
        this.originalEmployee = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.localEmployee);
      }
    }
  },
  methods: {
    handleChange: function handleChange() {
      if (!this.perDaySalaryManuallySet) {
        this.autoCalculatePerDaySalary();
      }
      this.$emit("update-employee", this.localEmployee);
    },
    manualOverride: function manualOverride() {
      this.perDaySalaryManuallySet = true;
      this.$emit("update-employee", this.localEmployee);
    },
    autoCalculatePerDaySalary: function autoCalculatePerDaySalary() {
      var basic = parseFloat(this.localEmployee.basicSalary) || 0;
      var extra = parseFloat(this.localEmployee.extraAllowance) || 0;
      var days = parseInt(this.localEmployee.requiredWorkingDays, 10) || 0;

      if (days > 0) {
        this.localEmployee.perDaySalary = parseFloat(((basic + extra) / days).toFixed(2));
      }
    },
    resetEmptyField: function resetEmptyField(field) {
      var newValue = this.initialValues[field];

      if (this.localEmployee[field] === null || this.localEmployee[field] === '' || isNaN(this.localEmployee[field]) || this.localEmployee[field] === 0 || this.localEmployee[field] !== newValue) {
        // Force Vue to detect the change
        this.$set(this.localEmployee, field, newValue);
        this.handleChange();
      }
    },
    hasChanged: function hasChanged(field) {
      var value = this.localEmployee[field] !== this.initialValues[field];
      return value;
    }
  }

});

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_Login_vue__ = __webpack_require__("mJTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_ResetPassword_vue__ = __webpack_require__("/ruN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Overview_vue__ = __webpack_require__("R2fa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_UserProfile_vue__ = __webpack_require__("B2Q4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChatbotManagement_index_vue__ = __webpack_require__("b0E1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_userManagement_index_vue__ = __webpack_require__("URhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Performance_index_vue__ = __webpack_require__("fV+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Reports_vue__ = __webpack_require__("JniN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_TableList_vue__ = __webpack_require__("yNcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Maps_vue__ = __webpack_require__("9279");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Typography_vue__ = __webpack_require__("mat/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Icons_vue__ = __webpack_require__("U7xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_LeaveManagement__ = __webpack_require__("Tvk2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_Views_Settings_vue__ = __webpack_require__("AM9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_complains__ = __webpack_require__("b6pX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PayrollManagement_index_vue__ = __webpack_require__("XpFn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PayrollManagement_PayrollDetails_index_vue__ = __webpack_require__("KKzb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_PayrollManagement_Payslip_PaySlip_vue__ = __webpack_require__("1rke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Policies_vue__ = __webpack_require__("1b4e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Dashboard_Views_AdminActivities_index_vue__ = __webpack_require__("yWQk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Dashboard_Views_ReportedBugs_index_vue__ = __webpack_require__("u4P3");




// GeneralViews


// Admin pages




















var routes = [{
  path: '/',
  name: "Login",
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_Login_vue__["a" /* default */]
}, {
  path: '/resetPassword',
  name: 'ResetPassword',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Login_ResetPassword_vue__["a" /* default */]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/overview'
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  name: "Dashboard",
  redirect: '/stats',
  children: [{
    path: 'overview',
    name: 'overview',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Overview_vue__["a" /* default */]
  }, {
    path: 'user',
    name: 'User Profile',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_UserProfile_vue__["a" /* default */]
  }, {
    path: 'user/:id',
    name: 'User Profile With ID',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_UserProfile_vue__["a" /* default */],
    props: true
  }, {
    path: 'userManagement',
    name: 'User Management',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_userManagement_index_vue__["a" /* default */]
  }, {
    path: 'performance',
    name: 'Performance',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Performance_index_vue__["a" /* default */]
  }, {
    path: 'reports',
    name: 'User Reports',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Reports_vue__["a" /* default */]
  }, {
    path: 'tables',
    name: 'Table List',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_TableList_vue__["a" /* default */]
  }, {
    path: 'leave',
    name: 'Leave Management',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_LeaveManagement__["a" /* default */]
  }, {
    path: 'payroll',
    name: 'Payroll Management',
    component: __WEBPACK_IMPORTED_MODULE_17__components_PayrollManagement_index_vue__["a" /* default */]
  }, {
    path: 'payroll/details/:employeeId',
    name: 'Payroll Details',
    component: __WEBPACK_IMPORTED_MODULE_18__components_PayrollManagement_PayrollDetails_index_vue__["a" /* default */],
    props: true
  }, {
    path: 'payroll/payslip/:employeeId',
    name: 'payslip',
    component: __WEBPACK_IMPORTED_MODULE_19__components_PayrollManagement_Payslip_PaySlip_vue__["a" /* default */]
  }, {
    path: 'settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_Views_Settings_vue__["a" /* default */]
  }, {
    path: 'complains',
    name: 'Complains',
    component: __WEBPACK_IMPORTED_MODULE_16__components_complains__["a" /* default */]
  }, {
    path: 'policies',
    name: 'Policies',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Policies_vue__["a" /* default */]
  }, {
    path: 'reported-bugs',
    name: 'Reported Bugs',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Dashboard_Views_ReportedBugs_index_vue__["a" /* default */]
  }, {
    path: 'activity-logs',
    name: 'Admin Activities',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Dashboard_Views_AdminActivities_index_vue__["a" /* default */]
  }, {
    path: 'chatbot',
    name: 'Chatbot Management',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChatbotManagement_index_vue__["a" /* default */]
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_3__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T3Oj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LateTimeDropdown_vue__ = __webpack_require__("M2ks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b57f4f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LateTimeDropdown_vue__ = __webpack_require__("bAcE");
function injectStyle (ssrContext) {
  __webpack_require__("8f3O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b57f4f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LateTimeDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b57f4f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LateTimeDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TJj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:" main-container d-flex flex-column"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-login"},[_c('div',{staticClass:"form-container"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.confirmReset($event)}}},[_c('span',{staticClass:"full-width d-inline-block text-center",staticStyle:{"font-size":"20px","font-weight":"600","margin-bottom":"20px"}},[_vm._v("\n              Set a New Password\n            ")]),_vm._v(" "),_c('div',{staticClass:"form-group margin-base-y"},[_c('label',{staticClass:"control-label",attrs:{"for":"new-password"}},[_vm._v("Enter new Password:")]),_vm._v(" "),_c('div',{staticClass:"password-input-wrapper"},[((_vm.showNewPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"form-control input-field",attrs:{"id":"new-password","placeholder":"Enter new password","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.newPassword)?_vm._i(_vm.newPassword,null)>-1:(_vm.newPassword)},on:{"input":_vm.clearErrors,"change":function($event){var $$a=_vm.newPassword,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newPassword=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newPassword=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newPassword=$$c}}}}):((_vm.showNewPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"form-control input-field",attrs:{"id":"new-password","placeholder":"Enter new password","type":"radio"},domProps:{"checked":_vm._q(_vm.newPassword,null)},on:{"input":_vm.clearErrors,"change":function($event){_vm.newPassword=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"form-control input-field",attrs:{"id":"new-password","placeholder":"Enter new password","type":_vm.showNewPassword ? 'text' : 'password'},domProps:{"value":(_vm.newPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value},_vm.clearErrors]}}),_vm._v(" "),_c('span',{staticClass:"password-toggle",on:{"click":function($event){_vm.showNewPassword = !_vm.showNewPassword}}},[_c('i',{class:_vm.showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'})])]),_vm._v(" "),_c('div',{staticClass:"form-group margin-base-y",staticStyle:{"position":"relative","margin-bottom":"5px"}},[_c('label',{staticClass:"control-label",attrs:{"for":"confirm-password"}},[_vm._v("Confirm Password:")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('div',{staticClass:"password-input-wrapper"},[((_vm.showConfirmPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control input-field",attrs:{"id":"confirm-password","placeholder":"Confirm new password","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.confirmPassword)?_vm._i(_vm.confirmPassword,null)>-1:(_vm.confirmPassword)},on:{"input":_vm.clearErrors,"change":function($event){var $$a=_vm.confirmPassword,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.confirmPassword=$$a.concat([$$v]))}else{$$i>-1&&(_vm.confirmPassword=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.confirmPassword=$$c}}}}):((_vm.showConfirmPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control input-field",attrs:{"id":"confirm-password","placeholder":"Confirm new password","type":"radio"},domProps:{"checked":_vm._q(_vm.confirmPassword,null)},on:{"input":_vm.clearErrors,"change":function($event){_vm.confirmPassword=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control input-field",attrs:{"id":"confirm-password","placeholder":"Confirm new password","type":_vm.showConfirmPassword ? 'text' : 'password'},domProps:{"value":(_vm.confirmPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value},_vm.clearErrors]}}),_vm._v(" "),_c('span',{staticClass:"password-toggle",on:{"click":function($event){_vm.showConfirmPassword = !_vm.showConfirmPassword}}},[_c('i',{class:_vm.showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'})])])]),_vm._v(" "),(_vm.formError)?_c('div',{staticClass:"text-danger",staticStyle:{"position":"absolute"}},[_vm._v(_vm._s(_vm.formError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"35px"}},[_c('button',{staticClass:"login-button",attrs:{"type":"submit","disabled":_vm.isLoading}},[(_vm.isLoading)?_c('img',{staticClass:"next-arrow",attrs:{"src":"static/img/loader.gif"}}):_c('span',[_vm._v("Reset Password")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-toggleable-md bg-theme nopadding-y"},[_c('div',{staticClass:" nopadding-y"},[_c('a',{staticClass:"navbar-brand nopadding-y",attrs:{"href":"#"}},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":__webpack_require__("pyqL")}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_chatbotLoader__ = __webpack_require__("LDEv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_chatbotLoader__["a" /* loadChatbot */])();
  }
});

/***/ }),

/***/ "Ttoc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TvP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_assets_config_firebase__ = __webpack_require__("guQB");



var _this = this;



var settings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(userId, constants) {
    var userData;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2__src_assets_config_firebase__["a" /* default */].getSingleUser(userId);

          case 3:
            userData = _context.sent;

            console.log("constants:", constants);

            if (!(userData && userData.specificSetting === true)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              days: userData.workingDays || constants.days,
              totalHours: userData.productiveHours || constants.totalHours,
              late: userData.late || constants.late
            });

          case 7:
            return _context.abrupt("return", constants);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);

            console.error("Error fetching user settings:", _context.t0);
            return _context.abrupt("return", constants);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 10]]);
  }));

  return function settings(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "Tvk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("8qAE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9eea88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("xNt5");
function injectStyle (ssrContext) {
  __webpack_require__("oIti")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d9eea88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9eea88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TwCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdjustmentTable_vue__ = __webpack_require__("jKu3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba35a79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdjustmentTable_vue__ = __webpack_require__("386r");
function injectStyle (ssrContext) {
  __webpack_require__("zkri")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ba35a79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdjustmentTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba35a79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdjustmentTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U72P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */] }
});

/***/ }),

/***/ "U7xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("U72P");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f3f09de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("B7VG");
function injectStyle (ssrContext) {
  __webpack_require__("eQDl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f3f09de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "UA9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "ResetButton",
    data: function data() {
        return {
            isRotating: false
        };
    },

    methods: {
        handleClick: function handleClick() {
            var _this = this;

            this.isRotating = true;
            this.$emit("reset");

            // Remove rotation class after animation duration
            setTimeout(function () {
                _this.isRotating = false;
            }, 600); // Match duration in CSS
        }
    }
});

/***/ }),

/***/ "UAIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-component"},[_c('div',{staticClass:"table-wrapper relative"},[(_vm.loading)?_c('div',{staticClass:"table-loader"},[_c('div',{staticClass:"spinner"})]):_vm._e(),_vm._v(" "),_c('table',{class:_vm.tableClass},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{key:JSON.stringify(column),style:(_vm.getHeaderStyle(column)),on:{"click":function($event){column.sortable ? _vm.sortTable(column.key) : null}}},[_vm._v("\n            "+_vm._s(column.label)+"\n            "),(column.sortable)?_c('span',{staticStyle:{"position":"absolute","width":"20px","text-align":"center"}},[(_vm.sortKey === column.key)?_c('i',{class:_vm.sortOrder === 'asc' ? 'now-ui-icons arrows-1_minimal-up' : 'now-ui-icons arrows-1_minimal-down'}):_c('i',{staticClass:"now-ui-icons arrows-1_minimal-up",staticStyle:{"visibility":"hidden"}})]):_vm._e()])}),0)]),_vm._v(" "),_c('tbody',{staticClass:"table-scroll"},_vm._l((_vm.paginatedData),function(item){return _c('tr',{key:JSON.stringify(item),staticClass:"table-row",on:{"mouseover":function($event){_vm.hoveredRow = item},"mouseleave":function($event){_vm.hoveredRow = null}}},_vm._l((_vm.columns),function(column){return _c('td',{key:JSON.stringify(column),class:['table-cell-td', { 'sticky-action': column.sticky }],style:(_vm.getCellStyle(column, item))},[_vm._t(column.key,[_vm._v("\n              "+_vm._s(item[column.key])+"\n            ")],{"item":item})],2)}),0)}),0)])]),_vm._v(" "),_c('PaginationComponent',{attrs:{"currentPage":_vm.currentPage,"totalPages":_vm.totalPages,"visiblePages":_vm.visiblePages,"itemsPerPage":_vm.itemsPerPage,"pageOptions":_vm.pageOptions},on:{"change-page":_vm.changePage,"change-items-per-page":_vm.changeItemsPerPage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UDry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_config_helpers__ = __webpack_require__("DJ6O");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var FISCAL_YEAR_START_MONTH = 6; // July

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TaxReportExport",
  components: { ReuseableModal: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_ReuseableModal_vue__["a" /* default */] },
  data: function data() {
    return {
      showModal: false,
      exporting: false,
      error: "",
      months: __WEBPACK_IMPORTED_MODULE_7__assets_config_constants__["a" /* monthNames */],
      years: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_config_helpers__["t" /* generateYearsArray */])(),
      preset: "fiscalYear",
      presetOptions: [{ value: "fiscalYear", label: "Current Fiscal Year (Jul - Jun)" }, { value: "previousFiscalYear", label: "Previous Fiscal Year (Jul - Jun)" }, { value: "calendarYear", label: "Current Calendar Year (Jan - Dec)" }, { value: "last6Months", label: "Last 6 Months" }, { value: "custom", label: "Custom" }],
      fromMonth: 0,
      fromYear: new Date().getFullYear(),
      toMonth: 11,
      toYear: new Date().getFullYear()
    };
  },

  methods: {
    openModal: function openModal() {
      this.error = "";
      this.preset = "fiscalYear";
      this.applyPreset();
      this.showModal = true;
    },
    applyPreset: function applyPreset() {
      var now = new Date();
      var month = now.getMonth();
      var year = now.getFullYear();
      var fiscalStartYear = month >= FISCAL_YEAR_START_MONTH ? year : year - 1;

      switch (this.preset) {
        case "fiscalYear":
          this.setRange(FISCAL_YEAR_START_MONTH, fiscalStartYear, FISCAL_YEAR_START_MONTH - 1, fiscalStartYear + 1);
          break;
        case "previousFiscalYear":
          this.setRange(FISCAL_YEAR_START_MONTH, fiscalStartYear - 1, FISCAL_YEAR_START_MONTH - 1, fiscalStartYear);
          break;
        case "calendarYear":
          this.setRange(0, year, 11, year);
          break;
        case "last6Months":
          {
            var start = new Date(year, month - 5, 1);
            this.setRange(start.getMonth(), start.getFullYear(), month, year);
            break;
          }
        default:
          break;
      }
    },
    setRange: function setRange(fromMonth, fromYear, toMonth, toYear) {
      this.fromMonth = fromMonth;
      this.fromYear = fromYear;
      this.toMonth = toMonth;
      this.toYear = toYear;
    },
    getPeriods: function getPeriods() {
      var periods = [];
      var end = this.toYear * 12 + this.toMonth;
      for (var index = this.fromYear * 12 + this.fromMonth; index <= end; index++) {
        var year = Math.floor(index / 12);
        var month = __WEBPACK_IMPORTED_MODULE_7__assets_config_constants__["a" /* monthNames */][index % 12];
        periods.push({ year: year, month: month, label: month.slice(0, 3) + "-" + year });
      }
      return periods;
    },
    getGrossSalary: function getGrossSalary(payroll) {
      return Number(payroll.basicSalary || payroll.salary || 0) + Number(payroll.extraAllowance || 0);
    },
    exportReport: function exportReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var periods, snapshots, usersById, employees, employeeList, buildRows, header, workbook, first, last;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = "";

                if (!(_this.fromYear * 12 + _this.fromMonth > _this.toYear * 12 + _this.toMonth)) {
                  _context.next = 4;
                  break;
                }

                _this.error = "The 'From' period must be before the 'To' period.";
                return _context.abrupt("return");

              case 4:

                _this.exporting = true;
                _context.prev = 5;
                periods = _this.getPeriods();
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(periods.map(function (_ref) {
                  var year = _ref.year,
                      month = _ref.month;
                  return __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.database().ref("payroll/" + year + "/" + month).once("value");
                }));

              case 9:
                snapshots = _context.sent;
                usersById = {};

                (_this.$store.state.auth.allUsers || []).forEach(function (user) {
                  usersById[user.uid] = user;
                });

                // employeeId -> { name, nic, salary: { label: value }, tax: { label: value } }
                employees = {};

                snapshots.forEach(function (snapshot, index) {
                  var label = periods[index].label;

                  var records = snapshot.exists() ? snapshot.val() : {};
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(records).forEach(function (payrollId) {
                    var payroll = records[payrollId];
                    if (!payroll || payroll.isSuperAdmin || !payroll.employeeId) return;
                    if (String(payroll.status || "").toLowerCase() !== "processed") return;

                    var user = usersById[payroll.employeeId] || {};
                    if (!employees[payroll.employeeId]) {
                      employees[payroll.employeeId] = {
                        name: user.username || payroll.employeeName || "",
                        nic: user.nicNumber || "",
                        salary: {},
                        tax: {}
                      };
                    }
                    var employee = employees[payroll.employeeId];
                    employee.salary[label] = (employee.salary[label] || 0) + _this.getGrossSalary(payroll);
                    employee.tax[label] = (employee.tax[label] || 0) + (Number(payroll.taxDeduction) || 0);
                  });
                });

                employeeList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(employees).map(function (id) {
                  return employees[id];
                }).sort(function (a, b) {
                  return a.name.localeCompare(b.name);
                });

                if (employeeList.length) {
                  _context.next = 18;
                  break;
                }

                _this.error = "No processed payroll records found for the selected period.";
                return _context.abrupt("return");

              case 18:
                buildRows = function buildRows(key) {
                  return employeeList.map(function (employee) {
                    var row = { "Employee Name": employee.name, NIC: employee.nic };
                    var total = 0;
                    periods.forEach(function (_ref2) {
                      var label = _ref2.label;

                      var value = Math.round(employee[key][label] || 0);
                      row[label] = value;
                      total += value;
                    });
                    row.Total = total;
                    return row;
                  });
                };

                header = ["Employee Name", "NIC"].concat(periods.map(function (p) {
                  return p.label;
                }), ["Total"]);
                workbook = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(buildRows("salary"), { header: header }), "Salary");
                XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(buildRows("tax"), { header: header }), "Tax Deducted");

                first = periods[0].label;
                last = periods[periods.length - 1].label;

                XLSX.writeFile(workbook, "Salary_Tax_Report_" + first + "_to_" + last + ".xlsx");
                _this.showModal = false;
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context["catch"](5);

                console.error("Error exporting salary & tax report:", _context.t0);
                _this.error = "Failed to export the report. Please try again.";

              case 33:
                _context.prev = 33;

                _this.exporting = false;
                return _context.finish(33);

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 29, 33, 36]]);
      }))();
    }
  }
});

/***/ }),

/***/ "URhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("p8kD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40696cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SHNF");
function injectStyle (ssrContext) {
  __webpack_require__("mHo8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40696cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UufD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EmailTemplateItem_vue__ = __webpack_require__("RdAx");








//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { EmailTemplateItem: __WEBPACK_IMPORTED_MODULE_10__EmailTemplateItem_vue__["a" /* default */] },

  data: function data() {
    return {
      activeTemplateId: null,
      templates: []

    };
  },
  mounted: function mounted() {
    this.fetchEmailTemplates();
  },

  methods: {
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dbTemplatesObj, dbTemplates;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].getEmailTemplates();

              case 3:
                dbTemplatesObj = _context.sent;

                console.log("Fetched templates from DB:", dbTemplatesObj);

                if (dbTemplatesObj) {
                  _context.next = 8;
                  break;
                }

                _this.templates = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__assets_config_constants__["j" /* STATIC_TEMPLATES */]));
                return _context.abrupt("return");

              case 8:
                dbTemplates = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(dbTemplatesObj).map(function (_ref) {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, value, {
                    dbId: key
                  });
                });


                _this.templates = _this.mergeTemplates(__WEBPACK_IMPORTED_MODULE_8__assets_config_constants__["j" /* STATIC_TEMPLATES */], dbTemplates);
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.error("Failed to fetch email templates", _context.t0);
                _this.templates = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__assets_config_constants__["j" /* STATIC_TEMPLATES */]));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    },
    mergeTemplates: function mergeTemplates(staticTemplates, dbTemplates) {
      var staticMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();

      staticTemplates.forEach(function (t) {
        staticMap.set(t.title, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, t));
      });

      dbTemplates.forEach(function (dbTemplate) {
        if (staticMap.has(dbTemplate.title)) {
          staticMap.set(dbTemplate.title, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, staticMap.get(dbTemplate.title), dbTemplate, {
            id: staticMap.get(dbTemplate.title).id
          }));
        } else {
          staticMap.set(dbTemplate.title, dbTemplate);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(staticMap.values());
    },
    toggleTemplate: function toggleTemplate(id) {
      this.activeTemplateId = this.activeTemplateId === id ? null : id;
    },
    handleSaveTemplate: function handleSaveTemplate(updatedTemplate) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("Saving template:", updatedTemplate);
                _context2.prev = 1;

                if (!updatedTemplate.dbId) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].updateEmailTemplate(updatedTemplate.dbId, updatedTemplate);

              case 5:
                _context2.next = 11;
                break;

              case 7:
                _context2.next = 9;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].addEmailTemplate(updatedTemplate);

              case 9:
                res = _context2.sent;


                updatedTemplate.dbId = res.id;

              case 11:

                _this2.templates = _this2.templates.map(function (t) {
                  return t.id === updatedTemplate.id ? updatedTemplate : t;
                });
                swal("Saved", "Email template saved successfully", "success");
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](1);

                console.error("Template save failed", _context2.t0);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 15]]);
      }))();
    }
  }
});

/***/ }),

/***/ "VC1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeLeaveManagement_vue__ = __webpack_require__("ozhT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267cc599_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeLeaveManagement_vue__ = __webpack_require__("OKCK");
function injectStyle (ssrContext) {
  __webpack_require__("NcLo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-267cc599"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeLeaveManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267cc599_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeLeaveManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VH9K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VK5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayMode === 'status')?_c('div',{staticStyle:{"width":"150px","height":"30px","margin-left":"8px","display":"flex","justify-content":"center"}},[(_vm.isAdmin)?_c('CustomDropdown',{attrs:{"id":"status","options":_vm.statusOptions,"value":_vm.item.status,"placeholder":'Select Status',"disabled":!_vm.isAdmin,"height":'30px'},on:{"change":function($event){return _vm.onStatusChange($event)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.displayMode === 'resignationDate')?_c('div',{staticClass:"resignation-date"},[(_vm.item.status === 'Resigned')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.resignationDate),expression:"item.resignationDate"}],staticClass:"resignation",attrs:{"type":"date"},domProps:{"value":(_vm.item.resignationDate)},on:{"change":function($event){return _vm.updateResignationDate($event, _vm.item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "resignationDate", $event.target.value)}}}):_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.item.status === 'Resigned' && _vm.item.resignationDate)?_c('span',{staticClass:"info-icon",on:{"mouseenter":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false}}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"#5EC1A5"}}),_vm._v(" "),(_vm.showTooltip)?_c('span',{staticClass:"tooltip"},[_vm._v("\n        "+_vm._s(_vm.tooltipText)+"\n      ")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.displayMode !== 'status' && _vm.displayMode !== 'resignationDate')?_c('div',[_c('span',[_vm._v("Invalid displayMode: "+_vm._s(_vm.displayMode))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VLbD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Vs7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("sMWI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1832cccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("aH+L");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1832cccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W/Va":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W5YQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activities && _vm.activities.length > 0)?_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('div',{staticClass:"overflow-auto",staticStyle:{"max-height":"250px","min-height":"200px"}},[_c('table',{staticClass:"table-auto min-w-max text-sm border border-gray-400 rounded-lg overflow-auto"},[_c('thead',{staticClass:"bg-gray-100"},[_c('tr',_vm._l((_vm.columns),function(col,i){return _c('th',{key:i,staticClass:"border border-gray-400 px-3 py-2 font-semibold text-gray-700",style:({ minWidth: col.width || '130px' })},[_vm._v("\n              "+_vm._s(col.label)+"\n            ")])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.activities),function(activity,i){return _c('tr',{key:i,staticClass:"hover:bg-gray-50"},_vm._l((_vm.columns),function(col,j){return _c('td',{key:j,staticClass:"border border-gray-400 px-3 py-2 text-left",style:({ minWidth: col.width || '100px' })},[(col.key === 'timestamp')?_c('span',[(activity.timestamp)?_c('span',{attrs:{"title":activity[col.key] || 'N/A'}},[_vm._v("\n                  "+_vm._s(_vm.formatTimestamp(activity.timestamp))+"\n                ")]):_c('span',[_vm._v("N/A")])]):(col.truncate)?_c('span',{attrs:{"title":activity[col.key] || 'N/A'}},[_vm._v("\n                "+_vm._s(_vm.truncateText(activity[col.key] || "N/A", col.length))+"\n              ")]):(col.key === 'map')?_c('span',[(activity.map)?_c('span',{staticClass:"text-blue-500 underline cursor-pointer",on:{"click":function($event){return _vm.handleMap(activity)}}},[_c('u',[_vm._v("View")])]):_c('span',[_vm._v("N/A")])]):(col.key === 'browserName')?_c('span',[_vm._v("\n                "+_vm._s(_vm.getBrowserName(activity.browserName))+"\n              ")]):(col.key === 'reason')?_c('span',[_vm._v("\n                "+_vm._s(activity.reason || "N/A")+"\n              ")]):_c('span',{staticClass:"relative"},[(activity[col.key] && typeof activity[col.key] === 'object' && !Array.isArray(activity[col.key]))?[_c('span',{staticClass:"text-blue-500 mr-2"},[_vm._v("Multiple")]),_vm._v(" "),_c('span',{staticClass:"detail-tooltip-wrapper inline-block",on:{"mouseover":function($event){return _vm.showDetails(activity.id || i, col.key)},"mouseleave":function($event){return _vm.hideDetails(activity.id || i, col.key)}}},[_c('i',{staticClass:"fa fa-info-circle text-info pointer info-icon"}),_vm._v(" "),(_vm.visibleDetails[_vm.getDetailKey(activity.id || i, col.key)])?_c('div',{staticClass:"detail-tooltip-box absolute left-0 bottom-full mb-2 bg-gray-800 text-white text-xs rounded py-2 px-3 z-10 whitespace-nowrap"},[_c('div',{staticClass:"details-title font-semibold mb-1"},[_vm._v("Changes")]),_vm._v(" "),_c('ul',{staticClass:"details-list list-disc list-inside"},_vm._l((activity[col.key]),function(value,key){return _c('li',{key:key,staticClass:"detail-item"},[_c('strong',[_vm._v(_vm._s(key)+":")]),_vm._v(" "+_vm._s(value || 'N/A')+"\n                        ")])}),0)]):_vm._e()])]:_c('span',{attrs:{"title":activity[col.key] || 'N/A'}},[_vm._v("\n                  "+_vm._s(activity[col.key] || "N/A")+"\n                ")])],2)])}),0)}),0)])])])]):_c('div',[_c('p',[_vm._v("No activity history found.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WIzc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wi1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"variables"},[_c('strong',[_vm._v("Available Variables")]),_vm._v(" "),_c('p',{staticClass:"hint"},[_vm._v("Click to insert:")]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.variables),function(variable){return _c('button',{key:variable.value,on:{"click":function($event){return _vm.$emit('insert', variable.value)}}},[_vm._v("\n      "+_vm._s(variable.label)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wll5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WoeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReuseableModal',{attrs:{"modelValue":_vm.isOpen,"title":"Report a Bug","scrollable":true,"loading":_vm.loading,"submitButtonText":"Submit","closeButtonText":"Close","fullOverlay":_vm.fullOverlay},on:{"update:modelValue":function($event){return _vm.$emit('update:isOpen', $event)},"submit":_vm.submitBugReport,"close":_vm.resetForm}},[_c('div',{staticClass:"form-group margin-base-y",staticStyle:{"position":"relative"}},[_c('label',{staticClass:"control-label",attrs:{"for":"email"}},[_vm._v("Email "),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-control bug-input-field",staticStyle:{"border":"1px solid #DDDDDD !important"},attrs:{"type":"email","id":"email","placeholder":"Enter your email","disabled":_vm.isUserLoggedIn},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),(_vm.error.email)?_c('div',{staticClass:"text-danger",style:(_vm.isUserLoggedIn ? 'font-size: 12px; margin-top: -5px;' : 'font-size: 12px; margin-top: 5px;')},[_vm._v("\n      "+_vm._s(_vm.error.email)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("How to reproduce the bug? "),_c('span',{staticClass:"required-asterisk"},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control bug-text-area",staticStyle:{"border":"1px solid #DDDDDD !important"},attrs:{"id":"description","placeholder":"Type your description...","required":""},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}}),_vm._v(" "),(_vm.error.description)?_c('div',{staticClass:"text-danger",style:(_vm.isUserLoggedIn ? 'font-size: 12px; margin-top: -5px;' : 'font-size: 12px; margin-top: 5px;')},[_vm._v(_vm._s(_vm.error.description))]):_vm._e()]),_vm._v(" "),_c('div',{},[_c('label',{attrs:{"for":"priority"}},[_vm._v("Priority")]),_vm._v(" "),_c('CustomDropdown',{attrs:{"name":"priority","id":"priority","label":"","options":_vm.priorities,"placeholder":"Select your priority","show-error":false},on:{"change":_vm.handlePriorityChange},model:{value:(_vm.form.priority),callback:function ($$v) {_vm.$set(_vm.form, "priority", $$v)},expression:"form.priority"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"-10px"}},[_c('label',{attrs:{"for":"priority"}},[_vm._v("Screenshot")]),_vm._v(" "),(!_vm.form.screenshot)?_c('div',{staticClass:"file-upload-area",on:{"click":_vm.triggerFileInput,"dragover":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();return _vm.handleFile($event)}}},[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.handleFile}}),_vm._v(" "),_c('div',{staticClass:"upload-icon"},[_c('i',{staticClass:"fas fa-upload"})]),_vm._v(" "),_c('div',{staticClass:"upload-text"},[_vm._v("\n        Click to browse or drag and drop\n        "),_c('div',{staticClass:"upload-format"},[_vm._v("Supported formats: PNG, JPEG, JPG")])])]):_c('div',{staticClass:"file-preview"},[_c('div',{staticClass:"file-info"},[(_vm.isImageFile)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.form.screenshot}}):(_vm.isPdfFile)?_c('i',{staticClass:"fas fa-file-pdf fa-3x"}):_c('i',{staticClass:"fas fa-file-word fa-3x"})]),_vm._v(" "),_c('div',{staticClass:"action-button-container"},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.removeFile}},[_c('i',{staticClass:"fas fa-trash-alt"})])])]),_vm._v(" "),(_vm.error.screenshot)?_c('div',{staticClass:"text-danger",staticStyle:{"font-size":"12px","margin-top":"3px"}},[_vm._v(_vm._s(_vm.error.screenshot)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WtC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"settings"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"}),_vm._v(" "),_c('Card',[_c('div',{staticClass:"tab-container"},[(_vm.activeTab !== 'general' && _vm.activeTab !== 'performance')?_c('div',{staticClass:"empoyee-dropdown-container"},[_c('EmployeeDropdown',{attrs:{"employees":_vm.$store.state.auth.allUsers,"company":_vm.$store.state.auth.company,"defaultFilter":"active"},on:{"update":function($event){_vm.filteredUsers = $event}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"left-section",staticStyle:{"width":"200px"}}),_vm._v(" "),_c('div',{staticClass:"tabs"},[_c('button',{class:{ active: _vm.activeTab === 'general' },on:{"click":function($event){_vm.activeTab = 'general'}}},[_vm._v("\n                General Settings\n              ")]),_vm._v(" "),(_vm.isAdmin)?_c('button',{class:{ active: _vm.activeTab === 'employee' },on:{"click":function($event){_vm.activeTab = 'employee'}}},[_vm._v("\n                Employee Specific Settings\n              ")]):_vm._e(),_vm._v(" "),_c('button',{class:{ active: _vm.activeTab === 'performance' },on:{"click":function($event){_vm.activeTab = 'performance'}}},[_vm._v("\n                Performance Criteria\n              ")])])]),_vm._v(" "),(_vm.activeTab === 'general')?_c('div',{staticClass:"settings-content general-settings"},[_c('div',{staticClass:"settings-grid"},[_c('div',{staticClass:"left-section"},[_c('div',{staticClass:"form-group"},[_c('h5',{staticClass:"title"},[_vm._v("Working Days")]),_vm._v(" "),_c('div',{staticClass:"checkbox-group"},_vm._l((_vm.weekDays),function(day){return _c('div',{key:day,staticClass:"checkbox-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDays),expression:"selectedDays"}],attrs:{"type":"checkbox","id":day,"disabled":!_vm.isAdmin},domProps:{"value":day,"checked":Array.isArray(_vm.selectedDays)?_vm._i(_vm.selectedDays,day)>-1:(_vm.selectedDays)},on:{"change":function($event){var $$a=_vm.selectedDays,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedDays=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedDays=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedDays=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":day}},[_vm._v(_vm._s(day))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"right-section"},[_c('div',{staticClass:"right-section-content"},[_c('div',{staticClass:"form-group"},[_c('h5',{staticClass:"title"},[_vm._v("Total Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productiveHours),expression:"productiveHours"}],staticClass:"genral-setting-input",attrs:{"type":"number","disabled":!_vm.isAdmin,"min":"0","max":"24"},domProps:{"value":(_vm.productiveHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productiveHours=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group time-dropdown-container"},[_c('h5',{staticClass:"title",attrs:{"for":"lateTime"}},[_vm._v("Late Time")]),_vm._v(" "),_c('div',{ref:"dropdown",staticClass:"time-dropdown",staticStyle:{"width":"100%","padding":"3px"}},[_c('div',{staticClass:"selected-time",on:{"click":function($event){return _vm.toggleLateTime('currentUser')}}},[_vm._v("\n                        "+_vm._s(_vm.selectedHour)+" : "+_vm._s(_vm.selectedMinute)+" "+_vm._s(_vm.selectedMeridian)+"\n                      ")]),_vm._v(" "),(_vm.activeLateDropdown === 'currentUser')?_c('div',{staticClass:"time-selector time-selector-genral"},[_c('div',{staticClass:"time-columns"},[_c('LateTimeDropdown',{attrs:{"data":_vm.hours,"selected":_vm.selectedHour},on:{"change":function (value) { return _vm.onHourChange(value); }}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.minutes,"selected":_vm.selectedMinute},on:{"change":function (value) { return _vm.setMinute(value); }}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.meridians,"selected":_vm.selectedMeridian},on:{"change":function (value) { return _vm.setMeridian(value); }}})],1)]):_vm._e()])])]),_vm._v(" "),(_vm.isAdmin)?_c('button',{staticClass:"save-btn",attrs:{"disabled":!_vm.isAdmin},on:{"click":_vm.saveGeneralSettings}},[_vm._v("\n                    Save Changes\n                  ")]):_vm._e()])]),_vm._v(" "),(_vm.isSuperAdmin)?_c('div',[_c('hr'),_vm._v(" "),_c('SlackIntegration')],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',[_c('hr'),_vm._v(" "),_c('GoogleCalendarIntegration',{on:{"connected":_vm.onCalendarConnected,"disconnected":_vm.onCalendarDisconnected}})],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',[_c('hr'),_vm._v(" "),_c('CompanyDetails')],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',[_c('hr'),_vm._v(" "),_c('EmailTemplateManager')],1):_vm._e(),_vm._v(" "),_c('div',[_c('hr'),_vm._v(" "),_c('PublicHoliday')],1)]):_vm._e(),_vm._v(" "),(_vm.activeTab === 'employee' && _vm.isAdmin)?_c('div',{staticClass:"settings-content"},[_c('CustomTable',{attrs:{"columns":_vm.tableColumns,"data":_vm.filteredEmployeeList},scopedSlots:_vm._u([{key:"username",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"employee-name"},[_vm._v(_vm._s(item.username))])]}},{key:"lateTime",fn:function(ref){
var item = ref.item;
return [_c('div',{ref:'dropdown_employee_' + item.id,staticClass:"time-dropdown",attrs:{"refInFor":""}},[_c('div',{staticClass:"selected-time",on:{"click":function($event){return _vm.toggleLateTime(item.id)}}},[_vm._v("\n                      "+_vm._s(item.lateTime)+"\n                    ")]),_vm._v(" "),(_vm.activeLateDropdown === item.id)?_c('div',{staticClass:"time-selector"},[_c('div',{staticClass:"time-columns"},[_c('LateTimeDropdown',{attrs:{"data":_vm.hours,"selected":_vm.activeLateDropdown === item.id ? _vm.tempLateTime.hour : item.lateTime.split(':')[0]},on:{"change":function (value) { return _vm.onLateTimeChange(value, item.id, 'hour'); }}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.minutes,"selected":_vm.activeLateDropdown === item.id ? _vm.tempLateTime.minute : item.lateTime.split(':')[1].split(' ')[0]},on:{"change":function (value) { return _vm.onLateTimeChange(value, item.id, 'minute'); }}}),_vm._v(" "),_c('LateTimeDropdown',{attrs:{"data":_vm.meridians,"selected":_vm.activeLateDropdown === item.id ? _vm.tempLateTime.meridian : item.lateTime.split(' ')[1]},on:{"change":function (value) { return _vm.onLateTimeChange(value, item.id, 'meridian'); }}})],1),_vm._v(" "),_c('button',{staticClass:"save-btn-employee",on:{"click":function($event){return _vm.saveLateTime(item.id, $event)}}},[_vm._v("Save")])]):_vm._e()])]}},{key:"productiveHours",fn:function(ref){
var item = ref.item;
return [_c('input',{staticClass:"productive-input",attrs:{"type":"number","min":"0","max":"24"},domProps:{"value":item.productiveHours},on:{"input":function($event){return _vm.handleInput($event, item.id, 'productiveHours')},"blur":function($event){return _vm.commitInput(item.id, 'productiveHours')},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.commitInput(item.id, 'productiveHours')}}})]}},{key:"workingDays",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"workigndayes"},[_c('WorkingDays',{on:{"input":function($event){return _vm.updateWorkingDays(item, $event)}},model:{value:(item.workingDaysObject),callback:function ($$v) {_vm.$set(item, "workingDaysObject", $$v)},expression:"item.workingDaysObject"}})],1)]}},{key:"leavesAllowed",fn:function(ref){
var item = ref.item;
return [_c('input',{staticClass:"productive-input",attrs:{"type":"number","min":"0","max":"24"},domProps:{"value":item.leavesAllowed},on:{"input":function($event){return _vm.handleInput($event, item.id, 'leavesAllowed')},"blur":function($event){return _vm.commitInput(item.id, 'leavesAllowed')},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.commitInput(item.id, 'leavesAllowed')}}})]}},{key:"leavesAvailable",fn:function(ref){
var item = ref.item;
return [_c('input',{staticClass:"productive-input",attrs:{"type":"number","min":"0","max":"24"},domProps:{"value":item.leavesAvailable},on:{"input":function($event){return _vm.handleInput($event, item.id, 'leavesAvailable')},"blur":function($event){return _vm.commitInput(item.id, 'leavesAvailable')},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.commitInput(item.id, 'leavesAvailable')}}})]}},{key:"screenshot",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"switch-container"},[_c('div',{staticClass:"screenshot-label"},[_vm._v(_vm._s(item.screenshotEnabled ? 'Enabled' : 'Disabled'))]),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.screenshotEnabled),expression:"item.screenshotEnabled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.screenshotEnabled)?_vm._i(item.screenshotEnabled,null)>-1:(item.screenshotEnabled)},on:{"change":function($event){var $$a=item.screenshotEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "screenshotEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "screenshotEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "screenshotEnabled", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])])]}},{key:"specific",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"switch-container"},[_c('div',{staticClass:"spacific-label",attrs:{"data-tooltip":"Modifying Late Time, Productive Hours or Working Days only will change it to Specific"}},[_vm._v("\n                      "+_vm._s(item.specificSetting ? 'Specific' : 'General')+"\n                    "),_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"color":"yellowgreen","margin-left":"7px"}})])])]}},{key:"action",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"edit-btn btn-status",attrs:{"title":"Update"},on:{"click":function($event){return _vm.showUpdateConfirmModal(item)}}},[_c('i',{staticClass:"fas fa-check",staticStyle:{"color":"gray"}})]),_vm._v(" "),_c('div',{staticClass:"resets-btn btn-status",attrs:{"title":"Reset"},on:{"click":function($event){return _vm.showResetConfirmModal(item)}}},[_c('i',{staticClass:"fa fa-undo",staticStyle:{"color":"gray"}})])])]}}])})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'performance')?_c('div',{staticClass:"settings-content"},[_c('PerformanceCriteria')],1):_vm._e()])],1)]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.showUpdateModal,"title":"Confirm Update","submitButtonText":"Update"},on:{"update:modelValue":function($event){_vm.showUpdateModal = $event},"submit":_vm.confirmUpdateEmployee}},[_c('div',[_vm._v("Are you sure you want to update settings for "+_vm._s(_vm.selectedEmployee && _vm.selectedEmployee.username ?
        _vm.selectedEmployee.username : '')+"?")])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.showResetModal,"title":"Confirm Reset","submitButtonText":"Reset"},on:{"update:modelValue":function($event){_vm.showResetModal = $event},"submit":_vm.confirmResetEmployee}},[_c('div',[_vm._v("Are you sure you want to reset settings for "+_vm._s(_vm.selectedEmployee && _vm.selectedEmployee.username ?
        _vm.selectedEmployee.username : '')+" to default?")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X1E9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employee-dropdown"},[_c('div',{staticClass:"dropdown-container-1"},[_c('div',{staticClass:"dropdown-header",on:{"click":_vm.toggleDropdown}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","gap":"8px"}},[(_vm.selectedEmployee)?_c('div',{staticStyle:{"gap":"6px","display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{staticClass:"avatar",style:({ marginTop: _vm.isPayrollPath ? '-5px' : '5px' }),attrs:{"src":_vm.selectedEmployee.profile_picture || 'static/img/default-dp.png'}}),_vm._v(" "),_c('div',{staticClass:"status",staticStyle:{"margin-left":"8px"}},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.selectedEmployee.username))])])]):_c('div',[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v("\n            "+_vm._s(_vm.filterType === "active" ? "Active Employees" : "All Employees")+"\n          ")])])]),_vm._v(" "),_c('div',{staticStyle:{"color":"#7b7a7ac7","margin-right":"2px","font-size":"14px"}},[_c('i',{class:['fa ', _vm.dropdownOpen ? 'fa-chevron-up'  : 'fa-chevron-down']})])]),_vm._v(" "),(_vm.dropdownOpen)?_c('div',{staticClass:"dropdown-body"},[_c('div',{staticClass:"filter-options"},[_c('div',{staticClass:"filter-item",class:{ active: _vm.filterType === 'active' },on:{"click":function($event){return _vm.setFilter('active')}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.activeEmployees.length))])]),_vm._v(" "),_c('div',{staticClass:"filter-item",class:{ active: _vm.filterType === 'all' },on:{"click":function($event){return _vm.setFilter('all')}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.companyEmployees.length))])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"search-box",attrs:{"type":"text","placeholder":"Search employees..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('ul',{staticClass:"employee-list"},_vm._l((_vm.finalList),function(emp){return _c('li',{key:emp.uid,staticClass:"employee-item",on:{"click":function($event){return _vm.selectEmployee(emp)}}},[_c('div',{staticClass:"item"},[_c('img',{staticClass:"avatar",style:({ marginTop: _vm.isPayrollPath ? '-5px' : '15px' }),attrs:{"src":emp.profile_picture || 'static/img/default-dp.png'}}),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(emp.username))]),_vm._v(" "),(!emp.isActive)?_c('span',{staticClass:"small"},[_vm._v("(Inactive)")]):_vm._e()])]),_vm._v(" "),(_vm.selectedEmployee && _vm.selectedEmployee.uid === emp.uid)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","margin-left":"auto","margin-top":"-10px"}}):_vm._e()])}),0),_vm._v(" "),(_vm.finalList.length === 0)?_c('div',{staticClass:"employee-item",staticStyle:{"justify-content":"center","color":"#888"}},[_vm._v("\n        No matching employees found\n      ")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',{staticClass:"filter"},[_vm._v("Active Employees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',{staticClass:"filter"},[_vm._v("All Employees")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XWAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XXp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_fileUtils__ = __webpack_require__("mq8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    CustomTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_5_src_assets_icons_PencilIcon_js__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_9__UIComponents_CustomDropdown_vue__["a" /* default */]
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      tableColumns: [{ label: "Holiday Name", key: "name", sortable: true, width: 180, sticky: "left" }, { label: "Date", key: "dates", sortable: true }, { label: "Type", key: "isRecurring", sortable: true }, { label: "Shift", key: "shift", sortable: true }, { label: "Days", key: "numberOfDays", sortable: true }, { label: "Action", key: "action", sticky: "right" }],

      holidayList: [],
      selectedHoliday: null,
      isHolidayModalOpen: false,

      name: "",
      dates: "",
      numberOfDays: 1,
      isRecurring: false,
      shift: "General",

      shiftOptions: ["General", "Morning", "Night"],

      nameError: "",
      dateError: "",

      loadingStates: {
        table: false,
        save: false,
        delete: false
      }
    };
  },


  computed: {
    filteredColumns: function filteredColumns() {
      return this.isAdmin ? this.tableColumns : this.tableColumns.filter(function (col) {
        return col.key !== "action";
      });
    }
  },

  mounted: function mounted() {
    this.fetchHolidays();
  },


  methods: {
    formatDate: function formatDate(dateStr, oneTime, numberOfDays) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_fileUtils__["f" /* formatHolidayDate */])(dateStr, oneTime, numberOfDays);
    },
    openHolidayModal: function openHolidayModal() {
      this.resetForm();
      this.isHolidayModalOpen = true;
    },
    editHoliday: function editHoliday(item) {
      this.selectedHoliday = item;
      this.name = item.name;
      this.dates = item.dates;
      this.numberOfDays = item.numberOfDays;
      this.isRecurring = item.isRecurring;
      this.shift = item.shift || "General";
      this.isHolidayModalOpen = true;
    },
    onDaysInput: function onDaysInput(event) {
      var value = Number(event.target.value);

      if (value < 1 || !value) {
        this.numberOfDays = 1;
      }
    },
    resetForm: function resetForm() {
      this.name = "";
      this.dates = "";
      this.numberOfDays = 1;
      this.isRecurring = false;
      this.shift = "General";
      this.selectedHoliday = null;
    },
    saveHoliday: function saveHoliday() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.name) {
                  _context.next = 3;
                  break;
                }

                _this.nameError = "Holiday name is required";
                return _context.abrupt("return");

              case 3:
                _this.nameError = "";

                if (_this.dates) {
                  _context.next = 7;
                  break;
                }

                _this.dateError = "Date is required";
                return _context.abrupt("return");

              case 7:
                _this.dateError = "";
                payload = {
                  name: _this.name,
                  dates: _this.dates,
                  numberOfDays: _this.numberOfDays,
                  isRecurring: _this.isRecurring,
                  shift: _this.shift
                };
                _context.prev = 9;

                _this.loadingStates.save = true;

                if (!_this.selectedHoliday) {
                  _context.next = 18;
                  break;
                }

                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].updateHoliday(_this.selectedHoliday.uid, payload);

              case 14:
                _this.fetchHolidays();
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Holiday updated", "Updated", "success");
                _context.next = 22;
                break;

              case 18:
                _context.next = 20;
                return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].addHoliday(payload);

              case 20:
                _this.fetchHolidays();
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Holiday added", "Added", "success");

              case 22:

                _this.isHolidayModalOpen = false;
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](9);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Error", _context.t0.message || "Something went wrong", "error");

              case 28:
                _context.prev = 28;

                _this.loadingStates.save = false;
                return _context.finish(28);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 25, 28, 31]]);
      }))();
    },
    openDeleteModal: function openDeleteModal(item) {
      var _this2 = this;

      this.selectedHoliday = item;
      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: "Are you sure?",
        text: "This holiday will be permanently deleted.",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(willDelete) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!willDelete) {
                    _context2.next = 3;
                    break;
                  }

                  _context2.next = 3;
                  return _this2.deleteHoliday();

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    deleteHoliday: function deleteHoliday() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.loadingStates.delete = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].deleteHoliday(_this3.selectedHoliday.uid);

              case 4:
                _this3.fetchHolidays();
                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Holiday deleted", "Deleted", "success");
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Delete failed", _context3.t0.message || "Could not delete", "error");

              case 11:
                _context3.prev = 11;

                _this3.loadingStates.delete = false;
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8, 11, 14]]);
      }))();
    },
    fetchHolidays: function fetchHolidays() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var holidays, user, role, userShift;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.loadingStates.table = true;
                _context4.prev = 1;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 4:
                holidays = _context4.sent;
                user = _this4.$store.state.auth.user;
                role = user.role;
                userShift = (user.shift || "morning").toLowerCase();

                if (!(role === "admin")) {
                  _context4.next = 11;
                  break;
                }

                _this4.holidayList = holidays;
                return _context4.abrupt("return");

              case 11:

                _this4.holidayList = holidays.filter(function (h) {
                  var hShift = (h.shift || "morning").toLowerCase();

                  if (hShift === "general") return true;
                  if (userShift === "morning" && hShift === "morning") return true;
                  if (userShift === "night" && hShift === "night") return true;

                  return false;
                });
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](1);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("Fetch failed", "Could not load holidays", "error");

              case 17:
                _context4.prev = 17;

                _this4.loadingStates.table = false;
                return _context4.finish(17);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 14, 17, 20]]);
      }))();
    }
  }
});

/***/ }),

/***/ "XaVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPerformanceItemModal_vue__ = __webpack_require__("a5aD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ceec5b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPerformanceItemModal_vue__ = __webpack_require__("3IDo");
function injectStyle (ssrContext) {
  __webpack_require__("n45B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ceec5b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPerformanceItemModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ceec5b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPerformanceItemModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XpFn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ye5Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5e449f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("3NxQ");
function injectStyle (ssrContext) {
  __webpack_require__("3Sp4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b5e449f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5e449f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YIuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDuration; });
/* unused harmony export formatTime12 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatMovedToDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseDurationString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeNullFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseHours; });
/* unused harmony export formatHours */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortByMovedDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var formatDuration = function formatDuration(totalMs) {
  if (!totalMs || totalMs <= 0) return "N/A";
  var totalSeconds = Math.floor(totalMs / 1000);
  var totalHours = totalSeconds / 3600;
  var hours = Math.floor(totalHours);
  var minutes = Math.floor(totalSeconds % 3600 / 60);
  var decimalDays = (totalHours / 24).toFixed(1);
  return hours + 'h ' + minutes + 'min (' + decimalDays + ' days)';
};

var formatTime12 = function formatTime12(date) {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

var formatMovedToDone = function formatMovedToDone(dateStr, timeStr) {
  var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateStr + ' ' + timeStr, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm'], true);

  if (!date.isValid()) return 'N/A';

  return date.format('DD/MM/YYYY') + ' at ' + date.format('hh:mm A');
};

var parseDurationString = function parseDurationString(durationStr) {
  if (!durationStr || durationStr === "N/A") return 0;

  // If only a number is passed → treat as hours
  if (/^\d+$/.test(durationStr)) {
    var _hrs = parseInt(durationStr, 10);
    return _hrs * 3600 * 1000;
  }

  // Match formats like: "7 hrs 30 mins", "7h 30m"
  var match = durationStr.match(/(\d+)\s*h(?:rs)?\s*(\d+)?\s*m(?:ins)?/i);
  if (!match) return 0;

  var hrs = parseInt(match[1], 10) || 0;
  var mins = parseInt(match[2], 10) || 0;

  return (hrs * 3600 + mins * 60) * 1000;
};

var removeNullFields = function removeNullFields(obj) {
  return Object.fromEntries(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(obj).filter(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        _ = _ref2[0],
        v = _ref2[1];

    return v !== null && v !== undefined;
  }));
};
var parseHours = function parseHours(str) {
  if (!str || str === 'N/A') return 0;

  var hMatch = str.match(/(\d+)\s*h/);
  return hMatch ? Number(hMatch[1]) : 0;
};
var formatHours = function formatHours(num) {
  if (!num) return '0 hrs 0 mins';
  var hrs = Math.floor(num);
  var mins = Math.round((num - hrs) * 60);
  return hrs + ' hrs ' + mins + ' mins';
};
var parseDateTime = function parseDateTime(dateStr, timeStr) {
  if (!dateStr) return 0;

  var _dateStr$split = dateStr.split('/'),
      _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 3),
      day = _dateStr$split2[0],
      month = _dateStr$split2[1],
      year = _dateStr$split2[2];

  var time = timeStr || "00:00:00"; // fallback if no time
  return new Date(year + '-' + month + '-' + day + 'T' + time).getTime();
};
function sortByMovedDate(cards) {
  return cards.sort(function (a, b) {
    return parseDateTime(b.movedDate, b.movedTime) - parseDateTime(a.movedDate, a.movedTime);
  });
}

/***/ }),

/***/ "Z/c4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_ReportedBugs_ReportedBugs_vue__ = __webpack_require__("6lRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__("wtEF");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ReportedBugs: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_ReportedBugs_ReportedBugs_vue__["a" /* default */]
  },
  computed: {
    isAdmin: function isAdmin() {
      var user = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.auth.user;
      return user && user.role === "admin";
    }
  },
  mounted: function mounted() {
    if (!this.isAdmin) {
      this.$router.push("/overview");
    }
  },

  methods: {
    refreshFiles: function refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "ZHTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PencilIcon',
  functional: true,
  props: {
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  render: function render(h, ctx) {
    return h('svg', {
      attrs: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 512 512',
        fill: ctx.props.color
      }, ctx.data.attrs),
      on: ctx.listeners
    }, [h('path', {
      attrs: {
        d: 'M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      }
    })]);
  }
});

/***/ }),

/***/ "ZHb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("wL/U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48bb26fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nAm2");
function injectStyle (ssrContext) {
  __webpack_require__("KF6g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48bb26fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48bb26fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserManagement_vue__ = __webpack_require__("scDz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e930bb3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserManagement_vue__ = __webpack_require__("Kyzy");
function injectStyle (ssrContext) {
  __webpack_require__("5n5o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e930bb3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e930bb3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZMzL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598dc4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("Ac3z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598dc4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZdPk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeDashboard_vue__ = __webpack_require__("CF5a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6db185_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeDashboard_vue__ = __webpack_require__("Gg+k");
function injectStyle (ssrContext) {
  __webpack_require__("yLDY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d6db185"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6db185_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZsxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payslip-container payslip-ref"},[(this.employee)?_c('div',{ref:"payslip",staticClass:"payslip"},[_c('div',{staticClass:"payslip-header"},[_c('div',{staticClass:"company-info"},[_c('div',[(_vm.companyInfo.logo)?_c('img',{attrs:{"src":_vm.companyInfo.logo,"width":"150px","height":"auto","alt":_vm.companyInfo.name}}):_c('h2',{staticClass:"company-name"},[_vm._v(_vm._s(_vm.companyInfo.name))]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[(_vm.companyInfo.address)?_c('p',{staticClass:"company-details"},[_vm._v(_vm._s(_vm.companyInfo.address))]):_vm._e(),_vm._v(" "),(_vm.companyContact)?_c('p',{staticClass:"company-contact"},[_vm._v(_vm._s(_vm.companyContact))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"payslip-title"},[_c('h1',[_vm._v("PAYSLIP")]),_vm._v(" "),_c('p',{staticClass:"payslip-period"},[_vm._v(_vm._s(_vm.formatPeriod(this.employee.month, this.employee.year)))]),_vm._v(" "),_c('p',{staticClass:"payslip-id"},[_vm._v("Transaction #"+_vm._s(this.formatPayrollId(this.employee.payrollId) || _vm.generateTransactionId()))])])]),_vm._v(" "),_c('div',{staticClass:"employee-info"},[_c('div',{staticClass:"employee-details"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"detail-row"},[_c('span',{staticClass:"detail-label"},[_vm._v("Employee ID:")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(this.formatEmployeeId(this.employee.employeeId)))])]),_vm._v(" "),_c('div',{staticClass:"detail-row"},[_c('span',{staticClass:"detail-label"},[_vm._v("Name:")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(this.employee.employeeName))])]),_vm._v(" "),_c('div',{staticClass:"detail-row"},[_c('span',{staticClass:"detail-label"},[_vm._v("Designation:")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(this.employee.employeeDesignation || 'Not specified'))])])]),_vm._v(" "),_c('div',{staticClass:"payment-details"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"detail-row"},[_c('span',{staticClass:"detail-label"},[_vm._v("Payment Date:")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(_vm.paymentDate))])]),_vm._v(" "),_c('div',{staticClass:"detail-row"},[_c('span',{staticClass:"detail-label"},[_vm._v("Status:")]),_vm._v(" "),_c('span',{staticClass:"detail-value status-badge",class:this.employee.status && this.employee.status.toLowerCase()},[_vm._v("\n                        "+_vm._s(this.employee.status)+"\n                    ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"calculation-breakdown"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"calculation-label"},[_vm._v("Basic Salary")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.basicSalary)))])]),_vm._v(" "),(this.employee.lateDeduction > 0)?_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"calculation-label"},[_vm._v("Allowances")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.extraAllowance)))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"salary-details"},[_c('div',{staticClass:"earnings"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Total Days Salary (PKR)")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.salaryData.totalDaysSalary)))])]),_vm._v(" "),_c('div',{staticClass:"calculation-note"},[_vm._v("\n                    "+_vm._s(this.employee.perDaySalary)+" * ("+_vm._s(this.employee.daysWorked)+" Days)\n                ")]),_vm._v(" "),(this.employee.bonus > 0)?_c('div',{staticClass:"amount-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Bonus/Incentives")]),_vm._v(" "),_c('span',{staticClass:"amount-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.bonus)))])]):_vm._e(),_vm._v(" "),(this.employee.leavesEncashmentAmount > 0)?_c('div',{staticClass:"amount-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Leave Encashment ("+_vm._s(_vm.totalEncashmentDays)+"\n                        days)")]),_vm._v(" "),_c('span',{staticClass:"amount-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.leavesEncashmentAmount || this.salaryData.leavesEncashmentDays)))])]):_vm._e(),_vm._v(" "),(this.employee.extraAmountAdjustment > 0)?_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Adjustments (PKR)")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.extraAmountAdjustment)))])]):_vm._e(),_vm._v(" "),( this.employee.extraAmountAdjustment > 0 && this.employee.extraAmountAdjustmentNote && this.employee.extraAmountAdjustment)?_c('div',{staticClass:"calculation-note"},[_vm._v("\n                    "+_vm._s(this.employee.extraAmountAdjustmentNote)+"\n                ")]):_vm._e(),_vm._v(" "),(this.employee.transactionFees > 0)?_c('div',{staticClass:"amount-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Transaction Fees")]),_vm._v(" "),_c('span',{staticClass:"amount-value"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.transactionFees)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-row total"},[_c('span',{staticClass:"amount-label"},[_vm._v("Gross Earnings")]),_vm._v(" "),_c('span',{staticClass:"amount-value"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.grossEarnings)))])])]),_vm._v(" "),_c('div',{staticClass:"deductions",staticStyle:{"position":"relative"}},[_vm._m(5),_vm._v(" "),(this.employee.lateDeduction > 0)?_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Late Deduction (PKR)")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v("- "+_vm._s(_vm.formatCurrency(this.employee.lateDeduction)))])]):_vm._e(),_vm._v(" "),(this.employee.lateDeduction > 0)?_c('div',{staticClass:"calculation-note"},[_vm._v("\n                    ("+_vm._s(_vm.formattedPerHoursalary)+" / hr * "+_vm._s(this.employee.lateDeductionDays * 4)+"x)\n                ")]):_vm._e(),_vm._v(" "),(this.employee.extraAmountAdjustment < 0)?_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Adjustments (PKR)")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v("  "+_vm._s(_vm.formatCurrency(this.employee.extraAmountAdjustment))+" ")])]):_vm._e(),_vm._v(" "),( this.employee.extraAmountAdjustment < 0 && this.employee.extraAmountAdjustmentNote && this.employee.extraAmountAdjustment)?_c('div',{staticClass:"calculation-note"},[_vm._v("\n                    "+_vm._s(this.employee.extraAmountAdjustmentNote)+"\n                ")]):_vm._e(),_vm._v(" "),(this.employee.taxDeduction > 0)?_c('div',{staticClass:"calculation-row"},[_c('span',{staticClass:"amount-label"},[_vm._v("Tax Deduction (PKR)")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v("- "+_vm._s(_vm.formatCurrency(this.employee.taxDeduction)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-row total",style:(_vm.totalDeductions <= 0 ? { paddingTop: '5px' } : {})},[_c('span',{staticClass:"amount-label"},[_vm._v("Total Deductions")]),_vm._v(" "),_c('span',{staticClass:"calculation-value"},[_vm._v("- "+_vm._s(_vm.formatCurrency(_vm.totalDeductions)))])])])]),_vm._v(" "),_c('div',{staticClass:"net-pay"},[_c('div',{staticClass:"net-pay-inner"},[_c('span',{staticClass:"net-pay-label"},[_vm._v("Net Pay")]),_vm._v(" "),_c('span',{staticClass:"net-pay-amount"},[_vm._v(_vm._s(_vm.formatCurrency(this.employee.finalAmount)))])]),_vm._v(" "),_c('p',{staticClass:"net-pay-words"},[_vm._v("("+_vm._s(_vm.amountToWords(Number(this.employee.finalAmount)))+" only)")])]),_vm._v(" "),_c('div',{staticClass:"payslip-footer"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"footer-meta"},[_c('p',[_vm._v("Generated on: "+_vm._s(_vm.currentDateTime))]),_vm._v(" "),_c('p',[_vm._v("Software: "+_vm._s(_vm.companyInfo.software))])])])]):_vm._e(),_vm._v(" "),(!_vm.hideActions)?_c('div',{staticClass:"payslip-actions"},[_c('button',{staticClass:"action-btn download-btn",on:{"click":_vm.downloadPayslip}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7 10L12 15L17 10","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 15V3","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v("\n            Download PDF\n        ")])]):_c('div',{staticClass:"no-data"},[_c('svg',{attrs:{"width":"48","height":"48","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","stroke":"#6B7280","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 8V12","stroke":"#6B7280","stroke-width":"2","stroke-linecap":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 16H12.01","stroke":"#6B7280","stroke-width":"2","stroke-linecap":"round"}})]),_vm._v(" "),_c('h3',[_vm._v("No Payroll Data Available")]),_vm._v(" "),_c('p',[_vm._v("Unable to generate payslip without employee payroll information")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header",staticStyle:{"margin-bottom":"20px"}},[_c('h3',[_vm._v("Employee Details")]),_vm._v(" "),_c('div',{staticClass:"header-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header",staticStyle:{"margin-bottom":"20px"}},[_c('h3',[_vm._v("Payment Details")]),_vm._v(" "),_c('div',{staticClass:"header-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-row"},[_c('span',{staticClass:"detail-label"},[_vm._v("Payment Method:")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v("Bank Transfer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('h3',[_vm._v("Earnings")]),_vm._v(" "),_c('div',{staticClass:"header-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('h3',[_vm._v("Salary Calculations")]),_vm._v(" "),_c('div',{staticClass:"header-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('h3',[_vm._v("Deductions")]),_vm._v(" "),_c('div',{staticClass:"header-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-notes"},[_c('p',[_vm._v("• This is a system generated payslip and does not require signature")]),_vm._v(" "),_c('p',[_vm._v("• Please report any discrepancies within 7 days of receipt")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZuEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{attrs:{"id":"map"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a1in":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a5aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__ = __webpack_require__("YIuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_notificationService_js__ = __webpack_require__("l527");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_CustomDropdown_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_7__UIComponents_ReuseableModal_vue__["a" /* default */]
  },
  props: {
    modelValue: Boolean,
    employee: Object,
    month: String,
    year: String,
    boards: Array,
    isAdmin: Boolean,
    existingItem: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'submitted', 'updated'],
  data: function data() {
    return {
      isLoading: false,
      formSubmitted: false,
      showTypeError: false,
      isInitializing: false,
      originalFormSnapshot: null,
      criteriaList: [],
      form: {
        criteriaName: '',
        type: '',
        title: '',
        project: '',
        boardId: '',
        url: '',
        duration: 0,
        reopens: 0,
        deadlineMissed: 0,
        count: 0,
        value: 1,
        date: '',
        level: '',
        reason: '',
        prs: [],
        selectedCriteria: null
      },
      interviewLevels: []
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      return this.existingItem ? 'Update Performance Item' : 'Add Performance Item';
    },
    submitText: function submitText() {
      return this.existingItem ? 'Update Item' : 'Submit Item';
    },
    criteriaNames: function criteriaNames() {
      return this.criteriaList.map(function (c) {
        return c.name;
      });
    },
    projectOptions: function projectOptions() {
      return this.boards.map(function (b) {
        return b.name;
      }) || [];
    },

    displayTitle: {
      get: function get() {
        return this.form.type === 'Ticket' ? this.form.title : this.autoGeneratedTitle;
      },
      set: function set(val) {
        if (this.form.type === 'Ticket') this.form.title = val;
      }
    },
    autoGeneratedTitle: function autoGeneratedTitle() {
      if (!this.form.type) return '';
      var desc = '';
      switch (this.form.type) {
        case 'PR Review/Help':
          desc = '' + this.form.prs.length;
          break;
        case 'Weekly Session':
          desc = this.form.date ? new Date(this.form.date).toLocaleDateString('en-US') : '';
          break;
        case 'Weekly Session Attendance':
          desc = '' + this.form.count;
          break;
        case 'Weekly Session Lead':
          desc = '';
          break;
        case 'Random Post':
          desc = '' + this.form.count;
          break;
        case 'Interview':
          desc = this.form.level ? '' + this.form.level : '';
          break;
        case 'Lead Per Project':
          desc = this.form.project || '';
          break;
      }
      return desc ? this.form.criteriaName + ': ' + desc : this.form.criteriaName;
    },
    rules: function rules() {
      return this.form.selectedCriteria.rules || {};
    },
    hasLimit: function hasLimit() {
      return !!this.rules.limit;
    },
    limitValue: function limitValue() {
      return this.rules.limit || 0;
    },
    prDivisor: function prDivisor() {
      return this.rules.countDivisor || 3;
    },
    prScore: function prScore() {
      return this.form.selectedCriteria ? this.form.selectedCriteria.score || 1 : 1;
    },
    attScore: function attScore() {
      return this.form.selectedCriteria ? this.form.selectedCriteria.score || 0.5 : 0.5;
    },
    randomDivisor: function randomDivisor() {
      return this.rules.countDivisor || 2;
    },
    randomScore: function randomScore() {
      return this.form.selectedCriteria ? this.form.selectedCriteria.score || 1 : 1;
    },
    leadScore: function leadScore() {
      return this.form.selectedCriteria ? this.form.selectedCriteria.rules.fixed || this.form.selectedCriteria.score || 0.5 : 0.5;
    },
    minCount: function minCount() {
      if (this.hasLimit) return 0;
      return this.form.selectedCriteria ? this.form.selectedCriteria.rules.countDivisor || 1 : 1;
    },
    countStep: function countStep() {
      if (this.hasLimit) return 1;
      return this.form.selectedCriteria ? this.form.selectedCriteria.rules.countDivisor || 1 : 1;
    },
    calcScore: function calcScore() {
      var s = 0;
      var selected = this.form.selectedCriteria;
      if (!selected) return s;
      var rules = this.rules;
      switch (this.form.type) {
        case 'Ticket':
          var hrs = this.form.duration || 0;
          var min = selected.rules.duration.min || 0;
          var max = selected.rules.duration.max - 0.01 || 0;
          s = hrs >= min && hrs <= max ? selected.score : 0;
          break;
        case 'PR Review/Help':
          var prCount = this.form.prs.length;
          if (rules.limit) {
            s = prCount >= rules.limit ? selected.score : 0;
          } else {
            var divisor = rules.countDivisor || 1;
            s = Math.floor(prCount / divisor) * selected.score;
          }
          break;
        case 'Weekly Session':
          var count = this.form.value || 0;
          if (rules.limit) {
            s = count >= rules.limit ? selected.score : 0;
          } else {
            var _divisor = rules.countDivisor || 1;
            s = Math.floor(count / _divisor) * selected.score;
          }
          break;
        case 'Weekly Session Attendance':
        case 'Random Post':
          var count2 = this.form.count || 0;
          if (rules.limit) {
            s = count2 >= rules.limit ? selected.score : 0;
          } else {
            var _divisor2 = rules.countDivisor || (this.form.type === 'Random Post' ? 2 : 1);
            s = Math.floor(count2 / _divisor2) * selected.score;
          }
          break;
        case 'Weekly Session Lead':
          s = selected.rules.fixed || selected.score;
          break;
        case 'Interview':
          s = selected.score;
          break;
        case 'Lead Per Project':
          s = this.form.project ? selected.score : 0;
          break;
      }
      return s;
    }
  },
  watch: {
    'form.criteriaName': function formCriteriaName(newVal) {
      if (this.isInitializing) return;

      if (newVal && this.form.type !== 'Ticket') {
        this.form.title = this.autoGeneratedTitle;
      }
      this.resetDependentFields();
      this.updateAutoTitle();
    },
    'form.prs.length': function formPrsLength() {
      this.updateAutoTitle();
    },
    'form.count': function formCount() {
      this.updateAutoTitle();
    },
    'form.value': function formValue() {
      this.updateAutoTitle();
    },
    'form.date': function formDate() {
      this.updateAutoTitle();
    },
    'form.level': function formLevel() {
      this.updateAutoTitle();
    },
    'form.project': function formProject() {
      this.updateAutoTitle();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var item, desc, criteriaName, type, board, hrs, matching, intCrit, crit, selected, _desc$split, _desc$split2, mm, dd, yyyy, b;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchCriteria();

            case 2:
              _this.interviewLevels = _this.criteriaList.filter(function (c) {
                return c.type === 'Interview';
              }).map(function (c) {
                return c.rules.level;
              }).filter(Boolean);

              if (!_this.existingItem) {
                _context.next = 32;
                break;
              }

              _this.isInitializing = true;
              item = _this.existingItem;
              desc = item.isCustom && item.taskName.includes(':') ? item.taskName.split(': ')[1].trim() : '';
              criteriaName = '';
              type = item.type || (item.isCustom ? item.taskName.split(': ')[0] : 'Ticket');

              _this.form.type = type;
              _this.form.reason = item.scoreReason || '';
              _this.form.project = item.project || item.board || '';
              board = _this.boards.find(function (b) {
                return b.name === _this.form.project;
              });

              _this.form.boardId = board ? board.id : '';
              _this.form.prs = Array.isArray(item.details) ? item.details.map(function (d) {
                return { link: (typeof d === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(d)) === 'object' ? d.link : d };
              }) : [];
              if (type === 'Ticket') {
                _this.form.title = item.taskName || '';
                _this.form.url = item.link || '';
                _this.form.duration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["e" /* parseHours */])(item.durationSpent) || 0;
                _this.form.reopens = item.reopened || 0;
                _this.form.deadlineMissed = item.deadlineMissed || 0;
                hrs = _this.form.duration;
                matching = _this.criteriaList.find(function (c) {
                  return c.type === 'Ticket' && hrs >= (c.rules.duration.min || 0) && hrs < (c.rules.duration.max || Infinity);
                });

                if (matching) criteriaName = matching.name;
              } else if (type === 'Interview') {
                _this.form.level = desc || '';
                intCrit = _this.criteriaList.find(function (c) {
                  return c.type === 'Interview' && c.rules.level === _this.form.level;
                });

                if (intCrit) criteriaName = intCrit.name;
              } else {
                crit = _this.criteriaList.find(function (c) {
                  return c.type === type;
                });

                if (crit) criteriaName = crit.name;
              }
              _this.form.criteriaName = criteriaName;
              selected = _this.criteriaList.find(function (c) {
                return c.name === criteriaName;
              });

              if (selected) _this.form.selectedCriteria = selected;
              _context.t0 = type;
              _context.next = _context.t0 === 'Weekly Session' ? 22 : _context.t0 === 'Weekly Session Attendance' ? 25 : _context.t0 === 'Random Post' ? 25 : _context.t0 === 'Lead Per Project' ? 27 : 31;
              break;

            case 22:
              _this.form.value = item.rating != null ? item.rating : 1;
              if (desc) {
                _desc$split = desc.split('/'), _desc$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_desc$split, 3), mm = _desc$split2[0], dd = _desc$split2[1], yyyy = _desc$split2[2];

                _this.form.date = yyyy + '-' + mm.padStart(2, '0') + '-' + dd.padStart(2, '0');
              } else {
                _this.form.date = '';
              }
              return _context.abrupt('break', 31);

            case 25:
              _this.form.count = parseInt(desc) || 0;
              return _context.abrupt('break', 31);

            case 27:
              _this.form.project = desc || '';
              b = _this.boards.find(function (b) {
                return b.name === desc;
              });

              _this.form.boardId = b ? b.id : '';
              return _context.abrupt('break', 31);

            case 31:

              _this.$nextTick(function () {
                _this.originalFormSnapshot = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.form));
                _this.isInitializing = false;
                console.log('Original form snapshot:', _this.originalFormSnapshot);
              });

            case 32:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    fetchCriteria: function fetchCriteria() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var list;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].getAllPerformanceCriteria();

              case 3:
                list = _context2.sent;

                console.log("performance critteria", list);
                _this2.criteriaList = list || [];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    handleCriteriaChange: function handleCriteriaChange(value) {
      var selected = this.criteriaList.find(function (c) {
        return c.name === value;
      });
      if (selected) {
        this.form.selectedCriteria = selected;
        this.form.type = selected.type;
        this.form.criteriaName = value;
        this.showTypeError = false;
        this.form.reason = '';
        if (selected.type === 'Ticket') {
          this.form.title = '';
        } else {
          this.form.title = this.autoGeneratedTitle;
        }
        if (selected.type === 'Interview') {
          this.form.level = selected.rules.level;
        }
        this.resetDependentFields();
        this.updateAutoTitle();
      }
    },
    isValidUrl: function isValidUrl(url) {
      if (!url.trim()) return false;
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    resetDependentFields: function resetDependentFields() {
      this.form.prs = [];
      this.form.count = 0;
      this.form.value = 1;
      this.form.date = '';
      this.form.level = '';
      this.form.project = '';
      this.form.boardId = '';
      this.form.url = '';
      this.form.duration = 0;
      this.form.reopens = 0;
      this.form.deadlineMissed = 0;
      if (this.form.type === 'Weekly Session Attendance') {
        this.form.count = 1;
      }
      if (this.form.type === 'Weekly Session') {
        this.form.value = 1;
      }
      if (this.form.type === 'Random Post') {
        if (this.hasLimit) {
          this.form.count = this.limitValue;
        } else {
          this.form.count = this.rules.countDivisor;
        }
      }
    },
    resetForm: function resetForm() {
      this.form = {
        criteriaName: '',
        type: '',
        title: '',
        project: '',
        boardId: '',
        url: '',
        duration: 0,
        reopens: 0,
        deadlineMissed: 0,
        count: 0,
        value: 1,
        date: '',
        level: '',
        reason: '',
        prs: [],
        selectedCriteria: null
      };
      this.originalFormSnapshot = null;
      this.formSubmitted = false;
      this.showTypeError = false;
    },
    updateAutoTitle: function updateAutoTitle() {
      if (this.form.type !== 'Ticket') {
        this.form.title = this.autoGeneratedTitle;
      }
    },
    handleProjectChange: function handleProjectChange(value) {
      var selected = this.boards.find(function (b) {
        return b.name === value;
      });
      this.form.project = value;
      this.form.boardId = selected.id || null;
    },
    addPr: function addPr() {
      this.form.prs.push({ link: '' });
    },
    removePr: function removePr(i) {
      this.form.prs.splice(i, 1);
    },
    preventDecimalInput: function preventDecimalInput(e) {
      if (e.key === '.' || e.key === ',') {
        e.preventDefault();
      }
    },
    hasChanges: function hasChanges() {
      if (!this.originalFormSnapshot) return true;
      var currentPrs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.form.prs.map(function (p) {
        return p.link.trim();
      }).sort());
      var originalPrs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.originalFormSnapshot.prs.map(function (p) {
        return p.link.trim();
      }).sort());
      return this.form.type !== this.originalFormSnapshot.type || this.form.title !== this.originalFormSnapshot.title || this.form.project !== this.originalFormSnapshot.project || this.form.url !== this.originalFormSnapshot.url || this.form.duration !== this.originalFormSnapshot.duration || this.form.reopens !== this.originalFormSnapshot.reopens || this.form.deadlineMissed !== this.originalFormSnapshot.deadlineMissed || this.form.count !== this.originalFormSnapshot.count || this.form.value !== this.originalFormSnapshot.value || this.form.date !== this.originalFormSnapshot.date || this.form.level !== this.originalFormSnapshot.level || this.form.reason !== this.originalFormSnapshot.reason || currentPrs !== originalPrs;
    },
    validateForm: function validateForm() {
      this.formSubmitted = true;
      this.showTypeError = !this.form.criteriaName;
      if (this.existingItem && !this.hasChanges()) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("No Changes", "No changes detected. Please modify something before updating.", "warning");
        return false;
      }

      if (!this.form.criteriaName) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Please select a type.", "error");
        return false;
      }
      if (this.form.type === 'Ticket' && !this.form.title.trim()) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Title is required for Ticket.", "error");
        return false;
      }
      if (['Ticket', 'Lead Per Project'].includes(this.form.type) && !this.form.project.trim()) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Project is required.", "error");
        return false;
      }
      if (this.form.type === 'Ticket' && !this.form.url.trim()) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Ticket URL is required.", "error");
        return false;
      }
      if (this.form.type === 'Ticket' && !this.isValidUrl(this.form.url)) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", "Please enter a valid Ticket URL.", "error");
        return false;
      }
      if (this.form.type === 'Ticket' && (this.form.duration === null || this.form.duration === 0)) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Duration (hrs) is required for Ticket.", "error");
        return false;
      }
      if (this.form.type === 'Ticket') {
        var selected = this.form.selectedCriteria;
        var hrs = this.form.duration || 0;
        var min = selected.rules.duration.min || 0;
        var max = selected.rules.duration.max - 0.01 || 0;
        if (hrs < min || hrs > max) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", 'Duration must be between ' + min + ' and ' + max + ' hrs for "' + selected.name + '".', "error");
          return false;
        }
      }
      if (this.form.type === 'PR Review/Help' && this.form.prs.length === 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Please add PR/Help.", "error");
        return false;
      }
      if (this.form.type === 'PR Review/Help' && !this.hasLimit && this.form.prs.length % this.prDivisor !== 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", 'Number of PRs/Helps must be divisible by ' + this.prDivisor + '.', "error");
        return false;
      }
      if (this.form.type === 'PR Review/Help' && this.form.prs.some(function (pr) {
        return !pr.link.trim();
      })) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Please fill all PR/Help details.", "error");
        return false;
      }
      if (this.form.type === 'Random Post' && this.form.count <= 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", "Number of posts must be greater than 0.", "error");
        return false;
      }
      if (this.form.type === 'Random Post' && !this.hasLimit && this.form.count % this.randomDivisor !== 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", 'Number of posts must be divisible by ' + this.randomDivisor + '.', "error");
        return false;
      }
      if (this.form.type === 'Weekly Session Attendance' && this.form.count <= 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", "Sessions attended must be greater than 0.", "error");
        return false;
      }
      if (this.form.type === 'Weekly Session') {
        if (!this.form.date) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Date is required for Weekly Session.", "error");
          return false;
        }
        if (this.form.value == null || this.form.value < 1 || this.form.value > 5) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Invalid", "Please enter a valid rating (1-5) for Weekly Session.", "error");
          return false;
        }
      }
      if (this.form.type === 'Lead Per Project' && !this.form.project) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Required", "Please select a project.", "error");
        return false;
      }
      return true;
    },
    addChangeIfDifferent: function addChangeIfDifferent(changes, label, oldVal, newVal) {
      var normalizedOld = oldVal == null || oldVal === '' ? '(none)' : oldVal;
      var normalizedNew = newVal == null || newVal === '' ? '(none)' : newVal;

      if (normalizedOld !== normalizedNew) {
        changes[label] = normalizedOld + ' \u2192 ' + normalizedNew;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload, cardId, existing, lastKnownData, originalData, updatedData, editPayload, changes, oldDurationFormatted, newDurationFormatted, oldPrs, newPrs, maxLength, prChanges, i, oldLink, newLink, oldDateDesc, newDateDesc, oldCountDesc, oldLevel, oldProject, action, commonField, adminActivity, _$store$state$auth$us, username, uid, _cardId, _action, _commonField, _adminActivity, _$store$state$auth$us2, _username, _uid;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.validateForm()) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:

                _this3.isLoading = true;

                _context3.prev = 3;
                payload = {
                  user: _this3.employee.uid,
                  year: _this3.year,
                  month: _this3.month,
                  name: _this3.displayTitle,
                  type: _this3.form.type,
                  link: _this3.form.url || null,
                  score: _this3.calcScore,
                  scoreReason: _this3.form.reason || null,
                  boardName: _this3.form.project || null,
                  boardId: _this3.form.boardId || null,
                  board: _this3.form.project || null,
                  details: _this3.form.type === "PR Review/Help" ? _this3.form.prs : null,
                  rating: _this3.form.type === 'Weekly Session' ? _this3.form.value : null,
                  ticketStatus: _this3.isAdmin ? "approved" : "pending",
                  status: "approved",
                  deadlineMissedCount: _this3.form.deadlineMissed || null,
                  durationInProgress: _this3.form.duration || null,
                  reopenCount: _this3.form.reopens || null,
                  isCustom: true,
                  filterKey: _this3.year + '-' + _this3.month + '-' + _this3.employee.uid + '-' + (_this3.form.boardId || "null")
                };

                if (!_this3.existingItem) {
                  _context3.next = 33;
                  break;
                }

                cardId = _this3.existingItem.id;
                existing = _this3.$parent.editedCards[cardId] || {};
                lastKnownData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, existing.originalData || {}, existing.updatedData || {});
                originalData = existing.originalData || {
                  name: _this3.existingItem.taskName || null,
                  link: _this3.existingItem && _this3.existingItem.link || null,
                  durationInProgress: _this3.existingItem.durationSpent,
                  reopenCount: _this3.existingItem.reopened,
                  score: _this3.existingItem.score,
                  deadlineMissedCount: _this3.existingItem.deadlineMissed,
                  boardName: _this3.existingItem.project,
                  details: _this3.existingItem.details || null,
                  type: _this3.existingItem.type || null,
                  scoreReason: _this3.existingItem.scoreReason || null
                };
                updatedData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, existing.updatedData || {}, {
                  name: payload.name,
                  link: payload.link || null,
                  durationInProgress: payload.durationInProgress,
                  reopened: payload.reopenCount,
                  score: payload.score,
                  deadlineMissedCount: payload.deadlineMissedCount,
                  scoreReason: payload.scoreReason,
                  boardName: payload.boardName,
                  rating: payload.rating,
                  status: _this3.isAdmin ? "approved" : null,
                  details: payload.details || null
                });
                editPayload = {
                  cardId: existing.cardId || cardId,
                  isCustom: existing.isCustom == true ? true : null,
                  type: payload.type || null,
                  user: _this3.employee.uid,
                  year: _this3.year,
                  month: _this3.month,
                  board: _this3.form.project || null,
                  movedDate: _this3.existingItem && _this3.existingItem.movedDate,
                  movedTime: _this3.existingItem && _this3.existingItem.movedTime,
                  originalData: originalData,
                  updatedData: updatedData,
                  scoreReason: payload.scoreReason || null,
                  ticketStatus: _this3.isAdmin ? "approved" : "pending",
                  status: _this3.isAdmin ? "approved" : "pending",
                  customEdit: existing.isCustom == true ? true : null
                };
                _context3.next = 14;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].saveEditedCard(editPayload);

              case 14:
                changes = {};

                _this3.addChangeIfDifferent(changes, 'Title', lastKnownData.name, payload.name);
                _this3.addChangeIfDifferent(changes, 'Type', lastKnownData.type, payload.type);
                _this3.addChangeIfDifferent(changes, 'Score', lastKnownData.score || 0, payload.score);
                _this3.addChangeIfDifferent(changes, 'Reason', lastKnownData.scoreReason || '', payload.scoreReason || '');
                if (payload.type === 'Ticket') {
                  _this3.addChangeIfDifferent(changes, 'Project', lastKnownData.boardName, payload.boardName);
                  _this3.addChangeIfDifferent(changes, 'Ticket URL', lastKnownData.link, payload.link);
                  oldDurationFormatted = lastKnownData.durationInProgress != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["a" /* formatDuration */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["b" /* parseDurationString */])(lastKnownData.durationInProgress)) : 'N/A';
                  newDurationFormatted = payload.durationInProgress != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["a" /* formatDuration */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["b" /* parseDurationString */])(payload.durationInProgress.toString())) : 'N/A';

                  if (oldDurationFormatted !== newDurationFormatted) {
                    changes['Duration (hrs)'] = oldDurationFormatted + ' \u2192 ' + newDurationFormatted;
                  }

                  _this3.addChangeIfDifferent(changes, 'Reopens', lastKnownData.reopenCount || 0, payload.reopenCount || 0);
                  _this3.addChangeIfDifferent(changes, 'Deadline Missed', lastKnownData.deadlineMissedCount || 0, payload.deadlineMissedCount || 0);
                } else if (payload.type === 'PR Review/Help') {
                  oldPrs = Array.isArray(lastKnownData.details) ? lastKnownData.details : [];
                  newPrs = Array.isArray(payload.details) ? payload.details : [];

                  if (oldPrs.length !== newPrs.length) {
                    changes['PRs_Helps_Count'] = oldPrs.length + ' \u2192 ' + newPrs.length;
                  }
                  maxLength = Math.max(oldPrs.length, newPrs.length);
                  prChanges = [];


                  for (i = 0; i < maxLength; i++) {
                    oldLink = (oldPrs[i] && oldPrs[i].link || '').trim() || '(empty)';
                    newLink = (newPrs[i] && newPrs[i].link || '').trim() || '(empty)';


                    if (oldLink !== newLink) {
                      prChanges.push('PR ' + (i + 1) + ': ' + oldLink + ' \u2192 ' + newLink);
                    }
                  }

                  if (prChanges.length > 0) {
                    changes['PRs_Helps_Updated'] = prChanges.join('\n');
                  }
                } else if (payload.type === 'Weekly Session') {
                  _this3.addChangeIfDifferent(changes, 'Rating', lastKnownData.rating || 1, _this3.form.value);
                  oldDateDesc = lastKnownData.name && lastKnownData.name.includes(': ') ? lastKnownData.name.split(': ')[1].trim() : '(none)';
                  newDateDesc = _this3.form.date ? new Date(_this3.form.date).toLocaleDateString('en-US') : '(none)';

                  if (oldDateDesc !== newDateDesc) {
                    changes['Date'] = oldDateDesc + ' \u2192 ' + newDateDesc;
                  }
                } else if (['Weekly Session Attendance', 'Random Post'].includes(payload.type)) {
                  oldCountDesc = lastKnownData.name && lastKnownData.name.includes(': ') ? parseInt(lastKnownData.name.split(': ')[1].trim()) || 0 : 0;

                  if (oldCountDesc !== _this3.form.count) {
                    changes['Count'] = oldCountDesc + ' \u2192 ' + _this3.form.count;
                  }
                } else if (payload.type === 'Interview') {
                  oldLevel = lastKnownData.name && lastKnownData.name.includes(': ') ? lastKnownData.name.split(': ')[1].trim() : '(none)';

                  if (oldLevel !== _this3.form.level) {
                    changes['Level'] = oldLevel + ' \u2192 ' + _this3.form.level;
                  }
                } else if (payload.type === 'Lead Per Project') {
                  oldProject = lastKnownData.name && lastKnownData.name.includes(': ') ? lastKnownData.name.split(': ')[1].trim() : '(none)';

                  _this3.addChangeIfDifferent(changes, 'Project', lastKnownData.boardName || oldProject, payload.boardName);
                }

                console.log('Final changes object:', changes); // Debug log

                action = _this3.isAdmin ? "Updated" : " Updated Request";
                commonField = {
                  description: _this3.$store.state.auth.user.email + ' ' + action.toLowerCase() + ' performance item "' + _this3.displayTitle + '" for ' + _this3.employee.email + ' with score ' + _this3.calcScore + ' ' + (_this3.form.reason ? '. Reason: ' + _this3.form.reason : ''),
                  activityName: _this3.$store.state.auth.user.username + ' ' + action.toLowerCase() + ' performance item "' + _this3.displayTitle + '" for ' + _this3.month + ' ' + _this3.year
                };
                adminActivity = {
                  adminId: _this3.$store.state.auth.user.uid,
                  activityOnUser: _this3.employee.uid,
                  activityOnUserName: _this3.employee.username,
                  activityByUserName: _this3.$store.state.auth.user.username || 'Admin',
                  action: action,
                  activityTitle: action.toLowerCase() + ' performance item',
                  activityDescription: commonField.description,
                  activityName: commonField.activityName,
                  type: 'performance_edit',
                  timestamp: new Date().toLocaleString('en-PK'),
                  cardId: cardId,
                  cardName: _this3.displayTitle,
                  field: "Task",
                  oldValue: lastKnownData.score || 0,
                  newValue: _this3.calcScore,
                  reason: _this3.form.reason || null,
                  month: _this3.month,
                  year: _this3.year,
                  actionType: action.toLowerCase(),
                  module: 'performance',
                  entityName: 'item',
                  entityId: cardId,
                  previousData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["f" /* removeNullFields */])(lastKnownData),
                  newData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["f" /* removeNullFields */])(updatedData),
                  change: changes,
                  performedBy: _this3.$store.state.auth.user.uid,
                  userRole: _this3.isAdmin ? 'admin' : 'user',
                  source: 'UI'
                };
                _context3.next = 26;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 26:
                _$store$state$auth$us = _this3.$store.state.auth.user, username = _$store$state$auth$us.username, uid = _$store$state$auth$us.uid;
                _context3.next = 29;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityDescription: commonField.description,
                  activityName: commonField.activityName,
                  activityOnUser: _this3.employee.uid,
                  activityOnUserName: _this3.employee.username,
                  activityByUserName: username,
                  action: action,
                  newValue: _this3.calcScore,
                  cardName: _this3.displayTitle
                }, _this3.$store.state.auth, uid);

              case 29:

                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Success!", "Item updated successfully.", "success");
                _this3.$emit("updated", editPayload);
                _context3.next = 46;
                break;

              case 33:
                _context3.next = 35;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].addPerformanceItem(payload);

              case 35:
                _cardId = _context3.sent;
                _action = _this3.isAdmin ? "Added" : "Requested";
                _commonField = {
                  description: _this3.$store.state.auth.user.email + ' ' + _action.toLowerCase() + ' a new performance item "' + _this3.displayTitle + '" for ' + _this3.employee.email + ' with score ' + _this3.calcScore + ' ' + (_this3.form.reason ? '. Reason: ' + _this3.form.reason : ''),
                  activityName: _this3.$store.state.auth.user.username + ' ' + _action.toLowerCase() + ' a new performance item "' + _this3.displayTitle + '" for ' + _this3.month + ' ' + _this3.year
                };
                _adminActivity = {
                  adminId: _this3.$store.state.auth.user.uid,
                  activityOnUser: _this3.employee.uid,
                  activityOnUserName: _this3.employee.username,
                  activityByUserName: _this3.$store.state.auth.user.username || 'Admin',
                  action: _action,
                  activityTitle: _action.toLowerCase() + ' performance item',
                  activityDescription: _commonField.description,
                  activityName: _commonField.activityName,
                  type: 'performance_edit',
                  timestamp: new Date().toLocaleString('en-PK'),
                  cardId: _cardId,
                  cardName: _this3.displayTitle,
                  field: "Task",
                  oldValue: null,
                  newValue: _this3.calcScore,
                  reason: _this3.form.reason || null,
                  month: _this3.month,
                  year: _this3.year,
                  actionType: _action.toLowerCase(),
                  module: 'performance',
                  entityName: 'item',
                  entityId: _cardId,
                  previousData: null,
                  newData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__performanceHelper_js__["f" /* removeNullFields */])(payload),
                  performedBy: _this3.$store.state.auth.user.uid,
                  userRole: _this3.isAdmin ? 'admin' : 'user',
                  source: 'UI'
                };
                _context3.next = 41;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs_js__["c" /* logAdminActivity */])(_adminActivity);

              case 41:
                _$store$state$auth$us2 = _this3.$store.state.auth.user, _username = _$store$state$auth$us2.username, _uid = _$store$state$auth$us2.uid;
                _context3.next = 44;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityDescription: _commonField.description,
                  activityName: _commonField.activityName,
                  activityOnUser: _this3.employee.uid,
                  activityOnUserName: _this3.employee.username,
                  activityByUserName: _username,
                  action: _action,
                  newValue: _this3.calcScore,
                  cardName: _this3.displayTitle
                }, _this3.$store.state.auth, _uid);

              case 44:

                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Success!", "Item saved successfully.", "success");
                _this3.$emit("submitted", { cardId: _cardId, payload: payload });

              case 46:
                _this3.resetForm();
                _this3.$emit('update:modelValue', false);

                _context3.next = 54;
                break;

              case 50:
                _context3.prev = 50;
                _context3.t0 = _context3['catch'](3);

                console.error(_context3.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Error", "Failed to submit item.", "error");

              case 54:
                _context3.prev = 54;

                _this3.isLoading = false;
                return _context3.finish(54);

              case 57:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 50, 54, 57]]);
      }))();
    }
  }
});

/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4c5b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("vlEJ");
function injectStyle (ssrContext) {
  __webpack_require__("HqTQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4c5b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aF5f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aH+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-attendance-main-content"},[_c('div',{staticClass:"payroll-attendance-panel"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-panel-body"},[_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Working Days")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('requiredWorkingDaysInput'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.requiredWorkingDaysInput),expression:"requiredWorkingDaysInput"}],class:{ 'updated-field': _vm.hasChanged('requiredWorkingDaysInput') },attrs:{"type":"number","disabled":_vm.isDisabled,"min":"0","placeholder":"0","max":this.getDaysInMonth()},domProps:{"value":(_vm.requiredWorkingDaysInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.requiredWorkingDaysInput=$event.target.value},_vm.updateRequiredWorkingDays],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Days Worked")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('daysWorkedInput'); }}}),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":_vm.showDaysWorkedInfo,"mouseleave":_vm.hideDaysWorkedInfo}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isDaysWorkedVisible)?_c('div',{staticClass:"required-hours-tooltip-box"},[_c('p',[_vm._v("Normal Days Worked: "+_vm._s(_vm.formattedNormalDaysWorked()))]),_vm._v(" "),(_vm.employee.eligibleHolidayDetails && _vm.employee.eligibleHolidayDetails.length)?[_c('b',[_vm._v("Public Holidays Included: ("+_vm._s(_vm.employee.eligibleHolidayDetails.length)+")")]),_vm._v(" "),_c('ul',_vm._l((_vm.employee.eligibleHolidayDetails),function(item,index){return _c('li',{key:'hol-' + index},[_vm._v(_vm._s(item))])}),0)]:_vm._e(),_vm._v(" "),(_vm.HalfDaysDetails().length)?[_c('b',[_vm._v("Additional Half Days: ("+_vm._s(_vm.HalfDaysDetails().length || 0)+") * 0.5 = "+_vm._s((_vm.HalfDaysDetails().length || 0) * 0.5))]),_vm._v(" "),_c('ul',_vm._l((_vm.HalfDaysDetails()),function(date,index){return _c('li',{key:index},[_vm._v(_vm._s(date))])}),0)]:_vm._e(),_vm._v(" "),(_vm.HalfDaysCount().totalHalfDayHours)?_c('p',[_c('b',[_vm._v("Total Half Days Hours:")]),_vm._v(" "),_c('br'),_vm._v(" "+_vm._s(_vm.HalfDaysCount().totalHalfDayHours))]):_vm._e()],2):_vm._e()])],1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v("\n            Half Days: "+_vm._s(_vm.HalfDaysCount().halfDaysCount || 0)+"\n          ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.daysWorkedInput),expression:"daysWorkedInput"}],class:{ 'updated-field': _vm.hasChanged('daysWorkedInput') },attrs:{"type":"number","disabled":_vm.isDisabled,"min":"0","placeholder":"0","step":"0.5","max":this.getRequiredWorkingDays()},domProps:{"value":(_vm.daysWorkedInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.daysWorkedInput=$event.target.value},_vm.updateWorkingDays],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Absents")]),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":_vm.showAbsentInfo,"mouseleave":_vm.hideAbsentInfo}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isAbsentInfoVisible)?_c('div',{staticClass:"required-hours-tooltip-box",staticStyle:{"margin-left":"-70px","width":"260px"}},[(_vm.formattedAbsentsDaysDetails().length)?[_c('b',[_vm._v("Absent Days: ("+_vm._s(_vm.absentDaysCount())+")")]),_vm._v(" "),_c('ul',_vm._l((_vm.formattedAbsentsDaysDetails()),function(item,index){return _c('li',{key:'low-' + index},[_vm._v(_vm._s(item))])}),0)]:_vm._e(),_vm._v(" "),(_vm.formattedAbsentsDetails().length)?[_c('b',[_vm._v("Low Worked Hours Count: ("+_vm._s(_vm.formattedAbsentsDetails().length)+")")]),_vm._v(" "),_c('ul',_vm._l((_vm.formattedAbsentsDetails()),function(item,index){return _c('li',{key:'low-' + index},[_vm._v(_vm._s(item))])}),0)]:_vm._e(),_vm._v(" "),(_vm.formattedAbsentsDetails(true).length)?[(_vm.formattedAbsentsDetails(true).length !== null)?_c('b',[_vm._v("\n                  Remaining Half Day Absence Count * 0.5: ("+_vm._s(_vm.formattedAbsentsDetails(true).length || 0)+") * 0.5 = "+_vm._s((_vm.formattedAbsentsDetails(true).length || 0) * 0.5)+"\n                ")]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.formattedAbsentsDetails(true)),function(item,index){return _c('li',{key:'half-' + index},[_vm._v(_vm._s(item))])}),0)]:_vm._e()],2):_vm._e()])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.absentsInput),expression:"absentsInput"}],class:[{ 'updated-field': _vm.hasChanged('absentsInput') },'payroll-disabled-field'],attrs:{"type":"number","disabled":true,"step":"0.5","min":"0","placeholder":"0","max":this.getRequiredWorkingDays(),"min":0},domProps:{"value":(_vm.absentsInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.absentsInput=$event.target.value},_vm.updateAbsents],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Leaves Taken")]),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":_vm.showLeavesInfo,"mouseleave":_vm.hideLeavesInfo}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isleaveInfoVisible)?_c('div',{staticClass:"required-hours-tooltip-box",staticStyle:{"margin-left":"-70px","width":"200px"}},[(!this.getLeavesAllowed())?_c('div',[_vm._v("Disabled due to 0 Leave Balance."),_c('br')]):_vm._e(),_vm._v(" "),(_vm.leavesTakenInput > 0)?[_c('b',[_vm._v("Leave Balance Info")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-left":"16px"}},[_c('li',[_vm._v("Leaves Allowed: "+_vm._s(_vm.getLeaveTooltipInfo.leavesAllowed))]),_vm._v(" "),_c('li',[_vm._v("Leaves taken: "+_vm._s(_vm.getLeaveTooltipInfo.leavesTaken))]),_vm._v(" "),_c('li',[_vm._v("Remaining: "+_vm._s(_vm.getLeaveTooltipInfo.remaining))])])]:_vm._e(),_vm._v(" "),(_vm.formattedLeavesDetails().length)?[_c('b',[_vm._v("Monthly Leaves Details: ("+_vm._s(_vm.formattedLeavesDetails().length || 0)+")")]),_vm._v(" "),_c('ul',_vm._l((_vm.formattedLeavesDetails()),function(item,index){return _c('li',{key:'leave-' + index},[_vm._v(_vm._s(item))])}),0)]:[_c('p',[_vm._v("No leaves taken for this month.")])]],2):_vm._e()])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v("(Leaves Balance: "+_vm._s(_vm.getLeaveTooltipInfo.remaining)+")")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.leavesTakenInput),expression:"leavesTakenInput"}],staticClass:"payroll-disabled-field",class:[
            !this.getLeavesAllowed() ? 'payroll-disabled-field' : '',
            _vm.hasChanged('leavesTakenInput') ? 'updated-field' : ''],attrs:{"type":"number","disabled":true,"max":this.getLeavesAllowed(),"min":"0","step":"0.5","placeholder":"0"},domProps:{"value":(_vm.leavesTakenInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.leavesTakenInput=$event.target.value},_vm.updateLeavesTaken],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Late Arrivals ")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('lateArrivalsInput'); }}})],1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v("\n            Late Deduction Days: "+_vm._s(_vm.lateDeductionDays || 0)+"\n          ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lateArrivalsInput),expression:"lateArrivalsInput"}],class:{ 'updated-field': _vm.hasChanged('lateArrivalsInput') },attrs:{"type":"number","disabled":_vm.isDisabled,"min":"0","placeholder":"0","max":this.getRequiredWorkingDays()},domProps:{"value":(_vm.lateArrivalsInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.lateArrivalsInput=$event.target.value},_vm.updateLateArrivals],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Late Deductions Count ")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('lateSalaryDeductionInput'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.manualLateDeductionInput),expression:"manualLateDeductionInput"}],class:[!_vm.leaveBalance && !_vm.leavesTakenInput ? 'payroll-disabled-field' : '',
          _vm.hasChanged('manualLateDeductionInput') ? 'updated-field' : ''],attrs:{"type":"number","disabled":_vm.isDisabled || !_vm.leaveBalance && !_vm.leavesTakenInput,"min":"0","placeholder":"0","max":this.getRequiredWorkingDays()},domProps:{"value":(_vm.manualLateDeductionInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.manualLateDeductionInput=$event.target.value},_vm.updateLateSalaryDeductionDays],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","flex-wrap":"wrap"}},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Leave Deduction Count")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('leaveDeductionInput'); }}})],1),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v("(New Leave Balance: "+_vm._s(this.getNewLeaveBalance || 0)+")")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.leaveDeductionInput),expression:"leaveDeductionInput"}],class:[!Number(this.getLeavesAllowed()) && !Number(_vm.leavesTakenInput) ? 'payroll-disabled-field' : '',
          _vm.hasChanged('leaveDeductionInput') ? 'updated-field' : ''],attrs:{"type":"number","disabled":_vm.isDisabled || !Number(this.getLeavesAllowed()) && !Number(_vm.leavesTakenInput),"min":"0","max":_vm.getMaxLeavesDeduction,"placeholder":"0","step":"0.5"},domProps:{"value":(_vm.leaveDeductionInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.leaveDeductionInput=$event.target.value},_vm.handleManualLeaveDeduction],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-attendance-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Leave Deduction Note")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('leaveDeductionNote'); }}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.leaveDeductionNote),expression:"leaveDeductionNote"}],staticClass:"payroll-adjustment-textarea",class:{ 'updated-field': _vm.hasChanged('leaveDeductionNote') },attrs:{"disabled":_vm.isDisabled,"placeholder":"Enter note for leave deduction"},domProps:{"value":(_vm.leaveDeductionNote)},on:{"input":function($event){if($event.target.composing){ return; }_vm.leaveDeductionNote=$event.target.value}}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-attendance-panel-header"},[_c('span',{staticClass:"icon"},[_vm._v("📅")]),_vm._v(" "),_c('h2',[_vm._v("Attendance Details")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aNyT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PayrollManagement_payrollHelper_js__ = __webpack_require__("mATD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_config_firebase_js__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_excludeholidayHours_js__ = __webpack_require__("OnzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_genralSpecificSettings_js__ = __webpack_require__("TvP8");























var payroll = {
  // namespaced: true,
  state: {
    allPayrollList: null,
    selectedEmployeePayroll: {},
    selectedMonth: new Date().toLocaleString("default", { month: "long" }),
    selectedYear: new Date().getFullYear(),
    payrollData: [],
    loading: false
  },
  mutations: {
    setAllPayrollList: function setAllPayrollList(state, payload) {
      state.allPayrollList = payload;
    },
    setSelectedEmployeePayroll: function setSelectedEmployeePayroll(state, payload) {
      state.selectedEmployeePayroll = payload;
    },
    setSelectedMonth: function setSelectedMonth(state, month) {
      state.selectedMonth = month;
    },
    setSelectedYear: function setSelectedYear(state, year) {
      state.selectedYear = year;
    },
    clearPayroll: function clearPayroll(state) {
      state.allPayrollList = null;
      state.selectedEmployeePayroll = null;
      state.selectedYear = new Date().getFullYear();
      state.selectedMonth = new Date().toLocaleString("default", { month: "long" });
      state.loading = false;
      state.payrollData = null;
    },
    setPayrollData: function setPayrollData(state, data) {
      state.payrollData = data;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    }
  },
  getters: {
    AllPayrollList: function AllPayrollList(state) {
      return function () {
        return state.allPayrollList;
      };
    },
    AllSelectedPayroll: function AllSelectedPayroll(state) {
      return function () {
        return state.selectedEmployeePayroll;
      };
    },
    selectedPayrollMonth: function selectedPayrollMonth(state) {
      return function () {
        return state.selectedMonth;
      };
    },
    selectedPayrollYear: function selectedPayrollYear(state) {
      return function () {
        return state.selectedYear;
      };
    },
    filteredPayrollListByMonthYear: function filteredPayrollListByMonthYear(state) {
      return function () {
        if (!state.allPayrollList) return [];
        return state.allPayrollList.filter(function (p) {
          return p.month === state.selectedMonth && p.year === String(state.selectedYear);
        });
      };
    }
  },
  actions: {
    fetchConstants: function fetchConstants() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee() {
        var constantsRef, constantsSnapshot;
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                constantsRef = __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("constants");
                _context.next = 3;
                return constantsRef.once("value");

              case 3:
                constantsSnapshot = _context.sent;
                return _context.abrupt("return", constantsSnapshot.exists() ? constantsSnapshot.val() : {});

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchPayrollRealTime: function fetchPayrollRealTime(_ref, _ref2) {
      var _this2 = this;

      var state = _ref.state,
          commit = _ref.commit,
          dispatch = _ref.dispatch;
      var router = _ref2.router;
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var selectedYear, selectedMonth, selectedMonthShort, payrollRef;
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                commit('setLoading', true);

                selectedYear = state.selectedYear || new Date().getFullYear();
                selectedMonth = state.selectedMonth || __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["a" /* monthNames */][new Date().getMonth()];
                selectedMonthShort = __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["b" /* monthShortNames */][selectedMonth];
                _context3.next = 7;
                return dispatch('getPayrollRef', {
                  year: selectedYear,
                  month: selectedMonth
                });

              case 7:
                payrollRef = _context3.sent;

                if (!(!payrollRef || typeof payrollRef.on !== 'function')) {
                  _context3.next = 12;
                  break;
                }

                console.error("Invalid payroll reference");
                commit("setLoading", false);
                return _context3.abrupt("return");

              case 12:

                payrollRef.off();

                payrollRef.on("value", function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee2(snapshot) {
                    return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return dispatch('processPayrollSnapshot', {
                              snapshot: snapshot,
                              year: selectedYear,
                              month: selectedMonth,
                              monthShort: selectedMonthShort,
                              router: router
                            });

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }(), function (error) {
                  dispatch('handleFirebaseError', error);
                });

                _context3.next = 21;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](0);

                console.error("Error fetching payroll data:", _context3.t0);
                dispatch('handleFirebaseError', _context3.t0);
                commit('setLoading', false);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 16]]);
      }))();
    },

    // async fetchPayrollRealTime({ state, commit, dispatch }) {
    //   commit('setLoading', true);

    //   const selectedYear = state.selectedYear || new Date().getFullYear();
    //   const selectedMonth = state.selectedMonth || monthNames[new Date().getMonth()];
    //   const selectedMonthShort = monthShortNames[selectedMonth];

    //   const payrollRef = await dispatch('getPayrollRef', { year: selectedYear, month: selectedMonth });

    //   if (!payrollRef) {
    //     console.error("Payroll reference is null");
    //     commit("setLoading", false);
    //     return;
    //   }

    //   payrollRef.off();

    //   payrollRef.on("value", async (snapshot) => {
    //     await dispatch('processPayrollSnapshot', {
    //       snapshot,
    //       year: selectedYear,
    //       month: selectedMonth,
    //       monthShort: selectedMonthShort
    //     });
    //     commit('setLoading', false);
    //   }, (error) => {
    //     dispatch('handleFirebaseError', error);
    //   });
    // },

    getPayrollRef: function getPayrollRef(_ref4, _ref5) {
      var state = _ref4.state,
          rootState = _ref4.rootState;
      var year = _ref5.year,
          month = _ref5.month;

      var user = rootState.auth.user;
      var isAdmin = user.role === "admin" || false;
      if (isAdmin) {
        return __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("payroll/" + year + "/" + month);
      }

      if (!user) return null;
      return __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("payroll/" + year + "/" + month).orderByChild('employeeId').equalTo(user.uid);
    },
    processPayrollSnapshot: function processPayrollSnapshot(_ref6, _ref7) {
      var _this3 = this;

      var state = _ref6.state,
          rootState = _ref6.rootState,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      var snapshot = _ref7.snapshot,
          year = _ref7.year,
          month = _ref7.month,
          monthShort = _ref7.monthShort,
          router = _ref7.router;
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var user, isAdmin, existingPayrolls, payrolls, routingFn, updatedPayrolls;
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                user = rootState.auth.user;
                isAdmin = user.role === "admin" || false;
                existingPayrolls = snapshot.exists() ? snapshot.val() : {};
                _context4.next = 5;
                return dispatch('mapPayrollData', existingPayrolls);

              case 5:
                payrolls = _context4.sent;

                if (isAdmin) {
                  _context4.next = 10;
                  break;
                }

                // dispatch('handleNonAdminPayroll', payrolls);
                routingFn = function routingFn(item) {
                  if (item && (item.status || "").toLowerCase() === "processed") {
                    router.push({
                      name: "Payroll Details",
                      params: {
                        employeeId: item.employeeId,
                        employee: item
                      }
                    });
                  }
                };

                dispatch('handleNonAdminPayroll', {
                  payrolls: payrolls,
                  callback: routingFn
                });

                return _context4.abrupt("return");

              case 10:
                _context4.next = 12;
                return dispatch('processMissingEmployees', {
                  payrolls: payrolls,
                  year: year,
                  month: month,
                  monthShort: monthShort
                });

              case 12:
                updatedPayrolls = _context4.sent;

                dispatch('updatePayrollData', updatedPayrolls);
                commit('setLoading', false);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    mapPayrollData: function mapPayrollData(_ref8, payrolls) {
      __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref8);

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(payrolls).map(function (payrollId) {
        var payroll = payrolls[payrollId];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__components_PayrollManagement_payrollHelper_js__["a" /* createPayrollObject */])(payrollId, payroll);
      });
    },
    handleNonAdminPayroll: function handleNonAdminPayroll(_ref9, _ref10) {
      var commit = _ref9.commit;
      var payrolls = _ref10.payrolls,
          callback = _ref10.callback;

      commit("setPayrollData", payrolls);
      commit("setAllPayrollList", payrolls);

      if (payrolls.length > 0) {
        commit("setSelectedEmployeePayroll", payrolls[0]);
        if (callback) callback(payrolls[0]);
        commit("setLoading", false);
      }
    },
    processMissingEmployees: function processMissingEmployees(_ref11, _ref12) {
      var _this4 = this;

      var state = _ref11.state,
          rootState = _ref11.rootState,
          dispatch = _ref11.dispatch;
      var payrolls = _ref12.payrolls,
          year = _ref12.year,
          month = _ref12.month,
          monthShort = _ref12.monthShort;
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var existingEmployeeIds, company, companyUserIds, allEmployees, missingEmployees, constants, holidays, monthNumber, newPayrollEntries;
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                existingEmployeeIds = payrolls.map(function (p) {
                  return p.employeeId;
                });
                company = rootState.auth.company;
                companyUserIds = company.users.map(function (u) {
                  return u.uid;
                });
                allEmployees = rootState.auth.allUsers.filter(function (u) {
                  return companyUserIds.includes(u.uid);
                });
                missingEmployees = allEmployees.filter(function (emp) {
                  return !existingEmployeeIds.includes(emp.uid);
                });
                _context6.t0 = rootState.constants && rootState.constants.constant;

                if (_context6.t0) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 9;
                return dispatch('fetchConstants');

              case 9:
                _context6.t0 = _context6.sent;

              case 10:
                constants = _context6.t0;
                _context6.next = 13;
                return __WEBPACK_IMPORTED_MODULE_19__assets_config_firebase_js__["a" /* default */].getAllHolidays();

              case 13:
                holidays = _context6.sent;
                monthNumber = typeof month === "string" ? __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["c" /* monthMap */][month] : month;
                _context6.next = 17;
                return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(missingEmployees.map(function () {
                  var _ref13 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee5(emp) {
                    var leavesSnapshot, empLeaves, timePeriodSnapshot, allTimePeriods, empTimePeriods, mockSnapshot;
                    return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("leaves").orderByChild("userId").equalTo(emp.uid).once("value");

                          case 2:
                            leavesSnapshot = _context5.sent;
                            empLeaves = leavesSnapshot.val() || {};
                            _context5.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("timePeriod").orderByChild("userId").equalTo(emp.uid).once("value");

                          case 6:
                            timePeriodSnapshot = _context5.sent;
                            allTimePeriods = timePeriodSnapshot.val() || {};
                            empTimePeriods = {};

                            __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(allTimePeriods).forEach(function (_ref14) {
                              var _ref15 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref14, 2),
                                  key = _ref15[0],
                                  record = _ref15[1];

                              var timeIn = record.timeIn ? new Date(record.timeIn) : null;
                              if (timeIn && timeIn.getFullYear() === year && timeIn.getMonth() + 1 === monthNumber) {
                                empTimePeriods[key] = record;
                              }
                            });

                            mockSnapshot = {
                              forEach: function forEach(callback) {
                                __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(empTimePeriods).forEach(function (_ref16) {
                                  var _ref17 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
                                      key = _ref17[0],
                                      value = _ref17[1];

                                  callback({ val: function val() {
                                      return value;
                                    } });
                                });
                              }
                            };
                            return _context5.abrupt("return", dispatch('createPayrollForEmployee', {
                              emp: emp,
                              selectedYear: year,
                              selectedMonth: month,
                              constantsCollection: constants,
                              preFetchedHolidays: holidays,
                              preFetchedLeaves: empLeaves,
                              preFetchedSnapshot: mockSnapshot
                            }));

                          case 12:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this4);
                  }));

                  return function (_x2) {
                    return _ref13.apply(this, arguments);
                  };
                }()));

              case 17:
                newPayrollEntries = _context6.sent;
                return _context6.abrupt("return", payrolls.concat(newPayrollEntries));

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    updatePayrollData: function updatePayrollData(_ref18, payrolls) {
      var commit = _ref18.commit;

      commit("setPayrollData", payrolls);
      commit("setAllPayrollList", payrolls);
    },
    handleFirebaseError: function handleFirebaseError(_ref19, error) {
      var commit = _ref19.commit;

      console.error("Firebase error:", error);
      commit("setLoading", false);
    },
    fetchEmployeeLeaves: function fetchEmployeeLeaves(_ref20, employeeId) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref20);

      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var leavesRef, leavesSnapshot;
        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                leavesRef = __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("leaves").orderByChild("userId").equalTo(employeeId);
                _context7.next = 3;
                return leavesRef.once("value");

              case 3:
                leavesSnapshot = _context7.sent;
                return _context7.abrupt("return", leavesSnapshot.val() || {});

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    calculateAttendanceStats: function calculateAttendanceStats(_ref21, _ref22) {
      var _this6 = this;

      var userId = _ref22.userId,
          year = _ref22.year,
          month = _ref22.month,
          empWorkingDays = _ref22.empWorkingDays,
          empTotalHours = _ref22.empTotalHours,
          _ref22$preFetchedSnap = _ref22.preFetchedSnapshot,
          preFetchedSnapshot = _ref22$preFetchedSnap === undefined ? null : _ref22$preFetchedSnap,
          emp = _ref22.emp;

      __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref21);

      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var monthNumber, snapshot, timePeriodRef, isResigned, lastWorkingDateObj, holidays, empWorkingDaysLowerForHolidays, empShift, eligibleHolidayDays, eligibleHolidayDetails, deductedHolidayDates, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, holiday, holidayDate, holidayYear, holidayStart, i, actualHolidayDate, holidayWeekday, holidayShift, dateKey, lateArrivals, totalHours, productiveHours, empWorkingDayObj, requiredWorkingDayObj, lowHoursDays, normalHoursDays, halfHoursDays, remainingHalfDays, totalExtraHoursDays, totalLowHours, totalNormalHours, totalExtraHours, totalHalfDayHours, remainingHalfDayHours, overallMonthlyTotalHours, absentDays, halfDayHours, halfDayUpperThreshold, daysWorked, empWorkingDaysLower, daysInMonth, monthFullName, monthShortName, absents, day, checkDate, weekDayName, leaveKey, dayWorkedArray, approvedLeaveDatesArray, approvedLeaves, safeMonthlyLeaves, approvedLeavesCount, requiredTotalWorkingHours;

        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["a" /* resetWorkData */])();
                monthNumber = typeof month === "string" ? __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["c" /* monthMap */][month] : month;
                snapshot = void 0;

                if (!preFetchedSnapshot) {
                  _context8.next = 7;
                  break;
                }

                snapshot = preFetchedSnapshot;
                _context8.next = 11;
                break;

              case 7:
                timePeriodRef = __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref("timePeriod").orderByChild("userId").equalTo(userId);
                _context8.next = 10;
                return timePeriodRef.once("value");

              case 10:
                snapshot = _context8.sent;

              case 11:
                isResigned = (emp && emp.status || '').toLowerCase() === 'resigned';
                lastWorkingDateObj = isResigned && emp && emp.lastWorkingDate ? new Date(emp.lastWorkingDate) : null;
                _context8.next = 15;
                return __WEBPACK_IMPORTED_MODULE_19__assets_config_firebase_js__["a" /* default */].getAllHolidays();

              case 15:
                holidays = _context8.sent;
                empWorkingDaysLowerForHolidays = empWorkingDays.map(function (day) {
                  return day.toLowerCase();
                });
                empShift = (emp && emp.shift || 'morning').toLowerCase();
                eligibleHolidayDays = [];
                eligibleHolidayDetails = [];
                deductedHolidayDates = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context8.prev = 24;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(holidays);

              case 26:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context8.next = 48;
                  break;
                }

                holiday = _step.value;
                holidayDate = new Date(holiday.dates);
                holidayYear = holiday.isRecurring ? year : holidayDate.getFullYear();
                holidayStart = new Date(holidayYear, holidayDate.getMonth(), holidayDate.getDate());
                i = 0;

              case 32:
                if (!(i < holiday.numberOfDays)) {
                  _context8.next = 45;
                  break;
                }

                actualHolidayDate = new Date(holidayStart);

                actualHolidayDate.setDate(actualHolidayDate.getDate() + i);

                if (!(actualHolidayDate.getFullYear() !== year || actualHolidayDate.getMonth() !== monthNumber - 1)) {
                  _context8.next = 37;
                  break;
                }

                return _context8.abrupt("continue", 42);

              case 37:
                if (!(lastWorkingDateObj && actualHolidayDate > lastWorkingDateObj)) {
                  _context8.next = 39;
                  break;
                }

                return _context8.abrupt("continue", 42);

              case 39:
                holidayWeekday = actualHolidayDate.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
                holidayShift = (holiday.shift || "general").toLowerCase();

                if (empWorkingDaysLowerForHolidays.includes(holidayWeekday) && (holidayShift === empShift || holidayShift === "general")) {
                  dateKey = actualHolidayDate.getFullYear() + "-" + String(actualHolidayDate.getMonth() + 1).padStart(2, '0') + "-" + String(actualHolidayDate.getDate()).padStart(2, '0');

                  if (!deductedHolidayDates.has(dateKey)) {
                    deductedHolidayDates.add(dateKey);
                    eligibleHolidayDays.push(actualHolidayDate.getDate());
                    eligibleHolidayDetails.push(String(actualHolidayDate.getDate()).padStart(2, '0') + "-" + String(actualHolidayDate.getMonth() + 1).padStart(2, '0') + "-" + actualHolidayDate.getFullYear() + ": " + holiday.name);
                  }
                }

              case 42:
                i++;
                _context8.next = 32;
                break;

              case 45:
                _iteratorNormalCompletion = true;
                _context8.next = 26;
                break;

              case 48:
                _context8.next = 54;
                break;

              case 50:
                _context8.prev = 50;
                _context8.t0 = _context8["catch"](24);
                _didIteratorError = true;
                _iteratorError = _context8.t0;

              case 54:
                _context8.prev = 54;
                _context8.prev = 55;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 57:
                _context8.prev = 57;

                if (!_didIteratorError) {
                  _context8.next = 60;
                  break;
                }

                throw _iteratorError;

              case 60:
                return _context8.finish(57);

              case 61:
                return _context8.finish(54);

              case 62:
                lateArrivals = 0;
                totalHours = 0;
                productiveHours = 0;
                empWorkingDayObj = {};
                requiredWorkingDayObj = {};
                lowHoursDays = {};
                normalHoursDays = {};
                halfHoursDays = {};
                remainingHalfDays = {};
                totalExtraHoursDays = {};
                totalLowHours = 0;
                totalNormalHours = 0;
                totalExtraHours = 0;
                totalHalfDayHours = 0;
                remainingHalfDayHours = 0;
                overallMonthlyTotalHours = 0;
                absentDays = {};
                halfDayHours = Number(empTotalHours) / 2 + 0.5;
                halfDayUpperThreshold = Math.floor(halfDayHours) + 59 / 60;

                snapshot.forEach(function (childSnapshot) {
                  var record = childSnapshot.val();
                  var timeIn = null;
                  var isNightShift = emp.shift && emp.shift.toLowerCase() === "night";
                  if (isNightShift) {
                    timeIn = record.createdAt ? new Date(record.createdAt) : null;
                  } else {
                    timeIn = record.timeIn ? new Date(record.timeIn) : null;
                  }

                  if (!timeIn || isNaN(timeIn)) {
                    console.warn("Skipping invalid timeIn:", record);
                    return;
                  }

                  var recordMonth = timeIn.getMonth() + 1;
                  var recordYear = timeIn.getFullYear();
                  var recordDay = timeIn.getDate();
                  var recordWeekday = timeIn.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();

                  if (recordMonth !== monthNumber || recordYear !== year) return;

                  if (empWorkingDays.map(function (day) {
                    return day.toLowerCase();
                  }).includes(recordWeekday)) {
                    __WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["b" /* daysWorkedSet */].add(recordDay);
                  }

                  if (record.late && ((record.late.hours || 0) > 0 || (record.late.minutes || 0) > 0)) {
                    lateArrivals++;
                  }

                  var workedHours = 0;

                  if (Array.isArray(record.sessions)) {
                    for (var i = 0; i < record.sessions.length; i++) {
                      var session = record.sessions[i];
                      var sessionIn = session.timeIn ? new Date(session.timeIn) : null;
                      var sessionOut = session.timeOut ? new Date(session.timeOut) : null;

                      // If this is the last session and timeOut is missing
                      if (!sessionOut && i === record.sessions.length - 1 && Array.isArray(record.screenshots) && record.screenshots.length > 0) {
                        var lastScreenshot = record.screenshots[record.screenshots.length - 1];
                        sessionOut = new Date(lastScreenshot.timestamp);
                      }

                      if (sessionIn && sessionOut) {
                        var sessionDuration = (sessionOut - sessionIn) / (1000 * 60 * 60); // in hours
                        workedHours += sessionDuration;
                        productiveHours += sessionDuration;
                      }
                    }
                  }

                  totalHours += workedHours;

                  var isInHalfDayRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["c" /* isInHourRange */])(halfDayHours);
                  if (workedHours > 0) {
                    // Check if the worked day is in the empWorkingDays set
                    var isWorkingDay = empWorkingDays.map(function (day) {
                      return day.toLowerCase();
                    }).includes(recordWeekday);

                    if (isWorkingDay) {
                      // If it is a working day, proceed with existing logic for low, mid, or extra hours
                      if (workedHours < halfDayHours) {
                        //Day is less than half day hours
                        lowHoursDays[recordDay] = workedHours;
                        totalLowHours += workedHours;
                        // absentDays[recordDay] = Number(workedHours || 0)
                        delete empWorkingDayObj[recordDay];
                        delete requiredWorkingDayObj[recordDay];
                      } else if (isInHalfDayRange && workedHours <= halfDayUpperThreshold && workedHours >= halfDayHours) {
                        // 5:00 to 5:59 - withing half day range
                        halfHoursDays[recordDay] = workedHours;
                        totalHalfDayHours += workedHours;

                        remainingHalfDays[recordDay] = Number(empTotalHours || 0) - Number(workedHours || 0);
                        remainingHalfDayHours += Number(empTotalHours || 0) - Number(workedHours || 0);

                        // adding those remaining required halfday hours to total monthly hours
                        // empWorkingDayObj[recordDay] = Number(empTotalHours || 0) - Number(halfDayHours || 0)
                      } else if (workedHours > halfDayUpperThreshold && workedHours <= empTotalHours) {
                        normalHoursDays[recordDay] = workedHours;
                        totalNormalHours += workedHours;
                      } else if (workedHours > empTotalHours) {
                        var normalHours = empTotalHours;
                        var extra = workedHours - empTotalHours;

                        normalHoursDays[recordDay] = normalHours;
                        totalNormalHours += normalHours;

                        totalExtraHours += extra;
                        totalExtraHoursDays[recordDay] = extra;
                      }
                    } else {
                      // If it's not a working day, count all hours as extra
                      totalExtraHours += workedHours;
                      totalExtraHoursDays[recordDay] = workedHours;
                    }
                  }
                });

                eligibleHolidayDays.forEach(function (day) {
                  return __WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["b" /* daysWorkedSet */].add(day);
                });

                daysWorked = __WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["b" /* daysWorkedSet */].size;
                empWorkingDaysLower = empWorkingDays.map(function (day) {
                  return day.toLowerCase();
                });
                daysInMonth = new Date(year, monthNumber, 0).getDate();
                // approvedLeaveDatesSet is keyed "Jun 15" style; resolve the short name once
                // so the lookup below works whether `month` is a name or a month number.

                monthFullName = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["c" /* monthMap */]).find(function (k) {
                  return __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["c" /* monthMap */][k] === Number(monthNumber);
                });
                monthShortName = __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["b" /* monthShortNames */][monthFullName] || "";
                absents = 0;
                day = 1;

              case 90:
                if (!(day <= daysInMonth)) {
                  _context8.next = 110;
                  break;
                }

                checkDate = new Date(year, monthNumber - 1, day);
                weekDayName = checkDate.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();

                if (empWorkingDaysLower.includes(weekDayName)) {
                  _context8.next = 95;
                  break;
                }

                return _context8.abrupt("continue", 107);

              case 95:
                if (!(lastWorkingDateObj && checkDate > lastWorkingDateObj)) {
                  _context8.next = 97;
                  break;
                }

                return _context8.abrupt("continue", 107);

              case 97:

                overallMonthlyTotalHours += Number(empTotalHours || 0);
                // approvedLeaveDatesSet is keyed by short month name ("Jun 15"), see
                // processLeavesData in payrollHelper.js. Comparing it against
                // `${monthNumber} ${day}` ("6 15") never matched, so approved leave days
                // were treated as absences.
                leaveKey = monthShortName + " " + day;

                if (!__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["d" /* approvedLeaveDatesSet */].has(leaveKey)) {
                  _context8.next = 101;
                  break;
                }

                return _context8.abrupt("continue", 107);

              case 101:

                empWorkingDayObj[day] = Number(empTotalHours || 0);
                requiredWorkingDayObj[day] = Number(empTotalHours || 0);

                if (remainingHalfDays[day] > 0) {
                  empWorkingDayObj[day] = Number(empTotalHours || 0) - Number(halfDayHours || 0);
                  requiredWorkingDayObj[day] = Number(halfDayHours || 0);
                };
                dayWorkedArray = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["b" /* daysWorkedSet */]));

                if (!dayWorkedArray.includes(day)) {
                  absents++;
                  // absentDays[day] = Number(empTotalHours || 0)
                  absentDays[day] = "Off";
                  delete empWorkingDayObj[day];
                  delete requiredWorkingDayObj[day];
                }

              case 107:
                day++;
                _context8.next = 90;
                break;

              case 110:
                approvedLeaveDatesArray = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["d" /* approvedLeaveDatesSet */] || []);
                approvedLeaves = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(approvedLeaveDatesArray)).filter(function (date) {
                  var fullDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["e" /* convertToFullDate */])(date, year, monthNumber);
                  var leaveDate = new Date(fullDate);

                  return leaveDate.getFullYear() === year && leaveDate.getMonth() + 1 === monthNumber;
                }).map(function (date) {
                  var fullDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["e" /* convertToFullDate */])(date, year, monthNumber);
                  var leaveDate = new Date(fullDate);

                  var _date$split = date.split(" "),
                      _date$split2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_date$split, 2),
                      _ = _date$split2[0],
                      day = _date$split2[1];

                  delete empWorkingDayObj[day];
                  delete requiredWorkingDayObj[day];
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["f" /* formatDate */])(leaveDate);
                });
                safeMonthlyLeaves = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(approvedLeaves));
                approvedLeavesCount = approvedLeaveDatesArray.filter(function (date) {
                  var fullDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["e" /* convertToFullDate */])(date, year, monthNumber);
                  var leaveDate = new Date(fullDate);
                  return leaveDate.getFullYear() === year && leaveDate.getMonth() + 1 === monthNumber;
                }).length;

                // const requiredTotalWorkingHours = Object.values(empWorkingDayObj).reduce((acc, curr) => acc+curr, 0) || overallMonthlyTotalHours

                requiredTotalWorkingHours = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(requiredWorkingDayObj).reduce(function (acc, curr) {
                  return acc + curr;
                }, 0) || overallMonthlyTotalHours;
                return _context8.abrupt("return", {
                  lateArrivals: lateArrivals,
                  totalHours: totalHours,
                  productiveHours: productiveHours,
                  daysWorked: daysWorked,
                  absents: Math.max(0, absents - approvedLeavesCount),
                  lowHoursDays: lowHoursDays,
                  totalLowHours: totalLowHours,
                  normalHoursDays: normalHoursDays,
                  totalNormalHours: totalNormalHours,
                  totalExtraHours: totalExtraHours,
                  monthlyLeaves: safeMonthlyLeaves,
                  halfHoursDays: halfHoursDays,
                  totalHalfDayHours: totalHalfDayHours,
                  remainingHalfDays: remainingHalfDays,
                  remainingHalfDayHours: remainingHalfDayHours,
                  requiredTotalWorkingHours: requiredTotalWorkingHours,
                  requiredTotalWorkingDays: requiredWorkingDayObj,
                  absentDays: absentDays,
                  totalExtraHoursDays: totalExtraHoursDays,
                  eligibleHolidayDetails: eligibleHolidayDetails
                });

              case 116:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this6, [[24, 50, 54, 62], [55,, 57, 61]]);
      }))();
    },
    calculateAnnualLeavesEncashmentDays: function calculateAnnualLeavesEncashmentDays(_ref23, _ref24) {
      var remainingLeaves = _ref24.remainingLeaves,
          _ref24$month = _ref24.month,
          month = _ref24$month === undefined ? "December" : _ref24$month;

      __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref23);

      if (month !== "December") return 0;
      var remaining = Math.min(Math.floor(remainingLeaves || 0), 5);
      var encashmentRules = { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3 };
      return encashmentRules[remaining] || 0;
    },
    calculateFinalAmount: function calculateFinalAmount(_ref25, props) {
      var _this7 = this;

      var dispatch = _ref25.dispatch;
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _ref26, obtainedLeaves, perDaySalary, lateArrivals, totalDaysSalary, leaveBalance, month, currentMonth, leavesTaken, lates, leaveDeductionDays, lateDeductionDays, i, threshold, lateSalaryDeduction, calcAnnualLeavesEncashmentDays, calcAnnualLeavesEncashmentSalary, leavesTakenEncashmentAmount, calculateFinalSalary;

        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref26 = props || {}, obtainedLeaves = _ref26.obtainedLeaves, perDaySalary = _ref26.perDaySalary, lateArrivals = _ref26.lateArrivals, totalDaysSalary = _ref26.totalDaysSalary, leaveBalance = _ref26.leaveBalance, month = _ref26.month;
                currentMonth = month || new Date().toLocaleString("default", { month: "long" });
                leavesTaken = parseInt(obtainedLeaves) || 0;
                lates = parseInt(lateArrivals) || 0;
                leaveDeductionDays = 0;
                lateDeductionDays = 0;
                i = 0;

              case 7:
                if (!(i < __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["d" /* newLateThresholds */].length)) {
                  _context9.next = 16;
                  break;
                }

                threshold = __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["d" /* newLateThresholds */][i];

                if (!(lates >= threshold.min)) {
                  _context9.next = 13;
                  break;
                }

                lateDeductionDays = threshold.salaryDeduct;
                leaveDeductionDays = leavesTaken > 0 ? 1 : 0;
                return _context9.abrupt("break", 16);

              case 13:
                i++;
                _context9.next = 7;
                break;

              case 16:
                lateSalaryDeduction = lateDeductionDays * perDaySalary;
                _context9.next = 19;
                return dispatch('calculateAnnualLeavesEncashmentDays', {
                  remainingLeaves: leaveBalance,
                  month: currentMonth
                });

              case 19:
                calcAnnualLeavesEncashmentDays = _context9.sent;
                calcAnnualLeavesEncashmentSalary = Number(calcAnnualLeavesEncashmentDays) * Number(perDaySalary) || 0;
                leavesTakenEncashmentAmount = (Number(obtainedLeaves) - Number(leaveDeductionDays)) * Number(perDaySalary) || 0;
                calculateFinalSalary = Number(totalDaysSalary || 0) - Number(lateSalaryDeduction) + Number(leavesTakenEncashmentAmount) + Number(calcAnnualLeavesEncashmentSalary);
                return _context9.abrupt("return", calculateFinalSalary.toFixed(2));

              case 24:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this7);
      }))();
    },
    createPayrollForEmployee: function createPayrollForEmployee(_ref27, _ref28) {
      var _this8 = this;

      var rootState = _ref27.rootState,
          dispatch = _ref27.dispatch;
      var emp = _ref28.emp,
          selectedYear = _ref28.selectedYear,
          selectedMonth = _ref28.selectedMonth,
          constantsCollection = _ref28.constantsCollection,
          _ref28$preFetchedHoli = _ref28.preFetchedHolidays,
          preFetchedHolidays = _ref28$preFetchedHoli === undefined ? null : _ref28$preFetchedHoli,
          _ref28$preFetchedLeav = _ref28.preFetchedLeaves,
          preFetchedLeaves = _ref28$preFetchedLeav === undefined ? null : _ref28$preFetchedLeav,
          _ref28$preFetchedSnap = _ref28.preFetchedSnapshot,
          preFetchedSnapshot = _ref28$preFetchedSnap === undefined ? null : _ref28$preFetchedSnap;
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _ref30;

        var selectedMonthShort, leavesData, _processLeavesData, obtainedLeaves, userSalary, userExtraAllowance, userGrossSalary, constants, fetchedContants, empWorkingDays, empTotalHours, requiredWorkingDaysInMonth, attendanceStats, holidays, calcRequiredWorkingHrs, _ref29, lowHoursDays, totalLowHours, normalHoursDays, totalNormalHours, totalExtraHours, monthlyLeaves, halfHoursDays, totalHalfDayHours, remainingHalfDays, remainingHalfDayHours, requiredTotalWorkingDays, requiredTotalWorkingHours, absentDays, totalExtraHoursDays, eligibleHolidayDetails, lowHoursDaysCount, leaveBalance, userPerDaySalary, totalDaysSalary, remainingHalfDaysCount, absentCount, updatedDaysWorkedSalary, finalAmount, halfHourLen, eligibleHolidayCount, countDaysWorked, lates, leaveDeductionDays, lateDeductionDays, i, threshold;

        return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (emp) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return", null);

              case 2:
                selectedMonthShort = __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["b" /* monthShortNames */][selectedMonth];
                leavesData = void 0;

                if (!preFetchedLeaves) {
                  _context10.next = 8;
                  break;
                }

                leavesData = preFetchedLeaves;
                _context10.next = 11;
                break;

              case 8:
                _context10.next = 10;
                return dispatch("fetchEmployeeLeaves", emp.uid || emp.employeeId);

              case 10:
                leavesData = _context10.sent;

              case 11:
                _processLeavesData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__components_PayrollManagement_payrollHelper_js__["b" /* processLeavesData */])(leavesData, selectedMonthShort, selectedYear), obtainedLeaves = _processLeavesData.obtainedLeaves;
                userSalary = emp.basicSalary || emp.salary || 0;
                userExtraAllowance = emp.extraAllowance || 0;
                userGrossSalary = Number(userSalary) + Number(userExtraAllowance);
                constants = null;
                fetchedContants = null;

                if (!(!emp.workingDays && !constantsCollection)) {
                  _context10.next = 21;
                  break;
                }

                if (rootState.constants && rootState.constants.constant) {
                  constants = rootState.constants.constant;
                }
                _context10.next = 24;
                break;

              case 21:
                _context10.next = 23;
                return dispatch('fetchConstants');

              case 23:
                fetchedContants = _context10.sent;

              case 24:
                empWorkingDays = emp.workingDays || fetchedContants.days || (constantsCollection ? constantsCollection.days || constantsCollection.constant.days : []) || constants && constants.days;
                empTotalHours = Number(emp.productiveHours) || Number(fetchedContants.totalHours) || (constantsCollection ? Number(constantsCollection.totalHours || constantsCollection.constant.totalHours) : 0);
                requiredWorkingDaysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__assets_config_helpers_js__["g" /* calculateTotalWorkingDays */])(selectedYear, selectedMonth, empWorkingDays);
                attendanceStats = void 0;

                if (!preFetchedSnapshot) {
                  _context10.next = 34;
                  break;
                }

                _context10.next = 31;
                return dispatch("calculateAttendanceStats", {
                  userId: emp.uid,
                  year: selectedYear,
                  month: selectedMonth,
                  empWorkingDays: empWorkingDays,
                  empTotalHours: empTotalHours,
                  preFetchedSnapshot: preFetchedSnapshot,
                  emp: emp
                });

              case 31:
                attendanceStats = _context10.sent;
                _context10.next = 37;
                break;

              case 34:
                _context10.next = 36;
                return dispatch("calculateAttendanceStats", {
                  userId: emp.uid,
                  year: selectedYear,
                  month: selectedMonth,
                  empWorkingDays: empWorkingDays,
                  empTotalHours: empTotalHours,
                  emp: emp
                });

              case 36:
                attendanceStats = _context10.sent;

              case 37:
                _context10.t0 = preFetchedHolidays;

                if (_context10.t0) {
                  _context10.next = 42;
                  break;
                }

                _context10.next = 41;
                return __WEBPACK_IMPORTED_MODULE_19__assets_config_firebase_js__["a" /* default */].getAllHolidays();

              case 41:
                _context10.t0 = _context10.sent;

              case 42:
                holidays = _context10.t0;
                calcRequiredWorkingHrs = Number(requiredWorkingDaysInMonth) * Number(empTotalHours || 0);
                _ref29 = attendanceStats || {}, lowHoursDays = _ref29.lowHoursDays, totalLowHours = _ref29.totalLowHours, normalHoursDays = _ref29.normalHoursDays, totalNormalHours = _ref29.totalNormalHours, totalExtraHours = _ref29.totalExtraHours, monthlyLeaves = _ref29.monthlyLeaves, halfHoursDays = _ref29.halfHoursDays, totalHalfDayHours = _ref29.totalHalfDayHours, remainingHalfDays = _ref29.remainingHalfDays, remainingHalfDayHours = _ref29.remainingHalfDayHours, requiredTotalWorkingDays = _ref29.requiredTotalWorkingDays, requiredTotalWorkingHours = _ref29.requiredTotalWorkingHours, absentDays = _ref29.absentDays, totalExtraHoursDays = _ref29.totalExtraHoursDays, eligibleHolidayDetails = _ref29.eligibleHolidayDetails;
                lowHoursDaysCount = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(lowHoursDays).length || 0;
                leaveBalance = Number(emp.leavesAvailable || 0) - Number(emp.leavesTaken || 0) || 0;
                userPerDaySalary = requiredWorkingDaysInMonth ? parseFloat((userGrossSalary / requiredWorkingDaysInMonth).toFixed(2)) : 0;
                totalDaysSalary = userPerDaySalary * attendanceStats.daysWorked;
                remainingHalfDaysCount = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(remainingHalfDays).length || 0;
                absentCount = Math.max(0, attendanceStats.absents + (remainingHalfDaysCount * __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["e" /* halfDay */] || 0) + Number(lowHoursDaysCount));
                updatedDaysWorkedSalary = userPerDaySalary * (Number(requiredWorkingDaysInMonth || 0) - Number(obtainedLeaves || 0) - Number(absentCount || attendanceStats.absents || 0) - Number(lowHoursDaysCount || 0));
                _context10.next = 54;
                return dispatch("calculateFinalAmount", {
                  obtainedLeaves: obtainedLeaves,
                  perDaySalary: userPerDaySalary,
                  totalDaysSalary: updatedDaysWorkedSalary,
                  lateArrivals: attendanceStats.lateArrivals,
                  leaveBalance: leaveBalance,
                  month: selectedMonth
                });

              case 54:
                finalAmount = _context10.sent;
                halfHourLen = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(halfHoursDays).length || 0;
                eligibleHolidayCount = (eligibleHolidayDetails || []).length;
                countDaysWorked = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(normalHoursDays).length + (halfHourLen && halfHourLen * __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["e" /* halfDay */]) + eligibleHolidayCount || 0;
                lates = parseInt(attendanceStats.lateArrivals) || 0;
                leaveDeductionDays = 0;
                lateDeductionDays = 0;
                i = 0;

              case 62:
                if (!(i < __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["d" /* newLateThresholds */].length)) {
                  _context10.next = 71;
                  break;
                }

                threshold = __WEBPACK_IMPORTED_MODULE_15__assets_config_constants__["d" /* newLateThresholds */][i];

                if (!(lates >= threshold.min)) {
                  _context10.next = 68;
                  break;
                }

                lateDeductionDays = threshold.salaryDeduct;
                leaveDeductionDays = threshold.leaveDeduct || 0;
                return _context10.abrupt("break", 71);

              case 68:
                i++;
                _context10.next = 62;
                break;

              case 71:
                return _context10.abrupt("return", (_ref30 = {
                  payrollId: __WEBPACK_IMPORTED_MODULE_16_firebase_app___default.a.database().ref().push().key,
                  employeeId: emp.uid,
                  employeeName: emp.username || "Unknown",
                  employeeDesignation: emp.designation ? "Grade-" + (emp.grade || 1) + " - " + emp.designation : "",
                  isSuperAdmin: emp.isSuperAdmin,
                  joiningDate: emp.joiningDate,
                  grossSalary: userGrossSalary,
                  calculatedSalary: totalDaysSalary,
                  basicSalary: userSalary,
                  perDaySalary: userPerDaySalary,
                  requiredWorkingDays: Number(requiredWorkingDaysInMonth) || 0,
                  finalAmount: Math.round(finalAmount),
                  transactionFees: 0,
                  extraAllowance: userExtraAllowance || 0,
                  extraAmountAdjustment: 0,
                  bonus: 0,
                  daysWorked: countDaysWorked || 0,
                  totalDaysWorked: attendanceStats.daysWorked,
                  normalDaysWorked: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(normalHoursDays).length,
                  obtainedLeaves: obtainedLeaves + " / " + leaveBalance,
                  actualAbsents: Number(attendanceStats.absents),
                  absents: Number(absentCount),
                  lateDeduction: Number(userPerDaySalary) * Number(lateDeductionDays) + " - " + attendanceStats.lateArrivals,
                  lateDeductionDays: 0,
                  resignationDate: emp.resignationDate || null,
                  lastWorkingDate: emp.lastWorkingDate || null,
                  eligibleHolidayDetails: eligibleHolidayDetails || [],
                  lateArrivals: attendanceStats.lateArrivals,
                  productiveHours: attendanceStats.totalHours || Number(empTotalHours),
                  status: "Pending",
                  month: selectedMonth,
                  year: selectedYear,
                  remainingLeaves: leaveBalance,
                  carryForwardDays: 0,
                  updatedLeaveQuota: 0,
                  leavesAvailable: Number(emp.leavesAvailable),
                  leavesAllowed: Number(emp.leavesAllowed),
                  leavesTaken: Number(emp.leavesTaken),
                  leaveBalance: Number(leaveBalance),
                  leaveDeductionCount: 0,
                  constantLeaveAllowed: constantsCollection ? constantsCollection.leavesAllowed : 0,
                  leavesEncashmentDays: 0,
                  leavesEncashmentAmount: 0,
                  annualLeavesEncashmentDays: 0,
                  totalNormalHours: totalNormalHours || 0,
                  totalExtraHours: totalExtraHours || 0,
                  totalLowHours: totalLowHours || 0,
                  // lowHoursDaysCount: lowHoursDaysCount || 0,
                  lowHoursDays: lowHoursDays || {},
                  reqWorkingHours: calcRequiredWorkingHrs || 0,
                  monthlyLeaves: monthlyLeaves || [],
                  extraAmountAdjustmentNote: "",
                  halfDays: halfHoursDays || {},
                  totalHalfDayHours: totalHalfDayHours,
                  remainingHalfDays: remainingHalfDays,
                  remainingHalfDayHours: remainingHalfDayHours,
                  leaveDeductionNote: "",
                  requiredTotalWorkingDays: requiredTotalWorkingDays,
                  requiredTotalWorkingHours: requiredTotalWorkingHours,
                  perDayProductiveHours: Number(empTotalHours),
                  newLeaveBalance: 0
                }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "leavesAllowed", Number(emp.leavesAllowed || 0)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "leavesAvailable", Number(emp.leavesAvailable || 0)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "DBLeavesTaken", Number(emp.leavesTaken || 0)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "leavesDeductionDays", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "absentDays", absentDays), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "totalExtraHoursDays", totalExtraHoursDays), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "empTotalHours", empTotalHours), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "normalHoursDays", normalHoursDays), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "taxDeduction", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "employeeStatus", emp.status), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "shift", (emp.shift || "Morning").toLowerCase()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "leavesQuota", emp.leavesQuota || {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref30, "workingDays", emp.workingDays), _ref30));

              case 72:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this8);
      }))();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (payroll);

/***/ }),

/***/ "aOf0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSearchIndexIfNeeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteByFileId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



var createSearchIndexIfNeeded = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var BACKEND_BASE = _ref2.BACKEND_BASE,
        collectionName = _ref2.collectionName,
        dbName = _ref2.dbName;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(BACKEND_BASE + '/atlas/create-search-index', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ collectionName: collectionName, dbName: dbName, indexName: 'vector_index' })
            });

          case 2:
            res = _context.sent;
            return _context.abrupt('return', res.json());

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function createSearchIndexIfNeeded(_x) {
    return _ref.apply(this, arguments);
  };
}();

var deleteByFileId = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var BACKEND_BASE = _ref4.BACKEND_BASE,
        dbName = _ref4.dbName,
        collectionName = _ref4.collectionName,
        fileId = _ref4.fileId;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(BACKEND_BASE + '/atlas/delete-by-fileid', {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ dbName: dbName, collectionName: collectionName, fileId: fileId })
            });

          case 2:
            res = _context2.sent;
            return _context2.abrupt('return', res.json());

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function deleteByFileId(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "ac4u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aqFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"header-actions"},[_c('h5',{staticClass:"title"},[_vm._v("Performance Target Score")]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"actions-right"},[_c('button',{staticClass:"add-employee",staticStyle:{"width":"170px"},on:{"click":function($event){return _vm.openScoreModal()}}},[_c('span',[_vm._v("Add Target Score")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('CustomTable',{attrs:{"header":_vm.filteredColumns,"loading":_vm.loadingStates.table,"columns":_vm.filteredColumns,"data":_vm.scoreList},scopedSlots:_vm._u([{key:"designation",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"criteria-name"},[_vm._v(_vm._s(item.designation || '-'))])]}},{key:"grade",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"type-text"},[_vm._v(_vm._s(item.gradeLabel || '-'))])]}},{key:"score",fn:function(ref){
var item = ref.item;
return [_c('span',{class:['score-display', item.score < 0 ? 'text-danger' : 'text-success']},[_vm._v("\n                  "+_vm._s(item.score !== undefined ? item.score : '-')+"\n                ")])]}},(_vm.isAdmin)?{key:"action",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"action-buttons"},[_c('button',{staticClass:"edit-btn btn-status",on:{"click":function($event){return _vm.editScore(item)}}},[_c('PencilIcon',{attrs:{"color":"gray","width":16,"height":16}})],1),_vm._v(" "),_c('button',{staticClass:"delete-btn btn-status",on:{"click":function($event){return _vm.openDeleteModal(item)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"gray"}})])])]}}:null],true)})],1)]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isScoreModalOpen,"title":_vm.selectedScore ? 'Edit Target Score' : 'Add Target Score',"isLarge":true,"submitButtonText":"Save","loading":_vm.loadingStates.save,"performance":true},on:{"update:modelValue":function($event){_vm.isScoreModalOpen = $event},"submit":function($event){return _vm.saveScore()}}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveScore()}}},[_c('div',{staticClass:"modal-body-container"},[_c('div',{staticClass:"form-scroll-container m-0 p-0"},[_c('div',{staticClass:"form-group row",staticStyle:{"padding":"0px 12px"}},[_c('div',{staticClass:"col-md-12 mb-3"},[_c('label',[_vm._v("Designation "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('CustomDropdown',{attrs:{"options":_vm.designations,"value":_vm.selectedDesignation,"placeholder":"Select Designation","required":true},on:{"change":_vm.onDesignationChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('label',[_vm._v("Grade "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('GradeDropdown',{attrs:{"designation":_vm.selectedDesignation,"designationGrades":_vm.designationGrades,"placeholder":"Select Grade","required":true,"disabled":!_vm.selectedDesignation},on:{"change":_vm.onGradeChange},model:{value:(_vm.selectedGrade),callback:function ($$v) {_vm.selectedGrade=$$v},expression:"selectedGrade"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('label',[_vm._v("Target Score "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.score),expression:"score",modifiers:{"number":true}}],staticClass:"form-control",staticStyle:{"height":"43px","border-radius":"4px"},attrs:{"type":"number","min":"1","placeholder":"e.g. 20 or 30"},domProps:{"value":(_vm.score)},on:{"input":function($event){if($event.target.composing){ return; }_vm.score=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])])])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeleteModalOpen,"title":"Delete Target Score?","isLarge":false,"submitButtonText":"Delete","loading":_vm.loadingStates.delete},on:{"update:modelValue":function($event){_vm.isDeleteModalOpen = $event},"submit":function($event){return _vm.deleteScore()}}},[_c('div',[_c('p',{staticClass:"m-0"},[_vm._v("Are you sure you want to permanently delete this target score?")])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "avKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__ = __webpack_require__("kfhz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e4642b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__ = __webpack_require__("VK5r");
function injectStyle (ssrContext) {
  __webpack_require__("iTqh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01e4642b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e4642b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b0E1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zZhI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afd74614_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("jpwa");
function injectStyle (ssrContext) {
  __webpack_require__("e1yX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afd74614"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afd74614_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b6pX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nG85");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5ef88c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1KY0");
function injectStyle (ssrContext) {
  __webpack_require__("rYrC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c5ef88c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5ef88c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bAcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.handleOutsideClick),expression:"handleOutsideClick"}],staticClass:"custom-dropdown"},[_c('div',{staticClass:"dropdown-header",on:{"click":_vm.toggleDropdown}},[_vm._v("\n    "+_vm._s(_vm.selected || _vm.placeholder)+"\n  ")]),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"dropdown-options"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"dropdown-option",on:{"click":function($event){return _vm.selectItem(item)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bXbZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cloudinary__ = __webpack_require__("SJFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_banks_json__ = __webpack_require__("k4ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_banks_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_banks_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_countries_json__ = __webpack_require__("565z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProfileData__ = __webpack_require__("JiyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UIComponents_GradeDropdown_vue__ = __webpack_require__("0AJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VerifyDocuments_vue__ = __webpack_require__("/daF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helperFunc__ = __webpack_require__("Al8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_notificationService__ = __webpack_require__("l527");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_11__UIComponents_CustomDropdown_vue__["a" /* default */],
    GradeDropdown: __WEBPACK_IMPORTED_MODULE_12__UIComponents_GradeDropdown_vue__["a" /* default */],
    VerifyDocuments: __WEBPACK_IMPORTED_MODULE_13__VerifyDocuments_vue__["a" /* default */]
  },
  data: function data() {
    return {
      profileLoading: false,
      documentLoading: false,
      user: null,
      errors: {},
      customBankName: '',
      showCustomBank: false,
      uploadingProfileImage: false,
      isUploadingExperienceLetter: false,
      isUploadingSalarySlip: false,
      uploadProgress: 0,
      profile_picture: '',
      pendingNicFile: null,
      nicLocalPreviewUrl: '',
      nicLocalFileType: '',
      nicFirebaseFileType: '',
      pendingExperienceLetterFile: null,
      experienceLetterLocalPreviewUrl: '',
      experienceLetterLocalFileType: '',
      experienceLetterFirebaseFileType: '',
      pendingSalarySlipFile: null,
      salarySlipLocalPreviewUrl: '',
      salarySlipLocalFileType: '',
      salarySlipFirebaseFileType: '',
      experienceLetterFileName: '',
      experienceLetterFileSize: '',
      experienceLetterFileType: '',
      salarySlipFileName: '',
      salarySlipFileSize: '',
      salarySlipFileType: '',
      designations: __WEBPACK_IMPORTED_MODULE_10__ProfileData__["a" /* designations */],
      designationGrades: __WEBPACK_IMPORTED_MODULE_10__ProfileData__["b" /* designationGrades */],
      countries: __WEBPACK_IMPORTED_MODULE_9__data_UserProfileData_countries_json___default.a.countries,
      banks: __WEBPACK_IMPORTED_MODULE_8__data_banks_json___default.a.banks,
      maritalStatusOptions: ['Single', 'Married', 'Divorced', 'Widowed'],
      defaultProfileImage: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
      isLoading: true
    };
  },
  computed: {
    companyName: function companyName() {
      var company = this.$store.state.auth.company;
      return company && company.companyName || '';
    },

    profileImageSrc: function profileImageSrc() {
      return this.user && this.user.profile_picture ? this.user.profile_picture : this.defaultProfileImage;
    },
    isCurrentUser: function isCurrentUser() {
      return !this.$route.params.id || this.$route.params.id === (this.$store.state.auth.user && this.$store.state.auth.user.uid);
    },
    isNonAdmin: function isNonAdmin() {
      return this.$store.state.auth.user && this.$store.state.auth.user.role !== 'admin';
    },
    nicPreviewUrl: function nicPreviewUrl() {
      return this.nicLocalPreviewUrl || this.user && this.user.nicImageUrl || '';
    },
    nicPreviewFileType: function nicPreviewFileType() {
      return this.nicLocalFileType || this.nicFirebaseFileType || '';
    },
    nicPreviewIsImage: function nicPreviewIsImage() {
      return this.nicPreviewFileType && this.nicPreviewFileType.match('image.*');
    },
    nicPreviewIsPdf: function nicPreviewIsPdf() {
      return this.nicPreviewFileType === 'application/pdf';
    },
    tempExperienceLetterUrl: function tempExperienceLetterUrl() {
      return this.experienceLetterLocalPreviewUrl || this.user && this.user.certificateUrl || '';
    },
    tempSalarySlipUrl: function tempSalarySlipUrl() {
      return this.salarySlipLocalPreviewUrl || this.user && this.user.salarySlipUrl || '';
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var defaultUserData, routeUserId, userData;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              defaultUserData = {
                bankName: '',
                email: '',
                iban: '',
                isActive: true,
                joiningDate: '',
                leavesAllowed: 7.5,
                leavesAvailable: 15,
                leavesTaken: '',
                nicNumber: '',
                phoneNumber: '',
                role: '',
                salary: 0,
                twitterProfile: '',
                uid: this.$store.state.auth.user ? this.$store.state.auth.user.uid : '',
                username: '',
                designation: '',
                grade: '',
                role_title: '',
                personalEmail: '',
                dateOfBirth: '',
                nationality: '',
                maritalStatus: '',
                currentAddress: '',
                permanentAddress: '',
                emergencyContactName: '',
                emergencyContactNumber: '',
                profile_picture: '',
                nicImageUrl: '',
                certificateUrl: '',
                salarySlipUrl: '',
                company: this.companyName,
                fullName: '',
                status: 'Active'
              };


              this.isLoading = true;
              routeUserId = this.$route.params.id || (localStorage.getItem('impersonateUser') ? JSON.parse(localStorage.getItem('impersonateUser')).uid : null);
              _context.prev = 3;
              _context.next = 6;
              return this.$store.dispatch('initializeAuth');

            case 6:
              if (!routeUserId) {
                _context.next = 14;
                break;
              }

              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].getSingleUser(routeUserId);

            case 9:
              userData = _context.sent;

              if (userData) {
                _context.next = 12;
                break;
              }

              throw new Error('User not found');

            case 12:
              _context.next = 15;
              break;

            case 14:
              userData = this.$store.state.auth.user || defaultUserData;

            case 15:

              this.user = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, userData, {
                bankName: userData.bankName || '',
                email: userData.email || '',
                iban: userData.iban || '',
                isActive: userData.isActive !== undefined ? userData.isActive : true,
                joiningDate: userData.joiningDate || '',
                leavesAllowed: userData.leavesAllowed || 7.5,
                leavesAvailable: userData.leavesAvailable || 15,
                leavesTaken: userData.leavesTaken || '',
                nicNumber: userData.nicNumber || '',
                phoneNumber: userData.phoneNumber || '',
                role: userData.role || '',
                salary: userData.salary || 0,
                twitterProfile: userData.twitterProfile || '',
                uid: routeUserId || userData.uid || (this.$store.state.auth.user ? this.$store.state.auth.user.uid : ''),
                username: userData.username || '',
                designation: userData.designation || '',
                grade: userData.grade || '',
                role_title: userData.role_title || '',
                personalEmail: userData.personalEmail || '',
                dateOfBirth: userData.dateOfBirth || '',
                nationality: userData.nationality || '',
                maritalStatus: userData.maritalStatus || '',
                currentAddress: userData.currentAddress || '',
                permanentAddress: userData.permanentAddress || '',
                emergencyContactName: userData.emergencyContactName || '',
                emergencyContactNumber: userData.emergencyContactNumber || '',
                profile_picture: userData.profile_picture || '',
                nicImageUrl: userData.nicImageUrl || '',
                certificateUrl: userData.certificateUrl || '',
                salarySlipUrl: userData.salarySlipUrl || '',
                company: this.companyName,
                fullName: userData.username || '',
                status: userData.status || this.$store.state.auth.user && this.$store.state.auth.user.status || 'Active'
              });

              if (this.user.nicImageUrl) {
                this.nicFirebaseFileType = this.inferFileType(this.user.nicImageUrl);
              }
              if (this.user.certificateUrl) {
                this.experienceLetterFirebaseFileType = this.inferFileType(this.user.certificateUrl);
                this.experienceLetterFileType = this.experienceLetterFirebaseFileType;
              }
              if (this.user.salarySlipUrl) {
                this.salarySlipFirebaseFileType = this.inferFileType(this.user.salarySlipUrl);
                this.salarySlipFileType = this.salarySlipFirebaseFileType;
              }

              if (this.isCurrentUser) {
                this.$store.commit('setUser', this.user);
              }
              _context.next = 28;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](3);

              console.error('Error fetching user from Firebase:', _context.t0);
              __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Failed to load user data: ' + _context.t0.message, 'error');
              this.user = defaultUserData;
              this.$router.push('/userManagement');

            case 28:
              _context.prev = 28;

              this.isLoading = false;
              return _context.finish(28);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3, 22, 28, 31]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    if (this.user && this.user.profile_picture) {
      this.profile_picture = this.user.profile_picture;
    }
    if (!this.user.joiningDate) {
      var today = new Date();
      var formattedDate = today.toISOString().split('T')[0];
      this.user.joiningDate = formattedDate;
    }
  },
  methods: {
    openFileInNewTab: __WEBPACK_IMPORTED_MODULE_16__utils_helperFunc__["a" /* openFileInNewTab */],
    initBankField: function initBankField() {
      if (this.user.bankName && !this.banks.includes(this.user.bankName)) {
        this.showCustomBank = true;
        this.customBankName = this.user.bankName;
      }
    },
    inferFileType: function inferFileType(url) {
      if (!url) return '';
      var extension = url.split('.').pop().toLowerCase().split('?')[0];
      if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image/' + extension;
      if (extension === 'pdf') return 'application/pdf';
      return '';
    },

    onDesignationChange: function onDesignationChange(value) {
      this.user.designation = value;
      this.user.grade = '';
      this.user.role_title = '';
      if (this.isCurrentUser) {
        this.$store.commit('setUser', this.user);
      }
    },
    onGradeChange: function onGradeChange(value) {
      this.user.grade = value;
      if (this.isCurrentUser) {
        this.$store.commit('setUser', this.user);
      }
    },
    onBankChange: function onBankChange(value) {
      var _this = this;

      if (!value) return;

      this.showCustomBank = value === 'Other';

      if (this.showCustomBank) {
        this.$nextTick(function () {
          return _this.$refs.customBank.focus();
        });

        if (this.customBankName) {
          this.user.bankName = this.customBankName;
        }
      } else {
        this.customBankName = '';
        this.user.bankName = value;
      }
      if (value) this.errors.bankName = undefined;
      if (this.isCurrentUser) {
        this.$store.commit('setUser', this.user);
      }
    },
    onCustomBankInput: function onCustomBankInput() {
      if (!this.customBankName) return;
      this.user.bankName = this.customBankName;
      if (this.isCurrentUser) {
        this.$store.commit('setUser', this.user);
      }
    },
    onNationalityChange: function onNationalityChange(value) {
      this.user.nationality = value;
      if (value) this.errors.nationality = undefined;
      if (this.isCurrentUser) {
        this.$store.commit('setUser', this.user);
      }
    },
    onMaritalStatusChange: function onMaritalStatusChange(value) {
      this.user.maritalStatus = value;
      if (value) this.errors.maritalStatus = undefined;
      if (this.isCurrentUser) {
        this.$store.commit('setUser', this.user);
      }
    },
    getGradesForDesignation: function getGradesForDesignation(designation) {
      return this.designationGrades[designation] || [];
    },
    getDisplayTitle: function getDisplayTitle(designation, grade) {
      if (!designation || !grade) return '';
      var grades = this.designationGrades[designation] || [];
      var gradeObj = grades.find(function (g) {
        return g.value.toString() === grade.toString();
      });
      if (!gradeObj) return '';

      var match = gradeObj.label.match(/\{([^}]+)\}/);
      var extractedTitle = match ? match[1] : gradeObj.label;

      var gradeNumberMatch = gradeObj.label.match(/(Grade\s*\d+)/i);
      var gradeNumber = gradeNumberMatch ? gradeNumberMatch[1] : '';

      return extractedTitle;
    },
    getRoleTitle: function getRoleTitle(designation, grade) {
      if (!designation || !grade) return '';
      var grades = this.designationGrades[designation] || [];
      var gradeObj = grades.find(function (g) {
        return g.value.toString() === grade.toString();
      });
      if (!gradeObj) return '';
      var match = gradeObj.label.match(/\{([^}]+)\}/);
      return match ? match[1] : gradeObj.label;
    },
    validateForm: function validateForm() {
      var _validateForm2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__assets_config_helpers__["y" /* validateForm */])(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.user, {
        bankName: this.showCustomBank ? this.customBankName : this.user.bankName,
        nicImageUrl: this.pendingNicFile ? 'pending' : this.user.nicImageUrl || ''
      }), this.isNonAdmin),
          isValid = _validateForm2.isValid,
          errors = _validateForm2.errors;

      this.errors = errors;
      return isValid;
    },
    updateProfile: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var oldUserData, loggedInUser, targetUser, oldNicUrl, finalNicImageUrl, actionType, userDataToUpdate, updatedFields, isAdmin, isUpdatingOwnProfile, activityName, activityDescription, changes, adminActivity, _$store$state$auth$us, adminId, adminUserName;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.validateForm()) {
                  _context2.next = 51;
                  break;
                }

                this.profileLoading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].getSingleUser(this.user.uid);

              case 5:
                oldUserData = _context2.sent;
                loggedInUser = this.$store.state.auth.user;
                targetUser = this.user;
                oldNicUrl = this.user.nicImageUrl || '';
                finalNicImageUrl = oldNicUrl;

                if (!this.pendingNicFile) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cloudinary__["a" /* uploadToCloudinary */])(this.pendingNicFile, 'user_cnic');

              case 13:
                finalNicImageUrl = _context2.sent;
                actionType = oldNicUrl ? 'replaced' : 'uploaded';
                _context2.next = 17;
                return this.logDocumentActivity('CNIC', actionType, targetUser, loggedInUser, oldNicUrl, finalNicImageUrl);

              case 17:
                userDataToUpdate = {
                  username: this.user.fullName,
                  designation: this.user.designation,
                  grade: this.user.grade,
                  companyEmail: this.user.email,
                  personalEmail: this.user.personalEmail,
                  nicNumber: this.user.nicNumber,
                  dateOfBirth: this.user.dateOfBirth,
                  joiningDate: this.user.joiningDate,
                  bankName: this.showCustomBank ? this.customBankName : this.user.bankName,
                  iban: this.user.iban,
                  nationality: this.user.nationality,
                  maritalStatus: this.user.maritalStatus,
                  phoneNumber: this.user.phoneNumber,
                  currentAddress: this.user.currentAddress,
                  permanentAddress: this.user.permanentAddress,
                  emergencyContactName: this.user.emergencyContactName,
                  emergencyContactNumber: this.user.emergencyContactNumber,
                  nicImageUrl: finalNicImageUrl
                };

                if (this.user.uid) {
                  _context2.next = 20;
                  break;
                }

                throw new Error('User UID is undefined');

              case 20:
                _context2.next = 22;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].updateEmployee(userDataToUpdate, this.user.uid);

              case 22:
                this.user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.user, userDataToUpdate, { status: this.user.status });

                if (this.pendingNicFile) {
                  this.user.nicImageUrl = finalNicImageUrl;
                  this.nicFirebaseFileType = this.nicLocalFileType;
                  URL.revokeObjectURL(this.nicLocalPreviewUrl);
                  this.nicLocalPreviewUrl = '';
                  this.nicLocalFileType = '';
                  this.pendingNicFile = null;
                }

                updatedFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["a" /* getUpdatedFields */])(oldUserData, userDataToUpdate);
                isAdmin = loggedInUser.role === 'admin';
                isUpdatingOwnProfile = loggedInUser.uid === targetUser.uid;
                activityName = '';
                activityDescription = '';
                changes = '';


                if (isUpdatingOwnProfile) {
                  activityName = loggedInUser.username + " updated their profile details";
                  activityDescription = loggedInUser.email + " updated their profile details.";
                } else {
                  activityName = loggedInUser.username + " updated " + targetUser.username + "'s profile details";
                  activityDescription = loggedInUser.email + " updated " + targetUser.email + "'s profile details.";
                }
                changes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(updatedFields).map(function (_ref3) {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                      key = _ref4[0],
                      value = _ref4[1];

                  return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["b" /* formatValue */])(value.new);
                }).join('\n');
                adminActivity = {
                  activityOnUserName: targetUser.username,
                  activityByUserName: loggedInUser.username,
                  activityName: activityName,
                  activityOnUser: targetUser.uid,
                  activityTitle: "Profile updated",
                  activityDescription: activityDescription,
                  changes: changes,
                  type: 'profile',
                  timestamp: new Date().toLocaleString('en-PK')
                };


                if (isAdmin) {
                  adminActivity.adminId = loggedInUser.uid;
                }

                _context2.next = 36;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(adminActivity);

              case 36:
                _$store$state$auth$us = this.$store.state.auth.user, adminId = _$store$state$auth$us.uid, adminUserName = _$store$state$auth$us.username;
                _context2.next = 39;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "update_user",
                  activityDescription: activityDescription,
                  activityOnUser: targetUser.uid,
                  activityOnUserName: targetUser.username,
                  activityByUserName: adminUserName,
                  activityName: activityName,
                  isAdmin: isAdmin
                }, this.$store.state.auth, adminId);

              case 39:

                if (this.isCurrentUser) {
                  this.$store.commit('setUser', this.user);
                }
                this.$emit('update-profile', this.user);
                this.profileLoading = false;
                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Success', 'Profile updated successfully', 'success');
                _context2.next = 49;
                break;

              case 45:
                _context2.prev = 45;
                _context2.t0 = _context2["catch"](2);

                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Failed to update profile: ' + _context2.t0.message, 'error');
                this.profileLoading = false;

              case 49:
                _context2.next = 52;
                break;

              case 51:
                this.$nextTick(function () {
                  var firstError = document.querySelector('.is-invalid,.invalid-feedback');
                  if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });

              case 52:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 45]]);
      }));

      function updateProfile() {
        return _ref2.apply(this, arguments);
      }

      return updateProfile;
    }(),
    submitVerificationDocuments: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var loggedInUser, targetUser, oldCertUrl, oldSlipUrl, finalCertificateUrl, finalSalarySlipUrl, actionType, _actionType, documentsData;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.documentLoading = true;
                loggedInUser = this.$store.state.auth.user;
                targetUser = this.user;
                oldCertUrl = this.user.certificateUrl || '';
                oldSlipUrl = this.user.salarySlipUrl || '';
                finalCertificateUrl = oldCertUrl;
                finalSalarySlipUrl = oldSlipUrl;

                if (!this.pendingExperienceLetterFile) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cloudinary__["a" /* uploadToCloudinary */])(this.pendingExperienceLetterFile, 'experience_letter');

              case 11:
                finalCertificateUrl = _context3.sent;
                actionType = oldCertUrl ? 'replaced' : 'uploaded';
                _context3.next = 15;
                return this.logDocumentActivity('Academic Certificate/Experience Letter', actionType, targetUser, loggedInUser, oldCertUrl, finalCertificateUrl);

              case 15:
                if (!this.pendingSalarySlipFile) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 18;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cloudinary__["a" /* uploadToCloudinary */])(this.pendingSalarySlipFile, 'salary_slip');

              case 18:
                finalSalarySlipUrl = _context3.sent;
                _actionType = oldSlipUrl ? 'replaced' : 'uploaded';
                _context3.next = 22;
                return this.logDocumentActivity('Salary Slip', _actionType, targetUser, loggedInUser, oldSlipUrl, finalSalarySlipUrl);

              case 22:
                documentsData = {
                  certificateUrl: finalCertificateUrl,
                  salarySlipUrl: finalSalarySlipUrl
                };

                if (this.user.uid) {
                  _context3.next = 25;
                  break;
                }

                throw new Error('User UID is undefined');

              case 25:
                _context3.next = 27;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].updateEmployee(documentsData, this.user.uid);

              case 27:
                this.user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.user, documentsData);
                if (this.pendingExperienceLetterFile) {
                  this.user.certificateUrl = finalCertificateUrl;
                  this.experienceLetterFirebaseFileType = this.experienceLetterLocalFileType;
                  URL.revokeObjectURL(this.experienceLetterLocalPreviewUrl);
                  this.experienceLetterLocalPreviewUrl = '';
                  this.experienceLetterLocalFileType = '';
                  this.pendingExperienceLetterFile = null;
                }
                if (this.pendingSalarySlipFile) {
                  this.user.salarySlipUrl = finalSalarySlipUrl;
                  this.salarySlipFirebaseFileType = this.salarySlipLocalFileType;
                  URL.revokeObjectURL(this.salarySlipLocalPreviewUrl);
                  this.salarySlipLocalPreviewUrl = '';
                  this.salarySlipLocalFileType = '';
                  this.pendingSalarySlipFile = null;
                }

                if (this.isCurrentUser) {
                  this.$store.commit('setUser', this.user);
                }
                this.documentLoading = false;
                this.$emit('submit-documents', documentsData);
                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Success', 'Verification documents submitted successfully', 'success');
                _context3.next = 40;
                break;

              case 36:
                _context3.prev = 36;
                _context3.t0 = _context3["catch"](0);

                this.documentLoading = false;
                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Failed to submit verification documents: ' + _context3.t0.message, 'error');

              case 40:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 36]]);
      }));

      function submitVerificationDocuments() {
        return _ref5.apply(this, arguments);
      }

      return submitVerificationDocuments;
    }(),
    triggerNicFileInput: function triggerNicFileInput() {
      this.$refs.nicImageInput.click();
    },
    handleNicFileDrop: function handleNicFileDrop(event) {
      var file = event.dataTransfer.files[0];
      if (file) this.selectNicFile(file);
    },
    handleNicImageUpload: function handleNicImageUpload(event) {
      var file = event.target.files[0];
      if (file) this.selectNicFile(file);
      event.target.value = '';
    },
    selectNicFile: function selectNicFile(file) {
      if (!file.type.match('image.*|application/pdf')) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Please select an image or PDF file for NIC Picture', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'File size should not exceed 5MB', 'error');
        return;
      }
      if (this.nicLocalPreviewUrl && this.nicLocalPreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.nicLocalPreviewUrl);
      }
      this.pendingNicFile = file;
      this.nicLocalPreviewUrl = URL.createObjectURL(file);
      this.nicLocalFileType = file.type;
      this.errors.nicImageUrl = null;
    },
    handleDocumentFileSelected: function handleDocumentFileSelected(file, type) {
      if (type === 'experience_letter') {
        this.selectExperienceLetterFile(file);
      } else if (type === 'salary_slip') {
        this.selectSalarySlipFile(file);
      }
    },
    selectExperienceLetterFile: function selectExperienceLetterFile(file) {
      if (!file.type.match('image.*|application/pdf')) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Please select a valid file format for Academic Certificate/Experience Letter', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'File size should not exceed 5MB', 'error');
        return;
      }
      if (this.experienceLetterLocalPreviewUrl && this.experienceLetterLocalPreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.experienceLetterLocalPreviewUrl);
      }
      this.pendingExperienceLetterFile = file;
      this.experienceLetterLocalPreviewUrl = URL.createObjectURL(file);
      this.experienceLetterLocalFileType = file.type;
      this.experienceLetterFileName = file.name;
      this.experienceLetterFileSize = this.formatFileSize(file.size);
      this.experienceLetterFileType = file.type;
    },
    selectSalarySlipFile: function selectSalarySlipFile(file) {
      if (!file.type.match('image.*|application/pdf')) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Please select a valid file format for Salary Slip', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'File size should not exceed 5MB', 'error');
        return;
      }
      if (this.salarySlipLocalPreviewUrl && this.salarySlipLocalPreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.salarySlipLocalPreviewUrl);
      }
      this.pendingSalarySlipFile = file;
      this.salarySlipLocalPreviewUrl = URL.createObjectURL(file);
      this.salarySlipLocalFileType = file.type;
      this.salarySlipFileName = file.name;
      this.salarySlipFileSize = this.formatFileSize(file.size);
      this.salarySlipFileType = file.type;
    },

    triggerProfileFileInput: function triggerProfileFileInput() {
      if (this.$refs.profileImageInput) {
        this.$refs.profileImageInput.click();
      } else {
        console.error('profileImageInput ref is undefined');
      }
    },
    handleProfileImageUpload: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(event) {
        var file, url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                file = event.target.files[0];

                if (file) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                if (file.type.match('image.*')) {
                  _context4.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Please select an image file for Profile Picture', 'error');
                return _context4.abrupt("return");

              case 6:
                if (!(file.size > 5 * 1024 * 1024)) {
                  _context4.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'File size should not exceed 5MB', 'error');
                return _context4.abrupt("return");

              case 9:
                _context4.prev = 9;

                this.uploadingProfileImage = true;
                _context4.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cloudinary__["a" /* uploadToCloudinary */])(file, 'profile_images');

              case 13:
                url = _context4.sent;

                this.user.profile_picture = url;
                this.errors.profile_picture = null;
                _context4.next = 18;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].updateEmployee({ profile_picture: url }, this.user.uid);

              case 18:
                if (this.isCurrentUser) {
                  this.$store.commit('setUser', this.user);
                }
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](9);

                __WEBPACK_IMPORTED_MODULE_14_sweetalert___default()('Error', 'Failed to upload profile image: ' + _context4.t0.message, 'error');

              case 24:
                _context4.prev = 24;

                this.uploadingProfileImage = false;
                return _context4.finish(24);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 21, 24, 27]]);
      }));

      function handleProfileImageUpload(_x) {
        return _ref6.apply(this, arguments);
      }

      return handleProfileImageUpload;
    }(),
    formatFileSize: function formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      var k = 1024;
      var sizes = ['Bytes', 'KB', 'MB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    getDocumentThumbnail: function getDocumentThumbnail(url) {
      if (!url || !url.includes('cloudinary.com')) return url;
      var lowerUrl = url.toLowerCase();
      if (lowerUrl.endsWith('.pdf')) {
        var normalized = url.replace('/raw/upload/', '/image/upload/').replace('/raw/', '/image/');
        var parts = normalized.split('/upload/');
        if (parts.length !== 2) return url;
        var transform = 'w_150,h_200,c_thumb,pg_1,f_auto,q_auto';
        return parts[0] + "/upload/" + transform + "/" + parts[1];
      }

      return url;
    },


    logDocumentActivity: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(documentType, actionType, targetUser, loggedInUser, oldUrl, newUrl) {
        var isUpdatingOwnProfile, activityName, activityDescription, changesLine, adminActivity, adminId;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isUpdatingOwnProfile = loggedInUser.uid === targetUser.uid;
                activityName = '';
                activityDescription = '';


                if (isUpdatingOwnProfile) {
                  activityName = loggedInUser.username + " " + actionType + " their " + documentType;
                  activityDescription = loggedInUser.email + " " + actionType + " their " + documentType + ".";
                } else {
                  activityName = loggedInUser.username + " " + actionType + " " + documentType + " for " + targetUser.username;
                  activityDescription = loggedInUser.email + " " + actionType + " " + documentType + " for " + targetUser.email + ".";
                }
                changesLine = '';

                if (oldUrl && newUrl) {
                  changesLine = documentType + ": " + oldUrl + " \u2192 " + newUrl;
                } else if (newUrl) {
                  changesLine = documentType + ": " + newUrl;
                } else {
                  changesLine = documentType + ": " + actionType + " at " + new Date().toLocaleString('en-PK');
                }

                adminActivity = {
                  activityOnUserName: targetUser.username,
                  activityByUserName: loggedInUser.username,
                  activityName: activityName,
                  activityOnUser: targetUser.uid,
                  activityTitle: "Document " + actionType,
                  activityDescription: activityDescription,
                  changes: changesLine,
                  type: 'document',
                  documentType: documentType,
                  actionType: actionType,
                  timestamp: new Date().toLocaleString('en-PK')
                };

                if (loggedInUser.role === 'admin') {
                  adminActivity.adminId = loggedInUser.uid;
                }
                _context5.next = 10;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_adminLogs__["c" /* logAdminActivity */])(adminActivity);

              case 10:
                adminId = this.$store.state.auth.user.uid;

                if (!(documentType !== 'CNIC')) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__services_notificationService__["b" /* handleActivityNotification */])({
                  type: 'update_user',
                  activityDescription: activityDescription,
                  activityOnUser: targetUser.uid,
                  activityOnUserName: targetUser.username,
                  activityByUserName: loggedInUser.username,
                  activityName: activityName,
                  isAdmin: loggedInUser.role === 'admin'
                }, this.$store.state.auth, adminId);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function logDocumentActivity(_x2, _x3, _x4, _x5, _x6, _x7) {
        return _ref7.apply(this, arguments);
      }

      return logDocumentActivity;
    }()
  },
  beforeDestroy: function beforeDestroy() {
    if (this.nicLocalPreviewUrl && this.nicLocalPreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.nicLocalPreviewUrl);
    }
    if (this.experienceLetterLocalPreviewUrl && this.experienceLetterLocalPreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.experienceLetterLocalPreviewUrl);
    }
    if (this.salarySlipLocalPreviewUrl && this.salarySlipLocalPreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.salarySlipLocalPreviewUrl);
    }
  },
  watch: {
    'user.bankName': function userBankName() {
      this.initBankField();
    }
  }
});

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dd6749c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("L9Zj");
function injectStyle (ssrContext) {
  __webpack_require__("+GrW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dd6749c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c+jd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Maps_API_KEY__ = __webpack_require__("JElF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps__);
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_0__Maps_API_KEY__["a" /* API_KEY */];
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initMap: function initMap(google) {
      var myLatlng = new google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 13,
        center: myLatlng,
        scrollwheel: false, // we disable de scroll over the map, it is a really annoing when you scroll through page
        styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
      };
      var map = new google.maps.Map(document.getElementById('map'), mapOptions);

      var marker = new google.maps.Marker({
        position: myLatlng,
        title: 'Hello World!'
      });

      // To add the marker to the map, call setMap();
      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.load(function (google) {
      _this.initMap(google);
    });
  }
});

/***/ }),

/***/ "cFw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-template-manager"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.templates),function(template){return _c('EmailTemplateItem',{key:template.id,attrs:{"template":template,"isOpen":_vm.activeTemplateId === template.id},on:{"toggle":function($event){return _vm.toggleTemplate(template.id)},"save":_vm.handleSaveTemplate}})})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-heading"},[_c('h5',{staticClass:"title"},[_vm._v("Email Template Manager")]),_vm._v(" "),_c('p',[_vm._v("Customize automated email templates")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cNeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeavesCalculation_vue__ = __webpack_require__("6nww");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a73133a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeavesCalculation_vue__ = __webpack_require__("EgLW");
function injectStyle (ssrContext) {
  __webpack_require__("Ttoc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a73133a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeavesCalculation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a73133a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeavesCalculation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cfT+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleCalendarIntegration_vue__ = __webpack_require__("h7Z3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4659f656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleCalendarIntegration_vue__ = __webpack_require__("yvXw");
function injectStyle (ssrContext) {
  __webpack_require__("S5nd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4659f656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleCalendarIntegration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4659f656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleCalendarIntegration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cjc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closePanel),expression:"closePanel"}],staticClass:"notif-wrapper"},[_c('button',{staticClass:"notif-bell",class:{ 'notif-bell--active': _vm.isPanelOpen && !_vm.isMobile, 'notif-bell--no-hover': _vm.isMobile },attrs:{"aria-label":"Notifications"},on:{"click":_vm.togglePanel}},[_c('i',{staticClass:"fa fa-bell",staticStyle:{"font-size":"18px"}}),_vm._v(" "),(_vm.unreadCount > 0)?_c('span',{staticClass:"notif-badge",style:(_vm.isMobile ? 'top: -10px; right: -7px;' : '')},[_vm._v("\n      "+_vm._s(_vm.unreadCount > 99 ? "99+" : _vm.unreadCount)+"\n    ")]):_vm._e()]),_vm._v(" "),(_vm.isMobile)?_c('span',{staticStyle:{"padding-left":"10px"},on:{"click":_vm.togglePanel}},[_vm._v("Notifications")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"notif-panel-slide"}},[(_vm.isPanelOpen)?_c('div',{staticClass:"notif-panel"},[_c('div',{staticClass:"notif-panel__header"},[_c('h3',{staticClass:"notif-panel__title"},[_vm._v("Notifications")]),_vm._v(" "),_c('label',{staticClass:"notif-toggle"},[_c('span',{staticClass:"notif-toggle__label"},[_vm._v("Only show unread")]),_vm._v(" "),_c('div',{staticClass:"notif-toggle__switch",class:{ 'notif-toggle__switch--on': _vm.showUnreadOnly },attrs:{"role":"switch","aria-checked":_vm.showUnreadOnly},on:{"click":function($event){_vm.showUnreadOnly = !_vm.showUnreadOnly}}},[_c('div',{staticClass:"notif-toggle__thumb"})])])]),_vm._v(" "),_c('div',{staticClass:"notif-panel__divider"}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","gap":"10px","padding":"5px 12px"}},[(_vm.unreadCount > 0)?_c('button',{staticClass:"notif-mark-all",on:{"click":_vm.markAllNotificationsRead}},[_vm._v("\n          Mark all as read\n        ")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"notif-panel__center"},[_c('div',{staticClass:"notif-spinner"})]):(_vm.displayedNotifications.length === 0)?_c('div',{staticClass:"notif-panel__empty"},[_c('svg',{attrs:{"width":"64","height":"64","viewBox":"0 0 24 24","fill":"none","stroke":"#CBD5E0","stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.73 21a2 2 0 0 1-3.46 0"}}),_vm._v(" "),_c('line',{attrs:{"x1":"1","y1":"1","x2":"23","y2":"23","stroke":"#CBD5E0"}})]),_vm._v(" "),_c('p',{staticClass:"notif-panel__empty-title"},[_vm._v("\n          "+_vm._s(_vm.showUnreadOnly ? "No unread notifications" : "No notifications yet")+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"notif-panel__empty-sub"},[_vm._v("\n          "+_vm._s(_vm.showUnreadOnly
              ? "You're all caught up!"
              : "")+"\n        ")])]):_c('div',{staticClass:"notif-panel__list"},[_vm._l((_vm.displayedNotifications),function(notif){return _c('div',{key:notif.id,staticClass:"notif-item",class:{ 'notif-item--unread': !notif.isRead },on:{"click":function($event){return _vm.handleNotifClick(notif)}}},[_c('div',{staticClass:"notif-item__icon",class:("notif-item__icon--" + (notif.type))},[(notif.type === 'leave_applied')?_c('i',{staticClass:"fa fa-file-alt"}):(notif.type === 'leave_approved')?_c('i',{staticClass:"fa fa-check-circle"}):(notif.type === 'leave_rejected')?_c('i',{staticClass:"fa fa-times-circle"}):(notif.type === 'performance_item_added')?_c('i',{staticClass:"fa fa-plus-circle"}):(notif.type === 'performance_item_updated')?_c('i',{staticClass:"fa fa-edit"}):(notif.type === 'performance_score_updated')?_c('i',{staticClass:"fa fa-bullseye"}):(notif.type === 'performance_reopen_updated')?_c('i',{staticClass:"fa fa-sync-alt"}):(notif.type === 'performance_locked')?_c('i',{staticClass:"fa fa-lock"}):(notif.type === 'performance_unlocked')?_c('i',{staticClass:"fa fa-lock-open"}):(notif.type === 'performance_scheduled_lock')?_c('i',{staticClass:"fa fa-calendar-check"}):(notif.type === 'settings_updated')?_c('i',{staticClass:"fa fa-cog"}):(notif.type === 'general_settings_updated')?_c('i',{staticClass:"fa fa-cog"}):(notif.type === 'hours_added')?_c('i',{staticClass:"fa fa-clock"}):(notif.type === 'hours_updated')?_c('i',{staticClass:"fa fa-clock"}):(notif.type === 'hours_edit_requested')?_c('i',{staticClass:"fa fa-clock"}):(notif.type === 'hours_edit_approved')?_c('i',{staticClass:"fa fa-check-circle"}):(notif.type === 'hours_edit_rejected')?_c('i',{staticClass:"fa fa-times-circle"}):(notif.type === 'quarterly_meeting_scheduled')?_c('i',{staticClass:"fa fa-calendar-alt"}):(notif.type === 'quarterly_meeting_deleted')?_c('i',{staticClass:"fa fa-calendar-times"}):(notif.type === 'increment_meeting_scheduled')?_c('i',{staticClass:"fa fa-calendar-alt"}):(notif.type === 'increment_meeting_deleted')?_c('i',{staticClass:"fa fa-calendar-times"}):(notif.type === 'user_created')?_c('i',{staticClass:"fa fa-user-plus"}):(notif.type === 'user_deleted')?_c('i',{staticClass:"fa fa-user-minus"}):(notif.type === 'payroll_processed')?_c('i',{staticClass:"fa fa-money-bill-wave"}):(notif.type === 'payroll_draft')?_c('i',{staticClass:"fa fa-file-invoice"}):(notif.type === 'expense_added' || notif.type === 'expense_updated')?_c('i',{staticClass:"fa fa-receipt"}):(notif.type === 'expense_deleted')?_c('i',{staticClass:"fa fa-trash-alt"}):_c('i',{staticClass:"fa fa-bell"})]),_vm._v(" "),_c('div',{staticClass:"notif-item__content"},[_c('p',{staticClass:"notif-item__title"},[_vm._v(_vm._s(notif.title))]),_vm._v(" "),_c('p',{staticClass:"notif-item__msg"},[_vm._v(_vm._s(notif.message))]),_vm._v(" "),_c('div',{staticClass:"notif-item__meta"},[_c('span',{staticClass:"notif-item__time"},[_vm._v(_vm._s(_vm.timeAgo(notif.createdAt)))])])]),_vm._v(" "),(!notif.isRead)?_c('div',{staticClass:"notif-item__dot"}):_vm._e()])}),_vm._v(" "),(_vm.hasMore)?_c('button',{staticClass:"notif-show-more",attrs:{"disabled":_vm.loadingMore},on:{"click":_vm.loadMore}},[(_vm.loadingMore)?_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{staticClass:"notif-spinner"})]):_c('span',[_vm._v("Show more ("+_vm._s(_vm.remainingCount)+" more)")])]):_vm._e()],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cknC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "csSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d2rl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"performance"},[(_vm.loading)?_c('div',{staticClass:"text-center py-4"},[_c('Card',[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Checking Trello authentication...")]),_vm._v(" "),(_vm.loadingTimeout)?_c('p',{staticClass:"text-warning mt-2"},[_vm._v("\n        Taking longer than expected...\n        "),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.retryCheck}},[_vm._v("Retry")])]):_vm._e()])],1):(!_vm.isTrelloConnected)?_c('div',{staticClass:"text-center py-5"},[_c('Card',[_c('img',{staticClass:"mb-4 mt-2",staticStyle:{"width":"150px","height":"auto"},attrs:{"src":"https://d2k1ftgv7pobq7.cloudfront.net/meta/c/p/res/images/trello-header-logos/76ceb1faa939ede03abacb6efacdde16/trello-logo-blue.svg","alt":"Trello Logo"}}),_vm._v(" "),_c('h4',{staticClass:"mb-3"},[_vm._v("Connect to Trello")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_vm._v("Please connect your Trello account to view performance metrics.")]),_vm._v(" "),_c('button',{staticClass:"connet-to-trello-btn",staticStyle:{"margin-bottom":"20px"},on:{"click":_vm.loginWithTrello}},[_vm._v("\n        Login with Trello\n      ")])])],1):_c('div',[_c('Performance',{attrs:{"selectedEmployeeTrelloUsername":_vm.selectedEmployeeTrelloUsername},on:{"logoutFromTrello":_vm.handleLogout}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dOhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EmployeeStatusDropdown",
  props: {
    employees: { type: Array, required: true },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      dropdownOpen: false,
      filterType: "active",
      searchTerm: "",
      selectedEmployee: null
    };
  },

  computed: {
    activeEmployees: function activeEmployees() {
      return this.employees.filter(function (u) {
        return u.isActive;
      });
    },
    allEmployees: function allEmployees() {
      return this.employees;
    },
    finalList: function finalList() {
      var list = this.filterType === "active" ? this.activeEmployees : this.allEmployees;

      if (this.searchTerm) {
        var term = this.searchTerm.toLowerCase();
        list = list.filter(function (u) {
          return u.username && u.username.toLowerCase().includes(term) || u.email && u.email.toLowerCase().includes(term);
        });
      }

      return list;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(newValue) {
        if (newValue) {
          this.selectedEmployee = this.employees.find(function (emp) {
            return emp.uid === newValue;
          }) || null;
        } else {
          this.selectedEmployee = null;
        }
      }
    },
    selectedEmployee: function selectedEmployee(newValue) {
      this.$emit("input", newValue ? newValue.uid : null);
    }
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      if (!this.disabled) {
        this.dropdownOpen = !this.dropdownOpen;
      }
    },
    setFilter: function setFilter(type) {
      this.filterType = type;
    },
    selectEmployee: function selectEmployee(emp) {
      this.selectedEmployee = emp;
      this.dropdownOpen = false;
      this.$emit("input", emp.uid);
    }
  }
});

/***/ }),

/***/ "deL4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "djO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"margin-top":"20px"}},[[_c('div',{staticClass:"header-actions"},[_c('h5',{staticClass:"title"},[_vm._v("Public Holidays")]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"actions-right"},[_c('button',{staticClass:"add-employee",on:{"click":function($event){return _vm.openHolidayModal()}}},[_c('span',[_vm._v("Add Holiday")])])]):_vm._e()])],_vm._v(" "),_c('div',[_c('CustomTable',{attrs:{"defaultSortKey":"dates","header":_vm.filteredColumns,"loading":_vm.loadingStates.table,"columns":_vm.filteredColumns,"data":_vm.holidayList},scopedSlots:_vm._u([{key:"fileName",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.name || '-'}},[_vm._v("\n                  "+_vm._s(item.name || '-')+"\n                ")])]}},{key:"dates",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text"},[_vm._v("\n                  "+_vm._s(_vm.formatDate(item.dates, !item.isRecurring, item.numberOfDays))+"\n                ")])]}},{key:"isRecurring",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text"},[_vm._v("\n                  "+_vm._s(item.isRecurring ? "Recurring" : "One-time")+"\n                ")])]}},{key:"shift",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text"},[_vm._v(_vm._s(item.shift || "-"))])]}},{key:"numberOfDays",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v("\n                  "+_vm._s(item.numberOfDays ? item.numberOfDays + (item.numberOfDays > 1 ? " days" : " day") : "-")+"\n                ")])]}},(_vm.isAdmin)?{key:"action",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"action-buttons"},[_c('button',{staticClass:"edit-btn btn-status",attrs:{"title":'Edit'},on:{"click":function($event){return _vm.editHoliday(item)}}},[_c('PencilIcon',{attrs:{"color":"gray","width":16,"height":16}})],1),_vm._v(" "),_c('button',{staticClass:"delete-btn btn-status",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.openDeleteModal(item)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"gray"}})])])]}}:null],true)})],1)],2),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isHolidayModalOpen,"title":this.selectedHoliday ? 'Edit Holiday' : 'Add Holiday',"isLarge":false,"submitButtonText":"Save","loading":_vm.loadingStates.save},on:{"update:modelValue":function($event){_vm.isHolidayModalOpen = $event},"submit":function($event){return _vm.saveHoliday()}}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveHoliday()}}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"20px"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Holiday Name "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Enter Holiday Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.nameError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.nameError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"20px"}},[_c('label',{attrs:{"for":"dates"}},[_vm._v("Date "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dates),expression:"dates"}],staticClass:"form-control",attrs:{"type":"date","id":"dates","required":""},domProps:{"value":(_vm.dates)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dates=$event.target.value}}}),_vm._v(" "),(_vm.dateError)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.dateError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"margin-bottom":"20px"}},[_c('label',{attrs:{"for":"days"}},[_vm._v("Number of Days")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.numberOfDays),expression:"numberOfDays",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":"days","min":"1","required":""},domProps:{"value":(_vm.numberOfDays)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.numberOfDays=_vm._n($event.target.value)},_vm.onDaysInput],"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('CustomDropdown',{attrs:{"id":"shift-dropdown","label":"Shift","options":_vm.shiftOptions,"value":_vm.shift,"placeholder":"Select Shift"},on:{"change":function($event){_vm.shift = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"checkbox-box col-md-6 public-holiday-checbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRecurring),expression:"isRecurring"}],staticClass:"checkbox",staticStyle:{"width":"15px","height":"15px","margin-bottom":"2px"},attrs:{"type":"checkbox","id":"recurring"},domProps:{"checked":Array.isArray(_vm.isRecurring)?_vm._i(_vm.isRecurring,null)>-1:(_vm.isRecurring)},on:{"change":function($event){var $$a=_vm.isRecurring,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isRecurring=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isRecurring=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isRecurring=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"recurring"}},[_vm._v("Recurring yearly")])])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e1yX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e49c370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("phi2");
function injectStyle (ssrContext) {
  __webpack_require__("iT8i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e49c370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eLjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_config_api__ = __webpack_require__("IFYK");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var tableColumns = ["Avatar", "Username", "Email", "Phone Number", "NIC"];
var tableData = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    console.log("allusers=======================>", this.$store.state.auth.allUsers);
    return {
      table1: {
        title: "Stripped Table",
        subTitle: "Here is a subtitle for this table",
        columns: [].concat(tableColumns),
        data: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.auth.allUsers))
      },
      email: "",
      username: "",
      cnic: "",
      phone: "",
      iban: "",
      isAdmin: false,
      isLoading: false,
      isAddingEmployee: false
    };
  },

  methods: {
    openModal: function openModal() {
      var modalBtn = document.querySelector("#modal-btn");
      var constants = this.$store.state.auth.constants;
      var allUsers = this.$store.state.auth.allUsers;

      var usersAllow = constants.usersAllow;

      if (usersAllow <= allUsers.length) {
        swal("Upgrade Your Plan!", "In order to add more employees, you have to upgrade your plan!", "info");
      } else {
        modalBtn.click();
      }
    },
    handleRadioChange: function handleRadioChange(event) {
      this.isAdmin = event.target.checked;
    },
    closeModal: function closeModal() {
      var modalBtn = document.querySelector("#modal-btn");

      modalBtn.click();
    },
    addEmployee: function addEmployee(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var email, username, iban, phone, cnic, role, apiBody, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                email = _this.email;
                username = _this.username;
                iban = _this.iban || "";
                phone = _this.phone || "";
                cnic = _this.cnic || "";
                role = _this.isAdmin ? "admin" : "user";
                apiBody = {
                  email: email,
                  name: username,
                  cnic: cnic,
                  phone: phone,
                  iban: iban,
                  role: role,
                  companyEmail: _this.$store.state.auth.company.email
                };
                _context.prev = 8;

                _this.isAddingEmployee = true;

                if (email.trim().length) {
                  _context.next = 12;
                  break;
                }

                throw { message: "Email is required" };

              case 12:
                if (username.trim().length) {
                  _context.next = 14;
                  break;
                }

                throw { message: "name is required" };

              case 14:
                _context.next = 16;
                return __WEBPACK_IMPORTED_MODULE_8__assets_config_api__["a" /* default */].createUser(apiBody);

              case 16:
                response = _context.sent;
                _context.next = 19;
                return response.json();

              case 19:
                data = _context.sent;

                if (!(response.status !== 200)) {
                  _context.next = 22;
                  break;
                }

                throw data;

              case 22:

                // this.dialog = false;

                _this.isAddingEmployee = false;
                _this.clearFields();
                swal("Great", "Added", "success");
                _context.next = 32;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](8);

                _this.isAddingEmployee = false;
                _this.email = "";
                swal("Oops!", _context.t0.message, "error");

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 27]]);
      }))();
    },
    clearFields: function clearFields() {
      this.email = "";
      this.name = "";
      this.phone = "";
      this.iban = "";
      this.cnic = "";
    }
  }
});

/***/ }),

/***/ "eQDl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eQcZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  }
});

/***/ }),

/***/ "f4OB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */] }
});

/***/ }),

/***/ "f50w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fV+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("sV9Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96dc691e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("d2rl");
function injectStyle (ssrContext) {
  __webpack_require__("VLbD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96dc691e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96dc691e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fWxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fyNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PublicHoliday_vue__ = __webpack_require__("3qd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__("wtEF");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FileTable: __WEBPACK_IMPORTED_MODULE_0__PublicHoliday_vue__["a" /* default */]
  },
  computed: {
    isAdmin: function isAdmin() {
      var user = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.auth.user;
      return user && user.role === "admin";
    }
  },
  methods: {
    refreshFiles: function refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "g5jX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gAKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_fileUtils__ = __webpack_require__("mq8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__ = __webpack_require__("guQB");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    CustomTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_ReuseableModal_vue__["a" /* default */]
  },

  data: function data() {
    return {
      searchTerm: "",
      resetTableFlag: false,
      activityList: [],
      selectedActivity: null,

      isViewModalOpen: false,

      tableColumns: [{ label: "Admin Name", key: "activityByUserName", sortable: true, sticky: "left" }, { label: "User Name", key: "activityOnUserName", sortable: true, sticky: "left" }, { label: "Type", key: "type", sortable: true }, { label: "Activity Date", key: "timestamp", sortable: true }, { label: "Open Activity", key: "action", sticky: "right" }],

      loadingStates: {
        table: false,
        view: false
      }
    };
  },


  computed: {
    formattedDescription: function formattedDescription() {
      var desc = this.selectedActivity.activityDescription;
      if (!desc) return 'N/A';

      var emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

      return desc.replace(emailRegex, '<strong>$1</strong>');
    },
    formattedChanges: function formattedChanges() {
      if (!this.selectedActivity && !this.selectedActivity.changes) return '';

      return this.selectedActivity.changes.split('\n').map(function (line) {
        var index = line.indexOf(':');
        if (index === -1) return line;

        var key = line.slice(0, index);
        var value = line.slice(index + 1);

        return "<strong>" + key + "</strong>:" + value;
      }).join('\n');
    },
    filteredActivities: function filteredActivities() {
      if (!this.searchTerm) return this.activityList;
      var term = this.searchTerm.toLowerCase();

      return this.activityList.filter(function (a) {
        var byUser = a.activityByUserName ? a.activityByUserName.toLowerCase() : '';
        var onUser = a.activityOnUserName ? a.activityOnUserName.toLowerCase() : '';
        var type = a.type ? a.type : '';

        return byUser.includes(term) || onUser.includes(term) || type.includes(term);
      });
    },
    mapLink: function mapLink() {
      if (!this.latitude || !this.longitude) return null;
      return "https://www.google.com/maps?q=" + this.latitude + "," + this.longitude;
    },
    googleMapEmbedUrl: function googleMapEmbedUrl() {
      if (!this.latitude || !this.longitude) return '';
      return "https://www.google.com/maps/embed/v1/view?key=YOUR_GOOGLE_MAPS_API_KEY&center=" + this.latitude + "," + this.longitude + "&zoom=15";
    }
  },

  mounted: function mounted() {
    this.fetchActivities();
  },


  methods: {
    resetTablePage: function resetTablePage() {
      // emit to child table
    },
    formatDate: function formatDate(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_fileUtils__["e" /* formatAdminActivityDate */])(date);
    },
    fetchActivities: function fetchActivities() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingStates.table = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__assets_config_firebase__["a" /* default */].getAllAdminActivities();

              case 4:
                _this.activityList = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                console.error("Fetch admin activities failed", _context.t0);

              case 10:
                _context.prev = 10;

                _this.loadingStates.table = false;
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7, 10, 13]]);
      }))();
    },
    openActivity: function openActivity(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isViewModalOpen = true;
                _this2.loadingStates.view = true;
                _this2.selectedActivity = null;

                try {
                  _this2.selectedActivity = item;
                } catch (err) {
                  console.error("Fetch activity failed", err);
                } finally {
                  _this2.loadingStates.view = false;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeViewModal: function closeViewModal() {
      this.isViewModalOpen = false;
      this.selectedActivity = null;
    }
  },

  watch: {
    searchTerm: function searchTerm() {
      this.resetTableFlag = true;
    }
  }
});

/***/ }),

/***/ "gDoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-profile"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',[_c('ProfileForm',{attrs:{"user":_vm.user,"company":_vm.company},on:{"updateParent":_vm.updateParent}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gWRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("zH0f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea354c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("CfxH");
function injectStyle (ssrContext) {
  __webpack_require__("IXZi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ea354c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea354c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gY6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monthNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monthShortNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return monthMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return lateRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deductionRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newLateThresholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return leaveEncashmentDecRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return leavesCarryForwardDecRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return appTrelloLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cardIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return halfDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return serverURL; });
/* unused harmony export numberRegex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STATIC_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_POLICY_URL; });
// let serverURL = "https://pertime.expertizo.pk" // server URL for production
// let serverURL = "https://pertime-staging.vercel.app" // server URL for dev environment
// let serverURL = "http://localhost:3000" // server URL for dev environment


var serverURL = "https://pertime.expertizo.co";
console.log("Server URL: ", serverURL);

// server URL for staging envionment
if (window.location.hostname === "localhost") {
  serverURL;
}
/* harmony default export */ __webpack_exports__["o"] = ({ serverURL: serverURL });

// Regular expression to find only numbers
var numberRegex = /^(-?\d+\.\d+)$|^(-?\d+)$/gm;

var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var monthShortNames = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec"
};

var monthMap = {
  "January": 1, "February": 2, "March": 3, "April": 4,
  "May": 5, "June": 6, "July": 7, "August": 8,
  "September": 9, "October": 10, "November": 11, "December": 12
};

var lateRules = [{ minLates: 30, leaveDeductionDays: 2, lateDeductionDays: 4, totalLatesCount: 6 }, { minLates: 25, leaveDeductionDays: 2, lateDeductionDays: 3, totalLatesCount: 5 }, { minLates: 20, leaveDeductionDays: 2, lateDeductionDays: 2, totalLatesCount: 4 }, { minLates: 15, leaveDeductionDays: 2, lateDeductionDays: 1, totalLatesCount: 3 }, { minLates: 10, leaveDeductionDays: 2, lateDeductionDays: 0, totalLatesCount: 2 }, { minLates: 5, leaveDeductionDays: 1, lateDeductionDays: 0, totalLatesCount: 1 }];
var deductionRules = [{ minLates: 30, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 6, '>=1,<2': 5 } }, { minLates: 25, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 5, '>=1,<2': 4 } }, { minLates: 20, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 4, '>=1,<2': 3 } }, { minLates: 15, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 3, '>=1,<2': 2 } }, { minLates: 10, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 2, '>=1,<2': 1 } }, { minLates: 5, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 1, '>=1,<2': 0 } }, { minLates: 0, leaveDeduction: { '<1': 0, '>=1,<2': 0 }, lateDeduction: { '<1': 0, '>=1,<2': 0 } }];

var newLateThresholds = [{ min: 30, salaryDeduct: 4, leaveDeduct: 2 }, { min: 25, salaryDeduct: 3, leaveDeduct: 2 }, { min: 20, salaryDeduct: 2, leaveDeduct: 2 }, { min: 15, salaryDeduct: 1, leaveDeduct: 2 }, { min: 10, salaryDeduct: 0, leaveDeduct: 2 }, { min: 5, salaryDeduct: 0, leaveDeduct: 1 }];

var leaveEncashmentDecRule = { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3 };
var leavesCarryForwardDecRule = { 2: 1, 3: 1, 4: 2, 5: 2 };

var appTrelloLabels = ["High Priority", "General", "Personal"];
var cardIdentifier = "expertizo.pk";

var halfDay = 0.5;



var STATIC_TEMPLATES = [{
  id: 1,
  dbId: null,
  title: "Probation Status Email",
  description: "Sent when employee is placed on probation",
  subject: "Probation Period - [Employee Name]",
  body: "Dear [Employee Name],\n\nWe are pleased to inform you that you have been placed on probation status.\n\nPrevious Employment Status: [Old Status]\nNew Employment Status: Probation\nEffective Date: [Current Date]\nUpdated Time: [Current Time]\n\nDuring your probation period:\n- Your performance will be evaluated regularly\n- You will receive guidance and support from your supervisor\n- You are expected to meet the performance objectives outlined in your role\n- Probation period is typically 90 days\n\nBest regards,\nHR Management System",
  variables: [{ label: "Employee Name", value: "[Employee Name]" }, { label: "Current Date", value: "[Current Date]" }, { label: "Current Time", value: "[Current Time]" }, { label: "Old Status", value: "[Old Status]" }, { label: "New Status", value: "[New Status]" }]
}, {
  id: 2,
  dbId: null,
  title: "Permanent Status Confirmation",
  description: "Sent when employee becomes permanent",
  subject: "Employment Status Updated to Permanent - [Employee Name]",
  body: "Dear [Employee Name],\n\nCongratulations! Your employment status has been updated to Permanent.\n\nPrevious Employment Status: [Old Status]\nNew Employment Status: [New Status]\nEffective Date: [Current Date]\nUpdated Time: [Current Time]\n\nYou now have [New Leaves] leaves available for this year.\n\nBest regards,\nHR Management System",
  variables: [{ label: "Employee Name", value: "[Employee Name]" }, { label: "Current Date", value: "[Current Date]" }, { label: "Current Time", value: "[Current Time]" }, { label: "Old Status", value: "[Old Status]" }, { label: "New Status", value: "[New Status]" }, { label: "New Leaves", value: "[New Leaves]" }]
}, {
  id: 3,
  dbId: null,
  title: "Resignation Acceptance Email",
  description: "Sent when an employee resignation is accepted",
  subject: "Resignation Acceptance - [Employee Name]",
  body: "Dear [Employee Name],\n\nThis letter confirms that your resignation has been accepted.\n\nEmployee Name: [Employee Name]\nPrevious Employment Status: [Old Status]\nNew Status: [New Status]\nResignation Approval Date: [Approval Date]\nNotice Period: [Notice Period Days] days (based on [Old Status] status)\nLast Working Date: [Last Working Date]\n\nDuring your notice period, please ensure:\n- Complete all pending assignments and handover documentation\n- Return all company property (ID card, laptop, access cards, etc.)\n- Complete exit formalities with HR\n- Provide updated contact information for future correspondence\n\nYour final settlement, including pending salary and benefits, will be processed after your last working day.\n\nWe appreciate your contributions during your tenure and wish you success in your future endeavors.\n\nBest regards,\nHR Management System",
  variables: [{ label: "Employee Name", value: "[Employee Name]" }, { label: "Current Date", value: "[Current Date]" }, { label: "Current Time", value: "[Current Time]" }, { label: "Old Status", value: "[Old Status]" }, { label: "New Status", value: "[New Status]" }, { label: "Approval Date", value: "[Approval Date]" }, { label: "Last Working Date", value: "[Last Working Date]" }, { label: "Notice Period Days", value: "[Notice Period Days]" }]
}, {
  id: 4,
  dbId: null,
  title: "Termination Notice Email",
  description: "Sent when an employee is terminated",
  subject: "Employment Termination Notice - [Employee Name]",
  body: "Dear [Employee Name],\n\nWe regret to inform you that your employment with our organization has been terminated effective [Current Date].\n\nEmployee Name: [Employee Name]\nPrevious Employment Status: [Old Status]\nNew Status: [New Status]\nTermination Date: [Current Date]\nLast Working Date: [Current Date]\n\nThis decision has been made after careful consideration and in accordance with company policies.\n\nPlease take note of the following:\n- Your access to company systems and facilities will be deactivated effective immediately\n- Please return all company property (ID card, laptop, access cards, documents, etc.) by end of business today\n- Contact HR to complete exit formalities and final settlement procedures\n- Your final settlement, including pending salary and applicable benefits, will be processed as per company policy\n\nAn HR representative will contact you regarding the exit process and final settlement details.\nWe wish you the best in your future endeavors.\n\nBest regards,\nHR Management System",
  variables: [{ label: "Employee Name", value: "[Employee Name]" }, { label: "Current Date", value: "[Current Date]" }, { label: "Current Time", value: "[Current Time]" }, { label: "Old Status", value: "[Old Status]" }, { label: "New Status", value: "[New Status]" }]
}, {
  id: 5,
  dbId: null,
  title: "New Note Notification Email",
  description: "Sent when an regular note is added to employee record",
  subject: "New Note Added to Your Employee Record - [Employee Name]",
  body: "Dear [Employee Name],\n\nA new note has been added to your employee record.\n\nEmployee: [Employee Name]\nAdded By: [Admin Name]\nDate: [Current Date]\nTime: [Current Time]\nNote Content: [Note Text]\n\nYou can view the complete note and your employee details in the HR Management System.\nIf you have any questions or concerns about this note, please contact HR.\n\nBest regards,\nHR Management System",
  variables: [{ label: "Employee Name", value: "[Employee Name]" }, { label: "Current Date", value: "[Current Date]" }, { label: "Current Time", value: "[Current Time]" }, { label: "Admin Name", value: "[Admin Name]" }, { label: "Note Text", value: "[Note Text]" }]
}, {
  id: 6,
  dbId: null,
  title: "Salary Increase Notification Email",
  description: "Sent when a salary increase note is added to employee record",
  subject: "Salary Increment Notification - [Employee Name]",
  body: "Dear [Employee Name],\n\nCongratulations! We are pleased to inform you that your salary has been increased.\n\nEmployee: [Employee Name]\nEffective Date: [Effective Date]\nUpdated Time: [Current Time]\nSalary Details:\nPrevious Salary: [Old Salary]\nNew Salary: [New Salary]\nIncrement Amount: [Increment Amount]\nIncrement Percentage: [Increment Percentage]%\nNote from Management: [Note Text]\n\nThis salary increment reflects your valuable contributions, dedication, and excellent performance. We appreciate your continued commitment to the organization and look forward to your ongoing success.\n\nYour updated salary will be reflected in your payroll starting from the effective date mentioned above.\n\nIf you have any questions regarding this increment, please contact HR.\n\nCongratulations once again!\n\nBest regards,\nHR Management System",
  variables: [{ label: "Employee Name", value: "[Employee Name]" }, { label: "Effective Date", value: "[Effective Date]" }, { label: "Current Time", value: "[Current Time]" }, { label: "Admin Name", value: "[Admin Name]" }, { label: "Note Text", value: "[Note Text]" }, { label: "Old Salary", value: "[Old Salary]" }, { label: "New Salary", value: "[New Salary]" }, { label: "Increment Amount", value: "[Increment Amount]" }, { label: "Increment Percentage", value: "[Increment Percentage]" }, { label: "Effective Date", value: "[Effective Date]" }]
}];
// Used until an admin sets a Company Policy URL in Settings > General Settings
var DEFAULT_POLICY_URL = "https://docs.google.com/document/d/18vAouRMNTxXOurNbEmDsGmWDG8romvkriYaVBhmC4qY/preview";

/***/ }),

/***/ "gd4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeDropdown_vue__ = __webpack_require__("qmBs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78189b8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeDropdown_vue__ = __webpack_require__("X1E9");
function injectStyle (ssrContext) {
  __webpack_require__("eQcZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78189b8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78189b8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "guQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_auth__ = __webpack_require__("dih4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_storage__ = __webpack_require__("cWbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_assets_config_api__ = __webpack_require__("IFYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);









var _this = this;

var fetchManualHoursActivities = function () {
  var _ref30 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee30(month, year, userId) {
    var months, selectMonthNum, startTime, endTime, ref, query, response, value, activities;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.prev = 0;
            months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            selectMonthNum = months.indexOf(month);

            if (!(selectMonthNum === -1)) {
              _context30.next = 6;
              break;
            }

            console.error("Invalid month provided:", month);
            return _context30.abrupt("return", []);

          case 6:
            startTime = new Date(year, selectMonthNum, 1, 0, 0, 0).getTime();
            endTime = new Date(year, selectMonthNum + 1, 0, 23, 59, 59).getTime();
            ref = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("adminActivities");
            query = ref.orderByChild("timestamp").startAt(new Date(startTime).toISOString()).endAt(new Date(endTime).toISOString());

            if (userId) {
              query = ref.orderByChild("activityOnUser").equalTo(userId);
            }
            _context30.next = 13;
            return query.once("value");

          case 13:
            response = _context30.sent;
            value = response.val();
            activities = [];

            if (value) {
              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(value).forEach(function (key) {
                if (value[key].type === "manual_hours" && (!userId || value[key].activityOnUser === userId)) {
                  activities.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, value[key], { activityKey: key }));
                }
              });
            }
            return _context30.abrupt("return", activities);

          case 20:
            _context30.prev = 20;
            _context30.t0 = _context30["catch"](0);

            console.error("Error fetching manual hours activities:", _context30.t0);
            return _context30.abrupt("return", []);

          case 24:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, this, [[0, 20]]);
  }));

  return function fetchManualHoursActivities(_x48, _x49, _x50) {
    return _ref30.apply(this, arguments);
  };
}();

var fetchAdminActivities = function () {
  var _ref31 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee31(month, year) {
    var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var cardId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var activityType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var parseTimestamp, months, monthIndex, startDate, endDate, ref, snapshot, data, result;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.prev = 0;

            parseTimestamp = function parseTimestamp(ts) {
              if (!ts || typeof ts !== "string") return null;
              if (ts.includes(", ")) {
                var _ts$split = ts.split(", "),
                    _ts$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ts$split, 2),
                    datePart = _ts$split2[0],
                    timePartRaw = _ts$split2[1];

                var _datePart$split = datePart.split("/"),
                    _datePart$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_datePart$split, 3),
                    d = _datePart$split2[0],
                    m = _datePart$split2[1],
                    y = _datePart$split2[2];

                if (!d || !m || !y) return null;
                var timePart = timePartRaw.toUpperCase().replace(/\s*(AM|PM)$/, ' $1');
                var isoStr = y + "-" + m.padStart(2, '0') + "-" + d.padStart(2, '0') + " " + timePart;
                var _t = new Date(isoStr);
                return isNaN(_t) ? null : _t.getTime();
              }
              var t = new Date(ts);
              return isNaN(t) ? null : t.getTime();
            };

            months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            monthIndex = months.indexOf(month);

            if (!(monthIndex === -1)) {
              _context31.next = 6;
              break;
            }

            return _context31.abrupt("return", []);

          case 6:
            startDate = new Date(year, monthIndex, 1);
            endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59, 999);
            ref = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("adminActivities");
            _context31.next = 11;
            return ref.once("value");

          case 11:
            snapshot = _context31.sent;
            data = snapshot.val();

            if (data) {
              _context31.next = 15;
              break;
            }

            return _context31.abrupt("return", []);

          case 15:
            result = [];

            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
              var act = data[key];

              // Only fetch types other than manual_hours
              if (act.type === "manual_hours") {
                console.log("Skipping manual_hours in universal fetch:", key);
                return;
              }

              if (activityType && (!act.type || act.type.toLowerCase() !== activityType.toLowerCase())) {
                console.log("Skipping due to type mismatch:", key, act.type);
                return;
              }

              if (act.month !== month || String(act.year) !== String(year)) return;

              if (userId && act.activityOnUser !== userId) return;
              if (cardId && act.cardId !== cardId) return;

              var actTime = parseTimestamp(act.timestamp);
              var actDate = actTime ? new Date(actTime) : null;

              result.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
                activityKey: key
              }, act, {
                readableDate: actDate ? actDate.toLocaleString() : act.timestamp
              }));
            });

            result.sort(function (a, b) {
              var timeA = parseTimestamp(a.timestamp) || 0;
              var timeB = parseTimestamp(b.timestamp) || 0;
              return timeA - timeB;
            });
            return _context31.abrupt("return", result);

          case 21:
            _context31.prev = 21;
            _context31.t0 = _context31["catch"](0);

            console.error("Error fetching universal activities:", _context31.t0);
            return _context31.abrupt("return", []);

          case 25:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31, this, [[0, 21]]);
  }));

  return function fetchAdminActivities(_x51, _x52) {
    return _ref31.apply(this, arguments);
  };
}();
// Wrapper for performance


var fetchPerformanceActivities = function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee32(month, year, userId) {
    var cardId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return fetchAdminActivities(month, year, userId, cardId, "performance_edit");

          case 2:
            return _context32.abrupt("return", _context32.sent);

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32, this);
  }));

  return function fetchPerformanceActivities(_x56, _x57, _x58) {
    return _ref32.apply(this, arguments);
  };
}();

var constants = function () {
  var _ref36 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee36() {
    var response, value;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.prev = 0;
            _context36.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants").once("value");

          case 3:
            response = _context36.sent;
            value = response.val();

            if (value) {
              _context36.next = 8;
              break;
            }

            console.warn("Constants not found, returning default values");
            return _context36.abrupt("return", { days: [], totalHours: 0, late: "11:00" });

          case 8:
            console.log("Constants fetched:", value);
            return _context36.abrupt("return", value);

          case 12:
            _context36.prev = 12;
            _context36.t0 = _context36["catch"](0);

            console.error("Error fetching constants:", _context36.t0);
            return _context36.abrupt("return", { days: [], totalHours: 0, late: "11:00" });

          case 16:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, this, [[0, 12]]);
  }));

  return function constants() {
    return _ref36.apply(this, arguments);
  };
}();

var fetchTaxSlabs = function () {
  var _ref44 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee42() {
    var response, value;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.prev = 0;
            _context42.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/taxSlabs").once("value");

          case 3:
            response = _context42.sent;
            value = response.val();

            if (!value) {
              console.warn("Tax slabs not found, returning default values");
            }
            return _context42.abrupt("return", value);

          case 9:
            _context42.prev = 9;
            _context42.t0 = _context42["catch"](0);

            console.error("Error fetching tax slabs:", _context42.t0);

          case 12:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42, this, [[0, 9]]);
  }));

  return function fetchTaxSlabs() {
    return _ref44.apply(this, arguments);
  };
}();

var logPerformanceChange = function () {
  var _ref45 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee43(changeData) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.prev = 0;
            _context43.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('performanceChanges').push(changeData);

          case 3:
            _context43.next = 9;
            break;

          case 5:
            _context43.prev = 5;
            _context43.t0 = _context43["catch"](0);

            console.error('Error logging performance change:', _context43.t0);
            throw _context43.t0;

          case 9:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43, this, [[0, 5]]);
  }));

  return function logPerformanceChange(_x69) {
    return _ref45.apply(this, arguments);
  };
}();








var auth = void 0;
var db = void 0;

var firebaseConfig = {
  apiKey: "AIzaSyB0Ypp3yy7XAelcrpiyijVjxfnhjSV31AE",
  authDomain: "link-assignment.firebaseapp.com",
  databaseURL: "https://link-assignment.firebaseio.com",
  projectId: "link-assignment",
  storageBucket: "link-assignment.appspot.com",
  messagingSenderId: "853589186002",
  appId: "1:853589186002:web:e1af579125195ba55b640b"
};

var configuredAppForReportBug = function configuredAppForReportBug(config) {
  if (!__WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.apps.length) {
    __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.initializeApp(config || firebaseConfig);
  }
  return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.apps[0];
};

var checkAlreadyConfiguredApp = function checkAlreadyConfiguredApp() {
  return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.apps[0];
};

var configureFirebase = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.initializeApp(config);
            auth = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth();
            db = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database();

            return _context.abrupt("return", { message: "Firebase configured successfully" });

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            throw _context.t0;

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 7]]);
  }));

  return function configureFirebase(_x) {
    return _ref.apply(this, arguments);
  };
}();

var unconfigureFirebase = function unconfigureFirebase() {
  return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.apps[0].delete();
};

var login = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(credentials) {
    var loginResponse, dbResponse;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().signInWithEmailAndPassword(credentials.email, credentials.password);

          case 3:
            loginResponse = _context2.sent;
            _context2.next = 6;
            return readDatabase("users/" + loginResponse.user.uid);

          case 6:
            dbResponse = _context2.sent;
            return _context2.abrupt("return", dbResponse);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            throw _context2.t0;

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[0, 10]]);
  }));

  return function login(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var readDatabase = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(path) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path).once("value");

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", { key: response.key, data: response.val() });

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw _context3.t0;

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 7]]);
  }));

  return function readDatabase(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var updateDatabase = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(path, data) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path).update(data));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function updateDatabase(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var uploadImage = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5(path, dataurl) {
    var name, ref, downloadURL;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            name = Math.random().toString().split(".")[1];
            ref = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.storage().ref(path + "/" + name);
            _context5.next = 5;
            return ref.putString(dataurl, "data_url");

          case 5:
            _context5.next = 7;
            return ref.getDownloadURL();

          case 7:
            downloadURL = _context5.sent;
            return _context5.abrupt("return", downloadURL);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](0);
            throw _context5.t0;

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, _this, [[0, 11]]);
  }));

  return function uploadImage(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();
var pushDatabase = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6(path, data) {
    var newRef;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            newRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path).push();
            _context6.next = 4;
            return newRef.set(data);

          case 4:
            return _context6.abrupt("return", {
              key: newRef.key,
              path: newRef.toString(),
              data: data
            });

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);

            console.error("Error pushing data:", _context6.t0);
            throw _context6.t0;

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, _this, [[0, 7]]);
  }));

  return function pushDatabase(_x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();
var reAuthenticateUserFirebase = function reAuthenticateUserFirebase(c) {
  var user = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().currentUser;
  var credential = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth.EmailAuthProvider.credential(c.email, c.password);

  return user.reauthenticateAndRetrieveDataWithCredential(credential);
};

var updatePasswordFirebase = function updatePasswordFirebase(newPassword) {
  var user = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().currentUser;

  return user.updatePassword(newPassword);
};

var logout = function logout() {
  return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().signOut();
};
var updateUserActiveStatus = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7(status, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({ isActive: status });

          case 3:
            _context7.next = 9;
            break;

          case 5:
            _context7.prev = 5;
            _context7.t0 = _context7["catch"](0);

            console.error("Error updating status:", _context7.t0);
            swal("Oops!", "Failed to update status", "error");

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, _this, [[0, 5]]);
  }));

  return function updateUserActiveStatus(_x10, _x11) {
    return _ref7.apply(this, arguments);
  };
}();
var createOrUpdateQuarterlyMeetingDetails = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8(details, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({ nextQuarterlyMeetingDetails: details, nextQuarterlyMeeting: null });

          case 3:
            _context8.next = 9;
            break;

          case 5:
            _context8.prev = 5;
            _context8.t0 = _context8["catch"](0);

            console.error("Error updating quarterly meeting details:", _context8.t0);
            swal("Oops!", "Failed to update quarterly meeting details", "error");

          case 9:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, _this, [[0, 5]]);
  }));

  return function createOrUpdateQuarterlyMeetingDetails(_x12, _x13) {
    return _ref8.apply(this, arguments);
  };
}();
var createOrUpdateIncrementMeetingDetails = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9(details, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({ nextIncrementMeetingDetails: details, nextIncrementReview: null });

          case 3:
            _context9.next = 9;
            break;

          case 5:
            _context9.prev = 5;
            _context9.t0 = _context9["catch"](0);

            console.error("Error updating increment meeting details:", _context9.t0);
            swal("Oops!", "Failed to update increment meeting details", "error");

          case 9:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, _this, [[0, 5]]);
  }));

  return function createOrUpdateIncrementMeetingDetails(_x14, _x15) {
    return _ref9.apply(this, arguments);
  };
}();
var deleteQuarterlyMeetingDetails = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10(userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({
              nextQuarterlyMeetingDetails: null,
              nextQuarterlyMeeting: null
            });

          case 3:
            _context10.next = 9;
            break;

          case 5:
            _context10.prev = 5;
            _context10.t0 = _context10["catch"](0);

            console.error("Error deleting quarterly meeting details:", _context10.t0);
            swal("Oops!", "Failed to delete quarterly meeting details", "error");

          case 9:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[0, 5]]);
  }));

  return function deleteQuarterlyMeetingDetails(_x16) {
    return _ref10.apply(this, arguments);
  };
}();
var deleteIncrementMeetingDetails = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee11(userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({
              nextIncrementMeetingDetails: null,
              nextIncrementReview: null
            });

          case 3:
            _context11.next = 9;
            break;

          case 5:
            _context11.prev = 5;
            _context11.t0 = _context11["catch"](0);

            console.error("Error deleting increment meeting details:", _context11.t0);
            swal("Oops!", "Failed to delete increment meeting details", "error");

          case 9:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, _this, [[0, 5]]);
  }));

  return function deleteIncrementMeetingDetails(_x17) {
    return _ref11.apply(this, arguments);
  };
}();

var updateUserStatus = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee12(status, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({ status: status });

          case 3:
            _context12.next = 8;
            break;

          case 5:
            _context12.prev = 5;
            _context12.t0 = _context12["catch"](0);
            throw new Error('Failed to update status: ' + _context12.t0.message);

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, _this, [[0, 5]]);
  }));

  return function updateUserStatus(_x18, _x19) {
    return _ref12.apply(this, arguments);
  };
}();
var updateUserPreviousStatus = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee13(previousStatus, uid) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + uid).update({ previousStatus: previousStatus });

          case 3:
            _context13.next = 8;
            break;

          case 5:
            _context13.prev = 5;
            _context13.t0 = _context13["catch"](0);
            throw new Error('Failed to update status: ' + _context13.t0.message);

          case 8:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, _this, [[0, 5]]);
  }));

  return function updateUserPreviousStatus(_x20, _x21) {
    return _ref13.apply(this, arguments);
  };
}();

var updateUserResignationDate = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee14(date, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({ resignationDate: date });

          case 3:
            _context14.next = 8;
            break;

          case 5:
            _context14.prev = 5;
            _context14.t0 = _context14["catch"](0);
            throw new Error('Failed to update resignation date: ' + _context14.t0.message);

          case 8:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, _this, [[0, 5]]);
  }));

  return function updateUserResignationDate(_x22, _x23) {
    return _ref14.apply(this, arguments);
  };
}();
var updateUserLeaves = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee15(userId, leavesData) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({
              leavesAllowed: leavesData.leavesAllowed,
              leavesTaken: leavesData.leavesTaken,
              leavesAvailable: leavesData.leavesAvailable
            });

          case 3:
            return _context15.abrupt("return", { message: "Leaves updated successfully" });

          case 6:
            _context15.prev = 6;
            _context15.t0 = _context15["catch"](0);

            console.error("Error updating leaves: ", _context15.t0);
            throw new Error("Failed to update leaves: " + _context15.t0.message);

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, _this, [[0, 6]]);
  }));

  return function updateUserLeaves(_x24, _x25) {
    return _ref15.apply(this, arguments);
  };
}();

var updateEmployee = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee16(data, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update(data);

          case 3:
            _context16.next = 9;
            break;

          case 5:
            _context16.prev = 5;
            _context16.t0 = _context16["catch"](0);

            console.error("Error updating employee: ", _context16.t0);
            swal("Oops!", _context16.t0.message, "error");

          case 9:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, _this, [[0, 5]]);
  }));

  return function updateEmployee(_x26, _x27) {
    return _ref16.apply(this, arguments);
  };
}();

var deletePromotionInfo = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee17(userId, index) {
    var userRef, snapshot, promotionInfo;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            userRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId);
            _context17.next = 4;
            return userRef.child('promotionInfo').once('value');

          case 4:
            snapshot = _context17.sent;
            promotionInfo = snapshot.val() || [];

            promotionInfo.splice(index, 1);

            _context17.next = 9;
            return userRef.child('promotionInfo').set(promotionInfo);

          case 9:

            console.log('Promotion info deleted successfully');
            _context17.next = 15;
            break;

          case 12:
            _context17.prev = 12;
            _context17.t0 = _context17["catch"](0);

            console.error('Error deleting promotion info:', _context17.t0);

          case 15:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, _this, [[0, 12]]);
  }));

  return function deletePromotionInfo(_x28, _x29) {
    return _ref17.apply(this, arguments);
  };
}();

var deleteEmployee = function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee18(userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).remove(function () {
              swal("Great", "User Deleted Successfully", "success");
            });

          case 3:
            _context18.next = 9;
            break;

          case 5:
            _context18.prev = 5;
            _context18.t0 = _context18["catch"](0);

            console.error("Error deleting user: ", _context18.t0);
            swal("Oops!", _context18.t0.message, "error");

          case 9:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, _this, [[0, 5]]);
  }));

  return function deleteEmployee(_x30) {
    return _ref18.apply(this, arguments);
  };
}();
var addEmployee = function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee19(data) {
    var newEmployeeRef, userId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            newEmployeeRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('users').push();
            userId = newEmployeeRef.key;
            _context19.next = 5;
            return newEmployeeRef.set(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              uid: userId,
              createdAt: Date.now()
            }));

          case 5:

            swal("Great", "Employee added successfully", "success");

            return _context19.abrupt("return", { uid: userId });

          case 9:
            _context19.prev = 9;
            _context19.t0 = _context19["catch"](0);

            console.error("Error adding employee: ", _context19.t0);
            swal("Oops!", _context19.t0.message || "Failed to add employee", "error");

          case 13:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, _this, [[0, 9]]);
  }));

  return function addEmployee(_x31) {
    return _ref19.apply(this, arguments);
  };
}();

var getEmailTemplates = function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee20() {
    var snapshot;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;
            _context20.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/emailTemplates').once('value');

          case 3:
            snapshot = _context20.sent;
            return _context20.abrupt("return", snapshot.val() || {});

          case 7:
            _context20.prev = 7;
            _context20.t0 = _context20["catch"](0);

            console.error("Error fetching templates:", _context20.t0);
            return _context20.abrupt("return", []);

          case 11:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, _this, [[0, 7]]);
  }));

  return function getEmailTemplates() {
    return _ref20.apply(this, arguments);
  };
}();

var addEmailTemplate = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee21(data) {
    var templateRef, templateId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;
            templateRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/emailTemplates').push();
            templateId = templateRef.key;
            _context21.next = 5;
            return templateRef.set(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              id: templateId,
              updatedAt: Date.now()
            }));

          case 5:
            return _context21.abrupt("return", { id: templateId });

          case 8:
            _context21.prev = 8;
            _context21.t0 = _context21["catch"](0);

            console.error("Error saving email template: ", _context21.t0);
            swal("Oops!", _context21.t0.message || "Failed to save email template", "error");

          case 12:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, _this, [[0, 8]]);
  }));

  return function addEmailTemplate(_x32) {
    return _ref21.apply(this, arguments);
  };
}();

var updateEmailTemplate = function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee22(templateId, data) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            _context22.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/emailTemplates/" + templateId).update(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              updatedAt: Date.now()
            }));

          case 3:
            _context22.next = 9;
            break;

          case 5:
            _context22.prev = 5;
            _context22.t0 = _context22["catch"](0);

            console.error("Error updating email template: ", _context22.t0);
            swal("Oops!", _context22.t0.message || "Failed to update email template", "error");

          case 9:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, _this, [[0, 5]]);
  }));

  return function updateEmailTemplate(_x33, _x34) {
    return _ref22.apply(this, arguments);
  };
}();

var fetchCompanyData = function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee23(userEmail) {
    var response, company;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.prev = 0;

            if (userEmail) {
              _context23.next = 3;
              break;
            }

            return _context23.abrupt("return");

          case 3:
            _context23.next = 5;
            return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_api__["a" /* default */].findCompanyByEmail(userEmail);

          case 5:
            response = _context23.sent;
            company = Array.isArray(response) && response.length > 0 ? response[0] : null;

            if (!company) {
              _context23.next = 9;
              break;
            }

            return _context23.abrupt("return", company);

          case 9:
            _context23.next = 14;
            break;

          case 11:
            _context23.prev = 11;
            _context23.t0 = _context23["catch"](0);

            console.error("Failed to fetch company data:", _context23.t0);

          case 14:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, _this, [[0, 11]]);
  }));

  return function fetchCompanyData(_x35) {
    return _ref23.apply(this, arguments);
  };
}();
var fetchAllUsersRealTime = function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee24() {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users").on("value", function (snapshot) {
              var usersData = snapshot.val();
              if (usersData) {
                var allUsers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(usersData).map(function (userKey) {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, usersData[userKey], {
                    uid: userKey
                  });
                });
                _this.$store.commit("setAllUsers", allUsers);
              } else {
                console.log("No users data found.");
              }
            });

          case 1:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, _this);
  }));

  return function fetchAllUsersRealTime() {
    return _ref24.apply(this, arguments);
  };
}();

var submitLeave = function () {
  var _ref25 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee25(path, data) {
    var res;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.prev = 0;
            _context25.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path).push(data);

          case 3:
            res = _context25.sent;

            if (!res) {
              _context25.next = 6;
              break;
            }

            return _context25.abrupt("return", { message: "Leave submitted successfully", res: res });

          case 6:
            _context25.next = 11;
            break;

          case 8:
            _context25.prev = 8;
            _context25.t0 = _context25["catch"](0);

            console.log("error agaaya bhai ", _context25.t0);

          case 11:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, _this, [[0, 8]]);
  }));

  return function submitLeave(_x36, _x37) {
    return _ref25.apply(this, arguments);
  };
}();

var getSingleUser = function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee26(userId) {
    var snapshot;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.prev = 0;
            _context26.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).once("value");

          case 3:
            snapshot = _context26.sent;

            if (!snapshot.exists()) {
              _context26.next = 8;
              break;
            }

            return _context26.abrupt("return", snapshot.val());

          case 8:
            console.error("User not found:", userId);
            return _context26.abrupt("return", null);

          case 10:
            _context26.next = 16;
            break;

          case 12:
            _context26.prev = 12;
            _context26.t0 = _context26["catch"](0);

            console.error("Error fetching user data: ", _context26.t0);
            throw _context26.t0;

          case 16:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, _this, [[0, 12]]);
  }));

  return function getSingleUser(_x38) {
    return _ref26.apply(this, arguments);
  };
}();

var updateLeaveStatusAndComment = function () {
  var _ref27 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee27(leaveId, status, userId) {
    var comment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var leavesTaken = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var updates, res;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.prev = 0;
            updates = {
              status: status,
              comment: comment
            };
            _context27.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("leaves/" + leaveId).update(updates);

          case 4:
            if (!(leavesTaken !== null)) {
              _context27.next = 8;
              break;
            }

            _context27.next = 7;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({
              leavesTaken: leavesTaken
            });

          case 7:
            res = _context27.sent;

          case 8:
            _context27.next = 10;
            return getSingleUser();

          case 10:
            return _context27.abrupt("return", { message: "Leave updated successfully" });

          case 13:
            _context27.prev = 13;
            _context27.t0 = _context27["catch"](0);

            console.error("Error updating leave: ", _context27.t0);
            throw _context27.t0;

          case 17:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27, _this, [[0, 13]]);
  }));

  return function updateLeaveStatusAndComment(_x39, _x40, _x41) {
    return _ref27.apply(this, arguments);
  };
}();
var updateUserRole = function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee28(role, userId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            _context28.prev = 0;
            _context28.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({ role: role });

          case 3:
            _context28.next = 9;
            break;

          case 5:
            _context28.prev = 5;
            _context28.t0 = _context28["catch"](0);

            console.error("Error updating role:", _context28.t0);
            swal("Oops!", "Failed to update role", "error");

          case 9:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, _this, [[0, 5]]);
  }));

  return function updateUserRole(_x44, _x45) {
    return _ref28.apply(this, arguments);
  };
}();
var sendPasswordResetEmail = function () {
  var _ref29 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee29(email, resetUrl) {
    var actionCodeSettings;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.prev = 0;
            actionCodeSettings = {
              url: resetUrl,
              handleCodeInApp: true
            };
            _context29.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().sendPasswordResetEmail(email, actionCodeSettings);

          case 4:
            console.log("Password reset email sent.");
            _context29.next = 10;
            break;

          case 7:
            _context29.prev = 7;
            _context29.t0 = _context29["catch"](0);
            throw _context29.t0;

          case 10:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, _this, [[0, 7]]);
  }));

  return function sendPasswordResetEmail(_x46, _x47) {
    return _ref29.apply(this, arguments);
  };
}();

var ResetPassword = function () {
  var _ref33 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee33(oobCode, newPassword) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.prev = 0;
            _context33.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().confirmPasswordReset(oobCode, newPassword);

          case 3:
            _context33.next = 8;
            break;

          case 5:
            _context33.prev = 5;
            _context33.t0 = _context33["catch"](0);
            throw new Error(_context33.t0.message);

          case 8:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, _this, [[0, 5]]);
  }));

  return function ResetPassword(_x60, _x61) {
    return _ref33.apply(this, arguments);
  };
}();

var ResetCode = function () {
  var _ref34 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee34(oobCode) {
    var info;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            console.log("Starting ResetCode with oobCode:", oobCode);
            _context34.prev = 1;
            _context34.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().verifyPasswordResetCode(oobCode);

          case 4:
            info = _context34.sent;

            console.log("OOB code verification successful, returned email:", info);

            if (info) {
              _context34.next = 9;
              break;
            }

            console.error("No email returned from verifyPasswordResetCode");
            throw new Error("Invalid or expired password reset code.");

          case 9:
            return _context34.abrupt("return", info);

          case 12:
            _context34.prev = 12;
            _context34.t0 = _context34["catch"](1);

            console.error("Error in ResetCode:", _context34.t0);
            throw _context34.t0;

          case 16:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, _this, [[1, 12]]);
  }));

  return function ResetCode(_x62) {
    return _ref34.apply(this, arguments);
  };
}();

var updateLogTime = function () {
  var _ref35 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee35(logKey, updatedTimes) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            return _context35.abrupt("return", __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("timePeriod/" + logKey).update(updatedTimes));

          case 1:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, _this);
  }));

  return function updateLogTime(_x63, _x64) {
    return _ref35.apply(this, arguments);
  };
}();

var saveBugReport = function () {
  var _ref37 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee37(bugData) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.prev = 0;
            _context37.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('bugReported').push(bugData);

          case 3:
            _context37.next = 9;
            break;

          case 5:
            _context37.prev = 5;
            _context37.t0 = _context37["catch"](0);

            console.error(' Firebase error:', _context37.t0);
            throw _context37.t0;

          case 9:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37, _this, [[0, 5]]);
  }));

  return function saveBugReport(_x65) {
    return _ref37.apply(this, arguments);
  };
}();

var getAllBugReports = function () {
  var _ref38 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee38() {
    var snapshot, data;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            _context38.prev = 0;
            _context38.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('bugReported').once('value');

          case 3:
            snapshot = _context38.sent;

            if (snapshot.exists()) {
              _context38.next = 6;
              break;
            }

            return _context38.abrupt("return", []);

          case 6:
            data = snapshot.val();
            return _context38.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(data).map(function (id) {
              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
                id: id
              }, data[id]);
            }).reverse());

          case 10:
            _context38.prev = 10;
            _context38.t0 = _context38["catch"](0);

            console.error('Firebase error:', _context38.t0);
            throw _context38.t0;

          case 14:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38, _this, [[0, 10]]);
  }));

  return function getAllBugReports() {
    return _ref38.apply(this, arguments);
  };
}();

var updateBugStatus = function () {
  var _ref39 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee39(bugId) {
    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Resolved';
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            _context39.prev = 0;
            _context39.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("bugReported/" + bugId).update({
              status: status,
              updatedAt: Date.now()
            });

          case 3:
            _context39.next = 9;
            break;

          case 5:
            _context39.prev = 5;
            _context39.t0 = _context39["catch"](0);

            console.error('Firebase error:', _context39.t0);
            throw _context39.t0;

          case 9:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39, _this, [[0, 5]]);
  }));

  return function updateBugStatus(_x66) {
    return _ref39.apply(this, arguments);
  };
}();

var logAdminActivityToDB = function () {
  var _ref40 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee40(activityData) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            _context40.prev = 0;
            _context40.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('adminActivities').push(activityData);

          case 3:
            _context40.next = 9;
            break;

          case 5:
            _context40.prev = 5;
            _context40.t0 = _context40["catch"](0);

            console.error(' Firebase error:', _context40.t0);
            throw _context40.t0;

          case 9:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40, _this, [[0, 5]]);
  }));

  return function logAdminActivityToDB(_x68) {
    return _ref40.apply(this, arguments);
  };
}();
var getAllAdminActivities = function () {
  var _ref41 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee41() {
    var snapshot;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.prev = 0;
            _context41.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('adminActivities').once('value');

          case 3:
            snapshot = _context41.sent;

            if (snapshot.exists()) {
              _context41.next = 6;
              break;
            }

            return _context41.abrupt("return", []);

          case 6:
            return _context41.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(snapshot.val()).map(function (_ref42) {
              var _ref43 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref42, 2),
                  id = _ref43[0],
                  data = _ref43[1];

              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
                id: id
              }, data);
            }).reverse());

          case 9:
            _context41.prev = 9;
            _context41.t0 = _context41["catch"](0);

            console.error('Firebase error:', _context41.t0);
            throw _context41.t0;

          case 13:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41, _this, [[0, 9]]);
  }));

  return function getAllAdminActivities() {
    return _ref41.apply(this, arguments);
  };
}();

;

var fetchEditedCards = function () {
  var _ref46 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee44(_ref47) {
    var month = _ref47.month,
        year = _ref47.year,
        userId = _ref47.userId,
        boardId = _ref47.boardId;
    var snap, data;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.prev = 0;
            _context44.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance").once("value");

          case 3:
            snap = _context44.sent;
            data = snap.val() || {};
            return _context44.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data).reduce(function (acc, _ref48) {
              var _ref49 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref48, 2),
                  cardId = _ref49[0],
                  doc = _ref49[1];

              var match = (!month || doc.month === month) && (!year || doc.year === year) && (!userId || doc.user === userId) && (!boardId || doc.board === boardId);

              if (match) acc[cardId] = doc;
              return acc;
            }, {}));

          case 8:
            _context44.prev = 8;
            _context44.t0 = _context44["catch"](0);

            console.error("fetchEditedCards error:", _context44.t0);
            return _context44.abrupt("return", {});

          case 12:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44, _this, [[0, 8]]);
  }));

  return function fetchEditedCards(_x70) {
    return _ref46.apply(this, arguments);
  };
}();
var addPerformanceItem = function () {
  var _ref50 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee45(payload) {
    var cardId, record;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            cardId = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref().push().key;

            if (cardId) {
              _context45.next = 3;
              break;
            }

            throw new Error("cardId is required");

          case 3:
            record = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, payload, {
              cardId: cardId,
              id: cardId
            });
            _context45.prev = 4;
            _context45.next = 7;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance/" + cardId).set(record);

          case 7:
            return _context45.abrupt("return", cardId);

          case 10:
            _context45.prev = 10;
            _context45.t0 = _context45["catch"](4);

            console.error(" Failed to save performance card:", _context45.t0);
            throw _context45.t0;

          case 14:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45, _this, [[4, 10]]);
  }));

  return function addPerformanceItem(_x71) {
    return _ref50.apply(this, arguments);
  };
}();

var saveEditedCard = function () {
  var _ref51 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee46(payload) {
    var cardId, user, year, month, board, updatedData, originalData, status, isCustom, customEdit, type, reason, ticketStatus, filterKey, record;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            cardId = payload.cardId, user = payload.user, year = payload.year, month = payload.month, board = payload.board, updatedData = payload.updatedData, originalData = payload.originalData, status = payload.status, isCustom = payload.isCustom, customEdit = payload.customEdit, type = payload.type, reason = payload.reason, ticketStatus = payload.ticketStatus;
            filterKey = year + "-" + month + "-" + user + "-" + (board || 'null');
            record = {
              reason: reason || null,
              type: type || null,
              cardId: cardId,
              user: user,
              year: year,
              month: month,
              board: board || null,
              updatedData: updatedData,
              originalData: originalData,
              movedDate: payload.movedDate || null,
              movedTime: payload.movedTime || null,
              filterKey: filterKey,
              status: status,
              isCustom: isCustom || null,
              customEdit: customEdit || null,
              ticketStatus: ticketStatus || null,
              timestamp: __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database.ServerValue.TIMESTAMP
            };
            _context46.prev = 3;
            _context46.next = 6;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance/" + cardId).set(record);

          case 6:
            _context46.next = 12;
            break;

          case 8:
            _context46.prev = 8;
            _context46.t0 = _context46["catch"](3);

            console.error("\u274C Failed to save card " + cardId + ":", _context46.t0);
            throw _context46.t0;

          case 12:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46, _this, [[3, 8]]);
  }));

  return function saveEditedCard(_x72) {
    return _ref51.apply(this, arguments);
  };
}();

var saveApproveReject = function () {
  var _ref52 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee47(payload) {
    var cardId, updatedData, status, updates;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            cardId = payload.cardId, updatedData = payload.updatedData, status = payload.status;
            updates = {
              updatedData: updatedData,
              status: status,
              timestamp: __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database.ServerValue.TIMESTAMP
            };
            _context47.prev = 2;
            _context47.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance/" + cardId).update(updates);

          case 5:

            console.log("Card " + cardId + " updated \u2192 status: " + status);
            _context47.next = 12;
            break;

          case 8:
            _context47.prev = 8;
            _context47.t0 = _context47["catch"](2);

            console.error("Failed to update card " + cardId + ":", _context47.t0);
            throw _context47.t0;

          case 12:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, _this, [[2, 8]]);
  }));

  return function saveApproveReject(_x73) {
    return _ref52.apply(this, arguments);
  };
}();

var deleteEditedCard = function () {
  var _ref53 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee48(cardId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            _context48.prev = 0;
            _context48.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance/" + cardId).remove();

          case 3:
            console.log("\uD83D\uDDD1\uFE0F Card " + cardId + " deleted successfully.");
            _context48.next = 10;
            break;

          case 6:
            _context48.prev = 6;
            _context48.t0 = _context48["catch"](0);

            console.error("\u274C Failed to delete card " + cardId + ":", _context48.t0);
            throw _context48.t0;

          case 10:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48, _this, [[0, 6]]);
  }));

  return function deleteEditedCard(_x74) {
    return _ref53.apply(this, arguments);
  };
}();
var getAdjustments = function () {
  var _ref54 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee49() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var month = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var query, response, data;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            _context49.prev = 0;
            query = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("adjustments");
            _context49.next = 4;
            return query.once("value");

          case 4:
            response = _context49.sent;
            data = response.val();

            if (!data) {
              _context49.next = 8;
              break;
            }

            return _context49.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(data).map(function (key) {
              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
                id: key
              }, data[key]);
            }).filter(function (adj) {
              var yearMatch = !year || Number(adj.year) === Number(year);
              var monthMatch = !month || adj.month === month;
              var userMatch = !userId || adj.employeeId === userId;
              return yearMatch && monthMatch && userMatch;
            }));

          case 8:
            return _context49.abrupt("return", []);

          case 11:
            _context49.prev = 11;
            _context49.t0 = _context49["catch"](0);

            console.error("Error fetching adjustments:", _context49.t0);
            return _context49.abrupt("return", []);

          case 15:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49, _this, [[0, 11]]);
  }));

  return function getAdjustments() {
    return _ref54.apply(this, arguments);
  };
}();

var postAdjustment = function () {
  var _ref55 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee50(data) {
    var path, newRef;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.prev = 0;
            path = "adjustments";

            if (!data.id) {
              _context50.next = 9;
              break;
            }

            _context50.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path + "/" + data.id).update(data);

          case 5:
            swal("Great", "Adjustment updated successfully");
            return _context50.abrupt("return", { message: "Adjustment updated successfully", id: data.id });

          case 9:
            // Create new adjustment
            newRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path).push();
            _context50.next = 12;
            return newRef.set(data);

          case 12:
            swal("Great", "Adjustment created successfully");
            return _context50.abrupt("return", { message: "Adjustment created successfully", id: newRef.key });

          case 14:
            _context50.next = 21;
            break;

          case 16:
            _context50.prev = 16;
            _context50.t0 = _context50["catch"](0);

            swal("Error", "Something went wrong!", "error");
            console.error("Error posting adjustment:", _context50.t0);
            throw _context50.t0;

          case 21:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50, _this, [[0, 16]]);
  }));

  return function postAdjustment(_x78) {
    return _ref55.apply(this, arguments);
  };
}();
var deleteAdjustment = function () {
  var _ref56 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee51(id) {
    var path;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            _context51.prev = 0;
            path = "adjustments/" + id;
            _context51.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref(path).remove();

          case 4:
            swal("Great", "Adjustment deleted successfully");
            return _context51.abrupt("return", { message: "Adjustment deleted successfully" });

          case 8:
            _context51.prev = 8;
            _context51.t0 = _context51["catch"](0);

            swal("Error", "Failed to delete adjustment", "error");
            console.error("Error deleting adjustment:", _context51.t0);
            throw _context51.t0;

          case 13:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51, _this, [[0, 8]]);
  }));

  return function deleteAdjustment(_x79) {
    return _ref56.apply(this, arguments);
  };
}();

var getEmployeeApprovedLeaves = function () {
  var _ref57 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee52(employeeId, month, year) {
    var monthNumber, leavesRef, snapshot, leaves, approvedLeaves, allLeaveDates;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            monthNumber = String(new Date(month + " 1, " + year).getMonth() + 1).padStart(2, '0');
            leavesRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('leaves').orderByChild('userId').equalTo(employeeId);
            _context52.next = 4;
            return leavesRef.once('value');

          case 4:
            snapshot = _context52.sent;

            if (snapshot.exists()) {
              _context52.next = 7;
              break;
            }

            return _context52.abrupt("return", []);

          case 7:
            leaves = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(snapshot.val());
            approvedLeaves = leaves.filter(function (leave) {
              if (leave.status !== 'Approved') return false;
              if (!leave.startDate) return false;
              var parts = leave.startDate.split('-');
              return parts[1] === monthNumber && parts[0] === String(year);
            });
            allLeaveDates = approvedLeaves.flatMap(function (leave) {
              var start = new Date(leave.startDate);
              var end = new Date(leave.endDate);
              var dates = [];

              for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                var day = String(d.getDate()).padStart(2, '0');
                var _month = String(d.getMonth() + 1).padStart(2, '0');
                var _year = d.getFullYear();
                dates.push(day + "-" + _month + "-" + _year);
              }

              return dates;
            });
            return _context52.abrupt("return", allLeaveDates);

          case 11:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52, _this);
  }));

  return function getEmployeeApprovedLeaves(_x80, _x81, _x82) {
    return _ref57.apply(this, arguments);
  };
}();

var addHoliday = function () {
  var _ref58 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee53(data) {
    var newHolidayRef, holidayId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _context53.prev = 0;
            newHolidayRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/holidays').push();
            holidayId = newHolidayRef.key;
            _context53.next = 5;
            return newHolidayRef.set(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              uid: holidayId,
              createdAt: Date.now()
            }));

          case 5:
            return _context53.abrupt("return", { success: true, uid: holidayId });

          case 8:
            _context53.prev = 8;
            _context53.t0 = _context53["catch"](0);

            console.error("Error adding holiday: ", _context53.t0);
            swal("Oops!", _context53.t0.message || "Failed to add holiday", "error");

          case 12:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53, _this, [[0, 8]]);
  }));

  return function addHoliday(_x83) {
    return _ref58.apply(this, arguments);
  };
}();

var getAllHolidays = function () {
  var _ref59 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee54() {
    var snapshot, holidaysObj;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            _context54.prev = 0;
            _context54.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/holidays').once('value');

          case 3:
            snapshot = _context54.sent;
            holidaysObj = snapshot.val() || {};
            return _context54.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(holidaysObj).map(function (key) {
              return holidaysObj[key];
            }));

          case 8:
            _context54.prev = 8;
            _context54.t0 = _context54["catch"](0);

            console.error("Error fetching holidays: ", _context54.t0);
            swal("Oops!", _context54.t0.message || "Failed to fetch holidays", "error");
            return _context54.abrupt("return", []);

          case 13:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54, _this, [[0, 8]]);
  }));

  return function getAllHolidays() {
    return _ref59.apply(this, arguments);
  };
}();

var updateHoliday = function () {
  var _ref60 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee55(uid, data) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            _context55.prev = 0;

            if (uid) {
              _context55.next = 3;
              break;
            }

            throw new Error("Holiday ID is required");

          case 3:
            _context55.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/holidays/" + uid).update(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              updatedAt: Date.now()
            }));

          case 5:
            return _context55.abrupt("return", { success: true });

          case 8:
            _context55.prev = 8;
            _context55.t0 = _context55["catch"](0);

            console.error("Error updating holiday: ", _context55.t0);
            swal("Oops!", _context55.t0.message || "Failed to update holiday", "error");

          case 12:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55, _this, [[0, 8]]);
  }));

  return function updateHoliday(_x84, _x85) {
    return _ref60.apply(this, arguments);
  };
}();

var deleteHoliday = function () {
  var _ref61 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee56(uid) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            _context56.prev = 0;

            if (uid) {
              _context56.next = 3;
              break;
            }

            throw new Error("Holiday ID is required");

          case 3:
            _context56.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/holidays/" + uid).remove();

          case 5:
            return _context56.abrupt("return", { success: true });

          case 8:
            _context56.prev = 8;
            _context56.t0 = _context56["catch"](0);

            console.error("Error deleting holiday: ", _context56.t0);
            swal("Oops!", _context56.t0.message || "Failed to delete holiday", "error");

          case 12:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56, _this, [[0, 8]]);
  }));

  return function deleteHoliday(_x86) {
    return _ref61.apply(this, arguments);
  };
}();

var saveTrelloUser = function () {
  var _ref62 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee57(userId, username) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            _context57.next = 2;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("users/" + userId).update({
              trelloUsername: username
            });

          case 2:
            return _context57.abrupt("return", _context57.sent);

          case 3:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57, _this);
  }));

  return function saveTrelloUser(_x87, _x88) {
    return _ref62.apply(this, arguments);
  };
}();

var isPayrollProcessed = function () {
  var _ref63 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee58(year, month, employeeId) {
    var ref, snapshot, data, key;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            _context58.prev = 0;
            ref = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("payroll/" + year + "/" + month).orderByChild("employeeId").equalTo(employeeId);
            _context58.next = 4;
            return ref.once("value");

          case 4:
            snapshot = _context58.sent;

            if (snapshot.exists()) {
              _context58.next = 7;
              break;
            }

            return _context58.abrupt("return", false);

          case 7:
            data = snapshot.val();
            _context58.t0 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.keys(data);

          case 9:
            if ((_context58.t1 = _context58.t0()).done) {
              _context58.next = 15;
              break;
            }

            key = _context58.t1.value;

            if (!(data[key].status === "Processed")) {
              _context58.next = 13;
              break;
            }

            return _context58.abrupt("return", true);

          case 13:
            _context58.next = 9;
            break;

          case 15:
            return _context58.abrupt("return", false);

          case 18:
            _context58.prev = 18;
            _context58.t2 = _context58["catch"](0);

            console.error("Payroll fetch failed:", _context58.t2);
            return _context58.abrupt("return", false);

          case 22:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58, _this, [[0, 18]]);
  }));

  return function isPayrollProcessed(_x89, _x90, _x91) {
    return _ref63.apply(this, arguments);
  };
}();

var ApproveNewTicket = function () {
  var _ref64 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee59(ticketId, ticketStatus) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            _context59.prev = 0;
            _context59.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance/" + ticketId).update({ ticketStatus: "approved" });

          case 3:
            _context59.next = 9;
            break;

          case 5:
            _context59.prev = 5;
            _context59.t0 = _context59["catch"](0);

            console.error("Error updating ticket status:", _context59.t0);
            swal("Oops!", "Failed to update ticket status", "error");

          case 9:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59, _this, [[0, 5]]);
  }));

  return function ApproveNewTicket(_x92, _x93) {
    return _ref64.apply(this, arguments);
  };
}();

var fetchPerformanceLock = function () {
  var _ref65 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee60(year, month) {
    var key, ref, snap, data;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            _context60.prev = 0;
            key = year + "_" + month;
            ref = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance_locks/" + key);
            _context60.next = 5;
            return ref.once('value');

          case 5:
            snap = _context60.sent;
            data = snap.val() || {};
            return _context60.abrupt("return", { locked: data.locked || false, scheduledLockTime: data.scheduledLockTime || null, userIds: data.userIds || {} });

          case 10:
            _context60.prev = 10;
            _context60.t0 = _context60["catch"](0);

            console.error("Error fetching performance lock:", _context60.t0);
            throw _context60.t0;

          case 14:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60, _this, [[0, 10]]);
  }));

  return function fetchPerformanceLock(_x94, _x95) {
    return _ref65.apply(this, arguments);
  };
}();

var savePerformanceLock = function () {
  var _ref66 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee61(year, month, locked) {
    var scheduledTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var key, ref, data;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            _context61.prev = 0;
            key = year + "_" + month;
            ref = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance_locks/" + key);
            data = {
              locked: locked,
              scheduledLockTime: scheduledTime
            };
            _context61.next = 6;
            return ref.update(data);

          case 6:
            _context61.next = 12;
            break;

          case 8:
            _context61.prev = 8;
            _context61.t0 = _context61["catch"](0);

            console.error("Error saving performance lock:", _context61.t0);
            throw _context61.t0;

          case 12:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61, _this, [[0, 8]]);
  }));

  return function savePerformanceLock(_x96, _x97, _x98) {
    return _ref66.apply(this, arguments);
  };
}();

var removeUserFromLock = function () {
  var _ref67 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee62(year, month, userId) {
    var lockKey, lockRef;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.prev = 0;
            lockKey = year + "_" + month;
            lockRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance_locks/" + lockKey + "/userIds/" + userId);
            _context62.next = 5;
            return lockRef.remove();

          case 5:
            return _context62.abrupt("return", true);

          case 8:
            _context62.prev = 8;
            _context62.t0 = _context62["catch"](0);

            console.error("Failed to remove userId:", _context62.t0);
            throw _context62.t0;

          case 12:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62, _this, [[0, 8]]);
  }));

  return function removeUserFromLock(_x100, _x101, _x102) {
    return _ref67.apply(this, arguments);
  };
}();

var savePerformanceSnapshot = function () {
  var _ref68 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee63(snapshotArray) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, card, cardId;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            _context63.prev = 0;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context63.prev = 4;
            _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(snapshotArray);

          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context63.next = 16;
              break;
            }

            card = _step.value;
            cardId = card.cardId || card.id;

            if (cardId) {
              _context63.next = 11;
              break;
            }

            return _context63.abrupt("continue", 13);

          case 11:
            _context63.next = 13;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance/" + cardId).set(card);

          case 13:
            _iteratorNormalCompletion = true;
            _context63.next = 6;
            break;

          case 16:
            _context63.next = 22;
            break;

          case 18:
            _context63.prev = 18;
            _context63.t0 = _context63["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context63.t0;

          case 22:
            _context63.prev = 22;
            _context63.prev = 23;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 25:
            _context63.prev = 25;

            if (!_didIteratorError) {
              _context63.next = 28;
              break;
            }

            throw _iteratorError;

          case 28:
            return _context63.finish(25);

          case 29:
            return _context63.finish(22);

          case 30:
            return _context63.abrupt("return", true);

          case 33:
            _context63.prev = 33;
            _context63.t1 = _context63["catch"](0);

            console.error("Failed to save performance snapshot:", _context63.t1);
            throw _context63.t1;

          case 37:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63, _this, [[0, 33], [4, 18, 22, 30], [23,, 25, 29]]);
  }));

  return function savePerformanceSnapshot(_x103) {
    return _ref68.apply(this, arguments);
  };
}();

var savePerformanceUserId = function () {
  var _ref69 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee64(year, month, userId) {
    var lockKey, lockRef, snap, currentUserIds;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            _context64.prev = 0;
            lockKey = year + "_" + month;
            lockRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance_locks/" + lockKey + "/userIds");
            _context64.next = 5;
            return lockRef.once('value');

          case 5:
            snap = _context64.sent;
            currentUserIds = snap.val() || {};

            currentUserIds[userId] = true;
            _context64.next = 10;
            return lockRef.set(currentUserIds);

          case 10:
            return _context64.abrupt("return", true);

          case 13:
            _context64.prev = 13;
            _context64.t0 = _context64["catch"](0);

            console.error("Failed to save performance user ID:", _context64.t0);
            throw _context64.t0;

          case 17:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64, _this, [[0, 13]]);
  }));

  return function savePerformanceUserId(_x104, _x105, _x106) {
    return _ref69.apply(this, arguments);
  };
}();

var updatePerformanceLockUserFlag = function () {
  var _ref70 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee65(year, month, userId, isSaved) {
    var key, lockRef, snap, currentUserIds;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            _context65.prev = 0;
            key = year + "_" + month;
            lockRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("performance_locks/" + key + "/userIds");
            _context65.next = 5;
            return lockRef.once('value');

          case 5:
            snap = _context65.sent;
            currentUserIds = snap.val() || {};

            currentUserIds[userId] = isSaved;
            _context65.next = 10;
            return lockRef.set(currentUserIds);

          case 10:
            return _context65.abrupt("return", true);

          case 13:
            _context65.prev = 13;
            _context65.t0 = _context65["catch"](0);

            console.error("Failed to update user lock flag:", _context65.t0);
            throw _context65.t0;

          case 17:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65, _this, [[0, 13]]);
  }));

  return function updatePerformanceLockUserFlag(_x107, _x108, _x109, _x110) {
    return _ref70.apply(this, arguments);
  };
}();

var addPerformanceCriteria = function () {
  var _ref71 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee66(data) {
    var newCriteriaRef, criteriaId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee66$(_context66) {
      while (1) {
        switch (_context66.prev = _context66.next) {
          case 0:
            _context66.prev = 0;
            newCriteriaRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/performanceCriteria').push();
            criteriaId = newCriteriaRef.key;
            _context66.next = 5;
            return newCriteriaRef.set(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              uid: criteriaId,
              createdAt: Date.now()
            }));

          case 5:
            return _context66.abrupt("return", { success: true, uid: criteriaId });

          case 8:
            _context66.prev = 8;
            _context66.t0 = _context66["catch"](0);

            console.error("Error adding performance criteria: ", _context66.t0);
            swal("Oops!", _context66.t0.message || "Failed to add performance criteria", "error");

          case 12:
          case "end":
            return _context66.stop();
        }
      }
    }, _callee66, _this, [[0, 8]]);
  }));

  return function addPerformanceCriteria(_x111) {
    return _ref71.apply(this, arguments);
  };
}();

var getAllPerformanceCriteria = function () {
  var _ref72 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee67() {
    var snapshot, criteriaObj;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            _context67.prev = 0;
            _context67.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/performanceCriteria').once('value');

          case 3:
            snapshot = _context67.sent;
            criteriaObj = snapshot.val() || {};
            return _context67.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(criteriaObj).map(function (key) {
              return criteriaObj[key];
            }));

          case 8:
            _context67.prev = 8;
            _context67.t0 = _context67["catch"](0);

            console.error("Error fetching performance criteria: ", _context67.t0);
            swal("Oops!", _context67.t0.message || "Failed to fetch performance criteria", "error");
            return _context67.abrupt("return", []);

          case 13:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67, _this, [[0, 8]]);
  }));

  return function getAllPerformanceCriteria() {
    return _ref72.apply(this, arguments);
  };
}();

var updatePerformanceCriteria = function () {
  var _ref73 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee68(uid, data) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee68$(_context68) {
      while (1) {
        switch (_context68.prev = _context68.next) {
          case 0:
            _context68.prev = 0;

            if (uid) {
              _context68.next = 3;
              break;
            }

            throw new Error("Performance criteria ID is required");

          case 3:
            _context68.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/performanceCriteria/" + uid).update(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              updatedAt: Date.now()
            }));

          case 5:
            return _context68.abrupt("return", { success: true });

          case 8:
            _context68.prev = 8;
            _context68.t0 = _context68["catch"](0);

            console.error("Error updating performance criteria: ", _context68.t0);
            swal("Oops!", _context68.t0.message || "Failed to update performance criteria", "error");

          case 12:
          case "end":
            return _context68.stop();
        }
      }
    }, _callee68, _this, [[0, 8]]);
  }));

  return function updatePerformanceCriteria(_x112, _x113) {
    return _ref73.apply(this, arguments);
  };
}();

var deletePerformanceCriteria = function () {
  var _ref74 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee69(uid) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            _context69.prev = 0;

            if (uid) {
              _context69.next = 3;
              break;
            }

            throw new Error("Performance criteria ID is required");

          case 3:
            _context69.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/performanceCriteria/" + uid).remove();

          case 5:
            return _context69.abrupt("return", { success: true });

          case 8:
            _context69.prev = 8;
            _context69.t0 = _context69["catch"](0);

            console.error("Error deleting performance criteria: ", _context69.t0);
            swal("Oops!", _context69.t0.message || "Failed to delete performance criteria", "error");

          case 12:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69, _this, [[0, 8]]);
  }));

  return function deletePerformanceCriteria(_x114) {
    return _ref74.apply(this, arguments);
  };
}();

var addPerformanceScoreByGrade = function () {
  var _ref75 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee70(data) {
    var newRef, scoreId;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            _context70.prev = 0;
            newRef = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/performanceScoresByGrade').push();
            scoreId = newRef.key;
            _context70.next = 5;
            return newRef.set(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              uid: scoreId,
              createdAt: Date.now()
            }));

          case 5:
            return _context70.abrupt("return", { success: true, uid: scoreId });

          case 8:
            _context70.prev = 8;
            _context70.t0 = _context70["catch"](0);

            console.error("Error adding performance score by grade: ", _context70.t0);
            swal("Oops!", _context70.t0.message || "Failed to add target score", "error");
            throw _context70.t0;

          case 13:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70, _this, [[0, 8]]);
  }));

  return function addPerformanceScoreByGrade(_x115) {
    return _ref75.apply(this, arguments);
  };
}();

var getAllPerformanceScoresByGrade = function () {
  var _ref76 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee71() {
    var snapshot, scoresObj;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee71$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            _context71.prev = 0;
            _context71.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref('constants/performanceScoresByGrade').once('value');

          case 3:
            snapshot = _context71.sent;
            scoresObj = snapshot.val() || {};
            return _context71.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(scoresObj).map(function (key) {
              return scoresObj[key];
            }));

          case 8:
            _context71.prev = 8;
            _context71.t0 = _context71["catch"](0);

            console.error("Error fetching performance scores by grade: ", _context71.t0);
            swal("Oops!", _context71.t0.message || "Failed to fetch target scores", "error");
            return _context71.abrupt("return", []);

          case 13:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee71, _this, [[0, 8]]);
  }));

  return function getAllPerformanceScoresByGrade() {
    return _ref76.apply(this, arguments);
  };
}();

var updatePerformanceScoreByGrade = function () {
  var _ref77 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee72(uid, data) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            _context72.prev = 0;

            if (uid) {
              _context72.next = 3;
              break;
            }

            throw new Error("Score ID (uid) is required");

          case 3:
            _context72.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/performanceScoresByGrade/" + uid).update(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
              updatedAt: Date.now()
            }));

          case 5:
            return _context72.abrupt("return", { success: true });

          case 8:
            _context72.prev = 8;
            _context72.t0 = _context72["catch"](0);

            console.error("Error updating performance score by grade: ", _context72.t0);
            swal("Oops!", _context72.t0.message || "Failed to update target score", "error");
            throw _context72.t0;

          case 13:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72, _this, [[0, 8]]);
  }));

  return function updatePerformanceScoreByGrade(_x116, _x117) {
    return _ref77.apply(this, arguments);
  };
}();

var deletePerformanceScoreByGrade = function () {
  var _ref78 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee73(uid) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            _context73.prev = 0;

            if (uid) {
              _context73.next = 3;
              break;
            }

            throw new Error("Score ID (uid) is required");

          case 3:
            _context73.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database().ref("constants/performanceScoresByGrade/" + uid).remove();

          case 5:
            return _context73.abrupt("return", { success: true });

          case 8:
            _context73.prev = 8;
            _context73.t0 = _context73["catch"](0);

            console.error("Error deleting performance score by grade: ", _context73.t0);
            swal("Oops!", _context73.t0.message || "Failed to delete target score", "error");
            throw _context73.t0;

          case 13:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73, _this, [[0, 8]]);
  }));

  return function deletePerformanceScoreByGrade(_x118) {
    return _ref78.apply(this, arguments);
  };
}();

var firebase = {
  deletePromotionInfo: deletePromotionInfo,
  getEmailTemplates: getEmailTemplates,
  addEmailTemplate: addEmailTemplate,
  updateEmailTemplate: updateEmailTemplate,
  getEmployeeApprovedLeaves: getEmployeeApprovedLeaves,
  addHoliday: addHoliday,
  getAllHolidays: getAllHolidays,
  updateHoliday: updateHoliday,
  deleteHoliday: deleteHoliday,
  ResetCode: ResetCode,
  ResetPassword: ResetPassword,
  sendPasswordResetEmail: sendPasswordResetEmail,
  checkAlreadyConfiguredApp: checkAlreadyConfiguredApp,
  configuredAppForReportBug: configuredAppForReportBug,
  updateUserActiveStatus: updateUserActiveStatus,
  createOrUpdateQuarterlyMeetingDetails: createOrUpdateQuarterlyMeetingDetails,
  createOrUpdateIncrementMeetingDetails: createOrUpdateIncrementMeetingDetails,
  deleteQuarterlyMeetingDetails: deleteQuarterlyMeetingDetails,
  deleteIncrementMeetingDetails: deleteIncrementMeetingDetails,
  updateEmployee: updateEmployee,
  configureFirebase: configureFirebase,
  unconfigureFirebase: unconfigureFirebase,
  login: login,
  fetchAllUsersRealTime: fetchAllUsersRealTime,
  readDatabase: readDatabase,
  updateDatabase: updateDatabase,
  uploadImage: uploadImage,
  reAuthenticateUserFirebase: reAuthenticateUserFirebase,
  updatePasswordFirebase: updatePasswordFirebase,
  logout: logout,
  submitLeave: submitLeave,
  getSingleUser: getSingleUser,
  updateLeaveStatusAndComment: updateLeaveStatusAndComment,
  fetchCompanyData: fetchCompanyData,
  deleteEmployee: deleteEmployee,
  addEmployee: addEmployee,
  updateLogTime: updateLogTime,
  pushDatabase: pushDatabase,
  updateUserRole: updateUserRole,
  fetchManualHoursActivities: fetchManualHoursActivities,
  fetchPerformanceActivities: fetchPerformanceActivities,
  constants: constants,
  saveBugReport: saveBugReport,
  getAllBugReports: getAllBugReports,
  updateBugStatus: updateBugStatus,
  logAdminActivityToDB: logAdminActivityToDB,
  getAllAdminActivities: getAllAdminActivities,
  fetchTaxSlabs: fetchTaxSlabs,
  updateUserStatus: updateUserStatus,
  updateUserResignationDate: updateUserResignationDate,
  updateUserLeaves: updateUserLeaves,
  updateUserPreviousStatus: updateUserPreviousStatus,
  logPerformanceChange: logPerformanceChange,
  fetchEditedCards: fetchEditedCards,
  saveEditedCard: saveEditedCard,
  deleteEditedCard: deleteEditedCard,
  postAdjustment: postAdjustment,
  getAdjustments: getAdjustments,
  deleteAdjustment: deleteAdjustment,
  saveApproveReject: saveApproveReject,
  saveTrelloUser: saveTrelloUser,
  isPayrollProcessed: isPayrollProcessed,
  addPerformanceItem: addPerformanceItem,
  ApproveNewTicket: ApproveNewTicket,
  fetchPerformanceLock: fetchPerformanceLock,
  savePerformanceLock: savePerformanceLock,
  addPerformanceCriteria: addPerformanceCriteria,
  getAllPerformanceCriteria: getAllPerformanceCriteria,
  updatePerformanceCriteria: updatePerformanceCriteria,
  deletePerformanceCriteria: deletePerformanceCriteria,
  savePerformanceSnapshot: savePerformanceSnapshot,
  savePerformanceUserId: savePerformanceUserId,
  updatePerformanceLockUserFlag: updatePerformanceLockUserFlag,
  removeUserFromLock: removeUserFromLock,
  addPerformanceScoreByGrade: addPerformanceScoreByGrade,
  getAllPerformanceScoresByGrade: getAllPerformanceScoresByGrade,
  updatePerformanceScoreByGrade: updatePerformanceScoreByGrade,
  deletePerformanceScoreByGrade: deletePerformanceScoreByGrade

};

/* harmony default export */ __webpack_exports__["a"] = (firebase);

/***/ }),

/***/ "h7Z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_config_constants__ = __webpack_require__("gY6d");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GoogleCalendarIntegration',

  data: function data() {
    return {
      isConnected: false,
      userEmail: '',
      initializing: true,
      loadings: {
        connect: false,
        disconnect: false
      }
    };
  },
  mounted: function mounted() {
    this.handleOAuthCallback();
    this.restoreSession();
  },


  methods: {
    handleOAuthCallback: function handleOAuthCallback() {
      console.log("Checking for OAuth callback parameters...");

      var hash = window.location.hash;
      var queryString = hash.includes('?') ? hash.split('?')[1] : '';
      var params = new URLSearchParams(queryString);

      var gcConnected = params.get('gc_connected');
      var accessToken = params.get('accessToken');
      var email = params.get('email');
      var gcError = params.get('gc_error');

      console.log(params.toString());

      if (gcConnected && accessToken && email) {
        localStorage.setItem('gc_access_token', accessToken);
        localStorage.setItem('gc_user_email', email);

        this.isConnected = true;
        this.userEmail = email;

        window.location.hash = window.location.hash.split('?')[0];

        this.$emit('connected');
      }

      if (gcError) {
        alert('Google Calendar connection failed. Please try again.');
        window.location.hash = window.location.hash.split('?')[0];
      }
    },
    restoreSession: function restoreSession() {
      var token = localStorage.getItem('gc_access_token');
      var email = localStorage.getItem('gc_user_email');
      if (token && email) {
        this.isConnected = true;
        this.userEmail = email;
      }
      this.initializing = false;
    },
    connect: function connect() {
      this.loadings.connect = true;
      var uid = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["auth"]().currentUser.uid;
      var companyEmail = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["auth"]().currentUser.email;
      var frontendUrl = window.location.origin;

      window.location.href = __WEBPACK_IMPORTED_MODULE_4__assets_config_constants__["f" /* serverURL */] + '/google-calendar/authorize?uid=' + uid + '&companyEmail=' + companyEmail + '&frontendUrl=' + encodeURIComponent(frontendUrl);
    },
    disconnect: function disconnect() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var currentUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadings.disconnect = true;

                _context.prev = 1;
                currentUser = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["auth"]().currentUser;

                if (!currentUser) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return fetch(__WEBPACK_IMPORTED_MODULE_4__assets_config_constants__["f" /* serverURL */] + '/google-calendar/disconnect', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    uid: currentUser.uid,
                    companyEmail: currentUser.email
                  })
                });

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Disconnect failed:', _context.t0);

              case 11:
                _context.prev = 11;

                _this.loadings.disconnect = false;
                return _context.finish(11);

              case 14:

                _this.clearSession();
                _this.$emit('disconnected');

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 11, 14]]);
      }))();
    },
    clearSession: function clearSession() {
      this.isConnected = false;
      this.userEmail = '';
      localStorage.removeItem('gc_access_token');
      localStorage.removeItem('gc_user_email');
    }
  }
});

/***/ }),

/***/ "hHDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */] },
  props: ["user"],
  mounted: function mounted() {
    this.setAvatar(this.user.profile_picture);
  },
  data: function data() {
    return {
      details: [{
        title: "12",
        subTitle: "Files"
      }, {
        title: "2GB",
        subTitle: "Used"
      }, {
        title: "24,6$",
        subTitle: "Spent"
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-md-3 col-md-offset-1";
      } else if (remainder === 2) {
        return "col-md-4";
      } else {
        return "col-md-3";
      }
    },
    getProfileText: function getProfileText(provider) {
      if (provider === "facebook") {
        return this.user.facebookProfile ? "Go to facebook profile" : "Please enter your profile";
      } else if (provider === "google") {
        return this.user.googlePlusProfile ? "Go to google profile" : "Please enter your profile";
      } else if (provider === "twitter") {
        return this.user.twitterProfile ? "Go to twitter profile" : "Please enter your profile";
      }
    },
    readImage: function readImage(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, response, newData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = document.querySelector("#avatar-input").files[0];
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__assets_config_helpers__["x" /* default */].fileToDataURL(file);

              case 4:
                response = _context.sent;
                newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.user, { profile_picture: response });

                _this.setAvatar(response);
                _this.$emit("updateParent", newData, true);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);

                swal("Error!", _context.t0.message, "error");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10]]);
      }))();
    },
    setAvatar: function setAvatar(image) {
      if (image) {
        var avatarEl = document.querySelector(".avatar");
        avatarEl.style.backgroundImage = "url('" + image + "')";
      }
    }
  }
});

/***/ }),

/***/ "hq6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderEmployeeDropdown_vue__ = __webpack_require__("qi3I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45573a89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderEmployeeDropdown_vue__ = __webpack_require__("MNXG");
function injectStyle (ssrContext) {
  __webpack_require__("N7fN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45573a89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderEmployeeDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45573a89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderEmployeeDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i+AN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MeetingModal',
  components: { ReuseableModal: __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_ReuseableModal_vue__["a" /* default */] },

  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    meeting: {
      type: Object,
      default: null
    },
    users: Array,
    meetingType: {
      type: String,
      default: 'quarterly',
      required: true
    },
    selectedEmployee: {
      type: Object,
      default: null
    },
    loading: {
      type: Object,
      default: function _default() {
        return {
          saveMeeting: false,
          deleteMeeting: false
        };
      }
    }
  },

  emits: ['update:modelValue', 'save', 'delete'],

  data: function data() {
    return {
      form: {
        date: '',
        time: '',
        attendees: [],
        title: '',
        description: '',
        googleEventId: null
      },
      errors: {}
    };
  },

  computed: {
    selectedUsers: function selectedUsers() {
      var _this = this;

      return this.users.filter(function (user) {
        return _this.form.attendees.includes(user.email);
      });
    }
  },

  mounted: function mounted() {
    if (this.meeting) {
      var dt = new Date(this.meeting.dateTime);

      this.form.date = dt.toISOString().slice(0, 10);
      this.form.time = dt.toTimeString().slice(0, 5);
      this.form.attendees = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.meeting.attendees || []));
      this.form.title = this.meeting.title || '';
      this.form.description = this.meeting.description || '';
      this.form.googleEventId = this.meeting.googleEventId || null;
    } else {
      this.form.title = 'Quarterly / Increment Review Meeting';
    }
  },


  methods: {
    setFormFromMeeting: function setFormFromMeeting() {
      if (!this.meeting) return;

      var details = null;

      if (this.meetingType === 'increment' && this.meeting.nextIncrementMeetingDetails) {
        details = this.meeting.nextIncrementMeetingDetails;
      } else if (this.meetingType === 'quarterly' && this.meeting.nextQuarterlyMeetingDetails) {
        details = this.meeting.nextQuarterlyMeetingDetails;
      } else if (this.meetingType === 'increment') {
        this.form.date = this.meeting.nextIncrementReview;
      } else {
        this.form.date = this.meeting.nextQuarterlyMeeting;
      }

      if (!details) return;

      this.form.date = details.date || '';
      this.form.time = details.time || '';
      this.form.title = details.title || '';
      this.form.attendees = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(details.attendees || []));
      this.form.description = details.description || '';
      this.form.googleEventId = details.googleEventId || null;
    },
    validateForm: function validateForm() {
      this.errors = {};

      if (!this.form.date) {
        this.errors.date = 'Date is required';
      }

      if (!this.form.time) {
        this.errors.time = 'Time is required';
      }

      if (!this.form.title) {
        this.errors.title = 'Title is required';
      }

      if (!this.form.attendees.length) {
        this.errors.attendees = 'At least one attendee is required';
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errors).length === 0;
    },
    generateTitleAndDescription: function generateTitleAndDescription() {
      if (!this.selectedEmployee) return;

      var name = this.selectedEmployee.username;

      if (this.meetingType === 'quarterly') {
        this.form.title = 'Quarterly Review Meeting - ' + name;
        this.form.description = 'Scheduled quarterly review meeting for ' + name + ' to discuss performance, goals, and development.';
      }

      if (this.meetingType === 'increment') {
        this.form.title = 'Increment Review Meeting - ' + name;
        this.form.description = 'Scheduled increment review meeting for ' + name + ' to discuss performance, compensation changes, and next steps.';
      }
    },
    saveMeeting: function saveMeeting() {
      if (!this.validateForm()) return;

      this.$emit('save', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        date: this.form.date,
        time: this.form.time,
        attendees: this.form.attendees,
        title: this.form.title,
        description: this.form.description
      }, this.form.googleEventId && { googleEventId: this.form.googleEventId }));
    },
    deleteMeeting: function deleteMeeting() {
      this.$emit('delete', this.meeting.id);
    },
    resetForm: function resetForm() {
      this.form = {
        date: '',
        time: '',
        attendees: [],
        title: '',
        description: '',
        googleEventId: null
      };
      this.errors = {};
    }
  },
  watch: {
    'form.date': function formDate() {
      delete this.errors.date;
    },
    'form.time': function formTime() {
      delete this.errors.time;
    },
    'form.title': function formTitle() {
      delete this.errors.title;
    },
    'form.attendees': function formAttendees() {
      delete this.errors.attendees;
    },
    modelValue: function modelValue(isOpen) {
      if (!isOpen) {
        this.resetForm();
        return;
      }

      this.generateTitleAndDescription();

      if (this.selectedEmployee.email) {
        this.form.attendees = [this.selectedEmployee.email];
      }

      if (this.meeting) {
        this.setFormFromMeeting();
      }
    },
    meetingType: function meetingType() {
      if (!this.meeting.nextQuarterlyMeetingDetails || !this.meeting.nextIncrementMeetingDetails && this.modelValue) {
        this.generateTitleAndDescription();
      }
    }
  }

});

/***/ }),

/***/ "iQbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatus_vue__ = __webpack_require__("xYk1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df79164_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatus_vue__ = __webpack_require__("5PIl");
function injectStyle (ssrContext) {
  __webpack_require__("fWxY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2df79164"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df79164_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iT8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iTqh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iXGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification-section"},[_c('h2',{staticClass:"section-title"},[_vm._v("Verification Documents")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),(!_vm.tempExperienceLetterUrl)?_c('div',{staticClass:"file-upload-area",on:{"click":_vm.triggerExperienceLetterFileInput,"dragover":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();return _vm.handleExperienceLetterFileDrop($event)}}},[_c('input',{ref:"experienceLetterInput",staticClass:"file-input",attrs:{"id":"experienceLetter","type":"file","accept":".pdf,image/*"},on:{"change":_vm.handleExperienceLetterUpload}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"upload-text"},[(_vm.errors.certificateUrl)?_c('span',{staticClass:"invalid-feedback",staticStyle:{"margin-top":"-12px"}},[_vm._v("This field is required")]):_vm._e(),_vm._v("\n          Click to browse or drag and drop\n          "),_c('div',{staticClass:"upload-format"},[_vm._v("Supported formats: PDF, IMAGE")])]),_vm._v(" "),(_vm.isUploadingExperienceLetter)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('span',[_vm._v("Uploading...")])]):_vm._e()]):_c('div',{staticClass:"file-preview"},[_c('div',{staticClass:"file-info"},[(_vm.isExperienceLetterImage)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.tempExperienceLetterUrl,"alt":"Experience Letter Image"}}):(_vm.isExperienceLetterPdf)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.getDocumentThumbnail(_vm.tempExperienceLetterUrl),"alt":"Document Preview"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"action-button-container"},[_c('button',{staticClass:"view-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openFileInNewTab(_vm.tempExperienceLetterUrl)}}},[_c('i',{staticClass:"fas fa-eye"})]),_vm._v(" "),_c('button',{staticClass:"replace-btn",attrs:{"type":"button","title":"Replace Document"},on:{"click":_vm.triggerExperienceLetterFileInput}},[_c('i',{staticClass:"fas fa-sync-alt"})])]),_vm._v(" "),_c('input',{ref:"experienceLetterInput",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"id":"experienceLetterReplace","type":"file","accept":".pdf,image/*"},on:{"change":_vm.handleExperienceLetterUpload}})]),_vm._v(" "),_c('div',{staticClass:"certificate-note"},[_vm._v("\n        For interns, it's required to submit an Academic Certificate; for experienced developers, submit an Experience Letter from your last organization.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),(!_vm.tempSalarySlipUrl)?_c('div',{staticClass:"file-upload-area",on:{"click":_vm.triggerSalarySlipFileInput,"dragover":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();return _vm.handleSalarySlipFileDrop($event)}}},[_c('input',{ref:"salarySlipInput",staticClass:"file-input",attrs:{"id":"salarySlip","type":"file","accept":".pdf,image/*"},on:{"change":_vm.handleSalarySlipUpload}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"upload-text"},[(_vm.errors.salarySlipUrl)?_c('span',{staticClass:"invalid-feedback",staticStyle:{"margin-top":"-12px"}},[_vm._v("This field is required")]):_vm._e(),_vm._v("\n          Click to browse or drag and drop\n          "),_c('div',{staticClass:"upload-format"},[_vm._v("Supported formats: PDF, IMAGE")])]),_vm._v(" "),(_vm.isUploadingSalarySlip)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('span',[_vm._v("Uploading...")])]):_vm._e()]):_c('div',{staticClass:"file-preview"},[_c('div',{staticClass:"file-info"},[(_vm.isSalarySlipImage)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.tempSalarySlipUrl,"alt":"Salary Slip Image"}}):(_vm.isSalarySlipPdf)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.getDocumentThumbnail(_vm.tempSalarySlipUrl),"alt":"Document Preview"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"action-button-container"},[_c('button',{staticClass:"view-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openFileInNewTab(_vm.tempSalarySlipUrl)}}},[_c('i',{staticClass:"fas fa-eye"})]),_vm._v(" "),_c('button',{staticClass:"replace-btn",attrs:{"type":"button","title":"Replace Document"},on:{"click":_vm.triggerSalarySlipFileInput}},[_c('i',{staticClass:"fas fa-sync-alt"})])]),_vm._v(" "),_c('input',{ref:"salarySlipInput",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"id":"salarySlipReplace","type":"file","accept":".pdf,image/*"},on:{"change":_vm.handleSalarySlipUpload}})])])]),_vm._v(" "),_c('div',{staticClass:"submit-button-container"},[_c('button',{staticClass:"button-submit",staticStyle:{"min-width":"200px"},attrs:{"type":"button"},on:{"click":_vm.submitDocuments}},[(this.documentLoading)?_c('span',[_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle"},attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v("\n        Submit Documents\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"experienceLetter"}},[_vm._v("Academic Certificate/Experience Letter "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-icon"},[_c('i',{staticClass:"fas fa-upload"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"salarySlip"}},[_vm._v("Salary Slip "),_c('span',{staticClass:"required"},[_vm._v("* ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-icon"},[_c('i',{staticClass:"fas fa-upload"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iaJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeetingModal_vue__ = __webpack_require__("i+AN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdc34fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeetingModal_vue__ = __webpack_require__("3dPH");
function injectStyle (ssrContext) {
  __webpack_require__("NM96")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bdc34fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeetingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdc34fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeetingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "icvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nI6u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e00205e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SLNd");
function injectStyle (ssrContext) {
  __webpack_require__("RYtT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e00205e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e00205e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j73S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UIComponents_EmployeeDropdown_vue__ = __webpack_require__("gd4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_config_api__ = __webpack_require__("IFYK");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CustomTable: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_CustomTable_vue__["a" /* default */], Card: __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__["a" /* default */], EmployeeDropdown: __WEBPACK_IMPORTED_MODULE_9__UIComponents_EmployeeDropdown_vue__["a" /* default */], ReuseableModal: __WEBPACK_IMPORTED_MODULE_10__UIComponents_ReuseableModal_vue__["a" /* default */], CustomDropdown: __WEBPACK_IMPORTED_MODULE_11__UIComponents_CustomDropdown_vue__["a" /* default */] },

  created: function created() {
    var _this = this;

    var store = this.$store;
    this.user = store.state.auth.user;
    this.role = store.state.auth.user.role;
    this.labels = store.state.complains.trelloLabels;
    this.complainsListId = store.state.complains.trelloListIds && store.state.complains.trelloListIds.complainsListId || null;
    this.resolvedListId = store.state.complains.trelloListIds && store.state.complains.trelloListIds.resolvedListId || null;

    this.assignees = store.state.complains.assignees ? store.state.complains.assignees.map(function (assignee) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, assignee, {
        fullName: assignee.fullName.includes('_') ? assignee.fullName.split('_').map(function (word) {
          return word[0].toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ') : assignee.fullName
      });
    }) : [];

    this.items = store.state.complains.cardsData.map(function (item) {
      var _item$name$split = item.name.split(' - '),
          _item$name$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_item$name$split, 2),
          title = _item$name$split2[0],
          email = _item$name$split2[1];

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, { title: title });
    });
    store.commit("loadingStarts");

    // Fetch Trello cards on first visit
    store.dispatch("fetchTrelloCards").finally(function () {
      store.commit("loadingEnds");
    });

    store.watch(store.getters.cardsData, function (cardsData) {
      _this.items = cardsData.map(function (item) {
        var _item$name$split3 = item.name.split(' - '),
            _item$name$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_item$name$split3, 2),
            title = _item$name$split4[0],
            email = _item$name$split4[1];

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, { title: title, email: email });
      });
      store.commit("loadingEnds");
    });

    store.watch(function () {
      return store.state.complains.assignees;
    }, function (newAssignees) {
      _this.assignees = newAssignees ? newAssignees.map(function (assignee) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, assignee, {
          fullName: assignee.fullName.includes('_') ? assignee.fullName.split('_').map(function (word) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
          }).join(' ') : assignee.fullName
        });
      }) : [];
    });
  },
  data: function data() {
    return {
      dialog: false,
      title: "",
      description: "",
      assigneeId: null,
      selectedAssigneeName: "",
      user: null,
      role: null,
      labels: null,
      moment: __WEBPACK_IMPORTED_MODULE_7_moment___default.a,
      complainsListId: null,
      resolvedListId: null,
      items: [],
      filteredUsers: [],
      assignees: [],
      priority: "Normal",
      issueType: "General",
      priorityOptions: ["High", "Normal"],
      issueTypeOptions: ["General", "Personal"],
      visibleDetails: {},
      feedbackDialog: false,
      feedbackRating: 0,
      feedbackComment: "",
      currentFeedbackItem: null,
      isSubmitting: false,
      tableColumns: [{ label: "Assignee", key: "assigneeName", sticky: "left", sortable: true, width: 140 }, { label: "Email", key: "email", sticky: "left", sortable: true, width: 100 }, { label: "Title", key: "title", sortable: true }, { label: "Description", key: "desc" }, { label: "Priority", key: "isHighPriority", sortable: true }, { label: "Issue Type", key: "isPersonal", sortable: true }, { label: "Last Activity", key: "dateLastActivity", sortable: true }, { label: "Feedback", key: "feedback", width: 140 }, { label: "Status", key: "status", sticky: "right", width: 150 }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    },
    assigneeOptions: function assigneeOptions() {
      return this.assignees.map(function (assignee) {
        return assignee.fullName;
      });
    },
    complains: function complains() {
      var complainsData = (this.$store.state.complains.cardsData || []).map(function (item) {
        var title = item.name;
        var email = '';
        if (typeof item.name === 'string' && item.name.includes(' - ')) {
          var _item$name$split5 = item.name.split(' - ');

          var _item$name$split6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_item$name$split5, 2);

          title = _item$name$split6[0];
          email = _item$name$split6[1];
        }

        var feedback = null;
        var originalDesc = item.desc;
        if (item.desc && item.desc.includes('Feedback Submitted')) {
          var parts = item.desc.split('Feedback Submitted');
          originalDesc = parts[0].trim();
          var lastFeedbackPart = parts.pop().trim();
          var ratingMatch = lastFeedbackPart.match(/Rating:\s*([⭐]+)\s*\((\d+)\)/);
          var commentMatch = lastFeedbackPart.match(/Comment:\s*"([^"]*)"/);

          // Only create feedback if rating exists (allow empty comment)
          if (ratingMatch) {
            feedback = {
              rating: parseInt(ratingMatch[2]),
              comment: commentMatch ? commentMatch[1] : ""
            };
          }
        }

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, { title: title, email: email, feedback: feedback, originalDesc: originalDesc });
      });
      var complains = null;
      var filteredEmail = this.filteredUsers.map(function (user) {
        return user.email;
      });
      if (filteredEmail.length > 0) {
        complains = complainsData.filter(function (complain) {
          return filteredEmail.includes(complain.email);
        });
        console.log("===complian", complains);
      }

      console.log("===complainsData", complainsData);
      return complains || complainsData;
    }
  },

  methods: {
    getStatusClass: function getStatusClass(status) {
      return {
        Resolved: "status-badge resolved",
        Pending: "status-badge pending"
      }[status] || "status-badge";
    },
    refreshData: function refreshData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$store.commit("loadingStarts");
                _context.prev = 1;
                _context.next = 4;
                return _this2.$store.dispatch("fetchTrelloCards", { forceRefresh: true });

              case 4:
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Success", "Data refreshed successfully", "success");
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                console.error("Error refreshing data:", _context.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Error", "Failed to refresh data", "error");

              case 11:
                _context.prev = 11;

                _this2.$store.commit("loadingEnds");
                return _context.finish(11);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 7, 11, 14]]);
      }))();
    },
    toggleStatus: function toggleStatus(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var targetListId, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.user.email === item.email && _this3.role === 'admin' && !_this3.user.isSuperAdmin)) {
                  _context2.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Restricted", "Admins cannot resolve their own complaints.", "warning");
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                targetListId = item.status === "Resolved" ? _this3.complainsListId : _this3.resolvedListId;
                _context2.next = 7;
                return _this3.updateCardStatus(item.id, targetListId);

              case 7:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 14;
                  break;
                }

                item.status = item.status === "Resolved" ? "Pending" : "Resolved";

                _this3.$store.dispatch("fetchTrelloCards");
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Great", "Status Updated", "success");
                _context2.next = 15;
                break;

              case 14:
                throw new Error(response.statusText);

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](3);

                console.log("Error:", _context2.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Oops!", _context2.t0.message || "Something went wrong", "error");

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 17]]);
      }))();
    },
    updateCardStatus: function updateCardStatus(cardId, newListId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var apiKey, token;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
                token = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
                return _context3.abrupt("return", fetch("https://api.trello.com/1/cards/" + cardId + "?key=" + apiKey + "&token=" + token, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    idList: newListId
                  })
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    openAddComplainModal: function openAddComplainModal() {
      this.dialog = true;
    },
    clearItems: function clearItems() {
      this.dialog = false;
      this.title = "";
      this.description = "";
      this.assigneeId = null;
      this.selectedAssigneeName = "";
      this.priority = "Normal";
      this.issueType = "General";
    },
    handleAssigneeChange: function handleAssigneeChange(value) {
      var selectedAssignee = this.assignees.find(function (assignee) {
        return assignee.fullName === value;
      });
      if (selectedAssignee) {
        this.assigneeId = selectedAssignee.id;
        this.selectedAssigneeName = selectedAssignee.fullName;
      }
    },
    handlePriorityChange: function handlePriorityChange(value) {
      this.priority = value;
    },
    handleIssueTypeChange: function handleIssueTypeChange(value) {
      this.issueType = value;
    },
    addComplain: function addComplain() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var title, description, assigneeId, labels, complainsListId, email, isHighPriority, isPersonal, isGeneral, memberIds, labelIds, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.$store.commit("loadingStarts");
                title = _this5.title, description = _this5.description, assigneeId = _this5.assigneeId, labels = _this5.labels, complainsListId = _this5.complainsListId;
                email = _this5.user.email;
                isHighPriority = _this5.priority === "High";
                isPersonal = _this5.issueType === "Personal";
                isGeneral = _this5.issueType === "General";
                memberIds = assigneeId ? [assigneeId] : [];
                labelIds = _this5.getLabelIds(isHighPriority, isPersonal, isGeneral, labels);
                _context4.prev = 8;

                _this5.validateInputs(title, description, isPersonal, isGeneral, complainsListId);
                _context4.next = 12;
                return _this5.createTrelloCard(title, email, description, labelIds, memberIds, complainsListId);

              case 12:
                response = _context4.sent;

                if (!(response && response.id)) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 16;
                return _this5.$store.dispatch('updateCardsData', { updatedCard: response });

              case 16:
                _this5.clearItems();
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Great", "Added", "success");
                _context4.next = 21;
                break;

              case 20:
                throw new Error("Failed to create card");

              case 21:
                _context4.next = 27;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4["catch"](8);

                console.log("Error:", _context4.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Oops!", _context4.t0.message || "Something went wrong", "error");

              case 27:
                _context4.prev = 27;

                _this5.$store.commit("loadingEnds");
                return _context4.finish(27);

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[8, 23, 27, 30]]);
      }))();
    },
    getLabelIds: function getLabelIds(isHighPriority, isPersonal, isGeneral, labels) {
      var labelIds = [];

      if (isHighPriority) labelIds.push(labels.highPriorityLabelId);
      if (isPersonal) labelIds.push(labels.personalLabelId);else if (isGeneral) labelIds.push(labels.generalLabelId);

      return labelIds;
    },
    validateInputs: function validateInputs(title, description, isPersonal, isGeneral, complainsListId) {
      if (!title.trim() || !description.trim()) {
        throw new Error("Title and Description are required");
      }
      if (!isPersonal && !isGeneral) {
        throw new Error("Please provide the issue type");
      }
      if (!complainsListId) {
        throw new Error("The provided list name is not present in your trello board");
      }
    },
    createTrelloCard: function createTrelloCard(title, email, description, labelIds, memberIds, complainsListId) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var apiKey, token, payload, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
                token = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
                payload = {
                  idList: complainsListId,
                  name: title + " - " + email,
                  desc: description,
                  idLabels: labelIds,
                  pos: 1,
                  idMembers: memberIds
                };
                _context5.next = 5;
                return fetch("https://api.trello.com/1/cards?key=" + apiKey + "&token=" + token, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
                });

              case 5:
                response = _context5.sent;
                _context5.next = 8;
                return response.json();

              case 8:
                data = _context5.sent;

                if (!response.ok) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt("return", data);

              case 13:
                throw new Error(data.error || "Something went wrong creating the card");

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    getModifiedName: function getModifiedName(name, isAdmin) {
      var parts = name.split(' - ');
      if (isAdmin) {
        return parts.length > 1 ? parts[0] + " - <span style=\"color: pink\">" + parts[1] + "</span>" : name;
      } else {
        return parts.length > 1 ? parts.slice(0, -1).join('-').trim() : name;
      }
    },
    showDetails: function showDetails(id) {
      this.$set(this.visibleDetails, id, true);
    },
    hideDetails: function hideDetails(id) {
      this.$set(this.visibleDetails, id, false);
    },
    openFeedbackModal: function openFeedbackModal(item) {
      this.currentFeedbackItem = item;
      this.feedbackRating = 0;
      this.feedbackComment = "";
      this.feedbackDialog = true;
    },
    submitFeedback: function submitFeedback() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var stars, feedbackText, newDesc, commentText, apiKey, token, cardId, descResponse, commentResponse;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this7.feedbackRating === 0)) {
                  _context6.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Error", "Please select a rating", "error");
                return _context6.abrupt("return");

              case 3:
                if (!_this7.isSubmitting) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return");

              case 5:
                _this7.isSubmitting = true;

                stars = '⭐'.repeat(_this7.feedbackRating);
                feedbackText = "Feedback Submitted\n\n      * Rating: " + stars + " (" + _this7.feedbackRating + ")\n      * Comment: \"" + _this7.feedbackComment + "\"\n      Submitted by: " + _this7.user.email;
                newDesc = _this7.currentFeedbackItem.desc ? _this7.currentFeedbackItem.desc + "\n\n" + feedbackText : feedbackText;
                commentText = "Rating: " + stars + " (" + _this7.feedbackRating + ") \u2014 " + _this7.feedbackComment + " (by " + _this7.user.email + ")";


                _this7.$store.commit("loadingStarts");

                _context6.prev = 11;
                apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
                token = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
                cardId = _this7.currentFeedbackItem.id;
                _context6.next = 17;
                return fetch("https://api.trello.com/1/cards/" + cardId + "?key=" + apiKey + "&token=" + token, {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ desc: newDesc })
                });

              case 17:
                descResponse = _context6.sent;

                if (descResponse.ok) {
                  _context6.next = 20;
                  break;
                }

                throw new Error("Failed to update card description");

              case 20:
                _context6.next = 22;
                return fetch("https://api.trello.com/1/cards/" + cardId + "/actions/comments?key=" + apiKey + "&token=" + token, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ text: commentText })
                });

              case 22:
                commentResponse = _context6.sent;

                if (commentResponse.ok) {
                  _context6.next = 25;
                  break;
                }

                throw new Error("Failed to post feedback comment");

              case 25:
                _context6.next = 27;
                return _this7.$store.dispatch("fetchTrelloCards");

              case 27:
                _this7.feedbackDialog = false;
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Success", "Feedback submitted", "success");
                _context6.next = 35;
                break;

              case 31:
                _context6.prev = 31;
                _context6.t0 = _context6["catch"](11);

                console.error(_context6.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Error", "Failed to submit feedback", "error");

              case 35:
                _context6.prev = 35;

                _this7.$store.commit("loadingEnds");
                _this7.isSubmitting = false;
                return _context6.finish(35);

              case 39:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[11, 31, 35, 39]]);
      }))();
    }
  }
});

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a536023c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("EUqX");
function injectStyle (ssrContext) {
  __webpack_require__("aF5f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a536023c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jEyp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jKu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_assets_icons_TrashIcon_js__ = __webpack_require__("jm0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_perdaySallaryUtils__ = __webpack_require__("yLp5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdjustmentTable",
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_2_src_assets_icons_PencilIcon_js__["a" /* default */],
    TrashIcon: __WEBPACK_IMPORTED_MODULE_3_src_assets_icons_TrashIcon_js__["a" /* default */]
  },
  props: {
    loading: Boolean,
    data: Array,
    employeeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    workingDays: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    workingHours: {
      type: Number,
      default: 9
    },
    workingDaysInMonth: {
      type: Number,
      default: 1
    },
    canModify: {
      type: Function,
      default: function _default() {
        return true;
      }
    }
  },
  emits: ['edit', 'openDeleteModal'],
  data: function data() {
    return {
      adjustmentColumns: [{ key: "employee", label: "Employee" }, { key: "adjustmentType", label: "Adjustment Type" }, { key: "amount", label: "Amount" }, { key: "reason", label: "Reason" }, { key: "receipt", label: "Receipt" }, { key: "addedBy", label: "Added By" }, { key: "createdAt", label: "Created At" }, { key: "action", label: "Action" }]
    };
  },

  computed: {
    sortedData: function sortedData() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.data)).sort(function (a, b) {
        var dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
        var dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
        return dateB - dateA;
      });
    }
  },
  methods: {
    formatAmount: function formatAmount(item) {
      var employee = this.employeeList.find(function (emp) {
        return emp.uid === item.employeeId;
      }) || { basicSalary: 0, extraAllowance: 0 };
      var perDaySalary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_perdaySallaryUtils__["a" /* calculatePerDaySalary */])(employee.basicSalary, employee.extraAllowance || 0, this.workingDaysInMonth);
      var perHourSalary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_perdaySallaryUtils__["b" /* calculatePerHourSalary */])(perDaySalary, this.workingHours);

      var raw = String(item.amount).trim();
      var value = 0;
      var label = '';

      if (/^\d+(\.\d+)?$/.test(raw)) {
        value = parseFloat(raw);
      } else if (raw.endsWith('x')) {
        var mult = parseInt(raw, 10) || 0;
        value = perHourSalary * mult;
        label = ' (' + mult + 'x)';
      } else if (/^\d+\s*days?$/i.test(raw)) {
        var _mult = parseInt(raw, 10) || 0;
        value = perDaySalary * _mult;
        console.log("Calculating days adjustment:", _mult, "→", value);
        label = ' (' + _mult + ' ' + (_mult === 1 ? 'day' : 'days') + ')';
      } else {
        value = parseFloat(raw) || 0;
      }

      var rounded = Math.round(Math.abs(value));
      return 'Rs. ' + rounded + label;
    },
    formatDate: function formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    }
  }
});

/***/ }),

/***/ "jdzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryActivityTable_vue__ = __webpack_require__("2yTf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c04bb88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryActivityTable_vue__ = __webpack_require__("W5YQ");
function injectStyle (ssrContext) {
  __webpack_require__("deL4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c04bb88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryActivityTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c04bb88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryActivityTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jiZV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jm0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrashIcon',
  functional: true,
  props: {
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  render: function render(h, ctx) {
    return h('svg', {
      attrs: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 448 512',
        fill: ctx.props.color
      }, ctx.data.attrs),
      on: ctx.listeners
    }, [h('path', {
      attrs: {
        d: 'M135.2 17.7L121 32H24C10.7 32 0 42.7 0 56s10.7 24 24 24h400c13.3 0 24-10.7 24-24S437.3 32 424 32h-97L312.8 17.7C307.1 6.9 295.9 0 283.4 0H164.6c-12.5 0-23.7 6.9-29.4 17.7zM53.2 467c1.8 25 22.7 45 47.7 45h246.2c25 0 45.9-20 47.7-45L416 128H32l21.2 339zM200 224v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      }
    })]);
  }
});

/***/ }),

/***/ "jp4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminActivities_vue__ = __webpack_require__("gAKX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608ddbaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminActivities_vue__ = __webpack_require__("+b3b");
function injectStyle (ssrContext) {
  __webpack_require__("KE/0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-608ddbaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminActivities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608ddbaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminActivities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jpwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('FileTable',{ref:"fileTable"}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jvZ3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k4ft":
/***/ (function(module, exports) {

module.exports = {"banks":["Al Baraka Bank (Pakistan) Limited","Allied Bank Limited","Askari Bank Limited","Bank Alfalah Limited","Bank Al-Habib Limited","Bank Islami Pakistan Limited","Citi Bank N.A.","Deutsche Bank A.G.","The Bank of Tokyo-Mitsubishi","Dubai Islamic Bank Pakistan Limited","Faysal Bank Limited","First Women Bank Limited","Finca Microfinace Bank Limited","Habib Bank Limited","Standard Chartered Bank (Pakistan) Limited","Habib Metropolitan Bank Limited","Industrial and Commercial Bank of China","Industrial Development Bank of Pakistan","JS Bank Limited","MCB Bank Limited","MCB Islamic Bank Limited","Meezan Bank Limited","National Bank of Pakistan","S.M.E. Bank Limited","Samba Bank Limited","Silk Bank Limited","Sindh Bank Limited","Soneri Bank Limited","Summit Bank Limited","The Bank of Khyber","The Bank of Punjab","The Punjab Provincial Cooperative Bank Limited","United Bank Limited","Zarai Taraqiati Bank Limited","Bank of Punjab","Sindh Bank","Bank of Khyber","First Women Bank","Bank of Azad Jammu & Kashmir","Industrial Development Bank","SME Bank","The Punjab Provincial Cooperative Bank","Other"]}

/***/ }),

/***/ "kQVJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainTableColumns; });
var MainTableColumns = [{
    key: 'employeeName',
    label: 'Name',
    sortable: true,
    sticky: "left",
    width: 150
}, {
    key: 'grossSalary',
    label: 'Gross Salary',
    sortable: true,
    width: '80px'
}, {
    key: 'daysWorked',
    label: 'Attendance',
    sortable: true,
    width: '100px'
}, {
    key: 'absents',
    label: 'Absents',
    sortable: true,
    width: '80px'
}, {
    key: 'obtainedLeaves',
    label: 'Leaves',
    sortable: true,
    width: '100px'
}, {
    key: 'lateDeduction',
    label: 'Late Deduction',
    sortable: true,
    width: '120px'
}, {
    key: 'extraAmountAdjustment',
    label: 'Adjustments',
    sortable: true,
    width: '160px'
}, {
    key: 'bonus',
    label: 'Bonus',
    sortable: true,
    width: '120px'
}, {
    key: 'finalAmount',
    label: 'Final Salary',
    sortable: true,
    width: '160px'
}, {
    key: 'taxDeduction',
    label: 'Tax',
    sortable: true,
    width: '160px'
}, {
    key: 'status',
    label: 'Status',
    sortable: true,
    width: '100px'
}, {
    key: 'action',
    label: 'Actions',
    width: 70,
    sticky: "right"
}];

/***/ }),

/***/ "kfhz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_assets_config_firebase_js__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ["status-change"],
  components: { CustomDropdown: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_CustomDropdown_vue__["a" /* default */] },
  props: {
    item: {
      type: Object,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    displayMode: {
      type: String,
      default: "status",
      validator: function validator(value) {
        return ["status", "resignationDate"].includes(value);
      }
    }
  },
  data: function data() {
    return {
      showTooltip: false,
      statusOptions: ["Probation", "Permanent", "Resigned", "Terminated"]
    };
  },

  computed: {
    tooltipText: function tooltipText() {
      if (this.item.status !== "Resigned" || !this.item.resignationDate) return "";
      var resignationDate = new Date(this.item.resignationDate);
      var daysToAdd = this.item.previousStatus === "Probation" ? 15 : 30;
      var estimatedLastDay = new Date(resignationDate);
      estimatedLastDay.setDate(resignationDate.getDate() + daysToAdd);
      var formattedDate = estimatedLastDay.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
      return "Estimated Last Day: " + formattedDate;
    }
  },
  methods: {
    onStatusChange: function onStatusChange(newStatus) {
      this.$emit("status-change", {
        employee: this.item,
        newStatus: newStatus,
        oldStatus: this.item.status
      });
    },
    updateResignationDate: function updateResignationDate(event, item) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                item.resignationDate = event.target.value;

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_src_assets_config_firebase_js__["a" /* default */].updateUserResignationDate(item.resignationDate, item.uid);

              case 4:

                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Success", "Resignation/Termination date updated", "success");
                _this.$store.dispatch("fetchAllUsersRealTime");
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.error("Error updating resignation date:", _context.t0);
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Error", "Failed to update resignation date", "error");

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  }
});

/***/ }),

/***/ "l527":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return markAsRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return markAllAsRead; });
/* harmony export (immutable) */ __webpack_exports__["e"] = listenToNotifications;
/* unused harmony export handleLeaveActivityNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestNotificationPermission; });
/* harmony export (immutable) */ __webpack_exports__["c"] = showChromeNotification;
/* unused harmony export handlePerformanceEditNotification */
/* unused harmony export handlePerformanceLockUnlockNotification */
/* unused harmony export handlePerformanceLockNotification */
/* unused harmony export handleSettingsNotification */
/* unused harmony export handlePerformanceCriteriaNotification */
/* unused harmony export handleManualHoursNotification */
/* unused harmony export handleMeetingNotification */
/* unused harmony export handleCreateUserNotification */
/* unused harmony export handleUpdateUserNotification */
/* unused harmony export handleDeleteUserNotification */
/* unused harmony export handlePayrollNotification */
/* unused harmony export handleExpenseNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleActivityNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_underscore__ = __webpack_require__("44pt");










var createNotif = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6(targetUserId, payload) {
    var notifRef;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!targetUserId || !payload)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            notifRef = db().ref("notifications/" + targetUserId).push();
            _context6.next = 5;
            return notifRef.set(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, payload, {
              id: notifRef.key,
              isRead: false,
              createdAt: Date.now()
            }));

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function createNotif(_x9, _x10) {
    return _ref6.apply(this, arguments);
  };
}();

var notifyAdmins = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7(allUsers, payload, excludeUserId) {
    var adminIds;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            adminIds = getAdminIds(allUsers);
            _context7.next = 3;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(adminIds.filter(function (id) {
              return id !== excludeUserId;
            }) // ← add this line
            .map(function (id) {
              return createNotif(id, payload);
            }));

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function notifyAdmins(_x11, _x12, _x13) {
    return _ref7.apply(this, arguments);
  };
}();

var notifyAllUsers = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8(allUsers, payload, excludeUserId) {
    var userIds;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            userIds = getAllUserIds(allUsers);
            _context8.next = 3;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(userIds.filter(function (id) {
              return id !== excludeUserId;
            }).map(function (id) {
              return createNotif(id, payload);
            }));

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function notifyAllUsers(_x14, _x15, _x16) {
    return _ref8.apply(this, arguments);
  };
}();





var db = function db() {
  try {
    return __WEBPACK_IMPORTED_MODULE_9_firebase_app___default.a.database();
  } catch (e) {
    console.warn("Firebase not ready yet:", e.message);
    return null;
  }
};

var createNotification = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee(targetUserId, payload) {
    var notifRef;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!targetUserId || !payload)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            notifRef = db().ref("notifications/" + targetUserId).push();
            _context.next = 5;
            return notifRef.set(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, payload, {
              id: notifRef.key,
              isRead: false,
              createdAt: Date.now(),
              navigateTo: "/leave"
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function createNotification(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var markAsRead = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2(userId, notifId) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!userId || !notifId)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            _context2.next = 4;
            return db().ref("notifications/" + userId + "/" + notifId).update({ isRead: true });

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function markAsRead(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var markAllAsRead = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(userId) {
    var snapshot, updates;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (userId) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            _context3.next = 4;
            return db().ref("notifications/" + userId).once("value");

          case 4:
            snapshot = _context3.sent;

            if (snapshot.exists()) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return");

          case 7:
            updates = {};

            snapshot.forEach(function (child) {
              if (!child.val().isRead) {
                updates[child.key + "/isRead"] = true;
              }
            });

            if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(updates).length) {
              _context3.next = 12;
              break;
            }

            _context3.next = 12;
            return db().ref("notifications/" + userId).update(updates);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function markAllAsRead(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Real-time listener for a user's notifications (most recent 50).
 * Returns an unsubscribe function — call it in beforeDestroy().
 *
 * @param {string}   userId
 * @param {function} callback  receives array of notifications, newest first
 * @returns {function} unsubscribe
 */
function listenToNotifications(userId, callback) {
  if (!userId) return function () {};

  var ref = db().ref("notifications/" + userId).orderByChild("createdAt").limitToLast(50);

  var handler = function handler(snapshot) {
    var items = [];
    snapshot.forEach(function (child) {
      items.push(child.val());
    });
    callback(items.reverse());
  };

  ref.on("value", handler);

  return function () {
    ref.off("value", handler);
  };
}

/**
 * Parse a leave activity object and fan-out the correct notification(s).
 *
 * @param {object} activity        The activity you already saved to Firebase
 * @param {object} allUsers        Map of uid => user object (from your users node)
 * @param {string} currentUserId   UID of the person performing the action
 */
var handleLeaveActivityNotification = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(activity, allUsers, currentUserId) {
    var activityOnUser, activityOnUserName, activityByUserName, activityDescription, isApplied, isApproved, isRejected, leaveTypeMatch, dateRangeMatch, daysMatch, leaveType, leaveFrom, leaveTo, leaveDays, adminIds, appliedPayload, approvedPayload, rejectedPayload;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!activity || activity.type !== "leaves")) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            activityDescription = activity.activityDescription;

            if (activityDescription) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("return");

          case 8:

            // ── Detect action type from description string ──────────────────────────
            isApplied = activityDescription.indexOf("applied for") !== -1;
            isApproved = activityDescription.indexOf("approved") !== -1;
            isRejected = activityDescription.indexOf("rejected") !== -1;

            if (!(!isApplied && !isApproved && !isRejected)) {
              _context4.next = 13;
              break;
            }

            return _context4.abrupt("return");

          case 13:

            // ── Extract leave details from description ──────────────────────────────
            leaveTypeMatch = activityDescription.match(/(Casual|Sick|Emergency|Annual|Maternity|Paternity|Unpaid)\s+Leave/);
            dateRangeMatch = activityDescription.match(/from\s+(\d{4}-\d{2}-\d{2})\s+to\s+(\d{4}-\d{2}-\d{2})/);
            daysMatch = activityDescription.match(/\(([^)]+)\)/);
            leaveType = leaveTypeMatch ? leaveTypeMatch[0] : "Leave";
            leaveFrom = dateRangeMatch ? dateRangeMatch[1] : "";
            leaveTo = dateRangeMatch ? dateRangeMatch[2] : "";
            leaveDays = daysMatch ? daysMatch[1] : "";

            // ── Find all admin UIDs to notify when employee applies ─────────────────

            adminIds = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(allUsers || {}).filter(function (entry) {
              var u = entry[1];
              return u.role === "admin" || u.isSuperAdmin === true;
            }).map(function (entry) {
              return entry[0];
            });

            if (!isApplied) {
              _context4.next = 27;
              break;
            }

            appliedPayload = {
              type: "leave_applied",
              title: "New Leave Request",
              message: activity.activityName,
              activityType: "leaves",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserId: activityOnUser,
              performedByUserName: activityByUserName,
              leaveType: leaveType,
              leaveFrom: leaveFrom,
              leaveTo: leaveTo,
              leaveDays: leaveDays
            };
            _context4.next = 25;
            return notifyAdmins(allUsers, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, appliedPayload, {
              navigateTo: "/leave"
            }), currentUserId);

          case 25:
            _context4.next = 37;
            break;

          case 27:
            if (!isApproved) {
              _context4.next = 33;
              break;
            }

            approvedPayload = {
              type: "leave_approved",
              title: "Leave Approved",
              message: activity.activityName,
              activityType: "leaves",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserId: currentUserId,
              performedByUserName: activityByUserName,
              leaveType: leaveType,
              leaveFrom: leaveFrom,
              leaveTo: leaveTo,
              leaveDays: leaveDays
            };
            _context4.next = 31;
            return createNotification(activityOnUser, approvedPayload);

          case 31:
            _context4.next = 37;
            break;

          case 33:
            if (!isRejected) {
              _context4.next = 37;
              break;
            }

            rejectedPayload = {
              type: "leave_rejected",
              title: "Leave Rejected",
              message: activity.activityName,
              activityType: "leaves",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserId: currentUserId,
              performedByUserName: activityByUserName,
              leaveType: leaveType,
              leaveFrom: leaveFrom,
              leaveTo: leaveTo,
              leaveDays: leaveDays
            };
            _context4.next = 37;
            return createNotification(activityOnUser, rejectedPayload);

          case 37:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function handleLeaveActivityNotification(_x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

var requestNotificationPermission = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
    var result;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if ("Notification" in window) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", "unsupported");

          case 2:
            if (!(Notification.permission === "granted")) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", "granted");

          case 4:
            if (!(Notification.permission === "denied")) {
              _context5.next = 6;
              break;
            }

            return _context5.abrupt("return", "denied");

          case 6:
            _context5.next = 8;
            return Notification.requestPermission();

          case 8:
            result = _context5.sent;
            return _context5.abrupt("return", result);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function requestNotificationPermission() {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Show a native Chrome / browser notification.
 *
 * @param {string}   title
 * @param {object}   options   { body, icon, tag }
 * @param {function} onClick   called when user clicks the notification
 */
function showChromeNotification(title, options, onClick) {
  if (!("Notification" in window) || Notification.permission !== "granted") return;

  var notification = new Notification(title, {
    body: options && options.body || "",
    icon: options && options.icon || "/static/img/pertime-log-.png",
    tag: options && options.tag || "pertime-notif",
    requireInteraction: false,
    silent: false
  });

  if (typeof onClick === "function") {
    notification.onclick = function () {
      window.focus();
      onClick();
      notification.close();
    };
  }
}

function getAdminIds(allUsers) {
  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(allUsers || {}).filter(function (entry) {
    var u = entry[1];
    return u.role === "admin" || u.isSuperAdmin === true;
  }).map(function (entry) {
    return entry[0];
  });
}

function getAllUserIds(allUsers) {
  var users = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(allUsers || {});
  var ids = [];

  users.forEach(function (user) {
    if (user && user.uid) ids.push(user.uid);
  });

  return ids;
}

var handlePerformanceEditNotification = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9(activity, allUsers, currentUserId) {
    var activityOnUser, activityOnUserName, activityByUserName, action, cardName, fieldLabel;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(!activity || activity.type !== "performance_edit")) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            action = (activity.action.trim() || "").toLowerCase();
            cardName = activity.cardName || "a performance item";
            fieldLabel = (activity.fieldLabel || "").toLowerCase();

            if (activityOnUser) {
              _context9.next = 10;
              break;
            }

            return _context9.abrupt("return");

          case 10:
            if (!(fieldLabel === "score" && action === "updated")) {
              _context9.next = 14;
              break;
            }

            _context9.next = 13;
            return createNotif(activityOnUser, {
              type: "performance_score_updated",
              title: "Performance Score Updated",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 13:
            return _context9.abrupt("return");

          case 14:
            if (!(fieldLabel === "reopened count" && action === "approved")) {
              _context9.next = 18;
              break;
            }

            _context9.next = 17;
            return createNotif(activityOnUser, {
              type: "performance_reopen_edit_approved",
              title: "Performance Reopen Edit Approved",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 17:
            return _context9.abrupt("return");

          case 18:
            if (!(fieldLabel === "reopened count" && action === "updated")) {
              _context9.next = 22;
              break;
            }

            _context9.next = 21;
            return createNotif(activityOnUser, {
              type: "performance_reopen_updated",
              title: "Reopen Count Updated",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 21:
            return _context9.abrupt("return");

          case 22:
            if (!(fieldLabel === "reopened count" && action === "requested")) {
              _context9.next = 26;
              break;
            }

            _context9.next = 25;
            return notifyAdmins(allUsers, {
              type: "performance_reopen_requested",
              title: "Reopen Count Edit Requested",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/performance"
            }, currentUserId);

          case 25:
            return _context9.abrupt("return");

          case 26:
            if (!(action === "requested" || action === "updated request")) {
              _context9.next = 30;
              break;
            }

            _context9.next = 29;
            return notifyAdmins(allUsers, {
              type: "performance_item_added",
              title: "Performance Item Added",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/performance"
            }, currentUserId);

          case 29:
            return _context9.abrupt("return");

          case 30:
            if (!(action === "approved")) {
              _context9.next = 34;
              break;
            }

            _context9.next = 33;
            return createNotif(activityOnUser, {
              type: "approved",
              title: "Performance Item Approved",
              message: activity.activityName || "Your performance item \"" + cardName + "\" was approved",
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 33:
            return _context9.abrupt("return");

          case 34:
            if (!(action === "rejected")) {
              _context9.next = 38;
              break;
            }

            _context9.next = 37;
            return createNotif(activityOnUser, {
              type: "rejected",
              title: "Performance Item Rejected",
              message: activity.activityName || "Your performance item \"" + cardName + "\" was rejected",
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 37:
            return _context9.abrupt("return");

          case 38:
            if (!(action === "deleted")) {
              _context9.next = 48;
              break;
            }

            if (!activity.isAdmin) {
              _context9.next = 45;
              break;
            }

            _context9.next = 42;
            return createNotif(activityOnUser, {
              type: "performance_item_deleted",
              title: "Performance Item Deleted",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 42:
            return _context9.abrupt("return");

          case 45:
            _context9.next = 47;
            return notifyAdmins(allUsers, {
              type: "performance_item_deleted",
              title: "Performance Item Deleted",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/performance"
            }, currentUserId);

          case 47:
            return _context9.abrupt("return");

          case 48:
            if (!(action === "added")) {
              _context9.next = 52;
              break;
            }

            _context9.next = 51;
            return createNotif(activityOnUser, {
              type: "performance_item_added",
              title: "Performance Item Added",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 51:
            return _context9.abrupt("return");

          case 52:
            if (!(action === "updated")) {
              _context9.next = 55;
              break;
            }

            _context9.next = 55;
            return createNotif(activityOnUser, {
              type: "performance_item_updated",
              title: "Performance Item Updated",
              message: activity.activityName,
              activityType: "performance_edit",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              cardName: cardName,
              navigateTo: "/performance"
            });

          case 55:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function handlePerformanceEditNotification(_x17, _x18, _x19) {
    return _ref9.apply(this, arguments);
  };
}();

var handlePerformanceLockUnlockNotification = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10(activity, allUsers, currentUserId) {
    var activityByUserName, activityName, desc, action;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(!activity || activity.type !== "performance_lock_unlock")) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return");

          case 2:
            activityByUserName = activity.activityByUserName;
            activityName = activity.activityName || "";
            desc = activity.activityDescription || "";
            action = (activity.action || "").toLowerCase();

            // Notify all users except the one who performed the action

            _context10.next = 8;
            return notifyAllUsers(allUsers, {
              type: "performance_lock_unlock",
              title: "Performance " + (action === "locked" ? "Locked" : action === "unlocked" ? "Unlocked" : "Lock Scheduled"),
              message: activityName || desc,
              activityType: "performance_lock_unlock",
              performedByUserName: activityByUserName,
              navigateTo: "/performance"
            }, currentUserId);

          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function handlePerformanceLockUnlockNotification(_x20, _x21, _x22) {
    return _ref10.apply(this, arguments);
  };
}();

var handlePerformanceLockNotification = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee11(activity) {
    var activityOnUser, activityOnUserName, activityByUserName, action, month, year, period, typeMap, meta, periodText, messageMap;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(!activity || activity.type !== "performance_lock")) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            action = activity.action || "";
            month = activity.month || "";
            year = activity.year || "";
            period = month && year ? month + " " + year : "";

            if (activityOnUser) {
              _context11.next = 11;
              break;
            }

            return _context11.abrupt("return");

          case 11:
            typeMap = {
              "Locked Performance": { type: "performance_locked", title: "Performance Locked" },
              "Unlocked Performance": { type: "performance_unlocked", title: "Performance Unlocked" },
              "Scheduled Lock Performance": { type: "performance_scheduled_lock", title: "Performance Lock Scheduled" }
            };
            meta = typeMap[action];

            if (meta) {
              _context11.next = 15;
              break;
            }

            return _context11.abrupt("return");

          case 15:
            periodText = period ? " for " + period : "";
            messageMap = {
              "Locked Performance": "Your performance" + periodText + " has been locked by " + activityByUserName,
              "Unlocked Performance": "Your performance" + periodText + " has been unlocked by " + activityByUserName,
              "Scheduled Lock Performance": "Your performance" + periodText + " has a scheduled lock set by " + activityByUserName
            };
            _context11.next = 19;
            return createNotif(activityOnUser, {
              type: meta.type,
              title: meta.title,
              message: messageMap[action],
              activityType: "performance_lock",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              month: month,
              year: year,
              navigateTo: "/performance"
            });

          case 19:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function handlePerformanceLockNotification(_x23) {
    return _ref11.apply(this, arguments);
  };
}();

var handleSettingsNotification = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee12(activity, allUsers, currentUserId) {
    var activityByUserName, activityOnUser, activityOnUserName, desc, isSpecific;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!(!activity || activity.type !== "settings")) {
              _context12.next = 2;
              break;
            }

            return _context12.abrupt("return");

          case 2:
            activityByUserName = activity.activityByUserName;
            activityOnUser = activity.activityOnUser || null; // null means general settings, userId means specific user settings

            activityOnUserName = activity.activityOnUserName || null;
            desc = activity.activityDescription || "";
            isSpecific = desc.indexOf("specific settings") !== -1;

            if (!(isSpecific && activityOnUser)) {
              _context12.next = 12;
              break;
            }

            _context12.next = 10;
            return createNotif(activityOnUser, {
              type: "settings_updated",
              title: "Your Settings Updated",
              message: activityByUserName + " updated your account settings",
              activityType: "settings",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/settings"
            });

          case 10:
            _context12.next = 14;
            break;

          case 12:
            _context12.next = 14;
            return notifyAllUsers(allUsers, {
              type: "general_settings_updated",
              title: "General Settings Updated",
              message: activityByUserName + " updated the general system settings",
              activityType: "settings",
              performedByUserName: activityByUserName,
              navigateTo: "/settings"
            }, currentUserId);

          case 14:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function handleSettingsNotification(_x24, _x25, _x26) {
    return _ref12.apply(this, arguments);
  };
}();

var handlePerformanceCriteriaNotification = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee13(activity, allUsers, currentUserId) {
    var activityByUserName, activityOnUser, activityOnUserName, activityName;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!(!activity || activity.type !== "performance_criteria")) {
              _context13.next = 2;
              break;
            }

            return _context13.abrupt("return");

          case 2:
            activityByUserName = activity.activityByUserName;
            activityOnUser = activity.activityOnUser || null;
            activityOnUserName = activity.activityOnUserName || null;
            activityName = activity.activityName || "";
            _context13.next = 8;
            return notifyAllUsers(allUsers, {
              type: "performance_criteria_updated",
              title: "Performance Criteria " + activity.action,
              message: activityName,
              activityType: "performance_criteria",
              performedByUserName: activityByUserName,
              navigateTo: "/settings"
            }, currentUserId);

          case 8:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function handlePerformanceCriteriaNotification(_x27, _x28, _x29) {
    return _ref13.apply(this, arguments);
  };
}();

var handleManualHoursNotification = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee14(activity, allUsers, currentUserId) {
    var activityOnUser, activityOnUserName, activityByUserName, action, desc, dateMatch, dateText, timeInMatch, timeOutMatch, timeRange, datePart;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!(!activity || activity.type !== "manual_hours")) {
              _context14.next = 2;
              break;
            }

            return _context14.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            action = (activity.action || "").toLowerCase();
            desc = activity.activityDescription || "";

            if (activityOnUser) {
              _context14.next = 9;
              break;
            }

            return _context14.abrupt("return");

          case 9:

            // Extract date  e.g. "for February 5, 2026"
            dateMatch = desc.match(/for\s+([A-Za-z]+\s+\d+,\s+\d+)/);
            dateText = dateMatch ? dateMatch[1] : "";

            // Extract time range  e.g. "Time In: 09:00 AM and Time Out: 05:00 PM"

            timeInMatch = desc.match(/Time In:\s*([\d:]+\s*[AP]M)/i);
            timeOutMatch = desc.match(/Time Out:\s*([\d:]+\s*[AP]M)/i);
            timeRange = timeInMatch && timeOutMatch ? " (" + timeInMatch[1] + " \u2192 " + timeOutMatch[1] + ")" : "";
            datePart = (dateText ? " for " + dateText : "") + timeRange;

            // \u2500\u2500 action: added \u2014 admin manually added hours \u2192 notify employee \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

            if (!(action === "added")) {
              _context14.next = 19;
              break;
            }

            _context14.next = 18;
            return createNotif(activityOnUser, {
              type: "hours_added",
              title: "Working Hours Added \u23F1\uFE0F",
              message: activity.activityName,
              activityType: "manual_hours",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/reports"
            });

          case 18:
            return _context14.abrupt("return");

          case 19:
            if (!(action === "updated")) {
              _context14.next = 23;
              break;
            }

            _context14.next = 22;
            return createNotif(activityOnUser, {
              type: "hours_updated",
              title: "Working Hours Updated \u23F1\uFE0F",
              message: activity.activityName,
              activityType: "manual_hours",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/reports"
            });

          case 22:
            return _context14.abrupt("return");

          case 23:
            if (!(action === "request")) {
              _context14.next = 27;
              break;
            }

            _context14.next = 26;
            return notifyAdmins(allUsers, {
              type: "hours_edit_requested",
              title: "Hours Edit Requested \u23F1\uFE0F",
              message: activity.activityName,
              activityType: "manual_hours",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/reports"
            }, currentUserId);

          case 26:
            return _context14.abrupt("return");

          case 27:
            if (!(action === "approve")) {
              _context14.next = 31;
              break;
            }

            _context14.next = 30;
            return createNotif(activityOnUser, {
              type: "hours_edit_approved",
              title: "Hours Edit Approved \u2705",
              message: activity.activityName,
              activityType: "manual_hours",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/reports"
            });

          case 30:
            return _context14.abrupt("return");

          case 31:
            if (!(action === "reject")) {
              _context14.next = 34;
              break;
            }

            _context14.next = 34;
            return createNotif(activityOnUser, {
              type: "hours_edit_rejected",
              title: "Hours Edit Rejected \u274C",
              message: activity.activityName,
              activityType: "manual_hours",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/reports"
            });

          case 34:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function handleManualHoursNotification(_x30, _x31, _x32) {
    return _ref14.apply(this, arguments);
  };
}();

var handleMeetingNotification = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee15(activity, allUsers) {
    var activityOnUser, activityOnUserName, activityByUserName, desc, meetingLabel, attendees, emailToUid, isScheduled, isDeleted, meetingDateMatch, meetingDate, attendeeUids, uniqueAttendees;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (activity) {
              _context15.next = 2;
              break;
            }

            return _context15.abrupt("return");

          case 2:
            if (!(activity.type !== "quarterly" && activity.type !== "increment")) {
              _context15.next = 4;
              break;
            }

            return _context15.abrupt("return");

          case 4:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            desc = activity.activityDescription || "";
            meetingLabel = activity.type === "quarterly" ? "Quarterly" : "Increment";
            attendees = activity.attendees || [];
            emailToUid = buildEmailToUidMap(allUsers || {});

            if (activityOnUser) {
              _context15.next = 13;
              break;
            }

            return _context15.abrupt("return");

          case 13:
            isScheduled = desc.indexOf("scheduled") !== -1;
            isDeleted = desc.indexOf("deleted") !== -1;

            if (!(!isScheduled && !isDeleted)) {
              _context15.next = 17;
              break;
            }

            return _context15.abrupt("return");

          case 17:

            // Extract meeting datetime  e.g. "on March 10, 2026 at 2:28 PM"
            meetingDateMatch = desc.match(/on\s+([A-Za-z]+\s+\d+,\s+\d+\s+at\s+[\d:]+\s*[AP]M)/i);
            meetingDate = meetingDateMatch ? meetingDateMatch[1] : "";

            if (!isScheduled) {
              _context15.next = 24;
              break;
            }

            _context15.next = 22;
            return createNotif(activityOnUser, {
              type: meetingLabel.toLowerCase() + "_meeting_scheduled",
              title: meetingLabel + " Meeting Scheduled",
              message: activityByUserName + " scheduled a " + meetingLabel + " meeting for you on " + meetingDate,
              activityType: activity.type,
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/usermanagement"
            });

          case 22:
            _context15.next = 27;
            break;

          case 24:
            if (!isDeleted) {
              _context15.next = 27;
              break;
            }

            _context15.next = 27;
            return createNotif(activityOnUser, {
              type: meetingLabel.toLowerCase() + "_meeting_deleted",
              title: meetingLabel + " Meeting Cancelled",
              message: activityByUserName + " cancelled a " + meetingLabel + " meeting for you on " + meetingDate,
              activityType: activity.type,
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/usermanagement"
            });

          case 27:
            attendeeUids = (attendees || []).map(function (email) {
              return emailToUid[email];
            }).filter(Boolean);
            uniqueAttendees = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(attendeeUids))).filter(function (uid) {
              return uid && uid !== activityOnUser;
            });

            console.log("Unique attendees to notify:", uniqueAttendees);

            if (!uniqueAttendees.length) {
              _context15.next = 33;
              break;
            }

            _context15.next = 33;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(uniqueAttendees.map(function (uid) {
              if (!uid || uid === activityOnUser) return;

              return createNotif(uid, {
                type: isScheduled ? meetingLabel.toLowerCase() + "_meeting_invite" : meetingLabel.toLowerCase() + "_meeting_cancelled",

                title: isScheduled ? meetingLabel + " Meeting Invitation" : meetingLabel + " Meeting Cancelled",

                message: isScheduled ? activityByUserName + " scheduled a " + meetingLabel + " meeting for " + activityOnUserName + " on " + meetingDate : activityByUserName + " cancelled a " + meetingLabel + " meeting for " + activityOnUserName + " on " + meetingDate,

                activityType: activity.type,
                relatedUserId: activityOnUser,
                relatedUserName: activityOnUserName,
                performedByUserName: activityByUserName,
                navigateTo: "/usermanagement"
              });
            }));

          case 33:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function handleMeetingNotification(_x33, _x34) {
    return _ref15.apply(this, arguments);
  };
}();

function buildEmailToUidMap(allUsers) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(allUsers || {}).reduce(function (map, user) {
    if (user && user.email && user.uid) {
      map[user.email] = user.uid;
    }
    return map;
  }, {});
}

var handleCreateUserNotification = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee16(activity, allUsers, currentUserId) {
    var activityOnUser, activityOnUserName, activityByUserName, newUserName, desc, activityName, emailMatch, email;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            if (!(!activity || activity.type !== "create_user")) {
              _context16.next = 2;
              break;
            }

            return _context16.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            newUserName = activity.activityOnUserName || "a new user";
            desc = activity.activityDescription || "";
            activityName = activity.activityName || "";

            // Extract email  e.g. "with email naeem.test3@expertizo.pk"

            emailMatch = desc.match(/email\s+([\w.+-]+@[\w.+-]+)/);
            email = emailMatch ? emailMatch[1] : "";
            _context16.next = 12;
            return notifyAdmins(allUsers, {
              type: "user_created",
              title: activity.role === "admin" ? "User Access Updated" : "New User Created 👤",
              message: activityName,
              activityType: "create_user",
              performedByUserName: activityByUserName,
              navigateTo: "/usermanagement"
            }, currentUserId);

          case 12:
            _context16.next = 14;
            return createNotif(activityOnUser, {
              type: "onboarded",
              title: "Welcome to the Team, " + newUserName + "!",
              message: "Hi " + newUserName + ", your " + (activity.role === "admin" ? "admin" : "user") + " account has been created. We're excited to have you on board!",
              activityType: "create_user",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/user"
            });

          case 14:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function handleCreateUserNotification(_x35, _x36, _x37) {
    return _ref16.apply(this, arguments);
  };
}();

var handleUpdateUserNotification = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee17(activity, allUsers, currentUserId) {
    var activityOnUser, activityOnUserName, activityByUserName, desc, activityName, emailMatch, email, lowerDesc, isStatusChange, isRoleChange;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            if (!(!activity || activity.type !== "update_user")) {
              _context17.next = 2;
              break;
            }

            return _context17.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            desc = activity.activityDescription || "";
            activityName = activity.activityName || "";

            // Extract email (optional)

            emailMatch = desc.match(/email\s+([\w.+-]+@[\w.+-]+)/);
            email = emailMatch ? emailMatch[1] : "";

            // Normalize description for checks

            lowerDesc = desc.toLowerCase();
            isStatusChange = lowerDesc.includes("activated") || lowerDesc.includes("deactivated");
            isRoleChange = lowerDesc.includes("admin") || lowerDesc.includes("role") || lowerDesc.includes("changed");

            if (!isRoleChange) {
              _context17.next = 15;
              break;
            }

            _context17.next = 15;
            return createNotif(activityOnUser, {
              type: "user_updated",
              title: "User Access Updated",
              message: activityByUserName + ("" + (lowerDesc.includes("admin") ? " granted you admin access" : " removed your admin access")),
              activityType: "update_user",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/user"
            });

          case 15:
            if (!(isStatusChange || isRoleChange)) {
              _context17.next = 19;
              break;
            }

            _context17.next = 18;
            return notifyAdmins(allUsers, {
              type: "user_updated",
              title: "User Access Updated",
              message: activityName,
              activityType: "update_user",
              performedByUserName: activityByUserName,
              navigateTo: "/usermanagement"
            }, currentUserId);

          case 18:
            return _context17.abrupt("return");

          case 19:
            if (!activity.isAdmin) {
              _context17.next = 24;
              break;
            }

            _context17.next = 22;
            return createNotif(activityOnUser, {
              type: "profile_updated",
              title: "Your Profile Updated",
              message: activityByUserName + " updated your profile details",
              activityType: "update_user",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/user"
            });

          case 22:
            _context17.next = 26;
            break;

          case 24:
            _context17.next = 26;
            return notifyAdmins(allUsers, {
              type: "profile_updated",
              title: "User Profile Updated",
              message: activityName,
              activityType: "update_user",
              performedByUserName: activityByUserName,
              navigateTo: "/usermanagement"
            }, currentUserId);

          case 26:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function handleUpdateUserNotification(_x38, _x39, _x40) {
    return _ref17.apply(this, arguments);
  };
}();

var handleDeleteUserNotification = function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee18(activity, allUsers, currentUserId) {
    var activityByUserName, deletedUserName, desc, emailMatch, email;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            if (!(!activity || activity.type !== "delete_user")) {
              _context18.next = 2;
              break;
            }

            return _context18.abrupt("return");

          case 2:
            activityByUserName = activity.activityByUserName;
            deletedUserName = activity.activityOnUserName || "a user";
            desc = activity.activityDescription || "";

            // Extract email  e.g. "with email urgent.sole.rzdk@hidingmail.com"

            emailMatch = desc.match(/email\s+([\w.+-]+@[\w.+-]+)/);
            email = emailMatch ? emailMatch[1] : "";
            _context18.next = 9;
            return notifyAdmins(allUsers, {
              type: "user_deleted",
              title: "User Account Deleted",
              message: activityByUserName + " deleted the account of " + deletedUserName + (email ? " (" + email + ")" : ""),
              activityType: "delete_user",
              performedByUserName: activityByUserName,
              navigateTo: "/usermanagement"
            }, currentUserId);

          case 9:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, this);
  }));

  return function handleDeleteUserNotification(_x41, _x42, _x43) {
    return _ref18.apply(this, arguments);
  };
}();

var handlePayrollNotification = function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee19(activity) {
    var activityOnUser, activityOnUserName, activityByUserName, desc, isProcessed, isDraft, isDraftUpdate, monthMatch, yearMatch, period;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            if (!(!activity || activity.type !== "payroll")) {
              _context19.next = 2;
              break;
            }

            return _context19.abrupt("return");

          case 2:
            activityOnUser = activity.activityOnUser;
            activityOnUserName = activity.activityOnUserName;
            activityByUserName = activity.activityByUserName;
            desc = activity.activityDescription || "";

            if (activityOnUser) {
              _context19.next = 8;
              break;
            }

            return _context19.abrupt("return");

          case 8:
            isProcessed = desc.indexOf("processed payroll") !== -1;
            isDraft = desc.indexOf("saved the payroll draft") !== -1 || desc.indexOf("updated the payroll draft") !== -1;
            isDraftUpdate = desc.indexOf("updated the payroll draft") !== -1;

            if (!(!isProcessed && !isDraft)) {
              _context19.next = 13;
              break;
            }

            return _context19.abrupt("return");

          case 13:

            // Extract month and year  e.g. "for Adnan Rafiq for March 2026"
            monthMatch = desc.match(/(January|February|March|April|May|June|July|August|September|October|November|December)/);
            yearMatch = desc.match(/(\d{4})/);
            period = (monthMatch ? monthMatch[1] + " " : "") + (yearMatch ? yearMatch[1] : "");

            if (!isProcessed) {
              _context19.next = 21;
              break;
            }

            _context19.next = 19;
            return createNotif(activityOnUser, {
              type: "payroll_processed",
              title: "Payroll Processed",
              message: "Your payroll" + (period ? " for " + period : "") + " has been processed by " + activityByUserName,
              activityType: "payroll",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/payroll"
            });

          case 19:
            _context19.next = 24;
            break;

          case 21:
            if (!isDraft) {
              _context19.next = 24;
              break;
            }

            _context19.next = 24;
            return createNotif(activityOnUser, {
              type: "payroll_draft",
              title: "Payroll Draft Saved",
              message: "Your payroll draft" + (period ? " for " + period : "") + " has been " + (isDraftUpdate ? "updated" : "saved") + " by " + activityByUserName,
              activityType: "payroll",
              relatedUserId: activityOnUser,
              relatedUserName: activityOnUserName,
              performedByUserName: activityByUserName,
              navigateTo: "/payroll"
            });

          case 24:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, this);
  }));

  return function handlePayrollNotification(_x44) {
    return _ref19.apply(this, arguments);
  };
}();

// Employee added/updated/deleted one of their own expense adjustments → tell the admins
var handleExpenseNotification = function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee20(activity, allUsers, currentUserId) {
    var action, amount, period, titles, message;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            action = activity.action || "added";
            amount = Number(activity.amount) || 0;
            period = [activity.month, activity.year].filter(Boolean).join(" ");
            titles = { added: "New Expense Added", updated: "Expense Updated", deleted: "Expense Deleted" };
            message = activity.activityByUserName + " " + action + " an expense of Rs. " + amount.toLocaleString("en-US") + (period ? " for " + period : "") + (activity.description ? ": " + activity.description : "");
            _context20.next = 7;
            return notifyAdmins(allUsers, {
              type: "expense_" + action,
              title: titles[action] || "Expense",
              message: message,
              activityType: "expense",
              relatedUserId: activity.activityOnUser,
              relatedUserName: activity.activityOnUserName,
              performedByUserId: currentUserId,
              performedByUserName: activity.activityByUserName,
              navigateTo: "/payroll?tab=adjustments"
            }, currentUserId);

          case 7:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, this);
  }));

  return function handleExpenseNotification(_x45, _x46, _x47) {
    return _ref20.apply(this, arguments);
  };
}();

var handleActivityNotification = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee21(activity, authData, currentUserId) {
    var _ref22, companyUsers, allUsers, companyUids, allUsersMap;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            if (activity) {
              _context21.next = 2;
              break;
            }

            return _context21.abrupt("return");

          case 2:
            _ref22 = authData || {}, companyUsers = _ref22.company.users, allUsers = _ref22.allUsers;
            companyUids = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a((companyUsers || []).filter(function (u) {
              return u && u.uid;
            }).map(function (u) {
              return u.uid;
            }));
            allUsersMap = (allUsers || []).reduce(function (acc, user) {
              if (user && user.uid && companyUids.has(user.uid)) {
                acc[user.uid] = user;
              }
              return acc;
            }, {});
            _context21.t0 = activity.type;
            _context21.next = _context21.t0 === "leaves" ? 8 : _context21.t0 === "performance_edit" ? 9 : _context21.t0 === "performance_lock_unlock" ? 10 : _context21.t0 === "settings" ? 11 : _context21.t0 === "performance_criteria" ? 12 : _context21.t0 === "manual_hours" ? 13 : _context21.t0 === "quarterly" ? 14 : _context21.t0 === "increment" ? 15 : _context21.t0 === "create_user" ? 16 : _context21.t0 === "update_user" ? 17 : _context21.t0 === "delete_user" ? 18 : _context21.t0 === "payroll" ? 19 : _context21.t0 === "expense" ? 20 : 21;
            break;

          case 8:
            return _context21.abrupt("return", handleLeaveActivityNotification(activity, allUsersMap, currentUserId));

          case 9:
            return _context21.abrupt("return", handlePerformanceEditNotification(activity, allUsersMap, currentUserId));

          case 10:
            return _context21.abrupt("return", handlePerformanceLockUnlockNotification(activity, allUsersMap, currentUserId));

          case 11:
            return _context21.abrupt("return", handleSettingsNotification(activity, allUsersMap, currentUserId));

          case 12:
            return _context21.abrupt("return", handlePerformanceCriteriaNotification(activity, allUsersMap, currentUserId));

          case 13:
            return _context21.abrupt("return", handleManualHoursNotification(activity, allUsersMap, currentUserId));

          case 14:
            return _context21.abrupt("return", handleMeetingNotification(activity, allUsersMap));

          case 15:
            return _context21.abrupt("return", handleMeetingNotification(activity, allUsersMap));

          case 16:
            return _context21.abrupt("return", handleCreateUserNotification(activity, allUsersMap, currentUserId));

          case 17:
            return _context21.abrupt("return", handleUpdateUserNotification(activity, allUsersMap, currentUserId));

          case 18:
            return _context21.abrupt("return", handleDeleteUserNotification(activity, allUsersMap, currentUserId));

          case 19:
            return _context21.abrupt("return", handlePayrollNotification(activity));

          case 20:
            return _context21.abrupt("return", handleExpenseNotification(activity, allUsersMap, currentUserId));

          case 21:
            return _context21.abrupt("return");

          case 22:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, this);
  }));

  return function handleActivityNotification(_x48, _x49, _x50) {
    return _ref21.apply(this, arguments);
  };
}();

/***/ }),

/***/ "l5qH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"container-fluid"},[_c('Card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"header-actions"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search by email or description..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})])]},proxy:true}])},[_vm._v(" "),_c('CustomTable',{attrs:{"loading":_vm.loadingStates.table,"columns":_vm.tableColumns,"data":_vm.filteredBugs,"resetPage":_vm.resetTableFlag},on:{"update:resetPage":function($event){_vm.resetTableFlag=$event},"update:reset-page":function($event){_vm.resetTableFlag=$event}},scopedSlots:_vm._u([{key:"email",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text"},[_vm._v(_vm._s(item.email))])]}},{key:"description",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text"},[_vm._v(_vm._s(item.description))])]}},{key:"timestamp",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm.formatDate(item.timestamp))+"\n          ")]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('span',{class:_vm.getStatusClass(item.status)},[_vm._v("\n              "+_vm._s(item.status == "Resolved" ? "Resolved" : "Open")+"\n            ")])]}},{key:"open",fn:function(ref){
var item = ref.item;
return [_c('button',{staticClass:"btn-sm action-button",staticStyle:{"color":"white"},on:{"click":function($event){return _vm.openBug(item)}}},[_c('span',[_vm._v("Open")])])]}},{key:"action",fn:function(ref){
var item = ref.item;
return [_c('button',{staticClass:"btn btn-sm action-button",class:{ 'disabled-btn': item.status === 'Resolved' },attrs:{"disabled":_vm.loadingStates.updateStatus[item.id] || item.status === 'Resolved'},on:{"click":function($event){return _vm.handleUpdateBugStatus(item)}}},[_vm._v("\n              Mark as Resolved\n            ")])]}}])})],1),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isModalOpen,"title":"Bug Report Details","hideSubmit":true,"scrollable":true,"maxHeight":"70vh","submitButtonText":"Close","hideCancelButton":true},on:{"update:modelValue":function($event){_vm.isModalOpen = $event},"submit":function($event){_vm.isModalOpen = false}}},[(_vm.selectedBug)?_c('div',{staticClass:"bug-detail"},[_c('p',[_c('strong',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.selectedBug.email || 'N/A'))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Browser Name:")]),_vm._v(" "+_vm._s(_vm.selectedBug.browserName || 'N/A'))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("OS Name:")]),_vm._v(" "+_vm._s(_vm.selectedBug.osName || 'N/A'))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Priority:")]),_vm._v(" "+_vm._s(_vm.selectedBug.priority || 'N/A'))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Status:")]),_vm._v(" "+_vm._s(_vm.selectedBug.status == "Resolved" ? "Resolved" : "Open"))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Reported On:")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.selectedBug.timestamp)))]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('strong',[_vm._v("Description:")]),_vm._v(" "),_c('p',{staticClass:"description-box"},[_vm._v(_vm._s(_vm.selectedBug.description))])]),_vm._v(" "),(_vm.selectedBug.screenshot)?_c('div',{staticClass:"mt-3",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('strong',[_vm._v("Screenshot:")]),_vm._v(" "),_c('img',{staticClass:"bug-image",attrs:{"src":_vm.selectedBug.screenshot,"loading":"lazy"}})]):_vm._e()]):_vm._e()])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lKy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',[_c('template',{slot:"header"},[_c('h5',{staticClass:"title"},[_vm._v("Now Ui Table Heading")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Created using Montserrat Font Family")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h1',[_c('span',[_vm._v("Header 1")]),_vm._v("The Life of Now Ui Dashboard  ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h2',[_c('span',[_vm._v("Header 2")]),_vm._v("The Life of Now Ui Dashboard ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h3',[_c('span',[_vm._v("Header 3")]),_vm._v("The Life of Now Ui Dashboard ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h4',[_c('span',[_vm._v("Header 4")]),_vm._v("The Life of Now Ui Dashboard ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h5',[_c('span',[_vm._v("Header 5")]),_vm._v("The Life of Now Ui Dashboard ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h6',[_c('span',[_vm._v("Header 6")]),_vm._v("The Life of Now Ui Dashboard ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('p',[_c('span',[_vm._v("Paragraph")]),_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',[_c('p',{staticClass:"blockquote blockquote-primary"},[_vm._v("\n                \"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.\"\n\n                "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                  - Noaa\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Muted Text")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Primary Text")]),_vm._v(" "),_c('p',{staticClass:"text-primary"},[_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Info Text")]),_vm._v(" "),_c('p',{staticClass:"text-info"},[_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Success Text")]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Warning Text")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('span',[_vm._v("Danger Text")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_vm._v("\n              I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]),_vm._v(" "),_c('div',{staticClass:"typography-line"},[_c('h2',[_c('span',[_vm._v("Small Tag")]),_vm._v("\n              Header with small subtitle "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Use \"small\" tag for the headers")])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lYPq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaginationComponent_vue__ = __webpack_require__("LPQ1");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_4__PaginationComponent_vue__["a" /* default */]
  },
  props: {
    columns: Array,
    data: Array,
    defaultSortKey: {
      type: String,
      default: ""
    },
    defaultSortOrder: {
      type: String,
      default: "asc"
    },
    itemsPerPageOptions: {
      type: Array,
      default: function _default() {
        return [10, 15, 20];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    },
    totals: {
      type: Object,
      default: function _default() {
        return { reopened: 0, deadlineMissed: 0, score: 0 };
      }
    },
    resetPage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      sortKey: "",
      sortOrder: "", // Default to no sorting
      itemsPerPage: 20,
      pageOptions: [5, 10, 15, 20],
      hoveredRow: null,
      maxVisiblePages: 7
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("resize", function () {
      return _this.$forceUpdate();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    window.removeEventListener("resize", function () {
      return _this2.$forceUpdate();
    });
  },

  computed: {
    isMobile: function isMobile() {
      return window.innerWidth <= 768;
    },
    totalPages: function totalPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    visiblePages: function visiblePages() {
      var total = this.totalPages;
      var current = this.currentPage;
      var max = this.maxVisiblePages;

      if (total <= max) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()({ length: total }, function (_, i) {
          return i + 1;
        });
      }

      var half = Math.floor(max / 2);
      var start = current - half;
      var end = current + half;

      if (start < 1) {
        start = 1;
        end = max;
      }

      if (end > total) {
        end = total;
        start = total - max + 1;
      }

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()({ length: end - start + 1 }, function (_, i) {
        return start + i;
      });
    },
    sortedData: function sortedData() {
      var _this3 = this;

      var sorted = Array.isArray(this.data) ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.data)) : [];

      if (this.sortKey) {
        if (this.sortKey === 'dates') {
          var withSortValues = sorted.map(function (item) {
            var dateStr = item[_this3.sortKey];
            return {
              original: item,
              sortValue: _this3.getDateSortValue(dateStr)
            };
          });
          withSortValues.sort(function (a, b) {
            var modifier = _this3.sortOrder === "asc" ? 1 : -1;
            return (a.sortValue - b.sortValue) * modifier;
          });
          sorted = withSortValues.map(function (item) {
            return item.original;
          });
        } else {
          sorted.sort(function (a, b) {
            var modifier = _this3.sortOrder === "asc" ? 1 : -1;
            if (a[_this3.sortKey] < b[_this3.sortKey]) return -1 * modifier;
            if (a[_this3.sortKey] > b[_this3.sortKey]) return 1 * modifier;
            return 0;
          });
        }
      } else {
        sorted.sort(function (a, b) {
          return b.createdAt - a.createdAt;
        });
      }

      return sorted;
    },
    paginatedData: function paginatedData() {
      var start = (this.currentPage - 1) * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      return this.sortedData.slice(start, end);
    },
    tableClass: function tableClass() {
      var user = this.$store.state.auth.user;
      var path = this.$route && this.$route.path ? this.$route.path : '';
      if (path === '/usermanagement' && user.role == "admin") {
        return 'table-usermanagement';
      }
      if (path === '/performance' && user.role == "user") {
        return 'table-performance-employee';
      }
      if (path === '/usermanagement' && user.role == "user") {
        return 'table-usermanagement-employee';
      }
      if (path === '/chatbot') {
        return 'table-chatbotmanagement';
      }
      if (path === '/settings') {
        return 'table-chatbotmanagement';
      }
      if (path === '/activity-logs') {
        return 'admin-log';
      }
      if (path === '/reported-bugs') {
        return 'reported-bugs-table';
      }
      return user.role === 'admin' ? 'table-admin' : 'table-employee';
    }
  },
  methods: {
    isStickyDisabledOnMobile: function isStickyDisabledOnMobile(column) {
      var keys = ["profile_picture", "assignees", "assigneeName", "action", "status", "activityOnUserName", "description"];
      return this.isMobile && keys.includes(column.key);
    },
    getStickyOffset: function getStickyOffset(column, position) {
      var offset = 0;

      var ordered = position === "left" ? this.columns : [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.columns)).reverse();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(ordered), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          if (col === column) break;

          var isDisabledMobile = this.isStickyDisabledOnMobile(col);

          if (col.sticky === position && !isDisabledMobile) {
            offset += col.width || 150;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return offset + "px";
    },
    getHeaderStyle: function getHeaderStyle(column) {
      var disableStickyMobile = this.isStickyDisabledOnMobile(column);

      var style = {
        position: column.sticky && !disableStickyMobile ? "sticky" : "static",
        zIndex: column.sticky && !disableStickyMobile ? 2 : 1,
        background: column.sticky && !disableStickyMobile ? "#435851" : "inherit",
        color: "white",
        textAlign: "center",
        cursor: column.sortable ? "pointer" : "default",
        width: column.width ? column.width + "px" : "auto"
      };

      if (!disableStickyMobile) {
        if (column.sticky === "left") {
          style.left = this.getStickyOffset(column, "left");
        }
        if (column.sticky === "right") {
          style.right = this.getStickyOffset(column, "right");
        }
      }

      return style;
    },
    getCellStyle: function getCellStyle(column, item) {
      var disableStickyMobile = this.isStickyDisabledOnMobile(column);

      var style = {
        position: column.sticky && !disableStickyMobile ? "sticky" : "static",
        zIndex: column.sticky && !disableStickyMobile ? 2 : 1,
        background: column.sticky ? "#ffffff" : this.getCellBackground(item, column),
        borderLeft: column.sticky ? '#ccc' : 'inherit',
        width: column.width ? column.width + "px" : "auto",
        maxWidth: column.width ? column.width + "px" : "200px"
      };

      if (!disableStickyMobile) {
        if (column.sticky === "left") {
          style.left = this.getStickyOffset(column, "left");
        }
        if (column.sticky === "right") {
          style.right = this.getStickyOffset(column, "right");
        }
      }

      return style;
    },
    getCellBackground: function getCellBackground(item, column) {
      if (column.sticky) {
        if (this.hoveredRow === item) {
          return '#f1eded';
        }
        return 'inherit';
      }
    },
    getDateSortValue: function getDateSortValue(dateStr) {
      if (!dateStr) return 0;

      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        var _dateStr$split$map = dateStr.split('-').map(Number),
            _dateStr$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_dateStr$split$map, 3),
            month = _dateStr$split$map2[1],
            day = _dateStr$split$map2[2];

        return month * 100 + day;
      }

      try {
        var date = dateStr;
        if (dateStr.includes('-')) {
          date = dateStr.split('-')[0].trim();
        }
        var parts = date.split(' ');
        if (parts.length !== 2) {
          console.warn("Invalid date format: " + dateStr);
          return 0;
        }

        var monthStr = parts[0];
        var dayStr = parts[1];
        var monthMap = {
          'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
          'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
        };

        if (!monthMap[monthStr]) {
          console.warn("Invalid month: " + monthStr + " in " + dateStr);
          return 0;
        }
        var _day = parseInt(dayStr, 10);
        if (isNaN(_day)) {
          console.warn("Invalid day: " + dayStr + " in " + dateStr);
          return 0;
        }
        var sortValue = monthMap[monthStr] * 100 + _day;
        console.log("Parsed \"" + dateStr + "\" as " + sortValue);
        return sortValue;
      } catch (error) {
        console.error("Error parsing date: " + dateStr, error);
        return 0;
      }
    },
    changePage: function changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    sortTable: function sortTable(key) {
      if (this.sortKey === key) {
        if (this.sortOrder === "asc") {
          this.sortOrder = "desc";
        } else if (this.sortOrder === "desc") {
          this.sortOrder = "";
          this.sortKey = "";
        } else {
          this.sortOrder = "asc";
        }
      } else {
        this.sortOrder = "asc";
        this.sortKey = key;
      }
    },
    changeItemsPerPage: function changeItemsPerPage(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.changePage(1);
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function handler(newValue) {
        if (Array.isArray(newValue) && newValue.length && this.defaultSortKey) {
          this.sortKey = this.defaultSortKey;
          this.sortOrder = this.defaultSortOrder;
        }
      }
    },
    resetPage: function resetPage(newVal) {
      if (newVal) {
        this.currentPage = 1;
        this.$emit('update:resetPage', false);
      }
    }
  }
});

/***/ }),

/***/ "lm93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-footer"},[_c('div',{staticClass:"footer-bug-button"},[_c('span',{on:{"click":function($event){_vm.isBugModalOpen = true}}},[_vm._v("\n      Report A Bug\n    ")])]),_vm._v(" "),_c('BugReportModal',{attrs:{"isOpen":_vm.isBugModalOpen},on:{"update:isOpen":function($event){_vm.isBugModalOpen = $event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m3dc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mATD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPayrollObject;
/* unused harmony export getLeavesTooltip */
/* harmony export (immutable) */ __webpack_exports__["b"] = processLeavesData;
/* unused harmony export getStatusClass */
/* unused harmony export getLeavesTaken */
/* unused harmony export getLateDeductionTooltip */
/* unused harmony export formatLateDeduction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_config_helpers__ = __webpack_require__("DJ6O");




function createPayrollObject(payrollId, payroll) {
    var _ref;

    return _ref = {
        payrollId: payrollId,
        employeeId: payroll.employeeId || "Employee",
        employeeName: payroll.employeeName || "Employee",
        isSuperAdmin: payroll.isSuperAdmin || false,
        joiningDate: payroll.joiningDate,
        employeeDesignation: payroll.employeeDesignation || "",
        grossSalary: calculateGrossSalary(payroll),
        calculatedSalary: calculateSalary(payroll),
        finalAmount: Number(payroll.finalAmount || 0).toFixed(2),
        basicSalary: Number(payroll.basicSalary || 0),
        extraAllowance: Number(payroll.extraAllowance || 0),
        perDaySalary: Number(payroll.perDaySalary || 0),
        extraAmountAdjustment: Number(payroll.extraAmountAdjustment || 0),
        bonus: Number(payroll.bonus || 0),
        daysWorked: Number(payroll.daysWorked || 0),
        requiredWorkingDays: Number(payroll.requiredWorkingDays || 0),
        productiveHours: Number(payroll.productiveHours || 0),
        obtainedLeaves: "" + (payroll.obtainedLeaves || 0),
        leavesTaken: Number(payroll.leavesTaken || 0),
        absents: Number(payroll.absents || 0),
        actualAbsents: Number(payroll.actualAbsents || 0),
        lateDeduction: "" + (Number(payroll.lateDeduction) || '0 - 0'),
        month: payroll.month,
        year: Number(payroll.year || 0),
        transactionFees: Number(payroll.transactionFees || 0),
        lateArrivals: Number(payroll.lateArrivals || 0),
        lateDeductionDays: Number(payroll.lateDeductionDays || 0),
        status: payroll.status,
        shift: (payroll.shift || "Morning").toLowerCase(),
        remainingLeaves: Number(payroll.remainingLeaves || 0),
        carryForwardDays: payroll.leavesQuota ? Number(payroll.leavesQuota.carryForwardDays || 0) : 0,
        updatedLeaveQuota: payroll.leavesQuota ? Number(payroll.leavesQuota.updatedLeaveQuota || 0) : 0,
        annualLeavesEncashmentDays: payroll.leavesQuota ? Number(payroll.leavesQuota.leavesEncashmentDays || 0) : 0,
        leavesQuota: payroll.leavesQuota || {},
        leavesEncashmentDays: Number(payroll.leavesEncashmentDays || 0),
        leavesEncashmentAmount: Number(payroll.leavesEncashmentAmount || 0)
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "annualLeavesEncashmentDays", Number(payroll.annualLeavesEncashmentDays || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "monthlyLeaves", payroll.monthlyLeaves || []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalNormalHours", Number(payroll.totalNormalHours || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalExtraHours", Number(payroll.totalExtraHours || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "lowHoursDays", payroll.lowHoursDays || {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalLowHours", Number(payroll.totalLowHours || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "reqWorkingHours", Number(payroll.reqWorkingHours || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "leaveBalance", Number(payroll.leaveBalance || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "extraAmountAdjustmentNote", payroll.extraAmountAdjustmentNote || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "leaveDeductionNote", payroll.leaveDeductionNote || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "leavesDeductionDays", payroll.leavesDeductionDays || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "perDayProductiveHours", payroll.perDayProductiveHours || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "remainingHalfDays", payroll.remainingHalfDays || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "halfDays", payroll.halfDays || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalHalfDayHours", payroll.totalHalfDayHours || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "normalDaysWorked", payroll.normalDaysWorked || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "newLeaveBalance", payroll.newLeaveBalance || ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "requiredTotalWorkingHours", Number(payroll.requiredTotalWorkingHours || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "leavesAllowed", Number(payroll.leavesAllowed || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "leavesAvailable", Number(payroll.leavesAvailable || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "DBLeavesTaken", Number(payroll.DBLeavesTaken || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "requiredTotalWorkingDays", payroll.requiredTotalWorkingDays || {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "normalHoursDays", payroll.normalHoursDays || {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "absentDays", payroll.absentDays || {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalExtraHoursDays", payroll.totalExtraHoursDays || {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "empTotalHours", payroll.empTotalHours || 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "normalHoursDays", payroll.normalHoursDays || {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "taxDeduction", Number(payroll.taxDeduction || 0)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "eligibleHolidayDetails", payroll.eligibleHolidayDetails || []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "workingDays", payroll.workingDays), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "employeeStatus", payroll.employeeStatus), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "lastWorkingDate", payroll.lastWorkingDate || null), _ref;
}

function calculateGrossSalary(payroll) {
    return Number(payroll.basicSalary || payroll.salary || 0) + Number(payroll.extraAllowance || 0);
}

function calculateSalary(payroll) {
    return Number(payroll.perDaySalary || 0) * Number(payroll.daysWorked || 0);
}

function getLeavesTooltip(item) {
    var parts = (item.obtainedLeaves || '0 / 0').split(' / ');
    return "Remaining Leaves: " + Number(parts[1] || 0);
}

function processLeavesData(leavesData, selectedMonthShort, selectedYear) {
    var maxDays = 0;
    var firstLeaveBalance = 0;
    var latestLeave = null;

    // Convert leaves data to array and sort by creation date
    var leavesArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(leavesData).map(function (key) {
        return leavesData[key];
    }).sort(function (a, b) {
        return a.createdAt - b.createdAt;
    });

    // Process each leave
    for (var i = 0; i < leavesArray.length; i++) {
        var leave = leavesArray[i];
        var leaveYear = new Date(leave.createdAt).getFullYear();

        if (leave.status === "Approved" && leaveYear == selectedYear) {
            var leaveDates = leave.dates.split(" - ");
            var monthMatch = leaveDates.some(function (date) {
                return date.startsWith(selectedMonthShort);
            });

            if (monthMatch) {
                // Track first leave balance
                if (firstLeaveBalance === 0 && leave.leavesBalance) {
                    firstLeaveBalance = parseFloat(leave.leavesBalance);
                }

                // Track latest leave
                if (!latestLeave || leave.createdAt > latestLeave.createdAt) {
                    latestLeave = leave;
                }

                // Add approved leave dates
                leaveDates.forEach(function (date) {
                    __WEBPACK_IMPORTED_MODULE_2__assets_config_helpers__["d" /* approvedLeaveDatesSet */].add(date);
                });

                // Sum total leave days
                maxDays += leave.noofdays ? leave.noofdays : 0;
            }
        }
    }

    console.log("leave max days", maxDays);

    return {
        obtainedLeaves: latestLeave ? maxDays : 0,
        leaveBalance: firstLeaveBalance
    };
}

// Helper methods for template
function getStatusClass(status) {
    return {
        'payroll-table-status-processed': status === 'Processed',
        'payroll-table-status-draft': status === 'Draft',
        'payroll-table-status-pending': status !== 'Processed' && status !== 'Draft'
    };
}

function getLeavesTaken(item) {
    var parts = (item.obtainedLeaves || '0 / 0').split(' / ');
    return parts[0] || 0;
}

function getLateDeductionTooltip(item) {
    var parts = (item.lateDeduction || '0 - 0').split(' - ');
    return "Late Deduction Days: " + (parts[1] || 0);
}

function formatLateDeduction(item) {
    var parts = (item.lateDeduction || '0 - 0').split(' - ');
    return (parseFloat(parts[0]) || 0).toFixed(2);
}

/***/ }),

/***/ "mAgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_9__UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_10__UIComponents_CustomDropdown_vue__["a" /* default */]
  },

  created: function created() {
    var _this = this;

    var store = this.$store;
    this.user = store.state.auth.user;
    this.role = store.state.auth.user.role;
    this.labels = store.state.complains.trelloLabels;

    this.complainsListId = store.state.complains.trelloListIds && store.state.complains.trelloListIds.complainsListId || null;
    this.resolvedListId = store.state.complains.trelloListIds && store.state.complains.trelloListIds.resolvedListId || null;

    this.assignees = store.state.complains.assignees ? store.state.complains.assignees.map(function (assignee) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, assignee, {
        fullName: assignee.fullName.includes('_') ? assignee.fullName.split('_').map(function (word) {
          return word[0].toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ') : assignee.fullName
      });
    }) : [];

    store.commit("loadingStarts");

    this.fetchData();

    store.watch(function () {
      return store.state.complains.cardsData;
    }, function (newCardsData) {
      console.log("Cards data updated:", newCardsData);
    });

    store.watch(function () {
      return store.state.complains.assignees;
    }, function (newAssignees) {
      _this.assignees = newAssignees ? newAssignees.map(function (assignee) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, assignee, {
          fullName: assignee.fullName.includes('_') ? assignee.fullName.split('_').map(function (word) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
          }).join(' ') : assignee.fullName
        });
      }) : [];
      console.log("Assignees updated from store:", _this.assignees);
    });

    store.watch(function () {
      return store.getters.getUser;
    }, function () {
      _this.role = store.state.auth.user.role;
    });
  },
  data: function data() {
    return {
      dialog: false,
      title: "",
      description: "",
      assigneeId: null,
      selectedAssigneeName: "",
      user: null,
      role: null,
      labels: null,
      moment: __WEBPACK_IMPORTED_MODULE_7_moment___default.a,
      complainsListId: null,
      resolvedListId: null,
      isEdit: false,
      editUserId: "",
      assignees: [],
      plan: "",
      usersAllow: 0,
      priority: "Normal",
      issueType: "General",
      priorityOptions: ["High", "Normal"],
      issueTypeOptions: ["General", "Personal"],
      feedbackDialog: false,
      feedbackRating: 0,
      feedbackComment: "",
      currentFeedbackItem: null,
      isSubmitting: false,
      visibleDetails: {},
      tableColumns: [{ label: "Assignee", key: "assigneeName", sortable: true, width: 170 }, { label: "Title", key: "name", sortable: true }, { label: "Description", key: "desc" }, { label: "Priority", key: "isHighPriority", sortable: true }, { label: "Issue Type", key: "isPersonal", sortable: true }, { label: "Last Activity", key: "dateLastActivity", sortable: true }, { label: "Feedback", key: "feedback", width: 140 }, { label: "Status", key: "status" }]
    };
  },


  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    },
    assigneeOptions: function assigneeOptions() {
      return this.assignees.map(function (assignee) {
        return assignee.fullName;
      });
    },
    items: function items() {
      var _this2 = this;

      var processedItems = (this.$store.state.complains.cardsData || []).map(function (item) {
        var title = item.name;
        var email = '';
        if (typeof item.name === 'string' && item.name.includes(' - ')) {
          var _item$name$split = item.name.split(' - ');

          var _item$name$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_item$name$split, 2);

          title = _item$name$split2[0];
          email = _item$name$split2[1];
        }

        var feedback = null;
        var originalDesc = item.desc || '';
        if (item.desc && item.desc.includes('Feedback Submitted')) {
          var parts = item.desc.split('Feedback Submitted');
          originalDesc = parts[0].trim();
          var lastFeedbackPart = parts.pop().trim();
          var ratingMatch = lastFeedbackPart.match(/Rating:\s*([⭐]+)\s*\((\d+)\)/);
          var commentMatch = lastFeedbackPart.match(/Comment:\s*"([^"]*)"/);

          if (ratingMatch) {
            feedback = {
              rating: parseInt(ratingMatch[2]),
              comment: commentMatch ? commentMatch[1] : ""
            };
          }
        }
        console.log('Processing item:', item.name, 'extracted email:', email, 'user email:', _this2.user ? _this2.user.email : 'undefined', 'status:', item.status, 'has feedback:', !!feedback);
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, { title: title, email: email, feedback: feedback, originalDesc: originalDesc });
      });
      console.log('Computed items:', processedItems);
      return processedItems;
    }
  },

  methods: {
    formatRelativeTime: function formatRelativeTime(timestamp) {
      if (!timestamp) return 'Just now';
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(timestamp).fromNow();
    },
    fetchData: function fetchData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this3.$store.dispatch("fetchAllTrelloData");

              case 3:
                _this3.assignees = _this3.$store.state.complains.assignees ? _this3.$store.state.complains.assignees.map(function (assignee) {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, assignee, {
                    fullName: assignee.fullName.includes('_') ? assignee.fullName.split('_').map(function (word) {
                      return word[0].toUpperCase() + word.slice(1).toLowerCase();
                    }).join(' ') : assignee.fullName
                  });
                }) : [];
                console.log("fetchData - Assignees:", _this3.assignees);
                _this3.$store.commit("loadingEnds");
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                _this3.$store.commit("loadingEnds");

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 8]]);
      }))();
    },
    getStatusClass: function getStatusClass(status) {
      return {
        Resolved: "status-badge resolved",
        Pending: "status-badge pending"
      }[status] || "status-badge";
    },
    clearItems: function clearItems() {
      this.isEdit = false;
      this.dialog = false;
      this.title = "";
      this.description = "";
      this.assigneeId = null;
      this.selectedAssigneeName = "";
      this.editUserId = "";
      this.priority = "Normal";
      this.issueType = "General";
    },
    openAddComplainModal: function openAddComplainModal() {
      this.dialog = true;
    },
    handleAssigneeChange: function handleAssigneeChange(value) {
      var selectedAssignee = this.assignees.find(function (assignee) {
        return assignee.fullName === value;
      });
      if (selectedAssignee) {
        this.assigneeId = selectedAssignee.id;
        this.selectedAssigneeName = selectedAssignee.fullName;
      }
    },
    handlePriorityChange: function handlePriorityChange(value) {
      this.priority = value;
    },
    handleIssueTypeChange: function handleIssueTypeChange(value) {
      this.issueType = value;
    },
    addComplain: function addComplain() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var title, description, assigneeId, labels, complainsListId, email, isHighPriority, isPersonal, isGeneral, memberIds, labelIds, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$store.commit("loadingStarts");
                title = _this4.title, description = _this4.description, assigneeId = _this4.assigneeId, labels = _this4.labels, complainsListId = _this4.complainsListId;
                email = _this4.user.email;
                isHighPriority = _this4.priority === "High";
                isPersonal = _this4.issueType === "Personal";
                isGeneral = _this4.issueType === "General";
                memberIds = assigneeId ? [assigneeId] : [];
                labelIds = _this4.getLabelIds(isHighPriority, isPersonal, isGeneral, labels);
                _context2.prev = 8;

                _this4.validateInputs(title, description, isPersonal, isGeneral, complainsListId);
                _context2.next = 12;
                return _this4.createTrelloCard(title, email, description, labelIds, memberIds, complainsListId);

              case 12:
                response = _context2.sent;

                if (!(response && response.id)) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 16;
                return _this4.$store.dispatch('updateCardsData', { updatedCard: response });

              case 16:
                _this4.clearItems();
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Great", "Added", "success");
                _context2.next = 21;
                break;

              case 20:
                throw new Error("Failed to create card");

              case 21:
                _context2.next = 27;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](8);

                console.log("Error:", _context2.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Oops!", _context2.t0.message || "Something went wrong", "error");

              case 27:
                _context2.prev = 27;

                _this4.$store.commit("loadingEnds");
                return _context2.finish(27);

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[8, 23, 27, 30]]);
      }))();
    },
    getLabelIds: function getLabelIds(isHighPriority, isPersonal, isGeneral, labels) {
      var labelIds = [];

      if (isHighPriority) labelIds.push(labels.highPriorityLabelId);
      if (isPersonal) labelIds.push(labels.personalLabelId);else if (isGeneral) labelIds.push(labels.generalLabelId);

      return labelIds;
    },
    validateInputs: function validateInputs(title, description, isPersonal, isGeneral, complainsListId) {
      if (!title.trim() || !description.trim()) {
        throw new Error("Title and Description are required");
      }
      if (!isPersonal && !isGeneral) {
        throw new Error("Please provide the issue type");
      }
      if (!complainsListId) {
        throw new Error("The provided list name is not present in your trello board");
      }
    },
    createTrelloCard: function createTrelloCard(title, email, description, labelIds, memberIds, complainsListId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var apiKey, token, payload, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
                token = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";


                console.log("process.env.PROD_VUE_APP_TRELLO_API_TOKEN", "ATTA21440b3581fd44dea9e0dd9f3d2f250621355173a84d49e0847d44247425ea4bA72ADDB3");
                payload = {
                  idList: complainsListId,
                  name: title + " - " + email,
                  desc: description,
                  idLabels: labelIds,
                  pos: 1,
                  idMembers: memberIds
                };
                _context3.next = 6;
                return fetch("https://api.trello.com/1/cards?key=" + apiKey + "&token=" + token, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
                });

              case 6:
                response = _context3.sent;
                _context3.next = 9;
                return response.json();

              case 9:
                data = _context3.sent;

                if (!response.ok) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return", data);

              case 14:
                throw new Error(data.error || "Something went wrong creating the card");

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    openFeedbackModal: function openFeedbackModal(item) {
      this.currentFeedbackItem = item;
      this.feedbackRating = 0;
      this.feedbackComment = "";
      this.feedbackDialog = true;
    },
    submitFeedback: function submitFeedback() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var stars, feedbackText, newDesc, commentText, apiKey, token, cardId, descResponse, commentResponse;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this6.feedbackRating === 0)) {
                  _context4.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Error", "Please select a rating", "error");
                return _context4.abrupt("return");

              case 3:
                if (!_this6.isSubmitting) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                _this6.isSubmitting = true;

                stars = '⭐'.repeat(_this6.feedbackRating);
                feedbackText = "Feedback Submitted\n\n      * Rating: " + stars + " (" + _this6.feedbackRating + ")\n      * Comment: \"" + _this6.feedbackComment + "\"\n      Submitted by: " + _this6.user.email;
                newDesc = _this6.currentFeedbackItem.desc ? _this6.currentFeedbackItem.desc + "\n\n" + feedbackText : feedbackText;
                commentText = "Rating: " + stars + " (" + _this6.feedbackRating + ") \u2014 " + _this6.feedbackComment + " (by " + _this6.user.email + ")";


                _this6.$store.commit("loadingStarts");

                _context4.prev = 11;
                apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
                token = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
                cardId = _this6.currentFeedbackItem.id;
                _context4.next = 17;
                return fetch("https://api.trello.com/1/cards/" + cardId + "?key=" + apiKey + "&token=" + token, {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ desc: newDesc })
                });

              case 17:
                descResponse = _context4.sent;

                if (descResponse.ok) {
                  _context4.next = 20;
                  break;
                }

                throw new Error("Failed to update card description");

              case 20:
                _context4.next = 22;
                return fetch("https://api.trello.com/1/cards/" + cardId + "/actions/comments?key=" + apiKey + "&token=" + token, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ text: commentText })
                });

              case 22:
                commentResponse = _context4.sent;

                if (commentResponse.ok) {
                  _context4.next = 25;
                  break;
                }

                throw new Error("Failed to post feedback comment");

              case 25:
                _context4.next = 27;
                return _this6.$store.dispatch("fetchAllTrelloData");

              case 27:
                _this6.feedbackDialog = false;
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Success", "Feedback submitted", "success");
                _context4.next = 35;
                break;

              case 31:
                _context4.prev = 31;
                _context4.t0 = _context4["catch"](11);

                console.error(_context4.t0);
                __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()("Error", "Failed to submit feedback", "error");

              case 35:
                _context4.prev = 35;

                _this6.$store.commit("loadingEnds");
                _this6.isSubmitting = false;
                return _context4.finish(35);

              case 39:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[11, 31, 35, 39]]);
      }))();
    },
    showDetails: function showDetails(id) {
      this.$set(this.visibleDetails, id, true);
    },
    hideDetails: function hideDetails(id) {
      this.$set(this.visibleDetails, id, false);
    }
  }
});

/***/ }),

/***/ "mHo8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("04Xd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46e085a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("A6/+");
function injectStyle (ssrContext) {
  __webpack_require__("GszA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46e085a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46e085a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mZEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsSection_vue__ = __webpack_require__("yn5O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1710bb3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsSection_vue__ = __webpack_require__("MFg3");
function injectStyle (ssrContext) {
  __webpack_require__("BCof")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1710bb3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1710bb3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mat/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__ = __webpack_require__("f4OB");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffd4e6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__ = __webpack_require__("lKy/");
function injectStyle (ssrContext) {
  __webpack_require__("0NQk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffd4e6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "mq8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDocx;
/* harmony export (immutable) */ __webpack_exports__["c"] = isPdf;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateFileSize; });
/* harmony export (immutable) */ __webpack_exports__["a"] = formatToLocaleString;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatAdminActivityDate;
/* harmony export (immutable) */ __webpack_exports__["f"] = formatHolidayDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip__ = __webpack_require__("PMNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jszip__);





function isDocx(file) {
  return file && file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
}

function isPdf(file) {
  return file && file.type === 'application/pdf';
}

var validateFileSize = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(file) {
    var maxSizeMB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var maxBytes, DOCX_TYPE, PDF_TYPE, headerBuffer, headerText, tailBuffer, tailText, arrayBuffer, zip, documentXmlFile, documentXml, textContent;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            maxBytes = maxSizeMB * 1024 * 1024;

            if (file) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "No file selected" });

          case 3:
            if (!(file.size === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "File is empty (0 bytes)" });

          case 5:
            if (!(file.size > maxBytes)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return', {
              ok: false,
              message: 'Maximum allowed file size is ' + maxSizeMB + ' MB'
            });

          case 7:
            DOCX_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            PDF_TYPE = "application/pdf";

            if (!(file.type === PDF_TYPE || file.name.toLowerCase().endsWith(".pdf"))) {
              _context.next = 31;
              break;
            }

            _context.prev = 10;

            if (!(file.size < 1000)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "PDF file is too small or empty" });

          case 13:
            _context.next = 15;
            return file.slice(0, 5).arrayBuffer();

          case 15:
            headerBuffer = _context.sent;
            headerText = new TextDecoder().decode(headerBuffer);

            if (!(headerText !== "%PDF-")) {
              _context.next = 19;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "Invalid or corrupted PDF file" });

          case 19:
            _context.next = 21;
            return file.slice(file.size - 5, file.size).arrayBuffer();

          case 21:
            tailBuffer = _context.sent;
            tailText = new TextDecoder().decode(tailBuffer);

            if (tailText.includes("EOF")) {
              _context.next = 25;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "Corrupted PDF file" });

          case 25:
            return _context.abrupt('return', { ok: true });

          case 28:
            _context.prev = 28;
            _context.t0 = _context['catch'](10);
            return _context.abrupt('return', { ok: false, message: "Unable to read PDF file" });

          case 31:
            if (!(file.type === DOCX_TYPE || file.name.toLowerCase().endsWith(".docx"))) {
              _context.next = 56;
              break;
            }

            _context.prev = 32;

            if (!(file.size < 8000)) {
              _context.next = 35;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "DOCX file is too small and likely empty" });

          case 35:
            _context.next = 37;
            return file.arrayBuffer();

          case 37:
            arrayBuffer = _context.sent;
            _context.next = 40;
            return __WEBPACK_IMPORTED_MODULE_3_jszip___default.a.loadAsync(arrayBuffer);

          case 40:
            zip = _context.sent;
            documentXmlFile = zip.file("word/document.xml");

            if (documentXmlFile) {
              _context.next = 44;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "Invalid DOCX file structure" });

          case 44:
            _context.next = 46;
            return documentXmlFile.async("text");

          case 46:
            documentXml = _context.sent;
            textContent = documentXml.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();

            if (!(!textContent || textContent.length < 20)) {
              _context.next = 50;
              break;
            }

            return _context.abrupt('return', { ok: false, message: "DOCX file contains no real content" });

          case 50:
            return _context.abrupt('return', { ok: true });

          case 53:
            _context.prev = 53;
            _context.t1 = _context['catch'](32);
            return _context.abrupt('return', { ok: false, message: "Corrupted DOCX file" });

          case 56:
            return _context.abrupt('return', {
              ok: false,
              message: "Only PDF and DOCX files are allowed"
            });

          case 57:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[10, 28], [32, 53]]);
  }));

  return function validateFileSize(_x) {
    return _ref.apply(this, arguments);
  };
}();

function formatToLocaleString(dateStr) {
  if (!dateStr) return '-';
  var d = new Date(dateStr);
  return d.toLocaleString();
}

function formatAdminActivityDate(input) {
  var alreadyFormatted = /^[A-Za-z]{3}\s\d{1,2},\s\d{4}\s\d{1,2}:\d{2}\s(am|pm)$/i;

  if (alreadyFormatted.test(input)) {
    return input;
  }

  var _input$split = input.split(', '),
      _input$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_input$split, 2),
      datePart = _input$split2[0],
      timePart = _input$split2[1];

  var _datePart$split$map = datePart.split('/').map(Number),
      _datePart$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_datePart$split$map, 3),
      day = _datePart$split$map2[0],
      month = _datePart$split$map2[1],
      year = _datePart$split$map2[2];

  var _timePart$split = timePart.split(' '),
      _timePart$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_timePart$split, 2),
      time = _timePart$split2[0],
      meridiem = _timePart$split2[1];

  var _time$split = time.split(':'),
      _time$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];

  var date = new Date(year, month - 1, day, meridiem.toLowerCase() === 'pm' && hours !== '12' ? Number(hours) + 12 : meridiem.toLowerCase() === 'am' && hours === '12' ? 0 : Number(hours), Number(minutes));

  var formatted = date.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  return formatted.replace(',', '').replace(' AM', ' am').replace(' PM', ' pm');
}

function formatHolidayDate(dateStr) {
  var oneTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var numberOfDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (!dateStr) return "-";

  var start = new Date(dateStr);
  if (isNaN(start.getTime())) return "-";

  var startMonth = start.toLocaleDateString("en-US", { month: "long" });
  var startDay = start.getDate();
  var year = start.getFullYear();

  if (numberOfDays === 1) {
    return oneTime ? startMonth + ' ' + startDay + ', ' + year : startMonth + ' ' + startDay;
  }

  var end = new Date(start);
  end.setDate(start.getDate() + numberOfDays - 1);

  var endMonth = end.toLocaleDateString("en-US", { month: "long" });
  var endDay = end.getDate();

  if (startMonth === endMonth) {
    return oneTime ? startMonth + ' ' + startDay + ' - ' + endDay + ', ' + year : startMonth + ' ' + startDay + ' - ' + endDay;
  } else {
    return oneTime ? startMonth + ' ' + startDay + ' - ' + endMonth + ' ' + endDay + ', ' + year : startMonth + ' ' + startDay + ' - ' + endMonth + ' ' + endDay;
  }
}

/***/ }),

/***/ "n45B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nAm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-salary-calculation-container"},[_c('div',{staticClass:"payroll-salary-calculation-panel"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-panel-body"},[_c('div',{staticClass:"payroll-salary-calculation-form-group"},[_c('label',[_vm._v("Total Days Salary (PKR) "),_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v(_vm._s(_vm.formattedPerDayWorkedSalary)+" * ("+_vm._s(_vm.selectedEmployee.daysWorked || 0)+" Days)")])]),_vm._v(" "),_c('input',{staticClass:"payroll-disabled-field",attrs:{"type":"text","disabled":"","min":"0"},domProps:{"value":_vm.totalDaysSalaryInputComputed}})]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-form-group"},[_c('label',{staticStyle:{"position":"relative"}},[_vm._v("Late Deduction (PKR) "),_c('span',{staticClass:"salary-calculation-minus"},[_vm._v("-")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v("\n                        ("+_vm._s(_vm.formattedPerHoursalary)+" / hr * "+_vm._s(_vm.calculatedSalaryDeductionDays * 4)+"x)\n                    ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lateSalaryDeductionUpdate),expression:"lateSalaryDeductionUpdate"}],staticClass:"payroll-disabled-field",attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0","min":"0","disabled":""},domProps:{"value":(_vm.lateSalaryDeductionUpdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lateSalaryDeductionUpdate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-form-group"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","flex-wrap":"wrap"}},[_c('div',{staticClass:"input-with-reset"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"payroll-leave-info-icon",on:{"mouseover":_vm.showLeavesInfo,"mouseleave":_vm.hideLeavesInfo}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isleaveInfoVisible)?_c('div',{staticClass:"payroll-leave-info-tooltip"},[(!_vm.getLeavesAllowed)?_c('div',[_vm._v("\n                                    Disabled due to 0 Leave Balance."),_c('br')]):_vm._e(),_vm._v(" "),(_vm.leavesEncashmentDetails)?[_c('b',[_vm._v("Monthly Leaves Details:")]),_vm._v(" "),_c('ul',_vm._l((_vm.leavesEncashmentDetails.details),function(item,index){return _c('li',{key:'leave-' + index},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('b',[_vm._v("Late Arrival Penalty Policy:")]),_vm._v(" "),_c('ul',_vm._l((_vm.formattedLeavePolicy),function(rule,idx){return _c('li',{key:'policy-' + idx},[_vm._v(_vm._s(rule))])}),0)]:[_c('p',[_vm._v("No leaves taken for this month.")])]],2):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v(_vm._s(_vm.formattedLeavesTakenSalary)+" * ("+_vm._s(this.leavesDaysReducedByLate + _vm.calculateAnnualLeavesEncashmentDays || 0)+" Days)\n                    ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.leavesEncashmentAmountUpdate),expression:"leavesEncashmentAmountUpdate",modifiers:{"number":true}}],staticClass:"payroll-disabled-field",attrs:{"type":"number","min":"0","disabled":_vm.isDisabled,"placeholder":"0","disabled":""},domProps:{"value":(_vm.leavesEncashmentAmountUpdate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.leavesEncashmentAmountUpdate=_vm._n($event.target.value)},_vm.handleLeaveEncashment],"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Adjustments (PKR) ")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('extraAmountAdjustmentInput'); }}})],1),_vm._v(" "),_c('div',{staticClass:"adjustment-summary-container"},[_c('span',{staticStyle:{"font-size":"smaller"}},[_vm._v("\n                        Low/Extra Hours Sum:\n                        → "),_c('span',{style:({ color: _vm.totalSummary.difference.color || 'green' })},[_vm._v(_vm._s(_vm.totalSummary.difference.text))])]),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":_vm.showAdjustmentInfo,"mouseleave":_vm.hideAdjustmentInfo}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen","margin-top":"-2px"}}),_vm._v(" "),(_vm.isAdjustmentInfoVisible)?_c('div',{staticClass:"required-hours-tooltip-box",staticStyle:{"margin-left":"-150px"}},[_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"required-hours-tooltip-summary-heading"},[_vm._v("Summary:")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px","border-top":"1px dashed #aaa","font-size":"11px"}},[_c('div',[_c('b',{staticClass:"required-hours-tooltip-summary-bold"},[_vm._v("Extra Hours:")]),_vm._v("\n                                    "+_vm._s(_vm.totalSummary.cumulativeOvertimeHours)+"\n                                ")]),_vm._v(" "),_c('div',[_c('b',{staticClass:"required-hours-tooltip-summary-bold"},[_vm._v("Unpaid Low Hours:")]),_vm._v("\n                                    "+_vm._s(_vm.totalSummary.lowAndRemainingLow)+"\n                                ")]),_vm._v(" "),_c('div',[_c('b',{staticClass:"required-hours-tooltip-summary-bold"},[_vm._v("Paid Low Hours:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("-"+_vm._s(_vm.totalSummary.remainingNormalHours))])]),_vm._v(" "),_c('div',{staticClass:"div-top-divider",style:({ backgroundColor: '#cccccc7d' })},[_c('b',{staticClass:"required-hours-tooltip-summary-bold-total"},[_vm._v("Total:")]),_vm._v(" "),_c('span',{style:({ color: _vm.totalSummary.difference.color })},[_vm._v("\n                                        "+_vm._s(_vm.totalSummary.grandTotal)+"\n                                    ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"required-hours-tooltip-summary-heading",staticStyle:{"margin-top":"10px"}},[_vm._v("Hours\n                                Details")]),_vm._v(" "),_vm._l((_vm.tooltipSections.slice(0, 4)),function(ref,index){
var title = ref.title;
var items = ref.items;
var key = ref.key;
return [(items && items.length)?_c('div',[_c('div',{staticClass:"required-hours-tooltip-header"},[_vm._v("\n                                        "+_vm._s(title)+" ("+_vm._s(items.length)+")\n                                        "),(_vm.totalsMap[key])?_c('span',{style:({ color: key === 'remainingNormalHours' ? 'red' : _vm.totalsMap[key].color, marginLeft: '10px' })},[_vm._v("\n                                            — Total: "+_vm._s(_vm.totalsMap[key].text)+"\n                                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"required-hours-tooltip-list"},[_c('ul',_vm._l((items),function(item,index2){return _c('li',{key:(key + "-" + index2)},[_vm._v(_vm._s(item)+"\n                                            ")])}),0)]),_vm._v(" "),_c('br')]):_vm._e()]}),_vm._v(" "),_vm._l((_vm.tooltipSections.slice(4)),function(ref,index){
var title = ref.title;
var items = ref.items;
var key = ref.key;
return [(items && items.length)?_c('div',[_c('div',{staticClass:"required-hours-tooltip-header"},[_vm._v("\n                                        "+_vm._s(title)+" ("+_vm._s(items.length)+")\n                                        "),(_vm.totalsMap[key])?_c('span',{style:({ color: key === 'remainingNormalHours' ? 'red' : _vm.totalsMap[key].color, marginLeft: '10px' })},[_vm._v("\n                                        — Total: "+_vm._s(_vm.totalsMap[key].text)+"\n                                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"required-hours-tooltip-list"},[_c('ul',_vm._l((items),function(item,index2){return _c('li',{key:(key + "-" + index2)},[_vm._v(_vm._s(item)+"\n                                            ")])}),0)]),_vm._v(" "),_c('br')]):_vm._e()]})],2):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper adjustment-days-tag",style:({ color: _vm.totalSummary.difference.color || 'green' }),on:{"mouseenter":function($event){_vm.adjustmentShowHoverTooltip = true},"mouseleave":function($event){_vm.adjustmentShowHoverTooltip = false}}},[_vm._v("\n                        "+_vm._s(_vm.totalSummary.difference.days)+"\n                        "),(_vm.adjustmentShowHoverTooltip)?_c('div',{staticClass:"required-hours-tooltip-box adjustment-tooltip-box"},[_c('div',{staticClass:"tooltip-label"},[_vm._v("\n                                Click below to\n                                "),_c('strong',[_vm._v(_vm._s(_vm.appliedAdjustments['lowExtraHours'] ? 'Remove' : 'Add'))]),_vm._v("\n                                Rs. "),_c('strong',[_vm._v(_vm._s(_vm.calcExtraAmountAdjustment))])]),_vm._v(" "),_c('button',{staticClass:"tooltip-action-btn",class:{ 'btn-add': !_vm.appliedAdjustments['lowExtraHours'], 'btn-remove': _vm.appliedAdjustments['lowExtraHours'] },attrs:{"disabled":_vm.calcExtraAmountAdjustment === 0},on:{"click":function($event){_vm.applyAdjustment(_vm.calcExtraAmountAdjustment, ("Rs. " + (Math.abs(_vm.calcExtraAmountAdjustment)) + " for Low/Extra Hours Sum: " + (_vm.totalSummary.difference.text)))}}},[_vm._v("\n                                "+_vm._s(_vm.appliedAdjustments['lowExtraHours'] ? 'Remove' : 'Add')+"\n                            ")])]):_vm._e()])]),_vm._v(" "),(_vm.adjustments && _vm.adjustments.length)?_c('div',{staticClass:"adjustment-summary-container"},[_c('span',{staticStyle:{"font-size":"smaller"}},[_vm._v("\n                        Other Adjustments: "),_c('span',[_vm._v(_vm._s(_vm.totalAdjustments))])]),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":_vm.showAdjustmentDetails,"mouseleave":_vm.hideAdjustmentDetails}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen","margin-bottom":"7px"}}),_vm._v(" "),(_vm.isAdjustmentDetailsVisible)?_c('div',{staticClass:"required-hours-tooltip-box payroll-adjustment-info-tooltip"},[_c('ul',{staticStyle:{"list-style":"none","padding":"0","margin":"0"}},_vm._l((_vm.adjustments),function(adj){return _c('li',{key:adj.id,staticClass:"adjustment-card"},[_c('div',{staticClass:"adjustment-card-content",attrs:{"title":adj.reason},on:{"click":function($event){$event.stopPropagation();return _vm.toggleAdjustment(adj)}}},[_c('div',{staticClass:"adjustment-card-details"},[_c('span',[_vm._v("Rs. "+_vm._s(Math.round(Math.abs(typeof adj.amount === 'number' ? adj.amount : _vm.calculateAdjustmentAmount(adj.amount))))+" "+_vm._s((adj.amount.includes('x') || adj.amount.includes('day')) ? ("(" + (adj.amount) + ")") : '')+" ("),_c('span',[_vm._v(_vm._s(adj.adjustmentType))]),_vm._v(")")]),_vm._v(" "),_c('span',{staticClass:"adjustment-card-reason"},[_vm._v(_vm._s(adj.reason.length > 30 ? adj.reason.substring(0, 30) + '...' : adj.reason))]),_vm._v(" "),(adj.receiptUrl)?_c('a',{staticClass:"adjustment-card-receipt",attrs:{"href":adj.receiptUrl,"target":"_blank","rel":"noopener"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("View receipt")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn-adjust",class:{ 'btn-add': !_vm.appliedAdjustments[adj.id], 'btn-remove': _vm.appliedAdjustments[adj.id] }},[(!_vm.appliedAdjustments[adj.id])?_c('i',{staticClass:"fas fa-plus"}):_c('i',{staticClass:"fas fa-minus"})])])])}),0)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraAmountAdjustmentInput),expression:"extraAmountAdjustmentInput"}],class:{ 'updated-field': _vm.hasChanged('extraAmountAdjustmentInput') },attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0"},domProps:{"value":(_vm.extraAmountAdjustmentInput)},on:{"wheel":function($event){return $event.target.blur()},"input":function($event){if($event.target.composing){ return; }_vm.extraAmountAdjustmentInput=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Adjustment Note")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('extraAmountAdjustmentNote'); }}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraAmountAdjustmentNoteInput),expression:"extraAmountAdjustmentNoteInput"}],staticClass:"payroll-adjustment-textarea",class:{ 'updated-field': _vm.hasChanged('extraAmountAdjustmentNoteInput') },attrs:{"disabled":_vm.isDisabled,"placeholder":"Optional note about adjustment"},domProps:{"value":(_vm.extraAmountAdjustmentNoteInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.extraAmountAdjustmentNoteInput=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Bonus (PKR)")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('bonusInput'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonusInput),expression:"bonusInput"}],class:{ 'updated-field': _vm.hasChanged('bonusInput') },attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0","min":"0"},domProps:{"value":(_vm.bonusInput)},on:{"wheel":function($event){return $event.target.blur()},"input":function($event){if($event.target.composing){ return; }_vm.bonusInput=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-form-group",staticStyle:{"display":"flex","gap":"10px"}},[_c('div',{staticStyle:{"width":"45%"}},[_c('div',{staticClass:"input-with-reset"},[_vm._m(3),_vm._v(" "),_c('span',{staticClass:"required-hours-tooltip-wrapper",on:{"mouseover":_vm.showTaxInfo,"mouseleave":_vm.hideTaxInfo}},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"yellowgreen"}}),_vm._v(" "),(_vm.isTaxInfoVisible)?_c('div',{staticClass:"required-hours-tooltip-box",staticStyle:{"margin-left":"-150px"}},[_c('b',[_vm._v("Income Tax Slabs:")]),_vm._v(" "),_c('ul',_vm._l((_vm.formattedTaxSlabs),function(slab,index){return _c('li',{key:index},[_vm._v(_vm._s(slab))])}),0)]):_vm._e()])]),_vm._v(" "),_c('input',{staticClass:"payroll-disabled-field",attrs:{"type":"number","disabled":"","placeholder":"0"},domProps:{"value":_vm.taxDeduction}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"45%"}},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Transaction Fees (PKR)")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetIfEmpty('transactionFeesInput'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactionFeesInput),expression:"transactionFeesInput"}],class:{ 'updated-field': _vm.hasChanged('transactionFeesInput') },attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0","min":"0"},domProps:{"value":(_vm.transactionFeesInput)},on:{"wheel":function($event){return $event.target.blur()},"input":function($event){if($event.target.composing){ return; }_vm.transactionFeesInput=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"payroll-salary-calculation-summary"},[_c('div',{staticClass:"summary-row final"},[_c('div',{staticClass:"label"},[_vm._v("Final Amount:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("PKR "+_vm._s(_vm.finalAmountUpdate()))])])]),_vm._v(" "),(!_vm.isDisabled)?_c('div',{staticClass:"payroll-salary-calculation-actions"},[_c('div',{staticClass:"right-buttons"},[(!_vm.isProcessed && !_vm.isPaymentProcessed && !_vm.isDraftProcessed && this.employee.status !== 'Draft')?_c('button',{staticClass:"payroll-salary-calculation-btn btn-outline",on:{"click":_vm.saveDraft}},[_c('span',{staticClass:"save-icon"},[_vm._v("💾")]),_vm._v(" Save Draft\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentProcessed && _vm.isDraftProcessed)?_c('button',{staticClass:"payroll-salary-calculation-btn btn-secondary",on:{"click":_vm.updateDraft}},[_vm._v("\n                        Update Draft\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.isPaymentProcessed && _vm.isDraftProcessed)?_c('button',{staticClass:"payroll-salary-calculation-btn btn-danger",on:{"click":_vm.deleteDraft}},[_vm._v("\n                        Delete Draft\n                    ")]):_vm._e(),_vm._v(" "),_c('button',{class:[
                        'payroll-salary-calculation-btn',
                        _vm.isPaymentProcessed ? 'payroll-btn-success' : _vm.isProcessing ? 'btn-success' : 'btn-success',
                        { 'button-loading': _vm.isProcessing }
                    ],attrs:{"disabled":_vm.isProcessing || _vm.isPaymentProcessed},on:{"click":_vm.processPayment}},[(_vm.isProcessing)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"margin-right":"10px"}}),_vm._v(" Generating...\n                        ")]):(_vm.isPaymentProcessed)?_c('span',[_c('i',{staticClass:"fa fa-check-circle",staticStyle:{"margin-right":"10px"}}),_vm._v(" Payslip Generated\n                        ")]):_c('span',[_c('i',{staticClass:"fa fa-credit-card",staticStyle:{"margin-right":"10px"}}),_vm._v(" Payslip Generate\n                        ")])]),_vm._v(" "),(_vm.isPaymentProcessed)?_c('button',{staticClass:"payslip-download",on:{"click":this.handleDownloadClick}},[_c('i',{staticClass:"fa fa-download",staticStyle:{"color":"#3D5953","font-size":"24px"}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(!this.isAdmin && this.employee.status === 'Processed')?_c('div',{staticClass:"payslip-download-acton"},[_c('button',{class:[
                    'payroll-salary-calculation-btn', 'payroll-btn-success'],staticStyle:{"margin-top":"20px"}},[_vm._m(4)]),_vm._v(" "),(_vm.isPaymentProcessed)?_c('button',{staticClass:"payslip-download",on:{"click":this.handleDownloadClick}},[_c('i',{staticClass:"fa fa-download",staticStyle:{"color":"#3D5953","font-size":"20px"}})]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('PaySlip',{attrs:{"employee":this.employee,"isPaymentProcessed":_vm.isPaymentProcessed}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-salary-calculation-panel-header"},[_c('span',{staticClass:"icon"},[_vm._v("💰")]),_vm._v(" "),_c('h2',[_vm._v("Salary Calculation")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"position":"relative","margin-right":"5px"}},[_vm._v("Leaves Encashment (PKR) "),_c('span',{staticClass:"salary-calculation-plus"},[_vm._v("+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v("Note: ")]),_vm._v("Total required hours do not include absents, approved leaves, or half\n                                days.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Tax Deduction (PKR) "),_c('span',{staticClass:"salary-calculation-minus"},[_vm._v("-")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-check-circle",staticStyle:{"margin-right":"10px"}}),_vm._v(" Payment Processed\n                    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nG85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminComplains_vue__ = __webpack_require__("DV2+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmployeeComplains_vue__ = __webpack_require__("Km+3");
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AdminComplains: __WEBPACK_IMPORTED_MODULE_0__AdminComplains_vue__["a" /* default */],
    EmployeeComplains: __WEBPACK_IMPORTED_MODULE_1__EmployeeComplains_vue__["a" /* default */]
  },
  data: function data() {
    var user = this.$store.state.auth.user;
    return {
      isAdmin: user && user.role === "admin"
    };
  }
});

/***/ }),

/***/ "nI6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AdjustmentTable_vue__ = __webpack_require__("TwCE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_genralSpecificSettings__ = __webpack_require__("TvP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_perdaySallaryUtils__ = __webpack_require__("yLp5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_cloudinary__ = __webpack_require__("SJFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_notificationService__ = __webpack_require__("l527");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var MAX_RECEIPT_BYTES = 5 * 1024 * 1024;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Adjustments",
  components: {
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_CustomDropdown_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_ReuseableModal_vue__["a" /* default */],
    AdjustmentTable: __WEBPACK_IMPORTED_MODULE_8__AdjustmentTable_vue__["a" /* default */]
  },
  props: {
    selectedMonth: String,
    selectedYear: Number,
    employeeList: Array,
    isAdmin: Boolean,
    selectedEmployee: Object,
    constants: Object
  },
  data: function data() {
    return {
      loading: false,
      isModalOpen: false,
      isDeleteModalOpen: false,
      isLoading: false,
      isEditMode: false,
      currentAdjustment: null,
      deleteItem: null,
      selectedAdjustmentType: "",
      amount: null,
      customAmount: null,
      reason: "",
      selectedModalMonth: this.selectedMonth || "",
      selectedModalYear: String(this.selectedYear) || "",
      selectedEmployeeId: this.selectedEmployee ? this.selectedEmployee.username : "",
      typeError: "",
      amountError: "",
      monthError: "",
      yearError: "",
      employeeError: "",
      reasonError: "",
      adjustments: [],
      expenseAmount: null,
      receiptFile: null,
      receiptUrl: "",
      receiptError: "",
      processedMonths: {}, // "<year>_<month>" -> true when the current user's payroll is processed
      workingDays: [],
      workingHours: 9,
      workingDaysInMonth: 1
    };
  },

  computed: {
    adjustmentTypeOptions: function adjustmentTypeOptions() {
      return this.isAdmin ? ["Fine", "Bonus", "Advance Loan", "Expense"] : ["Expense"];
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user || {};
    },
    isExpense: function isExpense() {
      return this.selectedAdjustmentType === "Expense";
    },
    modalTitle: function modalTitle() {
      if (!this.isAdmin) return this.isEditMode ? "Edit Expense" : "Add Expense";
      return "Add/Edit Adjustment";
    },
    monthItems: function monthItems() {
      return __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["a" /* monthNames */];
    },
    yearItems: function yearItems() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__assets_config_helpers__["t" /* generateYearsArray */])().map(function (year) {
        return String(year);
      });
    },
    employeeOptions: function employeeOptions() {
      return this.employeeList.map(function (user) {
        return user.username;
      });
    },
    filteredAdjustments: function filteredAdjustments() {
      var _this = this;

      return this.adjustments.filter(function (adj) {
        var monthMatch = !_this.selectedMonth || adj.month === _this.selectedMonth;
        var yearMatch = !_this.selectedYear || Number(adj.year) === Number(_this.selectedYear);
        var employeeMatch = !_this.selectedEmployee || adj.employeeId === _this.selectedEmployee.id;
        return monthMatch && yearMatch && employeeMatch;
      });
    },
    amountOptions: function amountOptions() {
      var _this2 = this;

      var employee = this.employeeList.find(function (emp) {
        return emp.username === _this2.selectedEmployeeId;
      });
      if (!employee || !employee.basicSalary || !this.selectedModalMonth || !this.selectedModalYear) {
        return ["Custom Value", "1x", "2x", "3x", "4x", "5x", "1day", "2days"];
      }

      var empWorkingDays = this.workingDays.length > 0 ? this.workingDays : employee.workingDays || this.constants.days || ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

      var empTotalHours = this.workingHours || Number(employee.productiveHours) || Number(this.constants.totalHours) || 9;

      var selectedMonthNum = __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["a" /* monthNames */].indexOf(this.selectedModalMonth) + 1;
      var selectedYearNum = parseInt(this.selectedModalYear);
      var requiredWorkingDaysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__assets_config_helpers__["g" /* calculateTotalWorkingDays */])(selectedYearNum, selectedMonthNum, empWorkingDays);

      if (requiredWorkingDaysInMonth === 0) {
        return ["Custom Value", "1x", "2x", "3x", "4x", "5x", "1day", "2days"];
      }

      var perDaySalary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_perdaySallaryUtils__["a" /* calculatePerDaySalary */])(employee.basicSalary, employee.extraAllowance || 0, requiredWorkingDaysInMonth);
      var perHourSalary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_perdaySallaryUtils__["b" /* calculatePerHourSalary */])(perDaySalary, empTotalHours);

      var calc = function calc(n, isDay) {
        return (isDay ? perDaySalary * n : perHourSalary * n).toFixed(2);
      };

      var options = [calc(1, false) + " (1x)", calc(2, false) + " (2x)", calc(3, false) + " (3x)", calc(4, false) + " (4x)", calc(5, false) + " (5x)", calc(1, true) + " (1 day)", calc(2, true) + " (2 days)", "Custom Value"];

      if (this.isEditMode && this.currentAdjustment && /^\d+$/.test(String(this.currentAdjustment.amount))) {
        options.unshift(String(this.currentAdjustment.amount));
      }

      return options;
    },
    reasonLength: function reasonLength() {
      return this.reason.length;
    }
  },
  watch: {
    selectedMonth: function selectedMonth(newMonth) {
      this.selectedModalMonth = newMonth || "";
      this.fetchAdjustments();
      this.getSettingData();
    },
    selectedYear: function selectedYear(newYear) {
      this.selectedModalYear = String(newYear) || "";
      this.fetchAdjustments();
      this.getSettingData();
    },
    amount: function amount(newAmount) {
      if (newAmount !== "Custom Value") this.customAmount = null;
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.fetchAdjustments();

            case 2:
              _context.next = 4;
              return _this3.getSettingData();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },

  methods: {
    getSettingData: function getSettingData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userId, response, selectedMonthNum, selectedYearNum;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                userId = _this4.selectedEmployee ? _this4.selectedEmployee.id : null;
                _context2.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_genralSpecificSettings__["a" /* settings */])(userId, _this4.constants || {
                  days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                  totalHours: 9
                });

              case 4:
                response = _context2.sent;

                if (response) {
                  _this4.workingDays = Array.isArray(response.days) ? response.days : response.days ? [response.days] : [];
                  _this4.workingHours = response.totalHours || 9;
                } else {
                  _this4.workingDays = _this4.constants.days || [];
                  _this4.workingHours = _this4.constants.totalHours || 9;
                }
                // Calculate working days for the selected month
                selectedMonthNum = __WEBPACK_IMPORTED_MODULE_10__assets_config_constants__["a" /* monthNames */].indexOf(_this4.selectedModalMonth) + 1;
                selectedYearNum = parseInt(_this4.selectedModalYear);

                _this4.workingDaysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__assets_config_helpers__["g" /* calculateTotalWorkingDays */])(selectedYearNum, selectedMonthNum, _this4.workingDays);
                _context2.next = 17;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);

                console.error("Error fetching settings:", _context2.t0);
                _this4.workingDays = _this4.constants.days || [];
                _this4.workingHours = _this4.constants.totalHours || 9;
                _this4.workingDaysInMonth = 1;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 11]]);
      }))();
    },
    fetchAdjustments: function fetchAdjustments() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userId, own;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.loading = true;
                _context3.prev = 1;

                if (!_this5.isAdmin) {
                  _context3.next = 9;
                  break;
                }

                userId = _this5.selectedEmployee ? _this5.selectedEmployee.id : null;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].getAdjustments(_this5.selectedYear, _this5.selectedMonth, userId);

              case 6:
                _this5.adjustments = _context3.sent;
                _context3.next = 15;
                break;

              case 9:
                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].getAdjustments(_this5.selectedYear, _this5.selectedMonth, _this5.currentUser.uid);

              case 11:
                own = _context3.sent;

                _this5.adjustments = own.filter(function (adj) {
                  return adj.adjustmentType === "Expense";
                });
                _context3.next = 15;
                return _this5.refreshProcessedMonths();

              case 15:
                _context3.next = 22;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](1);

                __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Error", "Failed to load adjustments.", "error");
                console.error("Error:", _context3.t0);
                _this5.adjustments = [];

              case 22:
                _context3.prev = 22;

                _this5.loading = false;
                return _context3.finish(22);

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 17, 22, 25]]);
      }))();
    },
    openAddModal: function openAddModal() {
      this.resetForm();
      this.isEditMode = false;
      if (!this.isAdmin) {
        this.selectedAdjustmentType = "Expense";
        this.selectedEmployeeId = this.currentUser.username || "";
      }
      this.isModalOpen = true;
    },
    refreshProcessedMonths: function refreshProcessedMonths() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var periods, processed;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                periods = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(_this6.adjustments.map(function (adj) {
                  return adj.year + "_" + adj.month;
                }));

                if (_this6.selectedMonth && _this6.selectedYear) periods.add(_this6.selectedYear + "_" + _this6.selectedMonth);
                processed = {};
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(periods)).map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(key) {
                    var _key$split, _key$split2, year, month;

                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _key$split = key.split("_"), _key$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_key$split, 2), year = _key$split2[0], month = _key$split2[1];
                            _context4.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].isPayrollProcessed(year, month, _this6.currentUser.uid);

                          case 3:
                            processed[key] = _context4.sent;

                          case 4:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this6);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 5:
                _this6.processedMonths = processed;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },

    // Never throws: a failed notification shouldn't fail the save
    notifyAdminsOfExpense: function notifyAdminsOfExpense(action, adjustment) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "expense",
                  action: action,
                  amount: adjustment.amount,
                  month: adjustment.month,
                  year: adjustment.year,
                  description: adjustment.reason,
                  activityOnUser: _this7.currentUser.uid,
                  activityOnUserName: _this7.currentUser.username,
                  activityByUserName: _this7.currentUser.username
                }, _this7.$store.state.auth, _this7.currentUser.uid);

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);

                console.warn("Failed to notify admins about expense:", _context6.t0);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 5]]);
      }))();
    },

    // Admins can change any adjustment; employees only their own expenses in a month that isn't processed yet
    canModify: function canModify(item) {
      if (this.isAdmin) return true;
      return item.adjustmentType === "Expense" && item.employeeId === this.currentUser.uid && !this.processedMonths[item.year + "_" + item.month];
    },
    onReceiptSelected: function onReceiptSelected(event) {
      var file = event.target.files && event.target.files[0];
      this.receiptError = "";
      if (!file) return;
      var isAllowed = file.type.startsWith("image/") || file.type === "application/pdf";
      if (!isAllowed) {
        this.receiptError = "Receipt must be an image or PDF";
      } else if (file.size > MAX_RECEIPT_BYTES) {
        this.receiptError = "Receipt must be 5 MB or smaller";
      } else {
        this.receiptFile = file;
        return;
      }
      event.target.value = "";
    },
    removeReceipt: function removeReceipt() {
      this.receiptFile = null;
      this.receiptUrl = "";
      this.receiptError = "";
      if (this.$refs.receiptInput) this.$refs.receiptInput.value = "";
    },
    openEditModal: function openEditModal(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var employee, stored, dropdownValue, num, label;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.currentAdjustment = item;
                _this8.selectedAdjustmentType = item.adjustmentType;
                _this8.reason = item.reason;
                _this8.selectedModalMonth = item.month;
                _this8.selectedModalYear = String(item.year);
                employee = _this8.employeeList.find(function (emp) {
                  return emp.uid === item.employeeId;
                }) || {};

                _this8.selectedEmployeeId = employee.username || "";
                _context7.next = 9;
                return _this8.getSettingData();

              case 9:

                _this8.expenseAmount = item.adjustmentType === "Expense" ? Number(item.amount) || null : null;
                _this8.receiptUrl = item.receiptUrl || "";
                _this8.receiptFile = null;
                _this8.receiptError = "";
                stored = String(item.amount).trim();
                dropdownValue = null;


                if (/^\d+$/.test(stored)) {
                  dropdownValue = stored;
                  _this8.customAmount = Number(stored);
                } else if (/^\d+x$/.test(stored)) {
                  dropdownValue = _this8.amountOptions.find(function (o) {
                    return o.includes("(" + stored + ")");
                  });
                } else if (/^\d+days?$/.test(stored)) {
                  num = stored.match(/^\d+/)[0];
                  label = num === "1" ? "1 day" : num + " days";

                  dropdownValue = _this8.amountOptions.find(function (o) {
                    return o.includes("(" + label + ")");
                  });
                }

                _this8.amount = dropdownValue || "Custom Value";
                _this8.isEditMode = true;
                _this8.isModalOpen = true;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    handleAmountChange: function handleAmountChange(newAmount) {
      this.amount = newAmount;
      if (newAmount === "Custom Value") {
        this.customAmount = this.isEditMode && /^\d+$/.test(String(this.currentAdjustment.amount)) ? Number(this.currentAdjustment.amount) : null;
      } else {
        this.customAmount = null;
      }
    },
    openDeleteModal: function openDeleteModal(item) {
      this.deleteItem = item;
      this.isDeleteModalOpen = true;
    },
    selectAdjustmentType: function selectAdjustmentType(type) {
      this.selectedAdjustmentType = type;
    },
    selectModalMonth: function selectModalMonth(month) {
      this.selectedModalMonth = month;
    },
    selectModalYear: function selectModalYear(year) {
      this.selectedModalYear = year;
    },
    selectEmployeeId: function selectEmployeeId(name) {
      this.selectedEmployeeId = name;
      this.amount = null;
      this.customAmount = null;
    },
    validateForm: function validateForm() {
      this.employeeError = this.isAdmin && !this.selectedEmployeeId ? "Employee is required" : "";
      this.typeError = !this.selectedAdjustmentType ? "Type is required" : "";
      this.monthError = !this.selectedModalMonth ? "Month is required" : "";
      this.yearError = !this.selectedModalYear ? "Year is required" : "";
      this.reasonError = !this.reason ? "Reason is required" : this.reason.length > 300 ? "Max 300 characters" : "";
      if (this.isExpense) {
        this.amountError = !(Number(this.expenseAmount) > 0) ? "Enter an amount greater than 0" : "";
      } else {
        this.amountError = !this.amount ? "Amount is required" : this.amount === "Custom Value" && !this.customAmount ? "Enter custom amount" : "";
      }

      return !this.employeeError && !this.typeError && !this.monthError && !this.yearError && !this.reasonError && !this.amountError && !this.receiptError;
    },


    /*** SAVE WITH TOAST MESSAGES ***/
    saveAdjustment: function saveAdjustment() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var employee, year, storedAmount, match, raw, adjustmentData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this9.validateForm()) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                _this9.isLoading = true;
                _context8.prev = 3;
                employee = _this9.isAdmin ? _this9.employeeList.find(function (emp) {
                  return emp.username === _this9.selectedEmployeeId;
                }) || {} : { uid: _this9.currentUser.uid, username: _this9.currentUser.username };
                year = Number(_this9.selectedModalYear);
                _context8.t0 = !_this9.isAdmin;

                if (!_context8.t0) {
                  _context8.next = 11;
                  break;
                }

                _context8.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].isPayrollProcessed(year, _this9.selectedModalMonth, employee.uid);

              case 10:
                _context8.t0 = _context8.sent;

              case 11:
                if (!_context8.t0) {
                  _context8.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Payroll already processed", "Your payroll for " + _this9.selectedModalMonth + " " + year + " is already processed. Choose another month.", "warning");
                return _context8.abrupt("return");

              case 14:
                storedAmount = void 0;

                if (_this9.isExpense) {
                  // Stored as a plain number string, which payroll treats as a fixed amount
                  storedAmount = String(Number(_this9.expenseAmount));
                } else if (_this9.amount === "Custom Value") {
                  storedAmount = _this9.customAmount;
                } else {
                  match = _this9.amount.match(/\((\d+(?:x| ?days?))\)/i);

                  if (match) {
                    raw = match[1]; // "1 day" → "1day"

                    storedAmount = raw;
                    if (storedAmount.includes('day') && !storedAmount.endsWith('s') && storedAmount !== '1 day') {
                      storedAmount += 's';
                    }
                  } else {
                    storedAmount = /^\d+$/.test(_this9.amount) ? _this9.amount : "1x";
                  }
                }

                adjustmentData = {
                  employeeId: employee.uid || "",
                  employeeName: employee.username || "Unknown",
                  adjustmentType: _this9.selectedAdjustmentType,
                  amount: storedAmount,
                  reason: _this9.reason,
                  month: _this9.selectedModalMonth,
                  year: year,
                  impact: { Fine: "Deduction", Bonus: "Addition", "Advance Loan": "Deduction", Expense: "Addition" }[_this9.selectedAdjustmentType] || "Deduction",
                  createdAt: Date.now(),
                  addedBy: _this9.currentUser.username || "Admin"
                };

                if (!_this9.isExpense) {
                  _context8.next = 26;
                  break;
                }

                if (!_this9.receiptFile) {
                  _context8.next = 24;
                  break;
                }

                _context8.next = 21;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_cloudinary__["a" /* uploadToCloudinary */])(_this9.receiptFile, "expense_receipts", "salary_slip");

              case 21:
                _context8.t1 = _context8.sent;
                _context8.next = 25;
                break;

              case 24:
                _context8.t1 = _this9.receiptUrl || "";

              case 25:
                adjustmentData.receiptUrl = _context8.t1;

              case 26:
                if (_this9.isEditMode && _this9.currentAdjustment) {
                  adjustmentData.id = _this9.currentAdjustment.id;
                }
                _context8.next = 29;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].postAdjustment(adjustmentData);

              case 29:
                if (_this9.isAdmin) {
                  _context8.next = 32;
                  break;
                }

                _context8.next = 32;
                return _this9.notifyAdminsOfExpense(_this9.isEditMode ? "updated" : "added", adjustmentData);

              case 32:
                _context8.next = 34;
                return _this9.fetchAdjustments();

              case 34:

                _this9.isEditMode ? __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Success", "adjustment updated successfully.", "success") : __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Success", "Adjustment added successfully.", "success");

                _this9.isModalOpen = false;
                _context8.next = 42;
                break;

              case 38:
                _context8.prev = 38;
                _context8.t2 = _context8["catch"](3);

                console.error("Save failed:", _context8.t2);
                __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Error", "Failed to save adjustment. Please try again.", "error");

              case 42:
                _context8.prev = 42;

                _this9.isLoading = false;
                return _context8.finish(42);

              case 45:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[3, 38, 42, 45]]);
      }))();
    },
    confirmDelete: function confirmDelete() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this10.deleteItem) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _this10.isLoading = true;
                _context9.prev = 3;
                _context9.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].deleteAdjustment(_this10.deleteItem.id);

              case 6:
                if (_this10.isAdmin) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 9;
                return _this10.notifyAdminsOfExpense("deleted", _this10.deleteItem);

              case 9:
                _context9.next = 11;
                return _this10.fetchAdjustments();

              case 11:
                __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Success", "Adjustment deleted successfully.", "success");
                _this10.isDeleteModalOpen = false;
                _this10.isLoading = false;
                _context9.next = 20;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t0 = _context9["catch"](3);

                __WEBPACK_IMPORTED_MODULE_15_sweetalert___default()("Error", "Failed to delete adjustment.", "error");
                console.error(_context9.t0);

              case 20:
                _context9.prev = 20;

                _this10.isDeleteModalOpen = false;
                _this10.isLoading = false;
                return _context9.finish(20);

              case 24:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[3, 16, 20, 24]]);
      }))();
    },
    resetForm: function resetForm() {
      this.selectedAdjustmentType = "";
      this.amount = null;
      this.customAmount = null;
      this.reason = "";
      this.selectedModalMonth = this.selectedMonth || "";
      this.selectedModalYear = String(this.selectedYear) || "";
      this.selectedEmployeeId = this.selectedEmployee ? this.selectedEmployee.username : "";
      this.expenseAmount = null;
      this.receiptFile = null;
      this.receiptUrl = "";
      this.receiptError = "";
      this.typeError = this.amountError = this.monthError = this.yearError = this.employeeError = this.reasonError = "";
    },
    formatDate: function formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    checkReasonLength: function checkReasonLength() {
      if (this.reason.length > 300) {
        this.reason = this.reason.slice(0, 300);
      }
    }
  }
});

/***/ }),

/***/ "nLtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InternalStateDropdown',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'dropdown'
    },
    placeholder: {
      type: String,
      default: 'Select an option'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 195
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'This field is required'
    },
    required: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '43px'
    },
    search: {
      type: Boolean,
      default: true
    },
    custom: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  data: function data() {
    return {
      isOpen: false,
      selectedValue: this.value,
      searchQuery: '',
      customValue: '',
      isCustomInput: false
    };
  },

  computed: {
    filteredOptions: function filteredOptions() {
      var _this = this;

      if (!this.search || !this.searchQuery) return this.options;
      return this.options.filter(function (option) {
        return option.toLowerCase().includes(_this.searchQuery.toLowerCase());
      });
    }
  },
  watch: {
    value: function value(newVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      var _this2 = this;

      if (!this.disabled) {
        this.isOpen = !this.isOpen;
        if (this.isOpen && this.search) {
          this.searchQuery = '';
          this.$nextTick(function () {
            _this2.$refs.searchInput.focus();
          });
        }
        if (this.custom && this.isOpen && this.selectedValue === 'Custom Value') {
          this.isCustomInput = true;
          this.$nextTick(function () {
            var input = _this2.$el.querySelector('.custom-input');
            if (input) input.focus();
          });
        }
      }
    },
    selectOption: function selectOption(option) {
      var _this3 = this;

      if (option === 'Custom Value' && this.custom) {
        this.isCustomInput = true;
        this.$nextTick(function () {
          var input = _this3.$el.querySelector('.custom-input');
          if (input) input.focus();
        });
      } else {
        this.selectedValue = option;
        this.isCustomInput = false;
        this.customValue = '';
        this.$emit('change', this.selectedValue);
        this.isOpen = false;
      }
    },
    updateCustomValue: function updateCustomValue() {
      if (this.custom && this.isCustomInput) {
        var value = this.customValue ? Number(this.customValue) : null;
        if (value !== null && !isNaN(value) && value > 0) {
          this.selectedValue = value.toString(); // Convert to string to match dropdown value type
          this.$emit('change', this.selectedValue);
        }
        this.isCustomInput = false;
        this.isOpen = false;
      }
    },
    handleClickOutside: function handleClickOutside(event) {
      var dropdownEl = this.$refs.dropdown;
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.isOpen = false;
        if (this.custom && this.isCustomInput) {
          this.updateCustomValue();
        }
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
});

/***/ }),

/***/ "nVsI":
/***/ (function(module, exports) {

module.exports = {"designationGrades":{"Executive Leadership":[{"value":"CEO","label":"Chief Executive Officer (CEO)"},{"value":"COO","label":"Chief Operating Officer (COO)"},{"value":"CTO","label":"Chief Technology Officer (CTO)"},{"value":"CMO","label":"Chief Marketing Officer (CMO)"},{"value":"CFO","label":"Chief Financial Officer (CFO)"},{"value":"CHRO","label":"Chief Human Resources Officer (CHRO)"},{"value":"CPO","label":"Chief Product Officer (CPO)"},{"value":"CIO","label":"Chief Information Officer (CIO)"}],"Human Resource":[{"value":1,"label":"Grade 1 - HR Intern"},{"value":2,"label":"Grade 2 - HR Executive"},{"value":3,"label":"Grade 3 - Senior HR Executive"},{"value":4,"label":"Grade 4 - HR Manager"}],"Intern":[{"value":1,"label":"Grade 1 - Trainee Intern"}],"Software Engineer":[{"value":1,"label":"Grade 1 - Junior Software Engineer"},{"value":2,"label":"Grade 2 - Software Engineer"},{"value":3,"label":"Grade 3 - Senior Software Engineer"},{"value":4,"label":"Grade 4 - Technical Lead"}],"Admin":[{"value":1,"label":"Grade 1 - Admin Assistant"},{"value":2,"label":"Grade 2 - Admin Officer"},{"value":3,"label":"Grade 3 - Admin Manager"}],"Office Boy":[{"value":1,"label":"Grade 1 - Junior Office Boy"},{"value":2,"label":"Grade 2 - Senior Office Boy"}],"Sales Executive":[{"value":1,"label":"Grade 1 - Sales Trainee"},{"value":2,"label":"Grade 2 - Sales Executive"},{"value":3,"label":"Grade 3 - Senior Sales Executive"},{"value":4,"label":"Grade 4 - Sales Manager"}],"Business Analyst":[{"value":1,"label":"Grade 1 - Junior Analyst"},{"value":2,"label":"Grade 2 - Business Analyst"},{"value":3,"label":"Grade 3 - Senior Analyst"},{"value":4,"label":"Grade 4 - Lead Analyst"}],"Team Lead":[{"value":2,"label":"Grade 2 - Associate Team Lead"},{"value":3,"label":"Grade 3 - Team Lead"},{"value":4,"label":"Grade 4 - Senior Team Lead"}],"Project Manager":[{"value":2,"label":"Grade 2 - Associate Project Manager"},{"value":3,"label":"Grade 3 - Project Manager"},{"value":4,"label":"Grade 4 - Senior Project Manager"}],"Quality Assurance Engineer":[{"value":1,"label":"Grade 1 - QA Trainee"},{"value":2,"label":"Grade 2 - QA Engineer"},{"value":3,"label":"Grade 3 - Senior QA Engineer"},{"value":4,"label":"Grade 4 - QA Lead"}],"Designer (UI/UX)":[{"value":1,"label":"Grade 1 - Junior Designer"},{"value":2,"label":"Grade 2 - UI/UX Designer"},{"value":3,"label":"Grade 3 - Senior Designer"},{"value":4,"label":"Grade 4 - Design Lead"}],"Marketing Specialist":[{"value":1,"label":"Grade 1 - Marketing Intern"},{"value":2,"label":"Grade 2 - Marketing Executive"},{"value":3,"label":"Grade 3 - Senior Marketing Specialist"},{"value":4,"label":"Grade 4 - Marketing Manager"}],"Customer Support":[{"value":1,"label":"Grade 1 - Support Trainee"},{"value":2,"label":"Grade 2 - Customer Support Executive"},{"value":3,"label":"Grade 3 - Senior Support Executive"}],"Technical Lead":[{"value":3,"label":"Grade 3 - Technical Specialist"},{"value":4,"label":"Grade 4 - Technical Lead"},{"value":5,"label":"Grade 5 - Senior Technical Lead"}]}}

/***/ }),

/***/ "nd9x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nimk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");


var _components$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (_components$data$comp = {
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    CustomTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_CustomTable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: "", // Store the search term
      tableColumns: [{ label: "Avatar", key: "avatar", width: 90 }, { label: "Name", key: "username", sortable: true }, { label: "Email", key: "email", sortable: true, width: 250 }, { label: "Designation", key: "designation", sortable: true }, { label: "Grade", key: "grade", sortable: true, width: 150 }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.loading || false;
    },

    paginatedData: {
      type: Array,
      required: true
    },
    sortKey: {
      type: String,
      default: ''
    },
    sortOrder: {
      type: String,
      default: 'asc'
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "computed", {
  loading: function loading() {
    return this.$store.state.loading || false;
  },
  filteredUsers: function filteredUsers() {
    var _this = this;

    var company = this.$store.state.auth.company;
    var companyUserIds = company.users.map(function (user) {
      return user.uid;
    });
    var allUsers = this.$store.state.auth.allUsers.filter(function (user) {
      return companyUserIds.includes(user.uid);
    });

    // If there's a search term, filter by name or email
    if (this.searchTerm) {
      return allUsers.filter(function (user) {
        var name = user.username ? user.username.toLowerCase() : "";
        var email = user.email ? user.email.toLowerCase() : "";
        var searchTerm = _this.searchTerm.toLowerCase();
        return name.includes(searchTerm) || email.includes(searchTerm);
      });
    }

    return allUsers;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "methods", {
  sortTable: function sortTable(columnKey) {
    if (this.sortKey === columnKey) {
      this.$emit('update:sortOrder', this.sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      this.$emit('update:sortKey', columnKey);
      this.$emit('update:sortOrder', 'asc');
    }
  }
}), _components$data$comp);

/***/ }),

/***/ "no2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Performance_vue__ = __webpack_require__("yAlI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788a2f05_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Performance_vue__ = __webpack_require__("NepR");
function injectStyle (ssrContext) {
  __webpack_require__("jiZV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-788a2f05"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Performance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788a2f05_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Performance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "npIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_api__ = __webpack_require__("IFYK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ResetPassword",
  data: function data() {
    return {
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      formError: "",
      success: "",
      email: "",
      selectedCompany: null,
      oobCode: "",
      passwordMismatch: false,
      initialLoad: true,
      showNewPassword: false,
      showConfirmPassword: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var mainUrlParams, continueUrl, decodedContinueUrl, urlParams;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              // Extract query parameters from the URL
              mainUrlParams = new URLSearchParams(window.location.search);

              _this.oobCode = mainUrlParams.get('oobCode') || '';

              // Extract email from continueUrl
              continueUrl = mainUrlParams.get('continueUrl');

              if (continueUrl) {
                decodedContinueUrl = decodeURIComponent(continueUrl);

                console.log("Decoded continue URL:", decodedContinueUrl);
                urlParams = new URLSearchParams(decodedContinueUrl.split('?')[1]);

                _this.email = urlParams.get('email') || '';
                console.log("Extracted email:", _this.email);
              }

              if (_this.oobCode) {
                _context.next = 7;
                break;
              }

              throw new Error("Reset code not found.");

            case 7:
              if (_this.email) {
                _context.next = 9;
                break;
              }

              throw new Error("Email not found in reset link.");

            case 9:
              _context.next = 11;
              return _this.initializeFirebase(false);

            case 11:
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);

              _this.formError = _context.t0.message;
              if (_context.t0.message !== "No account found for this email.") {
                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()("Error", _context.t0.message, "error");
              }

            case 17:
              _context.prev = 17;

              _this.initialLoad = false;
              return _context.finish(17);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 13, 17, 20]]);
    }))();
  },


  methods: {
    clearErrors: function clearErrors() {
      this.formError = "";
      this.passwordMismatch = false;
    },
    showError: function showError(message) {
      this.formError = message;
      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()("Error", message, "error");
    },
    initializeFirebase: function initializeFirebase() {
      var _this2 = this;

      var showErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, verifiedEmail;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.email) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Email is required to initialize Firebase.");

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.findCompany(_this2.email);

              case 5:
                response = _context2.sent;

                if (!(!response || !response.length)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("No account found for this email.");

              case 8:
                _this2.selectedCompany = response[0];

                if (!__WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].checkAlreadyConfiguredApp()) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].unconfigureFirebase();

              case 12:
                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].configureFirebase(_this2.selectedCompany.firebase);

              case 14:
                if (!(!_this2.initialLoad || showErrors)) {
                  _context2.next = 27;
                  break;
                }

                _context2.prev = 15;
                _context2.next = 18;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].ResetCode(_this2.oobCode);

              case 18:
                verifiedEmail = _context2.sent;

                if (!(verifiedEmail !== _this2.email)) {
                  _context2.next = 22;
                  break;
                }

                console.error("Email mismatch:", {
                  verifiedEmail: verifiedEmail,
                  providedEmail: _this2.email
                });
                throw new Error("The reset link is invalid: Email mismatch.");

              case 22:
                _context2.next = 27;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](15);
                throw new Error(_context2.t0.code === 'auth/expired-action-code' ? "The password reset link has expired." : _context2.t0.code === 'auth/invalid-action-code' ? "The password reset link is invalid: " + _context2.t0.message : _context2.t0.code === 'auth/user-not-found' ? "No user found for this email." : "Failed to verify reset code: " + _context2.t0.message);

              case 27:
                _context2.next = 34;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t1 = _context2["catch"](2);

                if (!showErrors) {
                  _context2.next = 33;
                  break;
                }

                throw new Error(_context2.t1.message || "Error validating email or reset code.");

              case 33:
                throw _context2.t1;

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 29], [15, 24]]);
      }))();
    },
    confirmReset: function confirmReset() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var errorMessage;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.clearErrors();

                if (_this3.validatePasswords()) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:

                _this3.isLoading = true;
                _context3.prev = 4;
                _context3.next = 7;
                return _this3.initializeFirebase(true);

              case 7:
                _context3.next = 9;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].ResetPassword(_this3.oobCode, _this3.newPassword);

              case 9:
                _this3.success = "Password has been successfully reset.";
                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()("Success!", "You can now log in with your new password.", "success");
                setTimeout(function () {
                  _this3.$router.push({ path: '/', query: {} });
                  window.history.replaceState({}, document.title, '/');
                }, 3000);
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](4);
                errorMessage = _context3.t0.code === 'auth/expired-action-code' ? "The password reset link has expired." : _context3.t0.code === 'auth/invalid-action-code' ? "The password reset link is invalid: " + _context3.t0.message : _context3.t0.code === 'auth/user-not-found' ? "No user found for this email." : "Failed to reset password: " + _context3.t0.message;

                _this3.showError(errorMessage);

              case 18:
                _context3.prev = 18;

                _this3.isLoading = false;
                return _context3.finish(18);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 14, 18, 21]]);
      }))();
    },
    validatePasswords: function validatePasswords() {
      if (!this.newPassword || !this.confirmPassword) {
        this.showError("Please enter and confirm your new password.");
        return false;
      }

      if (this.newPassword.length < 6) {
        this.showError("Password must be at least 6 characters.");
        return false;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.passwordMismatch = true;
        this.showError("Passwords do not match");
        return false;
      }

      return true;
    },
    findCompany: function findCompany(emailToFind) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__assets_config_api__["a" /* default */].findCompanyByEmail(emailToFind);

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", response);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                throw new Error("Error finding company");

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),

/***/ "nvCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = logAdminActivity;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendToTrello;
/* harmony export (immutable) */ __webpack_exports__["d"] = createActivityPayload;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__slack__ = __webpack_require__("BjXO");









var adminActivities = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(activityData) {
    var originalAdminUser;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            originalAdminUser = localStorage.getItem('originalAdminUser') ? JSON.parse(localStorage.getItem('originalAdminUser')) : null;

            if (originalAdminUser) {
              activityData.actionUserId = originalAdminUser.uid;
              activityData.actionUsername = originalAdminUser.username;
              activityData.actionUserEmail = originalAdminUser.companyEmail;
            }
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].logAdminActivityToDB(activityData);

          case 4:
            _context.next = 6;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__slack__["a" /* notifySlackOfActivity */])(activityData);

          case 6:
            return _context.abrupt('return', activityData);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function adminActivities(_x) {
    return _ref.apply(this, arguments);
  };
}();

// Still used by bug reports








function logAdminActivity(activity) {
  return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;

    navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
      if (permissionStatus.state === 'prompt') {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()("Warning", "Allow the location permission in order to proceed the action", "warning");
      } else if (permissionStatus.state === 'denied') {
        reject(new Error("Location permission is denied. Please enable it in browser settings."));
        return;
      }

      navigator.geolocation.getCurrentPosition(function (position) {
        var fullActivity = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, activity, {
          browserName: userAgent,
          osName: platform,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          map: 'https://www.google.com/maps?q=' + position.coords.latitude + ',' + position.coords.longitude
        });

        adminActivities(fullActivity).then(function () {
          return resolve(fullActivity);
        }).catch(function (error) {
          return reject(error);
        });
      }, function (error) {
        console.error('⚠️ Geolocation error:', error.message || error);
        reject(new Error("Location permission is denied. Please enable it in browser settings.")); // Changed to new Error
      }, {
        timeout: 15000,
        enableHighAccuracy: true
      });
    });
  });
}

function sendToTrello(cardData) {
  return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
    var apiToken = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";

    var url = 'https://api.trello.com/1/cards?key=' + apiKey + '&token=' + apiToken;

    var payload = {
      name: cardData.name || 'Untitled Activity',
      desc: cardData.desc || '',
      idList: cardData.idList,
      pos: cardData.pos || 'top'
    };

    if (cardData.due) {
      payload.due = cardData.due;
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Trello error: ' + response.status);
      return response.json();
    }).then(function (data) {
      console.log('✅ Trello card created:', data);
      resolve(data);
    }).catch(function (error) {
      console.error('❌ Trello API error:', error);
      reject(error);
    });
  });
}

function createActivityPayload(_ref2) {
  var user = _ref2.user,
      title = _ref2.title,
      description = _ref2.description,
      _ref2$changes = _ref2.changes,
      changes = _ref2$changes === undefined ? null : _ref2$changes,
      _ref2$reason = _ref2.reason,
      reason = _ref2$reason === undefined ? null : _ref2$reason,
      _ref2$username = _ref2.username,
      username = _ref2$username === undefined ? null : _ref2$username,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? "create_user" : _ref2$type,
      _ref2$uid = _ref2.uid,
      uid = _ref2$uid === undefined ? null : _ref2$uid,
      _ref2$isAdmin = _ref2.isAdmin,
      isAdmin = _ref2$isAdmin === undefined ? true : _ref2$isAdmin,
      _ref2$attendees = _ref2.attendees,
      attendees = _ref2$attendees === undefined ? null : _ref2$attendees;

  return {
    activityOnUserName: username,
    activityByUserName: user.username || "Admin",
    activityName: title,
    adminId: isAdmin ? user.uid : null,
    activityOnUser: uid,
    activityTitle: title,
    activityDescription: description,
    changes: changes,
    reason: reason,
    type: type,
    attendees: attendees,
    timestamp: new Date().toLocaleString('en-PK')
  };
}

function formatValue(value) {
  if (value === null || value === undefined) return 'N/A';

  if (Array.isArray(value)) {
    return value.length ? value.map(function (v) {
      return formatValue(v);
    }).join(', ') : '[]';
  }

  if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    var entries = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(value);
    if (!entries.length) return '{}';
    return entries.map(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];

      return k + ': ' + formatValue(v);
    }).join(', ');
  }

  return value;
}

function getUpdatedFields(oldData, newData) {
  console.log(oldData);
  console.log(newData);
  var updated = {};
  for (var key in newData) {
    var oldValue = oldData ? oldData[key] : undefined;
    var newValue = newData ? newData[key] : undefined;

    var oldStr = (typeof oldValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(oldValue)) === 'object' ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(oldValue) : oldValue;
    var newStr = (typeof newValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(newValue)) === 'object' ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newValue) : newValue;

    if (oldStr !== newStr) {
      updated[key] = { old: oldValue, new: newValue };
    }
  }
  return updated;
}

/***/ }),

/***/ "nzxg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function filterEmployees(_ref) {
  var allUsers = _ref.allUsers,
      company = _ref.company,
      _ref$currentUserId = _ref.currentUserId,
      currentUserId = _ref$currentUserId === undefined ? null : _ref$currentUserId,
      _ref$role = _ref.role,
      role = _ref$role === undefined ? null : _ref$role,
      _ref$employeeList = _ref.employeeList,
      employeeList = _ref$employeeList === undefined ? null : _ref$employeeList,
      _ref$searchTerm = _ref.searchTerm,
      searchTerm = _ref$searchTerm === undefined ? "" : _ref$searchTerm,
      _ref$includeInactive = _ref.includeInactive,
      includeInactive = _ref$includeInactive === undefined ? false : _ref$includeInactive;

  var companyUserIds = company.users.map(function (user) {
    return user.uid;
  });

  var users = employeeList || allUsers;

  // Step 1: Filter only company employees
  users = users.filter(function (user) {
    return companyUserIds.includes(user.uid || user.id);
  });

  // Step 2: Filter by role if provided (e.g., "admin")
  if (role) {
    users = users.filter(function (user) {
      return user.role === role;
    });
  }

  // Step 3: Exclude current user if needed
  if (currentUserId) {
    users = users.filter(function (user) {
      return user.uid !== currentUserId && user.id !== currentUserId;
    });
  }

  // Step 4: Active Employees check (default = only active)
  if (includeInactive) {
    users = users.filter(function (user) {
      return user.isActive;
    });
  }

  // Step 5: Search by username/email if searchTerm is provided
  if (searchTerm) {
    var term = searchTerm.toLowerCase();
    users = users.filter(function (user) {
      var name = user.username ? user.username.toLowerCase() : "";
      var email = user.email ? user.email.toLowerCase() : "";
      return name.includes(term) || email.includes(term);
    });
  }

  return users;
}

/***/ }),

/***/ "oCsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__ = __webpack_require__("gY6d");







var fetchTrelloCards = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(context, appLabels, user, members, listIds) {
        var cards, cardsData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return fetchFromTrello("cards", context);

                    case 2:
                        cards = _context4.sent;
                        cardsData = processCards(cards.cards, appLabels, user, members, listIds);

                        context.commit('setCardsData', cardsData);

                    case 5:
                    case "end":
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function fetchTrelloCards(_x, _x2, _x3, _x4, _x5) {
        return _ref4.apply(this, arguments);
    };
}();

var fetchFromTrello = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(dataToFetch, context) {
        var apiKey, token, boardId, APIEndPoint, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        apiKey = "d1e87bb459fdd63dc52cfc2a958603df";
                        token = "ATTA74e1c8dfbee10b99c65fcd394ac851a0ec8dcf010341e2cef741ab2841b95f1fAB10D149";
                        boardId = "65ec3c6f30e02fb49bb072d4";
                        APIEndPoint = dataToFetch === "cards" ? context.rootState.auth.user.role === "admin" ? "https://api.trello.com/1/search?idBoards=" + boardId + "&key=" + apiKey + "&token=" + token + "&query=" + __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["g" /* cardIdentifier */] + "&modelTypes=cards&cards_limit=" + 1000 : "https://api.trello.com/1/search?idBoards=" + boardId + "&key=" + apiKey + "&token=" + token + "&query=" + context.rootState.auth.user.email + "&modelTypes=cards&cards_limit=" + 1000 : "https://api.trello.com/1/boards/" + boardId + "/" + dataToFetch + "?key=" + apiKey + "&token=" + token;
                        _context5.next = 6;
                        return fetch(APIEndPoint);

                    case 6:
                        response = _context5.sent;

                        if (response.ok) {
                            _context5.next = 9;
                            break;
                        }

                        throw new Error("Network response was not ok for dataToFetch: " + dataToFetch);

                    case 9:
                        return _context5.abrupt("return", response.json());

                    case 10:
                    case "end":
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function fetchFromTrello(_x6, _x7) {
        return _ref5.apply(this, arguments);
    };
}();



var complains = {
    state: { assignees: null, trelloLabels: null, trelloListIds: null, cardsData: null },
    mutations: {
        setAssignees: function setAssignees(state, payload) {
            state.assignees = payload;
        },
        setTrelloLabels: function setTrelloLabels(state, payload) {
            state.trelloLabels = payload;
        },
        setTrelloListIds: function setTrelloListIds(state, payload) {
            state.trelloListIds = payload;
        },
        setCardsData: function setCardsData(state, payload) {
            state.cardsData = payload;
        }
    },
    actions: {
        fetchAllTrelloData: function fetchAllTrelloData(context) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var user, complainsListName, resolvedListName, _ref, _ref2, members, labels, lists, listIds, appLabels;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                user = context.rootState.auth.user;
                                complainsListName = "Team Complains".toLowerCase();
                                resolvedListName = "Done".toLowerCase();
                                _context.prev = 3;
                                _context.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([fetchFromTrello("members"), fetchFromTrello("labels"), fetchFromTrello("lists")]);

                            case 6:
                                _ref = _context.sent;
                                _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                                members = _ref2[0];
                                labels = _ref2[1];
                                lists = _ref2[2];
                                listIds = lists.reduce(function (acc, list) {
                                    if (list.name.toLowerCase() === complainsListName.toLowerCase()) {
                                        acc.complainsListId = list.id;
                                    } else if (list.name.toLowerCase() === resolvedListName) {
                                        acc.resolvedListId = list.id;
                                    }
                                    return acc;
                                }, { complainsListId: null, resolvedListId: null });
                                appLabels = getAppLabels(labels);

                                fetchTrelloCards(context, appLabels, user, members, listIds);
                                console.log(listIds, "listIds================");

                                context.commit('setAssignees', members);
                                context.commit('setTrelloLabels', appLabels);
                                context.commit('setTrelloListIds', listIds);
                                _context.next = 23;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context["catch"](3);

                                console.error('Error fetching Trello data:', _context.t0);

                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[3, 20]]);
            }))();
        },
        fetchTrelloCards: function fetchTrelloCards(context) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _context$state, trelloLabels, trelloListIds, assignees, user, cards, cardsData;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context$state = context.state, trelloLabels = _context$state.trelloLabels, trelloListIds = _context$state.trelloListIds, assignees = _context$state.assignees;
                                user = context.rootState.auth.user;
                                _context2.next = 4;
                                return fetchFromTrello("cards", context);

                            case 4:
                                cards = _context2.sent;
                                cardsData = processCards(cards.cards, trelloLabels, user, assignees, trelloListIds);

                                context.commit('setCardsData', cardsData);

                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        updateCardsData: function updateCardsData(context, _ref3) {
            var _this3 = this;

            var updatedCard = _ref3.updatedCard;
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _context$state2, trelloLabels, trelloListIds, assignees, cardsData, card, updatedCardsData;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context$state2 = context.state, trelloLabels = _context$state2.trelloLabels, trelloListIds = _context$state2.trelloListIds, assignees = _context$state2.assignees, cardsData = _context$state2.cardsData;
                                card = modifyData(updatedCard, assignees, trelloListIds, trelloLabels);
                                updatedCardsData = [card].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cardsData));

                                context.commit('setCardsData', updatedCardsData);

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    },
    getters: {
        allAssignees: function allAssignees(state) {
            return function () {
                return state.assignees;
            };
        },
        cardsData: function cardsData(state) {
            return function () {
                return state.cardsData;
            };
        }
    }
};

function processCards(cards, appLabels, user, assignees, listIds) {
    var resolvedListId = listIds.resolvedListId,
        complainsListId = listIds.complainsListId;

    var teamComplainCards = cards.filter(function (card) {
        return [resolvedListId, complainsListId].includes(card.idList);
    }).sort(function (a, b) {
        // Convert dateLastActivity to timestamps for comparison
        var dateA = new Date(a.dateLastActivity).getTime();
        var dateB = new Date(b.dateLastActivity).getTime();

        // Sort in descending order (most recent first)
        return dateB - dateA;
    });
    var processedCards = void 0;

    if (user.role === 'admin') {
        processedCards = teamComplainCards;
    } else {
        processedCards = teamComplainCards.filter(function (card) {
            return card.name.includes(user.email) || !card.name.includes(user.email) && card.idLabels.includes(appLabels.generalLabelId);
        });
    }

    processedCards = processedCards.map(function (card) {
        return modifyData(card, assignees, listIds, appLabels);
    });

    return processedCards;
}

function modifyData(card, assignees, listIds, appLabels) {
    var assignee = assignees.find(function (member) {
        return member.id === card.idMembers[0];
    });
    var assigneeName = assignee ? assignee.fullName.includes('_') ? assignee.fullName.split('_').map(function (word) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ') : assignee.fullName : null;

    var isHighPriority = card.idLabels.includes(appLabels.highPriorityLabelId);
    var isPersonal = card.idLabels.includes(appLabels.personalLabelId);
    var status = card.idList === listIds.resolvedListId ? "Resolved" : "Pending";

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, card, {
        assigneeName: assigneeName,
        isHighPriority: isHighPriority,
        isPersonal: isPersonal,
        status: status
    });
}

function getAppLabels(labels) {
    return labels.filter(function (item) {
        return __WEBPACK_IMPORTED_MODULE_6__assets_config_constants__["h" /* appTrelloLabels */].some(function (label) {
            return label.toLowerCase() === item.name.toLowerCase();
        });
    }).reduce(function (acc, item) {
        var key = convertToCamelCase(item.name);
        acc[key] = item.id;
        return acc;
    }, {});
}

function convertToCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
    }).replace(/\s+/g, '') + 'LabelId';
}

/* harmony default export */ __webpack_exports__["a"] = (complains);

/***/ }),

/***/ "oIti":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKtW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatbotManagement_vue__ = __webpack_require__("QJQ3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391374d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatbotManagement_vue__ = __webpack_require__("zyIC");
function injectStyle (ssrContext) {
  __webpack_require__("va8f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-391374d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatbotManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391374d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatbotManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oV+4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "odUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-emp-info-employee-info"},[_c('div',{staticClass:"payroll-emp-info-panel"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-panel-body"},[_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localEmployee.employeeName),expression:"localEmployee.employeeName"}],staticClass:"payroll-disabled-field",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.localEmployee.employeeName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localEmployee, "employeeName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',[_vm._v("Basic Salary (PKR)")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetEmptyField('basicSalary'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localEmployee.basicSalary),expression:"localEmployee.basicSalary"}],class:{ 'updated-field': _vm.hasChanged('basicSalary') },attrs:{"type":"number","disabled":_vm.isDisabled,"placeholder":"0"},domProps:{"value":(_vm.localEmployee.basicSalary)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.localEmployee, "basicSalary", $event.target.value)},_vm.handleChange],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('div',{staticClass:"input-with-reset"},[_c('label',{attrs:{"for":"extraAllowanceInput"}},[_vm._v("Extra Allowance (PKR)")]),_vm._v(" "),_c('ResetIconButton',{on:{"reset":function () { return _vm.resetEmptyField('extraAllowance'); }}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localEmployee.extraAllowance),expression:"localEmployee.extraAllowance"}],class:{ 'updated-field': _vm.hasChanged('extraAllowance') },attrs:{"type":"number","placeholder":"0","disabled":_vm.isDisabled},domProps:{"value":(_vm.localEmployee.extraAllowance)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.localEmployee, "extraAllowance", $event.target.value)},_vm.handleChange],"wheel":function($event){return $event.target.blur()}}})]),_vm._v(" "),_c('div',{staticClass:"payroll-emp-info-form-group"},[_c('label',[_vm._v("Per Day Salary (PKR)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localEmployee.perDaySalary),expression:"localEmployee.perDaySalary"}],staticClass:"payroll-disabled-field",attrs:{"type":"number","disabled":_vm.isDisabled,"disabled":""},domProps:{"value":(_vm.localEmployee.perDaySalary)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.localEmployee, "perDaySalary", $event.target.value)},_vm.manualOverride]}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-emp-info-panel-header"},[_c('span',{staticClass:"icon"},[_vm._v("👤")]),_vm._v(" "),_c('h2',[_vm._v("Employee Information")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ozhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardsSection_vue__ = __webpack_require__("mZEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_assets_config_helpers_js__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_notificationService__ = __webpack_require__("l527");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    CardsSection: __WEBPACK_IMPORTED_MODULE_5__CardsSection_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_8__UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_9__UIComponents_CustomDropdown_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      user: this.$store.state.auth.user,
      leaves: [],
      cards: [],
      loading: { applyLeave: false, responseLeaves: false, withdrawLeave: false },
      formSubmitted: false,
      duration: "full",
      leaveTypeOptions: ["Casual Leave", "Sick Leave", "Emergency Leave"],
      tableColumns: [{ label: "Assignees", key: "assignees", sortable: true }, { label: "Type", key: "type", sortable: true }, { label: "No.of Days", key: "noofdays", sortable: true }, { label: "Dates", key: "dates", sortable: true }, { label: "Applied At", key: "createdAt", sortable: true }, { label: "Reason", key: "reason" }, { label: "Comment", key: "comment" }, { label: "Status", key: "status" }],
      isModalOpen: false,
      isWithdrawModalOpen: false,
      selectedLeaveToWithdraw: null,
      newLeave: {
        startDate: "",
        endDate: "",
        assignees: "",
        assigneeId: "",
        type: "",
        noofdays: "",
        reason: "",
        status: "Pending"
      },
      holidays: []
    };
  },

  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      var company = this.$store.state.auth.company;
      var companyUserIds = company.users.map(function (user) {
        return user.uid;
      });
      var filteredAdmins = this.$store.state.auth.allUsers.filter(function (user) {
        return companyUserIds.includes(user.uid) && user.role === "admin" && user.uid !== _this.userId;
      });
      var emailMatchUser = this.$store.state.auth.allUsers.find(function (user) {
        return user.email === company.email && user.role === "admin" && user.uid !== _this.userId;
      });
      return emailMatchUser ? [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(filteredAdmins), [emailMatchUser]) : filteredAdmins;
    },
    assigneeOptions: function assigneeOptions() {
      return this.filteredUsers.map(function (user) {
        return user.username;
      });
    },
    selectedAssigneeName: function selectedAssigneeName() {
      var _this2 = this;

      if (!this.newLeave.assigneeId) return '';

      var selectedUser = this.filteredUsers.find(function (user) {
        return user.uid === _this2.newLeave.assigneeId;
      });
      return selectedUser ? selectedUser.username : '';
    },
    isResignedUser: function isResignedUser() {
      var currentUser = this.$store.state.auth.user;
      return currentUser.status === "Resigned";
    },
    isUserDataLoaded: function isUserDataLoaded() {
      return this.user && this.user.leavesAllowed !== undefined;
    }
  },
  watch: {
    "$store.state.auth.user": {
      handler: function handler(newUser) {
        this.user = newUser;
        this.updateCards();
      },

      immediate: true
    }
  },
  methods: {
    handleAssigneeChange: function handleAssigneeChange(selectedUsername) {
      var selectedUser = this.filteredUsers.find(function (user) {
        return user.username === selectedUsername;
      });
      if (selectedUser) {
        this.newLeave.assigneeId = selectedUser.uid;
        this.newLeave.assignees = selectedUser.username;
      }
    },
    handleLeaveTypeChange: function handleLeaveTypeChange(selectedType) {
      this.newLeave.type = selectedType;
    },
    formatRelativeTime: function formatRelativeTime(timestamp) {
      if (!timestamp) return 'Just now';
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(timestamp).fromNow();
    },
    getFirstWorkingDate: function getFirstWorkingDate(start, end, workingDays) {
      var current = new Date(start);
      var endDate = new Date(end);

      while (current <= endDate) {
        var dayNum = current.getDay();
        var isWeekend = dayNum === 0 || dayNum === 6;
        var isHol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_src_assets_config_helpers_js__["u" /* isHoliday */])(current, this.holidays, this.user.shift);

        if (!isWeekend && !isHol) {
          return new Date(current);
        }
        current.setDate(current.getDate() + 1);
      }
      return null;
    },
    updateCards: function updateCards() {
      var leavesBalance = parseFloat(this.user.leavesAllowed) - parseFloat(this.user.leavesTaken);
      this.cards = [{ value: parseFloat(this.user.leavesAvailable).toFixed(1), label: "Total yearly leave(s)", color: "#007bff" }, { value: parseFloat(this.user.leavesAllowed).toFixed(1), label: "Allowed Leave(s)", color: "#00c7c7" }, { value: parseFloat(this.user.leavesTaken).toFixed(1), label: "Taken Leave(s)", color: "#ff4d4d" }, { value: leavesBalance.toFixed(1), label: "Balance Leave(s)", color: "#00aaff" }];
    },
    getStatusClass: function getStatusClass(status) {
      return {
        "Auto-Deducted": "status-badge auto-deducted",
        "Pending": "status-badge pending",
        "Rejected": "status-badge rejected",
        "Approved": "status-badge approved",
        "Withdrawn": "status-badge withdrawn"
      }[status] || "status-badge";
    },
    withdrawLeave: function withdrawLeave(item) {
      this.selectedLeaveToWithdraw = item;
      this.isWithdrawModalOpen = true;
    },
    confirmWithdraw: function confirmWithdraw() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var leave, range, dayText, title, description;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.selectedLeaveToWithdraw) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:

                _this3.loading.withdrawLeave = true;

                _context.prev = 3;
                leave = _this3.selectedLeaveToWithdraw;
                range = leave.startDate + " to " + (leave.endDate || leave.startDate);
                dayText = leave.noofdays === 0.5 ? 'half day' : leave.noofdays > 1 ? 'days' : 'day';
                title = _this3.user.username + " withdrew " + leave.type + " from " + range + " (" + leave.noofdays + " " + dayText + ")";
                description = _this3.user.email + " withdrew " + leave.employee + "'s " + leave.type + " application from " + range + " (" + leave.noofdays + " " + dayText + ").";
                _context.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this3.user,
                  title: title,
                  description: description,
                  username: _this3.user.username,
                  type: "leaves",
                  uid: _this3.user.uid,
                  isAdmin: false
                }));

              case 11:
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__["a" /* default */].updateLeaveStatusAndComment(leave.id, "Withdrawn", _this3.user.uid);

              case 13:
                leave.status = "Withdrawn";
                _this3.fetchLeaves();

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Leave has been withdrawn successfully.", "success");
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](3);

                console.error("Error withdrawing leave:", _context.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to withdraw leave. Please try again.", "error");

              case 22:
                _context.prev = 22;

                _this3.loading.withdrawLeave = false;
                _this3.isWithdrawModalOpen = false;
                _this3.selectedLeaveToWithdraw = null;
                return _context.finish(22);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 18, 22, 27]]);
      }))();
    },
    fetchLeaves: function fetchLeaves() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userId, userLeaves;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.isLoading = true;

                userId = _this4.$store.state.auth.user.uid;

                try {
                  userLeaves = _this4.$store.state.auth.userLeaves || [];

                  _this4.leaves = userLeaves;
                  _this4.isLoading = false;
                } catch (error) {
                  _this4.isLoading = false;
                  console.error("Error fetching leaves:", error);
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchHolidays: function fetchHolidays() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var holidaysData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 3:
                holidaysData = _context3.sent;

                _this5.holidays = Array.isArray(holidaysData) ? holidaysData : [];
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                console.error("❌ Failed to fetch holidays:", _context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 7]]);
      }))();
    },
    checkHolidaysInRange: function checkHolidaysInRange(start, end) {
      for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_src_assets_config_helpers_js__["u" /* isHoliday */])(d, this.holidays, this.user.shift)) return true;
      }
      return false;
    },
    isRangeOnlyHolidays: function isRangeOnlyHolidays(start, end, workingDays) {
      var hasWorkingDay = false;
      var hasHoliday = false;

      for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        var isHol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_src_assets_config_helpers_js__["u" /* isHoliday */])(d, this.holidays, this.user.shift);
        var isWork = this.isWorkingDayForCheck(d, workingDays);

        if (isHol) hasHoliday = true;
        if (!isHol && isWork) hasWorkingDay = true;
      }

      return hasHoliday && !hasWorkingDay;
    },
    isWorkingDayForCheck: function isWorkingDayForCheck(date, workingDays) {
      var workingDaysNums = workingDays.map(function (day) {
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day);
      });
      return workingDaysNums.includes(date.getDay());
    },
    openModal: function openModal() {
      this.formSubmitted = false;
      this.duration = "full";
      this.isModalOpen = true;
    },
    closeModal: function closeModal() {
      this.isModalOpen = false;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return "";
      var d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    },
    addLeave: function addLeave() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var start, end, startYear, workingDays, actualWorkingDays, isSingleDay, hasHolidayInRange, holidayOnly, user, employee, leavesAllowed, leavesTaken, leavesBalance, options, dates, firstWorking, displayDate, formattedStartDate, formattedEndDate, assignee, payload, _newLeave, type, startDate, endDate, range, uid, username, email, reason, dayText, title, description;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.formSubmitted = true;

                if (!(!_this6.newLeave.assigneeId || !_this6.newLeave.type || !_this6.newLeave.startDate || !_this6.newLeave.endDate || !_this6.newLeave.reason)) {
                  _context4.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Please fill all required fields.", "error");
                return _context4.abrupt("return");

              case 4:
                start = new Date(_this6.newLeave.startDate);
                end = _this6.newLeave.endDate ? new Date(_this6.newLeave.endDate) : new Date(_this6.newLeave.startDate);
                startYear = start.getFullYear();
                workingDays = _this6.user.workingdays || _this6.$store.state.auth.constants && _this6.$store.state.auth.constants.days || [];
                actualWorkingDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_src_assets_config_helpers_js__["v" /* calculateWorkingDays */])(start, end, workingDays);
                isSingleDay = _this6.newLeave.startDate === _this6.newLeave.endDate || !_this6.newLeave.endDate;

                if (!(_this6.duration === "half")) {
                  _context4.next = 15;
                  break;
                }

                if (isSingleDay) {
                  _context4.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Half day is only allowed for single day leaves.", "error");
                return _context4.abrupt("return");

              case 14:
                actualWorkingDays = 0.5;

              case 15:
                if (!(actualWorkingDays <= 0)) {
                  _context4.next = 18;
                  break;
                }

                if (_this6.newLeave.startDate === _this6.newLeave.endDate) {
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Leave cannot be applied on weekend days.", "error");
                } else {
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "No working days found in the selected range.", "error");
                }
                return _context4.abrupt("return");

              case 18:
                if (!(_this6.holidays.length === 0)) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 21;
                return _this6.fetchHolidays();

              case 21:
                hasHolidayInRange = _this6.checkHolidaysInRange(start, end);
                holidayOnly = _this6.isRangeOnlyHolidays(start, end, workingDays);

                if (!holidayOnly) {
                  _context4.next = 27;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "You cannot apply leave on holidays", "error");;
                return _context4.abrupt("return");

              case 27:
                if (hasHolidayInRange) {
                  actualWorkingDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_src_assets_config_helpers_js__["w" /* calculateWorkingDaysExcludingHolidays */])(start, end, workingDays, _this6.holidays, _this6.user.shift);

                  if (_this6.duration === "half") {
                    actualWorkingDays = 0.5;
                  }
                }

                user = _this6.$store.state.auth.user;
                employee = user.username;
                leavesAllowed = parseFloat(user.leavesAllowed) || 0;
                leavesTaken = parseFloat(user.leavesTaken) || 0;
                leavesBalance = leavesAllowed - leavesTaken;

                if (!(leavesBalance < actualWorkingDays)) {
                  _context4.next = 36;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "You don't have sufficient leave balance.", "error");
                return _context4.abrupt("return");

              case 36:
                options = { day: 'numeric', month: 'short' };
                dates = void 0;


                if (actualWorkingDays === 0.5 || actualWorkingDays === 1) {
                  firstWorking = _this6.getFirstWorkingDate(start, end, workingDays);
                  displayDate = firstWorking || start;

                  dates = displayDate.toLocaleDateString('en-US', options);
                } else {
                  formattedStartDate = start.toLocaleDateString('en-US', options);
                  formattedEndDate = end.toLocaleDateString('en-US', options);

                  dates = formattedStartDate + " - " + formattedEndDate;
                }
                assignee = _this6.$store.state.auth.allUsers.find(function (user) {
                  return user.uid === _this6.newLeave.assigneeId;
                });
                _context4.prev = 40;

                _this6.loading.applyLeave = true;

                payload = {
                  assignees: assignee.username,
                  assigneeId: _this6.newLeave.assigneeId,
                  type: _this6.newLeave.type,
                  noofdays: actualWorkingDays,
                  reason: _this6.newLeave.reason,
                  status: "Pending",
                  userId: user.uid,
                  employee: employee,
                  dates: dates,
                  startYear: startYear,
                  leavesBalance: leavesBalance,
                  createdAt: Date.now(),
                  startDate: _this6.newLeave.startDate,
                  endDate: _this6.newLeave.endDate || _this6.newLeave.startDate,
                  duration: _this6.duration
                };

                _this6.$store.commit("setAllLeaves", [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this6.leaves), [payload]));
                _context4.next = 46;
                return __WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__["a" /* default */].submitLeave("leaves", payload);

              case 46:
                _newLeave = _this6.newLeave, type = _newLeave.type, startDate = _newLeave.startDate, endDate = _newLeave.endDate;
                range = actualWorkingDays > 1 ? "from " + _this6.formatDate(startDate) + " to " + _this6.formatDate(endDate || startDate) : "on " + _this6.formatDate(startDate);
                uid = user.uid, username = user.username, email = user.email;
                reason = payload.reason;
                dayText = actualWorkingDays === 0.5 ? 'half day' : actualWorkingDays > 1 ? 'days' : 'day';
                title = username + " applied for " + type + " " + range + " (" + actualWorkingDays + " " + dayText + ")";
                description = email + " applied for " + type + " from " + range + " (" + actualWorkingDays + " " + dayText + ").";
                _context4.next = 55;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: user,
                  title: title,
                  description: description,
                  reason: reason,
                  username: username,
                  type: "leaves",
                  uid: uid,
                  isAdmin: false
                }));

              case 55:
                _context4.next = 57;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "leaves",
                  activityDescription: description,
                  activityName: title,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: username
                }, _this6.$store.state.auth, uid);

              case 57:
                _this6.newLeave = {
                  startDate: "",
                  endDate: "",
                  assignees: "",
                  assigneeId: "",
                  type: "",
                  noofdays: "",
                  reason: "",
                  status: "Pending"
                };
                _this6.formSubmitted = false;
                _this6.closeModal();
                _this6.fetchLeaves();
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Leave application submitted successfully!", "success");
                _context4.next = 68;
                break;

              case 64:
                _context4.prev = 64;
                _context4.t0 = _context4["catch"](40);

                console.error("Error adding leave:", _context4.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to submit leave application. Please try again.", "error");

              case 68:
                _context4.prev = 68;

                _this6.loading.applyLeave = false;
                return _context4.finish(68);

              case 71:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[40, 64, 68, 71]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this7.fetchHolidays(), _this7.fetchLeaves()]);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  }
});

/***/ }),

/***/ "p/gn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8kD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminUserManagement_vue__ = __webpack_require__("ZKTD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmployeeUserManagement_vue__ = __webpack_require__("xLTI");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AdminUserManagement: __WEBPACK_IMPORTED_MODULE_0__AdminUserManagement_vue__["a" /* default */],
        EmployeeUserManagement: __WEBPACK_IMPORTED_MODULE_1__EmployeeUserManagement_vue__["a" /* default */]
    },
    data: function data() {
        var user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin"
        };
    }
});

/***/ }),

/***/ "phi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"sidebar-links":_vm.$sidebar.sidebarLinks}}),_vm._v(" "),_c('div',{staticClass:"main-panel",staticStyle:{"position":"relative"}},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pxek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pyqL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/new-Logo-color.57d03cf.png";

/***/ }),

/***/ "qD9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardsSection_vue__ = __webpack_require__("mZEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_assets_config_helpers_js__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UIComponents_EmployeeDropdown_vue__ = __webpack_require__("gd4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_notificationService__ = __webpack_require__("l527");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CustomTable: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_CustomTable_vue__["a" /* default */], Card: __WEBPACK_IMPORTED_MODULE_6__UIComponents_Cards_Card_vue__["a" /* default */], ReuseableModal: __WEBPACK_IMPORTED_MODULE_8__UIComponents_ReuseableModal_vue__["a" /* default */], CustomDropdown: __WEBPACK_IMPORTED_MODULE_10__UIComponents_CustomDropdown_vue__["a" /* default */], CardsSection: __WEBPACK_IMPORTED_MODULE_7__CardsSection_vue__["a" /* default */], EmployeeDropdown: __WEBPACK_IMPORTED_MODULE_14__UIComponents_EmployeeDropdown_vue__["a" /* default */] },
  data: function data() {
    return {
      filteredUsers: [],
      cards: [],
      loading: { applyLeave: false, responseLeaves: false, withdrawLeave: false },
      isLoading: false,
      isModalOpen: false,
      formSubmitted: false,
      duration: "full",
      user: this.$store.state.auth.user,
      leaveTypeOptions: ["Casual Leave", "Sick Leave", "Emergency Leave"],
      newLeave: {
        startDate: "",
        endDate: "",
        assignees: "",
        assigneeId: "",
        type: "",
        noofdays: "",
        reason: "",
        status: "Pending"
      },
      userId: this.$store.state.auth.user.uid,
      tableColumns: [{ label: "Assignees", key: "assignees", sticky: "left", sortable: true, width: 150 }, { label: "Employee", key: "employee", sticky: "left", sortable: true, width: 140 }, { label: "Type", key: "type", sortable: true }, { label: "No Of Days", key: "noofdays", sortable: true }, { label: "Dates", key: "dates", sortable: true }, { label: "Applied At", key: "createdAt", sortable: true, formatter: this.formatRelativeTime, width: 180 }, { label: "Reason", key: "reason", width: 200 }, { label: "leavesBalance", key: "leavesBalance" }, { label: "Comments", key: "comment", width: 150 }, { label: "Status", key: "status", width: 130 }, { label: "Action", key: "action", sticky: "right", width: 130 }],
      isActionModalOpen: false,
      selectedLeave: {
        comment: "",
        status: ""
      },
      payrollProcessedMap: {},
      holidays: [],
      isWithdrawModalOpen: false,
      selectedLeaveToWithdraw: null
    };
  },

  computed: {
    leaves: function leaves() {
      var leaves = this.$store.state.auth.AllLeaves || [];
      var userIds = this.filteredUsers.map(function (user) {
        return user.uid;
      });
      var filterLeaves = leaves.filter(function (leave) {
        return userIds.includes(leave.userId);
      });
      return filterLeaves || [];
    },
    isResignedUser: function isResignedUser() {
      var currentUser = this.$store.state.auth.user;
      return currentUser.status === "Resigned";
    },
    filteredUsers: function filteredUsers() {
      var _this = this;

      var company = this.$store.state.auth.company;
      var companyUserIds = company.users.map(function (user) {
        return user.uid;
      });
      var filteredAdmins = this.$store.state.auth.allUsers.filter(function (user) {
        return companyUserIds.includes(user.uid) && user.role === "admin" && user.uid !== _this.userId;
      });
      var emailMatchUser = this.$store.state.auth.allUsers.find(function (user) {
        return user.email === company.email && user.role === "admin" && user.uid !== _this.userId;
      });
      return emailMatchUser ? [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(filteredAdmins), [emailMatchUser]) : filteredAdmins;
    },
    assigneeOptions: function assigneeOptions() {
      return this.filteredUsers.map(function (user) {
        return user.username;
      });
    },
    selectedAssigneeName: function selectedAssigneeName() {
      var _this2 = this;

      if (!this.newLeave.assigneeId) return '';
      var selectedUser = this.filteredUsers.find(function (user) {
        return user.uid === _this2.newLeave.assigneeId;
      });
      return selectedUser ? selectedUser.username : '';
    }
  },
  watch: {
    "$store.state.auth.user": {
      handler: function handler(newUser) {
        this.user = newUser;
        this.updateCards();
      },

      immediate: true
    },
    leaves: {
      handler: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(newLeaves) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(newLeaves.length > 0)) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return this.processPayrollChecks();

                case 3:
                  this.isLoading = false;

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler(_x) {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      immediate: true
    }
  },
  methods: {
    getFirstWorkingDate: function getFirstWorkingDate(start, end, workingDays) {
      var current = new Date(start);
      var endDate = new Date(end);

      while (current <= endDate) {
        var dayNum = current.getDay();
        var isWeekend = dayNum === 0 || dayNum === 6;
        var isHol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_assets_config_helpers_js__["u" /* isHoliday */])(current, this.holidays, this.user.shift);

        if (!isWeekend && !isHol) {
          return new Date(current);
        }
        current.setDate(current.getDate() + 1);
      }
      return null;
    },
    openModal: function openModal() {
      if (this.isResignedUser) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "You can't apply. You are currently serving your notice period.", "error");
        return;
      }
      this.duration = "full";
      this.isModalOpen = true;
    },
    closeModal: function closeModal() {
      this.isModalOpen = false;
    },
    handleAssigneeChange: function handleAssigneeChange(selectedUsername) {
      var selectedUser = this.filteredUsers.find(function (user) {
        return user.username === selectedUsername;
      });
      if (selectedUser) {
        this.newLeave.assigneeId = selectedUser.uid;
        this.newLeave.assignees = selectedUser.username;
      }
    },
    handleLeaveTypeChange: function handleLeaveTypeChange(selectedType) {
      this.newLeave.type = selectedType;
    },
    formatRelativeTime: function formatRelativeTime(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(timestamp).fromNow();
    },
    getStatusClass: function getStatusClass(status) {
      return {
        "Auto-Deducted": "status-badge auto-deducted",
        "Pending": "status-badge pending",
        "Approved": "status-badge approved",
        "Rejected": "status-badge rejected",
        "Withdrawn": "status-badge withdrawn"
      }[status] || "status-badge";
    },
    updateCards: function updateCards() {

      if (!this.user || typeof this.user.leavesAllowed === 'undefined') {
        console.log("User data not fully loaded yet");
        return;
      }

      var leavesAllowed = parseFloat(this.user.leavesAllowed) || 0;
      var leavesTaken = parseFloat(this.user.leavesTaken) || 0;
      var leavesAvailable = parseFloat(this.user.leavesAvailable) || 0;
      var leavesBalance = leavesAllowed - leavesTaken;
      this.cards = [{ value: leavesAvailable.toFixed(1), label: "Total yearly leave(s)", color: "#007bff" }, { value: leavesAllowed.toFixed(1), label: "Allowed Leave(s)", color: "#00c7c7" }, { value: leavesTaken.toFixed(1), label: "Taken Leave(s)", color: "#ff4d4d" }, { value: leavesBalance.toFixed(1), label: "Balance Leave(s)", color: "#00aaff" }];
    },
    fetchHolidays: function fetchHolidays() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var holidaysData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 3:
                holidaysData = _context2.sent;

                _this3.holidays = Array.isArray(holidaysData) ? holidaysData : [];
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                console.error("❌ Failed to fetch holidays:", _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 7]]);
      }))();
    },
    checkHolidaysInRange: function checkHolidaysInRange(start, end) {
      for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_assets_config_helpers_js__["u" /* isHoliday */])(d, this.holidays, this.user.shift)) return true;
      }
      return false;
    },
    isRangeOnlyHolidays: function isRangeOnlyHolidays(start, end, workingDays) {
      var hasWorkingDay = false;
      var hasHoliday = false;
      for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        var isHol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_assets_config_helpers_js__["u" /* isHoliday */])(d, this.holidays, this.user.shift);
        var isWork = this.isWorkingDayForCheck(d, workingDays);
        if (isHol) hasHoliday = true;
        if (!isHol && isWork) hasWorkingDay = true;
      }
      return hasHoliday && !hasWorkingDay;
    },
    isWorkingDayForCheck: function isWorkingDayForCheck(date, workingDays) {
      var workingDaysNums = workingDays.map(function (day) {
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day);
      });
      return workingDaysNums.includes(date.getDay());
    },
    withdrawLeave: function withdrawLeave(item) {
      this.selectedLeaveToWithdraw = item;
      this.isWithdrawModalOpen = true;
    },
    confirmWithdraw: function confirmWithdraw() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var leave, range, dayText, title, description;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.selectedLeaveToWithdraw) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:

                _this4.loading.withdrawLeave = true;

                _context3.prev = 3;
                leave = _this4.selectedLeaveToWithdraw;
                range = leave.startDate + " to " + (leave.endDate || leave.startDate);
                dayText = leave.noofdays === 0.5 ? 'half day' : leave.noofdays > 1 ? 'days' : 'day';
                title = _this4.user.username + " withdrew " + leave.type + " from " + range + " (" + leave.noofdays + " " + dayText + ")";
                description = _this4.user.email + " withdrew " + leave.employee + "'s " + leave.type + " application from " + range + " (" + leave.noofdays + " " + dayText + ").";
                _context3.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this4.user,
                  title: title,
                  description: description,
                  username: leave.employee,
                  type: "leaves",
                  uid: leave.userId
                }));

              case 11:
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].updateLeaveStatusAndComment(leave.id, "Withdrawn", _this4.user.uid);

              case 13:
                leave.status = "Withdrawn";
                _this4.fetchLeaves();

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Success", "Leave has been withdrawn successfully.", "success");
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](3);

                console.error("Error withdrawing leave:", _context3.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Failed to withdraw leave. Please try again.", "error");

              case 22:
                _context3.prev = 22;

                _this4.loading.withdrawLeave = false;
                _this4.isWithdrawModalOpen = false;
                _this4.selectedLeaveToWithdraw = null;
                return _context3.finish(22);

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 18, 22, 27]]);
      }))();
    },
    addLeave: function addLeave() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var start, end, startYear, workingDays, actualWorkingDays, isSingleDay, hasHolidayInRange, holidayOnly, user, employee, leavesAllowed, leavesTaken, leavesBalance, options, dates, firstWorking, displayDate, formattedStartDate, formattedEndDate, assignee, payload, leaveId, _newLeave, type, startDate, endDate, range, uid, username, email, reason, dayText, title, description;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.formSubmitted = true;

                if (!(!_this5.newLeave.assigneeId || !_this5.newLeave.type || !_this5.newLeave.startDate || !_this5.newLeave.endDate || !_this5.newLeave.reason)) {
                  _context4.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Please fill all required fields.", "error");
                return _context4.abrupt("return");

              case 4:
                start = new Date(_this5.newLeave.startDate);
                end = _this5.newLeave.endDate ? new Date(_this5.newLeave.endDate) : new Date(_this5.newLeave.startDate);
                startYear = start.getFullYear();
                workingDays = _this5.user.workingdays || _this5.$store.state.auth.constants && _this5.$store.state.auth.constants.days || [];
                actualWorkingDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_assets_config_helpers_js__["v" /* calculateWorkingDays */])(start, end, workingDays);
                isSingleDay = _this5.newLeave.startDate === _this5.newLeave.endDate || !_this5.newLeave.endDate;

                if (!(_this5.duration === "half")) {
                  _context4.next = 15;
                  break;
                }

                if (isSingleDay) {
                  _context4.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Half day is only allowed for single day leaves.", "error");
                return _context4.abrupt("return");

              case 14:
                actualWorkingDays = 0.5;

              case 15:
                if (!(actualWorkingDays <= 0)) {
                  _context4.next = 18;
                  break;
                }

                if (_this5.newLeave.startDate === _this5.newLeave.endDate) {
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Leave cannot be applied on weekend days.", "error");
                } else {
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "No working days found in the selected range.", "error");
                }
                return _context4.abrupt("return");

              case 18:
                if (!(_this5.holidays.length === 0)) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 21;
                return _this5.fetchHolidays();

              case 21:
                hasHolidayInRange = _this5.checkHolidaysInRange(start, end);
                holidayOnly = _this5.isRangeOnlyHolidays(start, end, workingDays);

                if (!holidayOnly) {
                  _context4.next = 26;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "You cannot apply leave on holidays", "error");
                return _context4.abrupt("return");

              case 26:
                if (hasHolidayInRange) {
                  actualWorkingDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_src_assets_config_helpers_js__["w" /* calculateWorkingDaysExcludingHolidays */])(start, end, workingDays, _this5.holidays, _this5.user.shift);

                  if (_this5.duration === "half") {
                    actualWorkingDays = 0.5;
                  }
                }
                user = _this5.$store.state.auth.user;
                employee = user.username;
                leavesAllowed = parseFloat(user.leavesAllowed) || 0;
                leavesTaken = parseFloat(user.leavesTaken) || 0;
                leavesBalance = leavesAllowed - leavesTaken;

                if (!(leavesBalance < actualWorkingDays)) {
                  _context4.next = 35;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "You don't have sufficient leave balance.", "error");
                return _context4.abrupt("return");

              case 35:
                options = { day: 'numeric', month: 'short' };
                dates = void 0;

                if (actualWorkingDays === 0.5 || actualWorkingDays === 1) {
                  firstWorking = _this5.getFirstWorkingDate(start, end, workingDays);
                  displayDate = firstWorking || start;

                  dates = displayDate.toLocaleDateString('en-US', options);
                } else {
                  formattedStartDate = start.toLocaleDateString('en-US', options);
                  formattedEndDate = end.toLocaleDateString('en-US', options);

                  dates = formattedStartDate + " - " + formattedEndDate;
                }
                assignee = _this5.$store.state.auth.allUsers.find(function (user) {
                  return user.uid === _this5.newLeave.assigneeId;
                });

                if (assignee) {
                  _context4.next = 42;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("(Error)", "Selected assignee not found.", "error");
                return _context4.abrupt("return");

              case 42:
                _context4.prev = 42;

                _this5.loading.applyLeave = true;

                payload = {
                  assignees: assignee.username,
                  assigneeId: _this5.newLeave.assigneeId,
                  type: _this5.newLeave.type,
                  noofdays: actualWorkingDays,
                  reason: _this5.newLeave.reason,
                  status: "Pending",
                  userId: user.uid,
                  employee: user.username,
                  dates: dates,
                  leavesBalance: leavesBalance,
                  createdAt: Date.now(),
                  createdBy: "Admin",
                  startDate: _this5.newLeave.startDate,
                  endDate: _this5.newLeave.endDate || _this5.newLeave.startDate,
                  duration: _this5.duration
                };
                _context4.next = 47;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].submitLeave("leaves", payload);

              case 47:
                leaveId = _context4.sent;
                _newLeave = _this5.newLeave, type = _newLeave.type, startDate = _newLeave.startDate, endDate = _newLeave.endDate;
                range = actualWorkingDays > 1 ? "from " + _this5.formatDate(startDate) + " to " + _this5.formatDate(endDate ? endDate : startDate) : "for " + _this5.formatDate(startDate);
                uid = assignee.uid, username = assignee.username, email = assignee.email;
                reason = payload.reason;
                dayText = actualWorkingDays === 0.5 ? 'half day' : actualWorkingDays > 1 ? 'days' : 'day';
                title = _this5.user.username + " applied " + type + " " + range + " (" + actualWorkingDays + " " + dayText + ")";
                description = _this5.user.email + " applied for " + type + " " + range + " (" + actualWorkingDays + " " + dayText + ").";
                _context4.next = 57;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this5.user,
                  title: title,
                  description: description,
                  reason: reason,
                  username: username,
                  type: "leaves",
                  uid: uid
                }));

              case 57:
                _context4.next = 59;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "leaves",
                  activityDescription: description,
                  activityName: title,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: _this5.user.username
                }, _this5.$store.state.auth, _this5.user.uid);

              case 59:
                // const leaveWithId = { ...payload, id: leaveId };
                // const updatedLeaves = [...this.leaves, leaveWithId];
                // this.$store.commit("setAllLeaves", updatedLeaves);
                _this5.fetchLeaves();
                _this5.newLeave = {
                  startDate: "",
                  endDate: "",
                  assigneeId: "",
                  type: "",
                  reason: ""
                };
                _this5.selectedAssigneeName = "";
                _this5.formSubmitted = false;
                _this5.closeModal();

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Success", "Leave application submitted successfully!", "success");
                _context4.next = 71;
                break;

              case 67:
                _context4.prev = 67;
                _context4.t0 = _context4["catch"](42);

                console.error("Error adding leave:", _context4.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Failed to submit leave application. Please try again.", "error");

              case 71:
                _context4.prev = 71;

                _this5.loading.applyLeave = false;
                return _context4.finish(71);

              case 74:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[42, 67, 71, 74]]);
      }))();
    },
    fetchLeaves: function fetchLeaves() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var allLeaves;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                try {
                  _this6.isLoading = true;
                  allLeaves = _this6.$store.state.auth.AllLeaves || [];

                  _this6.$store.commit("setAllLeaves", allLeaves);
                  _this6.isLoading = false;
                } catch (error) {
                  console.error("Error fetching leaves:", error);
                } finally {
                  _this6.isLoading = false;
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    openActionModal: function openActionModal(leave) {
      this.selectedLeave = leave ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, leave) : { comment: "", status: "" };
      this.isActionModalOpen = true;
    },
    closeActionModal: function closeActionModal() {
      this.isActionModalOpen = false;
    },
    submitAction: function submitAction() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _selectedLeave, id, status, comment, userId, noofdays, createdBy, startDate, endDate, type, leavesuser, originalLeave, today, leaveEndDate, safeComment, response, uid, username, email, title, description, dayText, range;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.loading.responseLeaves = true;

                if (!(_this7.selectedLeave && _this7.selectedLeave.id)) {
                  _context6.next = 60;
                  break;
                }

                _selectedLeave = _this7.selectedLeave, id = _selectedLeave.id, status = _selectedLeave.status, comment = _selectedLeave.comment, userId = _selectedLeave.userId, noofdays = _selectedLeave.noofdays, createdBy = _selectedLeave.createdBy, startDate = _selectedLeave.startDate, endDate = _selectedLeave.endDate, type = _selectedLeave.type;

                if (!(userId === _this7.userId)) {
                  _context6.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "You cannot approve or reject your own leave.", "error");
                _this7.loading.responseLeaves = false;
                _this7.isActionModalOpen = false;
                return _context6.abrupt("return");

              case 8:
                if (!(status == "Pending")) {
                  _context6.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Status is required", "error");
                _this7.loading.responseLeaves = false;
                return _context6.abrupt("return");

              case 12:
                _context6.prev = 12;
                _context6.next = 15;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].getSingleUser(userId);

              case 15:
                leavesuser = _context6.sent;

                if (!leavesuser) {
                  _context6.next = 50;
                  break;
                }

                originalLeave = _this7.leaves.find(function (x) {
                  return id === x.id;
                });

                if (originalLeave) {
                  today = new Date();
                  leaveEndDate = new Date(originalLeave.endDate);
                  // if (leaveEndDate < today.setHours(0, 0, 0, 0)) {
                  //   swal("Error", "You cannot take action on leaves that have already ended.", "error");
                  //   return;
                  // }

                  if (originalLeave.status === "Approved" && status === "Rejected") {
                    leavesuser.leavesTaken = (Number(leavesuser.leavesTaken) - Number(noofdays)).toFixed(1);
                  } else if (originalLeave.status !== "Approved" && status === "Approved") {
                    leavesuser.leavesTaken = (Number(leavesuser.leavesTaken) + Number(noofdays)).toFixed(1);
                  }
                }
                safeComment = comment || "";
                _context6.next = 22;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].updateLeaveStatusAndComment(id, status, userId, safeComment, leavesuser.leavesTaken);

              case 22:
                response = _context6.sent;
                uid = leavesuser.uid, username = leavesuser.username, email = leavesuser.email;
                title = "";
                description = "";
                dayText = noofdays === 0.5 ? 'half day' : noofdays > 1 ? 'days' : 'day';
                range = noofdays > 1 ? "from " + _this7.formatDate(startDate) + " to " + _this7.formatDate(endDate ? endDate : startDate) : "for " + _this7.formatDate(startDate);

                if (!(status === "Approved")) {
                  _context6.next = 37;
                  break;
                }

                title = _this7.user.username + " approved " + username + "'s " + type + " request " + range + " (" + noofdays + " " + dayText + ")";

                description = _this7.user.email + " approved " + email + "'s " + type + " request from " + startDate + " to " + (endDate ? endDate : startDate) + " (" + noofdays + " " + dayText + ").";

                _context6.next = 33;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this7.user,
                  title: title,
                  description: description,
                  reason: safeComment,
                  username: username,
                  type: "leaves",
                  uid: uid
                }));

              case 33:
                _context6.next = 35;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "leaves",
                  activityDescription: description,
                  activityName: title,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: _this7.user.username
                }, _this7.$store.state.auth, _this7.user.uid);

              case 35:
                _context6.next = 44;
                break;

              case 37:
                if (!(status === "Rejected")) {
                  _context6.next = 44;
                  break;
                }

                title = _this7.user.username + " rejected " + username + "'s " + type + " request " + range + " (" + noofdays + " " + dayText + ")";

                description = _this7.user.email + " rejected " + email + "'s " + type + " request from " + startDate + " to " + (endDate ? endDate : startDate) + " (" + noofdays + " " + dayText + ").";

                _context6.next = 42;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this7.user,
                  title: title,
                  description: description,
                  reason: safeComment,
                  username: username,
                  type: "leaves",
                  uid: uid
                }));

              case 42:
                _context6.next = 44;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "leaves",
                  activityDescription: description,
                  activityName: title,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: _this7.user.username
                }, _this7.$store.state.auth, _this7.user.uid);

              case 44:
                //  const userdata= await firebase.getSingleUser(userId)
                //  this.$store.commit("setUser", {
                //   uid: userId,
                //   ...userdata,
                //});


                if (originalLeave) {
                  originalLeave.status = status;
                  originalLeave.comment = safeComment;
                  _this7.$store.commit("setAllLeaves", _this7.leaves);
                }
                _this7.loading.responseLeaves = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Success", "Leave status updated successfully!", "success");
                _this7.isActionModalOpen = false;
                _context6.next = 53;
                break;

              case 50:
                _this7.loading.responseLeaves = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "User associated with this leave not found.", "error");
                console.error("User not found:", userId);

              case 53:
                _context6.next = 60;
                break;

              case 55:
                _context6.prev = 55;
                _context6.t0 = _context6["catch"](12);

                _this7.loading.responseLeaves = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert___default()("Error", "Failed to update leave status. Please try again.", "error");
                console.error("Error updating leave:", _context6.t0);

              case 60:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[12, 55]]);
      }))();
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return "";
      var d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    },
    isMonthPassedAndPayrollProcessed: function isMonthPassedAndPayrollProcessed(item) {
      var endDate = new Date(item.endDate);
      var currentDate = new Date();

      var monthPassed = endDate.getFullYear() < currentDate.getFullYear() || endDate.getFullYear() === currentDate.getFullYear() && endDate.getMonth() < currentDate.getMonth();

      if (!monthPassed) return false;

      return this.payrollProcessedMap[item.id] || false;
    },
    processPayrollChecks: function processPayrollChecks() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, leave, endDate, currentDate, monthPassed, year, month, processed;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.payrollProcessedMap = {};

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context7.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this8.leaves);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context7.next = 23;
                  break;
                }

                leave = _step.value;
                endDate = new Date(leave.endDate);
                currentDate = new Date();
                monthPassed = endDate.getFullYear() < currentDate.getFullYear() || endDate.getFullYear() === currentDate.getFullYear() && endDate.getMonth() < currentDate.getMonth();

                if (monthPassed) {
                  _context7.next = 14;
                  break;
                }

                _this8.$set(_this8.payrollProcessedMap, leave.id, false);
                return _context7.abrupt("continue", 20);

              case 14:
                year = endDate.getFullYear();
                month = __WEBPACK_IMPORTED_MODULE_11_moment___default()(endDate).format("MMMM");
                _context7.next = 18;
                return __WEBPACK_IMPORTED_MODULE_9__assets_config_firebase__["a" /* default */].isPayrollProcessed(year, month, leave.userId);

              case 18:
                processed = _context7.sent;

                _this8.$set(_this8.payrollProcessedMap, leave.id, processed);

              case 20:
                _iteratorNormalCompletion = true;
                _context7.next = 6;
                break;

              case 23:
                _context7.next = 29;
                break;

              case 25:
                _context7.prev = 25;
                _context7.t0 = _context7["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context7.t0;

              case 29:
                _context7.prev = 29;
                _context7.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 32:
                _context7.prev = 32;

                if (!_didIteratorError) {
                  _context7.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context7.finish(32);

              case 36:
                return _context7.finish(29);

              case 37:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[4, 25, 29, 37], [30,, 32, 36]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this9.fetchLeaves();
              _context8.next = 3;
              return _this9.fetchHolidays();

            case 3:
              _this9.$nextTick(function () {
                if (_this9.user) {
                  _this9.updateCards();
                }
              });

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this9);
    }))();
  }
});

/***/ }),

/***/ "qF07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__("hZls");




var constants = {
  namespaced: true,
  state: { constant: null },
  mutations: {
    setConstants: function setConstants(state, payload) {
      state.constant = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload);
    }
  },
  actions: {
    fetchConstants: function fetchConstants(context) {
      __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database().ref("constants").once("value").then(function (snapshot) {
        context.commit("setConstants", snapshot.val());
      });
    }
  },
  getters: {
    getConstants: function getConstants(state) {
      return function () {
        return state.constant;
      };
    }
  }
};

/***/ }),

/***/ "qg9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_underscore__ = __webpack_require__("44pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jspdf__ = __webpack_require__("l9mu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mdi_font_css_materialdesignicons_css__ = __webpack_require__("csSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UIComponents_MonthlyStatus_vue__ = __webpack_require__("iQbm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__UIComponents_LateTimeDropdown_vue__ = __webpack_require__("T3Oj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__UIComponents_loaders_DoubleLoader_vue__ = __webpack_require__("AxYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_expertizoLocation_js__ = __webpack_require__("LtOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__UIComponents_HistoryActivityTable_vue__ = __webpack_require__("jdzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_genralSpecificSettings__ = __webpack_require__("TvP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__UIComponents_EmployeeStatusDropdown_vue__ = __webpack_require__("0gK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__UIComponents_Dropdowns_SearchableDropdown_vue__ = __webpack_require__("KM+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__services_notificationService_js__ = __webpack_require__("l527");










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























__WEBPACK_IMPORTED_MODULE_20_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_21_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  name: "Reports",
  components: {
    MonthlyStats: __WEBPACK_IMPORTED_MODULE_18__UIComponents_MonthlyStatus_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_19__UIComponents_ReuseableModal_vue__["a" /* default */],
    LateTimeDropdown: __WEBPACK_IMPORTED_MODULE_23__UIComponents_LateTimeDropdown_vue__["a" /* default */],
    DoubleLoader: __WEBPACK_IMPORTED_MODULE_24__UIComponents_loaders_DoubleLoader_vue__["a" /* default */],
    HistoryActivityTable: __WEBPACK_IMPORTED_MODULE_29__UIComponents_HistoryActivityTable_vue__["a" /* default */],
    EmployeeStatusDropdown: __WEBPACK_IMPORTED_MODULE_31__UIComponents_EmployeeStatusDropdown_vue__["a" /* default */],
    SearchableDropdown: __WEBPACK_IMPORTED_MODULE_32__UIComponents_Dropdowns_SearchableDropdown_vue__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getAllHolidays;
              _context.next = 3;
              return _this.$store.dispatch('fetchConstantsRealTime');

            case 3:
              window.addEventListener('keydown', _this.handleKeyboard);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyboard);
  },

  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this2 = this;

      var company, store, user;
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              company = this.$store.state.auth.company;
              _context2.prev = 1;

              if (__WEBPACK_IMPORTED_MODULE_11_firebase_app___default.a.apps.length) {
                _context2.next = 5;
                break;
              }

              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].configureFirebase(company.firebase);

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              console.error("Firebase initialization error:", _context2.t0.message);

            case 10:
              store = this.$store;
              user = this.$store.state.auth.user;

              store.commit("loadingStarts");
              // const constants = this.$store.state.auth.constants || {};
              if (user) {
                this.init(user);
              } else {
                this.$store.watch(this.$store.getters.getUser, function (user) {
                  _this2.init(user);
                });
              }
              _context2.prev = 14;
              _context2.next = 17;
              return this.getSettingData();

            case 17:
              _context2.next = 22;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t1 = _context2["catch"](14);

              console.error("Error fetching settings:", _context2.t1);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7], [14, 19]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  data: function data() {
    return {
      hours: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()({ length: 12 }, function (_, i) {
        return (i + 1).toString().padStart(2, "0");
      }),
      minutes: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()({ length: 60 }, function (_, i) {
        return i.toString().padStart(2, "0");
      }),
      meridians: ["AM", "PM"],
      isEditModalOpen: false,
      isEditRequestModalOpen: false,
      isHistoryModalOpen: false,
      isSelectLoading: false,
      selectedDay: {
        timeInHour: "09",
        timeInMinute: "00",
        timeInMeridian: "AM",
        timeOutHour: "05",
        timeOutMinute: "00",
        timeOutMeridian: "PM"
      },
      loading: {
        editRequest: false
      },
      selectedEditRequest: null,
      reason: "",
      description: [{ icon: "mdi-clock-outline", color: "red", for: "Late" }, { icon: "mdi-login", color: "blue", for: "Time In" }, { icon: "mdi-food", color: "orange", for: "Break Start" }, { icon: "mdi-food-off", color: "#77C97B", for: "Break End" }, { icon: "mdi-clock-alert", color: "#D74343", for: "Break Exceed" }, { icon: "mdi-logout", color: "yellow", for: "Time Out" }, { icon: "mdi-check-circle-outline", color: "#4eee19", for: "Completed" }],
      expandedPanels: [],
      employees: [],
      moment: __WEBPACK_IMPORTED_MODULE_12_moment___default.a,
      selectedEmployee: "",
      size: "xl",
      currentMonth: "",
      currentYear: "",
      currentObj: null,
      currentImgObj: null,
      currentScreenshotIndex: 0,
      previewDetails: false,
      hasAdminAccess: false,
      isAdmin: false,
      days: 0,
      workingDays: [],
      holidays: [],
      workingHours: 0,
      years: [],
      months: [{ name: "January" }, { name: "February" }, { name: "March" }, { name: "April" }, { name: "May" }, { name: "June" }, { name: "July" }, { name: "August" }, { name: "September" }, { name: "October" }, { name: "November" }, { name: "December" }],
      logs: [],
      mapPopup: false,
      currentCoordinates: null,
      manualHoursActivities: [],
      manualHoursActivity: [],
      columns: [{ label: "Activity On", key: "activityOnUserName", width: "200px" }, { label: "Activity By", key: "activityByUserName", width: "200px" }, { label: "Action", key: "action" }, { label: "Time In", key: "timeInChange", width: "200px" }, { label: "Time Out  ", key: "timeOutChange", width: "200px" }, { label: "Reason", key: "reason", width: "250px", truncate: true, length: 30 }, { label: "Timestamp", key: "timestamp", width: "230px", truncate: true, length: 20 }, { label: "OS", key: "osName" }, { label: "Browser", key: "browserName" }, { label: "Map", key: "map", width: "70px" }]
    };
  },
  watch: {
    user: function user(newVal) {
      if (newVal) {
        this.init(newVal);
      }
    },
    mapPopup: function mapPopup(val) {
      if (!val) {
        if (L.DomUtil.get("mapIn") != null) {
          L.DomUtil.get("mapIn")._leaflet_id = null;
        }
        if (L.DomUtil.get("mapOut") != null) {
          L.DomUtil.get("mapOut")._leaflet_id = null;
        }
        this.currentCoordinates = null;
      }
    },
    currentImgObj: function currentImgObj(val) {
      if (val && this.currentObj && this.currentObj.screenshots) {
        this.currentScreenshotIndex = this.currentObj.screenshots.findIndex(function (s) {
          return s.url === val.url;
        });
      }
    }
  },
  computed: {
    pendingEditRequestCount: function pendingEditRequestCount() {
      return this.logs.filter(function (log) {
        return log && log.editRequest;
      }).length;
    },
    averageHours: function averageHours() {
      var stats = this.calculateMonthlyStats();
      return stats.averageHours;
    },
    averageMinutes: function averageMinutes() {
      var stats = this.calculateMonthlyStats();
      return stats.averageMinutes;
    }
  },
  methods: {
    handleKeyboard: function handleKeyboard(e) {
      if (this.previewDetails && this.currentImgObj) {
        if (e.key === 'ArrowLeft') {
          this.prevScreenshot();
        } else if (e.key === 'ArrowRight') {
          this.nextScreenshot();
        }
      }
    },
    prevScreenshot: function prevScreenshot() {
      if (this.currentScreenshotIndex > 0) {
        this.currentScreenshotIndex--;
        this.currentImgObj = this.currentObj.screenshots[this.currentScreenshotIndex];
      }
    },
    nextScreenshot: function nextScreenshot() {
      if (this.currentScreenshotIndex < this.currentObj.screenshots.length - 1) {
        this.currentScreenshotIndex++;
        this.currentImgObj = this.currentObj.screenshots[this.currentScreenshotIndex];
      }
    },
    isHoliday: function isHoliday(dayNumber) {
      var _this3 = this;

      var selectedYear = this.currentYear;
      var selectedMonth = new Date(this.currentMonth + " 1, " + selectedYear).getMonth();

      var selectedEmployeeObj = this.employees.find(function (emp) {
        return emp.uid === _this3.selectedEmployee;
      });

      var baseShift = this.isAdmin && selectedEmployeeObj ? selectedEmployeeObj.shift : this.$store.state.auth.user.shift;

      var userShift = (baseShift || "Morning").toLowerCase();

      var workingDays = [];
      if (selectedEmployeeObj && Array.isArray(selectedEmployeeObj.workingDays) && selectedEmployeeObj.workingDays.length) {
        workingDays = selectedEmployeeObj.workingDays.map(function (d) {
          return d.toLowerCase();
        });
      } else {
        workingDays = ["monday", "tuesday", "wednesday", "thursday", "friday"];
      }

      var currentDate = new Date(selectedYear, selectedMonth, dayNumber);
      currentDate.setHours(0, 0, 0, 0);

      var dayName = currentDate.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();

      if (!workingDays.includes(dayName)) return "";

      var matches = this.holidays.filter(function (h) {
        var baseDate = new Date(h.dates);
        baseDate.setHours(0, 0, 0, 0);

        var isRecurring = !!h.isRecurring;
        var daysCount = h.numberOfDays || 1;

        var startDate = new Date(isRecurring ? selectedYear : baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
        startDate.setHours(0, 0, 0, 0);

        var endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + daysCount - 1);

        if (currentDate < startDate || currentDate > endDate) return false;

        if (currentDate.getMonth() !== selectedMonth) return false;

        var hShift = (h.shift || "").toLowerCase();
        if (hShift === "general") return true;

        return hShift === userShift;
      });

      if (!matches.length) return "";

      return matches.map(function (h) {
        return h.name;
      }).join(", ");
    },
    logMouseover: function logMouseover() {
      console.log('Hovering timeOut icon');
    },
    logMouseleave: function logMouseleave() {
      console.log('Mouseleave timeOut icon');
    },
    logEditRequest: function logEditRequest(index) {
      console.log('editRequest:', this.logs[index].editRequest);
    },
    logTooltipCondition: function logTooltipCondition(index) {
      console.log('editRequest:', this.logs[index].editRequest);
      console.log('Tooltip v-if condition:', this.logs[index].originalTimeOut !== this.logs[index].editRequest.timeOut);
      console.log('originalTimeOut:', this.logs[index].originalTimeOut);
      console.log('editRequest.timeOut:', this.logs[index].editRequest.timeOut);
    },
    getSettingData: function getSettingData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_genralSpecificSettings__["a" /* settings */])(_this4.selectedEmployee, _this4.$store.state.auth.constants);

              case 3:
                response = _context3.sent;

                if (response) {
                  _this4.days = response.days || 0;
                  _this4.workingDays = response.days;
                  _this4.workingHours = response.totalHours;
                } else {
                  console.warn("No settings data found for the selected employee.");
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                console.error("Error fetching settings data:", _context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },


    canPerformRequestAction: __WEBPACK_IMPORTED_MODULE_28__utils__["a" /* canPerformRequestAction */],
    updateTimeInHour: function updateTimeInHour(value) {
      this.selectedDay.timeInHour = value;
    },
    updateTimeInMinute: function updateTimeInMinute(value) {
      this.selectedDay.timeInMinute = value;
    },
    updateTimeInMeridian: function updateTimeInMeridian(value) {
      this.selectedDay.timeInMeridian = value;
    },
    updateTimeOutHour: function updateTimeOutHour(value) {
      this.selectedDay.timeOutHour = value;
    },
    updateTimeOutMinute: function updateTimeOutMinute(value) {
      this.selectedDay.timeOutMinute = value;
    },
    updateTimeOutMeridian: function updateTimeOutMeridian(value) {
      this.selectedDay.timeOutMeridian = value;
    },

    calculateLate: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(timeInRaw) {
        var lateHours, lateMinutes, timeInMoment, response, _response$late$split, _response$late$split2, hourStr, minuteStr, allowedLateTime, diffMinutes;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                lateHours = 11;
                lateMinutes = 0;
                timeInMoment = __WEBPACK_IMPORTED_MODULE_12_moment___default()(timeInRaw);
                _context4.prev = 3;
                _context4.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_genralSpecificSettings__["a" /* settings */])(this.selectedEmployee, this.$store.state.auth.constants);

              case 6:
                response = _context4.sent;

                if (response && response.late && response.late.includes(':')) {
                  _response$late$split = response.late.split(':'), _response$late$split2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_response$late$split, 2), hourStr = _response$late$split2[0], minuteStr = _response$late$split2[1];

                  lateHours = parseInt(hourStr) || 11;
                  lateMinutes = parseInt(minuteStr) || 0;
                } else {
                  console.warn("fetchedConstants.late missing or wrong format. Using default 11:00 AM");
                }
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](3);

                console.error("Failed to fetch constants. Using default 11:00 AM", _context4.t0);

              case 13:
                allowedLateTime = timeInMoment.clone().hours(lateHours).minutes(lateMinutes).seconds(0).milliseconds(0);
                diffMinutes = timeInMoment.diff(allowedLateTime, 'minutes');
                return _context4.abrupt("return", {
                  hours: diffMinutes > 0 ? Math.floor(diffMinutes / 60) : 0,
                  minutes: diffMinutes > 0 ? diffMinutes % 60 : 0
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 10]]);
      }));

      function calculateLate(_x) {
        return _ref2.apply(this, arguments);
      }

      return calculateLate;
    }(),

    editLog: function editLog(log) {
      if (typeof log === "number") {
        this.selectedDay = {
          timeInHour: "09",
          timeInMinute: "00",
          timeInMeridian: "AM",
          timeOutHour: "05",
          timeOutMinute: "00",
          timeOutMeridian: "PM",
          day: log,
          log: { day: log }
        };
        this.reason = "";
        this.isEditModalOpen = true;
        return;
      }

      // If log is an object (existing log), open modal for editing
      if (log && (typeof log === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(log)) === "object") {
        var timeInMoment = __WEBPACK_IMPORTED_MODULE_12_moment___default()(log.timeIn, "hh:mm A");
        var timeOutMoment = __WEBPACK_IMPORTED_MODULE_12_moment___default()(log.timeOut, "hh:mm A");
        this.selectedDay = {
          timeInHour: timeInMoment.isValid() ? timeInMoment.format("hh") : "09",
          timeInMinute: timeInMoment.isValid() ? timeInMoment.format("mm") : "00",
          timeInMeridian: timeInMoment.isValid() ? timeInMoment.format("A") : "AM",
          timeOutHour: timeOutMoment.isValid() ? timeOutMoment.format("hh") : "05",
          timeOutMinute: timeOutMoment.isValid() ? timeOutMoment.format("mm") : "00",
          timeOutMeridian: timeOutMoment.isValid() ? timeOutMoment.format("A") : "PM",
          log: log
        };
        this.reason = log.reason || "";
        this.isEditModalOpen = true;
        return;
      }
    },
    closemodal: function closemodal() {
      this.isEditRequestModalOpen = false;
    },
    formatTime: function formatTime(time) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(time).format("hh:mm A");
    },
    formatDuration: function formatDuration(ms) {
      var totalSeconds = Math.floor(ms / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor(totalSeconds % 3600 / 60);
      var seconds = totalSeconds % 60;

      if (hours > 0) return hours + "h " + minutes + "m";
      if (minutes === 0) return seconds + "s";
      if (seconds === 0) return minutes + "m";
      return minutes + "m " + seconds + "s";
    },
    submitAction: function submitAction() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var selectedEmployeeObj, timeIn, timeOut, log, logIndex, _canPerformRequestAct, allowed, message, selectedDayNum, dateString, timeInMoment, timeOutMoment, isNightShift, timeInHour, timeOutHour, obj, commonFields, adminActivity, activityData, _$store$state$auth$us, username, uid, originalDate, _moment$format$split, _moment$format$split2, inHours, inMinutes, _moment$format$split3, _moment$format$split4, outHours, outMinutes, updatedTimeIn, updatedTimeOut, _isNightShift, _timeInHour, _timeOutHour, updatedSessions, isTimeInChanged, isTimeOutChanged, formattedTimeOut, lastSession, formattedTimeIn, updatedLatestScreenshotTime, user, userName, userEmail, timeParts, timeInChange, timeOutChange, timeText, currentUser, isValid, payload, _commonFields, _adminActivity, _activityData, _$store$state$auth$us2, _username, _uid, _userName, _userEmail, role, isSuperAdmin, editRequest, _commonFields2, _adminActivity2, _activityData2;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                selectedEmployeeObj = _this5.employees.find(function (emp) {
                  return emp.uid === _this5.selectedEmployee;
                });
                timeIn = _this5.selectedDay.timeInHour + ":" + _this5.selectedDay.timeInMinute + " " + _this5.selectedDay.timeInMeridian;
                timeOut = _this5.selectedDay.timeOutHour + ":" + _this5.selectedDay.timeOutMinute + " " + _this5.selectedDay.timeOutMeridian;
                log = _this5.selectedDay.log;
                logIndex = _this5.selectedDay.logIndex;

                if (!(!_this5.reason || _this5.reason.trim() === "")) {
                  _context5.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Missing Field", "Please enter a reason for this edit.", "warning");
                return _context5.abrupt("return");

              case 8:
                if (!(!_this5.selectedDay.timeInHour || !_this5.selectedDay.timeInMinute || !_this5.selectedDay.timeInMeridian || !_this5.selectedDay.timeOutHour || !_this5.selectedDay.timeOutMinute || !_this5.selectedDay.timeOutMeridian)) {
                  _context5.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Missing Fields", "Please fill in all Time In and Time Out fields.", "warning");
                return _context5.abrupt("return");

              case 11:
                if (!(!log || !log.key)) {
                  _context5.next = 81;
                  break;
                }

                _context5.prev = 12;

                _this5.loading.editRequest = true;

                if (selectedEmployeeObj) {
                  _context5.next = 17;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Please select an employee.", "error");
                return _context5.abrupt("return");

              case 17:
                if (!(!_this5.$store.state.auth.user.isSuperAdmin == true)) {
                  _context5.next = 22;
                  break;
                }

                _canPerformRequestAct = _this5.canPerformRequestAction(selectedEmployeeObj, _this5.$store.state.auth.user, "edit"), allowed = _canPerformRequestAct.allowed, message = _canPerformRequestAct.message;

                if (allowed) {
                  _context5.next = 22;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", message, "error");
                return _context5.abrupt("return");

              case 22:
                selectedDayNum = _this5.selectedDay.log && _this5.selectedDay.log.day || 1;

                if (!(!_this5.currentMonth || !_this5.currentYear)) {
                  _context5.next = 26;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Please select a valid month and year.", "error");
                return _context5.abrupt("return");

              case 26:
                dateString = _this5.currentMonth + " " + selectedDayNum + ", " + _this5.currentYear;
                timeInMoment = __WEBPACK_IMPORTED_MODULE_12_moment___default()(dateString + " " + timeIn, "MMMM D, YYYY hh:mm A");
                timeOutMoment = __WEBPACK_IMPORTED_MODULE_12_moment___default()(dateString + " " + timeOut, "MMMM D, YYYY hh:mm A");

                if (!(!timeInMoment.isValid() || !timeOutMoment.isValid())) {
                  _context5.next = 32;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Invalid date or time format.", "error");
                return _context5.abrupt("return");

              case 32:
                isNightShift = selectedEmployeeObj.shift && selectedEmployeeObj.shift.toLowerCase() === "night" || null;

                if (!isNightShift) {
                  _context5.next = 39;
                  break;
                }

                timeInHour = timeInMoment.hours();
                timeOutHour = timeOutMoment.hours();

                if (!(timeInHour < 12 && timeOutHour >= 12)) {
                  _context5.next = 39;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Invalid Timing", "12 PM is the cutoff time for night shifts. Please select a valid Time Out.", "error");
                return _context5.abrupt("return");

              case 39:

                if (isNightShift && timeOutMoment.valueOf() < timeInMoment.valueOf()) {
                  timeOutMoment.add(1, 'day');
                }

                if (!(timeInMoment.valueOf() > timeOutMoment.valueOf())) {
                  _context5.next = 43;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "TimeOut must not be earlier than TimeIn.", "error");
                return _context5.abrupt("return");

              case 43:
                _context5.t0 = selectedEmployeeObj.username || '';
                _context5.t1 = _this5.selectedEmployee;
                _context5.t2 = selectedDayNum;
                _context5.t3 = timeOutMoment.valueOf();
                _context5.t4 = timeInMoment.valueOf();
                _context5.t5 = timeOutMoment.valueOf();
                _context5.t6 = [{
                  timeIn: timeInMoment.valueOf(),
                  timeOut: timeOutMoment.valueOf()
                }];
                _context5.t7 = [];
                _context5.next = 53;
                return _this5.calculateLate(timeInMoment);

              case 53:
                _context5.t8 = _context5.sent;
                _context5.t9 = timeInMoment.valueOf();
                obj = {
                  name: _context5.t0,
                  userId: _context5.t1,
                  day: _context5.t2,
                  latestScreenshotTime: _context5.t3,
                  timeIn: _context5.t4,
                  timeOut: _context5.t5,
                  sessions: _context5.t6,
                  screenshots: _context5.t7,
                  late: _context5.t8,
                  createdAt: _context5.t9
                };
                commonFields = {
                  description: _this5.$store.state.auth.user.email + " manually entered " + selectedEmployeeObj.email + "'s hours for " + _this5.currentMonth + " " + _this5.selectedDay.day + ", " + _this5.currentYear + ". Time In: " + timeIn + " and Time Out: " + timeOut,
                  activityName: _this5.$store.state.auth.user.username + " manually entered " + selectedEmployeeObj.username + "'s hours for " + _this5.currentMonth + " " + _this5.selectedDay.day + ", " + _this5.currentYear + ". Time In: " + timeIn + " and Time Out: " + timeOut
                };
                adminActivity = {
                  adminId: _this5.$store.state.auth.user.uid,
                  activityOnUser: _this5.selectedEmployee,
                  action: "Added",
                  activityOnUserName: selectedEmployeeObj.username || 'Unknown User',
                  activityByUserName: _this5.$store.state.auth.user.username || 'Unknown User',
                  activityTitle: 'hours manually added',
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  type: 'manual_hours',
                  timestamp: new Date().toLocaleString('en-PK'),
                  timeInChange: timeIn,
                  timeOutChange: timeOut,
                  reason: _this5.reason
                };
                _context5.next = 60;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_adminLogs__["c" /* logAdminActivity */])(adminActivity);

              case 60:
                activityData = _context5.sent;
                _$store$state$auth$us = _this5.$store.state.auth.user, username = _$store$state$auth$us.username, uid = _$store$state$auth$us.uid;
                _context5.next = 64;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "manual_hours",
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  activityOnUser: selectedEmployeeObj.uid,
                  activityOnUserName: selectedEmployeeObj.username,
                  activityByUserName: username,
                  action: "added"
                }, _this5.$store.state.auth, uid);

              case 64:
                _context5.next = 66;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].pushDatabase("timePeriod/", obj);

              case 66:
                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Success", "Log added successfully.", "success");

                _this5.isEditModalOpen = false;
                _context5.next = 70;
                return _this5.selectMonthYear();

              case 70:
                return _context5.abrupt("return");

              case 73:
                _context5.prev = 73;
                _context5.t10 = _context5["catch"](12);

                console.log("Error details:", _context5.t10);
                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Failed to add new log: " + _context5.t10.message, "error");
                return _context5.abrupt("return");

              case 78:
                _context5.prev = 78;

                _this5.loading.editRequest = false;
                return _context5.finish(78);

              case 81:
                if (!(!timeIn || !timeOut)) {
                  _context5.next = 84;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Missing Fields", "Both Time In and Time Out must be filled.", "warning");
                return _context5.abrupt("return");

              case 84:
                _context5.prev = 84;

                _this5.loading.editRequest = true;
                originalDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(log.createdAt);
                _moment$format$split = __WEBPACK_IMPORTED_MODULE_12_moment___default()(timeIn, "hh:mm A").format("HH:mm").split(":"), _moment$format$split2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_moment$format$split, 2), inHours = _moment$format$split2[0], inMinutes = _moment$format$split2[1];
                _moment$format$split3 = __WEBPACK_IMPORTED_MODULE_12_moment___default()(timeOut, "hh:mm A").format("HH:mm").split(":"), _moment$format$split4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_moment$format$split3, 2), outHours = _moment$format$split4[0], outMinutes = _moment$format$split4[1];
                updatedTimeIn = originalDate.clone().hours(inHours).minutes(inMinutes).seconds(0).milliseconds(0).valueOf();
                updatedTimeOut = originalDate.clone().hours(outHours).minutes(outMinutes).seconds(0).milliseconds(0).valueOf();
                _isNightShift = selectedEmployeeObj && selectedEmployeeObj.shift && selectedEmployeeObj.shift.toLowerCase() === "night" || null;

                if (!_isNightShift) {
                  _context5.next = 98;
                  break;
                }

                _timeInHour = __WEBPACK_IMPORTED_MODULE_12_moment___default()(updatedTimeIn).hours();
                _timeOutHour = __WEBPACK_IMPORTED_MODULE_12_moment___default()(updatedTimeOut).hours();

                if (!(_timeInHour < 12 && _timeOutHour >= 12)) {
                  _context5.next = 98;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Invalid Timing", "12 PM is the cutoff time for night shifts. Please select a valid Time Out.", "error");
                return _context5.abrupt("return");

              case 98:

                if (_isNightShift && updatedTimeOut < updatedTimeIn) {
                  updatedTimeOut = originalDate.clone().add(1, 'day').hours(outHours).minutes(outMinutes).seconds(0).milliseconds(0).valueOf();
                }

                updatedSessions = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(log.sessions));
                isTimeInChanged = log.timeIn !== timeIn;
                isTimeOutChanged = log.timeOut !== timeOut;

                if (!isTimeInChanged) {
                  _context5.next = 107;
                  break;
                }

                if (!(updatedSessions.length > 0 && updatedTimeIn >= updatedSessions[0].timeOut)) {
                  _context5.next = 107;
                  break;
                }

                formattedTimeOut = __WEBPACK_IMPORTED_MODULE_12_moment___default()(updatedSessions[0].timeOut).format("hh:mm A");

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Invalid Time In", "Time In must be earlier than " + formattedTimeOut, "error");
                return _context5.abrupt("return");

              case 107:
                if (!isTimeOutChanged) {
                  _context5.next = 113;
                  break;
                }

                lastSession = updatedSessions[updatedSessions.length - 1];

                if (!(lastSession && updatedTimeOut <= lastSession.timeIn)) {
                  _context5.next = 113;
                  break;
                }

                formattedTimeIn = __WEBPACK_IMPORTED_MODULE_12_moment___default()(lastSession.timeIn).format("hh:mm A");

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Invalid Time Out", "Time Out must be later than " + formattedTimeIn, "error");
                return _context5.abrupt("return");

              case 113:

                if (log.timeIn !== timeIn && updatedSessions[0]) {
                  updatedSessions[0].timeIn = updatedTimeIn;
                }
                if (log.timeOut !== timeOut && updatedSessions[updatedSessions.length - 1]) {
                  updatedSessions[updatedSessions.length - 1].timeOut = updatedTimeOut;
                }

                if (!(log.timeIn === timeIn && log.timeOut === timeOut)) {
                  _context5.next = 118;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("No Changes", "There are no changes to be saved.", "info");
                return _context5.abrupt("return");

              case 118:
                updatedLatestScreenshotTime = log.latestScreenshotTime;

                if (log.timeOut !== timeOut) {
                  updatedLatestScreenshotTime = updatedTimeOut;
                }
                user = _this5.employees.find(function (emp) {
                  return emp.uid === log.userId;
                });
                userName = user ? user.username : 'Unknown User';
                userEmail = user ? user.email : 'Unknown User';
                timeParts = [];
                timeInChange = null;
                timeOutChange = null;

                if (log.timeIn !== timeIn) {
                  timeInChange = (!log.timeIn ? "N/A" : log.timeIn) + " \u2192 " + timeIn;
                  timeParts.push("Time In: " + timeInChange);
                }
                if (log.timeOut !== timeOut) {
                  timeOutChange = (!log.timeOut ? "N/A" : log.timeOut) + " \u2192 " + timeOut;
                  timeParts.push("Time Out: " + timeOutChange);
                }
                timeText = timeParts.join(' and ');
                currentUser = _this5.$store.state.auth.user;
                isValid = _this5.hasAdminAccess && !(log.userId === currentUser.uid && currentUser.isSuperAdmin !== true);

                if (!isValid) {
                  _context5.next = 156;
                  break;
                }

                _context5.t11 = updatedTimeIn;
                _context5.t12 = updatedTimeOut;
                _context5.t13 = updatedSessions;
                _context5.t14 = updatedLatestScreenshotTime;
                _context5.next = 138;
                return _this5.calculateLate(updatedTimeIn);

              case 138:
                _context5.t15 = _context5.sent;
                payload = {
                  timeIn: _context5.t11,
                  timeOut: _context5.t12,
                  sessions: _context5.t13,
                  latestScreenshotTime: _context5.t14,
                  editRequest: null,
                  late: _context5.t15
                };
                _commonFields = {
                  description: _this5.$store.state.auth.user.email + " updated " + userEmail + "'s hours for " + _this5.currentMonth + " " + log.day + ", " + _this5.currentYear + ". " + timeText,
                  activityName: _this5.$store.state.auth.user.username + " updated " + userName + "'s hours for " + _this5.currentMonth + " " + log.day + ", " + _this5.currentYear + ". " + timeText
                };
                _adminActivity = {
                  adminId: _this5.$store.state.auth.user.uid,
                  activityOnUser: log.userId,
                  activityOnUserName: log.name,
                  activityByUserName: _this5.$store.state.auth.user.username || 'Unknown User',
                  activityTitle: 'hours manually updated',
                  activityDescription: _commonFields.description,
                  activityName: _commonFields.activityName,
                  type: 'manual_hours',
                  action: "Updated",
                  timestamp: new Date().toLocaleString('en-PK'),
                  timeInChange: timeInChange,
                  timeOutChange: timeOutChange,
                  Key: log.key,
                  reason: _this5.reason
                };
                _context5.next = 144;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_adminLogs__["c" /* logAdminActivity */])(_adminActivity);

              case 144:
                _activityData = _context5.sent;
                _$store$state$auth$us2 = _this5.$store.state.auth.user, _username = _$store$state$auth$us2.username, _uid = _$store$state$auth$us2.uid;
                _context5.next = 148;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "manual_hours",
                  activityDescription: _commonFields.description,
                  activityName: _commonFields.activityName,
                  activityOnUser: log.userId,
                  activityOnUserName: log.name,
                  activityByUserName: _username,
                  action: "updated"
                }, _this5.$store.state.auth, _uid);

              case 148:
                _context5.next = 150;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].updateLogTime(log.key, payload);

              case 150:
                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Success", "Log updated successfully.", "success");
                _context5.next = 153;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this5.currentMonth, _this5.currentYear, log.userId);

              case 153:
                _this5.manualHoursActivities = _context5.sent;
                _context5.next = 174;
                break;

              case 156:
                _userName = _this5.$store.state.auth.user.username || 'Unknown User';
                _userEmail = _this5.$store.state.auth.user.email || 'Unknown User';
                role = _this5.$store.state.auth.user.role;
                isSuperAdmin = _this5.$store.state.auth.user.isSuperAdmin || null;
                editRequest = {
                  userName: _userName,
                  userEmail: _userEmail,
                  day: log.day,
                  timeIn: timeIn,
                  timeOut: timeOut,
                  originalTimeIn: log.timeIn !== undefined ? log.timeIn : "",
                  originalTimeOut: log.timeOut !== undefined ? log.timeOut : "",
                  requestedAt: new Date().getTime(),
                  userId: log.userId,
                  role: role,
                  isSuperAdmin: isSuperAdmin,
                  Key: log.key,
                  reason: _this5.reason
                };
                _commonFields2 = {
                  description: _userEmail + " requested an edit for " + _this5.currentMonth + " " + log.day + ", " + _this5.currentYear + ". " + timeText,
                  activityName: _userName + " requested an edit for " + _this5.currentMonth + " " + log.day + ", " + _this5.currentYear + ". " + timeText
                };
                _adminActivity2 = {
                  activityOnUser: log.userId,
                  activityOnUserName: log.name,
                  activityByUserName: log.name,
                  action: "Requested",
                  activityTitle: 'hours edit request',
                  activityDescription: _commonFields2.description,
                  activityName: _commonFields2.activityName,
                  type: 'manual_hours',
                  timestamp: new Date().toLocaleString('en-PK'),
                  timeInChange: timeInChange,
                  timeOutChange: timeOutChange,
                  Key: log.key,
                  reason: _this5.reason
                };
                _context5.next = 165;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_adminLogs__["c" /* logAdminActivity */])(_adminActivity2);

              case 165:
                _activityData2 = _context5.sent;
                _context5.next = 168;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "manual_hours",
                  activityDescription: _commonFields2.description,
                  activityName: _commonFields2.activityName,
                  activityOnUser: log.userId,
                  activityOnUserName: log.name,
                  activityByUserName: _userName,
                  action: "request"
                }, _this5.$store.state.auth, log.userId);

              case 168:
                if (!(!_activityData2.latitude || !_activityData2.longitude)) {
                  _context5.next = 171;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Geolocation is required to submit an edit request.", "error");
                return _context5.abrupt("return");

              case 171:
                _context5.next = 173;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].updateLogTime(log.key, { editRequest: editRequest });

              case 173:
                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Success", "Edit request submitted for admin approval.", "success");

              case 174:

                _this5.isEditModalOpen = false;
                if (logIndex >= 0) {
                  _this5.$set(_this5.expandedPanels, logIndex, true);
                }
                _this5.selectMonthYear();

                _context5.next = 183;
                break;

              case 179:
                _context5.prev = 179;
                _context5.t16 = _context5["catch"](84);

                if (_context5.t16.message.includes("Location permission")) {
                  __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", _context5.t16.message, "error");
                } else {
                  console.log("Error details:", _context5.t16);
                  __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Failed to add new log: " + _context5.t16.message, "error");
                }
                return _context5.abrupt("return");

              case 183:
                _context5.prev = 183;

                _this5.loading.editRequest = false;
                return _context5.finish(183);

              case 186:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[12, 73, 78, 81], [84, 179, 183, 186]]);
      }))();
    },
    openEditRequestModal: function openEditRequestModal(log) {
      this.selectedEditRequest = {
        key: log.key,
        originalTimeIn: log.timeIn,
        originalTimeOut: log.timeOut,
        editRequest: log.editRequest
      };
      this.isEditRequestModalOpen = true;
    },
    approveEditRequest: function approveEditRequest() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _canPerformRequestAct2, allowed, message, log, logIndex, originalDate, timeIn, timeOut, _moment$format$split5, _moment$format$split6, inHours, inMinutes, _moment$format$split7, _moment$format$split8, outHours, outMinutes, updatedTimeIn, updatedTimeOut, updatedSessions, user, username, userEmail, timeChanges, timeInChange, timeOutChange, timeChangesText, activityName, activityDescription, adminActivity, activityData, _$store$state$auth$us3, adminUserName, uid, payload;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _canPerformRequestAct2 = _this6.canPerformRequestAction(_this6.selectedEditRequest.editRequest, _this6.$store.state.auth.user, "approve"), allowed = _canPerformRequestAct2.allowed, message = _canPerformRequestAct2.message;

                if (allowed) {
                  _context6.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", message, "error");
                return _context6.abrupt("return");

              case 4:
                if (!(!_this6.selectedEditRequest || !_this6.selectedEditRequest.key)) {
                  _context6.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "No edit request selected.", "error");
                return _context6.abrupt("return");

              case 7:
                _context6.prev = 7;
                log = _this6.logs.find(function (l) {
                  return l && l.key === _this6.selectedEditRequest.key;
                });

                if (log) {
                  _context6.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Log not found.", "error");
                return _context6.abrupt("return");

              case 12:
                logIndex = _this6.logs.findIndex(function (l) {
                  return l && l.key === _this6.selectedEditRequest.key;
                });
                originalDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(log.createdAt);
                timeIn = _this6.selectedEditRequest.editRequest.timeIn;
                timeOut = _this6.selectedEditRequest.editRequest.timeOut;
                _moment$format$split5 = __WEBPACK_IMPORTED_MODULE_12_moment___default()(timeIn, "hh:mm A").format("HH:mm").split(":"), _moment$format$split6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_moment$format$split5, 2), inHours = _moment$format$split6[0], inMinutes = _moment$format$split6[1];
                _moment$format$split7 = __WEBPACK_IMPORTED_MODULE_12_moment___default()(timeOut, "hh:mm A").format("HH:mm").split(":"), _moment$format$split8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_moment$format$split7, 2), outHours = _moment$format$split8[0], outMinutes = _moment$format$split8[1];
                updatedTimeIn = originalDate.clone().hours(inHours).minutes(inMinutes).seconds(0).milliseconds(0).valueOf();
                updatedTimeOut = originalDate.clone().hours(outHours).minutes(outMinutes).seconds(0).milliseconds(0).valueOf();
                updatedSessions = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(log.sessions));


                if (log.timeIn !== timeIn && updatedSessions[0]) {
                  updatedSessions[0].timeIn = updatedTimeIn;
                }
                if (log.timeOut !== timeOut && updatedSessions[updatedSessions.length - 1]) {
                  updatedSessions[updatedSessions.length - 1].timeOut = updatedTimeOut;
                }

                user = _this6.employees.find(function (emp) {
                  return emp.uid === log.userId;
                });
                username = user ? user.username : 'Unknown User';
                userEmail = user ? user.email : 'Unknown Email';
                timeChanges = [];
                timeInChange = null;
                timeOutChange = null;


                if (log.timeIn !== timeIn) {
                  timeInChange = (!log.timeIn ? "N/A" : log.timeIn) + " \u2192 " + timeIn;
                  timeChanges.push("Time In: " + timeInChange);
                }
                if (log.timeOut !== timeOut) {
                  timeOutChange = (!log.timeOut ? "N/A" : log.timeOut) + " \u2192 " + timeOut;
                  timeChanges.push("Time Out: " + timeOutChange);
                }
                timeChangesText = timeChanges.join(' and ');
                activityName = _this6.$store.state.auth.user.username + " approved " + username + "'s request to edit working hours for " + _this6.currentMonth + " " + log.day + ", " + _this6.currentYear + (timeChangesText ? ". " + timeChangesText : '');
                activityDescription = _this6.$store.state.auth.user.email + " approved " + userEmail + "'s request to edit working hours for " + _this6.currentMonth + " " + log.day + ", " + _this6.currentYear + (timeChangesText ? ". " + timeChangesText : '');
                adminActivity = {
                  adminId: _this6.$store.state.auth.user.uid,
                  activityOnUser: log.userId,
                  activityOnUserName: log.name,
                  action: "Approved",
                  activityByUserName: _this6.$store.state.auth.user.username || 'Unknown User',
                  activityTitle: 'hours manually updated',
                  activityName: activityName,
                  activityDescription: activityDescription,
                  type: 'manual_hours',
                  timestamp: new Date().toLocaleString('en-PK'),
                  timeInChange: timeInChange,
                  timeOutChange: timeOutChange,
                  Key: log.key
                };
                _context6.next = 37;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_adminLogs__["c" /* logAdminActivity */])(adminActivity);

              case 37:
                activityData = _context6.sent;
                _$store$state$auth$us3 = _this6.$store.state.auth.user, adminUserName = _$store$state$auth$us3.username, uid = _$store$state$auth$us3.uid;
                _context6.next = 41;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "manual_hours",
                  activityDescription: activityDescription,
                  activityName: activityName,
                  activityOnUser: log.userId,
                  activityOnUserName: log.name,
                  activityByUserName: adminUserName,
                  action: "approve"
                }, _this6.$store.state.auth, uid);

              case 41:
                if (!(!activityData.latitude || !activityData.longitude)) {
                  _context6.next = 45;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Location permission is denied. Please enable it in browser settings.", "error");;
                return _context6.abrupt("return");

              case 45:
                _context6.t0 = updatedTimeIn;
                _context6.t1 = updatedTimeOut;
                _context6.t2 = updatedTimeOut;
                _context6.t3 = updatedSessions;
                _context6.next = 51;
                return _this6.calculateLate(updatedTimeIn);

              case 51:
                _context6.t4 = _context6.sent;
                payload = {
                  timeIn: _context6.t0,
                  timeOut: _context6.t1,
                  latestScreenshotTime: _context6.t2,
                  sessions: _context6.t3,
                  editRequest: null,
                  late: _context6.t4
                };
                _context6.next = 55;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].updateLogTime(_this6.selectedEditRequest.key, payload);

              case 55:
                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Success", "Edit request approved.", "success");
                _this6.isEditRequestModalOpen = false;
                _this6.selectedEditRequest = null;
                if (logIndex >= 0) {
                  _this6.$set(_this6.expandedPanels, logIndex, true);
                }
                _context6.next = 61;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this6.currentMonth, _this6.currentYear);

              case 61:
                _this6.manualHoursActivities = _context6.sent;

                _this6.selectMonthYear();
                _context6.next = 69;
                break;

              case 65:
                _context6.prev = 65;
                _context6.t5 = _context6["catch"](7);

                if (_context6.t5.message.includes("Location permission")) {
                  __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", _context6.t5.message, "error");
                } else {
                  __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Failed to add new log: " + _context6.t5.message, "error");
                }
                return _context6.abrupt("return");

              case 69:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[7, 65]]);
      }))();
    },
    rejectEditRequest: function rejectEditRequest() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _canPerformRequestAct3, allowed, message, edit, username, useremail, timeInChanged, timeOutChanged, timeChanges, timeInChange, timeOutChange, timeChangeText, loggedInUser, isAdmin, activityDescription, activityName, adminActivity, activityData;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _canPerformRequestAct3 = _this7.canPerformRequestAction(_this7.selectedEditRequest.editRequest, _this7.$store.state.auth.user, "reject"), allowed = _canPerformRequestAct3.allowed, message = _canPerformRequestAct3.message;

                if (allowed) {
                  _context7.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", message, "error");
                return _context7.abrupt("return");

              case 4:
                if (!(!_this7.selectedEditRequest || !_this7.selectedEditRequest.key)) {
                  _context7.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "No edit request selected.", "error");
                return _context7.abrupt("return");

              case 7:
                _context7.prev = 7;
                edit = _this7.selectedEditRequest.editRequest;
                username = _this7.$store.state.auth.user.username;
                useremail = _this7.$store.state.auth.user.email;
                timeInChanged = edit.originalTimeIn !== edit.timeIn;
                timeOutChanged = edit.originalTimeOut !== edit.timeOut;
                timeChanges = [];
                timeInChange = null;
                timeOutChange = null;

                if (timeInChanged) {
                  timeInChange = (!edit.originalTimeIn ? "N/A" : edit.originalTimeIn) + " \u2192 " + edit.timeIn;
                  timeChanges.push("Time In: " + timeInChange);
                }
                if (timeOutChanged) {
                  timeOutChange = (!edit.originalTimeOut ? "N/A" : edit.originalTimeOut) + " \u2192 " + edit.timeOut;
                  timeChanges.push("Time Out: " + timeOutChange);
                }
                timeChangeText = timeChanges.length > 0 ? ". " + timeChanges.join(' and ') : '';
                loggedInUser = _this7.$store.state.auth.user;
                isAdmin = loggedInUser.role === 'admin';
                activityDescription = useremail + " rejected " + edit.userEmail + "'s request to edit working hours for " + _this7.currentMonth + " " + edit.day + ", " + _this7.currentYear + timeChangeText;
                activityName = username + " rejected " + edit.userName + "'s request to edit working hours for " + _this7.currentMonth + " " + edit.day + ", " + _this7.currentYear + timeChangeText;
                adminActivity = {
                  timestamp: new Date().toLocaleString('en-PK'),
                  activityDescription: activityDescription,
                  activityName: activityName,
                  activityByUserName: username || 'Unknown User',
                  action: "Rejected",
                  Key: _this7.selectedEditRequest.key,
                  activityOnUser: edit.userId,
                  activityOnUserName: edit.userName || 'Unknown User',
                  activityTitle: 'hours edit request',
                  type: 'manual_hours',
                  timeInChange: timeInChange,
                  timeOutChange: timeOutChange
                };

                if (isAdmin) {
                  adminActivity.adminId = loggedInUser.uid;
                }
                _context7.next = 27;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_adminLogs__["c" /* logAdminActivity */])(adminActivity);

              case 27:
                activityData = _context7.sent;
                _context7.next = 30;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "manual_hours",
                  activityDescription: activityDescription,
                  activityName: activityName,
                  activityOnUser: edit.userId,
                  activityOnUserName: edit.userName,
                  activityByUserName: username,
                  action: "reject"
                }, _this7.$store.state.auth, _this7.$store.state.auth.user.uid);

              case 30:
                if (!(!activityData.latitude || !activityData.longitude)) {
                  _context7.next = 33;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Geolocation is required to reject the edit request.", "error");
                return _context7.abrupt("return");

              case 33:
                _context7.next = 35;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].updateLogTime(_this7.selectedEditRequest.key, { editRequest: null });

              case 35:

                __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Success", "Edit request rejected.", "success");
                _this7.isEditRequestModalOpen = false;
                _this7.selectedEditRequest = null;
                _this7.selectMonthYear();
                _context7.next = 45;
                break;

              case 41:
                _context7.prev = 41;
                _context7.t0 = _context7["catch"](7);

                if (_context7.t0.message.includes("Location permission")) {
                  __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", _context7.t0.message, "error");
                } else {
                  __WEBPACK_IMPORTED_MODULE_22_sweetalert___default()("Error", "Failed to add new log: " + _context7.t0.message, "error");
                }
                return _context7.abrupt("return");

              case 45:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[7, 41]]);
      }))();
    },
    details: function details(index) {
      this.currentObj = this.logs[index];
      this.previewDetails = true;
      this.currentImgObj = null;
      this.currentScreenshotIndex = 0;
    },
    calculateMonthlyStats: function calculateMonthlyStats() {
      var totalLates = this.logs.filter(function (log) {
        return log && log.late && (log.late.hours > 0 || log.late.minutes > 0);
      }).length;

      var totalSpentHours = 0;
      var totalSpentMinutes = 0;
      this.logs.forEach(function (log) {
        if (log && log.completed) {
          totalSpentHours += log.completed.hours || 0;
          totalSpentMinutes += log.completed.minutes || 0;
        }
      });
      totalSpentHours += Math.floor(totalSpentMinutes / 60);
      totalSpentMinutes %= 60;

      var monthIndex = new Date(this.currentMonth + " 1, " + this.currentYear).getMonth();
      var daysInMonth = new Date(this.currentYear, monthIndex + 1, 0).getDate();
      var workingDaysInMonth = 0;

      for (var date = 1; date <= daysInMonth; date++) {
        var currentDate = new Date(this.currentYear, monthIndex, date);
        if (this.workingDays.includes(currentDate.toLocaleDateString("en-US", { weekday: "long" }))) {
          workingDaysInMonth++;
        }
      }

      var totalRequiredHours = workingDaysInMonth * Number(this.workingHours);

      var daysWithLogs = this.logs.filter(function (log) {
        return log;
      }).length;
      var averageHours = 0;
      var averageMinutes = 0;
      if (daysWithLogs > 0) {
        var totalHoursDecimal = totalSpentHours + totalSpentMinutes / 60;
        var averageHoursDecimal = totalHoursDecimal / daysWithLogs;
        averageHours = Math.floor(averageHoursDecimal);
        averageMinutes = Math.round((averageHoursDecimal - averageHours) * 60);
      }

      var netBalanceHours = totalSpentHours + totalSpentMinutes / 60 - totalRequiredHours;
      var netBalanceFormatted = netBalanceHours.toFixed(1);
      var isNegative = netBalanceHours < 0;

      return {
        totalLates: totalLates,
        totalSpentHours: totalSpentHours,
        totalSpentMinutes: totalSpentMinutes,
        totalRequiredHours: totalRequiredHours,
        averageHours: averageHours,
        averageMinutes: averageMinutes,
        netBalanceHours: netBalanceHours,
        netBalanceFormatted: netBalanceFormatted,
        isNegative: isNegative,
        workingDaysInMonth: workingDaysInMonth
      };
    },
    exportPDF: function exportPDF() {
      var stats = this.calculateMonthlyStats();
      var body = [["Date", "Day", "Time In", "Time Out", "Hours", "Late"]];
      var logs = this.logs;
      var days = this.days;
      var cMonth = this.currentMonth;
      var cYear = this.currentYear;
      var name = "";
      logs.map(function (item, i) {
        if (item) {
          var late = item.late.hours !== 0 ? item.late.hours + " hours " + item.late.minutes + " minutes" : item.late.minutes !== 0 ? item.late.minutes + " minutes" : "Not Late";
          var hoursSpent = item.completed ? item.completed.hours + "h " + item.completed.minutes + "m" : "0h 0m";

          var timeIn = item.editRequest ? item.timeIn + " (" + item.editRequest.timeIn + " pending)" : item.timeIn;
          var timeOut = item.editRequest ? item.timeOut + " (" + item.editRequest.timeOut + " pending)" : item.timeOut;

          var arr = [item.day + "/" + cMonth + "/" + cYear || "", days[i] || "", timeIn || "", timeOut || "", hoursSpent || "", late || ""];
          body.push(arr);
          name = item.name || "Report";
        }
      });
      var summaryTable = {
        table: {
          headerRows: 1,
          widths: ["*", "*"],
          body: [[{ text: "Monthly Summary", style: "tableHeader", colSpan: 2, alignment: "center" }, {}], ["Total Lates", stats.totalLates.toString()], ["Average Hours Spent", stats.averageHours + " hrs " + stats.averageMinutes + " mins"], ["Total Hours Required", stats.totalRequiredHours + " hrs"], ["Total Spent Hours", stats.totalSpentHours + (stats.totalSpentMinutes > 0 ? ":" + stats.totalSpentMinutes : "") + " hrs"], ["Net Balance", stats.netBalanceFormatted + " hrs"]]
        },
        margin: [0, 0, 0, 20]
      };
      var logsTable = {
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "auto", "auto", "auto", "*"],
          body: body
        }
      };

      var dd = {
        content: [{ text: name || "Monthly Report", style: "header" }, { text: this.currentMonth + " " + this.currentYear, style: "subheader" }, summaryTable, { text: "Daily Logs", style: "subheader" }, logsTable],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 14,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black"
          }
        }
      };

      __WEBPACK_IMPORTED_MODULE_20_pdfmake_build_pdfmake___default.a.createPdf(dd).download((name || "Report") + "_" + this.currentMonth + "_" + this.currentYear + ".pdf");
    },
    init: function init(user) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var year, i, employees, allUsers, company, companyUserIds, filteredUsers;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                year = [];

                for (i = -5; i < 2; i++) {
                  year.push({ name: new Date().getFullYear() + i });
                }
                _this8.years = year;

                employees = function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee8(allUsers) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _this8.employees = allUsers;
                            _this8.isAdmin = true;
                            _this8.isSuperAdmin = true;
                            _this8.hasAdminAccess = _this8.isAdmin || _this8.isSuperAdmin;
                            _this8.selectedEmployee = _this8.employees.filter(function (emp) {
                              return emp.isActive;
                            })[0].uid || null;
                            _context8.next = 7;
                            return _this8.getLogs(_this8.selectedEmployee);

                          case 7:
                            _context8.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this8.currentMonth, _this8.currentYear, _this8.selectedEmployee);

                          case 9:
                            _this8.manualHoursActivities = _context8.sent;

                          case 10:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this8);
                  }));

                  return function employees(_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                if (!(user.role == "admin" || user.isSuperAdmin)) {
                  _context10.next = 17;
                  break;
                }

                allUsers = _this8.$store.state.auth.allUsers;
                company = _this8.$store.state.auth.company;
                companyUserIds = company.users.map(function (user) {
                  return user.uid;
                });
                filteredUsers = allUsers.filter(function (user) {
                  return companyUserIds.includes(user.uid);
                });

                if (!filteredUsers) {
                  _context10.next = 14;
                  break;
                }

                _context10.next = 12;
                return employees(filteredUsers);

              case 12:
                _context10.next = 15;
                break;

              case 14:
                _this8.$store.watch(_this8.$store.getters.allUsers, function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee9(allUsers) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return employees(allUsers);

                          case 2:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this8);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 15:
                _context10.next = 21;
                break;

              case 17:
                _this8.getLogs(user.uid);
                _context10.next = 20;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this8.currentMonth, _this8.currentYear, user.uid);

              case 20:
                _this8.manualHoursActivities = _context10.sent;

              case 21:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this8);
      }))();
    },
    selectEmployee: function selectEmployee() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this9.isSelectLoading = true;
                _context11.next = 3;
                return _this9.getLogs(_this9.selectedEmployee, _this9.currentMonth, _this9.currentYear);

              case 3:
                _context11.next = 5;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this9.currentMonth, _this9.currentYear, _this9.selectedEmployee);

              case 5:
                _this9.manualHoursActivities = _context11.sent;

                _this9.isSelectLoading = false;

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this9);
      }))();
    },
    selectMonthYear: function selectMonthYear(selectedItem) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (selectedItem) {
                  if (_this10.months.some(function (month) {
                    return month.name === selectedItem.name;
                  })) {
                    _this10.currentMonth = selectedItem.name;
                  } else if (_this10.years.some(function (year) {
                    return year.name === selectedItem.name;
                  })) {
                    _this10.currentYear = selectedItem.name;
                  }
                }
                _this10.isSelectLoading = true;
                user = _this10.$store.state.auth.user;

                if (!(user.role == "admin" || user.isSuperAdmin)) {
                  _context12.next = 12;
                  break;
                }

                if (!_this10.$store.state.auth.allUsers) {
                  _context12.next = 10;
                  break;
                }

                _context12.next = 7;
                return _this10.getLogs(_this10.selectedEmployee, _this10.currentMonth, _this10.currentYear);

              case 7:
                _context12.next = 9;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this10.currentMonth, _this10.currentYear, _this10.selectedEmployee);

              case 9:
                _this10.manualHoursActivities = _context12.sent;

              case 10:
                _context12.next = 17;
                break;

              case 12:
                _context12.next = 14;
                return _this10.getLogs(user.uid, _this10.currentMonth, _this10.currentYear);

              case 14:
                _context12.next = 16;
                return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].fetchManualHoursActivities(_this10.currentMonth, _this10.currentYear, user.uid);

              case 16:
                _this10.manualHoursActivities = _context12.sent;

              case 17:
                _this10.isSelectLoading = false;

              case 18:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this10);
      }))();
    },
    getMonthNum: function getMonthNum(month) {
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var index = months.indexOf(month);
      if (index !== -1) {
        return index + 1;
      }
      return -1;
    },
    getLogs: function getLogs(userId, selectMonth, selectYear) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var date, store, Break, daysName, workingDays, workingHours, selectMonthNum, days, totalDays, _loop, i, startTime, endTime, database, ref;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this11.getSettingData();

              case 2:
                date = new Date();
                store = _this11.$store;
                Break = _this11.breakSecondsIntoHMS;
                daysName = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
                workingDays = _this11.workingDays;
                workingHours = _this11.workingHours;

                _this11.currentMonth = selectMonth || _this11.months[date.getMonth()].name;
                _this11.currentYear = selectYear || date.getFullYear();

                selectMonthNum = _this11.getMonthNum(_this11.currentMonth) - 1;

                if (!(selectMonthNum === -1)) {
                  _context13.next = 15;
                  break;
                }

                console.error("Invalid month selected:", _this11.currentMonth);
                store.commit("loadingEnds");
                return _context13.abrupt("return");

              case 15:
                days = new Date(_this11.currentYear || date.getFullYear(), (selectMonthNum !== -1 ? selectMonthNum : date.getMonth()) + 1, 0).getDate();
                //loading days

                totalDays = [];

                _loop = function _loop() {
                  var day = daysName[new Date(_this11.currentYear || date.getFullYear(), selectMonthNum !== -1 ? selectMonthNum : date.getMonth(), i).getDay()];

                  var isWorkingDay = workingDays.filter(function (workDay) {
                    if (workDay.indexOf(day) !== -1) {
                      return workDay;
                    }
                  });
                  if (isWorkingDay.length) {
                    totalDays.push(day);
                  } else {
                    totalDays.push(day + "*");
                  }
                };

                for (i = 1; i <= days; i++) {
                  _loop();
                }
                startTime = new Date(_this11.currentYear || date.getFullYear(), selectMonthNum !== -1 ? selectMonthNum : date.getMonth(), 1, 0, 0, 0).getTime();
                endTime = new Date(_this11.currentYear || date.getFullYear(), selectMonthNum + 1 || date.getMonth() + 1, 0, 23, 59, 59).getTime();
                database = __WEBPACK_IMPORTED_MODULE_11_firebase_app___default.a.database();
                ref = database.ref("timePeriod");

                ref.orderByChild("timeIn").startAt(startTime).endAt(endTime).once("value").then(function (snapshot) {
                  var value = snapshot.val();
                  var fullLogs = [];
                  var dbTimePeriod = [];
                  if (value) {
                    var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(value);
                    var logs = __WEBPACK_IMPORTED_MODULE_13_underscore__["a" /* default */].compact(keys.map(function (val, index) {
                      if (value[val].userId == userId) {
                        var selectedEmp = _this11.employees.find(function (emp) {
                          return emp.uid === userId;
                        });
                        var baseShift = (_this11.isAdmin && selectedEmp ? selectedEmp.shift : _this11.$store.state.auth.user.shift) || "Morning";
                        var logDay = void 0;
                        if (baseShift.toLowerCase() === "night") {
                          logDay = new Date(value[val].createdAt || value[val].timeIn).getDate();
                        } else {
                          logDay = new Date(value[val].timeIn).getDate();
                        }
                        dbTimePeriod.push(value[val]);
                        value[val].key = val;
                        value[val]["day"] = logDay;
                        var latein = new Date(value[val].timeIn);
                        var setTime = latein.toString();
                        var middle = setTime.slice(16, 18);
                        var centre = parseInt(middle) + 9;

                        // Calculate total duration from sessions
                        var totalDurationMs = 0;
                        if (value[val].sessions && Array.isArray(value[val].sessions)) {
                          totalDurationMs = value[val].sessions.reduce(function (total, session, index) {
                            if (session.timeIn && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(session.timeIn)) {
                              var sessionTimeOut = session.timeOut || (index === value[val].sessions.length - 1 ? value[val].latestScreenshotTime || session.timeOut : session.timeOut);
                              if (sessionTimeOut && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(sessionTimeOut)) {
                                if (sessionTimeOut < session.timeIn) {
                                  return total;
                                }
                                return total + (sessionTimeOut - session.timeIn);
                              }
                            }
                            return total;
                          }, 0);
                        }

                        var totalSeconds = Math.floor(totalDurationMs / 1000);
                        var hours = Math.floor(totalSeconds / 3600);
                        var minutes = Math.floor(totalSeconds % 3600 / 60);
                        var seconds = totalSeconds % 60;

                        value[val]["totalDuration"] = {
                          hours: hours,
                          minutes: minutes,
                          seconds: seconds
                        };

                        // Add completedPercent logic with validation
                        var totalWorkingSeconds = workingHours * 60 * 60;
                        var completedPercent = 0;
                        if (totalWorkingSeconds > 0 && totalSeconds > 0) {
                          completedPercent = Math.min(Math.round(totalSeconds / totalWorkingSeconds * 100), 100);
                        } else if (value[val].totalToday && value[val].totalToday > 0) {
                          completedPercent = Math.min(Math.round(value[val].totalToday / 32400 * 100), 100);
                        }
                        // Ensure reactivity for completedPercent
                        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(value[val], 'completedPercent', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(completedPercent) ? completedPercent : 0);

                        value[val].timeIn = __WEBPACK_IMPORTED_MODULE_12_moment___default()(value[val].timeIn).format("hh:mm A");
                        var time_Out = value[val].latestScreenshotTime > (value[val].timeOut || 0) ? value[val].latestScreenshotTime : value[val].timeOut;
                        value[val].timeOut = time_Out && __WEBPACK_IMPORTED_MODULE_12_moment___default()(time_Out).format("hh:mm A");

                        // Completed Hours logic if hours and minutes are 0
                        if (hours === 0 && minutes === 0 && seconds === 0) {
                          value[val]["completed"] = {
                            hours: Break(value[val].totalToday || 0).hours || 0,
                            minutes: Break(value[val].totalToday || 0).minutes || 0
                          };
                        } else {
                          value[val]["completed"] = {
                            hours: hours,
                            minutes: minutes
                          };
                        }

                        var allSessions = value[val].sessions;
                        if (allSessions && allSessions.length > 0) {
                          var lastSession = allSessions[allSessions.length - 1];
                          value[val].userStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(lastSession || {}).length > 1 ? "User Offline" : "User Online";
                        } else {
                          value[val].userStatus = "User Offline";
                        }
                        return value[val];
                      }
                    }));
                    fullLogs = totalDays.map(function (day, index) {
                      var log = __WEBPACK_IMPORTED_MODULE_13_underscore__["a" /* default */].findWhere(logs, { day: index + 1 }) || null;
                      console.debug("Index " + index + ": log=" + (log ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ day: log.day, completedPercent: log.completedPercent }) : 'null'));
                      return log;
                    });
                  } else {
                    fullLogs = totalDays.map(function () {
                      return null;
                    });
                    console.debug("No snapshot data, all logs set to null");
                  }
                  console.log('dbTimePeriod', dbTimePeriod);
                  console.log('fullLogs', fullLogs);
                  __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(_this11, 'days', totalDays);
                  __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(_this11, 'logs', fullLogs);
                  if (_this11.expandedPanels.length !== totalDays.length) {
                    _this11.$set(_this11, 'expandedPanels', new Array(totalDays.length).fill(false));
                  }

                  store.commit("loadingEnds");
                }).catch(function (error) {
                  console.error("Firebase error:", error);
                  var fullLogs = totalDays.map(function () {
                    return null;
                  });
                  __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(_this11, 'days', totalDays);
                  __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(_this11, 'logs', fullLogs);
                  if (_this11.expandedPanels.length !== totalDays.length) {
                    _this11.$set(_this11, 'expandedPanels', new Array(totalDays.length).fill(false));
                  }
                });

              case 24:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this11);
      }))();
    },

    diff_years: function diff_years(dt2, dt1) {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60 * 60 * 24;
      return Math.abs(Math.round(diff / 365.25));
    },
    breakSecondsIntoHMS: function breakSecondsIntoHMS(s) {
      var hours = Math.floor(s / 3600);
      var minutes = Math.floor(s % 3600 / 60);
      var seconds = Math.floor(s % 3600 % 60);

      return { hours: hours, minutes: minutes, seconds: seconds };
    },
    previewImage: function previewImage(index) {
      var dialogElement = document.getElementById("preview-dialog");

      if (dialogElement) {
        dialogElement.scrollTop = 0;
      }
      this.currentScreenshotIndex = index;
      this.currentImgObj = this.currentObj.screenshots[index];
    },
    checkLateScreenshot: function checkLateScreenshot(log) {
      if (!log || !log.timeIn) {
        return false;
      }
      if (!log.screenshots || !log.screenshots.length) {
        var currentDate = new Date();
        var _dateStr = currentDate.toISOString().split("T")[0];
        var _timeInStr = _dateStr + " " + log.timeIn;
        var _timeInMs = new Date(_timeInStr).getTime();
        var _diffMinutes = (currentDate.getTime() - _timeInMs) / (1000 * 60);
        return _diffMinutes > 22;
      }

      var firstShotMs = Number(log.screenshots[0].timestamp);
      if (isNaN(firstShotMs)) return false;
      var shotDate = new Date(firstShotMs);
      var dateStr = shotDate.toISOString().split("T")[0];
      var timeInStr = dateStr + " " + log.timeIn;
      var timeInMs = new Date(timeInStr).getTime();
      if (isNaN(timeInMs)) {
        console.warn("Could not parse timeIn:", timeInStr);
        return false;
      }
      var diffMinutes = (firstShotMs - timeInMs) / (1000 * 60);
      return diffMinutes > 22;
    },
    shouldHighlight: function shouldHighlight(log) {
      var highlight = true;
      var isExpertizo = true;

      if (!log || !log.coordinates || !log.coordinates.timeIn || !log.coordinates.timeIn.latitude || !log.coordinates.timeIn.longitude) {
        return { highlight: false, isExpertizo: false };
      }
      var _log$coordinates$time = log.coordinates.timeIn,
          latitude = _log$coordinates$time.latitude,
          longitude = _log$coordinates$time.longitude;

      isExpertizo = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_expertizoLocation_js__["a" /* isExpertizoLocation */])(latitude, longitude);
      return { highlight: highlight, isExpertizo: isExpertizo };
    },
    openMapPopup: function openMapPopup(payload) {
      var _this12 = this;

      if (typeof payload === "number") {
        this.selectedUser = this.logs[payload];
        this.currentCoordinates = this.logs[payload].coordinates || {};
      }

      if ((typeof payload === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(payload)) === "object") {
        this.selectedUser = payload;
        this.currentCoordinates = payload;
      }

      this.mapPopup = true;
      this.$nextTick(function () {
        var selectedUser = _this12.selectedUser;
        if (selectedUser.coordinates && selectedUser.coordinates.timeIn && document.getElementById("mapIn")) {
          var _selectedUser$coordin = selectedUser.coordinates.timeIn,
              latitude = _selectedUser$coordin.latitude,
              longitude = _selectedUser$coordin.longitude;

          var mapIn = L.map("mapIn").setView([latitude, longitude], 15);
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors"
          }).addTo(mapIn);
          L.marker([latitude, longitude]).addTo(mapIn).bindPopup("First Time In Location").openPopup();
        }

        // For timeOut
        if (selectedUser.coordinates && selectedUser.coordinates.timeOut && document.getElementById("mapOut")) {
          var _selectedUser$coordin2 = selectedUser.coordinates.timeOut,
              _latitude = _selectedUser$coordin2.latitude,
              _longitude = _selectedUser$coordin2.longitude;

          var mapOut = L.map("mapOut").setView([_latitude, _longitude], 15);
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors"
          }).addTo(mapOut);
          L.marker([_latitude, _longitude]).addTo(mapOut).bindPopup("Last Time Out Location").openPopup();
        }
        if (selectedUser.latitude && selectedUser.longitude && document.getElementById("mapActivity")) {
          var map = L.map("mapActivity").setView([selectedUser.latitude, selectedUser.longitude], 15);
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors"
          }).addTo(map);
          L.marker([selectedUser.latitude, selectedUser.longitude]).addTo(map).bindPopup("Activity Location").openPopup();
        }
      });
    },
    userOnline: function userOnline(logsIndex) {
      var createdAt = new Date(parseInt(logsIndex.createdAt));
      var currentDate = new Date();
      if (logsIndex.userStatus === 'User Online' && createdAt.toDateString() === currentDate.toDateString()) {
        return true;
      }
      return false;
    },
    checkTimeoutResult: function checkTimeoutResult(index, userOnline) {
      if (userOnline) return false;
      var result = this.checkTimeout(this.logs[index]);
      return result;
    },
    checkTimeout: function checkTimeout(logsIndex) {
      if (!logsIndex) return false;

      var latestScreenshotTime = logsIndex.latestScreenshotTime,
          timeOut = logsIndex.timeOut;

      if (!latestScreenshotTime && !timeOut) return false;

      try {
        if (!timeOut && latestScreenshotTime) {
          var _getLatestScreenshotTime = new Date(parseInt(latestScreenshotTime));
          var _latestScreenshotFormatted = _getLatestScreenshotTime.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
          });
          return _latestScreenshotFormatted;
        }

        var _split = (timeOut || "0:0 AM").split(':'),
            _split2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_split, 2),
            _split2$ = _split2[0],
            hours = _split2$ === undefined ? "0" : _split2$,
            _split2$2 = _split2[1],
            minutesMeridiem = _split2$2 === undefined ? "0 AM" : _split2$2;

        var _minutesMeridiem$spli = minutesMeridiem.split(' '),
            _minutesMeridiem$spli2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_minutesMeridiem$spli, 2),
            _minutesMeridiem$spli3 = _minutesMeridiem$spli2[0],
            minutes = _minutesMeridiem$spli3 === undefined ? "0" : _minutesMeridiem$spli3,
            _minutesMeridiem$spli4 = _minutesMeridiem$spli2[1],
            meridiem = _minutesMeridiem$spli4 === undefined ? "AM" : _minutesMeridiem$spli4;

        var calcTimeout = new Date().setHours(parseInt(hours) + (meridiem === 'PM' && parseInt(hours) < 12 ? 12 : 0), parseInt(minutes), 0);

        var calcTimeoutFormatted = new Date(calcTimeout).toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });

        if (!latestScreenshotTime) return calcTimeoutFormatted;

        var getLatestScreenshotTime = new Date(parseInt(latestScreenshotTime));
        var latestScreenshotFormatted = getLatestScreenshotTime.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });

        if (getLatestScreenshotTime.getTime() > new Date(calcTimeout).getTime()) {
          return latestScreenshotFormatted;
        } else {
          return calcTimeoutFormatted;
        }
      } catch (err) {
        console.error("Error checking timeout:", err);
        return false;
      }
    },
    openHistoryModal: function openHistoryModal(activity) {
      console.log('Opening history modal with activity:', activity);
      this.manualHoursActivity = activity || [];
      this.isHistoryModalOpen = true;
    },
    closeHistoryModal: function closeHistoryModal() {
      this.isHistoryModalOpen = false;
    }
  }
}, "computed", {
  getAllHolidays: function getAllHolidays() {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var holidays;
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_17__assets_config_firebase__["a" /* default */].getAllHolidays();

            case 2:
              holidays = _context14.sent;

              _this13.holidays = holidays;

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this13);
    }))();
  },
  loading: function loading() {
    return this.$store.state.loading;
  },
  averageHours: function averageHours() {
    var stats = this.calculateMonthlyStats();
    return stats.averageHours;
  },
  averageMinutes: function averageMinutes() {
    var stats = this.calculateMonthlyStats();
    return stats.averageMinutes;
  },
  pendingEditRequestCount: function pendingEditRequestCount() {
    return this.logs.filter(function (log) {
      return log && log.editRequest;
    }).length;
  }
}));

/***/ }),

/***/ "qi3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HeaderEmployeeDropdown",
  props: {
    items: { type: Array, required: true },
    labelKey: { type: String, default: "username" },
    searchable: { type: Boolean, default: true },
    placeholder: { type: String, default: "Select Employee" },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      dropdownOpen: false,
      searchQuery: "",
      selectedItem: null,
      filterType: "active" // default filter
    };
  },

  computed: {
    activeItems: function activeItems() {
      return this.items.filter(function (u) {
        return u.isActive;
      });
    },
    filteredItems: function filteredItems() {
      var _this = this;

      var list = this.filterType === "active" ? this.activeItems : this.items;

      if (this.searchQuery) {
        var term = this.searchQuery.toLowerCase();
        list = list.filter(function (u) {
          return u[_this.labelKey] && u[_this.labelKey].toLowerCase().includes(term) || u.email && u.email.toLowerCase().includes(term);
        });
      }

      return list;
    }
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      if (!this.disabled) this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown: function closeDropdown() {
      this.dropdownOpen = false;
    },
    selectItem: function selectItem(item) {
      this.selectedItem = item;
      this.$emit("select", item);
      this.closeDropdown();
    },
    clearSelection: function clearSelection() {
      this.selectedItem = null;
      this.searchQuery = "";
      this.$emit("select", null);
      this.closeDropdown();
    },
    setFilter: function setFilter(type) {
      this.filterType = type;
    }
  }
});

/***/ }),

/***/ "qmBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EmployeeDropdown",
  props: {
    employees: { type: Array, required: true },
    company: { type: Object, required: false, default: null },
    defaultFilter: { type: String, default: "active" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      dropdownOpen: false,
      filterType: this.defaultFilter,
      searchTerm: "",
      selectedEmployee: null
    };
  },

  computed: {
    isPayrollPath: function isPayrollPath() {
      // Use Vue Router's $route to check the current route
      return this.$route && this.$route.path.includes("/payroll");
    },
    companyEmployees: function companyEmployees() {
      if (!this.company || !this.company.users) return this.employees;
      var companyUserIds = this.company.users.map(function (u) {
        return u.uid;
      });
      return this.employees.filter(function (u) {
        return companyUserIds.includes(u.uid);
      });
    },
    activeEmployees: function activeEmployees() {
      return this.companyEmployees.filter(function (u) {
        return u.isActive;
      });
    },
    finalList: function finalList() {
      var list = this.filterType === "active" ? this.activeEmployees : this.companyEmployees;

      if (this.searchTerm) {
        var term = this.searchTerm.toLowerCase();
        list = list.filter(function (u) {
          return u.username && u.username.toLowerCase().includes(term) || u.email && u.email.toLowerCase().includes(term);
        });
      }

      return list;
    }
  },
  watch: {
    finalList: {
      immediate: true,
      handler: function handler(newList) {
        this.$emit("update", newList);
      }
    }
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      if (!this.disabled) {
        this.dropdownOpen = !this.dropdownOpen;
      }
    },
    setFilter: function setFilter(type) {
      this.filterType = type;
      this.selectedEmployee = null;
      this.searchTerm = "";
      this.$emit("select", null);
      this.$emit("update", this.filterType === "active" ? this.activeEmployees : this.companyEmployees);
    },
    selectEmployee: function selectEmployee(emp) {
      this.selectedEmployee = emp;
      this.dropdownOpen = false;
      this.$emit("select", emp);
      this.$emit("update", [emp]);
    },
    clearSelection: function clearSelection() {
      this.selectedEmployee = null;
      this.searchTerm = "";
      this.filterType = this.defaultFilter;
      this.$emit("select", null);
      this.$emit("update", this.filterType === "active" ? this.activeEmployees : this.companyEmployees);
    }
  }
});

/***/ }),

/***/ "qma3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qvnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_WorkingDays_vue__ = __webpack_require__("vDrL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UIComponents_LateTimeDropdown_vue__ = __webpack_require__("T3Oj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_assets_config_helpers_js__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UIComponents_EmployeeDropdown_vue__ = __webpack_require__("gd4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PublicHoliday_index_vue__ = __webpack_require__("65+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CompanyDetails_vue__ = __webpack_require__("NzMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SlackIntegration_vue__ = __webpack_require__("BgjK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__EmailTemplate_EmailTemplateManager_vue__ = __webpack_require__("SKLL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__GoogleCalender_GoogleCalendarIntegration_vue__ = __webpack_require__("chcm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PerformanceCriteria_index_vue__ = __webpack_require__("65a8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__ = __webpack_require__("l527");











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Settings",
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_13__UIComponents_CustomTable_vue__["a" /* default */],
    LateTimeDropdown: __WEBPACK_IMPORTED_MODULE_15__UIComponents_LateTimeDropdown_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_14__UIComponents_ReuseableModal_vue__["a" /* default */],
    WorkingDays: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_WorkingDays_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    EmployeeDropdown: __WEBPACK_IMPORTED_MODULE_17__UIComponents_EmployeeDropdown_vue__["a" /* default */],
    PublicHoliday: __WEBPACK_IMPORTED_MODULE_22__PublicHoliday_index_vue__["a" /* default */],
    CompanyDetails: __WEBPACK_IMPORTED_MODULE_23__CompanyDetails_vue__["a" /* default */],
    SlackIntegration: __WEBPACK_IMPORTED_MODULE_24__SlackIntegration_vue__["a" /* default */],
    EmailTemplateManager: __WEBPACK_IMPORTED_MODULE_25__EmailTemplate_EmailTemplateManager_vue__["a" /* default */],
    GoogleCalendarIntegration: __WEBPACK_IMPORTED_MODULE_26__GoogleCalender_GoogleCalendarIntegration_vue__["a" /* default */],
    PerformanceCriteria: __WEBPACK_IMPORTED_MODULE_27__PerformanceCriteria_index_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    var constants = this.$store.state.auth.constants || {};
    var usersData = this.$store.state.auth.allUsers || {};
    var selectedHour = "00";
    var selectedMinute = "00";
    var selectedMeridian = "AM";

    var selectedDays = constants.days || [];
    var productiveHours = constants.totalHours || 8;
    var leavesAllowed = "";
    var leavesAvailable = "";
    var screenshotEnabled = constants.screenshotEnabled !== null && constants.screenshotEnabled !== undefined ? constants.screenshotEnabled : false;
    if (constants.late) {
      var _constants$late$split = constants.late.split(':').map(Number),
          _constants$late$split2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_constants$late$split, 2),
          hours = _constants$late$split2[0],
          minutes = _constants$late$split2[1];

      selectedMeridian = hours >= 12 ? "PM" : "AM";
      selectedHour = String(hours % 12 || 12).padStart(2, "0");
      selectedMinute = String(minutes ? minutes : 0).padStart(2, "0");
    }

    var selectedDaysObject = {
      option: { value: 'custom', label: 'Custom' },
      customDays: selectedDays
    };

    var allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    var weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    var exceptSunday = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(selectedDays.sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(allDays.sort())) {
      selectedDaysObject.option = { value: 'all', label: 'All days' };
    } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(selectedDays.sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(weekdays.sort())) {
      selectedDaysObject.option = { value: 'except-weekend', label: 'Except weekend' };
    } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(selectedDays.sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(exceptSunday.sort())) {
      selectedDaysObject.option = { value: 'except-sunday', label: 'Except Sunday' };
    }

    var employeeList = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(usersData).map(function (userId) {
      var user = usersData[userId];
      var workingDays = user.workingDays ? [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(user.workingDays)) : [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(constants.days || [])); // Deep copy

      var workingDaysObject = {
        option: { value: 'custom', label: 'Custom' },
        customDays: workingDays
      };
      if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(workingDays.sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(allDays.sort())) {
        workingDaysObject.option = { value: 'all', label: 'All days' };
      } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(workingDays.sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(weekdays.sort())) {
        workingDaysObject.option = { value: 'except-weekend', label: 'Except weekend' };
      } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(workingDays.sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(exceptSunday.sort())) {
        workingDaysObject.option = { value: 'except-sunday', label: 'Except Sunday' };
      }
      var hasCustomSettings = user.lateTime != null && user.lateTime !== constants.late || user.productiveHours != null && user.productiveHours !== constants.totalHours || user.workingDays != null && __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(user.workingDays.sort()) !== __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(constants.days.sort()) || user.screenshotEnabled != null && user.screenshotEnabled !== constants.screenshotEnabled;
      return {
        id: usersData[userId].uid || userId,
        username: user.username || "Unknown",
        email: user.email || "",
        phoneNumber: user.phoneNumber || "",
        isActive: user.isActive || false,
        role: user.role || "user",
        salary: user.salary || 0,
        lateTime: user.lateTime || selectedHour + ":" + selectedMinute + " " + selectedMeridian,
        productiveHours: user.productiveHours || constants.totalHours,
        leavesAllowed: user.leavesAllowed || "",
        leavesAvailable: user.leavesAvailable || "",
        workingDays: workingDays,
        workingDaysObject: workingDaysObject,
        screenshotEnabled: user.screenshotEnabled !== null && user.screenshotEnabled !== undefined ? user.screenshotEnabled : constants.screenshotEnabled,
        customSetting: hasCustomSettings,
        specificSetting: user.specificSetting || false,
        hours: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()({ length: 12 }, function (_, i) {
          return (i + 1).toString().padStart(2, "0");
        }),
        minutes: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()({ length: 60 }, function (_, i) {
          return i.toString().padStart(2, "0");
        }),
        meridians: ["AM", "PM"]
      };
    });

    this.$store.commit("setEmployeeList", employeeList);

    var currentEmployee = employeeList.find(function (employee) {
      return employee.id === _this.$store.state.auth.user.uid;
    });

    if (currentEmployee && currentEmployee.customSetting) {
      selectedDays = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(currentEmployee.workingDays)); // Deep copy
      productiveHours = currentEmployee.productiveHours;
      leavesAllowed = currentEmployee.leavesAllowed;
      leavesAvailable = currentEmployee.leavesAvailable;
      screenshotEnabled = currentEmployee.screenshotEnabled;

      var _currentEmployee$late = currentEmployee.lateTime.split(':').map(Number),
          _currentEmployee$late2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_currentEmployee$late, 2),
          _hours = _currentEmployee$late2[0],
          _minutes = _currentEmployee$late2[1];

      selectedMeridian = _hours >= 12 ? "PM" : "AM";
      selectedHour = String(_hours % 12 || 12).padStart(2, "0");
      selectedMinute = String(_minutes ? _minutes : 0).padStart(2, "0");
    } else {
      selectedDays = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(constants.days || [])); // Deep copy
      productiveHours = constants.totalHours;
      leavesAllowed = "";
      leavesAvailable = "";
      screenshotEnabled = constants.screenshotEnabled;

      var _constants$late$split3 = constants.late.split(':').map(Number),
          _constants$late$split4 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_constants$late$split3, 2),
          _hours2 = _constants$late$split4[0],
          _minutes2 = _constants$late$split4[1];

      selectedMeridian = _hours2 >= 12 ? "PM" : "AM";
      selectedHour = String(_hours2 % 12 || 12).padStart(2, "0");
      selectedMinute = String(_minutes2 ? _minutes2 : 0).padStart(2, "0");
    }
    return {
      currentUser: this.$store.state.auth.user,
      activeTab: "general",
      filteredUsers: [],
      isAdmin: this.$store.state.auth.user && this.$store.state.auth.user.role === 'admin',
      isSuperAdmin: !!(this.$store.state.auth.user && this.$store.state.auth.user.isSuperAdmin === true),
      activeLateDropdown: null,
      tempLateTime: {},
      weekDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      selectedDays: selectedDays,
      selectedDaysObject: selectedDaysObject,
      productiveHours: productiveHours,
      leavesAllowed: leavesAllowed,
      leavesAvailable: leavesAvailable,
      screenshotEnabled: screenshotEnabled,
      late: constants.late || "",
      employeeList: employeeList,
      isDropdownOpen: false,
      selectedHour: selectedHour,
      selectedMinute: selectedMinute,
      selectedMeridian: selectedMeridian,
      hours: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()({ length: 12 }, function (_, i) {
        return (i + 1).toString().padStart(2, "0");
      }),
      minutes: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()({ length: 60 }, function (_, i) {
        return i.toString().padStart(2, "0");
      }),
      meridians: ["AM", "PM"],
      tableColumns: [{ key: "username", label: "Employee Name", sticky: "left", sortable: true, width: 150 }, { key: "lateTime", label: "Late Time" }, { key: "productiveHours", label: "Total Hours" }, { key: "workingDays", label: "Working Days" }, { key: "leavesAllowed", label: "leaves Allowed" }, { key: "leavesAvailable", label: "Leaves Available" }, { key: "screenshot", label: "Screenshot" }, { key: "specific", label: "Specific/General" }, { key: "action", label: "Action", sticky: "right", width: 95 }],
      showUpdateModal: false,
      showResetModal: false,
      selectedEmployee: null,
      tempInputValues: {}
    };
  },

  computed: {
    constants: function constants() {
      var data = this.$store.getters["constants/getConstants"]();
      return data || {};
    },
    filteredEmployeeList: function filteredEmployeeList() {
      var company = this.$store.state.auth.company;
      var companyUserIds = this.filteredUsers.map(function (user) {
        return user.uid;
      });
      var employeeList = this.$store.state.auth.employeeList || this.employeeList;
      return employeeList.filter(function (employee) {
        return companyUserIds.includes(employee.id);
      });
    },
    hourOptions: function hourOptions() {
      return this.hours.map(function (hour) {
        return { value: hour, label: hour };
      });
    }
  },
  watch: {
    selectedDaysObject: {
      handler: function handler(newVal) {
        this.selectedDays = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(newVal.customDays)); // Deep copy
      },

      deep: true
    },
    constants: {
      handler: function handler(val) {},

      deep: true,
      immediate: true
    }
  },
  methods: {
    onCalendarConnected: function onCalendarConnected() {
      console.log('Google Calendar connected');
      // optional: save flag to backend
    },
    onCalendarDisconnected: function onCalendarDisconnected() {
      console.log('Google Calendar disconnected');
    },
    updateWorkingDays: function updateWorkingDays(employee, ReceivedDaysObject) {

      var dayMap = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      };

      var rawCustomDays = ReceivedDaysObject.customDays || [];

      var normalizedDays = rawCustomDays.map(function (day) {
        var lower = day.toLowerCase();
        return dayMap[lower] || day;
      });

      var workingDaysObject = {
        option: ReceivedDaysObject.option || {},
        customDays: normalizedDays
      };

      // Update both the original employee and the employeeList entry
      var employeeIndex = this.employeeList.findIndex(function (emp) {
        return emp.id === employee.id;
      });
      if (employeeIndex !== -1) {
        this.$set(this.employeeList[employeeIndex], 'workingDays', [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(normalizedDays)));
        this.$set(this.employeeList[employeeIndex], 'workingDaysObject', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, workingDaysObject));
      }

      // Update the passed-in employee directly as well
      this.$set(employee, 'workingDays', [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(normalizedDays)));
      this.$set(employee, 'workingDaysObject', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, workingDaysObject));

      // Commit to Vuex to ensure global reactivity
      this.$store.commit("setEmployeeList", [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.employeeList)));
    },
    handleInput: function handleInput(event, id, field) {
      this.tempInputValues[id + "_" + field] = event.target.value;
    },
    commitInput: function commitInput(id, field) {
      var value = this.tempInputValues[id + "_" + field];
      if (value !== undefined) {
        var updatedList = this.employeeList.map(function (emp) {
          if (emp.id === id) {
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, emp, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, field, Number(value)));
          }
          return emp;
        });
        this.employeeList = updatedList;
        this.$store.commit("setEmployeeList", updatedList);
        delete this.tempInputValues[id + "_" + field];
      }
    },
    toggleLateTime: function toggleLateTime(id) {
      this.activeLateDropdown = this.activeLateDropdown === id ? null : id;
      if (this.activeLateDropdown) {
        var employee = this.employeeList.find(function (emp) {
          return emp.id === id;
        });
        if (employee) {
          var _employee$lateTime$sp = employee.lateTime.split(':'),
              _employee$lateTime$sp2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_employee$lateTime$sp, 2),
              hour = _employee$lateTime$sp2[0],
              minute = _employee$lateTime$sp2[1];

          var _minute$split = minute.split(' '),
              _minute$split2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_minute$split, 2),
              minuteValue = _minute$split2[0],
              meridian = _minute$split2[1];

          this.tempLateTime = {
            hour: hour,
            minute: minuteValue,
            meridian: meridian
          };
        }
      }
    },
    onHourChange: function onHourChange(selectedHour) {
      this.selectedHour = selectedHour;
    },
    onLateTimeChange: function onLateTimeChange(value, id, type) {
      if (type === 'hour') {
        this.tempLateTime.hour = value;
      } else if (type === 'minute') {
        this.tempLateTime.minute = value;
      } else if (type === 'meridian') {
        this.tempLateTime.meridian = value;
      }
    },
    saveLateTime: function saveLateTime(id) {
      var employee = this.employeeList.find(function (emp) {
        return emp.id === id;
      });
      if (employee) {
        employee.lateTime = this.tempLateTime.hour + ":" + this.tempLateTime.minute + " " + this.tempLateTime.meridian;
      }
      this.activeLateDropdown = null;
    },
    showUpdateConfirmModal: function showUpdateConfirmModal(employee) {
      this.selectedEmployee = employee;
      this.showUpdateModal = true;
    },
    showResetConfirmModal: function showResetConfirmModal(employee) {
      this.selectedEmployee = employee;
      this.showResetModal = true;
    },
    confirmUpdateEmployee: function confirmUpdateEmployee() {
      if (this.selectedEmployee) {
        this.updateEmployee(this.selectedEmployee);
        this.showUpdateModal = false;
      }
    },
    confirmResetEmployee: function confirmResetEmployee() {
      if (this.selectedEmployee) {
        this.resetEmployee(this.selectedEmployee);
        this.showResetModal = false;
      }
    },
    updateEmployee: function updateEmployee(employee) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var usersList, constants, userId, filteredUser, normalizedEmpLate, normalizedUserLate, normalizedConstLate, isProductiveHoursChanged, isScreenshotEnabledChanged, isWorkingDaysChanged, isLateTimeChanged, updatedFields, isSpecific;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("Updating employee:", employee);
                _this2.$store.commit("loadingStarts");
                usersList = _this2.$store.state.auth.allUsers || {};
                constants = _this2.$store.state.auth.constants || {};
                userId = employee.id;
                filteredUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(usersList).find(function (user) {
                  return user.uid === userId;
                });
                normalizedEmpLate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_src_assets_config_helpers_js__["h" /* normalizeTime */])(employee.lateTime);
                normalizedUserLate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_src_assets_config_helpers_js__["h" /* normalizeTime */])(filteredUser.lateTime);
                normalizedConstLate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_src_assets_config_helpers_js__["h" /* normalizeTime */])(constants.late);
                isProductiveHoursChanged = employee.productiveHours !== filteredUser.productiveHours && employee.productiveHours !== constants.totalHours;
                isScreenshotEnabledChanged = employee.screenshotEnabled !== filteredUser.screenshotEnabled;
                isWorkingDaysChanged = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(employee.workingDays) !== __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(filteredUser.workingDays) && __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(employee.workingDays) !== __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(constants.days);
                isLateTimeChanged = normalizedEmpLate !== normalizedUserLate && normalizedEmpLate !== normalizedConstLate;
                updatedFields = {};


                if (isProductiveHoursChanged) {
                  updatedFields.productiveHours = employee.productiveHours;
                }
                updatedFields.leavesAvailable = employee.leavesAvailable;
                updatedFields.leavesAllowed = employee.leavesAllowed;

                if (isScreenshotEnabledChanged) {
                  updatedFields.screenshotEnabled = employee.screenshotEnabled;
                }

                if (isWorkingDaysChanged) {
                  updatedFields.workingDays = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(employee.workingDays));
                }

                if (isLateTimeChanged) {
                  updatedFields.lateTime = employee.lateTime;
                }

                isSpecific = updatedFields.productiveHours || updatedFields.screenshotEnabled || updatedFields.lateTime || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(updatedFields.workingDays);


                if (isSpecific) {
                  updatedFields.specificSetting = true;
                  updatedFields.customSetting = true;
                }

                _context2.next = 24;
                return __WEBPACK_IMPORTED_MODULE_18_firebase___default.a.database().ref("users/" + employee.id).update(updatedFields).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  var updatedEmployeeList, changes, admin, uid, username, email, title, description;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this2.$store.commit("loadingEnds");
                          updatedEmployeeList = _this2.employeeList.map(function (emp) {
                            if (emp.id === employee.id) {
                              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, emp, updatedFields);
                            }
                            return emp;
                          });


                          _this2.employeeList = updatedEmployeeList;
                          _this2.$store.commit("setEmployeeList", updatedEmployeeList);

                          __WEBPACK_IMPORTED_MODULE_19_sweetalert___default()("Success!", "Employee updated successfully!", "success");

                          changes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["a" /* getUpdatedFields */])(filteredUser, updatedFields);

                          changes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(changes).map(function (_ref2) {
                            var _ref3 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                                key = _ref3[0],
                                value = _ref3[1];

                            return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["b" /* formatValue */])(value.new);
                          }).join('\n');

                          admin = _this2.currentUser;
                          uid = employee.id, username = employee.username, email = employee.email;
                          title = admin.username + " updated specific settings for " + username;
                          description = admin.email + " updated specific settings for " + email + ".";
                          _context.next = 13;
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["d" /* createActivityPayload */])({
                            user: admin,
                            title: title,
                            description: description,
                            changes: changes,
                            username: username,
                            type: "settings",
                            uid: uid
                          }));

                        case 13:
                          _context.next = 15;
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                            type: "settings",
                            activityDescription: description,
                            activityOnUser: uid,
                            activityOnUserName: username,
                            activityByUserName: _this2.currentUser.username
                          }, _this2.$store.state.auth, _this2.currentUser.uid);

                        case 15:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }))).catch(function (err) {
                  _this2.$store.commit("loadingEnds");
                  __WEBPACK_IMPORTED_MODULE_19_sweetalert___default()("Error!", err.message, "error");
                });

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    toggleDropdown: function toggleDropdown(role) {
      if (role) {
        this.isDropdownOpen = !this.isDropdownOpen;
      }
    },
    setHour: function setHour(hour) {
      this.selectedHour = hour;
      this.isDropdownOpen = false;
    },
    setMinute: function setMinute(minute) {
      this.selectedMinute = minute;
      this.isDropdownOpen = false;
    },
    setMeridian: function setMeridian(meridian) {
      this.selectedMeridian = meridian;
      this.isDropdownOpen = false;
    },
    handleClickOutside: function handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isDropdownOpen = false;
      }
      if (this.$refs.dropdown_employee && Array.isArray(this.$refs.dropdown_employee) && !this.$refs.dropdown_employee.some(function (el) {
        return el.contains(event.target);
      })) {
        this.activeLateDropdown = null;
      }
    },
    saveGeneralSettings: function saveGeneralSettings() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var oldConstants, lateTime, lateTime24, updatedConstants;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.$store.commit("loadingStarts");
                oldConstants = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this3.constants);
                lateTime = _this3.selectedHour + ":" + _this3.selectedMinute + " " + _this3.selectedMeridian;
                lateTime24 = _this3.convertTo24Hour(lateTime);
                updatedConstants = {
                  late: lateTime24,
                  days: [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(_this3.selectedDays)),
                  totalHours: _this3.productiveHours,
                  screenshotEnabled: _this3.screenshotEnabled
                };

                __WEBPACK_IMPORTED_MODULE_18_firebase___default.a.database().ref("constants").update(updatedConstants).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  var updatedEmployeeList, updatedFields, changes, title, description;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this3.$store.commit("setConstants", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this3.$store.state.auth.constants, updatedConstants));
                          updatedEmployeeList = _this3.employeeList.map(function (employee) {
                            if (!employee.customSetting) {
                              var defaultDays = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(updatedConstants.days || []));
                              var allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                              var weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
                              var exceptSunday = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                              var workingDaysOption = { value: "custom", label: "Custom" };
                              if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(defaultDays)).sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(allDays).sort())) {
                                workingDaysOption = { value: "all", label: "All days" };
                              } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(defaultDays)).sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(weekdays).sort())) {
                                workingDaysOption = { value: "except-weekend", label: "Except weekend" };
                              } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(defaultDays)).sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(exceptSunday).sort())) {
                                workingDaysOption = { value: "except-sunday", label: "Except Sunday" };
                              }
                              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, employee, {
                                lateTime: lateTime,
                                productiveHours: updatedConstants.totalHours,
                                workingDays: defaultDays,
                                workingDaysObject: {
                                  option: workingDaysOption,
                                  customDays: defaultDays
                                },
                                screenshotEnabled: updatedConstants.screenshotEnabled
                              });
                            }
                            return employee;
                          });

                          _this3.employeeList = updatedEmployeeList;
                          _this3.$store.commit("setEmployeeList", updatedEmployeeList);
                          _this3.$store.commit("loadingEnds");
                          __WEBPACK_IMPORTED_MODULE_19_sweetalert___default()("Success!", "General settings saved!", "success");

                          updatedFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["a" /* getUpdatedFields */])(oldConstants, updatedConstants);
                          changes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(updatedFields).map(function (_ref5) {
                            var _ref6 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                                key = _ref6[0],
                                value = _ref6[1];

                            return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["b" /* formatValue */])(value.new);
                          }).join('\n');
                          title = _this3.currentUser.username + " updated general settings";
                          description = _this3.currentUser.email + " updated general settings.";
                          _context3.next = 12;
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_adminLogs__["d" /* createActivityPayload */])({
                            user: _this3.currentUser,
                            title: title,
                            description: description,
                            changes: changes,
                            type: "settings"
                          }));

                        case 12:
                          _context3.next = 14;
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                            type: "settings",
                            activityDescription: description,
                            activityByUserName: _this3.currentUser.username
                          }, _this3.$store.state.auth, _this3.currentUser.uid);

                        case 14:
                          _this3.$store.dispatch("constants/fetchConstants").then(function () {});

                        case 15:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this3);
                }))).catch(function (err) {
                  _this3.$store.commit("loadingEnds");
                  __WEBPACK_IMPORTED_MODULE_19_sweetalert___default()("Error!", err.message, "error");
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    convertTo24Hour: function convertTo24Hour(time) {
      var _time$split = time.split(" "),
          _time$split2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_time$split, 2),
          timePart = _time$split2[0],
          meridian = _time$split2[1];

      var _timePart$split$map = timePart.split(":").map(Number),
          _timePart$split$map2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_timePart$split$map, 2),
          hours = _timePart$split$map2[0],
          minutes = _timePart$split$map2[1];

      if (meridian === "PM" && hours !== 12) hours += 12;
      if (meridian === "AM" && hours === 12) hours = 0;
      return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
    },
    resetEmployee: function resetEmployee(employee) {
      var _this4 = this;

      this.$store.commit("loadingStarts");
      var employeeRef = __WEBPACK_IMPORTED_MODULE_18_firebase___default.a.database().ref("users/" + employee.id);
      employeeRef.once("value").then(function (snapshot) {
        var currentEmployee = snapshot.val();
        var constants = _this4.$store.state.auth.constants;
        var resetFields = {
          lateTime: null,
          productiveHours: null,
          workingDays: null,
          screenshotEnabled: null,
          customSetting: false,
          specificSetting: null
        };
        employeeRef.update(resetFields).then(function () {
          var employeeIndex = _this4.employeeList.findIndex(function (e) {
            return e.id === employee.id;
          });
          if (employeeIndex !== -1) {
            var defaultDays = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(constants.days || []));
            var allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            var weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
            var exceptSunday = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var workingDaysOption = { value: 'custom', label: 'Custom' };
            if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(defaultDays)).sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(allDays).sort())) {
              workingDaysOption = { value: 'all', label: 'All days' };
            } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(defaultDays)).sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(weekdays).sort())) {
              workingDaysOption = { value: 'except-weekend', label: 'Except weekend' };
            } else if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(defaultDays)).sort()) === __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()([].concat(exceptSunday).sort())) {
              workingDaysOption = { value: 'except-sunday', label: 'Except Sunday' };
            }
            var updatedEmployee = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, employee, {
              lateTime: _this4.selectedHour + ":" + _this4.selectedMinute + " " + _this4.selectedMeridian,
              productiveHours: _this4.productiveHours,
              workingDays: defaultDays,
              workingDaysObject: {
                option: workingDaysOption,
                customDays: defaultDays
              },
              screenshotEnabled: _this4.screenshotEnabled,
              customSetting: false,
              specificSetting: false
            });
            var updatedEmployees = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(_this4.employeeList));
            updatedEmployees[employeeIndex] = updatedEmployee;
            _this4.employeeList = updatedEmployees;
            _this4.$store.commit("setEmployeeList", updatedEmployees);
            __WEBPACK_IMPORTED_MODULE_19_sweetalert___default()("Success!", "Reset settings saved!", "success");
          }
          _this4.$store.commit("loadingEnds");
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_19_sweetalert___default()("Error", "Could not reset employee settings", "error");
        _this4.$store.commit("loadingEnds");
      });
    }
  },
  mounted: function mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
});

/***/ }),

/***/ "qwKD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qyaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-container"},[_c('div',{staticClass:"profile-form"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_c('p',{staticClass:"section-heading"},[_vm._v("Employee Profile")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"company"}},[_vm._v("Company")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"company","type":"text","disabled":""},domProps:{"value":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.fullName),expression:"user.fullName"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.fullName},attrs:{"id":"fullName","type":"text","placeholder":"Enter your full name","aria-required":"true","aria-describedby":"fullNameError"},domProps:{"value":(_vm.user.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "fullName", $event.target.value)}}}),_vm._v(" "),(_vm.errors.fullName)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"fullNameError"}},[_vm._v("\n            "+_vm._s(_vm.errors.fullName)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{class:{'is-invalid': _vm.errors.designation}},[_c('CustomDropdown',{attrs:{"id":"designation","label":"","options":_vm.designations,"value":_vm.user.designation,"placeholder":"Select your designation","show-error":false,"disabled":_vm.isNonAdmin,"aria-required":!_vm.isNonAdmin},on:{"change":_vm.onDesignationChange}})],1),_vm._v(" "),(_vm.errors.designation)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"designationError"}},[_vm._v("\n            "+_vm._s(_vm.errors.designation)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.joiningDate),expression:"user.joiningDate"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.joiningDate},attrs:{"id":"joiningDate","type":"date","disabled":_vm.isNonAdmin,"aria-required":!_vm.isNonAdmin},domProps:{"value":(_vm.user.joiningDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "joiningDate", $event.target.value)}}}),_vm._v(" "),(_vm.errors.joiningDate)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"joiningDateError"}},[_vm._v("\n            "+_vm._s(_vm.errors.joiningDate)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{class:{'is-invalid': _vm.errors.grade}},[_c('GradeDropdown',{attrs:{"id":"grade","designation":_vm.user.designation,"designationGrades":_vm.designationGrades,"placeholder":"Select Grade","show-error":_vm.errors.grade !== undefined,"error-message":_vm.errors.grade,"disabled":_vm.isNonAdmin},on:{"change":_vm.onGradeChange},model:{value:(_vm.user.grade),callback:function ($$v) {_vm.$set(_vm.user, "grade", $$v)},expression:"user.grade"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.companyEmail},attrs:{"id":"companyEmail","type":"email","placeholder":"employee@expertizo.pk","disabled":_vm.isNonAdmin,"aria-required":!_vm.isNonAdmin},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.companyEmail)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"companyEmailError"}},[_vm._v("\n            "+_vm._s(_vm.errors.companyEmail)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.personalEmail),expression:"user.personalEmail"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.personalEmail},attrs:{"id":"personalEmail","type":"email","placeholder":"Enter your personal email","aria-required":"true","aria-describedby":"personalEmailError"},domProps:{"value":(_vm.user.personalEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "personalEmail", $event.target.value)}}}),_vm._v(" "),(_vm.errors.personalEmail)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"personalEmailError"}},[_vm._v("\n            "+_vm._s(_vm.errors.personalEmail)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.nicNumber),expression:"user.nicNumber"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.nicNumber},attrs:{"id":"nicNumber","type":"text","placeholder":"00000-0000000-0","aria-required":"true","aria-describedby":"nicNumberError"},domProps:{"value":(_vm.user.nicNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "nicNumber", $event.target.value)}}}),_vm._v(" "),(_vm.errors.nicNumber)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"nicNumberError"}},[_vm._v("\n            "+_vm._s(_vm.errors.nicNumber)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.dateOfBirth),expression:"user.dateOfBirth"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.dateOfBirth},attrs:{"id":"dateOfBirth","type":"date","aria-required":"true","aria-describedby":"dateOfBirthError"},domProps:{"value":(_vm.user.dateOfBirth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "dateOfBirth", $event.target.value)}}}),_vm._v(" "),(_vm.errors.dateOfBirth)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"dateOfBirthError"}},[_vm._v("\n            "+_vm._s(_vm.errors.dateOfBirth)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"bank-field"},[_c('CustomDropdown',{attrs:{"id":"bankName","label":"","options":_vm.banks,"value":_vm.user.bankName,"placeholder":"Select your bank","show-error":_vm.errors.bankName !== undefined,"error-message":_vm.errors.bankName,"custom":true},on:{"change":_vm.onBankChange}}),_vm._v(" "),(_vm.showCustomBank)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customBankName),expression:"customBankName"}],ref:"customBank",staticClass:"form-control custom-bank-input",attrs:{"id":"bankName","type":"text","placeholder":"Enter bank name"},domProps:{"value":(_vm.customBankName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customBankName=$event.target.value},_vm.onCustomBankInput]}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(9),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.iban),expression:"user.iban"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.iban},attrs:{"id":"iban","type":"text","placeholder":"Enter your IBAN or account number","aria-required":"true","aria-describedby":"ibanError"},domProps:{"value":(_vm.user.iban)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "iban", $event.target.value)}}}),_vm._v(" "),(_vm.errors.iban)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"ibanError"}},[_vm._v("\n            "+_vm._s(_vm.errors.iban)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"nationality","label":"","options":_vm.countries,"value":_vm.user.nationality,"placeholder":"Select your nationality","show-error":_vm.errors.nationality !== undefined,"error-message":_vm.errors.nationality},on:{"change":_vm.onNationalityChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(11),_vm._v(" "),_c('CustomDropdown',{attrs:{"id":"maritalStatus","label":"","options":_vm.maritalStatusOptions,"value":_vm.user.maritalStatus,"placeholder":"Select your marital status","show-error":_vm.errors.maritalStatus !== undefined,"error-message":_vm.errors.maritalStatus},on:{"change":_vm.onMaritalStatusChange}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(12),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.currentAddress),expression:"user.currentAddress"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.currentAddress},attrs:{"id":"currentAddress","type":"text","placeholder":"Enter your current address","aria-required":"true","aria-describedby":"currentAddressError"},domProps:{"value":(_vm.user.currentAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "currentAddress", $event.target.value)}}}),_vm._v(" "),(_vm.errors.currentAddress)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"currentAddressError"}},[_vm._v("\n            "+_vm._s(_vm.errors.currentAddress)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.permanentAddress),expression:"user.permanentAddress"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.permanentAddress},attrs:{"id":"permanentAddress","type":"text","placeholder":"Enter your permanent address","aria-required":"true","aria-describedby":"permanentAddressError"},domProps:{"value":(_vm.user.permanentAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "permanentAddress", $event.target.value)}}}),_vm._v(" "),(_vm.errors.permanentAddress)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"permanentAddressError"}},[_vm._v("\n            "+_vm._s(_vm.errors.permanentAddress)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phoneNumber),expression:"user.phoneNumber"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.contactNumber},attrs:{"id":"contactNumber","type":"number","placeholder":"Enter your contact number","aria-required":"true","aria-describedby":"contactNumberError"},domProps:{"value":(_vm.user.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phoneNumber", $event.target.value)}}}),_vm._v(" "),(_vm.errors.contactNumber)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"contactNumberError"}},[_vm._v("\n            "+_vm._s(_vm.errors.contactNumber)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group"},[_vm._m(15),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.emergencyContactName),expression:"user.emergencyContactName"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.emergencyContactName},attrs:{"id":"emergencyContactName","type":"text","placeholder":"E.g., John Doe (Father)","aria-required":"true","aria-describedby":"emergencyContactNameError"},domProps:{"value":(_vm.user.emergencyContactName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "emergencyContactName", $event.target.value)}}}),_vm._v(" "),(_vm.errors.emergencyContactName)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"emergencyContactNameError"}},[_vm._v("\n            "+_vm._s(_vm.errors.emergencyContactName)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(16),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.emergencyContactNumber),expression:"user.emergencyContactNumber"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.emergencyContactNumber},attrs:{"id":"emergencyContactNumber","type":"number","placeholder":"Enter emergency contact number","aria-required":"true","aria-describedby":"emergencyContactNumberError"},domProps:{"value":(_vm.user.emergencyContactNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "emergencyContactNumber", $event.target.value)}}}),_vm._v(" "),(_vm.errors.emergencyContactNumber)?_c('div',{staticClass:"invalid-feedback",attrs:{"id":"emergencyContactNumberError"}},[_vm._v("\n            "+_vm._s(_vm.errors.emergencyContactNumber)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{},[_vm._m(17),_vm._v(" "),(!_vm.nicPreviewUrl)?_c('div',{staticClass:"file-upload-area",on:{"click":_vm.triggerNicFileInput,"dragover":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();return _vm.handleNicFileDrop($event)}}},[_c('input',{ref:"nicImageInput",staticClass:"file-input",attrs:{"id":"nicImage","type":"file","accept":".pdf,image/*"},on:{"change":_vm.handleNicImageUpload}}),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticClass:"upload-text"},[(_vm.errors.nicImageUrl)?_c('span',{staticClass:"invalid-feedback",staticStyle:{"margin-top":"-12px"}},[_vm._v("This field is required")]):_vm._e(),_vm._v("\n            Only Click to browse or drag and drop\n            "),_c('div',{staticClass:"upload-format"},[_vm._v("Supported formats: IMAGE, PDF")])])]):_c('div',{staticClass:"file-preview"},[_c('div',{staticClass:"file-info"},[(_vm.nicPreviewIsImage)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.nicPreviewUrl,"alt":"NIC Image"}}):(_vm.nicPreviewIsPdf)?_c('img',{staticClass:"preview-image",attrs:{"src":_vm.getDocumentThumbnail(_vm.nicPreviewUrl),"alt":"Document Preview"}}):_c('i',{staticClass:"fas fa-file-word fa-3x",staticStyle:{"color":"#2b579a"}})]),_vm._v(" "),_c('div',{staticClass:"action-button-container"},[_c('button',{staticClass:"view-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openFileInNewTab(_vm.nicPreviewUrl)}}},[_c('i',{staticClass:"fas fa-eye"})]),_vm._v(" "),_c('button',{staticClass:"replace-btn",attrs:{"type":"button","title":"Replace NIC"},on:{"click":_vm.triggerNicFileInput}},[_c('i',{staticClass:"fas fa-sync-alt"})])]),_vm._v(" "),_c('input',{ref:"nicImageInput",staticClass:"file-input",staticStyle:{"display":"none"},attrs:{"id":"nicImageReplace","type":"file","accept":".pdf,image/*"},on:{"change":_vm.handleNicImageUpload}})])]),_vm._v(" "),_c('div',{staticClass:"submit-button-container"},[_c('button',{staticClass:"button-submit",staticStyle:{"min-width":"150px"},attrs:{"type":"submit"}},[(_vm.profileLoading)?_c('span',[_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle"},attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v("\n            Submit Profile\n          ")])])])]),_vm._v(" "),_c('VerifyDocuments',{attrs:{"user":_vm.user,"isUploadingExperienceLetter":_vm.isUploadingExperienceLetter,"isUploadingSalarySlip":_vm.isUploadingSalarySlip,"experienceLetterFileName":_vm.experienceLetterFileName,"experienceLetterFileSize":_vm.experienceLetterFileSize,"experienceLetterFileType":_vm.experienceLetterFileType,"salarySlipFileName":_vm.salarySlipFileName,"salarySlipFileSize":_vm.salarySlipFileSize,"salarySlipFileType":_vm.salarySlipFileType,"tempExperienceLetterUrl":_vm.tempExperienceLetterUrl,"tempSalarySlipUrl":_vm.tempSalarySlipUrl,"documentLoading":_vm.documentLoading},on:{"submit-documents":_vm.submitVerificationDocuments,"file-selected":_vm.handleDocumentFileSelected}})],1),_vm._v(" "),_c('div',{staticClass:"profile-card-container"},[_c('div',{staticClass:"profile-card"},[_c('div',{staticClass:"profile-header",staticStyle:{"border":"1px solid #ccc"},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"profile-image-wrapper"},[_c('img',{staticClass:"profile-background",staticStyle:{"width":"60%","height":"100%"},attrs:{"src":_vm.profileImageSrc,"alt":"Profile Background"}}),_vm._v(" "),_c('div',{staticClass:"image-overlay",on:{"click":function($event){$event.stopPropagation();return _vm.triggerProfileFileInput($event)}}},[_c('i',{staticClass:"fas fa-camera update-icon",staticStyle:{"font-size":"25px","color":"white"}})]),_vm._v(" "),_c('input',{ref:"profileImageInput",staticClass:"file-input",attrs:{"id":"profileImage","type":"file","accept":"image/*"},on:{"change":_vm.handleProfileImageUpload}}),_vm._v(" "),(_vm.uploadingProfileImage)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('span',[_vm._v("Uploading...")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"profile-info"},[_c('h3',{staticClass:"profile-name"},[_vm._v(_vm._s(_vm.user.username || 'John Doe'))]),_vm._v(" "),_c('p',{staticClass:"profile-title"},[_vm._v(_vm._s(_vm.getDisplayTitle(_vm.user.designation, _vm.user.grade) || ''))]),_vm._v(" "),_c('div',{staticClass:"profile-details"},[_c('div',{staticClass:"profile-detail-item"},[_c('span',{staticClass:"detail-label"},[_vm._v("Email")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(_vm.user.email || 'employee@expertizo.pk'))])]),_vm._v(" "),_c('div',{staticClass:"profile-detail-item"},[_c('span',{staticClass:"detail-label"},[_vm._v("Contact")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(_vm.user.phoneNumber || '+1234567890'))])]),_vm._v(" "),_c('div',{staticClass:"profile-detail-item"},[_c('span',{staticClass:"detail-label"},[_vm._v("Nationality")]),_vm._v(" "),_c('span',{staticClass:"detail-value"},[_vm._v(_vm._s(_vm.user.nationality || 'Pakistan'))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"fullName"}},[_vm._v("Full Name as per NIC "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"designation"}},[_vm._v("Designation "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"joiningDate"}},[_vm._v("Joining Date "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"grade"}},[_vm._v("Grade "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"companyEmail"}},[_vm._v("Company Email "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"personalEmail"}},[_vm._v("Personal Email "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nicNumber"}},[_vm._v("NIC Number "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"dateOfBirth"}},[_vm._v("Date of birth "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"bankName"}},[_vm._v("Bank Name "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"iban"}},[_vm._v("IBAN/Account no "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nationality"}},[_vm._v("Nationality "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"maritalStatus"}},[_vm._v("Marital Status "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"currentAddress"}},[_vm._v("Current Address "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"permanentAddress"}},[_vm._v("Permanent Address "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"contactNumber"}},[_vm._v("Contact Number "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"emergencyContactName"}},[_vm._v("Emergency Contact Name & Relationship "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"emergencyContactNumber"}},[_vm._v("Emergency Contact Number "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nicImage"}},[_vm._v("NIC Picture "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-icon"},[_c('i',{staticClass:"fas fa-upload"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r73q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Dropdowns_SearchableDropdown_vue__ = __webpack_require__("KM+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_HeaderEmployeeDropdown_vue__ = __webpack_require__("hq6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_loaders_DoubleLoader_vue__ = __webpack_require__("AxYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_database__ = __webpack_require__("hZls");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PayrollManagement',
    components: {
        SearchableDropdown: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Dropdowns_SearchableDropdown_vue__["a" /* default */],
        HeaderEmployeeDropdown: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_HeaderEmployeeDropdown_vue__["a" /* default */],
        DoubleLoader: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_loaders_DoubleLoader_vue__["a" /* default */]
    },
    props: ["employee"],
    data: function data() {
        var user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin",
            selectedYear: this.employee.year || null,
            selectedMonth: this.employee.month || null,
            selectedEmployee: null,
            employeeList: [],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            years: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()({
                length: 10
            }, function (_, i) {
                return new Date().getFullYear() - 5 + i;
            }),
            payrollSummary: [],
            employeeId: user.uid,
            previousSelectedMonth: null,
            previousSelectedYear: null,
            isManualMonthSelected: false,
            isManualYearSelected: false,
            isSearching: false
        };
    },
    created: function created() {
        var allUsers = this.$store.state.auth.allUsers;
        var companyUserIds = this.$store.state.auth.company.users.map(function (user) {
            return user.uid;
        });
        this.employeeList = allUsers.filter(function (user) {
            return companyUserIds.includes(user.uid);
        });

        if (!this.isAdmin) {
            this.selectedMonth = localStorage.getItem("payrollMonth") || this.employee.month;
            this.selectedYear = localStorage.getItem("payrollYear") || this.employee.year;
        } else {
            this.selectedMonth = this.employee.month;
            this.selectedYear = this.employee.year;
        }
        this.saveMonthYearToLocalStorage(this.selectedMonth, this.selectedYear);
    },

    methods: {
        selectEmployee: function selectEmployee(employee) {
            this.selectedEmployee = employee || this.employee;
        },
        selectMonth: function selectMonth(month) {
            this.selectedMonth = month.name;
            this.previousSelectedMonth = month.name;
            this.isManualMonthSelected = true;
            if (!this.isAdmin) {
                localStorage.setItem("payrollMonth", month.name);
            }
        },
        selectYear: function selectYear(year) {
            this.selectedYear = year.name;
            this.previousSelectedYear = year.name;
            this.isManualYearSelected = true;
            if (!this.isAdmin) {
                localStorage.setItem("payrollYear", year.name);
            }
        },
        exportToExcel: function exportToExcel() {
            this.$emit("export-excel");
        },
        filterPayrollData: function filterPayrollData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var selectedEmpId, searchCriteria, payrollRef, snapshot, payrollData, isProcessed;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                selectedEmpId = !_this.isAdmin && _this.employeeId || _this.selectedEmployee && _this.selectedEmployee.uid || _this.employee.employeeId;
                                searchCriteria = {
                                    employeeId: selectedEmpId,
                                    month: _this.isManualMonthSelected ? _this.selectedMonth : _this.employee.month,
                                    year: _this.isManualYearSelected ? _this.selectedYear : _this.employee.year
                                };

                                if (!(!searchCriteria.employeeId || !searchCriteria.month || !searchCriteria.year)) {
                                    _context.next = 5;
                                    break;
                                }

                                console.warn("Please select employee, month and year");
                                return _context.abrupt('return');

                            case 5:

                                // Use a local flag instead of the shared store `loading`: the page hides
                                // its header while that flag is set, which would destroy this component
                                // and wipe the employee/month/year the admin just selected.
                                _this.isSearching = true;

                                _context.prev = 6;
                                payrollRef = __WEBPACK_IMPORTED_MODULE_7_firebase_app___default.a.database().ref('payroll/' + searchCriteria.year + '/' + searchCriteria.month).orderByChild('employeeId').equalTo(searchCriteria.employeeId);
                                _context.next = 10;
                                return payrollRef.once('value');

                            case 10:
                                snapshot = _context.sent;

                                if (!snapshot.exists()) {
                                    _context.next = 22;
                                    break;
                                }

                                payrollData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(snapshot.val())[0];
                                isProcessed = payrollData.status && payrollData.status.toLowerCase().trim() === "processed";

                                if (!(isProcessed || _this.isAdmin)) {
                                    _context.next = 18;
                                    break;
                                }

                                _this.$store.commit('setSelectedEmployeePayroll', payrollData);
                                _context.next = 20;
                                break;

                            case 18:
                                _context.next = 20;
                                return _this.createNewPayroll(searchCriteria);

                            case 20:
                                _context.next = 24;
                                break;

                            case 22:
                                _context.next = 24;
                                return _this.createNewPayroll(searchCriteria);

                            case 24:
                                _context.next = 30;
                                break;

                            case 26:
                                _context.prev = 26;
                                _context.t0 = _context['catch'](6);

                                console.error("Error filtering payroll data:", _context.t0);
                                swal("Oops!", _context.t0.message || "Failed to load payroll data.", "error");

                            case 30:
                                _context.prev = 30;

                                _this.isSearching = false;
                                return _context.finish(30);

                            case 33:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[6, 26, 30, 33]]);
            }))();
        },
        createNewPayroll: function createNewPayroll() {
            var _this2 = this;

            var searchCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var selectedYear, selectedMonth, selectedEmployeeId, company, companyUserIds, allEmployees, selectedEmployeeRecord, constants, newPayroll;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                selectedYear = searchCriteria.year || _this2.employee.year;
                                selectedMonth = searchCriteria.month || _this2.employee.month;
                                selectedEmployeeId = searchCriteria.employeeId || _this2.employee.employeeId;
                                _context2.prev = 3;
                                company = _this2.$store.state.auth.company;
                                companyUserIds = company.users.map(function (user) {
                                    return user.uid;
                                });
                                allEmployees = _this2.$store.state.auth.allUsers.filter(function (user) {
                                    return companyUserIds.indexOf(user.uid) !== -1;
                                });
                                selectedEmployeeRecord = allEmployees.find(function (user) {
                                    return user.uid === selectedEmployeeId;
                                });

                                if (!(!_this2.isAdmin && selectedEmployeeRecord)) {
                                    _context2.next = 11;
                                    break;
                                }

                                swal("Oops!", 'No processed payroll found for ' + selectedMonth + ', ' + selectedYear + '.', "error");
                                return _context2.abrupt('return');

                            case 11:
                                constants = _this2.$store.state.constants;
                                _context2.next = 14;
                                return _this2.$store.dispatch('createPayrollForEmployee', {
                                    emp: selectedEmployeeRecord || _this2.employee,
                                    selectedYear: selectedYear,
                                    selectedMonth: selectedMonth,
                                    constantsCollection: constants && constants.constant ? constants.constant : constants
                                });

                            case 14:
                                newPayroll = _context2.sent;

                                if (newPayroll) {
                                    _this2.$store.commit('setSelectedEmployeePayroll', newPayroll);
                                } else {
                                    console.warn("No new payroll created.");
                                    swal("Oops!", 'No processed payroll found for ' + selectedMonth + ', ' + selectedYear + '.', "error");
                                }

                                _context2.next = 22;
                                break;

                            case 18:
                                _context2.prev = 18;
                                _context2.t0 = _context2['catch'](3);

                                console.error("Error creating new payroll:", _context2.t0);
                                throw _context2.t0;

                            case 22:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[3, 18]]);
            }))();
        },
        saveMonthYearToLocalStorage: function saveMonthYearToLocalStorage(month, year) {
            if (month) localStorage.setItem("payrollMonth", month);
            if (year) localStorage.setItem("payrollYear", year);
        }
    },
    computed: {
        isSearchDisabled: function isSearchDisabled() {
            var empId = this.employeeId || this.selectedEmployee && this.selectedEmployee.uid;
            return !empId || !this.selectedMonth || !this.selectedYear;
        },
        isEmployeeSearchHidden: function isEmployeeSearchHidden() {
            return this.$store.state.auth.user.role !== "admin";
        }
    }
});

/***/ }),

/***/ "r7wL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollTable_vue__ = __webpack_require__("BbOg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6b8d85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollTable_vue__ = __webpack_require__("rUNH");
function injectStyle (ssrContext) {
  __webpack_require__("ac4u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e6b8d85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6b8d85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rITC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-loader"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rNV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_notificationService__ = __webpack_require__("l527");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_7_src_assets_icons_PencilIcon_js__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_9__UIComponents_CustomDropdown_vue__["a" /* default */]
  },
  props: {
    isAdmin: Boolean
  },
  data: function data() {
    return {
      currentUser: this.$store.state.auth.user,
      tableColumns: [{ label: "Criteria Name", key: "name", sortable: true, width: 320 }, { label: "Type", key: "type", width: 160 }, { label: "Details", key: "details", width: 300 }, { label: "Reopens", key: "reopens", width: 140 }, { label: "Deadline Missed", key: "deadlineMissed", width: 160 }, { label: "Score", key: "score", width: 120, align: "right" }, { label: "Actions", key: "action", sticky: "right", width: 100 }],

      criteriaList: [],
      selectedCriteria: null,
      isCriteriaModalOpen: false,
      isDeleteModalOpen: false,

      name: "",
      details: "",
      score: 0,
      selectedType: "",
      selectedTemplate: "",

      minValue: null,
      maxValue: null,
      countValue: null,
      each: false,

      reopenEvery: 5,
      reopenPenalty: -0.5,
      missedEvery: 5,
      missedPenalty: -0.5,

      performanceTypes: ["Ticket", "PR Review/Help", "Weekly Session", "Weekly Session Attendance", "Weekly Session Lead", "Random Post", "Interview", "Lead Per Project"],

      criteriaPresets: [{ name: "Partial Task from a Ticket", type: "Ticket", details: "0 hrs to  3 hrs", score: 0.5 }, { name: "Normal/Small Ticket", type: "Ticket", details: "3 hrs to 9 hrs", score: 1 }, { name: "Large Ticket", type: "Ticket", details: "9 hrs to 40 hrs", score: 3 }, { name: "PR Reviews/Helps in 3 Unique Tickets", type: "PR Review/Help", details: "per 3 PRs/Helps", score: 1 }, { name: "Weekly Session", type: "Weekly Session", details: "Rating 1-5", score: 1 }, { name: "Weekly Session Attendance", type: "Weekly Session Attendance", details: "per session", score: 0.5 }, { name: "Weekly Session Lead", type: "Weekly Session Lead", details: "", score: 0.5 }, { name: "2 Random posts with Discussions", type: "Random Post", details: "per 2 posts", score: 1 }, { name: "Intern Interview", type: "Interview", details: "Intern level", score: 0.5 }, { name: "Jr. Interview", type: "Interview", details: "Junior level", score: 1 }, { name: "Mid. Interview", type: "Interview", details: "Mid level", score: 1.5 }, { name: "Lead Per Project", type: "Lead Per Project", details: "", score: 1 }],

      nameError: "",
      scoreError: "",
      loadingStates: { table: false, save: false, delete: false }
    };
  },


  computed: {
    filteredColumns: function filteredColumns() {
      return this.isAdmin ? this.tableColumns : this.tableColumns.filter(function (c) {
        return c.key !== "action";
      });
    },
    templateOptions: function templateOptions() {
      return this.criteriaPresets.map(function (p) {
        return p.name;
      });
    },
    isDurationBased: function isDurationBased() {
      var lower = this.name ? this.name.toLowerCase() : '';
      return this.selectedType === "Ticket" && !lower.includes("reopen") && !lower.includes("deadline");
    },
    isWeeklySession: function isWeeklySession() {
      return this.selectedType === "Weekly Session";
    },
    isShowCountInput: function isShowCountInput() {
      var lower = this.name ? this.name.toLowerCase() : '';
      var countTypes = ["pr review/help", "random post", "penalty", "weekly session attendance", "weekly session"];
      return countTypes.includes(this.selectedType.toLowerCase()) || this.selectedType === "Ticket" && (lower.includes("reopen") || lower.includes("deadline"));
    },
    showEachCheckbox: function showEachCheckbox() {
      var lower = this.name ? this.name.toLowerCase() : '';
      return this.selectedType === "Ticket" || this.selectedType === "Weekly Session Attendance" || this.selectedType === "Weekly Session" || this.selectedType === "Penalty" || lower.includes("reopen") || lower.includes("deadline") || this.selectedType === "PR Review/Help" || this.selectedType === "Random Post";
    },
    countLabel: function countLabel() {
      return this.selectedType === "Weekly Session" ? "Rating Count" : "Count";
    }
  },

  mounted: function mounted() {
    this.fetchCriteria();
  },


  methods: {
    updateFormFields: function updateFormFields() {

      if (this.minValue !== null || this.maxValue !== null || this.countValue !== null) {
        return;
      }

      if (!this.details) return;

      var cleaned = this.details.replace(/hrs/g, '').trim();

      if (cleaned.startsWith('<')) {
        this.maxValue = parseFloat(cleaned.slice(1).trim());
        this.minValue = null;
      } else if (cleaned.startsWith('>=')) {
        this.minValue = parseFloat(cleaned.slice(2).trim());
        this.maxValue = null;
      } else if (cleaned.includes('to')) {
        var _cleaned$split = cleaned.split('to'),
            _cleaned$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_cleaned$split, 2),
            minStr = _cleaned$split2[0],
            maxStr = _cleaned$split2[1];

        this.minValue = parseFloat(minStr.trim());
        this.maxValue = this.minValue !== null ? parseFloat(maxStr.trim()) : null;
      } else if (cleaned.startsWith('per')) {
        var perStr = cleaned.slice(3).trim();
        var numberMatch = perStr.match(/\d+/);
        var countNum = numberMatch ? parseFloat(numberMatch[0]) : 1;
        this.countValue = countNum;
      } else {
        var lowerDetails = cleaned.toLowerCase();
        if (lowerDetails.includes('score on each')) {
          var parts = cleaned.split('on each');
          if (parts[1]) {
            var eachPart = parts[1].trim();
            var numMatch = eachPart.match(/^(\d+)/);
            if (numMatch) {
              this.countValue = parseFloat(numMatch[1]);
            } else {
              this.countValue = 1;
            }
          }
        } else if (lowerDetails.includes('score on') && lowerDetails.includes('or more')) {
          var _parts = cleaned.split('on ');
          if (_parts[1]) {
            var onPart = _parts[1].split(' or more')[0].trim();
            this.countValue = parseFloat(onPart);
          }
        } else if (lowerDetails.includes('score on')) {
          var _parts2 = cleaned.split('on ');
          if (_parts2[1]) {
            var _onPart = _parts2[1].trim();
            var _numMatch = _onPart.match(/^(\d+)/) || _onPart.match(/(\d+)/);
            if (_numMatch) {
              this.countValue = parseFloat(_numMatch[1]);
            } else {
              this.countValue = 1;
            }
          }
        } else if (lowerDetails.includes('rating')) {
          var _numberMatch = cleaned.match(/\d+/);
          if (_numberMatch) {
            this.countValue = parseFloat(_numberMatch[0]);
          } else {
            this.countValue = 5;
          }
        }
      }
    },
    handleTemplateChange: function handleTemplateChange(value) {
      this.selectedTemplate = value;
      var preset = this.criteriaPresets.find(function (p) {
        return p.name === value;
      });
      if (preset) {
        this.name = preset.name;
        this.selectedType = preset.type;
        this.details = preset.details;
        this.score = preset.score;

        this.reopenEvery = 5;
        this.reopenPenalty = -0.5;
        this.missedEvery = 5;
        this.missedPenalty = -0.5;

        this.updateFormFields();
      }
    },
    openCriteriaModal: function openCriteriaModal() {
      this.resetForm();
      this.isCriteriaModalOpen = true;
    },
    editCriteria: function editCriteria(item) {
      this.selectedCriteria = item;
      this.name = item.name || "";
      this.details = item.details || "";
      this.score = item.score || 0;
      this.selectedType = item.type || "";
      this.selectedTemplate = "";

      if (this.isDurationBased && item.rules && item.rules.duration) {
        this.minValue = item.rules.duration.min !== undefined && item.rules.duration.min !== null ? item.rules.duration.min : null;
        this.maxValue = item.rules.duration.max !== undefined && item.rules.duration.max !== null ? item.rules.duration.max : null;
      } else {
        this.minValue = null;
        this.maxValue = null;
      }

      var penalties = item.rules && item.rules.penalties || {};
      var reopens = penalties.reopens || {};
      var deadlineMissed = penalties.deadlineMissed || {};

      this.reopenEvery = reopens.every || reopens.limit || 5;
      this.reopenPenalty = reopens.score !== undefined ? reopens.score : -0.5;
      this.missedEvery = deadlineMissed.every || deadlineMissed.limit || 5;
      this.missedPenalty = deadlineMissed.score !== undefined ? deadlineMissed.score : -0.5;
      var lowerName = this.name.toLowerCase();
      if (this.selectedType === "Ticket") {
        this.each = reopens.every !== undefined;
      } else if (this.selectedType === "PR Review/Help" || this.selectedType === "Random Post" || this.selectedType === "Weekly Session Attendance" || this.selectedType === "Weekly Session") {
        this.each = item.rules.countDivisor !== undefined;
        this.countValue = item.rules.countDivisor || item.rules.limit || null;
      } else if (lowerName.includes("reopens") || lowerName.includes("deadlines missed") || lowerName.includes("deadline")) {
        this.each = item.rules.penalty.per !== undefined;
      } else if (this.selectedType === "Penalty") {
        this.each = item.rules.penalty ? item.rules.penalty.per !== undefined : false;
      }

      this.updateFormFields();
      this.isCriteriaModalOpen = true;
    },
    resetForm: function resetForm() {
      this.name = "";
      this.details = "";
      this.score = 0;
      this.selectedType = "";
      this.selectedTemplate = "";
      this.selectedCriteria = null;
      this.minValue = null;
      this.maxValue = null;
      this.countValue = null;
      this.each = false;
      this.reopenEvery = 5;
      this.reopenPenalty = -0.5;
      this.missedEvery = 5;
      this.missedPenalty = -0.5;
      this.nameError = "";
      this.scoreError = "";
    },
    generateRules: function generateRules() {
      var lowerName = this.name.toLowerCase();

      var rules = {};

      if (this.isDurationBased) {
        var _reopens, _deadlineMissed;

        rules = { duration: {}, type: "Ticket" };
        if (this.minValue !== null) rules.duration.min = this.minValue;
        if (this.maxValue !== null) rules.duration.max = this.maxValue;

        // Always save penalties (even defaults)
        rules.penalties = {
          reopens: (_reopens = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_reopens, this.each ? 'every' : 'limit', Number(this.reopenEvery) || 5), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_reopens, "score", Number(this.reopenPenalty) || -0.5), _reopens),
          deadlineMissed: (_deadlineMissed = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_deadlineMissed, this.each ? 'every' : 'limit', Number(this.missedEvery) || 5), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_deadlineMissed, "score", Number(this.missedPenalty) || -0.5), _deadlineMissed)
        };
      } else {
        // old logic for other types
        if (lowerName.includes("reopens")) {
          var _penalty;

          var count = this.countValue || 5;
          var key = this.each ? 'per' : 'limit';
          rules = { penalty: (_penalty = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_penalty, key, count), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_penalty, "score", this.score), _penalty), field: "reopens" };
        } else if (lowerName.includes("deadlines missed") || lowerName.includes("deadline")) {
          var _penalty2;

          var _count = this.countValue || 5;
          var _key = this.each ? 'per' : 'limit';
          rules = { penalty: (_penalty2 = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_penalty2, _key, _count), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_penalty2, "score", this.score), _penalty2), field: "deadlineMissed" };
        } else if (this.selectedType === "PR Review/Help") {
          var _rules;

          var _count2 = this.countValue || 3;
          var _key2 = this.each ? 'countDivisor' : 'limit';
          rules = (_rules = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules, _key2, _count2), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules, "type", "PR Review/Help"), _rules);
        } else if (this.selectedType === "Random Post") {
          var _rules2;

          var _count3 = this.countValue || 2;
          var _key3 = this.each ? 'countDivisor' : 'limit';
          rules = (_rules2 = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules2, _key3, _count3), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules2, "type", "Random Post"), _rules2);
        } else if (this.selectedType === "Weekly Session Attendance") {
          var _rules3;

          var _count4 = this.countValue || 1;
          var _key4 = this.each ? 'countDivisor' : 'limit';
          rules = (_rules3 = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules3, _key4, _count4), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules3, "type", "Weekly Session Attendance"), _rules3);
        } else if (this.selectedType === "Weekly Session") {
          var _rules4;

          var _count5 = this.countValue || 5;
          var _key5 = this.each ? 'countDivisor' : 'limit';
          rules = (_rules4 = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules4, _key5, _count5), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_rules4, "type", "Weekly Session"), _rules4);
        } else if (this.selectedType === "Lead Per Project") {
          rules = { fixed: this.score };
        } else if (this.selectedType === "Weekly Session Lead") {
          rules = { fixed: this.score };
        } else if (this.selectedType === "Interview") {
          var level = "";
          if (lowerName.includes("intern")) level = "Intern";
          if (lowerName.includes("jr")) level = "Junior";
          if (lowerName.includes("mid")) level = "Mid";
          rules = { level: level, score: this.score };
        } else if (this.selectedType === "Penalty") {
          var _penalty3;

          var _count6 = this.countValue || 5;
          var _key6 = this.each ? 'per' : 'limit';
          rules = { penalty: (_penalty3 = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_penalty3, _key6, _count6), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_penalty3, "score", this.score), _penalty3), field: "penalty" };
        }
      }

      return rules;
    },
    saveCriteria: function saveCriteria() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var errors, lower, min, max, detailsStr, append, effectiveCount, payload, updatedFields, title, description, changes, _title, _description;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                errors = [];


                if (!_this.name.trim()) {
                  errors.push("Criteria name is required");
                }
                if (!_this.selectedType) {
                  errors.push("Performance type is required");
                }
                if (isNaN(_this.score)) {
                  errors.push("Score must be a valid number");
                } else {
                  if (_this.selectedType === "Penalty") {
                    if (_this.score >= 0) {
                      errors.push("Score for Penalty must be negative");
                    }
                  } else {
                    if (_this.score <= 0) {
                      errors.push("Score must be more than 0");
                    }
                  }
                }

                if (_this.isDurationBased) {
                  if (isNaN(_this.minValue) || _this.minValue === null || _this.minValue < 0) {
                    errors.push("Duration From is required and must be greater than or equal to 0");
                  }
                  if (isNaN(_this.maxValue) || _this.maxValue === null || _this.maxValue <= 0) {
                    errors.push("Duration To is required and must be greater than 0");
                  }
                  if (!isNaN(_this.minValue) && !isNaN(_this.maxValue) && _this.minValue >= _this.maxValue) {
                    errors.push("Duration From must be less than Duration To");
                  }
                  if (_this.each) {
                    if (isNaN(_this.reopenEvery) || _this.reopenEvery === null || _this.reopenEvery < 1) {
                      errors.push("Reopens Count is required and must be at least 1");
                    }
                    if (isNaN(_this.missedEvery) || _this.missedEvery === null || _this.missedEvery < 1) {
                      errors.push("Deadline Missed Count is required and must be at least 1");
                    }
                  }
                  if (isNaN(_this.reopenPenalty) || _this.reopenPenalty === null) {
                    errors.push("Reopens Penalty is required");
                  }
                  if (isNaN(_this.missedPenalty) || _this.missedPenalty === null) {
                    errors.push("Deadline Missed Penalty is required");
                  }
                }

                if (_this.isShowCountInput) {
                  if (isNaN(_this.countValue) || _this.countValue === null || _this.countValue <= 0) {
                    errors.push("Count is required and must be greater than 0");
                  }
                }

                if (!(errors.length > 0)) {
                  _context.next = 9;
                  break;
                }

                if (errors.length === 1) {
                  __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Validation Error", errors[0], "error");
                } else {
                  __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Validation Errors", "Kindly fill all the required fields", "error");
                }
                return _context.abrupt("return");

              case 9:
                lower = _this.name.toLowerCase();

                if (_this.isDurationBased) {
                  min = _this.minValue;
                  max = _this.maxValue;
                  detailsStr = '';

                  if (min !== null && min !== '' && max !== null && max !== '') {
                    detailsStr = min + " hrs to less than " + max + " hrs";
                  } else if (min !== null && min !== '') {
                    detailsStr = ">= " + min + " hrs";
                  } else if (max !== null && max !== '') {
                    detailsStr = "< " + max + " hrs";
                  }
                  _this.details = detailsStr;
                } else if (_this.isShowCountInput) {
                  append = '';

                  if (lower.includes('reopens')) append = ' reopens';
                  if (lower.includes('deadlines missed') || lower.includes('deadline')) append = ' missed';
                  if (_this.selectedType === "PR Review/Help") append = ' PRs/Helps';
                  if (_this.selectedType === "Random Post") append = ' posts';
                  if (_this.selectedType === "Weekly Session Attendance") append = ' session';
                  if (_this.selectedType === "Weekly Session") append = ' rating'; // Rating-specific
                  if (_this.selectedType === "Penalty") append = ' occurrence';
                  effectiveCount = _this.each ? " " + _this.score + " score on each " + (_this.countValue > 1 ? _this.countValue : ' ') : " " + _this.score + " score on " + _this.countValue;

                  _this.details = effectiveCount ? "" + effectiveCount + append : '';
                }

                payload = {
                  name: _this.name.trim(),
                  type: _this.selectedType,
                  details: _this.details.trim() || null,
                  score: _this.score,
                  rules: _this.generateRules(),
                  updatedAt: new Date().toISOString()
                };
                _context.prev = 12;

                _this.loadingStates.save = true;

                if (!_this.selectedCriteria) {
                  _context.next = 28;
                  break;
                }

                _context.next = 17;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].updatePerformanceCriteria(_this.selectedCriteria.uid, payload);

              case 17:
                updatedFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["a" /* getUpdatedFields */])(_this.selectedCriteria, payload);
                title = _this.currentUser.username + " updated the performance criterion for " + payload.name;
                description = _this.currentUser.email + " updated the performance criterion for " + payload.name + ".";
                changes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(updatedFields).map(function (_ref) {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  return key + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["b" /* formatValue */])(value.old) + " \u2192 " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["b" /* formatValue */])(value.new);
                }).join('\n');
                _context.next = 23;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this.currentUser,
                  title: title,
                  description: description,
                  changes: changes,
                  type: "performance_criteria_edit"
                }));

              case 23:
                _context.next = 25;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "performance_criteria",
                  activityDescription: description,
                  activityName: title,
                  activityByUserName: _this.currentUser.username,
                  action: "Updated"
                }, _this.$store.state.auth, _this.currentUser.uid);

              case 25:

                __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Success!", "Criteria updated successfully", "success");
                _context.next = 37;
                break;

              case 28:
                _context.next = 30;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].addPerformanceCriteria(payload);

              case 30:
                _title = _this.currentUser.username + " added a new performance criterion named " + payload.name;
                _description = _this.currentUser.email + " added a new performance criterion named " + payload.name + ".";
                _context.next = 34;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this.currentUser,
                  title: _title,
                  description: _description,
                  type: "performance_criteria_add"
                }));

              case 34:
                _context.next = 36;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "performance_criteria",
                  activityDescription: _description,
                  activityName: _title,
                  activityByUserName: _this.currentUser.username,
                  action: "Added"
                }, _this.$store.state.auth, _this.currentUser.uid);

              case 36:
                __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Success!", "Criteria added successfully", "success");

              case 37:
                _context.next = 39;
                return _this.fetchCriteria();

              case 39:
                _this.isCriteriaModalOpen = false;
                _context.next = 46;
                break;

              case 42:
                _context.prev = 42;
                _context.t0 = _context["catch"](12);

                console.error(_context.t0);
                __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Error", _context.t0.message || "Failed to save criteria", "error");

              case 46:
                _context.prev = 46;

                _this.loadingStates.save = false;
                return _context.finish(46);

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 42, 46, 49]]);
      }))();
    },
    openDeleteModal: function openDeleteModal(item) {
      this.selectedCriteria = item;
      this.isDeleteModalOpen = true;
    },
    deleteCriteria: function deleteCriteria() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var title, description;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loadingStates.delete = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].deletePerformanceCriteria(_this2.selectedCriteria.uid);

              case 4:
                _context2.next = 6;
                return _this2.fetchCriteria();

              case 6:
                title = _this2.currentUser.username + " deleted the performance criterion named " + _this2.selectedCriteria.name;
                description = _this2.currentUser.email + " deleted the performance criterion named " + _this2.selectedCriteria.name + ".";
                _context2.next = 10;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this2.currentUser,
                  title: title,
                  description: description,
                  type: "performance_criteria_delete"
                }));

              case 10:
                _context2.next = 12;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_notificationService__["b" /* handleActivityNotification */])({
                  type: "performance_criteria",
                  activityDescription: description,
                  activityName: title,
                  activityByUserName: _this2.currentUser.username,
                  action: "Deleted"
                }, _this2.$store.state.auth, _this2.currentUser.uid);

              case 12:

                __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Deleted", "Criteria removed successfully", "success");
                _this2.isDeleteModalOpen = false;
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](0);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Error", "Failed to delete criteria", "error");

              case 19:
                _context2.prev = 19;

                _this2.loadingStates.delete = false;
                return _context2.finish(19);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 16, 19, 22]]);
      }))();
    },
    fetchCriteria: function fetchCriteria() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var list;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loadingStates.table = true;
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__assets_config_firebase__["a" /* default */].getAllPerformanceCriteria();

              case 4:
                list = _context3.sent;

                _this3.criteriaList = list || [];
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

                console.error(_context3.t0);
                __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()("Error", "Could not load criteria", "error");

              case 12:
                _context3.prev = 12;

                _this3.loadingStates.table = false;
                return _context3.finish(12);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8, 12, 15]]);
      }))();
    }
  }
});

/***/ }),

/***/ "rUNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payroll-table"},[_c('div',{staticClass:"payroll-header-container",staticStyle:{"margin":"10px auto"}},[_c('div',{staticClass:"dropdowns-container"},[_c('div',{staticClass:"admin-access-section"},[(!_vm.isEmployeeSearchHidden)?_c('EmployeeDropdown',{attrs:{"employees":_vm.employeeList,"company":_vm.$store.state.auth.company,"defaultFilter":"active","disabled":_vm.isSelectLoading || !_vm.payrollData.length,"loading":_vm.isSelectLoading},on:{"select":_vm.selectEmployee,"update":function($event){_vm.filteredUsers = $event}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"search-group"},[_c('div',{staticClass:"searchable-1"},[_c('SearchableDropdown',{attrs:{"items":_vm.monthItems,"labelKey":"name","initialValue":{ name: _vm.selectedMonth },"placeholder":"Select Month"},on:{"select":_vm.selectMonth}})],1),_vm._v(" "),_c('div',{staticClass:"searchable-2"},[_c('SearchableDropdown',{attrs:{"items":_vm.yearItems,"labelKey":"name","initialValue":{ name: _vm.selectedYear },"placeholder":"Select Year"},on:{"select":_vm.selectYear}})],1)]),_vm._v(" "),(this.isAdmin)?_c('button',{staticClass:"btn btn-outline export-icon-button",on:{"click":_vm.exportToExcel}},[_c('span',{staticClass:"export-icon"},[_vm._v("↓")]),_vm._v("\n        Export\n      ")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('TaxReportExport'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"filter-container mb-3"},[_c('div',{staticClass:"custom-btn-toggle"},[_c('button',{staticClass:"tab-button",class:{ 'active-tab': _vm.activeTab === 'payroll' },staticStyle:{"width":"120px","display":"flex","justify-content":"center"},on:{"click":function($event){return _vm.switchTab('payroll')}}},[_vm._v("\n          Payroll\n        ")]),_vm._v(" "),_c('button',{staticClass:"tab-button",class:{ 'active-tab': _vm.activeTab === 'adjustments' },staticStyle:{"width":"120px","display":"flex","justify-content":"center"},on:{"click":function($event){return _vm.switchTab('adjustments')}}},[_vm._v("\n          "+_vm._s(_vm.isAdmin ? 'Adjustments' : 'My Expenses')+"\n        ")])])])]),_vm._v(" "),(_vm.activeTab === 'payroll')?_c('div',[(_vm.isAdmin)?_c('div',{staticStyle:{"margin":"10px 0px"}},[_c('CardsSection',{attrs:{"cards":_vm.cards}})],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"table-container",staticStyle:{"position":"relative"}},[_c('CustomTable',{attrs:{"loading":_vm.loading ? _vm.loading : _vm.tableFilterLoading,"columns":_vm.columns,"data":_vm.filteredPayrollData,"itemsPerPageOptions":[5, 10, 20, 50]},scopedSlots:_vm._u([{key:"employeeName",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.employeeName)+"\n        ")]}},{key:"grossSalary",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.grossSalary)+"\n        ")]}},{key:"taxDeduction",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.taxDeduction ? item.taxDeduction : '0')+"\n        ")]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('span',{class:_vm.getStatusClass(item.status)},[_vm._v("\n            "+_vm._s(item.status)+"\n          ")])]}},{key:"obtainedLeaves",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-ellipsis",attrs:{"title":_vm.getLeavesTooltip(item)}},[_vm._v("\n            "+_vm._s(_vm.getLeavesTaken(item))+"\n          ")])]}},{key:"daysWorked",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-ellipsis",attrs:{"title":("Required Working days: " + (item.requiredWorkingDays))}},[_vm._v("\n            "+_vm._s(item.daysWorked)+"\n          ")])]}},{key:"lateDeduction",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-ellipsis",attrs:{"title":_vm.getLateDeductionTooltip(item)}},[_vm._v("\n            "+_vm._s(_vm.formatLateDeduction(item))+"\n          ")])]}},{key:"action",fn:function(ref){
var item = ref.item;
return [_c('div',{staticStyle:{"display":"flex","justify-content":"center"},on:{"click":function($event){return _vm.viewDetails(item)}}},[_c('div',{staticClass:"payroll-action-button"},[_c('PencilIcon',{attrs:{"color":"gray","width":18,"height":18}})],1)])]}}])}),_vm._v(" "),(this.isLoading)?_c('div',{staticClass:"payroll-table-loader-overlay"},[_c('div',{staticClass:"payroll-loader-container"},[_c('DoubleLoader',{staticClass:"payroll-loader"})],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.noPayrollFound)?_c('div',{staticClass:"no-payroll-card"},[_c('p',{staticClass:"no-payroll-title"},[_vm._v("No Payroll Data")]),_vm._v(" "),_c('p',{staticClass:"no-payroll-subtext"},[_vm._v("We couldn't find any payroll records for the selected period.")])]):_vm._e()]):(_vm.activeTab === 'adjustments')?_c('div',[_c('Adjustments',{attrs:{"selectedMonth":_vm.selectedMonth,"selectedYear":_vm.selectedYear,"employeeList":_vm.employeeList,"filteredUsers":_vm.filteredUsers,"isAdmin":_vm.isAdmin,"selectedEmployee":_vm.selectedEmployee}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rYrC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s9Aa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"header-actions"},[_c('h5',{staticClass:"title"},[_vm._v("Performance Criteria")]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"actions-right"},[_c('button',{staticClass:"add-employee",on:{"click":function($event){return _vm.openCriteriaModal()}}},[_c('span',[_vm._v("Add Criteria")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('CustomTable',{attrs:{"header":_vm.filteredColumns,"loading":_vm.loadingStates.table,"columns":_vm.filteredColumns,"data":_vm.criteriaList},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"criteria-name"},[_vm._v(_vm._s(item.name || '-'))])]}},{key:"type",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"type-text"},[_vm._v(_vm._s(item.type || '-'))])]}},{key:"details",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-muted details-text"},[_vm._v(_vm._s(item.details || '-'))])]}},{key:"reopens",fn:function(ref){
var item = ref.item;
return [(item.rules && item.rules.penalties && item.rules.penalties.reopens)?_c('span',[(item.rules.penalties.reopens.every)?_c('span',[_vm._v("\n                    Per "+_vm._s(item.rules.penalties.reopens.every)+" → "+_vm._s(item.rules.penalties.reopens.score)+"\n                  ")]):(item.rules.penalties.reopens.limit)?_c('span',[_vm._v("\n                    On "+_vm._s(item.rules.penalties.reopens.limit)+" → "+_vm._s(item.rules.penalties.reopens.score)+"\n                  ")]):_vm._e()]):_c('span',[_vm._v("-")])]}},{key:"deadlineMissed",fn:function(ref){
var item = ref.item;
return [(item.rules && item.rules.penalties && item.rules.penalties.deadlineMissed)?_c('span',[(item.rules.penalties.deadlineMissed.every)?_c('span',[_vm._v("\n                    Per "+_vm._s(item.rules.penalties.deadlineMissed.every)+" → "+_vm._s(item.rules.penalties.deadlineMissed.score)+"\n                  ")]):(item.rules.penalties.deadlineMissed.limit)?_c('span',[_vm._v("\n                    On "+_vm._s(item.rules.penalties.deadlineMissed.limit)+" → "+_vm._s(item.rules.penalties.deadlineMissed.score)+"\n                  ")]):_vm._e()]):_c('span',[_vm._v("-")])]}},{key:"score",fn:function(ref){
var item = ref.item;
return [_c('span',{class:['score-display', item.score < 0 ? 'text-danger' : 'text-success']},[_vm._v("\n                  "+_vm._s(item.score !== undefined ? item.score : '-')+"\n                ")])]}},(_vm.isAdmin)?{key:"action",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"action-buttons"},[_c('button',{staticClass:"edit-btn btn-status",on:{"click":function($event){return _vm.editCriteria(item)}}},[_c('PencilIcon',{attrs:{"color":"gray","width":16,"height":16}})],1),_vm._v(" "),_c('button',{staticClass:"delete-btn btn-status",on:{"click":function($event){return _vm.openDeleteModal(item)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"gray"}})])])]}}:null],true)})],1)]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isCriteriaModalOpen,"title":_vm.selectedCriteria ? 'Edit Criteria' : 'Add Criteria',"isLarge":true,"submitButtonText":"Save","loading":_vm.loadingStates.save,"performance":true},on:{"update:modelValue":function($event){_vm.isCriteriaModalOpen = $event},"submit":function($event){return _vm.saveCriteria()}}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveCriteria()}}},[_c('div',{staticClass:"modal-body-container"},[_c('div',{staticClass:"form-scroll-container m-0"},[_c('div',{staticClass:"form-group row "},[_c('div',{staticClass:"col-md-12 mb-1"},[_c('CustomDropdown',{attrs:{"label":"Quick Template","options":_vm.templateOptions,"value":_vm.selectedTemplate,"placeholder":"Choose a preset to prefill"},on:{"change":_vm.handleTemplateChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-1"},[_c('CustomDropdown',{attrs:{"label":"Type","options":_vm.performanceTypes,"value":_vm.selectedType,"placeholder":"Select which performance type this applies to","required":true},on:{"change":function($event){_vm.selectedType = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-3"},[_c('label',[_vm._v("Criteria Name "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"e.g. Normal/Small Ticket"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.nameError)?_c('small',{staticStyle:{"display":"flex","align-items":"center","margin-top":"15px"}},[_vm._v(_vm._s(_vm.nameError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row mx-auto",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-md-12 mb-3"},[(!_vm.isDurationBased)?_c('label',[_vm._v(_vm._s(_vm.isShowCountInput ? _vm.countLabel : 'Details')+"  "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.isShowCountInput ? '*' : ''))])]):_vm._e(),_vm._v(" "),(_vm.isDurationBased)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('label',[_vm._v("\n                              Duration From (>=) "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.minValue),expression:"minValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"e.g. 0 or 3"},domProps:{"value":(_vm.minValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.minValue=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('label',[_vm._v("Duration To (<) "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.maxValue),expression:"maxValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"e.g. 3 or 9"},domProps:{"value":(_vm.maxValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxValue=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])])]):(_vm.isShowCountInput)?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.countValue),expression:"countValue",modifiers:{"number":true}}],staticClass:"form-control mb-3",attrs:{"type":"number","placeholder":"e.g. 5"},domProps:{"value":(_vm.countValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.countValue=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}):_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.details),expression:"details",modifiers:{"trim":true}}],staticClass:"form-control mb-3",attrs:{"type":"text","placeholder":"Any thing about the criteria"},domProps:{"value":(_vm.details)},on:{"input":function($event){if($event.target.composing){ return; }_vm.details=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),(_vm.isDurationBased && _vm.selectedType === 'Ticket')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6  mb-3"},[_c('label',[_vm._v("Reopens Count "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.reopenEvery),expression:"reopenEvery",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.reopenEvery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reopenEvery=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('label',[_vm._v("Reopens Penalty "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.reopenPenalty),expression:"reopenPenalty",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.5"},domProps:{"value":(_vm.reopenPenalty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reopenPenalty=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6  mb-3"},[_c('label',[_vm._v("Deadline Missed Count "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.missedEvery),expression:"missedEvery",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.missedEvery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.missedEvery=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-3"},[_c('label',[_vm._v("Deadline Missed Penalty "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.missedPenalty),expression:"missedPenalty",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.5"},domProps:{"value":(_vm.missedPenalty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.missedPenalty=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Score "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.score),expression:"score",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.5","placeholder":"e.g. 1 or -0.5"},domProps:{"value":(_vm.score)},on:{"input":function($event){if($event.target.composing){ return; }_vm.score=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.scoreError)?_c('small',{staticStyle:{"display":"flex","align-items":"center","margin-top":"15px"}},[_vm._v(_vm._s(_vm.scoreError))]):_vm._e()]),_vm._v(" "),(_vm.showEachCheckbox)?_c('div',{staticClass:"col-md-6 mt-4"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"checkbox-box",staticStyle:{"display":"flex","align-items":"center","margin-top":"15px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.each),expression:"each"}],staticClass:"checkbox",staticStyle:{"width":"15px","height":"15px"},attrs:{"type":"checkbox","id":'each-checkbox-' + (_vm.selectedCriteria ? _vm.selectedCriteria.uid : 'new')},domProps:{"checked":Array.isArray(_vm.each)?_vm._i(_vm.each,null)>-1:(_vm.each)},on:{"change":function($event){var $$a=_vm.each,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.each=$$a.concat([$$v]))}else{$$i>-1&&(_vm.each=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.each=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"width":"max-content","margin-top":"2px"},attrs:{"for":'each-checkbox-' + (_vm.selectedCriteria ? _vm.selectedCriteria.uid : 'new')}},[_vm._v("\n                            Applied on Each Count\n                          ")])])])]):_vm._e()])])])])])]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeleteModalOpen,"title":"Delete Criteria?","isLarge":false,"submitButtonText":"Delete","loading":_vm.loadingStates.delete},on:{"update:modelValue":function($event){_vm.isDeleteModalOpen = $event},"submit":function($event){return _vm.deleteCriteria()}}},[_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Are you sure to permanently delete the criteria?")])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s9bF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sHQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_slack__ = __webpack_require__("BjXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_adminLogs__ = __webpack_require__("nvCY");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var EMPTY = { webhookUrl: "", enabled: true };

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SlackIntegration",
  data: function data() {
    return {
      loading: true,
      saving: false,
      testing: false,
      showUrl: false,
      saved: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, EMPTY),
      form: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, EMPTY)
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user || {};
    },
    busy: function busy() {
      return this.saving || this.testing;
    },
    webhookValid: function webhookValid() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_slack__["b" /* isValidSlackWebhook */])(this.form.webhookUrl);
    },
    isDirty: function isDirty() {
      return this.form.webhookUrl !== this.saved.webhookUrl || this.form.enabled !== this.saved.enabled;
    },
    statusLabel: function statusLabel() {
      if (!this.saved.webhookUrl) return "Not connected";
      return this.saved.enabled ? "Active" : "Paused";
    },
    statusClass: function statusClass() {
      if (!this.saved.webhookUrl) return "is-off";
      return this.saved.enabled ? "is-on" : "is-paused";
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var config;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_slack__["c" /* getSlackConfig */])();

            case 3:
              config = _context.sent;

              _this.saved = {
                webhookUrl: config.webhookUrl || "",
                enabled: config.webhookUrl ? config.enabled !== false : true
              };
              _this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.saved);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.error("Failed to load Slack settings:", _context.t0);

            case 11:
              _context.prev = 11;

              _this.loading = false;
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }))();
  },

  methods: {
    sendTest: function sendTest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.webhookValid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this2.testing = true;
                _context2.prev = 3;
                _context2.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_slack__["d" /* postToSlack */])(_this2.form.webhookUrl, {
                  text: ":white_check_mark: Pertime is connected. Admin activities for " + _this2.companyName() + " will appear in this channel."
                });

              case 6:
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Test sent", "Check your Slack channel. If nothing arrives, the webhook URL is wrong or was revoked.", "info");
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Error!", "Could not reach Slack. Check your connection and try again.", "error");

              case 12:
                _context2.prev = 12;

                _this2.testing = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 9, 12, 15]]);
      }))();
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var wasConnected;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this3.form.webhookUrl && !_this3.webhookValid)) {
                  _context3.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Invalid URL", "The webhook URL should start with https://hooks.slack.com/services/", "error");
                return _context3.abrupt("return");

              case 3:
                if (_this3.form.webhookUrl) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 6;
                return _this3.disconnect();

              case 6:
                return _context3.abrupt("return");

              case 7:
                _this3.saving = true;
                _context3.prev = 8;
                _context3.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_slack__["e" /* saveSlackConfig */])({
                  webhookUrl: _this3.form.webhookUrl,
                  enabled: _this3.form.enabled,
                  updatedBy: _this3.currentUser.uid || null,
                  updatedAt: new Date().toISOString()
                });

              case 11:
                wasConnected = !!_this3.saved.webhookUrl;

                _this3.saved = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this3.form);
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Success!", "Slack settings saved!", "success");
                _context3.next = 16;
                return _this3.logChange(wasConnected ? "updated Slack integration" : "connected Slack", "Slack activity notifications " + (_this3.form.enabled ? "enabled" : "paused") + ".");

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](8);

                console.error("Failed to save Slack settings:", _context3.t0);
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Error!", "Failed to save Slack settings.", "error");

              case 22:
                _context3.prev = 22;

                _this3.saving = false;
                return _context3.finish(22);

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[8, 18, 22, 25]]);
      }))();
    },
    disconnect: function disconnect() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var confirmed;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()({
                  title: "Disconnect Slack?",
                  text: "Activities will no longer be posted to Slack.",
                  icon: "warning",
                  buttons: ["Cancel", "Disconnect"],
                  dangerMode: true
                });

              case 2:
                confirmed = _context4.sent;

                if (confirmed) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                _this4.saving = true;
                _context4.prev = 6;
                _context4.next = 9;
                return _this4.logChange("disconnected Slack", "Slack activity notifications turned off.");

              case 9:
                _context4.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_slack__["f" /* removeSlackConfig */])();

              case 11:
                _this4.saved = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, EMPTY);
                _this4.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, EMPTY);
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Disconnected", "Slack has been disconnected.", "success");
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](6);

                console.error("Failed to disconnect Slack:", _context4.t0);
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()("Error!", "Failed to disconnect Slack.", "error");

              case 20:
                _context4.prev = 20;

                _this4.saving = false;
                return _context4.finish(20);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[6, 16, 20, 23]]);
      }))();
    },
    companyName: function companyName() {
      var company = this.$store.state.auth.company;
      return company && company.companyName || "your company";
    },
    logChange: function logChange(action, description) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_adminLogs__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_adminLogs__["d" /* createActivityPayload */])({
                  user: _this5.currentUser,
                  title: _this5.currentUser.username + " " + action,
                  description: description,
                  type: "settings"
                }));

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);

                console.warn("Failed to log Slack settings change:", _context5.t0);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 5]]);
      }))();
    }
  }
});

/***/ }),

/***/ "sMWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UIComponents_Buttons_ResetIconButton_vue__ = __webpack_require__("0IWI");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AttendanceDetails",
  components: {
    ResetIconButton: __WEBPACK_IMPORTED_MODULE_11__UIComponents_Buttons_ResetIconButton_vue__["a" /* default */]
  },
  props: {
    employee: {
      type: Object,
      required: true
    },
    initialValues: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    console.log("employee", this.employee);
    return {
      currentUser: null,
      requiredWorkingDaysInput: "",
      daysWorkedInput: "",
      leavesTakenInput: "",
      absentsInput: "",
      lateArrivalsInput: "",
      leaveBalance: "",
      leaveDeductionInput: "",
      salaryDeductionInput: 0,
      lateDeductionDays: this.employee.lateDeductionDays || "",
      totalLatesCount: 0,
      manualLateDeductionInput: "",
      isLeaveDeductionManuallyUpdated: false,
      isLateDeductionManuallyUpdated: false,
      manualLeaveDeduction: "",
      previousAbsents: 0,
      originalLeavesTaken: 0,
      originalDaysWorked: 0,
      daysWorkedWhenLeavesZero: null,
      previousLeavesTaken: 0,
      isAbsentInfoVisible: false,
      isleaveInfoVisible: false,
      isDaysWorkedVisible: false,
      isWorkingDaysVisible: false,
      leaveDeductionNote: this.employee.leaveDeductionNote || "",
      newLeaveBalance: this.employee.newLeaveBalance || 0,
      absentDays: null,
      resignedAbsentDays: null,
      isAbsentsUpdatedByUser: false,
      holidaysList: [],
      calculatedLeaves: []
    };
  },

  computed: {
    selectedEmployee: function selectedEmployee() {
      return this.$store.state.payroll.selectedEmployeePayroll || {};
    },
    calculatedLateSalaryDeductionDays: function calculatedLateSalaryDeductionDays() {
      if (this.isLateDeductionManuallyUpdated) {
        return this.manualLateDeductionInput; // Return manual input if it is updated
      }
      return parseInt(this.lateDeductionDays) || "";
    },
    calculatedLeaveDeductionDays: function calculatedLeaveDeductionDays() {
      return parseInt(this.leaveDeductionInput) || "";
    },
    calculatedTotalLatesCount: function calculatedTotalLatesCount() {
      return parseInt(this.totalLatesCount) || "";
    },
    isDisabled: function isDisabled() {
      return this.$store.state.auth.user.role !== "admin";
    },
    leavesTaken: function leavesTaken() {
      return Number((this.selectedEmployee.obtainedLeaves || '0 / 0').split(' / ')[0]) || "";
    },
    leaveDeductionMax: function leaveDeductionMax() {
      return this.leavesTakenInput || 0;
    },
    getLeaveDeductionNote: function getLeaveDeductionNote() {
      if (this.leaveDeductionInput !== this.initialValues.leaveDeductionDays) {
        return true;
      }
      return false;
    },
    getNewLeaveBalance: function getNewLeaveBalance() {
      var allowed = Number(this.employee.leavesAllowed) || 0;
      var taken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      var netAllowed = (allowed - taken).toFixed(2);
      var deduction = Number(this.leaveDeductionInput) || 0;
      var newLeaveBalance = Math.max(Number((netAllowed - deduction).toFixed(2)), 0);
      this.employee.newLeaveBalance = newLeaveBalance;
      this.employee.DBLeavesTaken = this.employee.DBLeavesTaken;
      this.syncToEmployee();
      return newLeaveBalance;
    },
    getMaxLeavesDeduction: function getMaxLeavesDeduction() {
      var initialLeavesTaken = Number(this.initialValues.leavesTaken) || 0;
      var leavesTaken = Number(this.leavesTakenInput) || 0;
      var leavesAllowed = Number(this.employee.leavesAllowed) || 0;
      if (initialLeavesTaken !== leavesTaken) {
        return leavesAllowed - leavesTaken + initialLeavesTaken;
      }
      return leavesAllowed;
    },
    getLeaveTooltipInfo: function getLeaveTooltipInfo() {
      var leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      var leavesAllowed = this.getLeavesAllowed() || 0;
      var deduction = this.getNewLeaveBalance.deduction || 0;
      var remaining = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);
      return {
        leavesAllowed: leavesAllowed,
        leavesTaken: leavesTaken,
        remaining: remaining
      };
    }
  },
  methods: {
    getLeaveInfoText: function getLeaveInfoText() {
      var leavesAllowed = this.getLeavesAllowed() || 0;
      var deduction = this.getNewLeaveBalance.deduction || 0;
      var remaining = Math.max(Number((leavesAllowed - deduction).toFixed(2)), 0);
      return '(Leaves Allowed: ' + remaining + ')';
    },
    handleManualLeaveDeduction: function handleManualLeaveDeduction(e) {
      var manualInput = e && e.target.value;
      this.isLeaveDeductionManuallyUpdated = true;
      if (manualInput === "" || manualInput === "0" || Number(manualInput) === 0) {
        this.leaveDeductionInput = "";
        this.employee.leavesDeductionDays = 0;
        this.employee.leaveDeductionCount = "";
        this.employee.manualLeaveDeductionDays = "";
        this.manualLeaveDeduction = "";
      } else {
        this.leaveDeductionInput = "";
        this.leaveDeductionInput = Number(manualInput);
        this.employee.leavesDeductionDays = this.leaveDeductionInput;
        this.employee.leaveDeductionCount = this.leaveDeductionInput;
        this.employee.manualLeaveDeductionDays = this.leaveDeductionInput;
        this.manualLeaveDeduction = this.leaveDeductionInput;
      }
      this.employee.recentUpdatedField = "leavesDeductionDays";
      this.syncToEmployee();
    },
    updateAttendanceData: function updateAttendanceData() {
      var _this = this;

      var _employee = this.employee,
          obtainedLeaves = _employee.obtainedLeaves,
          requiredWorkingDays = _employee.requiredWorkingDays,
          daysWorked = _employee.daysWorked,
          absents = _employee.absents,
          lateArrivals = _employee.lateArrivals,
          leaveDeductionNote = _employee.leaveDeductionNote,
          lateDeductionDays = _employee.lateDeductionDays,
          leavesDeductionDays = _employee.leavesDeductionDays,
          leaveDeductionCount = _employee.leaveDeductionCount,
          manualLeaveDeductionDays = _employee.manualLeaveDeductionDays;


      var leaveBalance = 0;
      if (obtainedLeaves && obtainedLeaves.includes(" / ")) {
        var _obtainedLeaves$split = obtainedLeaves.split(" / ").map(Number);

        var _obtainedLeaves$split2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_obtainedLeaves$split, 2);

        leaveBalance = _obtainedLeaves$split2[1];
      }

      this.requiredWorkingDaysInput = requiredWorkingDays || "";
      this.daysWorkedInput = daysWorked || "";
      this.leavesTakenInput = obtainedLeaves ? obtainedLeaves.split(" / ")[0] || "0 / 0" : "0 / 0";
      this.absentsInput = absents || "";
      this.lateArrivalsInput = lateArrivals || "";
      this.leaveBalance = leaveBalance || "";
      this.leaveDeductionNote = leaveDeductionNote || "";

      // Set manual deduction inputs from saved employee data
      this.leaveDeductionInput = leavesDeductionDays || leaveDeductionCount || manualLeaveDeductionDays || "";
      this.manualLateDeductionInput = lateDeductionDays || "";
      this.lateDeductionDays = lateDeductionDays || "";

      // Check if saved values differ from calculated defaults to set manual flags
      var defaultLeaveDeduction = this.calculateDefaultLeaveDeduction();
      var defaultLateDeduction = this.calculateDefaultLateDeduction();
      var savedLateDeduction = this.employee.lateDeductionDays;
      var hasSavedLateDeduction = ["draft", "processed"].includes((this.employee.status || "").toLowerCase()) && savedLateDeduction !== undefined && savedLateDeduction !== null;
      if (hasSavedLateDeduction) {
        this.isLateDeductionManuallyUpdated = true;
        this.manualLateDeductionInput = Number(savedLateDeduction);
        this.lateDeductionDays = Number(savedLateDeduction);
        this.employee.lateDeductionDays = Number(savedLateDeduction);
      }
      this.$nextTick(function () {
        _this.recalculateAbsents();
        _this.calculateDeductions();
      });
    },
    resetIfEmpty: function resetIfEmpty(field) {
      var _this2 = this;

      var employeeField = field.replace('Input', '');

      this[field] = this.initialValues[employeeField] || 0;
      if (field === 'leaveDeductionNote') {
        this.leaveDeductionNote = this.initialValues.leaveDeductionNote || '';
        this.employee.leaveDeductionNote = this.leaveDeductionNote;
        this.syncToEmployee();
      }

      if (field === 'leaveDeductionInput') {
        this.isLeaveDeductionManuallyUpdated = false;
        this.leaveDeductionInput = this.initialValues.leavesDeductionDays || this.calculateDefaultLeaveDeduction();
        this.employee.leavesDeductionDays = this.leaveDeductionInput;
        this.employee.leaveDeductionCount = this.leaveDeductionInput;
        this.employee.manualLeaveDeductionDays = this.leaveDeductionInput;
        this.manualLeaveDeduction = this.leaveDeductionInput;
        this.syncToEmployee();
      }

      if (field === 'lateSalaryDeductionInput') {
        this.isLateDeductionManuallyUpdated = false;
        this.manualLateDeductionInput = this.initialValues.lateDeductionDays || this.calculateDefaultLateDeduction();
        this.lateDeductionDays = this.manualLateDeductionInput;
        this.employee.lateDeductionDays = this.manualLateDeductionInput;
        this.syncToEmployee();
      }

      if (field === 'leavesTakenInput') {
        var initialLeaves = this.initialValues.obtainedLeaves ? this.initialValues.obtainedLeaves.split(" / ")[0] : 0;
        this.leavesTakenInput = initialLeaves;

        if (this.employee.obtainedLeaves) {
          var _employee$obtainedLea = this.employee.obtainedLeaves.split(" / "),
              _employee$obtainedLea2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_employee$obtainedLea, 2),
              balance = _employee$obtainedLea2[1];

          this.employee.obtainedLeaves = initialLeaves + ' / ' + balance;
        }
        this.employee.leavesTaken = Number(initialLeaves);

        this.syncToEmployee();
      }
      if (field === 'daysWorkedInput') {
        this.daysWorkedInput = this.initialValues.daysWorked || 0;
        this.employee.daysWorked = this.daysWorkedInput;
        this.absentsInput = this.initialValues.absents || 0;
        this.employee.absents = this.absentsInput;
        this.isAbsentsUpdatedByUser = false;
        this.$nextTick(function () {
          return _this2.recalculateAbsents();
        });
        this.syncToEmployee();
      }
      if (field === 'requiredWorkingDaysInput') {
        this.requiredWorkingDaysInput = this.initialValues.requiredWorkingDays || 0;
        this.employee.requiredWorkingDays = this.requiredWorkingDaysInput;

        var salary = Number(this.employee.salary || this.employee.basicSalary || 0);
        var extraAllowance = Number(this.employee.extraAllowance || 0);
        var grossSalary = salary + extraAllowance;
        this.employee.perDaySalary = this.requiredWorkingDaysInput ? parseFloat(grossSalary) / Number(this.requiredWorkingDaysInput) : 0;
        this.isAbsentsUpdatedByUser = false;
        this.$nextTick(function () {
          return _this2.recalculateAbsents();
        });
        this.syncToEmployee();
      }
      if (field === 'lateArrivalsInput' || field === 'lateSalaryDeductionInput') {
        this.calculateDeductions();
        this.lateDeductionDays = this.calculatedLateSalaryDeductionDays;
        this.updateLateSalaryDeductionDays();
      }

      // Update the employee object if needed
      if (this.employee[employeeField] !== this[field]) {
        this.employee[employeeField] = this[field];
        this.syncToEmployee();
      }
    },
    absentDaysCount: function absentDaysCount() {
      return Math.max(0, Number(this.absentsInput) || 0);
    },
    recalculateAbsents: function recalculateAbsents() {
      var requiredDays = Number(this.requiredWorkingDaysInput) || 0;
      var daysWorked = Number(this.daysWorkedInput) || 0;
      var leavesTaken = Number(this.leavesTakenInput) || 0;

      // Ensure absents can't be negative
      var newAbsents = Math.max(0, requiredDays - daysWorked - leavesTaken);

      this.absentsInput = newAbsents;
      this.employee.absents = newAbsents;
    },
    calculateDeductions: function calculateDeductions() {
      var lates = Number(this.lateArrivalsInput) || 0;
      var leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      var leavesAllowed = this.getLeavesAllowed() || 0;
      var leavesBalance = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);

      var leaveDeductionDays = 0;
      var lateDeductionDays = 0;
      var totalLatesCount = 0;

      var rule = leavesBalance >= 2 ? __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["m" /* lateRules */].find(function (rule) {
        return lates >= rule.minLates;
      }) || { leaveDeductionDays: 0, lateDeductionDays: 0, totalLatesCount: 0 } : __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["n" /* deductionRules */].find(function (rule) {
        return lates >= rule.minLates;
      });

      if (rule) {
        if (leavesBalance >= 2) {
          // For leavesBalance >= 2, use lateRules
          leaveDeductionDays = Math.min(rule.leaveDeductionDays, leavesBalance);
          lateDeductionDays = rule.lateDeductionDays;
          totalLatesCount = rule.totalLatesCount;
        } else {
          // For leavesBalance < 2, use deductionRules
          var rangeKey = leavesBalance < 1 ? '<1' : '>=1,<2';
          leaveDeductionDays = Math.min(rule.leaveDeduction[rangeKey], leavesBalance);
          lateDeductionDays = rule.lateDeduction[rangeKey];
          var lateRule = __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["m" /* lateRules */].find(function (r) {
            return lates >= r.minLates;
          });
          totalLatesCount = lateRule ? lateRule.totalLatesCount : 0;
        }
      }

      leaveDeductionDays = this.roundToHalf(Math.min(leaveDeductionDays, leavesBalance, 2));

      this.leaveBalance = leavesBalance;
      var hasSavedLeaveDeduction = this.employee.status === "Draft" && (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.leavesDeductionDays)) || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.leaveDeductionCount)) || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.manualLeaveDeductionDays)));
      if (!this.isLeaveDeductionManuallyUpdated && !hasSavedLeaveDeduction) {
        this.leaveDeductionInput = leaveDeductionDays;
        this.employee.leavesDeductionDays = leaveDeductionDays;
        this.employee.leaveDeductionCount = leaveDeductionDays;
        this.employee.manualLeaveDeductionDays = leaveDeductionDays;
        this.manualLeaveDeduction = leaveDeductionDays;
      } else if (hasSavedLeaveDeduction) {
        this.leaveDeductionInput = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.leavesDeductionDays)) ? this.employee.leavesDeductionDays : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.leaveDeductionCount)) ? this.employee.leaveDeductionCount : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.manualLeaveDeductionDays)) ? this.employee.manualLeaveDeductionDays : "";
        this.employee.leavesDeductionDays = this.leaveDeductionInput;
        this.employee.leaveDeductionCount = this.leaveDeductionInput;
        this.employee.manualLeaveDeductionDays = this.leaveDeductionInput;
        this.manualLeaveDeduction = this.leaveDeductionInput;
      }
      var hasSavedLateDeduction = ["draft", "processed"].includes((this.employee.status || "").toLowerCase()) && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.lateDeductionDays));
      if (!this.isLateDeductionManuallyUpdated && !hasSavedLateDeduction) {
        this.lateDeductionDays = lateDeductionDays;
        this.manualLateDeductionInput = lateDeductionDays;
        this.employee.lateDeductionDays = lateDeductionDays;
      } else if (hasSavedLateDeduction) {
        this.lateDeductionDays = this.employee.lateDeductionDays;
        this.manualLateDeductionInput = this.employee.lateDeductionDays;
        this.employee.lateDeductionDays = this.manualLateDeductionInput;
      }
      this.totalLatesCount = totalLatesCount;

      var perDaySalary = Number(this.employee.perDaySalary) || 0;
      this.salaryDeductionInput = (lateDeductionDays * perDaySalary).toFixed(2);

      this.syncToEmployee();
    },
    updateRequiredWorkingDays: function updateRequiredWorkingDays() {
      var requiredWorkingDays = Number(this.requiredWorkingDaysInput);
      this.employee.requiredWorkingDays = requiredWorkingDays;

      // Recalculate per day salary
      var monthlySalary = Number(this.employee.salary || this.employee.basicSalary || 0) + Number(this.employee.extraAllowance) || 0;
      this.employee.perDaySalary = requiredWorkingDays ? monthlySalary / requiredWorkingDays : 0;

      // Recalculate absents when working days change
      this.recalculateAbsents(); // Updated to use shared method
      this.isAbsentsUpdatedByUser = true; // NEW: Set flag for user-triggered change

      this.syncToEmployee();
    },
    updateLeavesTaken: function updateLeavesTaken(e) {
      var maxLeaves = Number(this.leaveBalance) || 0;
      var rawValue = Number(e.target.value) || 0;

      // Round to nearest 0.5 and clamp between 0 and maxLeaves
      var newLeavesTaken = Math.min(Math.max(0, this.roundToHalf(rawValue)), maxLeaves);
      this.leavesTakenInput = newLeavesTaken;
      this.employee.leavesTaken = newLeavesTaken;

      // Update obtainedLeaves string
      var obtLeaves = this.employee.obtainedLeaves || "0 / 0";
      if (obtLeaves.includes(" / ")) {
        var _obtLeaves$split = obtLeaves.split(" / "),
            _obtLeaves$split2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_obtLeaves$split, 2),
            balance = _obtLeaves$split2[1];

        this.employee.obtainedLeaves = newLeavesTaken + ' / ' + balance;
      }

      this.getMaxLeavesDeduction;

      this.employee.recentUpdatedField = "leavesTaken";
      this.recalculateAbsents();
      this.isAbsentsUpdatedByUser = true;
      this.calculateDeductions();
      this.syncToEmployee();
    },
    updateAbsents: function updateAbsents(e) {
      var rawValue = Number(e.target.value || e) || 0;
      var newAbsents = this.roundToHalf(rawValue);

      // Apply updates
      this.absentsInput = newAbsents;
      this.employee.absents = newAbsents;

      this.previousAbsents = newAbsents;

      // Get current values
      var requiredDays = Number(this.requiredWorkingDaysInput) || 0;
      var leavesTaken = Number(this.leavesTakenInput) || 0;

      // Calculate new absents (can't be negative)
      var newDaysWorked = Math.max(0, requiredDays - newAbsents - leavesTaken);
      this.employee.daysWorked = newDaysWorked || 0;
      this.daysWorkedInput = newDaysWorked || 0;

      this.syncToEmployee();
    },
    updateLateArrivals: function updateLateArrivals(e) {
      var hasSavedLateDeduction = ["draft", "processed"].includes((this.employee.status || "").toLowerCase()) && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.lateDeductionDays));
      if (!hasSavedLateDeduction) {
        this.isLateDeductionManuallyUpdated = false;
      }
      this.employee.lateArrivals = Number(this.lateArrivalsInput) || e.target.value;
      this.employee.recentUpdatedField = "lateArrivals";
      this.calculateDeductions();
      this.syncToEmployee();
    },
    updateLeaveDeduction: function updateLeaveDeduction(e) {
      this.isLeaveDeductionManuallyUpdated = true;
      var obtLeaves = this.employee.obtainedLeaves || "0 / 0";
      var updatedLeaves = obtLeaves && obtLeaves.split(" / ");
      updatedLeaves[0] = e.target.value || 0;
      this.employee.obtainedLeaves = updatedLeaves.join(" / ");

      this.employee.leavesDeductionDays = e.target.value || Number(this.leaveDeductionInput);
      this.employee.recentUpdatedField = "leavesDeductionDays";
      this.syncToEmployee();
      this.isLeaveDeductionManuallyUpdated = false;
    },
    updateLateSalaryDeductionDays: function updateLateSalaryDeductionDays(e) {
      var manualInput = e && e.target.value;

      if (e && manualInput) {
        this.isLateDeductionManuallyUpdated = true;
        this.manualLateDeductionInput = manualInput;
        this.lateDeductionDays = Number(manualInput);
        this.employee.lateDeductionDays = this.lateDeductionDays;
      } else {
        this.isLateDeductionManuallyUpdated = false;
        this.lateDeductionDays = this.calculatedLateSalaryDeductionDays;
      }
      this.syncToEmployee();
    },
    updateWorkingDays: function updateWorkingDays() {
      var daysWorked = Number(this.daysWorkedInput) || 0;
      this.employee.daysWorked = daysWorked;

      this.recalculateAbsents(); // Updated to use shared method
      this.isAbsentsUpdatedByUser = true; // NEW: Set flag for user-triggered change

      this.syncToEmployee();
    },
    syncToEmployee: function syncToEmployee() {
      var obtLeaves = this.employee.obtainedLeaves;
      var updated = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.employee, {
        requiredWorkingDays: Number(this.requiredWorkingDaysInput),
        daysWorked: Number(this.daysWorkedInput),
        obtainedLeaves: obtLeaves && obtLeaves || this.leavesTakenInput + ' / ' + this.leaveBalance,
        leavesTaken: obtLeaves && obtLeaves.split(" / ")[0] || this.leavesTakenInput || 0,
        absents: Number(this.absentsInput),
        lateArrivals: Number(this.lateArrivalsInput),
        leaveDeductionDays: Number(this.leaveDeductionInput),
        // lateDeduction: `${Number(this.lateDeductionInput)} - ${this.lateArrivalsInput}`,
        lateDeductionDays: Number(this.lateDeductionDays),
        totalLatesCount: Number(this.totalLatesCount),
        manualLeaveDeductionDays: Number(this.manualLeaveDeduction),
        leaveDeductionNote: this.leaveDeductionNote || "",
        absentDays: this.absentDays || this.employee.absentDays || {}
      });
      this.$emit("update-attendance", updated); // emit updated employee data
    },
    roundToHalf: function roundToHalf(value) {
      return Math.round(value * 2) / 2;
    },
    calculatedAbsents: function calculatedAbsents() {
      var daysWorked = Number(this.selectedEmployee.daysWorked) || 0;
      var leavesTaken = this.leavesTaken;
      var requiredDays = this.requiredWorkingDays;

      var calculated = requiredDays - daysWorked - leavesTaken;
      return Math.max(0, calculated);
    },
    calculateDefaultLeaveDeduction: function calculateDefaultLeaveDeduction() {
      var lates = parseInt(this.lateArrivalsInput) || 0;
      var leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      var leavesAllowed = this.getLeavesAllowed() || 0;
      var leavesBalance = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);

      var rule = leavesBalance >= 2 ? __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["m" /* lateRules */].find(function (rule) {
        return lates >= rule.minLates;
      }) || { leaveDeductionDays: 0 } : __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["n" /* deductionRules */].find(function (rule) {
        return lates >= rule.minLates;
      });

      if (rule) {
        if (leavesBalance >= 2) {
          return this.roundToHalf(Math.min(rule.leaveDeductionDays, leavesBalance, 2));
        } else {
          var rangeKey = leavesBalance < 1 ? '<1' : '>=1,<2';
          return this.roundToHalf(Math.min(rule.leaveDeduction[rangeKey], leavesBalance));
        }
      }
      return 0;
    },
    calculateDefaultLateDeduction: function calculateDefaultLateDeduction() {
      var lates = parseInt(this.lateArrivalsInput) || 0;
      var leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      var leavesAllowed = this.getLeavesAllowed() || 0;
      var leavesBalance = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);

      var rule = leavesBalance >= 2 ? __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["m" /* lateRules */].find(function (rule) {
        return lates >= rule.minLates;
      }) || { lateDeductionDays: 0 } : __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["n" /* deductionRules */].find(function (rule) {
        return lates >= rule.minLates;
      });

      if (rule) {
        if (leavesBalance >= 2) {
          return rule.lateDeductionDays;
        } else {
          var rangeKey = leavesBalance < 1 ? '<1' : '>=1,<2';
          return rule.lateDeduction[rangeKey];
        }
      }
      return 0;
    },
    showAbsentInfo: function showAbsentInfo() {
      this.isAbsentInfoVisible = true;
    },
    hideAbsentInfo: function hideAbsentInfo() {
      this.isAbsentInfoVisible = false;
    },
    showLeavesInfo: function showLeavesInfo() {
      this.isleaveInfoVisible = true;
    },
    hideLeavesInfo: function hideLeavesInfo() {
      this.isleaveInfoVisible = false;
    },
    showDaysWorkedInfo: function showDaysWorkedInfo() {
      this.isDaysWorkedVisible = true;
    },
    hideDaysWorkedInfo: function hideDaysWorkedInfo() {
      this.isDaysWorkedVisible = false;
    },
    showWorkingDaysInfo: function showWorkingDaysInfo() {
      this.isWorkingDaysVisible = true;
    },
    hideWorkingDaysInfo: function hideWorkingDaysInfo() {
      this.isWorkingDaysVisible = false;
    },
    formattedAbsentsDetails: function formattedAbsentsDetails() {
      var halfDayCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var employee = this.employee || {};
      var absents = halfDayCount ? employee.remainingHalfDays : employee.lowHoursDays || {};
      var formattedDetails = [];

      var monthNum = String(__WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["c" /* monthMap */][employee.month]).padStart(2, '0') || '00'; // Convert 'April' → '04'

      for (var date in absents) {
        if (absents.hasOwnProperty(date)) {
          var decimalHours = absents[date];
          var hours = Math.floor(decimalHours);
          var minutes = Math.round((decimalHours - hours) * 60);
          formattedDetails.push(date + '-' + monthNum + '-' + employee.year + ': ' + hours + ' hrs & ' + minutes + ' mins');
        }
      }

      if (halfDayCount) {
        this.employee.remainingHalfDays = absents;
      } else {
        this.employee.lowHoursDays = absents;
      }
      this.syncToEmployee();
      return formattedDetails;
    },
    formattedAbsentsDaysDetails: function formattedAbsentsDaysDetails() {
      var employee = this.employee || {};
      var isResigned = employee.employeeStatus && employee.employeeStatus.toLowerCase() === 'resigned';
      var absents = (isResigned ? this.resignedAbsentDays : employee.absentDays) || {};

      var monthNum = String(__WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["c" /* monthMap */][employee.month] || 0).padStart(2, '0');
      var year = Number(employee.year);
      if (!monthNum || !year) return [];

      // The count comes from recalculateAbsents(): requiredDays - daysWorked -
      // leavesTaken. Derive the dates from those same inputs so the list and the
      // count always agree, instead of dumping whatever sparse keys the store
      // happened to write into `absentDays`.
      var dayOf = function dayOf(value) {
        return Number(String(value).split(':')[0].trim().split('-')[0]);
      };

      // Anything the employee recorded time for was attended, not absent.
      var attendedDays = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(employee.normalHoursDays || {})), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(employee.lowHoursDays || {})), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(employee.halfDays || {})), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(employee.remainingHalfDays || {}))).map(Number).filter(Boolean));

      // Public holidays are credited as worked days, so they are never absent.
      (employee.eligibleHolidayDetails || []).forEach(function (item) {
        var day = dayOf(item);
        if (day) attendedDays.add(day);
      });
      (this.holidaysList || []).forEach(function (item) {
        var day = dayOf(item);
        if (day) attendedDays.add(day);
      });

      // Approved leave days are not absences either.
      (this.calculatedLeaves || []).forEach(function (dateStr) {
        var day = dayOf(dateStr);
        if (day) attendedDays.add(day);
      });

      var workingDays = (employee.workingDays || ["monday", "tuesday", "wednesday", "thursday", "friday"]).map(function (day) {
        return day.toLowerCase();
      });
      var daysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["q" /* getTotalDaysInMonth */])(employee.month, employee.year) || 0;
      var lastWorkingDate = isResigned && employee.lastWorkingDate ? new Date(employee.lastWorkingDate) : null;

      var formattedDetails = [];
      for (var day = 1; day <= daysInMonth; day++) {
        var dateObj = new Date(year, monthNum - 1, day);
        var dayName = dateObj.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
        if (!workingDays.includes(dayName)) continue;
        if (lastWorkingDate && dateObj > lastWorkingDate) continue;
        if (attendedDays.has(day)) continue;

        formattedDetails.push(String(day).padStart(2, '0') + '-' + monthNum + '-' + year + ': Off');
      }

      this.absentDays = absents;
      this.employee.absentDays = absents;
      this.syncToEmployee();
      return formattedDetails;
    },
    getMissingWorkingDays: function getMissingWorkingDays(employee) {
      var monthInput = employee.month;
      var year = employee.year || new Date().getFullYear();

      var month = typeof monthInput === "string" ? new Date(monthInput + ' 1, ' + year).getMonth() + 1 : monthInput;
      var workedDays = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(employee.normalHoursDays).map(Number);
      var holidayDays = (employee.eligibleHolidayDetails || []).map(function (item) {
        var _item$split = item.split(":"),
            _item$split2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_item$split, 1),
            date = _item$split2[0];

        return Number(date.split("-")[0]);
      });

      // Use the employee's actual schedule rather than assuming Sat/Sun, so a
      // Mon-Sat employee is not reported absent on a day they are required to work.
      var workingDays = (employee.workingDays || ["monday", "tuesday", "wednesday", "thursday", "friday"]).map(function (d) {
        return d.toLowerCase();
      });

      var daysInMonth = new Date(year, month, 0).getDate();
      var missingDays = {};

      for (var day = 1; day <= daysInMonth; day++) {
        var date = new Date(year, month - 1, day);
        var weekDayName = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

        var isNonWorkingDay = !workingDays.includes(weekDayName);
        var isWorked = workedDays.includes(day);
        var isHoliday = holidayDays.includes(day);

        if (!isNonWorkingDay && !isWorked && !isHoliday) {
          missingDays[day] = "Off";
        }
      }

      return missingDays;
    },
    formatPublicHolidays: function formatPublicHolidays() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var holidays, shift, year, monthName, isResigned, lastWorkingDate, workingDays, holidayMap, formattedList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].getAllHolidays();

              case 2:
                holidays = _context.sent;
                shift = (_this3.employee.shift || "Morning").toLowerCase();
                year = Number(_this3.employee.year);
                monthName = (_this3.employee.month || "").toLowerCase();
                isResigned = (_this3.employee.employeeStatus || "").toLowerCase() === 'resigned';
                lastWorkingDate = isResigned && _this3.employee.lastWorkingDate ? new Date(_this3.employee.lastWorkingDate) : null;
                workingDays = [];

                if (_this3.employee && Array.isArray(_this3.employee.workingDays) && _this3.employee.workingDays.length) {
                  workingDays = _this3.employee.workingDays.map(function (d) {
                    return d.toLowerCase();
                  });
                } else {
                  workingDays = ["monday", "tuesday", "wednesday", "thursday", "friday"];
                }

                holidayMap = {};


                holidays.forEach(function (h) {
                  var baseDate = new Date(h.dates);
                  var isRecurring = !!h.isRecurring;
                  var count = h.numberOfDays || 1;

                  var hShift = (h.shift || "general").toLowerCase();

                  if (!(shift === "general" || hShift === "general" || hShift === shift)) {
                    return;
                  }

                  var startDate = new Date(isRecurring ? year : baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());

                  for (var i = 0; i < count; i++) {
                    var d = new Date(startDate);
                    d.setDate(startDate.getDate() + i);

                    if (lastWorkingDate && d > lastWorkingDate) continue;

                    var dayName = d.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();

                    if (!workingDays.includes(dayName)) continue;

                    var dMonthName = d.toLocaleString("default", { month: "long" }).toLowerCase();

                    if (monthName && dMonthName !== monthName) continue;

                    var dd = ("0" + d.getDate()).slice(-2);
                    var mm = ("0" + (d.getMonth() + 1)).slice(-2);
                    var yyyy = d.getFullYear();

                    var dateKey = dd + '-' + mm + '-' + yyyy;
                    if (!holidayMap[dateKey]) {
                      holidayMap[dateKey] = {
                        names: [],
                        dateObj: d
                      };
                    }
                    holidayMap[dateKey].names.push(h.name);
                  }
                });

                formattedList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(holidayMap).map(function (date) {
                  return {
                    text: date + ': ' + holidayMap[date].names.join(", "),
                    dateObj: holidayMap[date].dateObj
                  };
                });

                formattedList.sort(function (a, b) {
                  return a.dateObj - b.dateObj;
                });

                return _context.abrupt('return', formattedList.map(function (i) {
                  return i.text;
                }));

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    formattedNormalDaysWorked: function formattedNormalDaysWorked() {
      var employee = this.employee || {};
      var normalDays = employee.normalDaysWorked || 0;
      this.employee.normalDaysWorked = normalDays;
      this.syncToEmployee();
      return normalDays;
    },
    formattedLeavesDetails: function formattedLeavesDetails() {
      var employee = this.employee || {};
      var leavesTaken = this.calculatedLeaves || [];

      if (!leavesTaken.length) {
        return [];
      }

      var formatted = [];

      var holidaySet = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a((this.holidaysList || []).map(function (h) {
        return h.split(':')[0].trim();
      }));
      var workingDays = (employee.workingDays || ["monday", "tuesday", "wednesday", "thursday", "friday"]).map(function (day) {
        return day.toLowerCase();
      });

      // `calculatedLeaves` is already a flat array of individual leave date
      // strings (getEmployeeApprovedLeaves expands each leave's start→end range
      // into individual dates). So we format each date on its own and must NOT
      // treat consecutive entries as a [start, end] range — doing so incorrectly
      // merged separate single-day leaves (e.g. 15th & 19th) into a 5-day range.
      for (var i = 0; i < leavesTaken.length; i++) {
        var dateStr = leavesTaken[i];
        if (!dateStr) continue;

        var _dateStr$split$map = dateStr.split('-').map(Number),
            _dateStr$split$map2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_dateStr$split$map, 3),
            d = _dateStr$split$map2[0],
            m = _dateStr$split$map2[1],
            y = _dateStr$split$map2[2];

        var dateObj = new Date(y, m - 1, d);
        var dayName = dateObj.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
        if (workingDays.includes(dayName) && !holidaySet.has(dateStr)) {
          formatted.push('Leave Taken: ' + dateStr);
        }
      }

      return formatted;
    },
    HalfDaysDetails: function HalfDaysDetails() {
      var employee = this.employee || {};

      var _ref = employee || {},
          halfDays = _ref.halfDays,
          month = _ref.month,
          year = _ref.year;

      if (!halfDays) return [];
      this.employee.halfDays = halfDays;
      this.syncToEmployee();
      var totalHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["r" /* formatDaysToDateArray */])(halfDays, year, month);
      return totalHours.map(function (date) {
        var _date$split = date.split("-"),
            _date$split2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
            day = _date$split2[0],
            month = _date$split2[1],
            year = _date$split2[2];

        return day + '-' + month + '-' + year;
      });
    },
    HalfDaysCount: function HalfDaysCount() {
      var employee = this.employee || {};

      var _ref2 = employee || {},
          totalHalfDayHours = _ref2.totalHalfDayHours,
          halfDays = _ref2.halfDays;

      if (!halfDays) return 0;
      var halfHourLen = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(halfDays).length || 0;
      this.employee.totalHalfDayHours = totalHalfDayHours;
      this.syncToEmployee();
      var data = {
        halfDaysCount: halfHourLen,
        totalHalfDayHours: Number(totalHalfDayHours) > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["s" /* formatDecimalHours */])(totalHalfDayHours) : 0
      };
      return data;
    },
    hasChanged: function hasChanged(field) {
      var employeeField = field.replace('Input', '');
      if (field === 'absentsInput') {
        return Number(this[field]) !== Number(this.initialValues[employeeField] || 0) && this.isAbsentsUpdatedByUser;
      }
      if (field === 'manualLateDeductionInput') {
        return this.isLateDeductionManuallyUpdated && this[field] !== (this.initialValues.lateDeductionDays || 0);
      }
      if (field === 'leaveDeductionInput') {
        return this.isLeaveDeductionManuallyUpdated && this[field] !== (this.initialValues.leavesDeductionDays || 0);
      }
      if (field === 'leaveDeductionNote') {
        return this.leaveDeductionNote !== (this.initialValues.leaveDeductionNote || '');
      }
      return Number(this[field]) !== Number(this.initialValues[employeeField] || 0);
    },
    getDaysInMonth: function getDaysInMonth() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["q" /* getTotalDaysInMonth */])(this.employee.month, this.employee.year);
    },
    getRequiredWorkingDays: function getRequiredWorkingDays() {
      return Number(this.requiredWorkingDaysInput) || 0;
    },
    getLeavesAllowed: function getLeavesAllowed() {
      return Number(this.employee.leavesAllowed) || 0;
    }
  },
  watch: {
    employee: {
      handler: function handler(newVal) {
        if (newVal.leavesDeductionDays !== undefined && newVal.leavesDeductionDays !== null && !this.isLeaveDeductionManuallyUpdated) {
          this.leaveDeductionInput = newVal.leavesDeductionDays;
        }
        if (newVal.lateDeductionDays !== undefined && newVal.lateDeductionDays !== null && !this.isLateDeductionManuallyUpdated) {
          this.manualLateDeductionInput = newVal.lateDeductionDays;
          this.lateDeductionDays = newVal.lateDeductionDays;
        }
        this.updateAttendanceData();
      },

      immediate: true,
      deep: true
    },
    leaveDeductionNote: function leaveDeductionNote(newVal) {
      this.employee.leaveDeductionNote = newVal;
      this.syncToEmployee();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref3, employeeId, month, year;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].getSingleUser(_this4.employee.employeeId);

            case 2:
              _this4.currentUser = _context2.sent;

              _this4.updateAttendanceData();

              // Load leaves and holidays independently: a failure in one must not wipe
              // out the other, since both feed the same "Monthly Leaves Details" tooltip.
              _ref3 = _this4.employee || {}, employeeId = _ref3.employeeId, month = _ref3.month, year = _ref3.year;
              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].getEmployeeApprovedLeaves(employeeId, month, year).catch(function (err) {
                console.error("Error loading approved leaves:", err);
                return [];
              });

            case 7:
              _this4.calculatedLeaves = _context2.sent;
              _context2.next = 10;
              return _this4.formatPublicHolidays().catch(function (err) {
                console.error("Error loading holidays:", err);
                return [];
              });

            case 10:
              _this4.holidaysList = _context2.sent;


              _this4.resignedAbsentDays = _this4.getMissingWorkingDays(_this4.employee);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    icon: String
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sV9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Performance_vue__ = __webpack_require__("no2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_firestore__ = __webpack_require__("881v");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  components: {
    Performance: __WEBPACK_IMPORTED_MODULE_3__Performance_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_4__UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    var user = this.$store.state.auth.user;
    return {
      selectedEmployeeTrelloUsername: "",
      isAdmin: user && user.role === "admin",
      loading: true,
      loadingTimeout: false,
      isTrelloConnected: false,
      trelloApiKey: "b18c7d4c2051c75660623c349bf3e65f"
    };
  },

  methods: {
    retryCheck: function retryCheck() {
      this.loading = true;
      this.loadingTimeout = false;
      this.checkForTrelloToken();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var hash = window.location.hash;
    var tokenMatch = hash.match(/(?:[?&]token=)([^&]+)/);

    if (tokenMatch && tokenMatch[1]) {
      var token = tokenMatch[1];
      localStorage.setItem('trello_token', token);

      window.history.replaceState({}, '', '/#/performance');
    }

    this.checkForTrelloToken();
    setTimeout(function () {
      if (_this.loading) _this.loadingTimeout = true;
    }, 5000);
  }
}, "methods", {
  checkForTrelloToken: function checkForTrelloToken() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var token, response, respondata;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.loading = true;
              token = localStorage.getItem('trello_token');

              if (token) {
                _context.next = 6;
                break;
              }

              _this2.isTrelloConnected = false;
              _this2.loading = false;
              return _context.abrupt("return");

            case 6:
              _this2.isTrelloConnected = true;
              _this2.loading = false;
              _context.prev = 8;
              _context.next = 11;
              return fetch("https://api.trello.com/1/tokens/" + token + "?key=" + _this2.trelloApiKey + "&fields=idMember");

            case 11:
              response = _context.sent;
              _context.next = 14;
              return response.json();

            case 14:
              respondata = _context.sent;

              if (response.ok) {
                _context.next = 17;
                break;
              }

              throw new Error('Invalid token');

            case 17:
              _context.next = 19;
              return _this2.validateTrelloToken(token);

            case 19:
              _this2.isTrelloConnected = true;
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](8);

              localStorage.removeItem('trello_token');
              _this2.isTrelloConnected = false;

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[8, 22]]);
    }))();
  },
  validateTrelloToken: function validateTrelloToken(token) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response, userData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch("https://api.trello.com/1/members/me?key=" + _this3.trelloApiKey + "&token=" + token);

            case 3:
              response = _context2.sent;

              if (!response.ok) {
                _context2.next = 13;
                break;
              }

              _context2.next = 7;
              return response.json();

            case 7:
              userData = _context2.sent;
              _context2.next = 10;
              return _this3.storeTrelloUserInFirebase(userData, token);

            case 10:
              _this3.isTrelloConnected = true;
              _context2.next = 16;
              break;

            case 13:
              localStorage.removeItem("trello_token");
              _this3.isTrelloConnected = false;
              throw new Error("Invalid Trello token");

            case 16:
              _context2.next = 24;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](0);

              console.error("Error validating Trello token:", _context2.t0);
              localStorage.removeItem("trello_token");
              _this3.isTrelloConnected = false;
              throw _context2.t0;

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[0, 18]]);
    }))();
  },
  storeTrelloUserInFirebase: function storeTrelloUserInFirebase(userData) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var username, userId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              username = userData.username || "";
              userId = _this4.$store.state.auth.user.uid;
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_5__assets_config_firebase__["a" /* default */].saveTrelloUser(userId, username);

            case 5:
              _this4.selectedEmployeeTrelloUsername = username;
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.error("Error saving Trello username:", _context3.t0);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4, [[0, 8]]);
    }))();
  },
  loginWithTrello: function loginWithTrello() {
    var baseUrl = window.location.origin;
    var redirectUrl = baseUrl + "/#/performance?auth=trello";

    var authUrl = "https://trello.com/1/authorize?expiration=never&scope=read&response_type=token&key=" + this.trelloApiKey + "&return_url=" + encodeURIComponent(redirectUrl);

    window.location.href = authUrl;
  },
  handleLogout: function handleLogout() {
    localStorage.removeItem('trello_token');
    this.isTrelloConnected = false;
    this.selectedEmployeeTrelloUsername = "";
  }
}));

/***/ }),

/***/ "scDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_assets_config_constants_js__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_data_banks_json__ = __webpack_require__("k4ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_data_banks_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_src_components_data_banks_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UIComponents_CustomDropdown_vue__ = __webpack_require__("PzTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UIComponents_GradeDropdown_vue__ = __webpack_require__("0AJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Status_vue__ = __webpack_require__("avKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_assets_icons_PencilIcon_js__ = __webpack_require__("ZHTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_activeInactiveUser_js__ = __webpack_require__("nzxg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__UIComponents_EmployeeDropdown_vue__ = __webpack_require__("gd4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Dashboard_Views_UserProfile_ProfileData_js__ = __webpack_require__("JiyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_config_constants_js__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__GoogleCalender_MeetingModal_vue__ = __webpack_require__("iaJ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__ = __webpack_require__("OsJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__ = __webpack_require__("l527");










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// import { designations, designationGrades } from '../dashboard/views/UserProfile/ProfileData.js'; 







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    CustomTable: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_ReuseableModal_vue__["a" /* default */],
    CustomDropdown: __WEBPACK_IMPORTED_MODULE_17__UIComponents_CustomDropdown_vue__["a" /* default */],
    GradeDropdown: __WEBPACK_IMPORTED_MODULE_18__UIComponents_GradeDropdown_vue__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_19__Status_vue__["a" /* default */],
    PencilIcon: __WEBPACK_IMPORTED_MODULE_20_src_assets_icons_PencilIcon_js__["a" /* default */],
    EmployeeDropdown: __WEBPACK_IMPORTED_MODULE_22__UIComponents_EmployeeDropdown_vue__["a" /* default */],
    MeetingModal: __WEBPACK_IMPORTED_MODULE_26__GoogleCalender_MeetingModal_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    var store = this.$store;
    if (store.state.constants && store.state.constants.constant) {
      this.plan = store.state.constants.constant.plan || "premium";
      this.usersAllow = store.state.constants.constant.usersAllow || 10;
    } else {
      this.plan = "premium";
      this.usersAllow = 10;
    }
    this.items = store.state.auth && store.state.auth.allUsers ? store.state.auth.allUsers : [];
    store.commit("loadingStarts");
    if (this.items.length) {
      store.commit("loadingEnds");
    }
    if (store.getters && store.getters.allUsers) {
      store.watch(store.getters.allUsers, function (allUsers) {
        _this.items = store.state.auth && store.state.auth.allUsers ? store.state.auth.allUsers : [];
        store.commit("loadingEnds");
      });
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      noteType: 'regular',
      existingNotes: [],

      currentSalary: '',
      newBasicSalary: '',
      newExtraAllowance: '',
      effectiveDate: '',

      noteContent: '',
      isNotesModalOpen: false,
      isNotesEmailPreviewModalOpen: false,
      isStatusChangeModalOpen: false,
      isSubmitting: false,
      selectedEmployee: {},
      oldStatus: "",
      newStatus: "",
      templates: [],
      selectedTemplate: {},
      subject: "",
      emailBody: "",
      ccRecipients: [],
      terminationDate: "",
      resignationApprovalDate: Date.now(),
      lastWorkingDate: Date.now() + 30 * 24 * 60 * 60 * 1000,
      errors: {
        ccRecipients: "",
        subject: "",
        emailBody: "",
        resignationApprovalDate: "",
        terminationDate: ""
      },
      notesErrors: {
        currentSalary: "",
        newBasicSalary: "",
        newExtraAllowance: "",
        effectiveDate: "",
        noteContent: ""
      },
      showModal: false,
      isMeetingConfirmModalOpen: false,
      meetingType: "",
      selectedMeeting: null,
      meetings: [],
      loadings: { saveMeeting: false, deleteMeeting: false, deletingNote: false },
      filteredUsers: [],
      company: this.$store.state.auth.company,
      currentUser: this.$store.state.auth.user,
      isLoading: false,
      nameError: "",
      emailError: "",
      isAdmin: false,
      searchTerm: "",
      max25chars: function max25chars(v) {
        return v.length <= 25 || "Input too long!";
      },
      dialog: false,
      tmp: "",
      search: "",
      email: "",
      name: "",
      designation: "",
      grade: "",
      designations: __WEBPACK_IMPORTED_MODULE_23__Dashboard_Views_UserProfile_ProfileData_js__["a" /* designations */],
      designationGrades: __WEBPACK_IMPORTED_MODULE_23__Dashboard_Views_UserProfile_ProfileData_js__["b" /* designationGrades */],
      pagination: {},
      items: [],
      plan: "premium",
      usersAllow: 10,
      allusers: 0,
      isDeleteModalOpen: false,
      isEmployeeModalOpen: false,
      banks: __WEBPACK_IMPORTED_MODULE_16_src_components_data_banks_json___default.a.banks,
      isEdit: false,
      editUserId: "",
      selectedUser: null,
      isAddingEmployee: false,
      activeOptions: ['Active', 'InActive'], // Options for Active column
      roleOptions: ['admin', 'user'],
      promotionText: "",
      isSalaryPromotion: false
    }, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "newBasicSalary", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "newExtraAllowance", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "promotionEditIndex", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "selectedPromotionUser", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "isPromotionModalOpen", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "isDeletePromotionModalOpen", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "promotionToDelete", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "shift", "Morning"), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "shiftOptions", ["Morning", "Night"]), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "shiftError", ""), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "lastWorkingDateManuallySet", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "tableColumns", [{ label: "Avatar", key: "profile_picture", sticky: "left", width: 70 }, { label: "Name", key: "username", sticky: "left", sortable: true, width: 140 }, { label: "Designation", key: "designation", sortable: true, width: 180 }, { label: "Grade", key: "grade", sortable: true, width: 70 }, { label: "Shift", key: "shift", sortable: true, width: 100 }, { label: "Company Email", key: "email", sortable: true, width: 250 }, { label: "Personal Email", key: "personalEmail", sortable: true, width: 220 }, { label: "Date of Birth", key: "dateOfBirth", sortable: true, width: 180 }, { label: "Joining Date", key: "joiningDate", sortable: true, width: 180 }, { label: "Bank Name", key: "bankName", sortable: true, width: 180 }, { label: "IBAN", key: "iban", sortable: true, width: 180 }, { label: "Nationality", key: "nationality", sortable: true, width: 200 }, { label: "Marital Status", key: "maritalStatus", sortable: true, width: 180 }, { label: "Phone Number", key: "phoneNumber", sortable: true, width: 180 }, { label: "Current Address", key: "currentAddress", sortable: true, width: 180 }, { label: "Permanent Address", key: "permanentAddress", sortable: true, width: 180 }, { label: "Relative Name", key: "emergencyContactName", sortable: true, width: 180 }, { label: "Relative Number", key: "emergencyContactNumber", sortable: true, width: 180 }, { label: "CNIC Image", key: "nicImageUrl", width: 130 }, { label: "Experience letter", key: "certificateUrl", width: 130 }, { label: "Salary Slip", key: "salarySlipUrl", width: 130 }, { label: "Active", key: "active", width: 180 }, { label: "Status", key: "status", width: 180 }, { label: "Notes", key: "promotionInfo", width: 250 }, { label: "Next Quarterly Meeting", key: "nextQuarterlyMeeting", width: 200 }, { label: "Next Increment Review Meeting", key: "nextIncrementReview", width: 200 }, { label: "Resigned", key: "resignationDate", width: 200 }, { label: "Last Working Date", key: "lastWorkingDate", width: 200 }, { label: "Duration Spent", key: "durationSpent", width: 200 }, { label: "Admin", key: "role", width: 180 }, { label: "Action", key: "action", sticky: "right", width: 100 }]), _ref;
  },

  computed: {
    companyEmployees: function companyEmployees() {
      var _this2 = this;

      var companyUserIds = this.$store.state.auth.company.users.map(function (user) {
        return user.uid;
      });

      return this.$store.state.auth.allUsers.filter(function (u) {
        return companyUserIds.includes(u.uid) && u.uid !== _this2.selectedEmployee.uid && u.isActive;
      });
    },
    loading: function loading() {
      return this.$store.state.loading || false;
    },
    filteredUsers: function filteredUsers() {
      var _this3 = this;

      var company = this.$store.state.auth.company;
      var companyUserIds = company.users.map(function (user) {
        return user.uid;
      });
      var allUsers = this.$store.state.auth.allUsers.filter(function (user) {
        return companyUserIds.includes(user.uid);
      });
      if (this.searchTerm) {
        return allUsers.filter(function (user) {
          var name = user.username ? user.username.toLowerCase() : "";
          var email = user.email ? user.email.toLowerCase() : "";
          var searchTerm = _this3.searchTerm.toLowerCase();
          return name.includes(searchTerm) || email.includes(searchTerm);
        });
      }
      return allUsers;
    },
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      return this.$store.state.auth.user.role === "admin";
    }
  },
  watch: {
    lastWorkingDate: function lastWorkingDate(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.lastWorkingDateManuallySet = true;
      }
      this.updateEmailBodyDates();
    },
    resignationApprovalDate: function resignationApprovalDate(newDate) {
      if (!newDate) {
        this.lastWorkingDate = "";
        this.lastWorkingDateManuallySet = false;
        this.updateEmailBodyDates();
        return;
      }

      if (!this.lastWorkingDateManuallySet && this.newStatus === 'Resigned') {
        var date = new Date(newDate);
        var noticePeriod = this.oldStatus === "Probation" ? 15 : 30;
        date.setDate(date.getDate() + noticePeriod);
        this.lastWorkingDate = date.toISOString().split("T")[0];
      }

      this.updateEmailBodyDates();
    },
    terminationDate: function terminationDate(newVal) {
      if (this.newStatus === 'Terminated' && newVal) {
        this.lastWorkingDate = newVal;
        this.lastWorkingDateManuallySet = true;
        this.updateEmailBodyDates();
      }
    },
    newStatus: function newStatus(newVal) {
      if (newVal === 'Terminated' && this.terminationDate) {
        this.lastWorkingDate = this.terminationDate;
        this.lastWorkingDateManuallySet = true;
        this.updateEmailBodyDates();
      }
    },
    isStatusChangeModalOpen: function isStatusChangeModalOpen(isOpen) {
      var _this4 = this;

      if (!isOpen) {
        this.resetStatusChangeState();
        return;
      }

      var today = this.getTodayDate();

      if (this.newStatus === "Resigned") {
        this.resignationApprovalDate = today;
        this.lastWorkingDateManuallySet = false;
      }

      if (this.newStatus === "Terminated") {
        this.terminationDate = today;
        this.lastWorkingDate = today;
        this.lastWorkingDateManuallySet = true;
      }

      var values = this.getTemplateValues({
        employee: this.selectedEmployee,
        newStatus: this.newStatus,
        oldStatus: this.oldStatus
      });

      this.subject = this.replacePlaceholders(this.selectedTemplate.subject, values);

      this.emailBody = this.replacePlaceholders(this.selectedTemplate.body, values);
      this.$nextTick(function () {
        _this4.updateEmailBodyDates();
      });
    },
    isNotesModalOpen: function isNotesModalOpen(isOpen) {
      var _this5 = this;

      if (!isOpen && !this.isNotesEmailPreviewModalOpen) {
        this.resetNoteState();
      }
      if (isOpen) {
        this.$nextTick(function () {
          var lastNote = _this5.$refs.lastNote;
          var el = Array.isArray(lastNote) ? lastNote[lastNote.length - 1] : lastNote;
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    },
    isNotesEmailPreviewModalOpen: function isNotesEmailPreviewModalOpen(isOpen) {
      if (!isOpen) {
        this.resetNoteState();
      }
    }
  },
  mounted: function mounted() {
    this.fetchEmailTemplates();
  },

  methods: {
    deleteNote: function deleteNote() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _promotionToDelete, index, note, title, isIncrement, description;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this6.loadings.deletingNote) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this6.loadings.deletingNote = true;
                _promotionToDelete = _this6.promotionToDelete, index = _promotionToDelete.index, note = _promotionToDelete.note;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].deletePromotionInfo(_this6.selectedEmployee.uid, index);

              case 7:
                title = _this6.currentUser.username + " deleted a note for " + _this6.selectedEmployee.username;
                isIncrement = note.isSalaryPromotion;
                description = _this6.currentUser.email + " deleted a note from " + _this6.selectedEmployee.username + "'s profile.\n\nNote Details:\n- Text: \"" + note.text + "\"\n- Type: " + (isIncrement ? 'Salary Increment' : 'Regular Note') + "\n" + (isIncrement ? "- Effective Date: " + (note.effectiveDate || _this6.formatDate(note.createdAt)) : '') + "\n" + (isIncrement ? "- Old Salary: " + note.oldSalary.toLocaleString('en-PK') : '') + "\n" + (isIncrement ? "- New Salary: " + (note.newBasicSalary + note.newExtraAllowance).toLocaleString('en-PK') : '') + "\n" + (isIncrement ? "- Increment: " + note.increment.toLocaleString('en-PK') + " (" + note.percentage + "%)" : '');
                _context.next = 12;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this6.currentUser,
                  title: title,
                  description: description,
                  username: _this6.selectedEmployee.username,
                  type: "delete_note",
                  uid: _this6.selectedEmployee.uid
                }));

              case 12:

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Deleted", "Note has been deleted successfully", "success");
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);

                console.error("Error deleting promotion info:", _context.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Oops!", "Failed to delete note", "error");

              case 19:
                _context.prev = 19;

                _this6.loadings.deletingNote = false;
                _this6.isDeletePromotionModalOpen = false;
                _this6.selectedEmployee.promotionInfo.splice(index, 1);
                return _context.finish(19);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6, [[4, 15, 19, 24]]);
      }))();
    },
    resolveTemplateVariables: function resolveTemplateVariables(text) {
      if (!text) return '';

      var emp = this.selectedEmployee;
      var now = new Date();

      var variables = {
        '[Employee Name]': emp.username || '',
        '[Effective Date]': this.effectiveDate || '',
        '[Current Time]': now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }),
        '[Current Date]': now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
        '[Old Salary]': "PKR " + this.currentSalary.toLocaleString('en-PK') || '',
        '[New Salary]': "PKR " + (Number(this.newBasicSalary) + Number(this.newExtraAllowance)).toLocaleString('en-PK') || '',
        '[Increment Amount]': "PKR " + (Number(this.newBasicSalary) + Number(this.newExtraAllowance) - Number(this.currentSalary)).toLocaleString('en-PK') || '',
        '[Increment Percentage]': this.calculatePercentage() || '',
        '[Note Text]': this.noteContent || '',
        '[Admin Name]': this.currentUser.username || ''
      };

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(variables).reduce(function (result, _ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            placeholder = _ref3[0],
            value = _ref3[1];

        return result.replaceAll(placeholder, value);
      }, text);
    },
    resetNoteState: function resetNoteState() {
      this.noteType = 'regular';
      this.currentSalary = '';
      this.newBasicSalary = '';
      this.newExtraAllowance = '';
      this.effectiveDate = '';
      this.noteContent = '';
      this.ccRecipients = [];
      this.subject = '';
      this.emailBody = '';
      this.selectedTemplate = {};
      this.notesErrors = {
        currentSalary: "",
        newBasicSalary: "",
        newExtraAllowance: "",
        effectiveDate: "",
        noteContent: ""
      };
    },
    submitNote: function submitNote() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var statusForTemplate, payload, formData, title, isIncrement, description, response;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this7.noteType === 'increment')) {
                  _context2.next = 25;
                  break;
                }

                if (_this7.currentSalary) {
                  _context2.next = 6;
                  break;
                }

                _this7.notesErrors.currentSalary = "Current salary is required.";
                return _context2.abrupt("return");

              case 6:
                _this7.notesErrors.currentSalary = "";

              case 7:
                if (_this7.newBasicSalary) {
                  _context2.next = 12;
                  break;
                }

                _this7.notesErrors.newBasicSalary = "New basic salary is required.";
                return _context2.abrupt("return");

              case 12:
                _this7.notesErrors.newBasicSalary = "";

              case 13:
                if (_this7.newExtraAllowance) {
                  _context2.next = 18;
                  break;
                }

                _this7.notesErrors.newExtraAllowance = "New extra allowance is required.";
                return _context2.abrupt("return");

              case 18:
                _this7.notesErrors.newExtraAllowance = "";

              case 19:
                if (_this7.effectiveDate) {
                  _context2.next = 24;
                  break;
                }

                _this7.notesErrors.effectiveDate = "Effective date is required.";
                return _context2.abrupt("return");

              case 24:
                _this7.notesErrors.effectiveDate = "";

              case 25:
                if (_this7.isNotesEmailPreviewModalOpen) {
                  _context2.next = 40;
                  break;
                }

                _this7.isNotesEmailPreviewModalOpen = true;
                _this7.preselectAdminsForCC();
                _this7.isNotesModalOpen = false;

                statusForTemplate = _this7.noteType === 'increment' ? 'Increase' : 'Note';


                _this7.selectedTemplate = _this7.templates.find(function (t) {
                  return t.title.includes(statusForTemplate);
                });

                if (_this7.selectedTemplate) {
                  _context2.next = 37;
                  break;
                }

                _this7.subject = "";
                _this7.emailBody = "";
                return _context2.abrupt("return");

              case 37:
                _this7.subject = _this7.selectedTemplate.subject.replace('[Employee Name]', _this7.selectedEmployee.username);
                _this7.emailBody = _this7.resolveTemplateVariables(_this7.selectedTemplate.body);

              case 39:
                return _context2.abrupt("return");

              case 40:
                if (_this7.validateStatusChangeForm()) {
                  _context2.next = 43;
                  break;
                }

                console.log("Form validation failed", _this7.errors);
                return _context2.abrupt("return");

              case 43:
                payload = {
                  userId: _this7.selectedEmployee.uid,
                  type: _this7.noteType,
                  text: _this7.noteContent
                };

                if (_this7.noteType === 'increment') {
                  payload.oldSalary = _this7.currentSalary;
                  payload.newBasicSalary = Number(_this7.newBasicSalary);
                  payload.newExtraAllowance = Number(_this7.newExtraAllowance);
                  payload.increment = payload.newBasicSalary + payload.newExtraAllowance - payload.oldSalary;
                  payload.percentage = _this7.calculatePercentage();
                  payload.effectiveDate = _this7.effectiveDate;
                }
                formData = {
                  to: _this7.selectedEmployee.email,
                  subject: _this7.subject,
                  message: _this7.emailBody,
                  cc: _this7.ccRecipients
                };


                _this7.isSubmitting = true;
                _context2.next = 49;
                return _this7.savePromotion(payload);

              case 49:
                title = _this7.currentUser.username + " added a note for " + _this7.selectedEmployee.username;
                isIncrement = payload.type === 'increment';
                description = _this7.currentUser.email + " added a note on " + _this7.selectedEmployee.username + "'s profile.\n\nNote Details:\n- Text: \"" + payload.text + "\"\n- Type: " + (isIncrement ? 'Salary Increment' : 'Regular Note') + "\n" + (isIncrement ? "- Effective Date: " + payload.effectiveDate : '') + "\n" + (isIncrement ? "- Old Salary: " + payload.oldSalary.toLocaleString('en-PK') : '') + "\n" + (isIncrement ? "- New Salary: " + (payload.newBasicSalary + payload.newExtraAllowance).toLocaleString('en-PK') : '') + "\n" + (isIncrement ? "- Increment: " + payload.increment.toLocaleString('en-PK') + " (" + payload.percentage + "%)" : '');
                _context2.next = 54;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this7.currentUser,
                  title: title,
                  description: description,
                  username: _this7.selectedEmployee.username,
                  type: "create_note",
                  uid: _this7.selectedEmployee.uid
                }));

              case 54:
                _context2.prev = 54;
                _context2.next = 57;
                return fetch(__WEBPACK_IMPORTED_MODULE_11_src_assets_config_constants_js__["o" /* default */].serverURL + "/company/change-status", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(formData)
                }).catch(function (error) {
                  console.error("Fetch error:", error);
                  throw new Error("Failed to connect to server at " + serverURL + ". Please ensure the backend server is running and accessible.");
                });

              case 57:
                response = _context2.sent;

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Note updated and email sent successfully", "success");
                _context2.next = 65;
                break;

              case 61:
                _context2.prev = 61;
                _context2.t0 = _context2["catch"](54);

                console.error("Error updating status:", _context2.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to update status", "error");

              case 65:
                _context2.prev = 65;

                _this7.isSubmitting = false;
                _this7.isNotesEmailPreviewModalOpen = false;
                _this7.resetNoteState();
                return _context2.finish(65);

              case 70:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[54, 61, 65, 70]]);
      }))();
    },
    calculatePercentage: function calculatePercentage() {
      if (!this.currentSalary || !this.newBasicSalary || !this.newExtraAllowance) return 0;
      return ((Number(this.newBasicSalary) + Number(this.newExtraAllowance) - Number(this.currentSalary)) / Number(this.currentSalary) * 100).toFixed(2);
    },
    updateEmailBodyDates: function updateEmailBodyDates() {
      if (!this.emailBody) return;

      var format = function format(dateStr) {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-GB');
      };

      var approval = format(this.resignationApprovalDate);
      var termination = format(this.terminationDate);
      var lastWorking = format(this.lastWorkingDate);

      var noticeDays = this.newStatus === 'Resigned' ? this.noticePeriodDays() : 0;
      var baseStatus = this.oldStatus || 'Permanent';
      var noticeLine = "Notice Period: " + noticeDays + " days (based on " + baseStatus + " status)";

      var body = this.emailBody;
      body = body.replace(/^Resignation Approval Date:.*$/im, '').replace(/^Last Working Date:.*$/im, '').replace(/^Notice Period:.*$/im, '').replace(/^Termination Date:.*$/im, '').replace(/\[(Approval Date|Termination Date|Last Working Date|Current Date):[^\]]*\][\s\r\n]*/gi, '').replace(/\n{3,}/g, '\n\n').trim();

      if (this.newStatus === 'Resigned') {
        if (/Notice Period:/i.test(body)) {
          body = body.replace(/Notice Period:[^\n\r]*/i, noticeLine);
        } else if (/New Status:\s*Resigned/i.test(body)) {
          body = body.replace(/(New Status:\s*Resigned[^\n]*\n?)/i, "$1" + noticeLine + "\n");
        } else if (noticeDays > 0) {
          if (/New Status:\s*Resigned/i.test(body)) {
            body = body.replace(/(New Status:\s*Resigned[^\n]*)/i, "$1\n" + noticeLine);
          } else {
            body += "\n" + noticeLine;
          }
        }

        if (approval) {
          if (/Resignation Approval Date:/i.test(body)) {
            body = body.replace(/Resignation Approval Date:[^\n\r]*/i, "Resignation Approval Date: " + approval);
          } else {
            if (/New Status:/i.test(body)) {
              body = body.replace(/(New Status:[^\n]*)/i, "$1\nResignation Approval Date: " + approval);
            } else {
              body += "\nResignation Approval Date: " + approval;
            }
          }
        }

        if (lastWorking) {
          if (/Last Working Date:/i.test(body)) {
            body = body.replace(/Last Working Date:[^\n\r]*/i, "Last Working Date: " + lastWorking);
          } else {
            if (/Resignation Approval Date:/i.test(body)) {
              body = body.replace(/(Resignation Approval Date:[^\n]*)/i, "$1\nLast Working Date: " + lastWorking);
            } else if (/Notice Period:/i.test(body)) {
              body = body.replace(/(Notice Period:[^\n]*)/i, "$1\nLast Working Date: " + lastWorking);
            } else {
              body += "\nLast Working Date: " + lastWorking;
            }
          }
        }
      }

      if (this.newStatus === 'Terminated' && termination) {
        var theDate = termination;

        if (/Termination Date:/i.test(body)) {
          body = body.replace(/Termination Date:[^\n\r]*/i, "Termination Date: " + theDate);
        } else if (/termination date/i.test(body)) {
          body = body.replace(/termination date:[^\n\r]*/i, "Termination Date: " + theDate);
        } else {
          body += "\nTermination Date: " + theDate;
        }

        if (/Last Working Date:/i.test(body)) {
          body = body.replace(/Last Working Date:[^\n\r]*/i, "Last Working Date: " + theDate);
        } else {
          body += "\nLast Working Date: " + theDate;
        }

        if (/terminated effective/i.test(body)) {
          body = body.replace(/terminated effective\s*[^\n\r.]*/i, "terminated effective " + theDate);
        } else if (/effective\s*(immediately|on|\d)/i.test(body)) {
          body = body.replace(/effective\s*[^\n\r.]*/i, "effective " + theDate);
        } else {
          body += "\nWe regret to inform you that your employment with our organization has been terminated effective " + theDate + ".";
        }
      }

      this.emailBody = body.replace(/\n{3,}/g, '\n\n').trim();
    },
    calculateDaysDifference: function calculateDaysDifference(startDate, endDate) {
      console.log("Calculating days difference between", startDate, "and", endDate);
      if (!startDate || !endDate) return 0;

      var start = new Date(startDate);
      var end = new Date(endDate);

      var diffTime = end.getTime() - start.getTime();
      return Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);
    },
    getTodayDate: function getTodayDate() {
      return new Date().toISOString().split("T")[0];
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dbTemplatesObj, dbTemplates;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].getEmailTemplates();

              case 3:
                dbTemplatesObj = _context3.sent;

                console.log("Fetched templates from DB:", dbTemplatesObj);

                if (dbTemplatesObj) {
                  _context3.next = 8;
                  break;
                }

                _this8.templates = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_25__assets_config_constants_js__["j" /* STATIC_TEMPLATES */]));
                return _context3.abrupt("return");

              case 8:
                dbTemplates = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(dbTemplatesObj).map(function (_ref4) {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                      key = _ref5[0],
                      value = _ref5[1];

                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, value, {
                    dbId: key
                  });
                });


                _this8.templates = _this8.mergeTemplates(__WEBPACK_IMPORTED_MODULE_25__assets_config_constants_js__["j" /* STATIC_TEMPLATES */], dbTemplates);
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);

                console.error("Failed to fetch email templates", _context3.t0);
                _this8.templates = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_25__assets_config_constants_js__["j" /* STATIC_TEMPLATES */]));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[0, 12]]);
      }))();
    },
    mergeTemplates: function mergeTemplates(staticTemplates, dbTemplates) {
      var staticMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();

      staticTemplates.forEach(function (t) {
        staticMap.set(t.title, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, t));
      });

      dbTemplates.forEach(function (dbTemplate) {
        if (staticMap.has(dbTemplate.title)) {
          staticMap.set(dbTemplate.title, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, staticMap.get(dbTemplate.title), dbTemplate, {
            id: staticMap.get(dbTemplate.title).id
          }));
        } else {
          staticMap.set(dbTemplate.title, dbTemplate);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(staticMap.values());
    },
    submitStatusChange: function submitStatusChange() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var formData, uid, response;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this9.validateStatusChangeForm()) {
                  _context4.next = 3;
                  break;
                }

                console.log("Form validation failed", _this9.errors);
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                formData = {
                  to: _this9.selectedEmployee.email,
                  subject: _this9.subject,
                  message: _this9.emailBody,
                  cc: _this9.ccRecipients
                };

                _this9.isSubmitting = true;

                uid = _this9.selectedEmployee.uid;
                _context4.next = 9;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserStatus(_this9.newStatus, uid);

              case 9:
                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserPreviousStatus(_this9.oldStatus, uid);

              case 11:
                _this9.selectedEmployee.status = _this9.newStatus;
                _this9.selectedEmployee.previousStatus = _this9.oldStatus;

                if (!(_this9.newStatus === "Permanent")) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 16;
                return _this9.assignLeaves(_this9.selectedEmployee);

              case 16:
                if (!(_this9.newStatus === "Resigned" && !_this9.selectedEmployee.resignationDate)) {
                  _context4.next = 22;
                  break;
                }

                _this9.selectedEmployee.resignationDate = new Date().toISOString().split("T")[0];
                _context4.next = 20;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserResignationDate(_this9.selectedEmployee.resignationDate, _this9.selectedEmployee.uid);

              case 20:
                _context4.next = 26;
                break;

              case 22:
                if (!(_this9.newStatus !== "Resigned")) {
                  _context4.next = 26;
                  break;
                }

                _this9.selectedEmployee.resignationDate = null;
                _context4.next = 26;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserResignationDate(_this9.selectedEmployee.resignationDate, _this9.selectedEmployee.uid);

              case 26:
                _context4.next = 28;
                return fetch(__WEBPACK_IMPORTED_MODULE_11_src_assets_config_constants_js__["o" /* default */].serverURL + "/company/change-status", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(formData)
                }).catch(function (error) {
                  console.error("Fetch error:", error);
                  throw new Error("Failed to connect to server at " + serverURL + ". Please ensure the backend server is running and accessible.");
                });

              case 28:
                response = _context4.sent;


                _this9.$store.dispatch("fetchAllUsersRealTime");
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Status updated successfully", "success");

                _this9.isStatusChangeModalOpen = false;
                _context4.next = 37;
                break;

              case 34:
                _context4.prev = 34;
                _context4.t0 = _context4["catch"](3);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to update status", "error");

              case 37:
                _context4.prev = 37;

                _this9.isSubmitting = false;
                return _context4.finish(37);

              case 40:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this9, [[3, 34, 37, 40]]);
      }))();
    },
    assignLeaves: function assignLeaves(item) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _calculateLeaves, leavesAllowed, leavesAvailable;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _calculateLeaves = _this10.calculateLeaves(item), leavesAllowed = _calculateLeaves.leavesAllowed, leavesAvailable = _calculateLeaves.leavesAvailable;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserLeaves(item.uid, {
                  leavesAllowed: leavesAllowed,
                  leavesTaken: 0,
                  leavesAvailable: leavesAvailable
                });

              case 4:
                return _context5.abrupt("return", { leavesAllowed: leavesAllowed, leavesTaken: 0, leavesAvailable: leavesAvailable });

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                console.error("Error assigning leaves:", _context5.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to assign leaves", "error");

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this10, [[0, 7]]);
      }))();
    },
    validateStatusChangeForm: function validateStatusChangeForm() {
      if (!this.ccRecipients.length) {
        this.errors.ccRecipients = "Please select at least one recipient for CC";
        return false;
      } else {
        this.errors.ccRecipients = "";
      }
      if (!this.subject.trim()) {
        this.errors.subject = "Subject is required";
        return false;
      } else {
        this.errors.subject = "";
      }
      if (!this.emailBody.trim()) {
        this.errors.emailBody = "Email body cannot be empty";
        return false;
      } else {
        this.errors.emailBody = "";
      }
      return true;
    },
    resetStatusChangeState: function resetStatusChangeState() {
      this.selectedEmployee = {};
      this.oldStatus = "";
      this.newStatus = "";
      this.resignationApprovalDate = Date.now();
      this.lastWorkingDate = Date.now() + 30 * 24 * 60 * 60 * 1000;
      this.ccRecipients = [];
      this.subject = "";
      this.emailBody = "";
      this.errors = {
        ccRecipients: "",
        subject: "",
        emailBody: "",
        resignationApprovalDate: "",
        terminationDate: ""
      };
      this.selectedTemplate = null;
      this.terminationDate = "";
    },
    replacePlaceholders: function replacePlaceholders(template, values) {
      return template.replace(/\[([^\]]+)\]/g, function (_, key) {
        return values[key] !== undefined && values[key] !== null ? values[key] : "[" + key + "]";
      });
    },
    getTemplateValues: function getTemplateValues(_ref6) {
      var employee = _ref6.employee,
          newStatus = _ref6.newStatus,
          oldStatus = _ref6.oldStatus;

      var now = new Date();
      var time = now.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });

      var commonValues = {
        "Employee Name": employee.username,
        "Old Status": oldStatus,
        "New Status": newStatus,
        "Current Date": now.toLocaleDateString(),
        "Current Time": time
      };

      var _calculateLeaves2 = this.calculateLeaves(employee),
          leavesAvailable = _calculateLeaves2.leavesAvailable;

      switch (newStatus) {
        case "Probation":
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, commonValues);

        case "Permanent":
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, commonValues, {
            "New Leaves": employee.newLeaves || leavesAvailable
          });

        case "Resigned":
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, commonValues, {
            "Approval Date": this.resignationApprovalDate,
            "Notice Period Days": this.noticePeriodDays() - 1,
            "Last Working Date": new Date(new Date(this.resignationApprovalDate).setDate(new Date(this.resignationApprovalDate).getDate() + this.noticePeriodDays())).toLocaleDateString('en-GB')
          });

        case "Terminated":
          var termDate = this.terminationDate || this.getTodayDate();
          var formattedTermDate = new Date(termDate).toLocaleDateString('en-GB');
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, commonValues, {
            "Current Date": formattedTermDate,
            "Termination Date": formattedTermDate,
            "Last Working Date": formattedTermDate
          });

        default:
          return commonValues;
      }
    },
    calculateLeaves: function calculateLeaves(item) {
      var leavesPerSemester = 7.5;
      var monthsPerSemester = 6;

      var currentDate = new Date();
      var currentMonth = currentDate.getMonth();

      var isSecondSemester = currentMonth >= 6;
      var monthsRemaining = isSecondSemester ? 12 - currentMonth : 6 - currentMonth;

      var leavesPerMonth = leavesPerSemester / monthsPerSemester;

      var roundToHalf = function roundToHalf(num) {
        return Math.round(num * 2) / 2;
      };

      var leavesAllowed = roundToHalf(leavesPerMonth * monthsRemaining);

      var leavesAvailable = isSecondSemester ? leavesAllowed : leavesAllowed + leavesPerSemester;

      return {
        leavesAllowed: leavesAllowed,
        leavesTaken: 0,
        leavesAvailable: leavesAvailable
      };
    },
    noticePeriodDays: function noticePeriodDays() {
      if (!this.resignationApprovalDate || !this.lastWorkingDate) {
        return 0;
      }
      if (this.newStatus === 'Terminated') {
        return 0;
      }

      return this.calculateDaysDifference(this.resignationApprovalDate, this.lastWorkingDate);
    },
    openStatusChangeModal: function openStatusChangeModal(_ref7) {
      var employee = _ref7.employee,
          newStatus = _ref7.newStatus,
          oldStatus = _ref7.oldStatus;

      this.selectedEmployee = employee;
      this.oldStatus = oldStatus;
      this.newStatus = newStatus;
      this.isStatusChangeModalOpen = true;

      var statusForTemplate = newStatus;
      if (newStatus === "Resigned") statusForTemplate = "Resignation";
      if (newStatus === "Terminated") statusForTemplate = "Termination";

      this.selectedTemplate = this.templates.find(function (t) {
        return t.title.includes(statusForTemplate);
      });

      if (!this.selectedTemplate) {
        this.subject = "";
        this.emailBody = "";
        return;
      }

      this.preselectAdminsForCC();
    },
    preselectAdminsForCC: function preselectAdminsForCC() {
      var admins = this.$store.state.auth.allUsers.filter(function (user) {
        return user.role === "admin";
      }).map(function (user) {
        return user.email;
      });

      this.ccRecipients = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(admins));
    },
    saveMeetingOnlyInDB: function saveMeetingOnlyInDB() {
      this.isMeetingConfirmModalOpen = false;
    },
    goToGoogleCalendarSettings: function goToGoogleCalendarSettings() {
      this.isMeetingConfirmModalOpen = false;
      this.$router.push('/settings');
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var year = d.getFullYear();
      return day + "/" + month + "/" + year;
    },
    openMeetingModal: function openMeetingModal(user, type) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var isConnected, choice;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["a" /* isGoogleCalendarConnected */])();

              case 2:
                isConnected = _context6.sent;

                console.log("Google Calendar connection status:", isConnected);

                if (isConnected) {
                  _context6.next = 18;
                  break;
                }

                _context6.next = 7;
                return __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
                  title: 'Google Calendar not connected',
                  text: 'Do you want to connect Google Calendar or save meeting without syncing?',
                  icon: 'warning',
                  buttons: {
                    connect: {
                      text: 'Connect & Sync',
                      value: 'connect',
                      className: 'swal-btn-connect'
                    },
                    save: {
                      text: 'Save Without Sync',
                      value: 'save',
                      className: 'swal-btn-save'
                    }
                  }
                });

              case 7:
                choice = _context6.sent;

                if (!(choice === 'connect')) {
                  _context6.next = 11;
                  break;
                }

                _this11.$router.push('/settings');
                return _context6.abrupt("return");

              case 11:
                if (!(choice === 'save')) {
                  _context6.next = 17;
                  break;
                }

                _this11.selectedUser = user;
                _this11.meetingType = type;
                _this11.selectedMeeting = user;
                _this11.showModal = true;
                return _context6.abrupt("return");

              case 17:
                return _context6.abrupt("return");

              case 18:
                _this11.selectedUser = user;
                _this11.meetingType = type;
                _this11.selectedMeeting = user;
                _this11.showModal = true;

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this11);
      }))();
    },
    saveMeeting: function saveMeeting(form) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var dateTime, start, end, event, result, meetingObj;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this12.loadings.saveMeeting = true;
                dateTime = new Date(form.date + "T" + form.time);
                start = new Date(dateTime);
                end = new Date(start.getTime() + 30 * 60000);
                event = {
                  summary: form.title,
                  description: form.description,
                  start: { dateTime: start.toISOString() },
                  end: { dateTime: end.toISOString() },
                  attendees: form.attendees.map(function (email) {
                    return { email: email };
                  })
                };
                result = void 0;
                _context7.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["a" /* isGoogleCalendarConnected */])();

              case 9:
                if (!_context7.sent) {
                  _context7.next = 19;
                  break;
                }

                if (!form.googleEventId) {
                  _context7.next = 16;
                  break;
                }

                _context7.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["b" /* updateMeeting */])(form.googleEventId, event);

              case 13:
                result = _context7.sent;
                _context7.next = 19;
                break;

              case 16:
                _context7.next = 18;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["c" /* createMeeting */])(event);

              case 18:
                result = _context7.sent;

              case 19:
                meetingObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                  type: _this12.meetingType
                }, result && { googleEventId: result.eventId || form.googleEventId }, {
                  date: form.date,
                  time: form.time,
                  title: form.title,
                  attendees: form.attendees,
                  description: form.description
                });

                if (!(_this12.meetingType === 'quarterly')) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 23;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].createOrUpdateQuarterlyMeetingDetails(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, meetingObj), _this12.selectedUser.uid);

              case 23:
                _context7.next = 27;
                break;

              case 25:
                _context7.next = 27;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].createOrUpdateIncrementMeetingDetails(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, meetingObj), _this12.selectedUser.uid);

              case 27:
                _context7.next = 29;
                return _this12.trackActivity('Save', _this12.meetingType, _this12.selectedUser, meetingObj);

              case 29:

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Meeting " + (form.googleEventId ? 'updated' : 'scheduled') + " successfully", "success").then(function () {
                  _this12.showModal = false;
                });

                _context7.next = 36;
                break;

              case 32:
                _context7.prev = 32;
                _context7.t0 = _context7["catch"](0);

                console.error("Error saving meeting:", _context7.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to save meeting. Please try again.", "error");

              case 36:
                _context7.prev = 36;

                _this12.loadings.saveMeeting = false;
                return _context7.finish(36);

              case 39:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this12, [[0, 32, 36, 39]]);
      }))();
    },
    deleteMeeting: function deleteMeeting() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var eventId, date, time, attendees, isConnected;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this13.loadings.deleteMeeting = true;
                eventId = "";
                date = "";
                time = "";
                attendees = [];
                _context8.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["a" /* isGoogleCalendarConnected */])();

              case 8:
                isConnected = _context8.sent;

                if (!(_this13.meetingType === 'quarterly')) {
                  _context8.next = 21;
                  break;
                }

                eventId = _this13.selectedUser.nextQuarterlyMeetingDetails.googleEventId;
                date = _this13.selectedUser.nextQuarterlyMeetingDetails.date;
                time = _this13.selectedUser.nextQuarterlyMeetingDetails.time;
                attendees = _this13.selectedUser.nextQuarterlyMeetingDetails.attendees || [];

                if (!(isConnected && eventId)) {
                  _context8.next = 17;
                  break;
                }

                _context8.next = 17;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["d" /* deleteMeeting */])(eventId);

              case 17:
                _context8.next = 19;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].deleteQuarterlyMeetingDetails(_this13.selectedUser.uid);

              case 19:
                _context8.next = 30;
                break;

              case 21:
                eventId = _this13.selectedUser.nextIncrementMeetingDetails.googleEventId;
                date = _this13.selectedUser.nextIncrementMeetingDetails.date;
                time = _this13.selectedUser.nextIncrementMeetingDetails.time;
                attendees = _this13.selectedUser.nextIncrementMeetingDetails.attendees || [];

                if (!(isConnected && eventId)) {
                  _context8.next = 28;
                  break;
                }

                _context8.next = 28;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_googleCalendar_js__["d" /* deleteMeeting */])(eventId);

              case 28:
                _context8.next = 30;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].deleteIncrementMeetingDetails(_this13.selectedUser.uid);

              case 30:
                _context8.next = 32;
                return _this13.trackActivity('Delete', _this13.meetingType, _this13.selectedUser, { date: date, time: time, attendees: attendees });

              case 32:

                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Meeting deleted successfully", "success").then(function () {
                  _this13.showModal = false;
                });
                _context8.next = 39;
                break;

              case 35:
                _context8.prev = 35;
                _context8.t0 = _context8["catch"](0);

                console.error("Error deleting meeting:", _context8.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to delete meeting. Please try again.", "error");

              case 39:
                _context8.prev = 39;

                _this13.loadings.deleteMeeting = false;
                return _context8.finish(39);

              case 42:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this13, [[0, 35, 39, 42]]);
      }))();
    },
    trackActivity: function trackActivity(action, type, details, meetingObj) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var username, email, uid, _ref8, date, time, attendees, title, description, _$store$state$auth$us, adminId, adminUserName, _$store$state$auth$us2, _adminId, _adminUserName;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                username = details.username, email = details.email, uid = details.uid;
                _ref8 = meetingObj || {}, date = _ref8.date, time = _ref8.time, attendees = _ref8.attendees;

                date = new Date(date + "T" + time).toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
                console.log(date);
                console.log(time);
                time = time && function () {
                  var _time$split = time.split(':'),
                      _time$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_time$split, 2),
                      hourStr = _time$split2[0],
                      minute = _time$split2[1];

                  var hour = parseInt(hourStr, 10);
                  var ampm = hour >= 12 ? 'PM' : 'AM';
                  hour = hour % 12 || 12;
                  return hour + ":" + minute + " " + ampm;
                }();
                console.log(time);
                title = "";
                description = "";

                if (!(action === "Save")) {
                  _context9.next = 19;
                  break;
                }

                title = _this14.currentUser.username + " scheduled " + type + " meeting for " + username + " on " + date + " at " + time;
                description = _this14.currentUser.email + " scheduled " + type + " meeting for " + email + " on " + date + " at " + time + ".";

                _context9.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this14.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: type,
                  uid: uid,
                  attendees: attendees ? attendees.join(", ") : ""
                }));

              case 14:
                _$store$state$auth$us = _this14.$store.state.auth.user, adminId = _$store$state$auth$us.uid, adminUserName = _$store$state$auth$us.username;
                _context9.next = 17;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: type,
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: adminUserName,
                  attendees: attendees || []
                }, _this14.$store.state.auth, adminId);

              case 17:
                _context9.next = 26;
                break;

              case 19:
                title = _this14.currentUser.username + " deleted " + type + " meeting for " + username + " on " + date + " at " + time;
                description = _this14.currentUser.email + " deleted " + type + " meeting for " + email + " on " + date + " at " + time + ".";

                _context9.next = 23;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this14.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: type,
                  uid: uid
                }));

              case 23:
                _$store$state$auth$us2 = _this14.$store.state.auth.user, _adminId = _$store$state$auth$us2.uid, _adminUserName = _$store$state$auth$us2.username;
                _context9.next = 26;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: type,
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: _adminUserName,
                  attendees: attendees || []
                }, _this14.$store.state.auth, _adminId);

              case 26:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this14);
      }))();
    },
    onFilterChange: function onFilterChange(type) {
      this.filterType = type;
    },
    onEmployeeSelect: function onEmployeeSelect(user) {
      this.selectedEmployee = user;
    },
    onDesignationChange: function onDesignationChange(value) {
      this.designation = value;
      this.grade = ''; // Reset grade when designation changes
    },
    onGradeChange: function onGradeChange(value) {
      this.grade = value; // Update grade when selected
    },
    onShiftChange: function onShiftChange(value) {
      this.shift = value;
      this.validateShift();
    },
    validateName: function validateName() {
      if (!this.name || !this.name.trim().length) {
        this.nameError = "Full name is required";
        return false;
      } else {
        this.nameError = "";
        return true;
      }
    },
    validateEmail: function validateEmail() {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email || !emailRegex.test(this.email)) {
        this.emailError = "Invalid email format";
        return false;
      } else {
        this.emailError = "";
        return true;
      }
    },
    validateShift: function validateShift() {
      if (!this.shift) {
        this.shiftError = "Shift is required";
        return false;
      } else {
        this.shiftError = "";
        return true;
      }
    },
    validateAllFields: function validateAllFields() {
      var isNameValid = this.validateName();
      var isEmailValid = this.validateEmail();
      var isShiftValid = this.validateShift();
      return isNameValid && isEmailValid && isShiftValid;
    },

    clearItems: function clearItems() {
      this.isEdit = false;
      this.dialog = false;
      this.email = "";
      this.name = "";
      this.designation = "";
      this.grade = "";
      this.editUserId = "";
      this.nameError = "";
      this.emailError = "";
      this.isEmployeeModalOpen = false;
      this.shift = "Morning";
      this.shiftError = "";
    },
    changeStatus: function changeStatus(status, item) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var uid, username, email, title, description, _$store$state$auth$us3, adminId, adminUserName, _$store$state$auth$us4, _adminId2, _adminUserName2;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserActiveStatus(status, item.uid);

              case 3:
                item.active = status;
                uid = item.uid, username = item.username, email = item.email;
                title = "";
                description = "";

                if (!status) {
                  _context10.next = 17;
                  break;
                }

                title = _this15.currentUser.username + " activated " + username;
                description = _this15.currentUser.email + " activated " + email + ".";

                _context10.next = 12;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this15.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: "update_user",
                  uid: uid
                }));

              case 12:
                _$store$state$auth$us3 = _this15.$store.state.auth.user, adminId = _$store$state$auth$us3.uid, adminUserName = _$store$state$auth$us3.username;
                _context10.next = 15;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "update_user",
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: adminUserName,
                  activityName: title
                }, _this15.$store.state.auth, adminId);

              case 15:
                _context10.next = 24;
                break;

              case 17:
                title = _this15.currentUser.username + " deactivated " + username;
                description = _this15.currentUser.email + " deactivated " + email + ".";

                _context10.next = 21;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this15.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: "update_user",
                  uid: uid
                }));

              case 21:
                _$store$state$auth$us4 = _this15.$store.state.auth.user, _adminId2 = _$store$state$auth$us4.uid, _adminUserName2 = _$store$state$auth$us4.username;
                _context10.next = 24;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "update_user",
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: _adminUserName2,
                  activityName: title
                }, _this15.$store.state.auth, _adminId2);

              case 24:
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Employee " + (status ? 'activated' : 'deactivated') + " successfully", "success");
                _context10.next = 31;
                break;

              case 27:
                _context10.prev = 27;
                _context10.t0 = _context10["catch"](0);

                console.error("Error changing status:", _context10.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to update employee status", "error");

              case 31:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this15, [[0, 27]]);
      }))();
    },
    changeRole: function changeRole(newRole, item) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var uid, username, email, title, description, _$store$state$auth$us5, adminId, adminUserName, _$store$state$auth$us6, _adminId3, _adminUserName3;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateUserRole(newRole, item.uid);

              case 3:
                _context11.next = 5;
                return _this16.$store.dispatch("fetchAllUsersRealTime");

              case 5:
                uid = item.uid, username = item.username, email = item.email;
                title = "";
                description = "";

                if (!(newRole === 'admin')) {
                  _context11.next = 18;
                  break;
                }

                title = _this16.currentUser.username + " changed " + username + "'s role to Admin";
                description = _this16.currentUser.email + " changed " + email + "'s role to Admin.";

                _context11.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this16.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: "update_user",
                  uid: uid
                }));

              case 13:
                _$store$state$auth$us5 = _this16.$store.state.auth.user, adminId = _$store$state$auth$us5.uid, adminUserName = _$store$state$auth$us5.username;
                _context11.next = 16;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "update_user",
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: adminUserName,
                  activityName: title
                }, _this16.$store.state.auth, adminId);

              case 16:
                _context11.next = 25;
                break;

              case 18:
                title = _this16.currentUser.username + " changed " + username + "'s role to User";
                description = _this16.currentUser.email + " changed " + email + "'s role to User.";

                _context11.next = 22;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this16.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: "update_user",
                  uid: uid
                }));

              case 22:
                _$store$state$auth$us6 = _this16.$store.state.auth.user, _adminId3 = _$store$state$auth$us6.uid, _adminUserName3 = _$store$state$auth$us6.username;
                _context11.next = 25;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "update_user",
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: _adminUserName3,
                  activityName: title
                }, _this16.$store.state.auth, _adminId3);

              case 25:
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Success", "Employee role changed to " + newRole + " successfully", "success");
                _context11.next = 32;
                break;

              case 28:
                _context11.prev = 28;
                _context11.t0 = _context11["catch"](0);

                console.error("Error changing role:", _context11.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to update employee role", "error");

              case 32:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this16, [[0, 28]]);
      }))();
    },
    loginAsEmployee: function loginAsEmployee(employee) {
      if (employee.role === 'admin') {
        __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Action Not Allowed", "You cannot login as another admin user.", "warning");
        return;
      } else {
        localStorage.setItem('impersonateUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(employee));
        localStorage.setItem('originalAdminUser', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.currentUser));
        this.employeeLogin(employee);
        this.$root.isImpersonating = true;
        this.$root.impersonatedUser = employee;
        this.$router.push('/overview');
      }
    },
    employeeLogin: function employeeLogin(employee) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var routeUserId, userData, user;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                routeUserId = employee.uid;
                _context12.prev = 1;
                _context12.next = 4;
                return _this17.$store.dispatch('initializeAuth');

              case 4:
                if (!routeUserId) {
                  _context12.next = 12;
                  break;
                }

                _context12.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].getSingleUser(routeUserId);

              case 7:
                userData = _context12.sent;

                if (userData) {
                  _context12.next = 10;
                  break;
                }

                throw new Error('User not found');

              case 10:
                _context12.next = 13;
                break;

              case 12:
                userData = _this17.$store.state.auth.user || defaultUserData;

              case 13:
                user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, userData, {
                  bankName: userData.bankName || '',
                  email: userData.email || '',
                  iban: userData.iban || '',
                  isActive: userData.isActive !== undefined ? userData.isActive : true,
                  joiningDate: userData.joiningDate || '',
                  leavesAllowed: userData.leavesAllowed || 7.5,
                  leavesAvailable: userData.leavesAvailable || 15,
                  leavesTaken: userData.leavesTaken || '',
                  nicNumber: userData.nicNumber || '',
                  phoneNumber: userData.phoneNumber || '',
                  role: userData.role || '',
                  salary: userData.salary || 0,
                  twitterProfile: userData.twitterProfile || '',
                  uid: routeUserId || userData.uid || (_this17.$store.state.auth.user ? _this17.$store.state.auth.user.uid : ''),
                  username: userData.username || '',
                  designation: userData.designation || '',
                  grade: userData.grade || '',
                  role_title: userData.role_title || '',
                  personalEmail: userData.personalEmail || '',
                  dateOfBirth: userData.dateOfBirth || '',
                  nationality: userData.nationality || '',
                  maritalStatus: userData.maritalStatus || '',
                  currentAddress: userData.currentAddress || '',
                  permanentAddress: userData.permanentAddress || '',
                  emergencyContactName: userData.emergencyContactName || '',
                  emergencyContactNumber: userData.emergencyContactNumber || '',
                  profile_picture: userData.profile_picture || '',
                  nicImageUrl: userData.nicImageUrl || '',
                  certificateUrl: userData.certificateUrl || '',
                  salarySlipUrl: userData.salarySlipUrl || '',
                  // company: this.company.companyName,
                  fullName: userData.username || '',
                  status: userData.status || _this17.$store.state.auth.user && _this17.$store.state.auth.user.status || 'Active' // Preserve status
                });

                _this17.$store.commit('setUser', user);

                _context12.next = 23;
                break;

              case 17:
                _context12.prev = 17;
                _context12.t0 = _context12["catch"](1);

                console.error('Error fetching user from Firebase:', _context12.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()('Error', 'Failed to load user data: ' + _context12.t0.message, 'error');
                _this17.user = defaultUserData;
                _this17.$router.push('/userManagement');

              case 23:
                _context12.prev = 23;

                _this17.isLoading = false;
                return _context12.finish(23);

              case 26:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this17, [[1, 17, 23, 26]]);
      }))();
    },

    delEmp: function delEmp(user) {
      this.selectedUser = user;
      this.isDeleteModalOpen = true;
    },
    confirmDelete: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var response, data, _selectedUser, uid, username, email, title, description, _$store$state$auth$us7, adminId, adminUserName, company;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.isAddingEmployee = true;
                _context13.prev = 1;
                _context13.next = 4;
                return fetch(__WEBPACK_IMPORTED_MODULE_11_src_assets_config_constants_js__["o" /* default */].serverURL + "/company/user/delete", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
                    uid: this.selectedUser.uid,
                    email: this.selectedUser.email,
                    companyEmail: this.company.email
                  })
                });

              case 4:
                response = _context13.sent;
                _context13.next = 7;
                return response.json();

              case 7:
                data = _context13.sent;

                if (!(response.status !== 200)) {
                  _context13.next = 10;
                  break;
                }

                throw data;

              case 10:
                _selectedUser = this.selectedUser, uid = _selectedUser.uid, username = _selectedUser.username, email = _selectedUser.email;
                title = this.currentUser.username + " deleted the user with name " + username;
                description = this.currentUser.email + " deleted the user with email " + email + ".";
                _context13.next = 15;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: this.currentUser,
                  title: title,
                  description: description,
                  username: username,
                  type: "delete_user",
                  uid: uid
                }));

              case 15:
                _$store$state$auth$us7 = this.$store.state.auth.user, adminId = _$store$state$auth$us7.uid, adminUserName = _$store$state$auth$us7.username;
                _context13.next = 18;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "delete_user",
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: username,
                  activityByUserName: adminUserName
                }, this.$store.state.auth, adminId);

              case 18:
                _context13.next = 20;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].fetchCompanyData(this.$store.state.auth.user.email);

              case 20:
                company = _context13.sent;

                this.$store.commit("setCompany", company);
                this.isDeleteModalOpen = false;
                this.isAddingEmployee = false;
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("User has been deleted", "Deleted", "success");
                _context13.next = 32;
                break;

              case 27:
                _context13.prev = 27;
                _context13.t0 = _context13["catch"](1);

                this.isAddingEmployee = false;
                console.log("e =>", _context13.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Oops!", _context13.t0.message, "error");

              case 32:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[1, 27]]);
      }));

      function confirmDelete() {
        return _ref9.apply(this, arguments);
      }

      return confirmDelete;
    }(),
    addPromotion: function addPromotion(user) {
      this.selectedPromotionUser = user;
      this.promotionText = "";
      this.isSalaryPromotion = false;
      this.newBasicSalary = null;
      this.newExtraAllowance = null;
      this.promotionEditIndex = null;
      this.isPromotionModalOpen = true;
    },
    togglePromotions: function togglePromotions(item) {
      this.selectedPromotionUser = item;
      var now = new Date();
      var firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      this.currentSalary = Number(item.basicSalary) + Number(item.extraAllowance);
      this.effectiveDate = firstDay.getFullYear() + "-" + String(firstDay.getMonth() + 1).padStart(2, '0') + "-01";
      this.isNotesModalOpen = true;
      this.selectedEmployee = item;
    },
    editPromotion: function editPromotion(user, index) {
      var existing = user.promotionInfo[index];
      this.selectedPromotionUser = user;
      this.promotionText = existing.text;
      this.isSalaryPromotion = !!existing.isSalaryPromotion;
      this.newBasicSalary = existing.newBasicSalary || null;
      this.newExtraAllowance = existing.newExtraAllowance || null;
      this.promotionEditIndex = index;
      this.isPromotionModalOpen = true;
    },
    openDeletePromotionModal: function openDeletePromotionModal(index, note) {
      this.promotionToDelete = { index: index, note: note };
      this.isDeletePromotionModalOpen = true;
    },
    confirmDeletePromotion: function confirmDeletePromotion() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var _promotionToDelete2, user, index;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _promotionToDelete2 = _this18.promotionToDelete, user = _promotionToDelete2.user, index = _promotionToDelete2.index;
                _context14.prev = 1;

                user.promotionInfo.splice(index, 1);
                _context14.next = 5;
                return _this18.updatePromotionInDB(user);

              case 5:
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Deleted", "Promotion note removed successfully", "success");
                _context14.next = 12;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](1);

                console.error("Failed to delete promotion note:", _context14.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to delete promotion note", "error");

              case 12:
                _context14.prev = 12;

                _this18.isDeletePromotionModalOpen = false;
                _this18.promotionToDelete = null;
                return _context14.finish(12);

              case 16:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this18, [[1, 8, 12, 16]]);
      }))();
    },
    savePromotion: function savePromotion(promotionData) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var user, newPromotion;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                user = _this19.selectedPromotionUser;

                if (!user.promotionInfo) user.promotionInfo = [];

                newPromotion = {
                  text: promotionData.text,
                  createdAt: new Date().toISOString(),
                  isSalaryPromotion: promotionData.type === "increment" ? true : false,
                  oldSalary: promotionData.oldSalary,
                  newBasicSalary: Number(promotionData.newBasicSalary),
                  newExtraAllowance: Number(promotionData.newExtraAllowance),
                  increment: promotionData.increment,
                  type: promotionData.type,
                  percentage: Number(promotionData.percentage),
                  effectiveDate: promotionData.effectiveDate
                };


                if (_this19.promotionEditIndex !== null) {
                  user.promotionInfo[_this19.promotionEditIndex] = newPromotion;
                } else if (promotionData.type === "increment") {
                  user.promotionInfo.push(newPromotion);
                } else {
                  user.promotionInfo.push({ text: promotionData.text, createdAt: new Date().toISOString(), type: promotionData.type, isSalaryPromotion: false });
                }

                _context15.next = 6;
                return _this19.updatePromotionInDB(user);

              case 6:
                _this19.isPromotionModalOpen = false;

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this19);
      }))();
    },
    updatePromotionInDB: function updatePromotionInDB(user) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var lastPromo, updatedSalaryData;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateEmployee({ promotionInfo: user.promotionInfo }, user.uid);

              case 3:

                // 2️⃣ Check if latest promotion is a salary increment
                lastPromo = user.promotionInfo[user.promotionInfo.length - 1];

                if (!(lastPromo && lastPromo.isSalaryPromotion)) {
                  _context16.next = 8;
                  break;
                }

                updatedSalaryData = {
                  basicSalary: lastPromo.newBasicSalary,
                  extraAllowance: lastPromo.newExtraAllowance
                };
                _context16.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateEmployee(updatedSalaryData, user.uid);

              case 8:
                _context16.next = 10;
                return _this20.$store.dispatch("fetchAllUsersRealTime");

              case 10:
                _context16.next = 16;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16["catch"](0);

                console.error("Failed to update note:", _context16.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to update note.", "error");

              case 16:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this20, [[0, 12]]);
      }))();
    },
    updateMeetingDate: function updateMeetingDate(user, field, value) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var title;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].updateEmployee(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()({}, field, value), user.uid);

              case 3:
                title = '';
                _context17.t0 = field;
                _context17.next = _context17.t0 === 'nextQuarterlyMeeting' ? 7 : _context17.t0 === 'nextIncrementReview' ? 9 : _context17.t0 === 'lastWorkingDate' ? 11 : _context17.t0 === 'joiningDate' ? 13 : 15;
                break;

              case 7:
                title = 'Next Quarterly Meeting';
                return _context17.abrupt("break", 16);

              case 9:
                title = 'Next Increment Review';
                return _context17.abrupt("break", 16);

              case 11:
                title = 'Last Working Date';
                return _context17.abrupt("break", 16);

              case 13:
                title = 'Joining Date';
                return _context17.abrupt("break", 16);

              case 15:
                title = 'Meeting Date';

              case 16:
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Updated", title + " updated successfully", "success");
                _context17.next = 23;
                break;

              case 19:
                _context17.prev = 19;
                _context17.t1 = _context17["catch"](0);

                console.error("Error updating meeting date:", _context17.t1);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Error", "Failed to update meeting date", "error");

              case 23:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this21, [[0, 19]]);
      }))();
    },
    calculateDuration: function calculateDuration(item) {
      var joiningDate = item.joiningDate,
          lastWorkingDate = item.lastWorkingDate;

      if (!joiningDate) return "-";
      var start = new Date(joiningDate);
      var end = lastWorkingDate ? new Date(lastWorkingDate) : new Date(); // use today if active

      var years = end.getFullYear() - start.getFullYear();
      var months = end.getMonth() - start.getMonth();
      var days = end.getDate() - start.getDate();

      if (days < 0) {
        months -= 1;
        var prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
        days += prevMonth.getDate();
      }

      if (months < 0) {
        years -= 1;
        months += 12;
      }

      return years + " years " + months + " months " + days + " days";
    },


    addEmp: function addEmp() {
      console.log("this.$store.state.auth.company", this.$store.state.auth.company);
      this.isEdit = false;
      this.email = "";
      this.name = "";
      this.designation = "";
      this.grade = "";
      this.isAdmin = false;
      this.nameError = "";
      this.emailError = "";
      this.shift = "Morning";
      this.shiftError = "";
      this.isEmployeeModalOpen = true;
    },
    addEmployee: function addEmployee() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var email, name, designation, grade, role, joiningDate, shift, nightShiftSettings, userEmail, response, data, uid, company, title, description, _$store$state$auth$us8, adminId, adminUserName;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (_this22.validateAllFields()) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt("return");

              case 2:
                _this22.isLoading = true;

                email = _this22.email;
                name = _this22.name;
                designation = _this22.designation || "";
                grade = _this22.grade || "";
                role = _this22.isAdmin ? "admin" : "user";
                joiningDate = new Date().toISOString().split("T")[0];
                shift = _this22.shift;
                nightShiftSettings = shift === "Night" ? {
                  specificSettings: true,
                  workingDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                  lateTime: "07:00 PM",
                  productiveHours: 9
                } : {};
                _context18.prev = 11;

                _this22.isAddingEmployee = true;

                userEmail = _this22.$store.state.auth && _this22.$store.state.auth.user ? _this22.$store.state.auth.user.email : "";

                if (userEmail) {
                  _context18.next = 16;
                  break;
                }

                throw { message: "User email not found" };

              case 16:
                _context18.next = 18;
                return fetch(__WEBPACK_IMPORTED_MODULE_11_src_assets_config_constants_js__["o" /* default */].serverURL + "/company/user", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                    email: email, name: name, designation: designation, grade: grade, joiningDate: joiningDate, role: role,
                    companyEmail: userEmail, status: "Probation",
                    leavesAllowed: 0, leavesTaken: 0, leavesAvailable: 0,
                    shift: shift }, nightShiftSettings))
                }).catch(function (error) {
                  console.error("Fetch error:", error);
                  throw new Error("Failed to connect to server at " + serverURL + ". Please ensure the backend server is running and accessible.");
                });

              case 18:
                response = _context18.sent;
                _context18.next = 21;
                return response.json();

              case 21:
                data = _context18.sent;

                console.log("Backend response:", data); // Log the full response for debugging
                uid = null;

                if (data && data.user) {
                  uid = data.user.uid;
                }

                if (!(response.status !== 200)) {
                  _context18.next = 27;
                  break;
                }

                throw new Error(data.message || "Failed to add employee (Status: " + response.status + ")");

              case 27:
                if (!(response.status === 200)) {
                  _context18.next = 46;
                  break;
                }

                _context18.next = 30;
                return _this22.$store.dispatch("fetchAllUsersRealTime");

              case 30:
                _context18.next = 32;
                return __WEBPACK_IMPORTED_MODULE_12_src_assets_config_firebase_js__["a" /* default */].fetchCompanyData(_this22.$store.state.auth.user.email);

              case 32:
                company = _context18.sent;

                _this22.$store.commit("setCompany", company);

                title = _this22.currentUser.username + " created a new user with name " + name;
                description = _this22.currentUser.email + " created a new user with email " + email + ".";
                _context18.next = 38;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this22.currentUser,
                  title: title,
                  description: description,
                  username: name,
                  type: "create_user"
                }));

              case 38:
                _$store$state$auth$us8 = _this22.$store.state.auth.user, adminId = _$store$state$auth$us8.uid, adminUserName = _$store$state$auth$us8.username;
                _context18.next = 41;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "create_user",
                  activityDescription: description,
                  activityOnUser: uid,
                  activityOnUserName: name,
                  activityByUserName: adminUserName,
                  activityName: title,
                  role: _this22.isAdmin ? "admin" : "user"
                }, _this22.$store.state.auth, adminId);

              case 41:
                if (!_this22.isAdmin) {
                  _context18.next = 46;
                  break;
                }

                title = _this22.currentUser.username + " set " + name + "'s role as Admin";
                description = _this22.currentUser.email + " set " + email + "'s role as Admin.";

                _context18.next = 46;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["c" /* logAdminActivity */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_adminLogs_js__["d" /* createActivityPayload */])({
                  user: _this22.currentUser,
                  title: title,
                  description: description,
                  username: name,
                  type: "create_user"
                }));

              case 46:
                if (_this22.$store.dispatch) {
                  _this22.$store.dispatch("getAllUsers");
                }
                _this22.isAddingEmployee = false;
                _this22.isEmployeeModalOpen = false;
                _this22.email = "";
                _this22.designation = "";
                _this22.grade = "";
                _this22.name = "";
                _this22.isAdmin = false;
                _this22.shift = "Morning";
                _this22.isLoading = false;
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Great", "Added", "success");
                _context18.next = 65;
                break;

              case 59:
                _context18.prev = 59;
                _context18.t0 = _context18["catch"](11);

                _this22.isLoading = false;
                _this22.isAddingEmployee = false;
                console.error("Error in addEmployee:", _context18.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()("Oops!", _context18.t0.message || "An error occurred while adding the employee. Please check the input data or server logs.", "error");

              case 65:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this22, [[11, 59]]);
      }))();
    }
  }
});

/***/ }),

/***/ "smu3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "sqB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableVariables_vue__ = __webpack_require__("Ppg2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727e8ff2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableVariables_vue__ = __webpack_require__("Wi1e");
function injectStyle (ssrContext) {
  __webpack_require__("MZnX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-727e8ff2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableVariables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727e8ff2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableVariables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tMXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"header-card"},[_c('div',{staticClass:"header-left"},[_c('img',{staticClass:"header-avatar",attrs:{"src":_vm.currentUser.profile_picture || 'static/img/default-dp.png',"alt":"avatar"},on:{"click":function($event){return _vm.$router.replace(("/user/" + (_vm.currentUser.uid)))}}}),_vm._v(" "),_c('div',{staticClass:"employee-info"},[_c('h1',{staticClass:"emp-name"},[_vm._v(_vm._s(_vm.currentUser.username))]),_vm._v(" "),_c('p',{staticClass:"emp-role"},[_vm._v(_vm._s(_vm.currentUser.designation || 'Admin'))]),_vm._v(" "),_c('div',{staticClass:"badges"},[(_vm.joiningDateText)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.joiningDateText))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.todayText))])])])]),_vm._v(" "),_c('div',{staticClass:"header-right"},[_c('span',{staticClass:"status-btn"},[_vm._v("Overview")]),_vm._v(" "),_c('div',{staticClass:"checkin-time"},[(_vm.loading.header)?[_c('span',{staticClass:"time"},[_vm._v("--")]),_vm._v(" "),_c('span',{staticClass:"time-label"},[_vm._v("Counting active employees")])]:[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.presentToday)+" / "+_vm._s(_vm.totalActiveEmployees))]),_vm._v(" "),_c('span',{staticClass:"time-label"},[_vm._v("Employees present today")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"stats-row"},_vm._l((_vm.stats),function(stat){return _c('div',{key:stat.label,staticClass:"stat-card"},[(_vm.loading.stats)?[_c('div',{staticClass:"sk sk-label"}),_vm._v(" "),_c('div',{staticClass:"sk sk-value"}),_vm._v(" "),_c('div',{staticClass:"sk sk-sub"})]:[_c('p',{staticClass:"stat-label"},[_vm._v(_vm._s(stat.label))]),_vm._v(" "),_c('p',{staticClass:"stat-value",style:({ color: stat.color })},[_vm._v(_vm._s(stat.value))]),_vm._v(" "),_c('p',{staticClass:"stat-sub",style:(stat.subColor ? { color: stat.subColor } : null)},[_vm._v(_vm._s(stat.sub))])]],2)}),0),_vm._v(" "),_c('div',{staticClass:"panels-row panels-row-triple"},[_c('div',{staticClass:"panel panel-attendance"},[_c('div',{staticClass:"panel-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/reports"}},[_vm._v("View Report →")])],1),_vm._v(" "),_c('div',{staticClass:"att-summary"},[_c('span',{staticClass:"att-summary-value"},[_vm._v(_vm._s(_vm.weekAttendancePct)+"%")]),_vm._v(" "),_c('span',{staticClass:"att-summary-label"},[_vm._v("\n          average attendance · "+_vm._s(_vm.weekRangeLabel)+"\n        ")])]),_vm._v(" "),(_vm.attendance.length)?_c('div',{staticClass:"att-bars"},_vm._l((_vm.attendance),function(d){return _c('div',{key:d.key,staticClass:"att-group",class:{ 'att-group--today': d.isToday, 'att-group--future': d.isFuture },attrs:{"tabindex":"0"}},[_c('div',{staticClass:"att-pair"},[_c('div',{staticClass:"att-column"},[_c('div',{staticClass:"att-tooltip",attrs:{"role":"tooltip"}},[_c('p',{staticClass:"att-tooltip-title"},[_vm._v(_vm._s(d.day)+", "+_vm._s(d.date))]),_vm._v(" "),_c('p',{staticClass:"att-tooltip-row"},[_c('span',{staticClass:"legend-dot legend-present"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(d.present)+" present")])]),_vm._v(" "),_c('p',{staticClass:"att-tooltip-row"},[_c('span',{staticClass:"legend-dot legend-absent"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(d.absent)+" absent")])]),_vm._v(" "),(_vm.totalActiveEmployees)?_c('p',{staticClass:"att-tooltip-total"},[_vm._v("\n                  "+_vm._s(d.present)+" of "+_vm._s(_vm.totalActiveEmployees)+" active\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"att-bar att-present",style:({ height: _vm.attendanceBarHeight(d.present) + 'px' })}),_vm._v(" "),_c('div',{staticClass:"att-bar att-absent",style:({ height: _vm.attendanceBarHeight(d.absent) + 'px' })})])]),_vm._v(" "),_c('span',{staticClass:"att-label"},[_vm._v(_vm._s(d.day))])])}),0):(_vm.loading.attendance)?_c('div',{staticClass:"att-skeleton"},_vm._l((7),function(n){return _c('div',{key:'sk-att-' + n,staticClass:"sk sk-att"})}),0):_vm._e(),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"panel panel-events"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"event-list"},[(_vm.loading.events)?_vm._l((3),function(n){return _c('div',{key:'sk-evt-' + n,staticClass:"event-row"},[_vm._m(3,true),_vm._v(" "),_vm._m(4,true)])}):[_vm._l((_vm.events),function(ev,i){return _c('div',{key:i,staticClass:"event-row"},[_c('div',{staticClass:"event-date"},[_c('span',{staticClass:"event-day"},[_vm._v(_vm._s(ev.day))]),_vm._v(" "),_c('span',{staticClass:"event-month"},[_vm._v(_vm._s(ev.month))])]),_vm._v(" "),_c('div',{staticClass:"event-details"},[_c('p',{staticClass:"event-title"},[_vm._v(_vm._s(ev.title))]),_vm._v(" "),_c('p',{staticClass:"event-desc"},[_vm._v(_vm._s(ev.desc))]),_vm._v(" "),_c('span',{staticClass:"event-tag",class:ev.tagClass},[_vm._v(_vm._s(ev.tag))])])])}),_vm._v(" "),(!_vm.events.length)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"now-ui-icons objects_globe",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"empty-state-title"},[_vm._v("Nothing scheduled ahead")]),_vm._v(" "),_c('p',{staticClass:"empty-text"},[_vm._v("No upcoming meetings or holidays")])]):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"panel panel-leaves"},[_c('div',{staticClass:"panel-header"},[_vm._m(5),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/leave"}},[_vm._v("View All →")])],1),_vm._v(" "),_c('div',{staticClass:"leave-list"},[(_vm.leavesLoading)?_vm._l((4),function(n){return _c('div',{key:'sk-leave-' + n,staticClass:"leave-item"},[_vm._m(6,true)])}):[_vm._l((_vm.leaveRequests),function(leave,i){return _c('div',{key:leave.id,staticClass:"leave-item"},[_c('div',{staticClass:"leave-row"},[_c('div',{staticClass:"leave-avatar",style:(_vm.avatarStyle(i))},[_vm._v(_vm._s(_vm.initials(leave.name)))]),_vm._v(" "),_c('div',{staticClass:"leave-info"},[_c('p',{staticClass:"leave-name"},[_vm._v(_vm._s(leave.name))]),_vm._v(" "),_c('p',{staticClass:"leave-date"},[_vm._v(_vm._s(leave.dates)+" · "+_vm._s(leave.type))])]),_vm._v(" "),_c('div',{staticClass:"leave-actions"},[_c('button',{staticClass:"leave-btn btn-approve",attrs:{"disabled":leave.busy},on:{"click":function($event){return _vm.openDecision(leave, 'Approved')}}},[_vm._v("Approve")]),_vm._v(" "),_c('button',{staticClass:"leave-btn btn-reject",attrs:{"disabled":leave.busy},on:{"click":function($event){return _vm.openDecision(leave, 'Rejected')}}},[_vm._v("Reject")])])]),_vm._v(" "),(_vm.pendingDecision && _vm.pendingDecision.id === leave.id)?_c('div',{staticClass:"leave-decision"},[_c('label',{staticClass:"decision-label",attrs:{"for":'leave-comment-' + leave.id}},[_vm._v("\n                Comment\n                "),_c('span',{staticClass:"decision-hint"},[_vm._v(_vm._s(_vm.pendingDecision.status === "Approved" ? "Approving" : "Rejecting")+" "+_vm._s(leave.name)+"'s request")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.pendingDecision.comment),expression:"pendingDecision.comment"}],staticClass:"decision-textarea",attrs:{"id":'leave-comment-' + leave.id,"rows":"2","placeholder":_vm.pendingDecision.status === 'Approved'
                  ? 'Reason for approving (optional)'
                  : 'Reason for rejecting (optional)'},domProps:{"value":(_vm.pendingDecision.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pendingDecision, "comment", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"decision-actions"},[_c('button',{staticClass:"leave-btn btn-cancel",attrs:{"disabled":leave.busy},on:{"click":_vm.cancelDecision}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"leave-btn",class:_vm.pendingDecision.status === 'Approved' ? 'btn-approve' : 'btn-reject',attrs:{"disabled":leave.busy},on:{"click":_vm.confirmDecision}},[_vm._v("\n                  "+_vm._s(leave.busy ? "Saving…" : "Confirm " + _vm.pendingDecision.status)+"\n                ")])])]):_vm._e()])}),_vm._v(" "),(!_vm.leaveRequests.length)?_c('p',{staticClass:"empty-text"},[_vm._v("\n            No pending leave requests from the last 30 days\n          ")]):_vm._e(),_vm._v(" "),(_vm.stalePendingLeaves)?_c('p',{staticClass:"stale-note"},[_vm._v("\n            "+_vm._s(_vm.stalePendingLeaves)+" older pending\n            "+_vm._s(_vm.stalePendingLeaves === 1 ? "request" : "requests")+" in Leave Management\n          ")]):_vm._e()]],2)])]),_vm._v(" "),_c('div',{staticClass:"panels-row panels-row-triple"},[[_c('div',{staticClass:"panel panel-payroll"},[_c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Payroll — "+_vm._s(_vm.payroll.monthLabel))]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("SUMMARY")])]),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/payroll"}},[_vm._v("View All →")])],1),_vm._v(" "),_c('div',{staticClass:"summary-row"},[_c('span',{staticClass:"summary-key"},[_vm._v("Total employees")]),_vm._v(" "),_c('span',{staticClass:"summary-val"},[_vm._v(_vm._s(_vm.payroll.payrollEmployeeCount))])]),_vm._v(" "),_c('div',{staticClass:"summary-row"},[_c('span',{staticClass:"summary-key"},[_vm._v("Processed")]),_vm._v(" "),_c('span',{staticClass:"summary-val val-green"},[_vm._v(_vm._s(_vm.payroll.processed))])]),_vm._v(" "),(_vm.payroll.draft)?_c('div',{staticClass:"summary-row"},[_c('span',{staticClass:"summary-key"},[_vm._v("Draft")]),_vm._v(" "),_c('span',{staticClass:"summary-val val-amber"},[_vm._v(_vm._s(_vm.payroll.draft))])]):_vm._e(),_vm._v(" "),(_vm.payroll.hasEstimate)?_c('div',{staticClass:"summary-row"},[_c('span',{staticClass:"summary-key"},[_vm._v("Estimated from salary")]),_vm._v(" "),_c('span',{staticClass:"summary-val val-amber"},[_vm._v(_vm._s(_vm.payroll.estimatedCount))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"summary-row"},[_c('span',{staticClass:"summary-key"},[_vm._v("Total salaries")]),_vm._v(" "),_c('span',{staticClass:"summary-val"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.payroll.realSalaries)))])]),_vm._v(" "),(_vm.payroll.hasEstimate)?_c('div',{staticClass:"summary-row"},[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"summary-val val-amber"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.payroll.estimatedSalaries)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"summary-row"},[_c('span',{staticClass:"summary-key"},[_vm._v("Total taxes")]),_vm._v(" "),_c('span',{staticClass:"summary-val"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.payroll.totalTaxes)))])]),_vm._v(" "),_c('button',{staticClass:"primary-btn",on:{"click":function($event){return _vm.$router.push('/payroll')}}},[_vm._v("Generate Payslips")])])],_vm._v(" "),_c('div',{staticClass:"panel panel-activity"},[_c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Recent Activity")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v(_vm._s(_vm.activitySubtitle))])]),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/activity-logs"}},[_vm._v("View All →")])],1),_vm._v(" "),_c('div',{staticClass:"activity-list"},[(_vm.loading.activity)?_vm._l((5),function(n){return _c('div',{key:'sk-act-' + n,staticClass:"activity-row"},[_c('div',{staticClass:"sk sk-dot"}),_vm._v(" "),_vm._m(8,true)])}):[_vm._l((_vm.activity),function(item){return _c('div',{key:item.id,staticClass:"activity-row"},[_c('span',{staticClass:"activity-dot",style:({ backgroundColor: item.color })}),_vm._v(" "),_c('div',{staticClass:"activity-body"},[_c('p',{staticClass:"activity-text"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('p',{staticClass:"activity-time"},[_vm._v(_vm._s(item.time))])])])}),_vm._v(" "),(!_vm.activity.length)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"now-ui-icons ui-1_bell-53",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"empty-state-title"},[_vm._v("No activity yet")]),_vm._v(" "),_c('p',{staticClass:"empty-text"},[_vm._v("Admin actions will show up here")])]):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"panel panel-bugs"},[_c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Reported Bugs")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v(_vm._s(_vm.bugsSubtitle))])]),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/reported-bugs"}},[_vm._v("View All →")])],1),_vm._v(" "),_c('div',{staticClass:"bug-list"},[(_vm.loading.bugs)?_vm._l((4),function(n){return _c('div',{key:'sk-bug-' + n,staticClass:"bug-row"},[_vm._m(9,true),_vm._v(" "),_c('div',{staticClass:"sk sk-badge"})])}):[_vm._l((_vm.bugs),function(bug){return _c('div',{key:bug.id,staticClass:"bug-row"},[_c('div',{staticClass:"bug-body"},[_c('p',{staticClass:"bug-text"},[_vm._v(_vm._s(bug.text))]),_vm._v(" "),_c('p',{staticClass:"bug-meta"},[_vm._v(_vm._s(bug.time)+" · "+_vm._s(bug.reporter))])]),_vm._v(" "),_c('div',{staticClass:"bug-badges"},[(bug.priority)?_c('span',{staticClass:"bug-priority",class:'bug-priority--' + bug.priorityClass},[_vm._v(_vm._s(bug.priority))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"bug-badge",class:bug.resolved ? 'bug-resolved' : 'bug-open'},[_vm._v("\n                "+_vm._s(bug.resolved ? 'Resolved' : 'Open')+"\n              ")])])])}),_vm._v(" "),(!_vm.bugs.length)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"now-ui-icons objects_diamond",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"empty-state-title"},[_vm._v("Nothing to fix right now")]),_vm._v(" "),_c('p',{staticClass:"empty-text"},[_vm._v("No bugs reported in the last 24 hours")])]):_vm._e()]],2)])],2),_vm._v(" "),_c('div',{staticClass:"panels-row panels-row-triple"},[_c('div',{staticClass:"panel panel-performance"},[_c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Performance — "+_vm._s(_vm.lastMonthRange.month)+" "+_vm._s(_vm.lastMonthRange.year))]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("ALL EMPLOYEES")])]),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/performance"}},[_vm._v("View All →")])],1),_vm._v(" "),_c('div',{staticClass:"perf-list"},[(_vm.loading.performance)?_vm._l((14),function(n){return _c('div',{key:'sk-perf-' + n,staticClass:"perf-row"},[_c('div',{staticClass:"sk sk-emp"}),_vm._v(" "),_c('div',{staticClass:"sk sk-bar-lg"}),_vm._v(" "),_c('div',{staticClass:"sk sk-pct"}),_vm._v(" "),_c('div',{staticClass:"sk sk-badge"})])}):[_vm._l((_vm.performance),function(p){return _c('div',{key:p.uid,staticClass:"perf-row"},[_c('div',{staticClass:"perf-emp"},[_c('span',{staticClass:"perf-name"},[_vm._v(_vm._s(p.name))]),_vm._v(" "),(p.gradeLabel)?_c('span',{staticClass:"perf-grade"},[_vm._v(_vm._s(p.gradeLabel))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"perf-bar-track"},[_c('div',{staticClass:"perf-bar-fill",style:({ width: p.pct + '%', backgroundColor: p.color })})]),_vm._v(" "),_c('span',{staticClass:"perf-pct"},[_vm._v(_vm._s(p.display))]),_vm._v(" "),_c('span',{staticClass:"perf-badge",class:p.badgeClass},[_vm._v(_vm._s(p.label))])])}),_vm._v(" "),(!_vm.performance.length)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"now-ui-icons business_chart-bar-32",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"empty-state-title"},[_vm._v("No performance data")]),_vm._v(" "),_c('p',{staticClass:"empty-text"},[_vm._v("Nothing recorded for last month")])]):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"panel panel-complains"},[_c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Complains")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v(_vm._s(_vm.complainsSubtitle))])]),_vm._v(" "),_c('router-link',{staticClass:"panel-link",attrs:{"to":"/complains"}},[_vm._v("View All →")])],1),_vm._v(" "),_c('div',{staticClass:"complain-list"},[(_vm.loading.complains)?_vm._l((3),function(n){return _c('div',{key:'sk-cmp-' + n,staticClass:"complain-row"},[_c('div',{staticClass:"sk sk-title"}),_vm._v(" "),_c('div',{staticClass:"sk sk-desc"}),_vm._v(" "),_c('div',{staticClass:"sk sk-tag"})])}):[_vm._l((_vm.complains),function(c){return _c('div',{key:c.id,staticClass:"complain-row"},[_c('div',{staticClass:"complain-body"},[_c('p',{staticClass:"complain-text"},[_vm._v(_vm._s(c.text))]),_vm._v(" "),_c('p',{staticClass:"complain-meta"},[_vm._v("\n                "+_vm._s(c.time)),(c.reporter)?_c('span',[_vm._v(" · "+_vm._s(c.reporter))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"complain-badges"},[_c('span',{staticClass:"complain-chip",class:'complain-chip--' + c.priorityClass},[_vm._v(_vm._s(c.priority))]),_vm._v(" "),_c('span',{staticClass:"complain-chip",class:'complain-chip--' + c.statusClass},[_vm._v(_vm._s(c.status))]),_vm._v(" "),(c.type !== 'General')?_c('span',{staticClass:"complain-chip complain-chip--type"},[_vm._v(_vm._s(c.type))]):_vm._e()])])}),_vm._v(" "),(!_vm.complains.length)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"now-ui-icons ui-1_check",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"empty-state-title"},[_vm._v("Nothing to resolve")]),_vm._v(" "),_c('p',{staticClass:"empty-text"},[_vm._v("No recent complains raised")])]):_vm._e()]],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Attendance")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("THIS WEEK PERFORMANCE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"att-legend"},[_c('div',{staticClass:"legend-item"},[_c('span',{staticClass:"legend-dot legend-present"}),_vm._v("Present")]),_vm._v(" "),_c('div',{staticClass:"legend-item"},[_c('span',{staticClass:"legend-dot legend-absent"}),_vm._v("Absent")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Upcoming")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("COMPANY-WIDE MEETINGS & HOLIDAYS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-date"},[_c('div',{staticClass:"sk sk-day"}),_vm._v(" "),_c('div',{staticClass:"sk sk-mon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-details"},[_c('div',{staticClass:"sk sk-title"}),_vm._v(" "),_c('div',{staticClass:"sk sk-desc"}),_vm._v(" "),_c('div',{staticClass:"sk sk-tag"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"panel-title"},[_vm._v("Leave Requests")]),_vm._v(" "),_c('p',{staticClass:"panel-subtitle"},[_vm._v("PENDING APPROVALS · LAST 30 DAYS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leave-row"},[_c('div',{staticClass:"sk sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-grow"},[_c('div',{staticClass:"sk sk-title"}),_vm._v(" "),_c('div',{staticClass:"sk sk-desc"})]),_vm._v(" "),_c('div',{staticClass:"leave-actions"},[_c('div',{staticClass:"sk sk-btn"}),_vm._v(" "),_c('div',{staticClass:"sk sk-btn"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"summary-key"},[_vm._v("\n            Pending salaries\n            "),_c('span',{staticClass:"estimate-tag"},[_vm._v("ESTIMATED")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-grow"},[_c('div',{staticClass:"sk sk-line"}),_vm._v(" "),_c('div',{staticClass:"sk sk-line-sm"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-grow"},[_c('div',{staticClass:"sk sk-title"}),_vm._v(" "),_c('div',{staticClass:"sk sk-desc"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tjNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileForm_vue__ = __webpack_require__("bwkV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e989090_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileForm_vue__ = __webpack_require__("qyaE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e989090_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "trEX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notificationService__ = __webpack_require__("l527");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var clickOutsideDirective = {
  bind: function bind(el, binding) {
    el.__clickOutsideHandler__ = function (event) {
      if (!el.contains(event.target)) binding.value(event);
    };
    document.addEventListener("mousedown", el.__clickOutsideHandler__);
  },
  unbind: function unbind(el) {
    document.removeEventListener("mousedown", el.__clickOutsideHandler__);
  }
};

var PAGE_SIZE = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NotificationBell",

  directives: {
    "click-outside": clickOutsideDirective
  },

  props: {
    userId: {
      type: String,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isPanelOpen: false,
      showUnreadOnly: localStorage.getItem("notif_unread_only") === "true",
      loading: true,
      loadingMore: false,
      allNotifications: [],
      visibleCount: PAGE_SIZE,
      unsubscribe: null,
      seenChromeIds: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a()
    };
  },


  computed: {
    filteredNotifications: function filteredNotifications() {
      if (this.showUnreadOnly) {
        return this.allNotifications.filter(function (n) {
          return !n.isRead;
        });
      }
      return this.allNotifications;
    },
    displayedNotifications: function displayedNotifications() {
      return this.filteredNotifications.slice(0, this.visibleCount);
    },
    unreadCount: function unreadCount() {
      return this.allNotifications.filter(function (n) {
        return !n.isRead;
      }).length;
    },
    hasMore: function hasMore() {
      return this.visibleCount < this.filteredNotifications.length;
    },
    remainingCount: function remainingCount() {
      return Math.min(PAGE_SIZE, this.filteredNotifications.length - this.visibleCount);
    }
  },

  watch: {
    userId: {
      immediate: true,
      handler: function handler(newId) {
        this.teardown();
        if (newId) this.setup(newId);
      }
    },

    showUnreadOnly: function showUnreadOnly(val) {
      this.visibleCount = PAGE_SIZE;
      localStorage.setItem("notif_unread_only", val);
    },
    allNotifications: function allNotifications(newList, oldList) {
      var _this = this;

      if (oldList.length === 0) return;
      newList.forEach(function (notif) {
        if (!notif.isRead && !_this.seenChromeIds.has(notif.id)) {
          _this.seenChromeIds.add(notif.id);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_notificationService__["c" /* showChromeNotification */])(notif.title, {
            body: notif.message,
            tag: notif.id
          });
        }
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.teardown();
  },


  methods: {
    markAllNotificationsRead: function markAllNotificationsRead() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.userId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_notificationService__["d" /* markAllAsRead */])(_this2.userId);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);

                console.error("Failed to mark all as read", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 7]]);
      }))();
    },
    setup: function setup(userId) {
      var _this3 = this;

      this.loading = true;

      var tryListen = function tryListen(attempts) {
        try {
          __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.app();

          _this3.unsubscribe = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_notificationService__["e" /* listenToNotifications */])(userId, function (notifications) {
            if (_this3.loading) {
              notifications.forEach(function (n) {
                return _this3.seenChromeIds.add(n.id);
              });
            }
            _this3.allNotifications = notifications;
            _this3.loading = false;
          });
        } catch (e) {
          if (attempts > 0) {
            setTimeout(function () {
              return tryListen(attempts - 1);
            }, 300);
          } else {
            console.error("Firebase failed to initialize after retries.");
            _this3.loading = false;
          }
        }
      };

      tryListen(10);
    },
    teardown: function teardown() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      this.allNotifications = [];
      this.loading = true;
    },
    togglePanel: function togglePanel() {
      this.isPanelOpen = !this.isPanelOpen;
      if (this.isMobile && this.isPanelOpen) {
        this.$emit('close');
      }
    },
    closePanel: function closePanel() {
      this.isPanelOpen = false;
    },
    handleNotifClick: function handleNotifClick(notif) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var target;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (notif.isRead) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_notificationService__["f" /* markAsRead */])(_this4.userId, notif.id);

              case 3:
                target = notif.navigateTo || "/leave";

                if (_this4.$route && _this4.$route.fullPath !== target) {
                  _this4.$router.push(target);
                }
                _this4.closePanel();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    loadMore: function loadMore() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.loadingMore = true;
                _context3.next = 3;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (r) {
                  return setTimeout(r, 300);
                });

              case 3:
                _this5.visibleCount += PAGE_SIZE;
                _this5.loadingMore = false;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return "";
      var d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    },
    timeAgo: function timeAgo(timestamp) {
      if (!timestamp) return "";
      var diff = Date.now() - timestamp;
      var mins = Math.floor(diff / 60000);
      if (mins < 1) return "just now";
      if (mins < 60) return mins + "m ago";
      var hrs = Math.floor(mins / 60);
      if (hrs < 24) return hrs + "h ago";
      var days = Math.floor(hrs / 24);
      if (days < 7) return days + "d ago";
      return new Date(timestamp).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short"
      });
    }
  }
});

/***/ }),

/***/ "u4P3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z/c4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270e0610_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("RmNJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270e0610_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uBxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceByGrade_vue__ = __webpack_require__("Pu0m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d33184c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceByGrade_vue__ = __webpack_require__("aqFc");
function injectStyle (ssrContext) {
  __webpack_require__("Wll5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d33184c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceByGrade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d33184c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceByGrade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uNpY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vDrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkingDays_vue__ = __webpack_require__("zIXY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c02d24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkingDays_vue__ = __webpack_require__("Hv92");
function injectStyle (ssrContext) {
  __webpack_require__("W/Va")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32c02d24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkingDays_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c02d24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkingDays_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vGmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "va8f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vh+9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vlEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",_vm._l((_vm.columns),function(column){return _c('th',{key:JSON.stringify(column)},[_vm._v(_vm._s(column))])}))],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{key:JSON.stringify(item)},[_vm._t("default",_vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',{key:JSON.stringify(column)},[(_vm.isImage(item, column))?_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"20px"},attrs:{"src":item['profile_picture'] || __webpack_require__("smu3")}}):_c('span',[_vm._v(_vm._s(_vm.itemValue(item, column)))])]):_vm._e()}),{"item":item})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w2Je":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReuseableModal_vue__ = __webpack_require__("GIso");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3009e0a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReuseableModal_vue__ = __webpack_require__("64t6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReuseableModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3009e0a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReuseableModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wL/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__ = __webpack_require__("gY6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UIComponents_Buttons_ResetIconButton_vue__ = __webpack_require__("0IWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Payslip_PaySlip_vue__ = __webpack_require__("1rke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__ = __webpack_require__("guQB");









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "SalaryCalculation",
    components: {
        ResetIconButton: __WEBPACK_IMPORTED_MODULE_11__UIComponents_Buttons_ResetIconButton_vue__["a" /* default */],
        PaySlip: __WEBPACK_IMPORTED_MODULE_12__Payslip_PaySlip_vue__["a" /* default */]
    },
    props: ["employee", "initialValues", "paymentProcessedLoaded", "draftLoaded", "isActionProcessing"],
    data: function data() {
        var user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin",
            perDaySalaryInput: "",
            totalDaysSalaryInput: "",
            lateDeductionInput: "",
            leavesEncashmentAmountInput: "",
            extraAmountAdjustmentInput: "",
            bonusInput: "",
            transactionFeesInput: "",
            lateSalaryDeductionInput: 0,
            lateDeductionDays: 0,
            lateArrivalsInput: "",
            finalAmount: 0,
            annualLeavesEncashmentDays: 0,
            annualLeavesEncashmentAmount: 0,
            isProcessed: false,
            perDaySalaryManuallySet: false,
            leaveDeductionDays: 0,
            manualSalaryDeduction: null,
            manualLeaveEncashmentUpdate: false,
            leavesDaysReducedByLate: 0,
            extraAmountAdjustmentNoteInput: "",
            isleaveInfoVisible: false,
            isAdjustmentInfoVisible: false,
            adjustmentShowHoverTooltip: false,
            isTaxInfoVisible: false,
            isAdjustmentDetailsVisible: false,
            taxDeductionInput: 0,
            taxSlabs: {},
            adjustments: [],
            appliedAdjustments: {}
        };
    },

    created: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _this = this;

            var note, lowExtraHoursPattern;
            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__["a" /* default */].fetchTaxSlabs();

                        case 3:
                            this.taxSlabs = _context.sent;
                            _context.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_13__assets_config_firebase__["a" /* default */].getAdjustments(this.employee.year, this.employee.month, this.employee.employeeId);

                        case 6:
                            this.adjustments = _context.sent;

                            // Initialize appliedAdjustments based on extraAmountAdjustmentNoteInput
                            note = this.employee.extraAmountAdjustmentNote || '';

                            this.adjustments.forEach(function (adj) {
                                var isNonCustom = adj.amount.includes('x') || adj.amount.includes('day');
                                var amountDisplay = Math.round(Math.abs(typeof adj.amount === 'number' ? adj.amount : _this.calculateAdjustmentAmount(adj.amount)));
                                var notePattern = 'Rs. ' + amountDisplay + (isNonCustom ? '(' + adj.amount + ')' : '') + ' (' + adj.adjustmentType + ') ' + adj.reason;
                                if (note.includes(notePattern)) {
                                    _this.$set(_this.appliedAdjustments, adj.id, true);
                                }
                            });
                            // Check for Low/Extra Hours adjustment
                            lowExtraHoursPattern = 'Rs. ' + Math.abs(this.calculateExtraAmount()) + ' for Low/Extra Hours Sum:';

                            if (note.includes(lowExtraHoursPattern)) {
                                this.$set(this.appliedAdjustments, 'lowExtraHours', true);
                            }
                            _context.next = 15;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](0);

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 13]]);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    computed: {
        selectedEmployee: function selectedEmployee() {
            return this.$store.state.payroll.selectedEmployeePayroll || {};
        },
        taxDeduction: function taxDeduction() {
            var availableYears = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.taxSlabs).map(Number).sort(function (a, b) {
                return b - a;
            });
            var selectedYear = availableYears.includes(Number(this.employee.year)) ? Number(this.employee.year) : availableYears[0] || 2025;
            var slabs = this.taxSlabs[selectedYear] || {};

            var annualSalary = ((this.selectedEmployee.basicSalary || 0) + (this.selectedEmployee.extraAllowance || 0)) * 12;
            var medicalExemption = annualSalary * 0.065;
            var taxableSalary = annualSalary - medicalExemption;

            var annualTax = 0;
            var thresholds = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(slabs).map(Number).sort(function (a, b) {
                return a - b;
            });
            for (var i = 0; i < thresholds.length; i++) {
                var threshold = thresholds[i];
                var slab = slabs[threshold];
                var nextThreshold = thresholds[i + 1] || Infinity;
                if (taxableSalary >= threshold && taxableSalary < nextThreshold) {
                    annualTax = slab.fixed + (taxableSalary - threshold) * (slab.percentage / 100);
                    break;
                }
            }

            var monthlyTax = annualTax / 12;
            this.taxDeductionInput = monthlyTax.toFixed(1);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["j" /* stripeLeadingZero */])(monthlyTax.toFixed(1));
        },
        formattedTaxSlabs: function formattedTaxSlabs() {
            var availableYears = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.taxSlabs).map(Number).sort(function (a, b) {
                return b - a;
            });
            var selectedYear = availableYears.includes(Number(this.employee.year)) ? Number(this.employee.year) : availableYears[0] || 2025;
            var slabs = this.taxSlabs[selectedYear] || {};
            var thresholds = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(slabs).map(Number).sort(function (a, b) {
                return a - b;
            });
            var formatted = [];
            for (var i = 0; i < thresholds.length; i++) {
                var threshold = thresholds[i];
                var slab = slabs[threshold];
                var nextThreshold = thresholds[i + 1] || Infinity;
                var range = nextThreshold === Infinity ? 'Above Rs. ' + threshold.toLocaleString() : 'Rs. ' + threshold.toLocaleString() + ' - Rs. ' + (nextThreshold - 1).toLocaleString();
                var rate = slab.percentage === 0 ? '0%' : slab.percentage + '%';
                var fixed = slab.fixed > 0 ? 'Rs. ' + slab.fixed.toLocaleString() + ' + ' : '';
                formatted.push(range + ': ' + fixed + rate + (slab.percentage > 0 ? ' of amount exceeding Rs. ' + threshold.toLocaleString() : ''));
            }
            return formatted;
        },
        salary: function salary() {
            var employee = this.selectedEmployee;
            if (!employee) return {};

            var grossSalary = (employee.basicSalary || 0) + (employee.extraAllowance || 0);
            var calculatedSalary = employee.calculatedSalary || 0;
            var lateDeduction = parseFloat(this.perDayWorkedSalary) * parseFloat(this.calculatedSalaryDeductionDays);

            var workingDays = employee.daysWorked || 0;
            var perDaySalary = employee.perDaySalary || (grossSalary / workingDays).toFixed(2);
            var extraAmountAdjustment = Number(employee.extraAmountAdjustment) || 0;
            var bonus = Number(employee.bonus) || 0;
            var totalSalary = (Number(calculatedSalary) - Number(lateDeduction) + Number(extraAmountAdjustment) + Number(bonus)).toFixed(2);
            var totalDaysSalary = (Number(employee.perDaySalary) * Number(employee.daysWorked) || 0).toFixed(2);
            var leavesEncashmentAmount = Number(employee.perDaySalary * this.leavesCountReducedByLate) || 0;
            var transactionFees = Number(employee.transactionFees) || 0;
            var taxDeduction = Number(this.taxDeduction) || 0;
            var finalAmount = totalDaysSalary - lateDeduction + leavesEncashmentAmount + extraAmountAdjustment + bonus + transactionFees - taxDeduction;
            var annualLeaves = totalDaysSalary - lateDeduction + leavesEncashmentAmount + extraAmountAdjustment + transactionFees;
            var annualLeavesEncashmentAmount = (leavesEncashmentAmount + Number(employee.perDaySalary) * Number(employee.annualLeavesEncashmentDays)).toFixed(2);
            this.annualLeavesEncashmentAmount = annualLeavesEncashmentAmount || 0;

            return {
                perDaySalary: perDaySalary,
                lateDeduction: lateDeduction,
                totalSalary: totalSalary,
                transactionFees: transactionFees,
                taxDeduction: taxDeduction,
                finalAmount: finalAmount,
                extraAmountAdjustment: extraAmountAdjustment,
                bonus: bonus,
                leavesEncashmentAmount: leavesEncashmentAmount,
                totalDaysSalary: totalDaysSalary,
                annualLeavesEncashmentAmount: annualLeavesEncashmentAmount
            };
        },
        formattedTotalSalary: function formattedTotalSalary() {
            return Number(this.salary.totalSalary).toLocaleString();
        },
        formattedFinalAmount: function formattedFinalAmount() {
            return Number(this.salary.finalAmount).toLocaleString();
        },
        leavesTakenSalary: function leavesTakenSalary() {
            var leavesTaken = this.selectedEmployee.obtainedLeaves.split(" / ")[0] || 0;
            return this.salary.perDaySalary * leavesTaken || 0;
        },
        formattedLeavesTakenSalary: function formattedLeavesTakenSalary() {
            var perDaySalary = Number(this.salary.perDaySalary);
            console.log(this.salary.perDaySalary);
            if (perDaySalary) return perDaySalary.toLocaleString() || 0;
            return Number(0).toLocaleString();
        },
        formattedPerDayWorkedSalary: function formattedPerDayWorkedSalary() {
            return Number(this.selectedEmployee.perDaySalary).toLocaleString();
        },
        formattedPerHoursalary: function formattedPerHoursalary() {
            return Number(this.selectedEmployee.perDaySalary / this.selectedEmployee.empTotalHours).toFixed(2);
        },
        perDayWorkedSalary: function perDayWorkedSalary() {
            return Number(this.selectedEmployee.perDaySalary);
        },
        calculatedSalaryDeductionDays: function calculatedSalaryDeductionDays() {
            return this.lateDeductionDays;
        },
        leavesCountReducedByLate: function leavesCountReducedByLate() {
            var employee = this.selectedEmployee || {};
            var recentUpdatedField = this.employee.recentUpdatedField;
            var manualLeaveDeduction = Number(this.employee.manualLeaveDeductionDays) || 0;
            var systemLeaveDeduction = Number(this.employee.leaveDeductionCount || this.employee.leavesDeductionDays) || 0;
            var manualDeduction = Number(employee.leavesDeductionDays) || 0;

            var obtainedLeavesStr = employee.obtainedLeaves || "0 / 0";
            var initObtainedLeavesStr = this.initialValues.obtainedLeaves || "0 / 0";

            var _ref2 = obtainedLeavesStr.split(" / ").map(Number) || [0],
                _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 1),
                obtainedLeaves = _ref3[0];

            var _ref4 = initObtainedLeavesStr.split(" / ").map(Number) || [0],
                _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 1),
                initObtainedLeaves = _ref5[0];

            var lateCount = parseInt(this.lateArrivalsInput) || 0;
            var isUpdatedLateArrivals = employee.lateArrivals != this.initialValues.lateArrivals;
            var updatedLateArrivals = isUpdatedLateArrivals ? employee.lateArrivals : lateCount;

            var isUpdatedLeavesTaken = obtainedLeaves !== initObtainedLeaves;
            var updatedLeavesTaken = isUpdatedLeavesTaken ? obtainedLeaves : initObtainedLeaves;

            if (isUpdatedLeavesTaken && recentUpdatedField == "leavesTaken") {
                return Math.max(updatedLeavesTaken - systemLeaveDeduction, 0);
            }

            var salaryDeduction = 0;
            var leaveDeduction = 0;

            if (!manualLeaveDeduction || updatedLateArrivals) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["d" /* newLateThresholds */]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var threshold = _step.value;

                        if (updatedLateArrivals >= threshold.min) {
                            salaryDeduction = threshold.salaryDeduct;
                            leaveDeduction = threshold.leaveDeduct;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            var leavesTaken = Number(employee.leavesTaken) || 0;
            var adjustedLeaves = leavesTaken;

            // ✅ Issue 1 FIX: Late deductions don't affect encashment
            if (recentUpdatedField == "lateArrivals") {
                adjustedLeaves = Math.max(leavesTaken - leaveDeduction, 0);
                this.leavesEncashmentDays = leavesTaken; // Full leaves for encashment
                this.leavesDaysReducedByLate = leavesTaken; // Full leaves for salary calc
                this.salaryDeductionDays = salaryDeduction;
                return leavesTaken; // Return FULL leaves for encashment
            }

            if (isUpdatedLateArrivals && !manualLeaveDeduction) {
                if (systemLeaveDeduction === 0 && obtainedLeaves === 0) {
                    return 0;
                } else {
                    return leavesTaken; // Full leaves for encashment
                }
            }

            // ✅ Apply manual or system deduction
            var deductionToApply = this.employee.manualLeaveDeductionDays !== null && this.employee.manualLeaveDeductionDays !== undefined ? manualLeaveDeduction : leaveDeduction;

            deductionToApply = Math.min(deductionToApply, leavesTaken);

            if (leavesTaken === deductionToApply) {
                adjustedLeaves = 0;
            } else if (deductionToApply > 0) {
                adjustedLeaves = Math.max(leavesTaken - deductionToApply, 0);
            } else {
                var isLeaveDeduction = systemLeaveDeduction !== leavesTaken && leavesTaken > systemLeaveDeduction;
                var initialValue = Math.max(leavesTaken - this.employee.leavesDeductionDays, 0);
                adjustedLeaves = isLeaveDeduction ? initialValue || leavesTaken : initialValue || 0;
            }

            // ✅ Apply encashment if triggered
            if (this.manualLeaveEncashmentUpdate && employee.leavesDeductionDays) {
                var encashmentDeduction = employee.leavesDeductionDays >= 1 ? employee.leavesDeductionDays : 0;
                adjustedLeaves = Math.max(adjustedLeaves - encashmentDeduction, 0);
            }

            // ✅ Final assignments - ENCASHMENT uses FULL leaves
            this.leavesEncashmentDays = leavesTaken;
            this.leavesDaysReducedByLate = leavesTaken;
            this.salaryDeductionDays = salaryDeduction;
            this.leavesEncashmentDetails;
            return leavesTaken; // FIXED: Full leaves for encashment
        },
        calculateAnnualLeavesEncashmentDays: function calculateAnnualLeavesEncashmentDays() {
            var emp = this.selectedEmployee;
            return Number(emp.annualLeavesEncashmentDays || emp.leavesQuota && emp.leavesQuota.leavesEncashmentDays) || 0;
        },
        isDisabled: function isDisabled() {
            if (!this.isAdmin) return true;
        },
        isPaymentProcessed: function isPaymentProcessed() {
            if (this.selectedEmployee.status === "Processed") return true;
        },
        isDraftProcessed: function isDraftProcessed() {
            if (this.selectedEmployee.status === "Draft") return true;
        },
        totalDaysSalaryInputComputed: function totalDaysSalaryInputComputed() {
            this.manualSalaryDeduction = null;
            var perDay = parseFloat(this.selectedEmployee.perDaySalary) || 0;
            var days = parseFloat(this.selectedEmployee.daysWorked) || 0;
            this.totalDaysSalaryInput = (perDay * days).toFixed(2);
            return (perDay * days).toFixed(2);
        },

        lateSalaryDeductionUpdate: {
            get: function get() {
                if (this.manualSalaryDeduction !== null) {
                    return this.manualSalaryDeduction;
                }
                var perHourSalary = this.perDayWorkedSalary / this.selectedEmployee.empTotalHours;
                var deduction = (perHourSalary * 4 * this.lateDeductionDays).toFixed(2);

                this.lateSalaryDeductionInput = deduction;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["j" /* stripeLeadingZero */])(deduction);
            },
            set: function set(value) {
                this.manualSalaryDeduction = value;
                this.lateSalaryDeductionInput = value;

                var updatedLateDeduction = this.selectedEmployee.lateDeduction.split(" - ");
                updatedLateDeduction[0] = value || 0;
                this.selectedEmployee.lateDeduction = updatedLateDeduction.join(" - ");

                this.finalAmountUpdate();
            }
        },
        leavesEncashmentAmountUpdate: {
            get: function get() {
                // Otherwise calculate automatically
                var days = this.leavesCountReducedByLate + this.calculateAnnualLeavesEncashmentDays;
                console.log("🚀 ~ get ~ this.leavesCountReducedByLate:", this.leavesCountReducedByLate);
                var rate = this.perDayWorkedSalary;
                var calculatedValue = (days * rate).toFixed(2);
                this.leavesEncashmentAmountInput = calculatedValue;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["j" /* stripeLeadingZero */])(calculatedValue);
            },
            set: function set(value) {
                this.manualLeaveEncashmentUpdate = true;
                this.leavesEncashmentAmountInput = value;
                this.finalAmountUpdate();
                this.syncToEmployee();
            }
        },
        emptyLeaveBalance: function emptyLeaveBalance() {
            var leaveBalance = Number(this.selectedEmployee.leaveBalance) || 0;
            return leaveBalance > 0 ? false : true;
        },
        reactiveLeaveDays: function reactiveLeaveDays() {
            return this.employee.leavesDeductionDays || 0;
        },
        formattedTotalSpentHours: function formattedTotalSpentHours() {
            var emp = this.selectedEmployee;
            var totalHours = Number(emp.totalNormalHours) + Number(emp.totalExtraHours) + Number(emp.totalLowHours) + Number(emp.totalHalfDayHours) || 0;

            // const hours = Math.floor(totalHours);
            // const minutes = Math.round((totalHours - hours) * 60);

            // return `${totalHours.toFixed(2)} hrs`;
            return totalHours.toFixed(2) + ' hrs';
        },
        formattedRequiredHours: function formattedRequiredHours() {
            var emp = this.selectedEmployee;
            var reqWorkingHours = Number(emp.requiredTotalWorkingHours || emp.reqWorkingHours) || 0;
            this.employee.requiredTotalWorkingHours = reqWorkingHours;
            this.syncToEmployee();
            return reqWorkingHours.toLocaleString();
        },
        formattedDifference: function formattedDifference() {
            var emp = this.selectedEmployee;

            var totalNormalHours = Number(emp.totalNormalHours) || 0;
            var totalExtraHours = Number(emp.totalExtraHours) || 0;
            var totalLowHours = Number(emp.totalLowHours) || 0;
            var totalHalfDayHours = Number(emp.totalHalfDayHours) || 0;
            var requiredHours = Number(emp.requiredTotalWorkingHours || emp.reqWorkingHours) || 0;
            var perDayHours = Number(emp.perDayProductiveHours || emp.productiveHours) || 1;

            var spentHours = totalNormalHours + totalExtraHours + totalLowHours + totalHalfDayHours;
            var difference = spentHours - requiredHours;

            var sign = difference >= 0 ? "+" : "-";
            var absDifference = Math.abs(difference);

            var differenceInHours = Math.floor(absDifference);
            var differenceInMinutes = Math.round((absDifference - differenceInHours) * 60);

            var totalDecimalHours = differenceInHours + differenceInMinutes / 60;
            var equivalentDays = totalDecimalHours / perDayHours;

            return {
                hours: '' + sign + differenceInHours + ' hrs ' + differenceInMinutes + ' mins',
                days: '' + sign + equivalentDays.toFixed(2) + ' Days'
            };
        },
        differenceStyle: function differenceStyle() {
            var spentHours = Number(this.selectedEmployee.totalNormalHours) + Number(this.selectedEmployee.totalExtraHours) || 0;
            var requiredHours = Number(this.selectedEmployee.reqWorkingHours) || 0;
            var diff = spentHours - requiredHours;

            return diff < 0 ? { color: 'red' } : { color: 'green' };
        },
        isProcessing: function isProcessing() {
            return this.isActionProcessing;
        },
        leavesEncashmentDetails: function leavesEncashmentDetails() {
            var leaveTaken = Number(this.employee.leavesTaken) || 0;
            var leavesDeductionCount = Number(this.employee.leavesDeductionCount || this.employee.leavesDeductionDays) || 0;
            var leavesEncashmentDays = Math.max(leaveTaken - leavesDeductionCount, 0);

            var details = ['Leaves Taken: ' + leaveTaken, 'Leave Deductions (due to late arrivals): ' + leavesDeductionCount, 'Total Leave Deductions: ' + (leaveTaken - leavesDeductionCount), 'Encashable Leaves: ' + leavesEncashmentDays];

            return {
                leavesEncashmentDays: leavesEncashmentDays,
                details: details
            };
        },
        formattedLeavePolicy: function formattedLeavePolicy() {
            return __WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["d" /* newLateThresholds */].sort(function (a, b) {
                return a.min - b.min;
            }).map(function (threshold) {
                var parts = [];
                if (threshold.salaryDeduct > 0) {
                    parts.push(threshold.salaryDeduct * 4 + 'x per-hour salary deducted');
                }
                if (threshold.leaveDeduct > 0) {
                    parts.push(threshold.leaveDeduct + ' leave' + (threshold.leaveDeduct > 1 ? 's' : '') + ' deducted');
                }
                return threshold.min + '+ late arrivals: ' + parts.join(', ');
            });
        },
        getLeavesAllowed: function getLeavesAllowed() {
            return Number(this.employee.leavesAllowed) || 0;
        },
        getRequiredHoursInfo: function getRequiredHoursInfo() {
            var emp = this.employee;
            var monthNum = String(__WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["c" /* monthMap */][emp.month]).padStart(2, '0');
            var year = emp.year;
            var format = this.formatToHoursMinutes;

            var totalExtraHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(emp.totalExtraHoursDays);
            var requiredHoursTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(emp.requiredTotalWorkingDays);
            var requiredHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["l" /* formatHoursDetails */])(emp.requiredTotalWorkingDays, format, monthNum, year);

            var remainingNormalRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["m" /* getRemainingHours */])(emp.normalHoursDays, emp.empTotalHours, true);
            var remainingNormal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["n" /* formatAndFilterZeroMins */])(remainingNormalRaw, format, monthNum, year);
            var remainingNormalTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(remainingNormalRaw);

            var spentLowHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["n" /* formatAndFilterZeroMins */])(emp.lowHoursDays, format, monthNum, year);
            var spentLowHoursTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(emp.lowHoursDays);

            var normalHoursRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["m" /* getRemainingHours */])(emp.normalHoursDays, emp.empTotalHours, true);
            var normalHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["n" /* formatAndFilterZeroMins */])(normalHoursRaw, format, monthNum, year);
            var normalHoursTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(normalHoursRaw);

            var allNormalHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["l" /* formatHoursDetails */])(emp.normalHoursDays, format, monthNum, year);
            var allNormalHoursTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(emp.normalHoursDays);

            var remainingHalfDaysDetails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["l" /* formatHoursDetails */])(emp.remainingHalfDays, format, monthNum, year);
            var remainingHalfDaysTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(emp.remainingHalfDays);

            var halfDayHours = Number(emp.empTotalHours) / 2 + 0.5;
            var extraTimeAboveHalfDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["o" /* getAboveHalfDayExtra */])(emp.halfDays, halfDayHours);
            var extraTimeAboveHalfDayTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(extraTimeAboveHalfDay);
            var extraTimeAboveHalfDayDetails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["l" /* formatHoursDetails */])(extraTimeAboveHalfDay, format, monthNum, year);
            var extraTimeAboveHalfDayHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["n" /* formatAndFilterZeroMins */])(extraTimeAboveHalfDay, format, monthNum, year);

            var cumulativeOvertimeHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["p" /* sumHoursAndMinutes */])(totalExtraHours, extraTimeAboveHalfDayTotal);

            var spentHalfDaysDetails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["l" /* formatHoursDetails */])(emp.halfDays, format, monthNum, year);
            var spentHalfDaysTotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["k" /* calculateTotalHoursAndMinutes */])(emp.halfDays);

            return {
                requiredHoursDetails: requiredHours,
                remainingHalfDaysDetails: remainingHalfDaysDetails,
                spentHalfDaysDetails: spentHalfDaysDetails,
                totalExtraHoursDays: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_config_helpers__["l" /* formatHoursDetails */])(emp.totalExtraHoursDays, format, monthNum, year),
                remainingNormalHours: remainingNormal,
                spentLowHours: spentLowHours,
                normalHoursDetails: normalHours,
                allNormalHours: allNormalHours,
                cumulativeOvertimeHours: cumulativeOvertimeHours,
                extraHalfDaysHours: extraTimeAboveHalfDayDetails,
                totals: {
                    totalExtraHours: totalExtraHours,
                    remainingNormalTotal: remainingNormalTotal,
                    spentLowHoursTotal: spentLowHoursTotal,
                    normalHoursTotal: normalHoursTotal,
                    requiredHoursTotal: requiredHoursTotal,
                    allNormalHoursTotal: allNormalHoursTotal,
                    remainingHalfDaysTotal: remainingHalfDaysTotal,
                    spentHalfDaysTotal: spentHalfDaysTotal,
                    cumulativeOvertimeHours: cumulativeOvertimeHours,
                    extraTimeAboveHalfDayTotal: extraTimeAboveHalfDayTotal
                }
            };
        },
        tooltipSections: function tooltipSections() {
            var info = this.getRequiredHoursInfo;
            return [{ key: 'totalExtraHoursDays', title: 'Spent Extra Hours Details:', text: 'Extra Hours', items: info.totalExtraHoursDays }, { key: 'extraHalfDaysHours', title: 'Extra Half Days Hours Details:', text: 'Extra Half Days Hours', items: info.extraHalfDaysHours }, { key: 'spentLowHours', title: 'Unpaid Low Hours Details:', text: 'Unpaid Low Hours', items: info.spentLowHours }, { key: 'remainingNormalHours', title: 'Paid Low Hours Details:', text: 'Paid Low Hours', items: info.remainingNormalHours }];
        },
        totalsMap: function totalsMap() {
            var totals = this.getRequiredHoursInfo.totals;

            return {
                spentLowHours: totals.spentLowHoursTotal,
                normalHours: totals.normalHoursTotal,
                remainingNormalHours: totals.remainingNormalTotal,
                totalExtraHoursDays: totals.totalExtraHours,
                requiredHours: totals.requiredHoursTotal,
                allNormalHours: totals.allNormalHoursTotal,
                remainingHalfDays: totals.remainingHalfDaysTotal,
                spentHalfDays: totals.spentHalfDaysTotal,
                cumulativeOvertimeHours: totals.cumulativeOvertimeHours,
                extraHalfDaysHours: totals.extraTimeAboveHalfDayTotal
            };
        },
        totalSummary: function totalSummary() {
            var getTotalMins = function getTotalMins() {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return (obj.hrs || 0) * 60 + (obj.mins || 0);
            };

            var _totalsMap = this.totalsMap,
                allNormalHours = _totalsMap.allNormalHours,
                remainingNormalHours = _totalsMap.remainingNormalHours,
                spentLowHours = _totalsMap.spentLowHours,
                spentHalfDays = _totalsMap.spentHalfDays,
                totalExtraHoursDays = _totalsMap.totalExtraHoursDays,
                requiredHours = _totalsMap.requiredHours,
                extraTimeAboveHalfDay = _totalsMap.extraTimeAboveHalfDay,
                cumulativeOvertimeHours = _totalsMap.cumulativeOvertimeHours,
                extraHalfDaysHours = _totalsMap.extraHalfDaysHours;


            var perDayHours = Number(this.selectedEmployee.perDayProductiveHours || this.selectedEmployee.productiveHours) || 1;

            var normalTotalMins = getTotalMins(allNormalHours);
            var lowTotalMins = getTotalMins(spentLowHours);
            var halfDaysMins = getTotalMins(spentHalfDays);
            var extraHoursMins = getTotalMins(totalExtraHoursDays) + getTotalMins(extraTimeAboveHalfDay);
            var cumulativeOvertimeMins = getTotalMins(cumulativeOvertimeHours);
            var extraTimeAboveHalfDayMins = getTotalMins(extraHalfDaysHours);
            var requiredWorkingMins = getTotalMins(requiredHours);
            var remainingNormalMins = getTotalMins(remainingNormalHours);

            var summaryTotalMins = lowTotalMins + cumulativeOvertimeMins - remainingNormalMins;
            var grandTotalMins = summaryTotalMins;

            var diffMins = Math.abs(summaryTotalMins);
            var nonSignDiffMins = Math.abs(diffMins);

            var format = function format(mins) {
                var sign = mins < 0 ? '-' : '';
                var absMins = Math.abs(mins);
                var hrs = Math.floor(absMins / 60);
                var rem = absMins % 60;
                return '' + sign + hrs + ' hrs ' + rem + ' mins';
            };

            var sign = diffMins >= 0 ? '' : '-';
            var absDiffMins = Math.abs(diffMins);
            var diffHrs = Math.floor(absDiffMins / 60);
            var diffRemMins = absDiffMins % 60;
            var totalDecimalHours = diffHrs + diffRemMins / 60;
            var equivalentDays = totalDecimalHours / perDayHours;

            var nonSignAbsDiffMins = Math.abs(nonSignDiffMins);
            var nonSignDiffHrs = Math.floor(nonSignAbsDiffMins / 60);
            var nonSignDiffRemMins = nonSignAbsDiffMins % 60;
            var nonSignTotalDecimalHours = nonSignDiffHrs + nonSignDiffRemMins / 60;
            var nonSignEquivalentDays = nonSignTotalDecimalHours / perDayHours;

            return {
                normalAndRemainingNormal: format(normalTotalMins),
                lowAndRemainingLow: format(lowTotalMins),
                remainingNormalHours: format(remainingNormalMins),
                spentHalfDaysOnly: format(halfDaysMins),
                extraHours: format(extraHoursMins),
                cumulativeOvertimeHours: format(cumulativeOvertimeMins),
                extraHalfDaysHours: format(extraTimeAboveHalfDayMins),
                summaryTotal: format(summaryTotalMins),
                grandTotal: format(grandTotalMins),
                nonSignGrandTotal: format(Math.abs(grandTotalMins)),
                requiredWorkingHours: format(requiredWorkingMins),
                difference: {
                    text: '' + sign + diffHrs + ' hrs ' + diffRemMins + ' mins',
                    nonSignText: nonSignDiffHrs + ' hrs ' + nonSignDiffRemMins + ' mins',
                    days: '' + sign + equivalentDays.toFixed(2) + ' Days',
                    nonSignDays: '' + sign + nonSignEquivalentDays.toFixed(2) + ' Days',
                    isPositive: diffMins >= 0,
                    color: grandTotalMins >= 0 ? 'green' : 'red'
                }
            };
        },
        calcExtraAmountAdjustment: function calcExtraAmountAdjustment() {
            return this.calculateExtraAmount;
        },
        calculateExtraAmount: function calculateExtraAmount() {
            var hourlyRate = Number(this.employee.perDaySalary) / Number(this.empDayHours().empTotalHours);
            var extraHoursText = this.totalSummary.difference.nonSignText || '0 hrs 0 mins';

            var isNegative = this.totalSummary.grandTotal.trim().startsWith('-');
            var match = extraHoursText.match(/-?(\d+)\s*hrs?\s*(\d+)?\s*mins?/i);

            var hours = match ? Number(match[1]) : 0;
            var mins = match && match[2] ? Number(match[2]) : 0;

            var totalHours = hours + mins / 60;
            if (isNegative) totalHours = -totalHours;
            var finalvalue = Math.round(totalHours * hourlyRate);
            return finalvalue;
        },
        totalAdjustments: function totalAdjustments() {
            var _this2 = this;

            var perDaySalary = Number(this.selectedEmployee.perDaySalary) || 0;
            return this.adjustments.reduce(function (sum, adj) {
                var adjustmentValue = typeof adj.amount === 'number' ? adj.amount : _this2.calculateAdjustmentAmount(adj.amount);
                // Apply impact logic: add for Addition, subtract for Deduction
                if (adj.impact === "Addition") {
                    return sum + Math.abs(adjustmentValue);
                } else if (adj.impact === "Deduction") {
                    return sum - Math.abs(adjustmentValue);
                }
                return sum;
            }, 0).toFixed(2);
        }
    },
    watch: {
        employee: {
            immediate: true,
            deep: true,
            handler: function handler(newVal) {
                var emp = this.employee;
                emp.employeeName = newVal.employeeName || "";
                emp.basicSalary = newVal.basicSalary || 0;
                emp.extraAllowance = newVal.extraAllowance || 0;
                emp.perDaySalary = newVal.perDaySalary || 0;
                emp.requiredWorkingDays = newVal.requiredWorkingDays || 0;
                this.perDaySalaryManuallySet = false;
                this.updateSalaryData();
                this.finalAmountUpdate();
                this.leavesDaysReducedByLate;
                this.leavesDaysReducedByLate = this.leavesCountReducedByLate || 0;
            }
        },
        selectedEmployee: {
            handler: function handler(newVal) {
                if (!newVal) return;
                this.updateSalaryData();
                this.finalAmountUpdate();
            },

            deep: true,
            immediate: true
        },
        lateArrivalsInput: {
            handler: function handler(newVal) {
                this.calculateDeductions();
            },

            immediate: true
        },
        lateDeductionDays: {
            handler: function handler(oldVal, newVal) {
                this.updateSalaryData();
                this.finalAmountUpdate();
            },

            immediate: true
        },
        reactiveLeaveDays: function reactiveLeaveDays(newVal) {
            this.finalAmountUpdate();
        },

        leavesEncashmentAmountInput: {
            handler: function handler(newVal) {
                this.finalAmountUpdate();
            },

            immediate: true
        },
        manualLeaveEncashmentUpdate: {
            handler: function handler(newVal) {
                this.finalAmountUpdate();
            },

            immediate: true
        },
        taxDeduction: {
            handler: function handler(newVal) {
                this.updateSalaryData();
                this.finalAmountUpdate();
            },

            immediate: true
        }
    },
    methods: {
        updateSalaryData: function updateSalaryData() {
            if (!this.selectedEmployee) return;

            var _ref6 = this.selectedEmployee.obtainedLeaves ? this.selectedEmployee.obtainedLeaves.split(" / ").map(Number) : "0 / 0",
                _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
                leavesTaken = _ref7[0],
                leaveBalance = _ref7[1];

            var perDaySalary = Number(this.selectedEmployee.perDaySalary) || 0;
            var annualLeaves = this.selectedEmployee.annualLeavesEncashmentDays;
            var totalLeavesTaken = Number((leavesTaken || 0) + (annualLeaves || 0)) || 0;
            var leaveDeductionByLate = this.leaveDeductionDays >= 1 ? this.leaveDeductionDays : 0;

            this.perDaySalaryInput = this.selectedEmployee.perDaySalary || 0;

            if (!this.totalDaysSalaryInput) {
                this.totalDaysSalaryInput = ((parseFloat(this.selectedEmployee && this.selectedEmployee.perDaySalary) || 0) * (parseFloat(this.selectedEmployee && this.selectedEmployee.daysWorked) || 0)).toFixed(2);
            }

            this.lateDeductionInput = this.selectedEmployee.lateDeduction || 0;
            this.extraAmountAdjustmentInput = this.selectedEmployee.extraAmountAdjustment || "";
            this.extraAmountAdjustmentNoteInput = this.selectedEmployee.extraAmountAdjustmentNote || "";
            this.bonusInput = this.selectedEmployee.bonus || "";
            this.transactionFeesInput = this.selectedEmployee.transactionFees || "";
            this.taxDeductionInput = this.selectedEmployee.taxDeduction || 0;
            var savedLate = this.employee.lateDeductionDays;
            this.lateDeductionDays = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(Number(savedLate)) ? Number(savedLate) : this.selectedEmployee.lateDeductionDays || 0;
            if (!this.leavesEncashmentAmountInput) {
                this.leavesEncashmentAmountInput = totalLeavesTaken ? (parseFloat((perDaySalary * (this.leavesCountReducedByLate || 0)).toFixed(2)) + parseFloat((perDaySalary * (annualLeaves || 0)).toFixed(2))).toFixed(2) : this.selectedEmployee.leavesEncashmentAmount || 0;
            }

            this.lateArrivalsInput = this.selectedEmployee.lateArrivals || 0;
            this.annualLeavesEncashmentDays = annualLeaves;
            // this.annualLeavesEncashmentAmount = (perDaySalary * (annualLeaves || 0)).toFixed(2) || 0;
        },
        processPayment: function processPayment() {
            this.$emit("process-payment");
        },
        saveDraft: function saveDraft() {
            this.$emit("save-draft");
        },
        updateDraft: function updateDraft() {
            this.$emit("update-draft");
        },
        deleteDraft: function deleteDraft() {
            this.$emit("delete-draft");
        },
        calculateDeductions: function calculateDeductions() {
            this.manualSalaryDeduction = null;
            var obtLeaves = this.selectedEmployee.obtainedLeaves || "0 / 0";

            var _ref8 = obtLeaves || obtLeaves.split(" / ").map(Number) || [0],
                _ref9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref8, 1),
                obtainedLeaves = _ref9[0];

            var isObtainedLeaves = obtainedLeaves > 0;
            var lates = parseInt(this.lateArrivalsInput) || 0;
            var leaveDeductionDays = 0;
            var lateDeductionDays = 0;
            var totalLatesCount = 0;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__assets_config_constants__["d" /* newLateThresholds */]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var threshold = _step2.value;


                    if (lates >= threshold.min) {
                        totalLatesCount = threshold.lates;
                        lateDeductionDays = isObtainedLeaves ? threshold.lates - 1 : threshold.lates;
                        leaveDeductionDays = isObtainedLeaves ? 1 : 0;
                        break;
                    }
                }

                // Deduct 1 leave if lateCount is at least 1
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (lates >= 1) {
                obtainedLeaves = Math.max(0, obtainedLeaves - 1);
            }
            var processedLeavesQuota = this.selectedEmployee.leavesQuota;

            var _ref10 = processedLeavesQuota || {},
                carryForwardDays = _ref10.carryForwardDays,
                leavesEncashmentDays = _ref10.leavesEncashmentDays;

            this.leaveDeductionInput = Number(leaveDeductionDays || 0);
            console.log("🚀 ~ calculateDeductions ~ calculateDeductions lateDeductionDays:", lateDeductionDays);

            var empStatus = (this.employee && this.employee.status || "").toLowerCase();
            var hasSavedLateDeduction = (empStatus === "draft" || empStatus === "processed") && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(Number(this.employee.lateDeductionDays));
            this.lateDeductionDays = hasSavedLateDeduction ? Number(this.employee.lateDeductionDays) : lateDeductionDays;

            this.lateDeductionDays = lateDeductionDays;

            var perDaySalary = this.selectedEmployee.perDaySalary || 0;

            this.totalLatesCount = totalLatesCount;
            this.lateSalaryDeductionInput = (lateDeductionDays * perDaySalary).toFixed(2);

            var leavesTaken = this.selectedEmployee.obtainedLeaves ? parseInt(this.selectedEmployee.obtainedLeaves.split(" / ")[0]) : 0;
            var adjustedLeaves = Math.max(0, leavesTaken - leaveDeductionDays);
            this.$set(this.selectedEmployee, "adjustedLeavesTaken", adjustedLeaves);
        },
        finalAmountUpdate: function finalAmountUpdate() {
            var leavesEncashment = this.manualLeaveEncashmentUpdate ? Number(this.leavesEncashmentAmountInput || 0) : (this.perDayWorkedSalary * (this.leavesCountReducedByLate + this.calculateAnnualLeavesEncashmentDays)).toFixed(2);

            var calc = Number(this.totalDaysSalaryInput || 0) - Number(this.lateSalaryDeductionInput || 0) + Number(leavesEncashment || 0) + Number(this.extraAmountAdjustmentInput || 0) + Number(this.bonusInput || 0) + Number(this.transactionFeesInput || 0) - Number(this.taxDeduction || 0);

            this.finalAmount = Math.round(calc);
            this.syncToEmployee();
            return Math.round(calc);
        },
        formatSalaryInput: function formatSalaryInput(field) {
            if (this[field] === "" || isNaN(parseFloat(this[field]))) {
                this[field] = "0.00";
            } else {
                this[field] = parseFloat(this[field]).toFixed(2);
            }
        },
        syncToEmployee: function syncToEmployee() {
            var updated = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.employee, {
                lateDeduction: this.lateSalaryDeductionInput,
                extraAmountAdjustment: this.extraAmountAdjustmentInput,
                extraAmountAdjustmentNote: this.extraAmountAdjustmentNoteInput,
                bonus: this.bonusInput,
                transactionFees: this.transactionFeesInput,
                taxDeduction: this.taxDeduction,
                totalSalary: Number(this.totalDaysSalaryInput),
                finalAmount: this.finalAmount,
                leavesEncashmentDays: this.leavesEncashmentDays,
                annualLeavesEncashmentDays: this.annualLeavesEncashmentDays,
                // leavesEncashmentAmount: this.leavesEncashmentAmountInput,
                leavesEncashmentAmount: this.manualLeaveEncashmentUpdate ? Number(this.leavesEncashmentAmountInput) : (this.perDayWorkedSalary * (this.leavesCountReducedByLate + this.calculateAnnualLeavesEncashmentDays)).toFixed(2)
            });
            this.$emit("update-salary", updated); // emit updated employee data
        },
        handleExternalUpdate: function handleExternalUpdate() {
            this.lateDeductionDays = Number(this.employee.lateDeductionDays) || 0;
            this.finalAmountUpdate();
        },
        resetIfEmpty: function resetIfEmpty(field) {
            // Check if the input field is empty
            if (true) {
                var employeeField = field.replace('Input', '');

                // Reset to initial value if available, otherwise to 0
                this[field] = this.initialValues[employeeField] || 0;

                if (field === 'lateSalaryDeductionUpdate') {
                    this.lateSalaryDeductionUpdate();
                }
                if (field === 'leavesEncashmentAmountInput') {
                    this.leavesEncashmentAmountInput();
                }
                if (field === 'extraAmountAdjustmentInput') {
                    this.extraAmountAdjustmentInput = this.initialValues.extraAmountAdjustment || 0;
                    this.appliedAdjustments = {}; // Reset appliedAdjustments
                }
                if (field === 'extraAmountAdjustmentNote') {
                    this.extraAmountAdjustmentNote = this.initialValues.extraAmountAdjustmentNote || 0;
                }
                if (field === 'bonusInput') {
                    this.bonusInput = this.initialValues.bonus || 0;
                }
                if (field === 'transactionFeesInput') {
                    this.transactionFeesInput = this.initialValues.transactionFees || 0;
                }
                if (field === 'extraAmountAdjustmentNote') {
                    this.extraAmountAdjustmentNoteInput = this.initialValues.extraAmountAdjustmentNote || 0;
                }
                this.syncToEmployee();

                // Update the employee object if needed
                if (this.employee[employeeField] !== this[field]) {
                    this.employee[employeeField] = this[field];
                    this.syncToEmployee();
                }
            }
        },
        handleLeaveEncashment: function handleLeaveEncashment(e) {
            this.manualLeaveEncashmentUpdate = true;
            this.leavesEncashmentAmountInput = e.target.value;
            this.finalAmountUpdate();
            this.syncToEmployee();
        },
        hasChanged: function hasChanged(field) {
            var employeeField = field.replace('Input', '');
            return this[field] !== (this.initialValues[employeeField] || 0);
        },
        showLeavesInfo: function showLeavesInfo() {
            this.isleaveInfoVisible = true;
        },
        hideLeavesInfo: function hideLeavesInfo() {
            this.isleaveInfoVisible = false;
        },
        showAdjustmentInfo: function showAdjustmentInfo() {
            this.isAdjustmentInfoVisible = true;
        },
        hideAdjustmentInfo: function hideAdjustmentInfo() {
            this.isAdjustmentInfoVisible = false;
        },
        showAdjustmentDetails: function showAdjustmentDetails() {
            this.isAdjustmentDetailsVisible = true;
        },
        hideAdjustmentDetails: function hideAdjustmentDetails() {
            this.isAdjustmentDetailsVisible = false;
        },
        showTaxInfo: function showTaxInfo() {
            this.isTaxInfoVisible = true;
        },
        hideTaxInfo: function hideTaxInfo() {
            this.isTaxInfoVisible = false;
        },
        handleDownloadClick: function handleDownloadClick() {
            var payslipId = '' + this.employee.employeeId;

            localStorage.setItem('payslipData_' + payslipId, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                employee: this.employee,
                salaryData: {
                    totalDaysSalary: this.totalDaysSalaryInput,
                    lateDeduction: this.lateSalaryDeductionInput,
                    leavesEncashment: this.leavesEncashmentAmountInput,
                    adjustment: this.extraAmountAdjustmentInput,
                    bonus: this.bonusInput,
                    transactionFees: this.transactionFeesInput,
                    taxDeduction: this.taxDeduction,
                    finalAmount: this.finalAmount,
                    leavesEncashmentDays: this.leavesEncashmentDays,
                    annualLeavesEncashmentDays: this.annualLeavesEncashmentDays
                }
            }));

            var baseUrl = window.location.origin;
            var payslipUrl = baseUrl + '/#/payroll/payslip/' + payslipId;
            window.open(payslipUrl, '_blank');
        },
        formatToHoursMinutes: function formatToHoursMinutes(decimal) {
            var d = parseFloat(decimal);
            if (isNaN(d)) return '-';

            var hours = Math.floor(d);
            var minutes = Math.round((d - hours) * 60);

            var hrsText = hours ? hours + ' hr' + (hours !== 1 ? 's' : '') : '0 hrs';
            var minsText = minutes ? minutes + ' min' + (minutes !== 1 ? 's' : '') : '0 mins';

            return [hrsText, minsText].filter(Boolean).join(' ') || '0 min';
        },
        empDayHours: function empDayHours() {
            var hours = Number(this.employee.empTotalHours);
            var halfDayHours = hours / 2 + 0.5;
            return {
                halfDayHours: halfDayHours,
                empTotalHours: hours
            };
        },
        applyAdjustment: function applyAdjustment(adjOrAmount, note) {
            console.log("adjorAmount", adjOrAmount + "note", note);
            this.adjustmentShowHoverTooltip = false;
            var adjustmentValue = void 0;
            var finalNote = void 0;
            if ((typeof adjOrAmount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(adjOrAmount)) === 'object' && adjOrAmount !== null) {
                adjustmentValue = typeof adjOrAmount.amount === 'number' ? adjOrAmount.amount : Number(this.calculateAdjustmentAmount(adjOrAmount.amount));
                var isNonCustom = adjOrAmount.amount.includes('x') || adjOrAmount.amount.includes('day');
                finalNote = 'Rs. ' + Math.round(Math.abs(adjustmentValue)) + (isNonCustom ? ' (' + adjOrAmount.amount + ')' : '') + ' (' + adjOrAmount.adjustmentType + ') ' + adjOrAmount.reason;
                this.$set(this.appliedAdjustments, adjOrAmount.id, true);
            } else {
                var lowExtraHoursKey = 'lowExtraHours';
                var isApplied = !!this.appliedAdjustments[lowExtraHoursKey];
                adjustmentValue = adjOrAmount;
                finalNote = 'Rs. ' + adjustmentValue + ' for Low/Extra Hours Sum: ' + (adjustmentValue < 0 ? '-' : '') + ' ' + note.split(': ')[1];
                var currentAdjustment = Number(this.extraAmountAdjustmentInput) || 0;
                var currentNote = this.extraAmountAdjustmentNoteInput || '';
                if (isApplied) {
                    // Remove the adjustment
                    this.extraAmountAdjustmentInput = (currentAdjustment - adjustmentValue).toFixed(2);
                    this.extraAmountAdjustmentNoteInput = currentNote.replace(finalNote, '').trim();
                    this.$set(this.appliedAdjustments, lowExtraHoursKey, false);
                } else {
                    // Add the adjustment
                    this.extraAmountAdjustmentInput = (currentAdjustment + adjustmentValue).toFixed(2);
                    this.extraAmountAdjustmentNoteInput = currentNote ? currentNote + '\n' + finalNote : finalNote;
                    this.$set(this.appliedAdjustments, lowExtraHoursKey, true);
                }
            }
            this.syncToEmployee();
        },
        toggleAdjustment: function toggleAdjustment(adj) {
            var adjustmentValue = typeof adj.amount === 'number' ? adj.amount : Number(this.calculateAdjustmentAmount(adj.amount));
            // Apply impact logic: use positive value for Addition, negative for Deduction
            var adjustedValue = adj.impact === "Addition" ? Math.abs(adjustmentValue) : -Math.abs(adjustmentValue);
            var isNonCustom = adj.amount.includes('x') || adj.amount.includes('day');
            var finalNote = 'Rs. ' + Math.round(Math.abs(adjustmentValue)) + (isNonCustom ? ' (' + adj.amount + ')' : '') + ' (' + adj.adjustmentType + ') ' + adj.reason;
            var currentAdjustment = Number(this.extraAmountAdjustmentInput) || 0;
            var currentNote = this.extraAmountAdjustmentNoteInput || '';

            if (!this.appliedAdjustments[adj.id]) {
                this.extraAmountAdjustmentInput = (currentAdjustment + adjustedValue).toFixed(2);
                this.extraAmountAdjustmentNoteInput = currentNote ? currentNote + '\n' + finalNote : finalNote;
                this.$set(this.appliedAdjustments, adj.id, true);
            } else {
                this.extraAmountAdjustmentInput = (currentAdjustment - adjustedValue).toFixed(2);
                this.extraAmountAdjustmentNoteInput = currentNote.replace(finalNote, '').trim();
                this.$set(this.appliedAdjustments, adj.id, false);
            }
            this.syncToEmployee();
        },
        calculateAdjustmentAmount: function calculateAdjustmentAmount(amount) {
            // If amount is a string and does not contain 'x' or 'day', treat as custom value and return as-is
            if (typeof amount === 'string' && !amount.includes('x') && !amount.includes('day')) {
                return Number(amount);
            }
            // Otherwise, calculate for non-custom values (1x, 2x, 1 day, etc.)
            var perDaySalary = Number(this.selectedEmployee.perDaySalary) || 0;
            var hourlyRate = perDaySalary / 9;
            var multiplier = parseFloat(amount) || 1;
            var isDay = amount.includes('day');
            return isDay ? perDaySalary * multiplier : hourlyRate * multiplier;
        }
    },
    mounted: function mounted() {
        this.finalAmountUpdate();
    }
});

/***/ }),

/***/ "war1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-profile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cp-body"},[_c('div',{staticClass:"cp-logo"},[_c('span',{staticClass:"cp-label"},[_vm._v("Company Logo")]),_vm._v(" "),_c('div',{staticClass:"cp-logo-box",class:{ 'has-logo': _vm.logoPreview, disabled: !_vm.isAdmin },on:{"click":_vm.openFilePicker}},[(_vm.logoPreview)?_c('img',{attrs:{"src":_vm.logoPreview,"alt":"Company logo"}}):_c('div',{staticClass:"cp-logo-empty"},[_c('i',{staticClass:"fa fa-cloud-upload-alt"}),_vm._v(" "),_c('span',[_vm._v("Upload logo")]),_vm._v(" "),_c('small',[_vm._v("PNG, JPG, SVG or WEBP, up to 1 MB")])])]),_vm._v(" "),_c('input',{ref:"logoInput",attrs:{"type":"file","accept":"image/png,image/jpeg,image/svg+xml,image/webp","hidden":""},on:{"change":_vm.onLogoSelected}}),_vm._v(" "),(_vm.isAdmin && _vm.logoPreview)?_c('div',{staticClass:"cp-logo-actions"},[_c('button',{staticClass:"cp-link",attrs:{"type":"button"},on:{"click":_vm.openFilePicker}},[_vm._v("Change")]),_vm._v(" "),_c('button',{staticClass:"cp-link cp-link--danger",attrs:{"type":"button"},on:{"click":_vm.removeLogo}},[_vm._v("Remove")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cp-fields"},[_c('div',{staticClass:"cp-field"},[_c('label',{staticClass:"cp-label",attrs:{"for":"companyEmail"}},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"cp-input-wrap"},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.companyEmail),expression:"form.companyEmail",modifiers:{"trim":true}}],staticClass:"cp-input",attrs:{"id":"companyEmail","type":"email","disabled":!_vm.isAdmin,"placeholder":"info@company.com"},domProps:{"value":(_vm.form.companyEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "companyEmail", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"cp-field"},[_c('label',{staticClass:"cp-label",attrs:{"for":"companyPhone"}},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"cp-input-wrap"},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.companyPhone),expression:"form.companyPhone",modifiers:{"trim":true}}],staticClass:"cp-input",attrs:{"id":"companyPhone","type":"text","disabled":!_vm.isAdmin,"placeholder":"(021) 1234567"},domProps:{"value":(_vm.form.companyPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "companyPhone", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"cp-field cp-field--full"},[_c('label',{staticClass:"cp-label",attrs:{"for":"companyAddress"}},[_vm._v("Address")]),_vm._v(" "),_c('div',{staticClass:"cp-input-wrap"},[_c('i',{staticClass:"fa fa-map-marker-alt"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.companyAddress),expression:"form.companyAddress",modifiers:{"trim":true}}],staticClass:"cp-input",attrs:{"id":"companyAddress","type":"text","disabled":!_vm.isAdmin,"placeholder":"Office address"},domProps:{"value":(_vm.form.companyAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "companyAddress", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"cp-field cp-field--full"},[_c('label',{staticClass:"cp-label",attrs:{"for":"policyUrl"}},[_vm._v("Company Policy URL")]),_vm._v(" "),_c('div',{staticClass:"cp-input-wrap"},[_c('i',{staticClass:"fa fa-file-alt"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.policyUrl),expression:"form.policyUrl",modifiers:{"trim":true}}],staticClass:"cp-input",attrs:{"id":"policyUrl","type":"url","disabled":!_vm.isAdmin,"placeholder":"https://docs.google.com/document/d/..."},domProps:{"value":(_vm.form.policyUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "policyUrl", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.isValidUrl(_vm.form.policyUrl))?_c('a',{staticClass:"cp-open",attrs:{"href":_vm.form.policyUrl,"target":"_blank","rel":"noopener","title":"Open"}},[_c('i',{staticClass:"fa fa-external-link-alt"})]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"cp-help"},[_vm._v("Shown on the Policies page. Google Docs links are embedded automatically.")])])])]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"cp-footer"},[_c('button',{staticClass:"cp-btn cp-btn--ghost",attrs:{"type":"button","disabled":!_vm.isDirty || _vm.saving},on:{"click":_vm.reset}},[_vm._v("\n      Discard\n    ")]),_vm._v(" "),_c('button',{staticClass:"cp-btn cp-btn--primary",attrs:{"type":"button","disabled":!_vm.isDirty || _vm.saving},on:{"click":_vm.save}},[_vm._v("\n      "+_vm._s(_vm.saving ? "Saving..." : "Save Changes")+"\n    ")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-header"},[_c('div',[_c('h5',{staticClass:"title cp-title"},[_vm._v("Company Profile")]),_vm._v(" "),_c('p',{staticClass:"cp-subtitle"},[_vm._v("Used on employee payslips and the Policies page.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "we63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__("jcKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_constants_js__ = __webpack_require__("qF07");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_complains_js__ = __webpack_require__("oCsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_payroll_js__ = __webpack_require__("aNyT");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// modules





var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        loading: false,
        success: false
    },
    mutations: {
        loadingStarts: function loadingStarts(state, payload) {
            state.loading = true;
        },
        loadingEnds: function loadingEnds(state, payload) {
            state.loading = false;
        },
        succeeded: function succeeded(state, payload) {
            state.success = payload.message;
        }
    },
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
        constants: __WEBPACK_IMPORTED_MODULE_4__modules_constants_js__["a" /* constants */],
        complains: __WEBPACK_IMPORTED_MODULE_5__modules_complains_js__["a" /* default */],
        payroll: __WEBPACK_IMPORTED_MODULE_6__modules_payroll_js__["a" /* default */]
    }
});

new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
    supportCircular: true,
    storage: window.localStorage
}).plugin(store);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_complains__ = __webpack_require__("oCsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_services_notificationService__ = __webpack_require__("l527");






//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isImpersonating: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var company, user, currentPath;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              company = _this.$store.state.auth.company;
              user = _this.$store.state.auth.user;
              currentPath = _this.$router.history.current.path;
              _context.prev = 3;

              if (!(!__WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].checkAlreadyConfiguredApp() && company)) {
                _context.next = 17;
                break;
              }

              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_8__assets_config_firebase__["a" /* default */].configureFirebase(company.firebase);

            case 7:
              _context.next = 9;
              return _this.$store.dispatch('fetchAllTrelloData');

            case 9:
              if (user && user.uid) {
                _this.watchUserStatusRealTime(user.uid); // ✅ ADDED LINE
              }
              _this.fetchAllUsersRealTime();
              _this.fetchConstantsRealTime();
              _this.fetchNewUsersRealTime();
              _this.removeUserRealTime();
              _this.fetchLeavesRealTime();
              _this.fetchCurrentUser();
              _this.fetchUserLeavesRealTime();

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](3);

              console.log("e =>", _context.t0);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 19]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.userListenerRef) {
      this.userListenerRef.off();
      this.userListenerRef = null;
    }
  },

  methods: {
    watchUserStatusRealTime: function watchUserStatusRealTime(uid) {
      var _this2 = this;

      this.userListenerRef = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users/" + uid);
      this.userListenerRef.on("value", function (snapshot) {
        var userData = snapshot.val();
        if (userData && userData.isActive === false) {
          _this2.$store.commit("setUser", null);
          _this2.$store.commit("setCompany", null);
          _this2.$store.commit("setConstants", {});
          _this2.$router.replace("/");
          localStorage.clear();
          if (_this2.userListenerRef) {
            _this2.userListenerRef.off();
            _this2.userListenerRef = null;
          }
        }
      });
    },
    fetchConstantsRealTime: function fetchConstantsRealTime() {
      var _this3 = this;

      var constants = this.$store.state.auth.constants || {};
      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("constants").on("child_changed", function (data) {
        if (data.val()) {
          constants[data.key] = data.val();
          _this3.$store.commit("setConstants", constants);
        }
      });
    },
    fetchNewUsersRealTime: function fetchNewUsersRealTime() {
      var _this4 = this;

      var allUsers = this.$store.state.auth.allUsers;
      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users").on("child_added", function (data) {
        if (data.val()) {
          var foundUser = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(allUsers, { uid: data.key });
          if (!foundUser) {
            allUsers.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data.val(), { uid: data.key }));
            _this4.$store.commit("setAllUsers", allUsers);
          }
        }
      });
    },
    removeUserRealTime: function removeUserRealTime() {
      var _this5 = this;

      var allUsers = this.$store.state.auth.allUsers;
      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users").on("child_removed", function (data) {
        if (data.val()) {
          var foundIndex = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.findIndex(allUsers, { uid: data.key });
          if (foundIndex > -1) {
            allUsers.splice(foundIndex, 1);
            _this5.$store.commit("setAllUsers", allUsers);
          }
        }
      });
    },
    fetchAllUsersRealTime: function fetchAllUsersRealTime() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users").on("child_changed", function (data) {
        if (data.val()) {
          var allUsers = _this6.$store.state.auth.allUsers;
          var targetIndex = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.findIndex(allUsers, { uid: data.key });
          if (targetIndex !== -1) {
            allUsers[targetIndex] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data.val(), { uid: data.key });
            _this6.$store.commit("setAllUsers", [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(allUsers)));
          }
        }
      });
    },
    fetchCurrentUser: function fetchCurrentUser() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var user, userSnapshot, userData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                user = _this7.$store.state.auth.user;

                if (!(user && user.uid)) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users/" + user.uid).once("value");

              case 5:
                userSnapshot = _context2.sent;

                if (userSnapshot.exists()) {
                  userData = userSnapshot.val();

                  _this7.$store.commit("setUser", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                    uid: user.uid
                  }, userData));
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);

                console.error("Error fetching current user data:", _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[2, 9]]);
      }))();
    },
    fetchLeavesRealTime: function fetchLeavesRealTime() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("leaves").orderByChild("createdAt").on("value", function (snapshot) {
        var leaves = [];
        snapshot.forEach(function (childSnapshot) {
          var leave = childSnapshot.val();
          leave.id = childSnapshot.key;
          leaves.push(leave);
        });
        var sortedLeaves = leaves.reverse();
        _this8.$store.commit("setAllLeaves", sortedLeaves);
      }, function (error) {
        console.error("Error fetching real-time leaves: ", error);
      });
    },
    fetchUserLeavesRealTime: function fetchUserLeavesRealTime() {
      var _this9 = this;

      var user = this.$store.state.auth.user;

      if (!user) {
        console.error("User not found!");
        return;
      }

      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("leaves").orderByChild("userId").equalTo(user.uid).on("value", function (snapshot) {
        var leaves = [];
        snapshot.forEach(function (childSnapshot) {
          var leave = childSnapshot.val();
          leave.id = childSnapshot.key;
          leaves.push(leave);
        });
        var sortedLeaves = leaves.sort(function (a, b) {
          return b.createdAt - a.createdAt;
        });
        _this9.$store.commit("setUserLeaves", sortedLeaves);
      }, function (error) {
        console.error("Error fetching real-time leaves: ", error);
      });
    },
    initializeAppData: function initializeAppData() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var user, userSnapshot, userData, _ref, _ref2, allUsersSnapshot, constantsSnapshot, leavesSnapshot, errorsSnapshot, users, leaves, errors;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                user = _this10.$store.state.auth.user;

                if (!(!user || !user.uid)) {
                  _context3.next = 5;
                  break;
                }

                console.warn("No user found in store");
                return _context3.abrupt("return");

              case 5:
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users/" + user.uid).once("value");

              case 7:
                userSnapshot = _context3.sent;
                userData = userSnapshot.val();

                if (!(!userData || userData.isActive === false)) {
                  _context3.next = 16;
                  break;
                }

                console.warn("User is not active");
                // Handle inactive user (logout, redirect, etc.)
                _this10.$store.commit("setUser", null);
                _this10.$store.commit("setCompany", null);
                _this10.$store.commit("setConstants", {});
                _this10.$router.replace("/");
                return _context3.abrupt("return");

              case 16:
                _context3.next = 18;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("users").once("value"), __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("constants").once("value"), __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("leaves").once("value"), __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref("errors").once("value")]);

              case 18:
                _ref = _context3.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 4);
                allUsersSnapshot = _ref2[0];
                constantsSnapshot = _ref2[1];
                leavesSnapshot = _ref2[2];
                errorsSnapshot = _ref2[3];


                // Process users data
                users = [];

                allUsersSnapshot.forEach(function (childSnapshot) {
                  users.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, childSnapshot.val(), { uid: childSnapshot.key }));
                });
                _this10.$store.commit("setAllUsers", users);
                _this10.$store.commit("setConstants", constantsSnapshot.val() || {});
                leaves = [];

                leavesSnapshot.forEach(function (childSnapshot) {
                  leaves.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, childSnapshot.val(), { id: childSnapshot.key }));
                });
                _this10.$store.commit("setAllLeaves", leaves.reverse());
                // just for console the errors collection on refresh, it will be used in future for error tracking and management
                errors = [];

                errorsSnapshot.forEach(function (childSnapshot) {
                  var errorData = childSnapshot.val();
                  errorData.id = childSnapshot.key;
                  errors.push(errorData);
                });
                console.log("Errors Collection Fetched on Refresh:", errors);

                // Fetch Trello data
                _context3.next = 36;
                return _this10.$store.dispatch('fetchAllTrelloData');

              case 36:

                // Set up realtime listeners
                _this10.fetchAllUsersRealTime();
                _this10.fetchLeavesRealTime();
                _this10.fetchUserLeavesRealTime();
                _this10.fetchConstantsRealTime();
                _this10.fetchNewUsersRealTime();
                _this10.fetchCurrentUser();
                _this10.removeUserRealTime();
                _context3.next = 48;
                break;

              case 45:
                _context3.prev = 45;
                _context3.t0 = _context3["catch"](0);

                console.error("Initialization error:", _context3.t0);

              case 48:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this10, [[0, 45]]);
      }))();
    }
  },
  created: function created() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var company;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this11.isImpersonating = !!localStorage.getItem('impersonateUser');
              company = _this11.$store.state.auth.company;
              _context4.prev = 2;

              if (!(!__WEBPACK_IMPORTED_MODULE_6_firebase___default.a.apps || __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.apps.length === 0)) {
                _context4.next = 8;
                break;
              }

              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.initializeApp(company.firebase);

            case 6:
              _context4.next = 8;
              return _this11.initializeAppData();

            case 8:
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](2);

              console.error("Firebase initialization error:", _context4.t0);

            case 13:
              _context4.next = 15;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__src_services_notificationService__["a" /* requestNotificationPermission */])();

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this11, [[2, 10]]);
    }))();
  }
});

/***/ }),

/***/ "xLTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeUserManagement_vue__ = __webpack_require__("nimk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66db7db4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeUserManagement_vue__ = __webpack_require__("9Gbe");
function injectStyle (ssrContext) {
  __webpack_require__("F8TZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66db7db4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeUserManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66db7db4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeUserManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xNt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('AdminLeaveManagement'):_c('EmployeeLeaveManagement')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xYPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_excludeholidayHours__ = __webpack_require__("OnzM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "MonthlyStats",
    props: {
        logs: {
            type: Array,
            required: true
        },
        workingDays: {
            type: Array,
            required: true
        },
        workingHours: {
            type: [Number, String],
            required: true
        },
        month: {
            type: String,
            required: true
        },
        year: {
            type: String,
            required: true
        },
        averageHours: {
            type: Number,
            default: 0
        },
        averageMinutes: {
            type: Number,
            default: 0
        },
        holidays: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            filter: 'fullMonth'
        };
    },

    computed: {
        isCurrentMonth: function isCurrentMonth() {
            var monthIndex = new Date(this.month + ' 1, ' + this.year).getMonth();
            var year = parseInt(this.year);
            var today = new Date();
            return today.getMonth() === monthIndex && today.getFullYear() === year;
        },
        stats: function stats() {
            var monthIndex = new Date(this.month + ' 1, ' + this.year).getMonth();
            var year = parseInt(this.year);
            var filteredLogs = this.logs.filter(function (log) {
                if (!log || !log.date) return false;
                var logDate = new Date(log.date);
                return logDate.getMonth() === monthIndex && logDate.getFullYear() === year;
            });

            var totalLates = this.logs.filter(function (log) {
                return log && log.late && (log.late.hours > 0 || log.late.minutes > 0);
            }).length;

            var totalSpentHours = 0;
            var totalSpentMinutes = 0;
            this.logs.forEach(function (log) {
                if (log && log.completed) {
                    totalSpentHours += log.completed.hours || 0;
                    totalSpentMinutes += log.completed.minutes || 0;
                }
            });
            totalSpentHours += Math.floor(totalSpentMinutes / 60);
            totalSpentMinutes %= 60;

            var daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
            var today = new Date();
            var maxDays = this.filter === 'tillToday' && this.isCurrentMonth ? today.getDate() : daysInMonth;

            var workingDaysInMonth = 0;
            for (var date = 1; date <= maxDays; date++) {
                var currentDate = new Date(year, monthIndex, date);
                if (this.workingDays.includes(currentDate.toLocaleDateString("en-US", { weekday: "long" }))) {
                    workingDaysInMonth++;
                }
            }
            workingDaysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_excludeholidayHours__["a" /* subtractHolidays */])({
                holidays: this.holidays,
                currentYear: year,
                monthIndex: monthIndex,
                workingDays: this.workingDays,
                workingDaysInMonth: workingDaysInMonth,
                shift: this.$store.state.auth.user.shift || 'morning'
            });

            var totalRequiredHours = workingDaysInMonth * Number(this.workingHours);
            var daysWithLogs = this.logs.filter(function (log) {
                return log;
            }).length;
            var averageHours = this.averageHours;
            var averageMinutes = this.averageMinutes;
            if (daysWithLogs > 0) {
                var totalHoursDecimal = totalSpentHours + totalSpentMinutes / 60;
                var averageHoursDecimal = totalHoursDecimal / daysWithLogs;
                averageHours = Math.floor(averageHoursDecimal);
                averageMinutes = Math.round((averageHoursDecimal - averageHours) * 60);
            }

            var netBalanceHours = totalSpentHours + totalSpentMinutes / 60 - totalRequiredHours;
            var netBalanceFormatted = netBalanceHours.toFixed(1);
            var isNegative = netBalanceHours < 0;

            // Convert totalRequiredHours to decimal and breakdown
            var totalRequiredDecimal = totalRequiredHours;
            var totalRequiredWholeHours = Math.floor(totalRequiredDecimal);
            var totalRequiredMinutes = Math.round((totalRequiredDecimal - totalRequiredWholeHours) * 60);

            // Convert totalSpentHours to decimal and breakdown
            var totalSpentDecimal = totalSpentHours + totalSpentMinutes / 60;
            var totalSpentWholeHours = Math.floor(totalSpentDecimal);
            var totalSpentMinutesCalc = Math.round((totalSpentDecimal - totalSpentWholeHours) * 60);

            // Convert netBalance to decimal and breakdown
            var netBalanceDecimal = netBalanceFormatted;
            var netBalanceWholeHours = Math.floor(netBalanceDecimal);
            var netBalanceMinutes = Math.round((netBalanceDecimal - netBalanceWholeHours) * 60);

            return [{
                title: "Total Lates",
                value: totalLates + ' ' + (totalLates > 1 ? "days" : "day"),
                icon: "mdi-clock-outline",
                iconColor: "red",
                valueClass: totalLates > 3 ? "error--text" : ""
            }, {
                title: "Average Hours Spent",
                value: (averageHours + averageMinutes / 60).toFixed(1) + ' Hrs',
                breakdown: '(' + averageHours + ' hrs, ' + averageMinutes + ' mins)',
                icon: "mdi-chart-timeline-variant",
                iconColor: "blue",
                valueClass: ""
            }, {
                title: "Total Hours Required",
                value: totalRequiredDecimal.toFixed(1) + ' Hrs',
                breakdown: '(' + totalRequiredWholeHours + ' hrs, ' + totalRequiredMinutes + ' mins)',
                icon: "mdi-calendar-clock",
                iconColor: "purple",
                valueClass: ""
            }, {
                title: "Total Spent Hours",
                value: totalSpentDecimal.toFixed(1) + ' Hrs',
                breakdown: '(' + totalSpentWholeHours + ' hrs, ' + totalSpentMinutesCalc + ' mins)',
                icon: "mdi-timer-outline",
                iconColor: "green",
                valueClass: ""
            }, {
                title: "Net Balance",
                value: netBalanceFormatted + ' Hrs',
                breakdown: '(' + netBalanceWholeHours + ' hrs, ' + netBalanceMinutes + ' mins)',
                icon: "mdi-scale-balance",
                iconColor: isNegative ? "red" : "green",
                valueClass: isNegative ? "error--text" : "success--text"
            }];
        },
        days: function days() {
            return this.$parent.days || [];
        }
    }
});

/***/ }),

/***/ "yAlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_CustomTable_vue__ = __webpack_require__("E95N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Dropdowns_SearchableDropdown_vue__ = __webpack_require__("KM+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_HeaderEmployeeDropdown_vue__ = __webpack_require__("hq6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UIComponents_ReuseableModal_vue__ = __webpack_require__("w2Je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_loaders_DoubleLoader_vue__ = __webpack_require__("AxYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeaveManagement_CardsSection_vue__ = __webpack_require__("mZEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_HistoryActivityTable_vue__ = __webpack_require__("jdzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddPerformanceItemModal_vue__ = __webpack_require__("XaVe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__ = __webpack_require__("nvCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__performanceHelper_js__ = __webpack_require__("YIuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__ = __webpack_require__("l527");












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








 // New component








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    selectedEmployeeTrelloUsername: {
      type: String,
      default: ""
    }
  },
  components: {
    CustomTable: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_CustomTable_vue__["a" /* default */],
    SearchableDropdown: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Dropdowns_SearchableDropdown_vue__["a" /* default */],
    HeaderEmployeeDropdown: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_HeaderEmployeeDropdown_vue__["a" /* default */],
    ReuseableModal: __WEBPACK_IMPORTED_MODULE_15__UIComponents_ReuseableModal_vue__["a" /* default */],
    DoubleLoader: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_loaders_DoubleLoader_vue__["a" /* default */],
    CardsSection: __WEBPACK_IMPORTED_MODULE_17__LeaveManagement_CardsSection_vue__["a" /* default */],
    HistoryActivityTable: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_HistoryActivityTable_vue__["a" /* default */],
    AddPerformanceItemModal: __WEBPACK_IMPORTED_MODULE_19__AddPerformanceItemModal_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      currentTime: Date.now(),
      selectedEmployeeTrelloUsername: "",
      isLogoutModalOpen: false,
      isAddModalOpen: false,
      mapPopup: false,
      currentCoordinates: null,
      loading: false,
      isLoading: false,
      error: null,
      noMemberFound: false,
      selectedBoardId: "",
      selectedBoardName: "",
      selectedMemberId: "",
      selectedMemberName: "",
      startDate: "",
      endDate: "",
      boards: [],
      showLockBar: false,
      doneCards: [],
      selectedItem: null,
      isModalOpen: false,
      isHistoryModalOpen: false,
      TRELLO_API_KEY: "b18c7d4c2051c75660623c349bf3e65f",
      TRELLO_TOKEN: "ATTA21440b3581fd44dea9e0dd9f3d2f250621355173a84d49e0847d44247425ea4bA72ADDB3",
      tableColumns: [{ label: "S. No", key: "sno", sortable: true }, { label: "Tasks", key: "taskName", sortable: true, width: 200 }, { label: "Project", key: "project", sortable: true }, { label: "Duration Spent", key: "durationSpent", sortable: true }, { label: "Moved to Done", key: "movedToDone", sortable: true }, { label: "Reopened", key: "reopened", sortable: true, width: 130 }, { label: "Deadline Missed", key: "deadlineMissed", sortable: true }, { label: "Score", key: "score", sortable: true, width: 130 }, { label: "Action", key: "action", sortable: false }],
      columns: [{ label: "Activity On", key: "activityOnUserName", width: "200px" }, { label: "Activity By", key: "activityByUserName", width: "200px" }, { label: "Action", key: "action", width: "200px" }, { label: "Field", key: "field", width: "120px" }, { label: "Change", key: "change" }, { label: "Reason", key: "reason", width: "250px", truncate: true, length: 30 }, { label: "Timestamp", key: "timestamp", width: "250px", truncate: true, length: 20 }, { label: "OS", key: "osName" }, { label: "Browser", key: "browserName" }, { label: "Map", key: "map", width: "70px" }],
      isAdmin: false,
      selectedEmployee: null,
      user: this.$store.state.auth.user,
      employeeList: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      selectedMonth: "",
      years: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_array_from___default()({ length: 5 }, function (_, i) {
        return new Date().getFullYear() - i;
      }),
      selectedYear: new Date().getFullYear().toString(),
      autoLoadDone: false,
      boardMemberCache: {},
      membersLoaded: false,
      performanceActivity: [],
      editing: {},
      tempValues: {},
      showReasonModal: false,
      changeInfo: {},
      reason: '',
      editedCards: {},
      customCards: [],
      showTooltip: null,
      tooltipX: 0,
      tooltipY: 0,
      currentHoverField: null,
      isDeleteModalOpen: false,
      cardToDelete: null,
      pendingAction: null,
      pendingCardId: null,
      pendingField: null
    }, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedItem', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'isApproveModalOpen', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'cardToApprove', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'visibleDetails', {}), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'visibleReasons', {}), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'isSaveConfirmModalOpen', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'tableData', []), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'lockData', { locked: false, scheduledLockTime: null, userIds: {} }), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'timeRemaining', '00:00:00'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'interval', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'isLockModalOpen', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'lockDate', ''), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'lockTime', ''), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'hasSearched', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'criteriaList', []), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'reopenEvery', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'reopenScore', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'deadlineEvery', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'deadlineScore', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'reopenLimit', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'deadlineLimit', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'scheduledloading', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'isUnLockModalOpen', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'isEndScheduleModalOpen', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'hasUnmatchedTrelloCards', false), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_ref, 'scheduledLockSaveFired', false), _ref;
  },

  computed: {
    effectiveLocked: function effectiveLocked() {
      return this.lockData.locked || this.lockData.scheduledLockTime && this.lockData.scheduledLockTime <= this.currentTime;
    },
    isScheduled: function isScheduled() {
      return !!this.lockData.scheduledLockTime && this.lockData.scheduledLockTime > this.currentTime;
    },
    lockButtonText: function lockButtonText() {
      if (this.effectiveLocked) return 'Unlock';
      if (this.isScheduled) return 'Reschedule Lock';
      return 'Lock';
    },
    hasHistory: function hasHistory() {
      var _this = this;

      return function (cardId) {
        var edit = _this.editedCards[cardId];
        if (!edit) return false;
        // If there's any updated field or status change → there is history
        var upd = edit.updatedData || {};
        if (upd.reopened || upd.score || upd.status) return true;
        if (edit.isCustom === true) return true;
        return false;
      };
    },
    reasonModalTitle: function reasonModalTitle() {
      if (this.pendingAction === 'approve') return 'Approve Change';
      if (this.pendingAction === 'reject') return 'Reject Change';
      return 'Enter Reason for Change';
    },
    filteredBoardsForEmployee: function filteredBoardsForEmployee() {
      var _this2 = this;

      if (!this.selectedEmployee || !this.membersLoaded) return [];

      var empUsername = "";
      if (this.selectedEmployee.uid === this.user.uid) {

        empUsername = this.selectedEmployeeTrelloUsername.trim().toLowerCase();
      } else {
        if (!this.selectedEmployee.trelloUsername) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", "Employee Trello username is missing.", "error");
          return [];
        }
        empUsername = this.selectedEmployee.trelloUsername.trim().toLowerCase();
      }
      var boards = this.boards.map(function (board) {
        var members = _this2.boardMemberCache[board.id] || [];
        var isMember = Array.isArray(members) && members.some(function (m) {
          return m && m.username && m.username.trim().toLowerCase() === empUsername;
        });
        return isMember ? { name: board.name, id: board.id } : null;
      }).filter(Boolean);

      return [{ name: "All Projects", id: "" }].concat(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(boards));
    },
    filteredPerformanceData: function filteredPerformanceData() {
      var _this3 = this;

      var finalCards = this.doneCards.map(function (card, index) {
        return {
          id: card.id || card.cardId,
          sno: index + 1,
          details: Array.isArray(card.details) ? card.details : card.updatedData && Array.isArray(card.updatedData.details) ? card.updatedData.details : [],
          taskName: card.name || 'Untitled',
          type: card.type || null,
          project: card.boardName || _this3.selectedBoardName || null,
          durationSpent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__performanceHelper_js__["a" /* formatDuration */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__performanceHelper_js__["b" /* parseDurationString */])(card.durationInProgress)),
          movedToDone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__performanceHelper_js__["c" /* formatMovedToDone */])(card.movedDate, card.movedTime),
          movedDate: card.movedDate || null,
          movedTime: card.movedTime || null,
          reopened: card.status === "rejected" ? card.originalreopenCount || 0 : card.reopenCount || 0,
          deadlineMissed: card.deadlineMissedCount || 0,
          score: card.score !== undefined ? card.score : 0,
          rating: card.rating !== undefined ? card.rating : 0,
          link: card.link,
          scoreReason: card.scoreReason || null,
          isCustom: card.isCustom || false,
          board: card.boardName || _this3.selectedBoardName,
          member: _this3.selectedMemberName || "Unknown",
          reopenHistory: card.reopenHistory || [],
          status: card.status,
          ticketStatus: card.ticketStatus || null,
          originalreopenCount: card.originalreopenCount !== undefined && card.originalreopenCount
        };
      });
      return finalCards;
    },
    tableTotals: function tableTotals() {
      var totals = { reopened: 0, deadlineMissed: 0, score: 0 };
      this.doneCards.forEach(function (c) {
        if (c.ticketStatus === 'pending') return;
        totals.reopened += c.status !== "pending" && c.status !== "rejected" ? Number(c.reopenCount || 0) : Number(c.originalreopenCount || 0);
        totals.score += Number(c.score || 0);
        totals.deadlineMissed += Number(c.deadlineMissedCount || 0);
      });
      return totals;
    },
    summaryCards: function summaryCards() {
      if (this.loading || this.error || this.noMemberFound || !this.doneCards.length) return [];
      var rawScore = this.tableTotals.score;
      var reopenDeduction = this.reopenLimit && this.reopenScore ? this.tableTotals.reopened >= this.reopenLimit ? this.reopenScore : 0 : this.reopenEvery && this.reopenScore ? Math.floor(this.tableTotals.reopened / this.reopenEvery) * this.reopenScore : 0;
      var deadlineDeduction = this.deadlineLimit && this.deadlineScore ? this.tableTotals.deadlineMissed >= this.deadlineLimit ? this.deadlineScore : 0 : this.deadlineEvery && this.deadlineScore ? Math.floor(this.tableTotals.deadlineMissed / this.deadlineEvery) * this.deadlineScore : 0;
      var adjustedScore = rawScore + reopenDeduction + deadlineDeduction;
      var scoreByType = {};

      this.doneCards.forEach(function (card) {
        if (card.ticketStatus === 'pending') return;
        var type = card.type || 'Ticket';
        scoreByType[type] = (scoreByType[type] || 0) + Number(card.score || 0);
      });
      var sortedTypes = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(scoreByType).sort(function (_ref2, _ref3) {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            a = _ref5[1];

        var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            b = _ref4[1];

        return b - a;
      }).map(function (_ref6) {
        var _ref7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
            type = _ref7[0],
            sum = _ref7[1];

        return { type: type, sum: sum };
      });
      return [{ value: this.doneCards.length, label: "Total Items", color: "#007bff" }, { value: this.tableTotals.reopened, label: "Total Reopens", color: "#ff4d4d" }, { value: this.tableTotals.deadlineMissed, label: "Total Deadlines Missed", color: "#ff8c00" }, { value: adjustedScore.toFixed(1), label: "Total Score", color: "#00c7c7", hasTooltip: true, grossScore: rawScore, reopenDeduction: this.reopenEvery || this.reopenLimit ? reopenDeduction : null, deadlineDeduction: this.deadlineEvery || this.deadlineLimit ? deadlineDeduction : null, typeBreakdown: sortedTypes }];
    }
  },
  watch: {
    effectiveLocked: function effectiveLocked(newVal, oldVal) {
      if (newVal === true && oldVal === false && !this.lockData.locked && this.lockData.scheduledLockTime && !this.scheduledLockSaveFired && this.showLockBar && this.selectedEmployee && this.selectedMonth && this.selectedYear) {
        this.scheduledLockSaveFired = true;
        this.onScheduledLockElapsed();
      }
    }
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      var user, allUsers, companyUserIds, now;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              user = _this4.$store.state.auth.user;

              _this4.isAdmin = user && user.role === "admin";

              allUsers = _this4.$store.state.auth.allUsers || [];
              companyUserIds = (_this4.$store.state.auth.company.users || []).map(function (u) {
                return u.uid;
              });

              _this4.employeeList = allUsers.filter(function (u) {
                return companyUserIds.includes(u.uid);
              });

              now = new Date();

              _this4.selectedMonth = _this4.months[now.getMonth()];
              _this4.selectedYear = now.getFullYear().toString();

              _this4.selectedEmployee = _this4.isAdmin ? _this4.employeeList.find(function (e) {
                return e.isActive;
              }) || _this4.employeeList[0] : _this4.employeeList.find(function (u) {
                return u.uid === user.uid;
              });

              if (!_this4.isAdmin) {
                _this4.loading = true;
              }
              _context.next = 12;
              return _this4.fetchBoards();

            case 12:
              if (!_this4.boards.length) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return _this4.fetchAllBoardMembers();

            case 15:
              _this4.membersLoaded = true;

              _context.next = 18;
              return _this4.loadFirebaseEdits();

            case 18:
              if (!(!_this4.isAdmin && !_this4.autoLoadDone)) {
                _context.next = 21;
                break;
              }

              _context.next = 21;
              return _this4.triggerSearch();

            case 21:
              _context.next = 23;
              return _this4.fetchCriteria();

            case 23:
              _this4.loading = false;

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  },
  mounted: function mounted() {
    this.interval = setInterval(this.updateCountdown, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },


  methods: {
    fetchLockStatus: function fetchLockStatus() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this5.selectedMonth || !_this5.selectedYear)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].fetchPerformanceLock(_this5.selectedYear, _this5.selectedMonth);

              case 4:
                _this5.lockData = _context2.sent;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    formatDate: function formatDate(ts) {
      return new Date(ts).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    },
    formatTime: function formatTime(ts) {
      return new Date(ts).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    },
    updateCountdown: function updateCountdown() {
      this.currentTime = Date.now();
      if (!this.isScheduled) {
        this.timeRemaining = '';
        return;
      }
      var diff = this.lockData.scheduledLockTime - this.currentTime;
      if (diff <= 0) {
        this.timeRemaining = '00:00:00';
        return;
      }
      var h = Math.floor(diff / 3600000).toString().padStart(2, '0');
      var m = Math.floor(diff % 3600000 / 60000).toString().padStart(2, '0');
      var s = Math.floor(diff % 60000 / 1000).toString().padStart(2, '0');
      this.timeRemaining = h + ':' + m + ':' + s;
    },
    onScheduledLockElapsed: function onScheduledLockElapsed() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].savePerformanceLock(_this6.selectedYear, _this6.selectedMonth, true, null);

              case 3:
                _this6.lockData.locked = true;

                if (!(!_this6.lockData.userIds || _this6.lockData.userIds[_this6.selectedEmployee.uid] !== true)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 7;
                return _this6.savePerformanceTableAndFlag();

              case 7:
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.error('onScheduledLockElapsed error:', _context3.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Error', _context3.t0.message || 'Failed to apply scheduled lock.', 'error');

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 9]]);
      }))();
    },
    openEndScheduleModal: function openEndScheduleModal() {
      this.isEndScheduleModalOpen = true;
    },
    confirmEndSchedule: function confirmEndSchedule() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.isLoading = true;
                _context4.next = 3;
                return _this7.saveLock(false, null);

              case 3:
                swal('Success', 'Schedule ended successfully.', 'success');
                _this7.isLoading = false;
                _this7.isEndScheduleModalOpen = false;

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    onLockButtonClick: function onLockButtonClick() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var scheduled;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this8.effectiveLocked) {
                  _context5.next = 3;
                  break;
                }

                _this8.isUnLockModalOpen = true;
                return _context5.abrupt('return');

              case 3:
                if (_this8.isScheduled && _this8.lockData.scheduledLockTime) {
                  scheduled = new Date(_this8.lockData.scheduledLockTime);

                  _this8.lockDate = scheduled.toISOString().slice(0, 10);
                  _this8.lockTime = scheduled.toTimeString().slice(0, 5);
                } else {
                  _this8.lockDate = '';
                  _this8.lockTime = '';
                }
                _this8.isLockModalOpen = true;

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    scheduleLock: function scheduleLock() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var newTs;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!_this9.lockDate || !_this9.lockTime)) {
                  _context6.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Error', 'Please select date and time.', 'error');
                return _context6.abrupt('return');

              case 3:
                newTs = new Date(_this9.lockDate + 'T' + _this9.lockTime + ':00').getTime();

                if (!(newTs <= Date.now())) {
                  _context6.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Error', 'Please select a future date and time.', 'error');
                return _context6.abrupt('return');

              case 7:
                if (!(_this9.isScheduled && _this9.lockData.scheduledLockTime === newTs)) {
                  _context6.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Info', 'No changes were made to the schedule.', 'info');
                return _context6.abrupt('return');

              case 10:
                _this9.scheduledloading = true;
                _this9.scheduledLockSaveFired = false;
                _context6.next = 14;
                return _this9.saveLock(false, newTs);

              case 14:
                swal('Success', 'Lock scheduled successfully.', 'success');
                _this9.scheduledloading = false;
                _this9.isLockModalOpen = false;

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    lockNow: function lockNow() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this10.isLoading = true;
                _context7.next = 3;
                return _this10.saveLock(true, null);

              case 3:
                _this10.isLoading = false;
                _this10.isLockModalOpen = false;

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    confirmUnLock: function confirmUnLock() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this11.isLoading = true;
                _this11.scheduledLockSaveFired = false;
                _context8.next = 4;
                return _this11.saveLock(false, null);

              case 4:
                swal('Success', 'Unlocked successfully.', 'success');
                _this11.isLoading = false;
                _this11.isUnLockModalOpen = false;

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    saveLock: function saveLock(locked, scheduledTime) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var action, descExtra, commonFields, adminActivity;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                if (scheduledTime !== null) {
                  _this12.lockData.scheduledLockTime = scheduledTime;
                } else {
                  _this12.lockData.scheduledLockTime = null;
                }
                _context9.next = 4;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].savePerformanceLock(_this12.selectedYear, _this12.selectedMonth, locked, scheduledTime);

              case 4:
                _this12.lockData.locked = locked;
                action = '';
                descExtra = '';

                if (locked) {
                  action = 'Locked';
                } else if (scheduledTime) {
                  action = 'Scheduled Lock';
                  descExtra = ' on ' + _this12.formatDate(scheduledTime) + ' at ' + _this12.formatTime(scheduledTime);
                } else {
                  action = 'Unlocked';
                }
                commonFields = {
                  description: _this12.$store.state.auth.user.username + ' ' + action.toLowerCase() + ' performance modifications for All employees for ' + _this12.selectedMonth + ' ' + _this12.selectedYear + descExtra,
                  activityName: _this12.$store.state.auth.user.username + ' ' + (action === "Scheduled Lock" ? "scheduled" : action.toLowerCase()) + ' Performance ' + (action === "Scheduled Lock" ? "Lock for" : "for") + ' ' + _this12.selectedMonth + ' ' + _this12.selectedYear
                };
                adminActivity = {
                  adminId: _this12.$store.state.auth.user.uid,
                  activityOnUser: "All Employees",
                  activityOnUserName: "All Employees",
                  activityByUserName: _this12.$store.state.auth.user.username || 'Admin',
                  action: action + ' Performance',
                  activityTitle: action + ' performance',
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  type: 'performance_lock',
                  timestamp: new Date().toLocaleString('en-PK'),
                  month: _this12.selectedMonth,
                  year: _this12.selectedYear
                };
                _context9.next = 12;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 12:
                _context9.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_lock_unlock",
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  activityByUserName: _this12.user.username,
                  action: action
                }, _this12.$store.state.auth, _this12.user.uid);

              case 14:
                if (!locked) {
                  _context9.next = 20;
                  break;
                }

                _context9.next = 17;
                return _this12.savePerformanceTableAndFlag();

              case 17:
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Success', (_this12.hasUnmatchedTrelloCards ? 'Locked and saved' : 'Locked') + ' successfully.', 'success');
                _context9.next = 21;
                break;

              case 20:
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Success', (action === 'Scheduled Lock' ? 'Lock scheduled' : 'Unlocked') + ' successfully.', 'success');

              case 21:
                _context9.next = 26;
                break;

              case 23:
                _context9.prev = 23;
                _context9.t0 = _context9['catch'](0);

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Error', _context9.t0.message || 'Failed to save lock status.', 'error');

              case 26:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 23]]);
      }))();
    },
    fetchCriteria: function fetchCriteria() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var list, ticketCrit;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].getAllPerformanceCriteria();

              case 3:
                list = _context10.sent;

                _this13.criteriaList = list || [];
                ticketCrit = _this13.criteriaList.find(function (c) {
                  return c.type === 'Ticket';
                });

                if (ticketCrit && ticketCrit.rules.penalties) {
                  _this13.reopenEvery = ticketCrit.rules.penalties.reopens.every || null;
                  _this13.reopenScore = ticketCrit.rules.penalties.reopens.score || null;
                  _this13.deadlineEvery = ticketCrit.rules.penalties.deadlineMissed.every || null;
                  _this13.deadlineScore = ticketCrit.rules.penalties.deadlineMissed.score || null;
                  _this13.reopenLimit = ticketCrit.rules.penalties.reopens.limit || null;
                  _this13.deadlineLimit = ticketCrit.rules.penalties.deadlineMissed.limit || null;
                }
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10['catch'](0);

                console.error("Failed to fetch criteria:", _context10.t0);

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[0, 9]]);
      }))();
    },
    handleModalClose: function handleModalClose(newVal) {
      this.isAddModalOpen = newVal;
      if (!newVal) {
        this.selectedItem = null;
      }
    },
    showDetails: function showDetails(id) {
      this.$set(this.visibleDetails, id, true);
    },
    hideDetails: function hideDetails(id) {
      this.$set(this.visibleDetails, id, false);
    },
    onEditClick: function onEditClick(item) {
      this.selectedItem = item;
      this.isAddModalOpen = true;
    },
    openLogoutModal: function openLogoutModal() {
      this.isLogoutModalOpen = true;
    },
    confirmLogout: function confirmLogout() {
      this.$emit("logoutFromTrello");
      this.isLogoutModalOpen = false;
    },
    onItemAdded: function onItemAdded(_ref8) {
      var _this14 = this;

      var cardId = _ref8.cardId,
          payload = _ref8.payload;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var newEdited, mergedCard;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this14.isAddModalOpen = false;
                _this14.selectedItem = null;

                newEdited = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, payload, { cardId: cardId, isCustom: true });

                _this14.$set(_this14.editedCards, cardId, newEdited);

                mergedCard = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, newEdited);

                mergedCard.id = cardId;
                mergedCard.name = payload.name;
                mergedCard.durationInProgress = payload.durationInProgress;
                mergedCard.reopenCount = payload.reopenCount || 0;
                mergedCard.deadlineMissedCount = payload.deadlineMissedCount || 0;
                mergedCard.score = payload.score || 0;
                mergedCard.rating = payload.rating || 0;
                mergedCard.link = payload.link || '#';
                mergedCard.boardName = payload.boardName || 'Custom';
                mergedCard.type = payload.type;
                mergedCard.scoreReason = payload.scoreReason;
                mergedCard.isCustom = true;
                mergedCard.ticketStatus = payload.ticketStatus;
                mergedCard.status = 'approved'; // Adjust based on logic
                _this14.doneCards.push(mergedCard);

              case 20:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    onItemUpdated: function onItemUpdated(editPayload) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var cardId, card, mergedCard, upd, index;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this15.isAddModalOpen = false;
                _this15.selectedItem = null;

                cardId = editPayload.cardId;

                _this15.$set(_this15.editedCards, cardId, editPayload);

                card = editPayload;
                mergedCard = void 0;

                mergedCard = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, card.originalData, {
                  id: card.cardId,
                  boardName: card.board || card.originalData.boardName || 'Unknown',
                  details: card.updatedData.details || card.originalData.details || '',
                  type: card.type || 'custom'
                });
                mergedCard.customEdit = card.customEdit;
                mergedCard.isCustom = card.isCustom;
                mergedCard.type = card.type;
                mergedCard.scoreReason = card.scoreReason;
                mergedCard.ticketStatus = card.ticketStatus;
                mergedCard.movedDate = card.movedDate || card.originalData.movedDate || null;
                mergedCard.movedTime = card.movedTime || card.originalData.movedTime || null;

                upd = card.updatedData || {};

                mergedCard.status = upd.status || 'approved';
                if (upd.reopened !== undefined) mergedCard.reopenCount = upd.reopened;
                if (upd.score !== undefined) mergedCard.score = upd.score;
                if (upd.rating !== undefined) mergedCard.rating = upd.rating;
                if (upd.name !== undefined) mergedCard.name = upd.name;
                if (upd.durationInProgress !== undefined) mergedCard.durationInProgress = upd.durationInProgress;
                if (upd.deadlineMissedCount !== undefined) mergedCard.deadlineMissedCount = upd.deadlineMissedCount;

                index = _this15.doneCards.findIndex(function (c) {
                  return c.id === cardId;
                });

                if (index > -1) {
                  _this15.$set(_this15.doneCards, index, mergedCard);
                } else {
                  _this15.doneCards.push(mergedCard);
                }

              case 24:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    openMapPopup: function openMapPopup(activity) {
      var lat = activity.latitude || activity.timeIn.latitude || activity.timeOut.latitude;
      var lng = activity.longitude || activity.timeIn.longitude || activity.timeOut.longitude;

      if (!lat || !lng) {
        alert("No location data available for this activity.");
        return;
      }

      this.currentCoordinates = { latitude: lat, longitude: lng };
      this.mapPopup = true;
      this.$nextTick(function () {
        var mapEl = document.getElementById('mapActivity');
        if (!mapEl) return;
        if (mapEl._leaflet_id) {
          mapEl._leaflet_id = null;
        }

        var map = L.map('mapActivity').setView([lat, lng], 16);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(map);

        L.marker([lat, lng]).addTo(map).bindPopup('\n            <b>Location</b><br>\n            ' + lat.toFixed(6) + ', ' + lng.toFixed(6) + '<br>\n            <small>' + (activity.activityByUserName || 'Admin') + ' \u2022 ' + (activity.timestamp || 'Just now') + '</small>\n          ').openPopup();
        var googleLink = 'https://www.google.com/maps?q=' + lat + ',' + lng;
        L.DomUtil.create('div', 'map-link', map.getContainer()).innerHTML = '\n          <a href="' + googleLink + '" target="_blank" style="color:#1a73e8; font-size:12px;">\n            Open in Google Maps\n          </a>\n        ';
      });
    },
    onHistoryClick: function onHistoryClick(item) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this16.isHistoryModalOpen = true;

                _context13.prev = 1;
                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].fetchPerformanceActivities(_this16.selectedMonth, _this16.selectedYear, _this16.selectedEmployee.uid, item.id // cardId
                );

              case 4:
                _this16.performanceActivity = _context13.sent;
                _context13.next = 12;
                break;

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13['catch'](1);

                console.error("Failed to load history:", _context13.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", "Failed to load activity history", "error");
                _this16.performanceActivity = [];

              case 12:
                _context13.prev = 12;

                _this16.loading = false;
                return _context13.finish(12);

              case 15:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this16, [[1, 7, 12, 15]]);
      }))();
    },
    onDeleteClick: function onDeleteClick(item) {
      this.cardToDelete = item.id;
      this.isDeleteModalOpen = true;
    },
    onApproveClick: function onApproveClick(item) {
      this.cardToApprove = item;
      this.isApproveModalOpen = true;
    },
    openConfirm: function openConfirm(action, card, field) {
      this.pendingAction = action;
      this.pendingCardId = card.id;
      this.pendingField = field;
      this.changeInfo = { field: field, original: card.originalreopenCount != null ? card.originalreopenCount : 0,
        new: card.reopened != null ? card.reopened : 0
      };
      this.reason = card.reopenReason || card.scoreReason || '';
      this.showReasonModal = true;
    },
    handleReasonSubmit: function handleReasonSubmit() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(_this17.pendingAction === 'approve')) {
                  _context14.next = 5;
                  break;
                }

                _context14.next = 3;
                return _this17.approveEdit(_this17.pendingCardId, _this17.pendingField);

              case 3:
                _context14.next = 12;
                break;

              case 5:
                if (!(_this17.pendingAction === 'reject')) {
                  _context14.next = 10;
                  break;
                }

                _context14.next = 8;
                return _this17.rejectEdit(_this17.pendingCardId, _this17.pendingField);

              case 8:
                _context14.next = 12;
                break;

              case 10:
                _context14.next = 12;
                return _this17.saveChange();

              case 12:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this17);
      }))();
    },
    delay: function delay(ms) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (r) {
        return setTimeout(r, ms);
      });
    },
    safeTrelloFetch: function safeTrelloFetch(url) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return fetch(url);

              case 3:
                res = _context15.sent;

                if (!(res.status === 429)) {
                  _context15.next = 8;
                  break;
                }

                _context15.next = 7;
                return _this18.delay(10000);

              case 7:
                throw new Error("Rate limit");

              case 8:
                if (res.ok) {
                  _context15.next = 10;
                  break;
                }

                throw new Error('HTTP ' + res.status);

              case 10:
                _context15.next = 12;
                return res.json();

              case 12:
                return _context15.abrupt('return', _context15.sent);

              case 15:
                _context15.prev = 15;
                _context15.t0 = _context15['catch'](0);

                console.error("Fetch error:", _context15.t0);
                return _context15.abrupt('return', []);

              case 19:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this18, [[0, 15]]);
      }))();
    },
    truncateText: function truncateText(text) {
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      if (text === null || text === undefined) return '';
      var str = String(text);
      return str.length > max ? str.slice(0, max) + '...' : str;
    },
    fetchBoards: function fetchBoards() {
      var _this19 = this;

      return fetch('https://api.trello.com/1/members/me/boards?key=' + this.TRELLO_API_KEY + '&token=' + this.TRELLO_TOKEN).then(function (r) {
        return r.json();
      }).then(function (data) {
        _this19.boards = data;
      }).catch(function (err) {
        _this19.error = "Failed to fetch boards.";throw err;
      });
    },
    fetchAllBoardMembers: function fetchAllBoardMembers() {
      var _this20 = this;

      var promises = this.boards.map(function (board) {
        return fetch('https://api.trello.com/1/boards/' + board.id + '/members?key=' + _this20.TRELLO_API_KEY + '&token=' + _this20.TRELLO_TOKEN).then(function (r) {
          return r.json();
        }).then(function (m) {
          _this20.boardMemberCache[board.id] = m;
        }).catch(function (err) {
          console.warn("Failed to fetch members for board:", board.id, err);
          _this20.boardMemberCache[board.id] = [];
        });
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises);
    },
    onBoardSelect: function onBoardSelect(board) {
      if (!board.id) {
        this.selectedBoardId = "";
        this.selectedBoardName = "";
        return;
      }

      this.selectedBoardId = board.id;
      this.selectedBoardName = board.name;
    },
    onEmployeeSelect: function onEmployeeSelect(emp) {
      this.selectedEmployee = emp;
      this.selectedBoardId = "";
      this.selectedBoardName = "";
      this.noMemberFound = false;
      this.hasSearched = false;
      this.showLockBar = false;
    },
    onMonthSelect: function onMonthSelect(m) {
      this.selectedMonth = m.name;
      this.showLockBar = false;
    },
    onYearSelect: function onYearSelect(y) {
      this.selectedYear = y.name;
      this.showLockBar = false;
    },
    updateDateRange: function updateDateRange() {
      if (!this.selectedMonth || !this.selectedYear) return;
      var mIdx = this.months.indexOf(this.selectedMonth);
      var y = parseInt(this.selectedYear);
      this.startDate = new Date(y, mIdx, 1, 0, 0, 0, 0).toISOString();
      this.endDate = new Date(y, mIdx + 1, 0, 23, 59, 59, 999).toISOString();
    },
    loadFirebaseEdits: function loadFirebaseEdits() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var filters, result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(!_this21.selectedEmployee || !_this21.selectedMonth || !_this21.selectedYear)) {
                  _context16.next = 2;
                  break;
                }

                return _context16.abrupt('return');

              case 2:
                filters = {
                  month: _this21.selectedMonth,
                  year: _this21.selectedYear,
                  userId: _this21.selectedEmployee.uid,
                  boardId: _this21.selectedBoardId || null
                };
                _context16.next = 5;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].fetchEditedCards(filters);

              case 5:
                result = _context16.sent;

                _this21.editedCards = result || {};
                _this21.customCards = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this21.editedCards).filter(function (card) {
                  return card.isCustom === true;
                });

              case 8:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this21);
      }))();
    },
    openSaveConfirmModal: function openSaveConfirmModal() {
      this.isSaveConfirmModalOpen = true;
    },
    savePerformanceTableAndFlag: function savePerformanceTableAndFlag() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var existingCardIds, cardsToSave, preparedCards, adminActivity;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(!_this22.selectedEmployee || !_this22.doneCards.length)) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt('return');

              case 2:

                _this22.isLoading = true;
                _context17.prev = 3;
                _context17.next = 6;
                return _this22.loadFirebaseEdits();

              case 6:
                existingCardIds = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this22.editedCards || {}).map(function (card) {
                  return card.cardId || card.id;
                }).filter(Boolean));
                cardsToSave = _this22.doneCards.filter(function (card) {
                  var cardId = card.cardId || card.id;
                  return cardId && !existingCardIds.has(cardId);
                });
                _context17.next = 10;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].savePerformanceUserId(_this22.selectedYear, _this22.selectedMonth, _this22.selectedEmployee.uid);

              case 10:
                _this22.hasUnmatchedTrelloCards = cardsToSave.length > 0 ? true : false;

                if (!(cardsToSave.length === 0)) {
                  _context17.next = 13;
                  break;
                }

                return _context17.abrupt('return');

              case 13:
                preparedCards = cardsToSave.map(function (card) {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, card, {
                    month: _this22.selectedMonth,
                    year: _this22.selectedYear,
                    user: _this22.selectedEmployee.uid,
                    isSnapshot: true,
                    snapshotSavedAt: new Date().toLocaleString('en-PK'),
                    cardId: card.cardId || card.id,
                    id: card.cardId || card.id,
                    boardName: card.boardName || card.board || _this22.selectedBoardName || "Unknown",
                    ticketStatus: card.ticketStatus || "approved",
                    status: card.status || "approved",
                    filterKey: _this22.selectedYear + '-' + _this22.selectedMonth + '-' + _this22.selectedEmployee.uid + '-' + (card.boardId || card.board || 'null'),
                    reopenCount: card.reopenCount ? card.reopenCount : card.reopens ? card.reopens : null,
                    originalreopenCount: card.originalreopenCount ? card.originalreopenCount : null,
                    deadlineMissedCount: card.deadlineMissedCount ? card.deadlineMissedCount : card.deadlineMissed ? card.deadlineMissed : null,
                    durationInProgress: card.durationInProgress ? card.durationInProgress : card.duration ? card.duration : null,
                    originalDurationInProgress: card.originalDurationInProgress ? card.originalDurationInProgress : null,
                    type: card.type || "Ticket"
                  });
                });
                _context17.next = 16;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].savePerformanceSnapshot(preparedCards);

              case 16:
                adminActivity = {
                  adminId: _this22.$store.state.auth.user.uid,
                  activityOnUser: _this22.selectedEmployee.uid || _this22.selectedEmployee.email || 'Unknown Employee',
                  activityOnUserName: _this22.selectedEmployee.username || _this22.selectedEmployee.email || 'Unknown Employee',
                  activityByUserName: _this22.$store.state.auth.user.username || 'Admin',
                  action: 'Saved Performance Snapshot',
                  activityTitle: 'Saved performance snapshot for ' + (_this22.selectedBoardName || 'all boards'),
                  activityDescription: (_this22.isAdmin ? _this22.$store.state.auth.user.username + ' saved' : 'Saved') + ' performance of ' + _this22.selectedEmployee.username + ' for ' + _this22.selectedMonth + ' ' + _this22.selectedYear,
                  activityName: (_this22.isAdmin ? _this22.$store.state.auth.user.username + ' saved' : 'Saved') + ' performance of ' + _this22.selectedEmployee.username + ' for ' + _this22.selectedMonth + ' ' + _this22.selectedYear,
                  type: 'performance_snapshot',
                  timestamp: new Date().toLocaleString('en-PK'),
                  month: _this22.selectedMonth,
                  year: _this22.selectedYear
                };
                _context17.next = 19;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 19:
                _context17.next = 25;
                break;

              case 21:
                _context17.prev = 21;
                _context17.t0 = _context17['catch'](3);

                console.error("Save snapshot failed:", _context17.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()('Error', 'Failed to save snapshot data.', 'error');

              case 25:
                _context17.prev = 25;

                _this22.isLoading = false;
                return _context17.finish(25);

              case 28:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[3, 21, 25, 28]]);
      }))();
    },
    normalizePerformanceCard: function normalizePerformanceCard(card) {
      if (!card) return {};
      var original = card.originalData || {};
      var updated = card.updatedData || {};
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, card, {
        id: card.cardId || card.id,
        name: card.name || updated.name || original.name || 'Untitled',
        boardName: card.boardName || card.board || original.boardName || this.selectedBoardName || 'Unknown',
        reopenCount: card.reopenCount != null ? card.reopenCount : updated.reopened != null ? updated.reopened : null,
        originalreopenCount: card.originalreopenCount != null ? card.originalreopenCount : original.reopenCount != null ? original.reopenCount : null,
        score: card.score != null ? card.score : updated.score != null ? updated.score : null,
        link: card.link || original.link || updated.link || '#',
        movedDate: card.movedDate || original.movedDate || null,
        movedTime: card.movedTime || original.movedTime || null,
        deadlineMissedCount: card.deadlineMissedCount != null ? card.deadlineMissedCount : updated.deadlineMissedCount != null ? updated.deadlineMissedCount : null,
        durationInProgress: card.durationInProgress || updated.durationInProgress || original.durationInProgress,
        status: card.status || updated.status || 'approved',
        ticketStatus: card.ticketStatus || 'approved',
        isCustom: !!card.isCustom,
        type: card.type || null,
        reopenHistory: Array.isArray(card.reopenHistory) ? card.reopenHistory : []
      });
    },
    mergeWithFirebase: function mergeWithFirebase() {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var mergedCustom, merged;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(!_this23.doneCards.length && !_this23.customCards.length)) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt('return');

              case 2:
                _context18.next = 4;
                return _this23.loadFirebaseEdits();

              case 4:
                _this23.customCards = _this23.customCards.filter(function (card) {
                  return card.isSnapshot !== true;
                });
                mergedCustom = _this23.customCards.map(function (card) {
                  var _extends2;

                  if (card.customEdit !== true) return card;
                  var mergedCard = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, card.originalData, (_extends2 = { id: card.cardId, boardName: card.board || card.originalData.boardName || 'Unknown', details: card.updatedData.details || card.originalData.details || '', type: card.type || 'custom',
                    customEdit: card.customEdit, isCustom: card.isCustom }, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_extends2, 'type', card.type), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_extends2, 'scoreReason', card.reason), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_extends2, 'ticketStatus', card.ticketStatus), _extends2));
                  var upd = card.updatedData || {};
                  mergedCard.status = upd.status || 'approved';

                  if (upd.reopened !== undefined) mergedCard.reopenCount = upd.reopened;
                  if (upd.score !== undefined) mergedCard.score = upd.score;
                  if (card.originalData.reopenCount !== undefined && (mergedCard.status === 'pending' || mergedCard.status === 'rejected')) mergedCard.originalreopenCount = card.originalData.reopenCount;
                  if (upd.status !== undefined) mergedCard.status = upd.status;
                  if (upd.name !== undefined) mergedCard.name = upd.name;
                  if (upd.durationInProgress !== undefined) mergedCard.durationInProgress = upd.durationInProgress;
                  if (upd.deadlineMissedCount !== undefined) mergedCard.deadlineMissedCount = upd.deadlineMissedCount;
                  if (upd.scoreReason !== undefined) mergedCard.scoreReason = upd.scoreReason;

                  return mergedCard;
                });
                merged = _this23.doneCards.map(function (card) {
                  var fb = _this23.editedCards[card.id];
                  if (!fb) return card;

                  var mergedCard = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, card);
                  var upd = fb.updatedData || {};
                  if (upd.reopened !== undefined) mergedCard.reopenCount = upd.reopened;
                  if (upd.score !== undefined) mergedCard.score = upd.score;
                  if (upd.status !== undefined) mergedCard.status = upd.status;
                  if (upd.name !== undefined) mergedCard.name = upd.name;
                  if (upd.durationInProgress !== undefined) mergedCard.durationInProgress = upd.durationInProgress;
                  if (upd.deadlineMissedCount !== undefined) mergedCard.deadlineMissedCount = upd.deadlineMissedCount;
                  if (fb.originalData && fb.originalData.reopenCount !== undefined) {
                    mergedCard.originalreopenCount = fb.originalData.reopenCount;
                  }
                  if (upd.scoreReason !== undefined) mergedCard.scoreReason = upd.scoreReason;

                  return mergedCard;
                });

                _this23.doneCards = [].concat(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(merged), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(mergedCustom));

              case 8:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this23);
      }))();
    },
    triggerSearch: function triggerSearch() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var empName, boardsToCheck, isLockedAndSaved, finalCards, allDoneCards, processBoard;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this24.loading = true;
                _this24.showLockBar = false;

                if (!(!_this24.selectedEmployee || !_this24.selectedMonth || !_this24.selectedYear)) {
                  _context20.next = 6;
                  break;
                }

                _this24.error = "Select employee, month, and year.";
                _this24.loading = false;
                return _context20.abrupt('return');

              case 6:
                _context20.next = 8;
                return _this24.fetchLockStatus();

              case 8:
                _context20.next = 10;
                return _this24.fetchCriteria();

              case 10:
                _this24.updateDateRange();
                _this24.doneCards = [];
                _this24.error = null;
                _this24.hasSearched = true;

                empName = _this24.selectedEmployee.username.trim().toLowerCase();
                boardsToCheck = _this24.selectedBoardId ? [{ id: _this24.selectedBoardId, name: _this24.selectedBoardName }] : _this24.filteredBoardsForEmployee;

                if (boardsToCheck.length) {
                  _context20.next = 20;
                  break;
                }

                _this24.noMemberFound = true;
                _this24.loading = false;
                return _context20.abrupt('return');

              case 20:
                isLockedAndSaved = _this24.effectiveLocked && _this24.lockData.userIds && _this24.lockData.userIds[_this24.selectedEmployee.uid] === true;

                if (!isLockedAndSaved) {
                  _context20.next = 28;
                  break;
                }

                _context20.next = 24;
                return _this24.loadFirebaseEdits();

              case 24:
                finalCards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__performanceHelper_js__["d" /* sortByMovedDate */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this24.editedCards || {}).map(function (card) {
                  return _this24.normalizePerformanceCard(card);
                }));

                _this24.doneCards = finalCards;
                _context20.next = 35;
                break;

              case 28:
                allDoneCards = [];

                processBoard = function () {
                  var _ref9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee19(board) {
                    var members, member, lists, resp, doneList, reopenList, cards, _resp, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, card, actions, safeActions, moveToDone, moveDate, moveISO, total, inProgress, outProgress, _loop, j, dur, sc, cd, reopenActs;

                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            members = _this24.boardMemberCache[board.id] || [];
                            member = Array.isArray(members) && members.find(function (m) {
                              return m && m.fullName && m.fullName.trim().toLowerCase().includes(empName);
                            });

                            if (member) {
                              _context19.next = 4;
                              break;
                            }

                            return _context19.abrupt('return');

                          case 4:

                            _this24.selectedMemberId = member.id;
                            _this24.selectedMemberName = member.fullName;

                            lists = [];
                            _context19.prev = 7;
                            _context19.next = 10;
                            return fetch('https://api.trello.com/1/boards/' + board.id + '/lists?key=' + _this24.TRELLO_API_KEY + '&token=' + _this24.TRELLO_TOKEN);

                          case 10:
                            resp = _context19.sent;

                            if (!resp.ok) {
                              _context19.next = 15;
                              break;
                            }

                            _context19.next = 14;
                            return resp.json();

                          case 14:
                            lists = _context19.sent;

                          case 15:
                            _context19.next = 20;
                            break;

                          case 17:
                            _context19.prev = 17;
                            _context19.t0 = _context19['catch'](7);

                            console.warn("Failed to fetch lists for board:", board.id, _context19.t0);

                          case 20:
                            doneList = Array.isArray(lists) ? lists.find(function (l) {
                              return l && l.name && typeof l.name === 'string' && l.name.toLowerCase().includes("done");
                            }) : null;
                            reopenList = Array.isArray(lists) ? lists.find(function (l) {
                              return l && l.name && typeof l.name === 'string' && l.name.toLowerCase().includes("reopen");
                            }) : null;

                            if (doneList) {
                              _context19.next = 24;
                              break;
                            }

                            return _context19.abrupt('return');

                          case 24:
                            cards = [];
                            _context19.prev = 25;
                            _context19.next = 28;
                            return fetch('https://api.trello.com/1/lists/' + doneList.id + '/cards?key=' + _this24.TRELLO_API_KEY + '&token=' + _this24.TRELLO_TOKEN);

                          case 28:
                            _resp = _context19.sent;

                            if (!_resp.ok) {
                              _context19.next = 33;
                              break;
                            }

                            _context19.next = 32;
                            return _resp.json();

                          case 32:
                            cards = _context19.sent;

                          case 33:
                            _context19.next = 38;
                            break;

                          case 35:
                            _context19.prev = 35;
                            _context19.t1 = _context19['catch'](25);
                            return _context19.abrupt('return');

                          case 38:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context19.prev = 41;
                            _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(cards || []);

                          case 43:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                              _context19.next = 73;
                              break;
                            }

                            card = _step.value;

                            if (!(!card.idMembers || !card.idMembers.includes(member.id))) {
                              _context19.next = 47;
                              break;
                            }

                            return _context19.abrupt('continue', 70);

                          case 47:
                            _context19.next = 49;
                            return _this24.safeTrelloFetch('https://api.trello.com/1/cards/' + card.id + '/actions?key=' + _this24.TRELLO_API_KEY + '&token=' + _this24.TRELLO_TOKEN + '&filter=updateCard:idList,commentCard');

                          case 49:
                            actions = _context19.sent;
                            safeActions = Array.isArray(actions) ? actions : [];
                            moveToDone = safeActions.find(function (a) {
                              return a.type === "updateCard" && a.data && a.data.listAfter && a.data.listAfter.id === doneList.id;
                            });

                            if (moveToDone) {
                              _context19.next = 54;
                              break;
                            }

                            return _context19.abrupt('continue', 70);

                          case 54:
                            moveDate = new Date(moveToDone.date);
                            moveISO = moveDate.toISOString();

                            if (!(moveISO < _this24.startDate || moveISO > _this24.endDate)) {
                              _context19.next = 58;
                              break;
                            }

                            return _context19.abrupt('continue', 70);

                          case 58:
                            total = 0;
                            inProgress = safeActions.filter(function (a) {
                              return a.data && a.data.listAfter && a.data.listAfter.name && a.data.listAfter.name.toLowerCase().includes("in progress");
                            }).reverse();
                            outProgress = safeActions.filter(function (a) {
                              return a.data && a.data.listBefore && a.data.listBefore.name && a.data.listBefore.name.toLowerCase().includes("in progress");
                            }).reverse();

                            _loop = function _loop(j) {
                              var entry = new Date(inProgress[j].date);
                              var exit = outProgress.find(function (a) {
                                return new Date(a.date) > entry;
                              });
                              if (exit) total += new Date(exit.date) - entry;
                            };

                            for (j = 0; j < inProgress.length; j++) {
                              _loop(j);
                            }

                            dur = "N/A", sc = 0;

                            if (total > 0) {
                              (function () {
                                var hrs = Math.floor(total / (1000 * 60 * 60));
                                var mins = Math.floor(total % (1000 * 60 * 60) / (1000 * 60));
                                dur = hrs + ' hrs ' + mins + ' mins';
                                var totalHours = total / (1000 * 60 * 60);
                                var ticketCriteria = _this24.criteriaList.filter(function (c) {
                                  return c.type === 'Ticket';
                                }).sort(function (a, b) {
                                  return a.rules.duration.min - b.rules.duration.min;
                                });
                                (!_this24.criteriaList.length || !ticketCriteria.length) && swal("Warning", "No performance or ticket criteria found. Please add criteria to calculate scores.", "warning");
                                var matchingCrit = ticketCriteria.find(function (crit) {
                                  return totalHours >= crit.rules.duration.min && totalHours < crit.rules.duration.max;
                                });
                                var lastCrit = ticketCriteria[ticketCriteria.length - 1];
                                if (!matchingCrit && ticketCriteria.length && lastCrit && totalHours <= lastCrit.rules.duration.min) {
                                  swal("Warning", 'Some tickets do not match any criteria. e.g : ' + totalHours.toFixed(2) + ' hrs. \n These tickets will be scored 0. Needs to update ticket criteria.', "warning");
                                }
                                sc = matchingCrit ? matchingCrit.score : lastCrit && lastCrit.length >= 3 && totalHours >= lastCrit.rules.duration.min ? lastCrit.score : 0;
                              })();
                            }

                            cd = {
                              id: card.id,
                              name: card.name || "Untitled Card",
                              link: card.shortUrl || "#",
                              movedDate: moveDate.toLocaleDateString(),
                              movedTime: moveDate.toLocaleTimeString(),
                              durationInProgress: dur,
                              deadlineMissedCount: safeActions.filter(function (a) {
                                return a.type === "commentCard" && a.data && a.data.text && a.data.text.includes("Deadline missed an hour ago!");
                              }).length,
                              score: sc,
                              reopenCount: 0,
                              reopenHistory: [],
                              boardName: board.name
                            };


                            if (reopenList) {
                              reopenActs = safeActions.filter(function (a) {
                                return a.data && a.data.listAfter && a.data.listAfter.id === reopenList.id;
                              });

                              if (reopenActs.length > 0) {
                                cd.reopenCount = reopenActs.length;
                                cd.reopenHistory = reopenActs.map(function (a) {
                                  return {
                                    moveDate: new Date(a.date).toLocaleString(),
                                    listName: a.data.listAfter && a.data.listAfter.name || "Reopen"
                                  };
                                });
                              }
                            }

                            allDoneCards.push(cd);
                            _context19.next = 70;
                            return _this24.delay(100);

                          case 70:
                            _iteratorNormalCompletion = true;
                            _context19.next = 43;
                            break;

                          case 73:
                            _context19.next = 79;
                            break;

                          case 75:
                            _context19.prev = 75;
                            _context19.t2 = _context19['catch'](41);
                            _didIteratorError = true;
                            _iteratorError = _context19.t2;

                          case 79:
                            _context19.prev = 79;
                            _context19.prev = 80;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }

                          case 82:
                            _context19.prev = 82;

                            if (!_didIteratorError) {
                              _context19.next = 85;
                              break;
                            }

                            throw _iteratorError;

                          case 85:
                            return _context19.finish(82);

                          case 86:
                            return _context19.finish(79);

                          case 87:
                          case 'end':
                            return _context19.stop();
                        }
                      }
                    }, _callee19, _this24, [[7, 17], [25, 35], [41, 75, 79, 87], [80,, 82, 86]]);
                  }));

                  return function processBoard(_x2) {
                    return _ref9.apply(this, arguments);
                  };
                }();

                _context20.next = 32;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(boardsToCheck.map(processBoard));

              case 32:
                _this24.doneCards = allDoneCards;

                _context20.next = 35;
                return _this24.mergeWithFirebase();

              case 35:
                _this24.showLockBar = true;
                _this24.loading = false;
                _this24.autoLoadDone = true;

                if (!(_this24.effectiveLocked && (!_this24.lockData.userIds || _this24.lockData.userIds[_this24.selectedEmployee.uid] !== true))) {
                  _context20.next = 41;
                  break;
                }

                _context20.next = 41;
                return _this24.savePerformanceTableAndFlag();

              case 41:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this24);
      }))();
    },
    openDeleteModal: function openDeleteModal(cardId) {
      this.cardToDelete = cardId;
      this.isDeleteModalOpen = true;
    },
    closeHistoryModal: function closeHistoryModal() {
      this.isHistoryModalOpen = false;
      this.performanceActivity = [];
    },
    handleRowClick: function handleRowClick(item) {
      this.selectedItem = item;this.isModalOpen = true;
    },
    canEdit: function canEdit(field) {
      if (field === 'score') return this.isAdmin;
      return true;
    },
    isEditing: function isEditing(key, field) {
      return this.editing[key + '-' + field];
    },
    startEdit: function startEdit(key, field, value) {
      this.$set(this.editing, key + '-' + field, true);
      this.$set(this.tempValues, key + '-' + field, value);
    },
    cancelEdit: function cancelEdit(key, field) {
      this.$set(this.editing, key + '-' + field, false);
    },
    confirmEdit: function confirmEdit(item, field, original, reason) {
      this.tableData = item;
      var key = item.id;
      var newVal = this.tempValues[key + '-' + field];
      if (newVal == original) {
        this.cancelEdit(key, field);
        return;
      }
      this.changeInfo = { field: field, original: original, new: newVal, cardId: key };
      this.reason = reason || '';
      this.showReasonModal = true;
    },
    confirmDelete: function confirmDelete() {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var action, cardId, trelloCard, commonFields, adminActivity, _$store$state$auth$us, uid, username;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (_this25.cardToDelete) {
                  _context21.next = 2;
                  break;
                }

                return _context21.abrupt('return');

              case 2:
                _this25.isLoading = true;
                action = "Deleted";
                cardId = _this25.cardToDelete;
                trelloCard = _this25.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (trelloCard) {
                  _context21.next = 8;
                  break;
                }

                return _context21.abrupt('return');

              case 8:
                commonFields = {
                  description: _this25.$store.state.auth.user.email + ' ' + action.toLowerCase() + ' ' + _this25.selectedEmployee.email + '\'s card "' + trelloCard.name + '" ' + (_this25.reason ? '. Reason: ' + _this25.reason : ''),
                  activityName: _this25.$store.state.auth.user.username + ' ' + (_this25.isAdmin && trelloCard.ticketStatus === 'pending' ? 'rejected' : action.toLowerCase()) + ' ' + (_this25.isAdmin ? _this25.selectedEmployee.username + '\'s' : '') + ' card "' + trelloCard.name + ' " for ' + _this25.selectedMonth + ' ' + _this25.selectedYear
                };
                adminActivity = {
                  adminId: _this25.$store.state.auth.user.uid,
                  activityOnUser: _this25.selectedEmployee.uid,
                  activityOnUserName: _this25.selectedEmployee.username,
                  activityByUserName: _this25.$store.state.auth.user.username || 'Admin',
                  action: action,
                  activityTitle: 'deleted card edit',
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  type: 'performance_edit',
                  timestamp: new Date().toLocaleString('en-PK'),
                  cardId: cardId,
                  cardName: trelloCard.name,
                  month: _this25.selectedMonth,
                  year: _this25.selectedYear
                };
                _context21.prev = 10;
                _context21.next = 13;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].deleteEditedCard(_this25.cardToDelete);

              case 13:
                _context21.next = 15;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 15:
                _this25.doneCards = _this25.doneCards.filter(function (c) {
                  return c.id !== _this25.cardToDelete;
                });
                _this25.$delete(_this25.editedCards, _this25.cardToDelete);

                if (!(trelloCard.ticketStatus !== 'pending' || _this25.isAdmin)) {
                  _context21.next = 21;
                  break;
                }

                _$store$state$auth$us = _this25.$store.state.auth.user, uid = _$store$state$auth$us.uid, username = _$store$state$auth$us.username;
                _context21.next = 21;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityDescription: commonFields.description,
                  activityOnUser: _this25.selectedEmployee.uid,
                  activityOnUserName: _this25.selectedEmployee.username,
                  activityByUserName: username,
                  action: action,
                  cardName: trelloCard.taskName,
                  activityName: commonFields.activityName,
                  isAdmin: _this25.isAdmin
                }, _this25.$store.state.auth, uid);

              case 21:

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Success", "Card deleted successfully.", "success");
                _this25.isDeleteModalOpen = false;
                _this25.cardToDelete = null;
                _this25.isLoading = false;
                _context21.next = 31;
                break;

              case 27:
                _context21.prev = 27;
                _context21.t0 = _context21['catch'](10);

                console.log("confirmDelete error:", _context21.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", _context21.t0.message + ' Failed to delete card.', "error");

              case 31:
                _context21.prev = 31;

                _this25.isLoading = false;
                _this25.isDeleteModalOpen = false;
                _this25.cardToDelete = null;
                return _context21.finish(31);

              case 36:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this25, [[10, 27, 31, 36]]);
      }))();
    },
    confirmApprove: function confirmApprove() {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var cardId, trelloCard, _adminActivity, current, commonFields, adminActivity, _$store$state$auth$us2, uid, username, local;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _this26.isLoading = true;
                cardId = _this26.cardToApprove.id;
                trelloCard = _this26.cardToApprove;
                _context22.prev = 3;
                current = _this26.editedCards[cardId];

                if (current) {
                  _context22.next = 7;
                  break;
                }

                throw new Error("No data found");

              case 7:
                _context22.next = 9;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].ApproveNewTicket(cardId);

              case 9:
                commonFields = {
                  description: _this26.$store.state.auth.user.email + ' approved ' + _this26.selectedEmployee.email + '\'s ticket "' + trelloCard.taskName + '"',
                  activityName: _this26.$store.state.auth.user.username + ' approved ' + _this26.selectedEmployee.username + '\'s ticket "' + trelloCard.taskName + '" for ' + _this26.selectedMonth + ' ' + _this26.selectedYear
                };
                adminActivity = (_adminActivity = {
                  adminId: _this26.$store.state.auth.user.uid,
                  activityOnUser: _this26.selectedEmployee.uid,
                  activityOnUserName: _this26.selectedEmployee.username,
                  activityByUserName: _this26.$store.state.auth.user.username || 'Admin',
                  action: 'Approved',
                  activityTitle: 'approved ticket',
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName
                }, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'activityDescription', commonFields.description), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'activityName', commonFields.activityName), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'type', 'performance_edit'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'timestamp', new Date().toLocaleString('en-PK')), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'cardId', cardId), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'cardName', trelloCard.taskName), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'field', 'Task'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'change', 'N/A'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'oldValue', 'pending'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'newValue', 'approved'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'reason', null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'month', _this26.selectedMonth), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'year', _this26.selectedYear), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'userRole', 'admin'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_adminActivity, 'source', 'UI'), _adminActivity);
                _context22.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 13:
                _$store$state$auth$us2 = _this26.$store.state.auth.user, uid = _$store$state$auth$us2.uid, username = _$store$state$auth$us2.username;
                _context22.next = 16;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityDescription: commonFields.description,
                  activityOnUser: _this26.selectedEmployee.uid,
                  activityOnUserName: _this26.selectedEmployee.username,
                  activityByUserName: username,
                  action: "approved",
                  cardName: trelloCard.taskName,
                  activityName: commonFields.activityName
                }, _this26.$store.state.auth, uid);

              case 16:
                local = _this26.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (local) {
                  local.ticketStatus = 'approved';
                }
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Success", "Ticket approved successfully.", "success");
                _this26.isApproveModalOpen = false;
                _this26.cardToApprove = null;
                _context22.next = 27;
                break;

              case 23:
                _context22.prev = 23;
                _context22.t0 = _context22['catch'](3);

                console.error(_context22.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", "Failed to approve ticket.", "error");

              case 27:
                _context22.prev = 27;

                _this26.isLoading = false;
                return _context22.finish(27);

              case 30:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this26, [[3, 23, 27, 30]]);
      }))();
    },
    saveChange: function saveChange() {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var _extends3, _changeInfo, field, original, newVal, cardId, isCustom, required, trelloCard, minimalOriginal, existing, existingUpdated, newValue, reasonKey, status, fieldLabel, action, mergedUpdated, payload, commonFields, adminActivity, _$store$state$auth$us3, uid, username, message, local;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this27.isLoading = true;
                _context23.prev = 1;
                _changeInfo = _this27.changeInfo, field = _changeInfo.field, original = _changeInfo.original, newVal = _changeInfo.new, cardId = _changeInfo.cardId, isCustom = _changeInfo.isCustom;
                required = !_this27.isAdmin && field === 'reopened';

                if (!(required && !_this27.reason.trim())) {
                  _context23.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", "Reason is required for this change.", "error");
                return _context23.abrupt('return');

              case 7:
                trelloCard = _this27.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (trelloCard) {
                  _context23.next = 10;
                  break;
                }

                return _context23.abrupt('return');

              case 10:
                minimalOriginal = {
                  durationInProgress: trelloCard.durationInProgress || null,
                  reopenCount: trelloCard.reopenCount || 0,
                  score: trelloCard.score || 0,
                  deadlineMissedCount: trelloCard.deadlineMissedCount || null,
                  link: trelloCard.link || null,
                  name: trelloCard.name,
                  boardName: trelloCard.boardName || trelloCard.name || null
                };
                existing = _this27.editedCards[cardId] || {};
                existingUpdated = existing.updatedData || {};
                newValue = field === 'reopened' ? parseInt(newVal) : parseFloat(newVal);
                reasonKey = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
                status = _this27.isAdmin ? 'approved' : 'pending';
                fieldLabel = field === 'reopened' ? 'Reopened Count' : 'Score';
                action = _this27.isAdmin ? "Updated" : "Requested";
                mergedUpdated = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, existingUpdated, (_extends3 = {}, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_extends3, field, newValue), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_extends3, reasonKey, _this27.reason || null), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_extends3, 'status', status), _extends3));
                payload = {
                  isCustom: trelloCard.isCustom ? true : null,
                  reason: trelloCard.reason ? trelloCard.reason : null,
                  customEdit: trelloCard.isCustom ? true : null,
                  type: trelloCard.isCustom ? trelloCard.type : null,
                  cardId: cardId,
                  movedDate: trelloCard.movedDate || null,
                  movedTime: trelloCard.movedTime || null,
                  user: _this27.selectedEmployee.uid,
                  year: _this27.selectedYear,
                  month: _this27.selectedMonth,
                  board: _this27.selectedBoardId || trelloCard.boardName || trelloCard.name || null,
                  originalData: minimalOriginal,
                  updatedData: mergedUpdated,
                  status: status
                };
                commonFields = {
                  description: _this27.isAdmin ? _this27.$store.state.auth.user.email + ' ' + action.toLowerCase() + ' ' + _this27.selectedEmployee.email + '\'s ' + fieldLabel.toLowerCase() + ' ' + original + ' \u2192 ' + newVal + ' for card "' + trelloCard.name + '" for ' + _this27.selectedMonth + ' ' + _this27.selectedYear + ' ' + (_this27.reason ? '. Reason: ' + _this27.reason : '') : _this27.selectedEmployee.email + ' ' + action.toLowerCase() + ' ' + fieldLabel.toLowerCase() + ' ' + original + ' \u2192 ' + newVal + ' for card "' + trelloCard.name + '" for ' + _this27.selectedMonth + ' ' + _this27.selectedYear + ' ' + (_this27.reason ? '. Reason: ' + _this27.reason : ''),

                  activityName: _this27.isAdmin ? _this27.$store.state.auth.user.username + ' ' + action.toLowerCase() + ' ' + _this27.selectedEmployee.username + '\'s ' + fieldLabel.toLowerCase() + ' ' + original + ' \u2192 ' + newVal + ' for card "' + trelloCard.name + '" for ' + _this27.selectedMonth + ' ' + _this27.selectedYear : _this27.selectedEmployee.username + ' ' + action.toLowerCase() + ' ' + fieldLabel.toLowerCase() + ' ' + original + ' \u2192 ' + newVal + ' for card ' + trelloCard.name + ' for ' + _this27.selectedMonth + ' ' + _this27.selectedYear
                };
                adminActivity = {
                  adminId: _this27.$store.state.auth.user.uid,
                  activityOnUser: _this27.selectedEmployee.uid,
                  activityOnUserName: _this27.selectedEmployee.username,
                  activityByUserName: _this27.$store.state.auth.user.username || 'Admin',
                  action: action,
                  activityTitle: fieldLabel + ' ' + action.toLowerCase(),
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  type: 'performance_edit',
                  timestamp: new Date().toLocaleString('en-PK'),
                  cardId: cardId,
                  cardName: trelloCard.name,
                  field: field,
                  change: (!original ? "0" : original) + ' \u2192 ' + newVal,
                  oldValue: original,
                  newValue: newVal,
                  reason: _this27.reason || null,
                  month: _this27.selectedMonth,
                  year: _this27.selectedYear
                };
                _context23.next = 24;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 24:
                _$store$state$auth$us3 = _this27.$store.state.auth.user, uid = _$store$state$auth$us3.uid, username = _$store$state$auth$us3.username;
                _context23.next = 27;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityName: commonFields.activityName,
                  activityDescription: commonFields.description,
                  activityOnUser: _this27.selectedEmployee.uid,
                  activityOnUserName: _this27.selectedEmployee.username,
                  activityByUserName: username,
                  action: action,
                  cardName: trelloCard.name,
                  fieldLabel: fieldLabel
                }, _this27.$store.state.auth, uid);

              case 27:
                _context23.next = 29;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].saveEditedCard(payload);

              case 29:
                _this27.doneCards = _this27.doneCards.map(function (c) {
                  if (c.id === cardId) {
                    var updatedCard = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, c);
                    if (field === 'score') updatedCard.score = newValue;
                    updatedCard.scoreReason = _this27.reason;
                    return updatedCard;
                  }
                  return c;
                });
                message = _this27.isAdmin ? "Updated successfully." : "Request saved successfully.";

                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Success", message, "success");
                local = _this27.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (local) {
                  if (field === 'reopened') {
                    local.reopenCount = newValue;
                    local.originalreopenCount = original;
                  }
                  if (field === 'score') local.score = newValue;
                  local.__fbReason = _this27.reason;
                  local.__fbField = field;
                  local.status = status;
                }

                _this27.$set(_this27.editedCards, cardId, { updatedData: mergedUpdated });

                _this27.showReasonModal = false;
                _this27.cancelEdit(cardId, field);
                _this27.showReasonModal = false;
                _this27.pendingAction = null;
                _this27.pendingCardId = null;
                _this27.pendingField = null;
                _this27.reason = '';
                _context23.next = 48;
                break;

              case 44:
                _context23.prev = 44;
                _context23.t0 = _context23['catch'](1);

                console.error("saveChange error:", _context23.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", _context23.t0.message || "Something went wrong.", "error");

              case 48:
                _context23.prev = 48;

                _this27.isLoading = false;
                return _context23.finish(48);

              case 51:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this27, [[1, 44, 48, 51]]);
      }))();
    },
    approveEdit: function approveEdit(cardId, field) {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var fb, prefixedReason, updatedData, payload, trelloCard, reasonKey, status, fieldLabel, action, newValue, oldValue, commonFields, adminActivity, _$store$state$auth$us4, uid, username, local;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _this28.isLoading = true;
                fb = _this28.editedCards[cardId];

                if (!(!fb || !fb.updatedData)) {
                  _context24.next = 4;
                  break;
                }

                return _context24.abrupt('return');

              case 4:
                prefixedReason = _this28.reason.trim() ? 'Approved reason: ' + _this28.reason.trim() : null;
                updatedData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, fb.updatedData, {
                  status: 'approved'
                }, field === 'reopened' ? { reopenedReason: prefixedReason || null } : {});
                payload = {
                  cardId: cardId,
                  updatedData: updatedData,
                  status: 'approved'
                };
                trelloCard = _this28.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (trelloCard) {
                  _context24.next = 10;
                  break;
                }

                return _context24.abrupt('return');

              case 10:
                reasonKey = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
                status = _this28.isAdmin ? 'approved' : 'pending';
                fieldLabel = field === 'reopened' ? 'Reopened Count' : 'Score';
                action = "Approved";
                newValue = field === 'reopened' ? parseInt(fb.updatedData.reopened) : parseFloat(fb.updatedData.score);
                oldValue = field === 'reopened' ? parseInt(fb.originalData.reopenCount) || 0 : parseFloat(fb.originalData.score);
                commonFields = {
                  description: _this28.$store.state.auth.user.email + ' ' + action.toLowerCase() + ' ' + _this28.selectedEmployee.email + '\'s ' + fieldLabel.toLowerCase() + ' ' + oldValue + ' \u2192 ' + newValue + ' for card "' + trelloCard.name + '" for ' + _this28.selectedMonth + ' ' + _this28.selectedYear + ' ' + (_this28.reason ? '. Reason: ' + _this28.reason : ''),
                  activityName: _this28.$store.state.auth.user.username + ' ' + action.toLowerCase() + ' ' + _this28.selectedEmployee.username + '\'s ' + fieldLabel.toLowerCase() + ' ' + oldValue + ' \u2192 ' + newValue + ' for card "' + trelloCard.name + ' for ' + _this28.selectedMonth + ' ' + _this28.selectedYear
                };
                adminActivity = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()({
                  adminId: _this28.$store.state.auth.user.uid,
                  activityOnUser: _this28.selectedEmployee.uid,
                  activityOnUserName: _this28.selectedEmployee.username,
                  activityByUserName: _this28.$store.state.auth.user.username || 'Admin',
                  action: action,
                  activityTitle: fieldLabel + ' ' + action.toLowerCase(),
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  type: 'performance_edit',
                  timestamp: new Date().toLocaleString('en-PK'),
                  cardId: cardId,
                  cardName: trelloCard.name,
                  field: field,
                  change: (!oldValue ? "0" : oldValue) + ' \u2192 ' + newValue,
                  oldValue: oldValue,
                  newValue: newValue,
                  reason: _this28.reason || null,
                  month: _this28.selectedMonth,
                  year: _this28.selectedYear
                }, 'reason', prefixedReason);
                _context24.prev = 18;
                _context24.next = 21;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].saveApproveReject(payload);

              case 21:
                _context24.next = 23;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 23:
                _$store$state$auth$us4 = _this28.$store.state.auth.user, uid = _$store$state$auth$us4.uid, username = _$store$state$auth$us4.username;
                _context24.next = 26;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityDescription: commonFields.description,
                  activityOnUser: _this28.selectedEmployee.uid,
                  activityOnUserName: _this28.selectedEmployee.username,
                  activityByUserName: username,
                  action: action,
                  fieldLabel: fieldLabel,
                  activityName: commonFields.activityName
                }, _this28.$store.state.auth, uid);

              case 26:
                local = _this28.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (local) {
                  local.status = 'approved';
                  if (field === 'reopened') delete local.originalreopenCount;
                }

                _this28.$set(_this28.editedCards, cardId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, fb, { updatedData: updatedData }));
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Approved", "Request approved Successfully", "success");
                _this28.isLoading = false;
                _this28.showReasonModal = false;
                _this28.pendingAction = null;
                _this28.pendingCardId = null;
                _this28.pendingField = null;
                _this28.reason = '';
                _context24.next = 42;
                break;

              case 38:
                _context24.prev = 38;
                _context24.t0 = _context24['catch'](18);

                _this28.isLoading = false;
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", "Failed to approve the change.", "error");

              case 42:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this28, [[18, 38]]);
      }))();
    },
    rejectEdit: function rejectEdit(cardId, field) {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee25() {
        var fb, prefixedReason, updatedData, payload, trelloCard, reasonKey, status, fieldLabel, action, newValue, oldValue, commonFields, adminActivity, _$store$state$auth$us5, uid, username, local;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this29.isLoading = true;
                fb = _this29.editedCards[cardId];

                if (!(!fb || !fb.updatedData || !fb.originalData)) {
                  _context25.next = 4;
                  break;
                }

                return _context25.abrupt('return');

              case 4:
                prefixedReason = _this29.reason.trim() ? 'Rejection reason: ' + _this29.reason.trim() : null;
                updatedData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, fb.updatedData, {
                  status: 'rejected'
                }, field === 'reopened' ? { reopenedReason: prefixedReason || null } : {});
                payload = {
                  cardId: cardId,
                  updatedData: updatedData,
                  status: 'rejected'
                };
                trelloCard = _this29.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (trelloCard) {
                  _context25.next = 10;
                  break;
                }

                return _context25.abrupt('return');

              case 10:
                reasonKey = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
                status = _this29.isAdmin ? 'approved' : 'pending';
                fieldLabel = field === 'reopened' ? 'Reopened Count' : 'Score';
                action = "Rejected";
                newValue = field === 'reopened' ? parseInt(fb.updatedData.reopened) : parseFloat(fb.updatedData.score);
                oldValue = field === 'reopened' ? parseInt(fb.originalData.reopenCount) || 0 : parseFloat(fb.originalData.score);
                commonFields = {
                  description: _this29.$store.state.auth.user.email + ' ' + action.toLowerCase() + ' ' + _this29.selectedEmployee.email + '\'s ' + fieldLabel.toLowerCase() + '  ' + oldValue + ' \u2192  ' + newValue + ' for card "' + trelloCard.name + '" for ' + _this29.selectedMonth + ' ' + _this29.selectedYear + ' ' + (_this29.reason ? '. Reason: ' + _this29.reason : ''),
                  activityName: _this29.$store.state.auth.user.username + ' ' + action.toLowerCase() + ' ' + _this29.selectedEmployee.username + '\'s ' + fieldLabel.toLowerCase() + '  ' + oldValue + ' \u2192 ' + newValue + ' for card "' + trelloCard.name + ' for ' + _this29.selectedMonth + ' ' + _this29.selectedYear
                };
                adminActivity = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()({
                  adminId: _this29.$store.state.auth.user.uid,
                  activityOnUser: _this29.selectedEmployee.uid,
                  activityOnUserName: _this29.selectedEmployee.username,
                  activityByUserName: _this29.$store.state.auth.user.username || 'Admin',
                  action: action,
                  activityTitle: fieldLabel + ' ' + action.toLowerCase(),
                  activityDescription: commonFields.description,
                  activityName: commonFields.activityName,
                  type: 'performance_edit',
                  timestamp: new Date().toLocaleString('en-PK'),
                  cardId: cardId,
                  cardName: trelloCard.name,
                  field: field,
                  change: (!oldValue ? "0" : oldValue) + ' \u2192 ' + newValue,
                  oldValue: oldValue,
                  newValue: newValue,
                  reason: _this29.reason || null,
                  month: _this29.selectedMonth,
                  year: _this29.selectedYear
                }, 'reason', prefixedReason);
                _context25.prev = 18;
                _context25.next = 21;
                return __WEBPACK_IMPORTED_MODULE_21__assets_config_firebase__["a" /* default */].saveApproveReject(payload);

              case 21:
                _context25.next = 23;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_adminLogs_js__["c" /* logAdminActivity */])(adminActivity);

              case 23:
                _$store$state$auth$us5 = _this29.$store.state.auth.user, uid = _$store$state$auth$us5.uid, username = _$store$state$auth$us5.username;
                _context25.next = 26;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__services_notificationService_js__["b" /* handleActivityNotification */])({
                  type: "performance_edit",
                  activityDescription: commonFields.description,
                  activityOnUser: _this29.selectedEmployee.uid,
                  activityOnUserName: _this29.selectedEmployee.username,
                  activityByUserName: username,
                  action: action,
                  fieldLabel: fieldLabel,
                  activityName: commonFields.activityName
                }, _this29.$store.state.auth, uid);

              case 26:
                local = _this29.doneCards.find(function (c) {
                  return c.id === cardId;
                });

                if (local) {
                  local.status = 'rejected';
                  if (field === 'reopened') {
                    local.reopenCount = fb.originalData.reopenCount;
                    local.originalreopenCount = fb.originalData.reopenCount;
                  }
                }

                _this29.$set(_this29.editedCards, cardId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, fb, { updatedData: updatedData }));
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Rejected", "Change rejected and reverted to original value.", "warning");
                _this29.isLoading = false;
                _this29.showReasonModal = false;
                _this29.pendingAction = null;
                _this29.pendingCardId = null;
                _this29.pendingField = null;
                _this29.reason = '';
                _context25.next = 43;
                break;

              case 38:
                _context25.prev = 38;
                _context25.t0 = _context25['catch'](18);

                console.error("Reject failed:", _context25.t0);
                __WEBPACK_IMPORTED_MODULE_20_sweetalert___default()("Error", "Failed to reject the change.", "error");
                _this29.isLoading = false;

              case 43:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, _this29, [[18, 38]]);
      }))();
    },
    showInfo: function showInfo(event, id, field) {
      var _this30 = this;

      this.showTooltip = id;
      this.currentHoverField = field;
      this.$nextTick(function () {
        var el = event.target;
        var rect = el.getBoundingClientRect();
        _this30.tooltipX = rect.left + rect.width / 2;
        _this30.tooltipY = rect.top + 15;
      });
    },
    getReasonForField: function getReasonForField(cardId, field) {
      var fb = this.editedCards[cardId];
      var item = this.doneCards.find(function (c) {
        return c.id === cardId;
      });

      if (field === 'reason') {
        return item && item.reason ? item.reason : '';
      }
      if (field === 'score' && fb && fb.scoreReason !== undefined) {
        return fb.scoreReason;
      }
      if (!fb || !fb.updatedData) return null;
      if (fb.updatedData.approvalReason) return fb.updatedData.approvalReason;
      if (fb.updatedData.rejectionReason) return fb.updatedData.rejectionReason;
      var key = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
      return fb.updatedData[key] || null;
    },
    hideInfo: function hideInfo() {
      this.showTooltip = null;
      this.currentHoverField = null;
    }
  }
});

/***/ }),

/***/ "yLDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yLp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatePerDaySalary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculatePerHourSalary; });
/* unused harmony export formatAmountForDisplay */
/* unused harmony export formatAmountForSave */
var _this = this;

var calculatePerDaySalary = function calculatePerDaySalary(basicSalary, extraAllowance, workingDaysInMonth) {
  var grossSalary = (basicSalary || 0) + (extraAllowance || 0);
  return workingDaysInMonth > 0 ? grossSalary / workingDaysInMonth : 0;
};

var calculatePerHourSalary = function calculatePerHourSalary(perDaySalary, totalHours) {
  return totalHours > 0 ? perDaySalary / totalHours : 0;
};

var formatAmountForDisplay = function formatAmountForDisplay(item, workingDays, workingHours) {
  var numericAmount = void 0;

  if (item.amount === "Custom Value" || /^\d+$/.test(String(item.amount))) {
    numericAmount = parseFloat(item.amount);
  } else if (String(item.amount).includes('x') || String(item.amount).includes('day')) {
    var employee = _this.employeeList.find(function (emp) {
      return emp.uid === item.employeeId;
    }) || { basicSalary: 0, extraAllowance: 0 };
    var perDay = calculatePerDaySalary(employee.basicSalary, employee.extraAllowance, workingDays.length);
    var perHour = calculatePerHourSalary(perDay, workingHours);
    var multiplier = parseFloat(String(item.amount)) || 1;
    var isDay = String(item.amount).includes('day');
    numericAmount = isDay ? perDay * multiplier : perHour * multiplier;
  } else {
    numericAmount = parseFloat(item.amount) || 0;
  }

  return isNaN(numericAmount) ? String(item.amount) : numericAmount.toFixed(2);
};

var formatAmountForSave = function formatAmountForSave(amount) {
  if (amount !== "Custom Value" && amount.includes('(')) {
    return amount.match(/\((.*?)\)/)[1]; // Extracts "(1x)" and takes "1x"
  } else if (amount === "Custom Value") {
    return null; // Will be handled by customAmount
  }
  return amount;
};

/***/ }),

/***/ "yNcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableList_vue__ = __webpack_require__("eLjm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204e97a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableList_vue__ = __webpack_require__("8Dap");
function injectStyle (ssrContext) {
  __webpack_require__("NW5j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204e97a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yWQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Bt9R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeadb730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GGDW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeadb730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ye5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_PayrollManagement_PayrollSummary_PayrollTable_vue__ = __webpack_require__("r7wL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__ = __webpack_require__("guQB");




//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PayrollTable: __WEBPACK_IMPORTED_MODULE_4_src_components_PayrollManagement_PayrollSummary_PayrollTable_vue__["a" /* default */]
    },
    data: function data() {
        var user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin"
        };
    },

    methods: {
        fetchAllUsersRealTime: function fetchAllUsersRealTime() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.database().ref("users").on("child_changed", function (data) {
                if (data.val()) {
                    var allUsers = _this.$store.state.auth.allUsers;
                    var targetIndex = _.findIndex(allUsers, { uid: data.key });
                    if (targetIndex !== -1) {
                        allUsers[targetIndex] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data.val(), { uid: data.key });
                        _this.$store.commit("setAllUsers", [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(allUsers)));
                    }
                }
            });
        }
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var company;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            company = _this2.$store.state.auth.company;
                            _context.prev = 1;

                            if (__WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__["a" /* default */].apps.length) {
                                _context.next = 7;
                                break;
                            }

                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_7__assets_config_firebase__["a" /* default */].configureFirebase(company.firebase);

                        case 5:
                            _context.next = 7;
                            return _this2.fetchAllUsersRealTime();

                        case 7:
                            _context.next = 12;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context["catch"](1);

                            console.error("Firebase initialization error:", _context.t0.message);

                        case 12:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[1, 9]]);
        }))();
    }
});

/***/ }),

/***/ "yfmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employee-dropdown"},[_c('div',{staticClass:"dropdown-container"},[_c('div',{staticClass:"dropdown-header",class:{ disabled: _vm.disabled },on:{"click":_vm.toggleDropdown}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between","gap":"8px","width":"100%"}},[(_vm.selectedEmployee)?_c('div',{staticStyle:{"margin-top":"1px","gap":"3","display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.selectedEmployee.profile_picture || 'static/img/default-dp.png'}}),_vm._v(" "),_c('div',{staticClass:"status",staticStyle:{"margin-left":"10px"}},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.selectedEmployee.username))])])]):_c('div',[_c('i',{staticClass:"fa fa-users"}),_vm._v("\n          "+_vm._s(_vm.filterType === "active" ? "Active Employees" : "All Employees")+"\n        ")])]),_vm._v(" "),_c('div',{staticStyle:{"color":"#7b7a7ac7","margin-right":"5px","font-size":"14px"}},[_c('i',{class:['fa  ', _vm.dropdownOpen ? 'fa-chevron-up'  : 'fa-chevron-down']})])]),_vm._v(" "),(_vm.dropdownOpen)?_c('div',{staticClass:"dropdown-body"},[_c('div',{staticClass:"filter-options"},[_c('div',{staticClass:"filter-item",class:{ active: _vm.filterType === 'all' },on:{"click":function($event){return _vm.setFilter('all')}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.allEmployees.length))])]),_vm._v(" "),_c('div',{staticClass:"filter-item",class:{ active: _vm.filterType === 'active' },on:{"click":function($event){return _vm.setFilter('active')}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.activeEmployees.length))])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"search-box",attrs:{"type":"text","placeholder":"Search employees..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('ul',{staticClass:"employee-list"},_vm._l((_vm.finalList),function(emp){return _c('li',{key:emp.uid,staticClass:"employee-item",on:{"click":function($event){return _vm.selectEmployee(emp)}}},[_c('div',{staticClass:"item"},[_c('img',{staticClass:"avatar",attrs:{"src":emp.profile_picture || 'static/img/default-dp.png'}}),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(emp.username))]),_vm._v(" "),(!emp.isActive)?_c('span',{staticClass:"small"},[_vm._v("(inactive)")]):_vm._e()])]),_vm._v(" "),(_vm.selectedEmployee && _vm.selectedEmployee.uid === emp.uid)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","margin-left":"auto","margin-top":"-10px"}}):_vm._e()])}),0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-users ",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('span',{staticClass:"filter"},[_vm._v("  All Employees")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-users",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('span',{staticClass:"filter"},[_vm._v("Active Employees")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yhB7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yn5O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CardsSection",
  props: {
    cards: {
      type: Array,
      required: true
    },
    showScoreInfo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return { showTooltip: false, tooltipX: 0, tooltipY: 0, currentCard: null, hideTimeout: null };
  },

  methods: {
    showInfo: function showInfo(event, card) {
      clearTimeout(this.hideTimeout);
      this.currentCard = card;
      this.showTooltip = true;
      var rect = event.currentTarget.getBoundingClientRect();
      this.tooltipX = rect.left + rect.width / 2;
      this.tooltipY = rect.bottom + 10; // below icon
    },
    hideInfo: function hideInfo() {
      var _this = this;

      this.hideTimeout = setTimeout(function () {
        _this.showTooltip = false;
        _this.currentCard = null;
      }, 200);
    },
    keepTooltip: function keepTooltip() {
      clearTimeout(this.hideTimeout);
      this.showTooltip = true;
    }
  }
});

/***/ }),

/***/ "yvXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"gc-actions"},[(_vm.initializing)?_c('div',{staticClass:"gc-skeleton"},[_c('div',{staticClass:"skeleton-bar"})]):(!_vm.isConnected)?_c('button',{staticClass:"gc-btn primary",attrs:{"disabled":_vm.loadings.connect},on:{"click":_vm.connect}},[_c('img',{attrs:{"src":"https://img.icons8.com/color/48/google-logo.png","alt":"Google"}}),_vm._v("\n      "+_vm._s(_vm.loadings.connect ? 'Connecting...' : 'Connect Google Calendar')+"\n    ")]):_c('div',{staticClass:"gc-connected-bar"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"check"},[_vm._v("✔")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('strong',[_vm._v("Connected")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.userEmail))])])]),_vm._v(" "),_c('button',{staticClass:"gc-btn outline",attrs:{"disabled":_vm.loadings.disconnect},on:{"click":_vm.disconnect}},[_c('i',{staticClass:"mdi mdi-link-variant-off"}),_vm._v("\n        "+_vm._s(_vm.loadings.disconnect ? 'Disconnecting...' : 'Disconnect')+"\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-header"},[_c('img',{staticClass:"gc-icon",attrs:{"src":"https://img.icons8.com/color/48/google-logo.png","alt":"Google Calendar"}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Google Calendar Integration")]),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Connect your Google Calendar to automatically sync meetings and events\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zH0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_assets_config_helpers__ = __webpack_require__("DJ6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ForgotPassword",
  data: function data() {
    return {
      email: '',
      emailError: '',
      emailValidated: false,
      emailValidating: false,
      isLoading: false,
      successMessage: '',
      companies: [],
      selectedCompany: null,
      selectedCompanyId: null,
      emailCheckTimeout: null
    };
  },

  methods: {
    handleEmailChange: function handleEmailChange() {
      var _this = this;

      if (this.emailCheckTimeout) {
        clearTimeout(this.emailCheckTimeout);
      }
      this.emailError = "";
      this.emailValidated = false;
      this.successMessage = "";
      this.selectedCompany = null;
      this.companies = [];

      if (!this.email) {
        this.emailValidating = false;
        return;
      }

      // Check if there is at least one '.' after '@'
      var atIndex = this.email.indexOf('@');
      if (atIndex === -1) {
        this.emailValidating = false;
        return;
      }
      var domainPart = this.email.slice(atIndex + 1);
      if (!domainPart.includes('.')) {
        this.emailValidating = false;
        return;
      }

      this.emailCheckTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var emailRegex, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                emailRegex = __WEBPACK_IMPORTED_MODULE_3__src_assets_config_helpers__["x" /* default */].emailRegex;

                if (emailRegex.test(_this.email)) {
                  _context.next = 5;
                  break;
                }

                _this.emailError = "Please enter a valid email address";
                _this.emailValidating = false;
                return _context.abrupt("return");

              case 5:

                _this.emailValidating = true;
                _context.prev = 6;
                _context.next = 9;
                return _this.findCompany();

              case 9:
                response = _context.sent;

                if (_this.email) {
                  _context.next = 13;
                  break;
                }

                _this.emailValidating = false;
                return _context.abrupt("return");

              case 13:

                if (response && response.length > 0) {
                  _this.companies = response;
                  _this.selectCompany(response[0]);
                  _this.emailValidated = true;

                  if (response.length > 1) {
                    _this.selectedCompanyId = response[0].id || response[0].companyName;
                    _this.openCompanyModal();
                  }
                } else {
                  _this.emailError = "No account found with this email";
                }
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);

                if (_context.t0.message === "you are not added by any company") {
                  _this.emailError = "You have not been added to any company yet";
                } else {
                  _this.emailError = _context.t0.message;
                }

              case 19:
                _context.prev = 19;

                _this.emailValidating = false;
                return _context.finish(19);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 16, 19, 22]]);
      })), 1000);
    },
    handleForgotPassword: function handleForgotPassword() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resetUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.emailValidated || !_this2.selectedCompany)) {
                  _context2.next = 3;
                  break;
                }

                _this2.emailError = "Please enter a valid email associated with a company";
                return _context2.abrupt("return");

              case 3:
                _this2.isLoading = true;
                _this2.emailError = '';
                _this2.successMessage = '';

                _context2.prev = 6;

                if (!__WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].checkAlreadyConfiguredApp()) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].unconfigureFirebase();

              case 10:
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].configureFirebase(_this2.selectedCompany.firebase);

              case 12:
                resetUrl = window.location.origin + "/#/resetPassword?email=" + _this2.email.toLowerCase();
                _context2.next = 15;
                return __WEBPACK_IMPORTED_MODULE_2__assets_config_firebase__["a" /* default */].sendPasswordResetEmail(_this2.email.toLowerCase(), resetUrl);

              case 15:

                _this2.successMessage = "Password reset instructions have been sent to this email, " + _this2.email.toLowerCase();
                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()("Success", _this2.successMessage, "success");
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](6);

                _this2.emailError = _context2.t0.message || "Failed to send reset instructions. Please try again.";
                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()("Error", _this2.emailError, "error");

              case 23:
                _context2.prev = 23;

                _this2.isLoading = false;
                return _context2.finish(23);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 19, 23, 26]]);
      }))();
    },
    findCompany: function findCompany() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$parent.findCompany(_this3.email.toLowerCase());

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    selectCompany: function selectCompany(company) {
      this.selectedCompany = company;
    },
    openCompanyModal: function openCompanyModal() {
      // Implement if needed for multiple companies
    }
  }
});

/***/ }),

/***/ "zIXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WorkingDaysDropdown',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isOpen: false,
      dropdownPosition: 'bottom',
      workingDaysOptions: [{ value: 'all', label: 'All days' }, { value: 'except-weekend', label: 'Except weekend' }, { value: 'except-sunday', label: 'Except Sunday' }, { value: 'custom', label: 'Custom' }],
      daysOfWeek: [{ value: 'monday', label: 'Monday' }, { value: 'tuesday', label: 'Tuesday' }, { value: 'wednesday', label: 'Wednesday' }, { value: 'thursday', label: 'Thursday' }, { value: 'friday', label: 'Friday' }, { value: 'saturday', label: 'Saturday' }, { value: 'sunday', label: 'Sunday' }],
      tempSelection: {
        option: { value: '', label: '' },
        customDays: []
      },
      isFirstCustomToggle: true
    };
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.tempSelection = {
      option: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.option),
      customDays: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.value.customDays || []))
    };
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    togglePopover: function togglePopover(event) {
      var _this = this;

      if (event) event.stopPropagation();
      this.$nextTick(function () {
        var rect = _this.$el.getBoundingClientRect();
        var dropdownHeight = 250;
        var spaceBelow = window.innerHeight - rect.bottom;
        _this.isOpen = !_this.isOpen;
        _this.dropdownPosition = spaceBelow < dropdownHeight ? 'top' : 'bottom';
        if (_this.isOpen) {
          _this.tempSelection = {
            option: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.value.option),
            customDays: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.value.customDays || []))
          };
          _this.isFirstCustomToggle = true;
        }
      });
    },
    selectOption: function selectOption(option, event) {
      if (event) event.stopPropagation();
      var customDays = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempSelection.customDays));

      if (option.value === 'custom') {
        if (this.tempSelection.option.value === 'custom') {
          this.tempSelection = {
            option: { value: '', label: '' },
            customDays: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.value.customDays))
          };
          this.isFirstCustomToggle = true;
          return;
        }
        this.isFirstCustomToggle = true;
      } else {
        switch (option.value) {
          case 'all':
            customDays = this.daysOfWeek.map(function (day) {
              return day.value;
            });
            break;
          case 'except-weekend':
            customDays = this.daysOfWeek.filter(function (day) {
              return day.value !== 'saturday' && day.value !== 'sunday';
            }).map(function (day) {
              return day.value;
            });
            break;
          case 'except-sunday':
            customDays = this.daysOfWeek.filter(function (day) {
              return day.value !== 'sunday';
            }).map(function (day) {
              return day.value;
            });
            break;
        }
        this.isFirstCustomToggle = true;
      }
      this.tempSelection = { option: option, customDays: customDays };
    },
    onCustomDayToggle: function onCustomDayToggle(dayValue) {
      var customDays = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempSelection.customDays));
      var index = customDays.indexOf(dayValue);

      if (this.isFirstCustomToggle) {
        customDays = index === -1 ? [dayValue] : [];
        this.isFirstCustomToggle = false;
      } else {
        if (index === -1) {
          customDays.push(dayValue);
        } else {
          customDays.splice(index, 1);
        }
      }
      this.tempSelection.customDays = customDays;
    },
    applySelection: function applySelection(event) {
      var dayMap = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      };

      var dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

      // Always use the current temp selection
      var rawCustomDays = this.tempSelection.customDays || [];

      var uniqueCustomDays = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rawCustomDays.map(function (day) {
        return dayMap[day.toLowerCase()] || day;
      })))).sort(function (a, b) {
        return dayOrder.indexOf(a) - dayOrder.indexOf(b);
      });

      var workingDaysObject = {
        option: this.tempSelection.option,
        customDays: uniqueCustomDays
      };
      -this.$emit('input', workingDaysObject);
      this.isOpen = false;
      this.isFirstCustomToggle = true; // you can still reset this if needed
    },
    closeCustomPopover: function closeCustomPopover(event) {
      if (event) event.stopPropagation();
      this.isOpen = false;
      this.tempSelection = {
        option: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.option),
        customDays: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.value.customDays || []))
      };
      this.isFirstCustomToggle = true;
    },
    getWorkingDaysDisplay: function getWorkingDaysDisplay(selection) {
      var dayAbbreviations = {
        Monday: 'Mo',
        Tuesday: 'Tu',
        Wednesday: 'We',
        Thursday: 'Th',
        Friday: 'Fr',
        Saturday: 'Sa',
        Sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'Su'
      };
      if (selection.option.value === 'custom') {
        if (!selection.customDays || selection.customDays.length === 0) {
          return 'None';
        }
        var selectedDays = selection.customDays.map(function (day) {
          return dayAbbreviations[day] || '';
        }).filter(Boolean).join(', ');
        return selectedDays;
      }
      if (selection.option.value === 'all') return 'Mo, Tu, We, Th, Fr, Sa, Su';
      if (selection.option.value === 'except-weekend') return 'Mo, Tu, We, Th, Fr';
      if (selection.option.value === 'except-sunday') return 'Mo, Tu, We, Th, Fr, Sa';
      return selection.option.label;
    },
    handleClickOutside: function handleClickOutside(event) {
      var popover = this.$refs.popover;
      var dropdown = this.$refs.dropdownRoot;

      if (this.isOpen && (!popover || !popover.contains(event.target)) && !dropdown.contains(event.target)) {
        this.isOpen = false;
        this.tempSelection = {
          option: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.option),
          customDays: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.value.customDays || []))
        };
        this.isFirstCustomToggle = true;
      }
    }
  }
});

/***/ }),

/***/ "zKnm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label'):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$props,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_config_firebase__ = __webpack_require__("guQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_chatbotLoader__ = __webpack_require__("LDEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBell_vue__ = __webpack_require__("6s0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_notificationService__ = __webpack_require__("l527");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NotificationBell: __WEBPACK_IMPORTED_MODULE_6__NotificationBell_vue__["a" /* default */]
  },
  computed: {
    impersonatedUserEmail: function impersonatedUserEmail() {
      var user = localStorage.getItem('impersonateUser');
      return user ? JSON.parse(user).email : '';
    },
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    },
    isResignedUser: function isResignedUser() {
      var currentUser = this.$store.state.auth.user;
      return currentUser.status === "Resigned";
    },
    isImpersonating: function isImpersonating() {
      return this.$root.isImpersonating;
    },
    currentUserId: function currentUserId() {
      if (this.isImpersonatingLocal) {
        // use reactive flag instead of localStorage directly
        try {
          var impersonated = localStorage.getItem("impersonateUser");
          return impersonated ? JSON.parse(impersonated).uid || null : null;
        } catch (e) {
          return null;
        }
      }
      return this.$store.state.auth.user.uid || null;
    }
  },
  data: function data() {
    return {
      activeNotifications: false,
      mobileMenuOpen: false,
      isImpersonatingLocal: !!localStorage.getItem('impersonateUser') // add this
    };
  },

  watch: {
    '$route': function $route() {
      console.log('Route changed to:', this.$route.name);
      this.checkResignedStatus();
      this.$forceUpdate();
    },

    '$store.state.auth.user': {
      handler: function handler(newUser) {
        console.log('Auth user changed:', newUser);
        this.$forceUpdate();
      },

      deep: true
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var user;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              user = localStorage.getItem('impersonateUser');


              _this.$root.isImpersonating = !!user;
              _this.$root.impersonatedUser = user ? JSON.parse(user) : null;

              _context.next = 5;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_notificationService__["a" /* requestNotificationPermission */])();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    this.checkResignedStatus();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount: function beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    handleClickOutside: function handleClickOutside(event) {
      var menu = this.$refs.menuWrapper;

      if (menu && !menu.contains(event.target)) {
        this.mobileMenuOpen = false;
      }
    },
    logoutAsEmployee: function logoutAsEmployee() {
      localStorage.removeItem('impersonateUser');
      this.$root.isImpersonating = false;
      this.$root.impersonatedUser = null;
      this.isImpersonatingLocal = false;
      this.againLoginAsAdmin();
      if (this.$route.path === '/usermanagement') {
        this.$router.push('/overview');
      } else {
        this.$router.push('/usermanagement');
      }
    },
    againLoginAsAdmin: function againLoginAsAdmin() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var routeUserId, userData, user;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                routeUserId = localStorage.getItem('originalAdminUser') ? JSON.parse(localStorage.getItem('originalAdminUser')).uid : null;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$store.dispatch('initializeAuth');

              case 4:
                if (!routeUserId) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__assets_config_firebase__["a" /* default */].getSingleUser(routeUserId);

              case 7:
                userData = _context2.sent;

                if (userData) {
                  _context2.next = 10;
                  break;
                }

                throw new Error('User not found');

              case 10:
                _context2.next = 13;
                break;

              case 12:
                userData = _this2.$store.state.auth.user || defaultUserData;

              case 13:
                user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, userData, {
                  bankName: userData.bankName || '',
                  email: userData.email || '',
                  iban: userData.iban || '',
                  isActive: userData.isActive !== undefined ? userData.isActive : true,
                  joiningDate: userData.joiningDate || '',
                  leavesAllowed: userData.leavesAllowed || 7.5,
                  leavesAvailable: userData.leavesAvailable || 15,
                  leavesTaken: userData.leavesTaken || '',
                  nicNumber: userData.nicNumber || '',
                  phoneNumber: userData.phoneNumber || '',
                  role: userData.role || '',
                  salary: userData.salary || 0,
                  twitterProfile: userData.twitterProfile || '',
                  uid: routeUserId || userData.uid || (_this2.$store.state.auth.user ? _this2.$store.state.auth.user.uid : ''),
                  username: userData.username || '',
                  designation: userData.designation || '',
                  grade: userData.grade || '',
                  role_title: userData.role_title || '',
                  personalEmail: userData.personalEmail || '',
                  dateOfBirth: userData.dateOfBirth || '',
                  nationality: userData.nationality || '',
                  maritalStatus: userData.maritalStatus || '',
                  currentAddress: userData.currentAddress || '',
                  permanentAddress: userData.permanentAddress || '',
                  emergencyContactName: userData.emergencyContactName || '',
                  emergencyContactNumber: userData.emergencyContactNumber || '',
                  profile_picture: userData.profile_picture || '',
                  nicImageUrl: userData.nicImageUrl || '',
                  certificateUrl: userData.certificateUrl || '',
                  salarySlipUrl: userData.salarySlipUrl || '',
                  // company: this.company.companyName,
                  fullName: userData.username || '',
                  status: userData.status || _this2.$store.state.auth.user && _this2.$store.state.auth.user.status || 'Active' // Preserve status
                });

                _this2.$store.commit('setUser', user);

                _context2.next = 23;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](1);

                console.error('Error fetching user from Firebase:', _context2.t0);
                swal('Error', 'Failed to load user data: ' + _context2.t0.message, 'error');
                _this2.user = defaultUserData;
                _this2.$router.push('/userManagement');

              case 23:
                _context2.prev = 23;

                _this2.isLoading = false;
                localStorage.removeItem('originalAdminUser');
                return _context2.finish(23);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 17, 23, 27]]);
      }))();
    },
    checkResignedStatus: function checkResignedStatus() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userId, userData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                userId = _this3.$store.state.auth.user.uid;

                if (!userId) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__assets_config_firebase__["a" /* default */].readDatabase("users/" + userId);

              case 5:
                userData = _context3.sent;

                console.log('Firebase user data:', userData);
                if (userData && userData.status) {
                  _this3.$store.commit("setUser", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$store.state.auth.user, { status: userData.status }));
                }

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error('Error checking Firebase status:', _context3.t0);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    logout: function logout() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__assets_config_firebase__["a" /* default */].logout();

              case 3:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_chatbotLoader__["b" /* unloadChatbot */])();

                _this4.$store.commit("clearAuth");

                _this4.$router.replace("/");
                localStorage.clear();
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);

                swal("Error!", _context4.t0.message, "error");

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
});

/***/ }),

/***/ "zZhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_ChatbotManagement_ChatbotManagement_vue__ = __webpack_require__("oKtW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__("wtEF");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FileTable: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_ChatbotManagement_ChatbotManagement_vue__["a" /* default */]
  },
  computed: {
    isAdmin: function isAdmin() {
      var user = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.auth.user;
      return user && user.role === "admin";
    }
  },
  mounted: function mounted() {
    if (!this.isAdmin) {
      this.$router.push("/overview");
    }
  },

  methods: {
    refreshFiles: function refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "zkri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zmwx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCurrentUsage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDocumentsAPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var getCurrentUsage = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var FLOWISE_BASE = _ref2.FLOWISE_BASE,
            apiKey = _ref2.apiKey;
        var url, res, json, err;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        url = FLOWISE_BASE + '/organization/get-current-usage';
                        _context.next = 3;
                        return fetch(url, {
                            method: 'GET',
                            headers: { Authorization: 'Bearer ' + apiKey }
                        });

                    case 3:
                        res = _context.sent;
                        _context.next = 6;
                        return res.json().catch(function () {
                            return {};
                        });

                    case 6:
                        json = _context.sent;

                        if (res.ok) {
                            _context.next = 11;
                            break;
                        }

                        err = new Error(json.message || 'getting error while getting current usage');

                        err.details = json;
                        throw err;

                    case 11:
                        return _context.abrupt('return', { ok: true, data: json });

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getCurrentUsage(_x) {
        return _ref.apply(this, arguments);
    };
}();

var canUploadFile = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(fileSizeMB, FLOWISE_BASE, apiKey) {
        var userUsage, _userUsage$data$stora, usage, limit;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return getCurrentUsage({
                            FLOWISE_BASE: FLOWISE_BASE,
                            apiKey: apiKey
                        });

                    case 2:
                        userUsage = _context2.sent;
                        _userUsage$data$stora = userUsage.data.storage, usage = _userUsage$data$stora.usage, limit = _userUsage$data$stora.limit;

                        if (!(usage >= limit)) {
                            _context2.next = 6;
                            break;
                        }

                        return _context2.abrupt('return', { ok: false, message: "Storage limit reached. Cannot upload more files." });

                    case 6:
                        if (!(usage + fileSizeMB > limit)) {
                            _context2.next = 8;
                            break;
                        }

                        return _context2.abrupt('return', { ok: false, message: "Uploading this file exceeds storage limit." });

                    case 8:
                        return _context2.abrupt('return', { ok: true });

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function canUploadFile(_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

var uploadFile = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
        var FLOWISE_BASE = _ref5.FLOWISE_BASE,
            documentStoreId = _ref5.documentStoreId,
            apiKey = _ref5.apiKey,
            formData = _ref5.formData;
        var url, res, json, err;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        url = FLOWISE_BASE + '/document-store/upsert/' + documentStoreId;
                        _context3.next = 3;
                        return fetch(url, {
                            method: 'POST',
                            headers: { Authorization: 'Bearer ' + apiKey },
                            body: formData
                        });

                    case 3:
                        res = _context3.sent;
                        _context3.next = 6;
                        return res.json().catch(function () {
                            return {};
                        });

                    case 6:
                        json = _context3.sent;

                        if (res.ok) {
                            _context3.next = 11;
                            break;
                        }

                        err = new Error(json.message || 'Flowise upload failed');

                        err.details = json;
                        throw err;

                    case 11:
                        return _context3.abrupt('return', { ok: true, data: json });

                    case 12:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function uploadFile(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

var fetchDocumentsAPI = function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7) {
        var FLOWISE_BASE = _ref7.FLOWISE_BASE,
            documentStoreId = _ref7.documentStoreId,
            apiKey = _ref7.apiKey;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return fetch(FLOWISE_BASE + '/document-store/store/' + documentStoreId, {
                            headers: { Authorization: 'Bearer ' + apiKey }
                        });

                    case 2:
                        res = _context4.sent;
                        return _context4.abrupt('return', res.json());

                    case 4:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function fetchDocumentsAPI(_x6) {
        return _ref6.apply(this, arguments);
    };
}();

var deleteLoader = function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9) {
        var FLOWISE_BASE = _ref9.FLOWISE_BASE,
            documentStoreId = _ref9.documentStoreId,
            loaderId = _ref9.loaderId,
            apiKey = _ref9.apiKey;
        var res, json, err;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return fetch(FLOWISE_BASE + '/document-store/loader/' + documentStoreId + '/' + loaderId, {
                            method: "DELETE",
                            headers: { Authorization: 'Bearer ' + apiKey }
                        });

                    case 2:
                        res = _context5.sent;
                        _context5.next = 5;
                        return res.json().catch(function () {
                            return {};
                        });

                    case 5:
                        json = _context5.sent;

                        if (res.ok) {
                            _context5.next = 10;
                            break;
                        }

                        err = new Error(json.message || "Flowise delete failed");

                        err.details = json;
                        throw err;

                    case 10:
                        return _context5.abrupt('return', json);

                    case 11:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function deleteLoader(_x7) {
        return _ref8.apply(this, arguments);
    };
}();

/***/ }),

/***/ "zyIC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"user-management"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"header-actions"},[_c('h5',{staticClass:"title"},[_vm._v("Uploaded Files")]),_vm._v(" "),_c('div',{staticClass:"actions-right"},[_c('button',{staticClass:"add-employee",attrs:{"disabled":_vm.loadingStates.upload},on:{"click":function($event){return _vm.startUpload()}}},[(_vm.loadingStates.upload)?_c('span',[_c('img',{staticClass:"loader-icon",attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('span',[_vm._v("Upload File")])]),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"d-none",attrs:{"type":"file","accept":".docx,.pdf"},on:{"change":_vm.handleFileUpload}})])])]},proxy:true}])},[_vm._v(" "),_c('div',[_c('CustomTable',{attrs:{"loading":_vm.loadingStates.table,"columns":_vm.tableColumns,"data":_vm.fileList},scopedSlots:_vm._u([{key:"fileName",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"truncate-text",attrs:{"title":item.loaderConfig.metadata.fileName || '-'}},[_vm._v("\n                    "+_vm._s(item.loaderConfig.metadata.fileName || '-')+"\n                  ")])]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('span',{attrs:{"title":item.status}},[_vm._v(_vm._s(item.status || '-'))])]}},{key:"username",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                  "+_vm._s(item.loaderConfig.metadata.username || '-')+"\n                ")]}},{key:"uploadedAt",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.formatDate(item.files[0].uploaded)))])]}},{key:"action",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"action-buttons"},[_c('button',{staticClass:"edit-btn btn-status",attrs:{"title":'Edit'},on:{"click":function($event){return _vm.startUpload(item, true)}}},[(_vm.loadingStates.edit)?_c('span',[_c('img',{staticClass:"loader-icon",attrs:{"src":"/static/img/loader.gif","alt":"Loading"}})]):_c('PencilIcon',{attrs:{"color":"gray","width":16,"height":16}})],1),_vm._v(" "),_c('button',{staticClass:"delete-btn btn-status",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.openDeleteModal(item)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"gray"}})])])]}}])})],1)]),_vm._v(" "),_c('ReuseableModal',{attrs:{"modelValue":_vm.isDeleteModalOpen,"title":"Confirm Deletion","submitButtonText":"Delete","loading":_vm.loadingStates.delete},on:{"update:modelValue":function($event){_vm.isDeleteModalOpen = $event},"submit":_vm.confirmDelete}},[_c('div',[_vm._v("Are you sure you want to delete this file?\n            ")])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.695a4d3bc9f4053187dc.js